/*! https://mths.be/punycode v1.4.1 by @mathias */


/** Highest positive signed 32-bit float value */
var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1

/** Bootstring parameters */
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'

/** Regular expressions */
var regexPunycode = /^xn--/;
var regexNonASCII = /[^\x20-\x7E]/; // unprintable ASCII chars + non-ASCII chars
var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators

/** Error messages */
var errors = {
  'overflow': 'Overflow: input needs wider integers to process',
  'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
  'invalid-input': 'Invalid input'
};

/** Convenience shortcuts */
var baseMinusTMin = base - tMin;
var floor = Math.floor;
var stringFromCharCode = String.fromCharCode;

/*--------------------------------------------------------------------------*/

/**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */
function error(type) {
  throw new RangeError(errors[type]);
}

/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */
function map(array, fn) {
  var length = array.length;
  var result = [];
  while (length--) {
    result[length] = fn(array[length]);
  }
  return result;
}

/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */
function mapDomain(string, fn) {
  var parts = string.split('@');
  var result = '';
  if (parts.length > 1) {
    // In email addresses, only the domain name should be punycoded. Leave
    // the local part (i.e. everything up to `@`) intact.
    result = parts[0] + '@';
    string = parts[1];
  }
  // Avoid `split(regex)` for IE8 compatibility. See #17.
  string = string.replace(regexSeparators, '\x2E');
  var labels = string.split('.');
  var encoded = map(labels, fn).join('.');
  return result + encoded;
}

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */
function ucs2decode(string) {
  var output = [],
    counter = 0,
    length = string.length,
    value,
    extra;
  while (counter < length) {
    value = string.charCodeAt(counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // high surrogate, and there is a next character
      extra = string.charCodeAt(counter++);
      if ((extra & 0xFC00) == 0xDC00) { // low surrogate
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // unmatched surrogate; only append this code unit, in case the next
        // code unit is the high surrogate of a surrogate pair
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
}

/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */
function ucs2encode(array) {
  return map(array, function(value) {
    var output = '';
    if (value > 0xFFFF) {
      value -= 0x10000;
      output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
      value = 0xDC00 | value & 0x3FF;
    }
    output += stringFromCharCode(value);
    return output;
  }).join('');
}

/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */
function basicToDigit(codePoint) {
  if (codePoint - 48 < 10) {
    return codePoint - 22;
  }
  if (codePoint - 65 < 26) {
    return codePoint - 65;
  }
  if (codePoint - 97 < 26) {
    return codePoint - 97;
  }
  return base;
}

/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */
function digitToBasic(digit, flag) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
}

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */
function adapt(delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  for ( /* no initialization */ ; delta > baseMinusTMin * tMax >> 1; k += base) {
    delta = floor(delta / baseMinusTMin);
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
}

/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */
function decode(input) {
  // Don't use UCS-2
  var output = [],
    inputLength = input.length,
    out,
    i = 0,
    n = initialN,
    bias = initialBias,
    basic,
    j,
    index,
    oldi,
    w,
    k,
    digit,
    t,
    /** Cached calculation results */
    baseMinusT;

  // Handle the basic code points: let `basic` be the number of input code
  // points before the last delimiter, or `0` if there is none, then copy
  // the first basic code points to the output.

  basic = input.lastIndexOf(delimiter);
  if (basic < 0) {
    basic = 0;
  }

  for (j = 0; j < basic; ++j) {
    // if it's not a basic code point
    if (input.charCodeAt(j) >= 0x80) {
      error('not-basic');
    }
    output.push(input.charCodeAt(j));
  }

  // Main decoding loop: start just after the last delimiter if any basic code
  // points were copied; start at the beginning otherwise.

  for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */ ) {

    // `index` is the index of the next character to be consumed.
    // Decode a generalized variable-length integer into `delta`,
    // which gets added to `i`. The overflow checking is easier
    // if we increase `i` as we go, then subtract off its starting
    // value at the end to obtain `delta`.
    for (oldi = i, w = 1, k = base; /* no condition */ ; k += base) {

      if (index >= inputLength) {
        error('invalid-input');
      }

      digit = basicToDigit(input.charCodeAt(index++));

      if (digit >= base || digit > floor((maxInt - i) / w)) {
        error('overflow');
      }

      i += digit * w;
      t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

      if (digit < t) {
        break;
      }

      baseMinusT = base - t;
      if (w > floor(maxInt / baseMinusT)) {
        error('overflow');
      }

      w *= baseMinusT;

    }

    out = output.length + 1;
    bias = adapt(i - oldi, out, oldi == 0);

    // `i` was supposed to wrap around from `out` to `0`,
    // incrementing `n` each time, so we'll fix that now:
    if (floor(i / out) > maxInt - n) {
      error('overflow');
    }

    n += floor(i / out);
    i %= out;

    // Insert `n` at position `i` of the output
    output.splice(i++, 0, n);

  }

  return ucs2encode(output);
}

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */
function encode(input) {
  var n,
    delta,
    handledCPCount,
    basicLength,
    bias,
    j,
    m,
    q,
    k,
    t,
    currentValue,
    output = [],
    /** `inputLength` will hold the number of code points in `input`. */
    inputLength,
    /** Cached calculation results */
    handledCPCountPlusOne,
    baseMinusT,
    qMinusT;

  // Convert the input in UCS-2 to Unicode
  input = ucs2decode(input);

  // Cache the length
  inputLength = input.length;

  // Initialize the state
  n = initialN;
  delta = 0;
  bias = initialBias;

  // Handle the basic code points
  for (j = 0; j < inputLength; ++j) {
    currentValue = input[j];
    if (currentValue < 0x80) {
      output.push(stringFromCharCode(currentValue));
    }
  }

  handledCPCount = basicLength = output.length;

  // `handledCPCount` is the number of code points that have been handled;
  // `basicLength` is the number of basic code points.

  // Finish the basic string - if it is not empty - with a delimiter
  if (basicLength) {
    output.push(delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {

    // All non-basic code points < n have been handled already. Find the next
    // larger one:
    for (m = maxInt, j = 0; j < inputLength; ++j) {
      currentValue = input[j];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
    // but guard against overflow
    handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      error('overflow');
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (j = 0; j < inputLength; ++j) {
      currentValue = input[j];

      if (currentValue < n && ++delta > maxInt) {
        error('overflow');
      }

      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer
        for (q = delta, k = base; /* no condition */ ; k += base) {
          t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) {
            break;
          }
          qMinusT = q - t;
          baseMinusT = base - t;
          output.push(
            stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
          );
          q = floor(qMinusT / baseMinusT);
        }

        output.push(stringFromCharCode(digitToBasic(q, 0)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        ++handledCPCount;
      }
    }

    ++delta;
    ++n;

  }
  return output.join('');
}

/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */
function toUnicode(input) {
  return mapDomain(input, function(string) {
    return regexPunycode.test(string) ?
      decode(string.slice(4).toLowerCase()) :
      string;
  });
}

/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */
function toASCII(input) {
  return mapDomain(input, function(string) {
    return regexNonASCII.test(string) ?
      'xn--' + encode(string) :
      string;
  });
}
var version = '1.4.1';
/**
 * An object of methods to convert from JavaScript's internal character
 * representation (UCS-2) to Unicode code points, and back.
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode
 * @type Object
 */

var ucs2 = {
  decode: ucs2decode,
  encode: ucs2encode
};
var punycode_1 = {
  version: version,
  ucs2: ucs2,
  toASCII: toASCII,
  toUnicode: toUnicode,
  encode: encode,
  decode: decode
}

class Domain {
    constructor(hostname) {
        this.hostname = hostname;
        // tslint:disable-next-line:deprecation
        this.labels = this.hostname.split('.').map(toUnicode);
        this.isTldAscii = !this.hostname
            .substring(this.hostname.lastIndexOf('.'))
            .startsWith('.xn--');
        this.isEthTld =
            this.hostname.substring(this.hostname.lastIndexOf('.')) === '.eth';
    }
}

var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["ZERO_ERROR"] = 0] = "ZERO_ERROR";
    ErrorCode[ErrorCode["SUCCESS"] = 1] = "SUCCESS";
    ErrorCode[ErrorCode["FAILURE"] = 2] = "FAILURE";
    ErrorCode[ErrorCode["INVALID_FORMAT_ERROR"] = 3] = "INVALID_FORMAT_ERROR";
    ErrorCode[ErrorCode["ILLEGAL_ARGUMENT_ERROR"] = 4] = "ILLEGAL_ARGUMENT_ERROR";
    ErrorCode[ErrorCode["MEMORY_ALLOCATION_ERROR"] = 5] = "MEMORY_ALLOCATION_ERROR";
})(ErrorCode || (ErrorCode = {}));
var RestrictionLevel;
(function (RestrictionLevel) {
    /**
     * All characters in the string are in the identifier profile and all characters in the string are in the
     * ASCII range.
     *
     * @stable ICU 51
     */
    RestrictionLevel[RestrictionLevel["ASCII"] = 268435456] = "ASCII";
    /**
     * The string classifies as ASCII-Only, or all characters in the string are in the identifier profile and
     * the string is single-script, according to the definition in UTS 39 section 5.1.
     *
     * @stable ICU 53
     */
    RestrictionLevel[RestrictionLevel["SINGLE_SCRIPT_RESTRICTIVE"] = 536870912] = "SINGLE_SCRIPT_RESTRICTIVE";
    /**
     * The string classifies as Single Script, or all characters in the string are in the identifier profile and
     * the string is covered by any of the following sets of scripts, according to the definition in UTS 39
     * section 5.1:
     * <ul>
     *   <li>Latin + Han + Bopomofo (or equivalently: Latn + Hanb)</li>
     *   <li>Latin + Han + Hiragana + Katakana (or equivalently: Latn + Jpan)</li>
     *   <li>Latin + Han + Hangul (or equivalently: Latn +Kore)</li>
     * </ul>
     * This is the default restriction in ICU.
     *
     * @stable ICU 51
     */
    RestrictionLevel[RestrictionLevel["HIGHLY_RESTRICTIVE"] = 805306368] = "HIGHLY_RESTRICTIVE";
    /**
     * The string classifies as Highly Restrictive, or all characters in the string are in the identifier profile
     * and the string is covered by Latin and any one other Recommended or Aspirational script, except Cyrillic,
     * Greek, and Cherokee.
     *
     * @stable ICU 51
     */
    RestrictionLevel[RestrictionLevel["MODERATELY_RESTRICTIVE"] = 1073741824] = "MODERATELY_RESTRICTIVE";
    /**
     * All characters in the string are in the identifier profile.  Allow arbitrary mixtures of scripts.
     *
     * @stable ICU 51
     */
    RestrictionLevel[RestrictionLevel["MINIMALLY_RESTRICTIVE"] = 1342177280] = "MINIMALLY_RESTRICTIVE";
    /**
     * Any valid identifiers, including characters outside of the Identifier Profile.
     *
     * @stable ICU 51
     */
    RestrictionLevel[RestrictionLevel["UNRESTRICTIVE"] = 1610612736] = "UNRESTRICTIVE";
    /**
     * Mask for selecting the Restriction Level bits from the return value of {@link uspoof_check}.
     *
     * @stable ICU 53
     */
    RestrictionLevel[RestrictionLevel["RESTRICTION_LEVEL_MASK"] = 2130706432] = "RESTRICTION_LEVEL_MASK";
    /**
     * An undefined restriction level.
     * @internal
     */
    RestrictionLevel[RestrictionLevel["UNDEFINED_RESTRICTIVE"] = -1] = "UNDEFINED_RESTRICTIVE";
})(RestrictionLevel || (RestrictionLevel = {}));
var SpoofChecks;
(function (SpoofChecks) {
    SpoofChecks[SpoofChecks["SINGLE_SCRIPT_CONFUSABLE"] = 1] = "SINGLE_SCRIPT_CONFUSABLE";
    SpoofChecks[SpoofChecks["MIXED_SCRIPT_CONFUSABLE"] = 2] = "MIXED_SCRIPT_CONFUSABLE";
    SpoofChecks[SpoofChecks["WHOLE_SCRIPT_CONFUSABLE"] = 4] = "WHOLE_SCRIPT_CONFUSABLE";
    SpoofChecks[SpoofChecks["CONFUSABLE"] = 7] = "CONFUSABLE";
    SpoofChecks[SpoofChecks["RESTRICTION_LEVEL"] = 16] = "RESTRICTION_LEVEL";
    SpoofChecks[SpoofChecks["INVISIBLE"] = 32] = "INVISIBLE";
    SpoofChecks[SpoofChecks["CHAR_LIMIT"] = 64] = "CHAR_LIMIT";
    SpoofChecks[SpoofChecks["MIXED_NUMBERS"] = 128] = "MIXED_NUMBERS";
    SpoofChecks[SpoofChecks["ALL_CHECKS"] = 65535] = "ALL_CHECKS";
    // AUX_INFO = 0x40000000,
})(SpoofChecks || (SpoofChecks = {}));

class CheckResult {
    constructor() {
        this.checks = SpoofChecks.ALL_CHECKS;
        this.numerics = [];
        this.restrictionLevel = RestrictionLevel.HIGHLY_RESTRICTIVE;
    }
    toCombinedBitmask(enabledChecks) {
        if (enabledChecks !== 0 &&
            this.restrictionLevel !== RestrictionLevel.UNDEFINED_RESTRICTIVE) {
            return this.checks | this.restrictionLevel;
        }
        else {
            return this.checks;
        }
    }
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var interopRequireDefault = createCommonjsModule(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(interopRequireDefault);

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (bind ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});

var FunctionPrototype$1 = Function.prototype;
var bind$1 = FunctionPrototype$1.bind;
var call$1 = FunctionPrototype$1.call;
var callBind = bind$1 && bind$1.bind(call$1);

var functionUncurryThis = bind$1 ? function (fn) {
  return fn && callBind(call$1, fn);
} : function (fn) {
  return fn && function () {
    return call$1.apply(fn, arguments);
  };
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable = function (argument) {
  return typeof argument == 'function';
};

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var call$2 = Function.prototype.call;

var functionCall = call$2.bind ? call$2.bind(call$2) : function () {
  return call$2.apply(call$2, arguments);
};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var objectPropertyIsEnumerable = {
	f: f
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = functionUncurryThis({}.toString);
var stringSlice = functionUncurryThis(''.slice);

var classofRaw = function (it) {
  return stringSlice(toString(it), 8, -1);
};

var Object$1 = global_1.Object;
var split = functionUncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object$1('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split(it, '') : Object$1(it);
} : Object$1;

var TypeError$1 = global_1.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (it == undefined) throw TypeError$1("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

var isObject = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};

var path = {};

var aFunction = function (variable) {
  return isCallable(variable) ? variable : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global_1[namespace])
    : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
};

var objectIsPrototypeOf = functionUncurryThis({}.isPrototypeOf);

var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';

var process = global_1.process;
var Deno = global_1.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version$1;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version$1 = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version$1 && engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match) version$1 = +match[1];
  }
}

var engineV8Version = version$1;

/* eslint-disable es/no-symbol -- required for testing */



// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && engineV8Version && engineV8Version < 41;
});

/* eslint-disable es/no-symbol -- required for testing */


var useSymbolAsUid = nativeSymbol
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var Object$2 = global_1.Object;

var isSymbol = useSymbolAsUid ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && objectIsPrototypeOf($Symbol.prototype, Object$2(it));
};

var String$1 = global_1.String;

var tryToString = function (argument) {
  try {
    return String$1(argument);
  } catch (error) {
    return 'Object';
  }
};

var TypeError$2 = global_1.TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError$2(tryToString(argument) + ' is not a function');
};

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};

var TypeError$3 = global_1.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = functionCall(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
  throw TypeError$3("Can't convert object to primitive value");
};

var isPure = true;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

var setGlobal = function (key, value) {
  try {
    defineProperty(global_1, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global_1[key] = value;
  } return value;
};

var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || setGlobal(SHARED, {});

var sharedStore = store;

var shared = createCommonjsModule(function (module) {
(module.exports = function (key, value) {
  return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.18.3',
  mode: isPure ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});
});

var Object$3 = global_1.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject = function (argument) {
  return Object$3(requireObjectCoercible(argument));
};

var hasOwnProperty = functionUncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};

var id = 0;
var postfix = Math.random();
var toString$1 = functionUncurryThis(1.0.toString);

var uid = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$1(++id + postfix, 36);
};

var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global_1.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol = function (name) {
  if (!hasOwnProperty_1(WellKnownSymbolsStore, name) || !(nativeSymbol || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (nativeSymbol && hasOwnProperty_1(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (useSymbolAsUid && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var TypeError$4 = global_1.TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = functionCall(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError$4("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var document$1 = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var f$1 = descriptors ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (ie8DomDefine) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwnProperty_1(O, P)) return createPropertyDescriptor(!functionCall(objectPropertyIsEnumerable.f, O, P), O[P]);
};

var objectGetOwnPropertyDescriptor = {
	f: f$1
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

var bind$2 = functionUncurryThis(functionUncurryThis.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : bind$2 ? bind$2(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var String$2 = global_1.String;
var TypeError$5 = global_1.TypeError;

// `Assert: Type(argument) is Object`
var anObject = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError$5(String$2(argument) + ' is not an object');
};

var TypeError$6 = global_1.TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var f$2 = descriptors ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError$6('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty = {
	f: f$2
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;






var wrapConstructor = function (NativeConstructor) {
  var Wrapper = function (a, b, c) {
    if (this instanceof Wrapper) {
      switch (arguments.length) {
        case 0: return new NativeConstructor();
        case 1: return new NativeConstructor(a);
        case 2: return new NativeConstructor(a, b);
      } return new NativeConstructor(a, b, c);
    } return functionApply(NativeConstructor, this, arguments);
  };
  Wrapper.prototype = NativeConstructor.prototype;
  return Wrapper;
};

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var PROTO = options.proto;

  var nativeSource = GLOBAL ? global_1 : STATIC ? global_1[TARGET] : (global_1[TARGET] || {}).prototype;

  var target = GLOBAL ? path : path[TARGET] || createNonEnumerableProperty(path, TARGET, {})[TARGET];
  var targetPrototype = target.prototype;

  var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
  var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;

  for (key in source) {
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contains in native
    USE_NATIVE = !FORCED && nativeSource && hasOwnProperty_1(nativeSource, key);

    targetProperty = target[key];

    if (USE_NATIVE) if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(nativeSource, key);
      nativeProperty = descriptor && descriptor.value;
    } else nativeProperty = nativeSource[key];

    // export native or implementation
    sourceProperty = (USE_NATIVE && nativeProperty) ? nativeProperty : source[key];

    if (USE_NATIVE && typeof targetProperty == typeof sourceProperty) continue;

    // bind timers to global for call from export context
    if (options.bind && USE_NATIVE) resultProperty = functionBindContext(sourceProperty, global_1);
    // wrap global constructors for prevent changs in this version
    else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
    // make static versions for prototype methods
    else if (PROTO && isCallable(sourceProperty)) resultProperty = functionUncurryThis(sourceProperty);
    // default case
    else resultProperty = sourceProperty;

    // add a flag to not completely full polyfills
    if (options.sham || (sourceProperty && sourceProperty.sham) || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(resultProperty, 'sham', true);
    }

    createNonEnumerableProperty(target, key, resultProperty);

    if (PROTO) {
      VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
      if (!hasOwnProperty_1(path, VIRTUAL_PROTOTYPE)) {
        createNonEnumerableProperty(path, VIRTUAL_PROTOTYPE, {});
      }
      // export virtual prototype methods
      createNonEnumerableProperty(path[VIRTUAL_PROTOTYPE], key, sourceProperty);
      // export real prototype methods
      if (options.real && targetPrototype && !targetPrototype[key]) {
        createNonEnumerableProperty(targetPrototype, key, sourceProperty);
      }
    }
  }
};

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
_export({ target: 'Object', stat: true, forced: !descriptors, sham: !descriptors }, {
  defineProperty: objectDefineProperty.f
});

var defineProperty_1 = createCommonjsModule(function (module) {
var Object = path.Object;

var defineProperty = module.exports = function defineProperty(it, key, desc) {
  return Object.defineProperty(it, key, desc);
};

if (Object.defineProperty.sham) defineProperty.sham = true;
});

var defineProperty$1 = defineProperty_1;

var defineProperty$2 = defineProperty$1;

var iterators = {};

var functionToString = functionUncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(sharedStore.inspectSource)) {
  sharedStore.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var WeakMap = global_1.WeakMap;

var nativeWeakMap = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));

var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys = {};

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$7 = global_1.TypeError;
var WeakMap$1 = global_1.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$7('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (nativeWeakMap || sharedStore.state) {
  var store$1 = sharedStore.state || (sharedStore.state = new WeakMap$1());
  var wmget = functionUncurryThis(store$1.get);
  var wmhas = functionUncurryThis(store$1.has);
  var wmset = functionUncurryThis(store$1.set);
  set = function (it, metadata) {
    if (wmhas(store$1, it)) throw new TypeError$7(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store$1, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store$1, it) || {};
  };
  has = function (it) {
    return wmhas(store$1, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwnProperty_1(it, STATE)) throw new TypeError$7(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwnProperty_1(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwnProperty_1(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var FunctionPrototype$2 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = descriptors && Object.getOwnPropertyDescriptor;

var EXISTS$1 = hasOwnProperty_1(FunctionPrototype$2, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS$1 && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS$1 && (!descriptors || (descriptors && getDescriptor(FunctionPrototype$2, 'name').configurable));

var functionName = {
  EXISTS: EXISTS$1,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor$1 : ceil)(number);
};

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength = function (argument) {
  return argument > 0 ? min$1(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike = function (obj) {
  return toLength(obj.length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;


var push = functionUncurryThis([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwnProperty_1(hiddenKeys, key) && hasOwnProperty_1(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwnProperty_1(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], props[key]);
  return O;
};

var html = getBuiltIn('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */








var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : objectDefineProperties(result, Properties);
};

var correctPrototypeGetter = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO$1 = sharedKey('IE_PROTO');
var Object$4 = global_1.Object;
var ObjectPrototype = Object$4.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf = correctPrototypeGetter ? Object$4.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwnProperty_1(object, IE_PROTO$1)) return object[IE_PROTO$1];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object$4 ? ObjectPrototype : null;
};

var redefine = function (target, key, value, options) {
  if (options && options.enumerable) target[key] = value;
  else createNonEnumerableProperty(target, key, value);
};

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (isPure) IteratorPrototype = objectCreate(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  redefine(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
var Object$5 = global_1.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object$5(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var objectToString = toStringTagSupport ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};

var defineProperty$3 = objectDefineProperty.f;





var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');

var setToStringTag = function (it, TAG, STATIC, SET_METHOD) {
  if (it) {
    var target = STATIC ? it : it.prototype;
    if (!hasOwnProperty_1(target, TO_STRING_TAG$2)) {
      defineProperty$3(target, TO_STRING_TAG$2, { configurable: true, value: TAG });
    }
    if (SET_METHOD && !toStringTagSupport) {
      createNonEnumerableProperty(target, 'toString', objectToString);
    }
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;





var returnThis = function () { return this; };

var createIteratorConstructor = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};

var String$3 = global_1.String;
var TypeError$8 = global_1.TypeError;

var aPossiblePrototype = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw TypeError$8("Can't set " + String$3(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */




// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = functionUncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var PROPER_FUNCTION_NAME = functionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis$1 = function () { return this; };

var defineIterator = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$1 && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!isPure && objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype$2) {
        if (objectSetPrototypeOf) {
          objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$2);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR$1])) {
          redefine(CurrentIteratorPrototype, ITERATOR$1, returnThis$1);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (isPure) iterators[TO_STRING_TAG] = returnThis$1;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!isPure && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return functionCall(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!isPure || FORCED) && IterablePrototype[ITERATOR$1] !== defaultIterator) {
    redefine(IterablePrototype, ITERATOR$1, defaultIterator, { name: DEFAULT });
  }
  iterators[NAME] = defaultIterator;

  return methods;
};

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = internalState.set;
var getInternalState = internalState.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
iterators.Arguments = iterators.Array;

var String$4 = global_1.String;

var toString_1 = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String$4(argument);
};

var charAt = functionUncurryThis(''.charAt);
var charCodeAt = functionUncurryThis(''.charCodeAt);
var stringSlice$1 = functionUncurryThis(''.slice);

var createMethod$1 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString_1(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$1(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};

var charAt$1 = stringMultibyte.charAt;




var STRING_ITERATOR = 'String Iterator';
var setInternalState$1 = internalState.set;
var getInternalState$1 = internalState.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState$1(this, {
    type: STRING_ITERATOR,
    string: toString_1(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$1(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt$1(string, index);
  state.index += point.length;
  return { value: point, done: false };
});

var ITERATOR$2 = wellKnownSymbol('iterator');

var getIteratorMethod = function (it) {
  if (it != undefined) return getMethod(it, ITERATOR$2)
    || getMethod(it, '@@iterator')
    || iterators[classof(it)];
};

var TypeError$9 = global_1.TypeError;

var getIterator = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(functionCall(iteratorMethod, argument));
  throw TypeError$9(tryToString(argument) + ' is not iterable');
};

var getIterator_1 = getIterator;

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');

for (var COLLECTION_NAME in domIterables) {
  var Collection = global_1[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype && classof(CollectionPrototype) !== TO_STRING_TAG$3) {
    createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$3, COLLECTION_NAME);
  }
  iterators[COLLECTION_NAME] = iterators.Array;
}

var getIterator$1 = getIterator_1;

var getIterator$2 = getIterator$1;

var getIterator$3 = getIterator$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray || function isArray(argument) {
  return classofRaw(argument) == 'Array';
};

// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
_export({ target: 'Array', stat: true }, {
  isArray: isArray
});

var isArray$1 = path.Array.isArray;

var isArray$2 = isArray$1;

var isArray$3 = isArray$2;

var getIteratorMethod_1 = getIteratorMethod;

var getIteratorMethod$1 = getIteratorMethod_1;

var getIteratorMethod$2 = getIteratorMethod$1;

var getIteratorMethod$3 = getIteratorMethod$2;

var createProperty = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = functionUncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function (argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function (argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
    // we can't check .prototype since constructors produced by .bind haven't it
  } return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
};

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var SPECIES = wellKnownSymbol('species');
var Array$1 = global_1.Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array$1 || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array$1 : C;
};

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var SPECIES$1 = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return engineV8Version >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$1] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';
var TypeError$10 = global_1.TypeError;

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = engineV8Version >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
_export({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError$10(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError$10(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});

// empty

var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$1);
};

var objectGetOwnPropertyNames = {
	f: f$3
};

var arraySlice = functionUncurryThis([].slice);

/* eslint-disable es/no-object-getownpropertynames -- safe */


var $getOwnPropertyNames = objectGetOwnPropertyNames.f;


var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var f$4 = function getOwnPropertyNames(it) {
  return windowNames && classofRaw(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};

var objectGetOwnPropertyNamesExternal = {
	f: f$4
};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var f$5 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols = {
	f: f$5
};

var f$6 = wellKnownSymbol;

var wellKnownSymbolWrapped = {
	f: f$6
};

var defineProperty$4 = objectDefineProperty.f;

var defineWellKnownSymbol = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwnProperty_1(Symbol, NAME)) defineProperty$4(Symbol, NAME, {
    value: wellKnownSymbolWrapped.f(NAME)
  });
};

var push$1 = functionUncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod$2 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var boundFunction = functionBindContext(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push$1(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push$1(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$2(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$2(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$2(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$2(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$2(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$2(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$2(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod$2(7)
};

var $forEach = arrayIteration.forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE$1 = 'prototype';
var TO_PRIMITIVE$1 = wellKnownSymbol('toPrimitive');

var setInternalState$2 = internalState.set;
var getInternalState$2 = internalState.getterFor(SYMBOL);

var ObjectPrototype$1 = Object[PROTOTYPE$1];
var $Symbol = global_1.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE$1];
var TypeError$11 = global_1.TypeError;
var QObject = global_1.QObject;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var nativeDefineProperty = objectDefineProperty.f;
var nativeGetOwnPropertyNames = objectGetOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = objectPropertyIsEnumerable.f;
var push$2 = functionUncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore$1 = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE$1] || !QObject[PROTOTYPE$1].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = descriptors && fails(function () {
  return objectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype$1, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype$1[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype$1) {
    nativeDefineProperty(ObjectPrototype$1, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = objectCreate(SymbolPrototype);
  setInternalState$2(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!descriptors) symbol.description = description;
  return symbol;
};

var $defineProperty$1 = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype$1) $defineProperty$1(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwnProperty_1(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwnProperty_1(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwnProperty_1(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = objectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!descriptors || functionCall($propertyIsEnumerable$1, properties, key)) $defineProperty$1(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? objectCreate(O) : $defineProperties(objectCreate(O), Properties);
};

var $propertyIsEnumerable$1 = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = functionCall(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype$1 && hasOwnProperty_1(AllSymbols, P) && !hasOwnProperty_1(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwnProperty_1(this, P) || !hasOwnProperty_1(AllSymbols, P) || hasOwnProperty_1(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor$1 = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype$1 && hasOwnProperty_1(AllSymbols, key) && !hasOwnProperty_1(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwnProperty_1(AllSymbols, key) && !(hasOwnProperty_1(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames$1 = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwnProperty_1(AllSymbols, key) && !hasOwnProperty_1(hiddenKeys, key)) push$2(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$1;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwnProperty_1(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwnProperty_1(ObjectPrototype$1, key))) {
      push$2(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!nativeSymbol) {
  $Symbol = function Symbol() {
    if (objectIsPrototypeOf(SymbolPrototype, this)) throw TypeError$11('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : toString_1(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype$1) functionCall(setter, ObjectPrototypeSymbols, value);
      if (hasOwnProperty_1(this, HIDDEN) && hasOwnProperty_1(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (descriptors && USE_SETTER) setSymbolDescriptor(ObjectPrototype$1, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE$1];

  redefine(SymbolPrototype, 'toString', function toString() {
    return getInternalState$2(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  objectPropertyIsEnumerable.f = $propertyIsEnumerable$1;
  objectDefineProperty.f = $defineProperty$1;
  objectGetOwnPropertyDescriptor.f = $getOwnPropertyDescriptor$1;
  objectGetOwnPropertyNames.f = objectGetOwnPropertyNamesExternal.f = $getOwnPropertyNames$1;
  objectGetOwnPropertySymbols.f = $getOwnPropertySymbols;

  wellKnownSymbolWrapped.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (descriptors) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState$2(this).description;
      }
    });
    if (!isPure) {
      redefine(ObjectPrototype$1, 'propertyIsEnumerable', $propertyIsEnumerable$1, { unsafe: true });
    }
  }
}

_export({ global: true, wrap: true, forced: !nativeSymbol, sham: !nativeSymbol }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore$1), function (name) {
  defineWellKnownSymbol(name);
});

_export({ target: SYMBOL, stat: true, forced: !nativeSymbol }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = toString_1(key);
    if (hasOwnProperty_1(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError$11(sym + ' is not a symbol');
    if (hasOwnProperty_1(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

_export({ target: 'Object', stat: true, forced: !nativeSymbol, sham: !descriptors }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty$1,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor$1
});

_export({ target: 'Object', stat: true, forced: !nativeSymbol }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames$1,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
_export({ target: 'Object', stat: true, forced: fails(function () { objectGetOwnPropertySymbols.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return objectGetOwnPropertySymbols.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !nativeSymbol || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  _export({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (isCallable($replacer)) value = functionCall($replacer, this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return functionApply($stringify, null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!SymbolPrototype[TO_PRIMITIVE$1]) {
  var valueOf = SymbolPrototype.valueOf;
  // eslint-disable-next-line no-unused-vars -- required for .length
  redefine(SymbolPrototype, TO_PRIMITIVE$1, function (hint) {
    // TODO: improve hint logic
    return functionCall(valueOf, this);
  });
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');

// empty

// `Symbol.hasInstance` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.hasinstance
defineWellKnownSymbol('hasInstance');

// `Symbol.isConcatSpreadable` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
defineWellKnownSymbol('isConcatSpreadable');

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');

// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
defineWellKnownSymbol('match');

// `Symbol.matchAll` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.matchall
defineWellKnownSymbol('matchAll');

// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
defineWellKnownSymbol('replace');

// `Symbol.search` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.search
defineWellKnownSymbol('search');

// `Symbol.species` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.species
defineWellKnownSymbol('species');

// `Symbol.split` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.split
defineWellKnownSymbol('split');

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');

// `Symbol.unscopables` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.unscopables
defineWellKnownSymbol('unscopables');

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global_1.JSON, 'JSON', true);

// empty

// empty

var symbol = path.Symbol;

var symbol$1 = symbol;

var symbol$2 = symbol$1;

var iteratorClose = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = functionCall(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

var ITERATOR$3 = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod = function (it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype[ITERATOR$3] === it);
};

var Array$2 = global_1.Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = functionBindContext(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this == Array$2 && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = functionCall(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : Array$2(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};

var ITERATOR$4 = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$4] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
_export({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: arrayFrom
});

var from_1 = path.Array.from;

var from_1$1 = from_1;

var from_1$2 = from_1$1;

var entryVirtual = function (CONSTRUCTOR) {
  return path[CONSTRUCTOR + 'Prototype'];
};

var concat = entryVirtual('Array').concat;

var ArrayPrototype$1 = Array.prototype;

var concat$1 = function (it) {
  var own = it.concat;
  return it === ArrayPrototype$1 || (objectIsPrototypeOf(ArrayPrototype$1, it) && own === ArrayPrototype$1.concat) ? concat : own;
};

var concat$2 = concat$1;

var concat$3 = concat$2;

var arrayMethodIsStrict = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

/* eslint-disable es/no-array-prototype-indexof -- required for testing */


var $IndexOf = arrayIncludes.indexOf;


var un$IndexOf = functionUncurryThis([].indexOf);

var NEGATIVE_ZERO = !!un$IndexOf && 1 / un$IndexOf([1], 1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
_export({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? un$IndexOf(this, searchElement, fromIndex) || 0
      : $IndexOf(this, searchElement, fromIndex);
  }
});

var indexOf$1 = entryVirtual('Array').indexOf;

var ArrayPrototype$2 = Array.prototype;

var indexOf$2 = function (it) {
  var own = it.indexOf;
  return it === ArrayPrototype$2 || (objectIsPrototypeOf(ArrayPrototype$2, it) && own === ArrayPrototype$2.indexOf) ? indexOf$1 : own;
};

var indexOf$3 = indexOf$2;

var indexOf$4 = indexOf$3;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
_export({ target: 'Object', stat: true, sham: !descriptors }, {
  create: objectCreate
});

var Object$6 = path.Object;

var create = function create(P, D) {
  return Object$6.create(P, D);
};

var create$1 = create;

var create$2 = create$1;

var isArray$4 = isArray$2;

var isArray$5 = isArray$4;

var arrayWithHoles = createCommonjsModule(function (module) {
function _arrayWithHoles(arr) {
  if (isArray$5(arr)) return arr;
}

module.exports = _arrayWithHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(arrayWithHoles);

// `Symbol.asyncDispose` well-known symbol
// https://github.com/tc39/proposal-using-statement
defineWellKnownSymbol('asyncDispose');

// `Symbol.dispose` well-known symbol
// https://github.com/tc39/proposal-using-statement
defineWellKnownSymbol('dispose');

// `Symbol.matcher` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol('matcher');

// `Symbol.metadata` well-known symbol
// https://github.com/tc39/proposal-decorators
defineWellKnownSymbol('metadata');

// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
defineWellKnownSymbol('observable');

// TODO: remove from `core-js@4`


// `Symbol.patternMatch` well-known symbol
// https://github.com/tc39/proposal-pattern-matching
defineWellKnownSymbol('patternMatch');

// TODO: remove from `core-js@4`


defineWellKnownSymbol('replaceAll');

// TODO: Remove from `core-js@4`

// TODO: Remove from `core-js@4`


var symbol$3 = symbol$1;

var symbol$4 = symbol$3;

var iterableToArrayLimit = createCommonjsModule(function (module) {
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof symbol$4 !== "undefined" && getIteratorMethod$3(arr) || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(iterableToArrayLimit);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES$2 = wellKnownSymbol('species');
var Array$3 = global_1.Array;
var max$1 = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === Array$3 || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES$2];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array$3 || Constructor === undefined) {
        return arraySlice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array$3 : Constructor)(max$1(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});

var slice = entryVirtual('Array').slice;

var ArrayPrototype$3 = Array.prototype;

var slice$1 = function (it) {
  var own = it.slice;
  return it === ArrayPrototype$3 || (objectIsPrototypeOf(ArrayPrototype$3, it) && own === ArrayPrototype$3.slice) ? slice : own;
};

var slice$2 = slice$1;

var slice$3 = slice$2;

var slice$4 = slice$3;

var from_1$3 = from_1$1;

var from_1$4 = from_1$3;

var arrayLikeToArray = createCommonjsModule(function (module) {
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(arrayLikeToArray);

var unsupportedIterableToArray = createCommonjsModule(function (module) {
function _unsupportedIterableToArray(o, minLen) {
  var _context;

  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);

  var n = slice$4(_context = Object.prototype.toString.call(o)).call(_context, 8, -1);

  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return from_1$4(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(unsupportedIterableToArray);

var nonIterableRest = createCommonjsModule(function (module) {
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(nonIterableRest);

var slicedToArray = createCommonjsModule(function (module) {
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(slicedToArray);

var $forEach$1 = arrayIteration.forEach;


var STRICT_METHOD$1 = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD$1 ? function forEach(callbackfn /* , thisArg */) {
  return $forEach$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
_export({ target: 'Array', proto: true, forced: [].forEach != arrayForEach }, {
  forEach: arrayForEach
});

var forEach = entryVirtual('Array').forEach;

var forEach$1 = forEach;

var ArrayPrototype$4 = Array.prototype;

var DOMIterables = {
  DOMTokenList: true,
  NodeList: true
};

var forEach$2 = function (it) {
  var own = it.forEach;
  return it === ArrayPrototype$4 || (objectIsPrototypeOf(ArrayPrototype$4, it) && own === ArrayPrototype$4.forEach)
    || hasOwnProperty_1(DOMIterables, classof(it)) ? forEach$1 : own;
};

var forEach$3 = forEach$2;

var $includes = arrayIncludes.includes;


// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
_export({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var includes = entryVirtual('Array').includes;

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
};

var TypeError$12 = global_1.TypeError;

var notARegexp = function (it) {
  if (isRegexp(it)) {
    throw TypeError$12("The method doesn't accept regular expressions");
  } return it;
};

var MATCH$1 = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var stringIndexOf = functionUncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
_export({ target: 'String', proto: true, forced: !correctIsRegexpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString_1(requireObjectCoercible(this)),
      toString_1(notARegexp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

var includes$1 = entryVirtual('String').includes;

var ArrayPrototype$5 = Array.prototype;
var StringPrototype = String.prototype;

var includes$2 = function (it) {
  var own = it.includes;
  if (it === ArrayPrototype$5 || (objectIsPrototypeOf(ArrayPrototype$5, it) && own === ArrayPrototype$5.includes)) return includes;
  if (typeof it == 'string' || it === StringPrototype || (objectIsPrototypeOf(StringPrototype, it) && own === StringPrototype.includes)) {
    return includes$1;
  } return own;
};

var includes$3 = includes$2;

var includes$4 = includes$3;

// a string of all valid unicode whitespaces
var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var replace = functionUncurryThis(''.replace);
var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$3 = function (TYPE) {
  return function ($this) {
    var string = toString_1(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$3(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$3(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$3(3)
};

var trim = stringTrim.trim;


var $parseInt = global_1.parseInt;
var Symbol$2 = global_1.Symbol;
var ITERATOR$5 = Symbol$2 && Symbol$2.iterator;
var hex = /^[+-]?0x/i;
var exec$1 = functionUncurryThis(hex.exec);
var FORCED$1 = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR$5 && !fails(function () { $parseInt(Object(ITERATOR$5)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED$1 ? function parseInt(string, radix) {
  var S = trim(toString_1(string));
  return $parseInt(S, (radix >>> 0) || (exec$1(hex, S) ? 16 : 10));
} : $parseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
_export({ global: true, forced: parseInt != numberParseInt }, {
  parseInt: numberParseInt
});

var _parseInt = path.parseInt;

var _parseInt$1 = _parseInt;

var _parseInt$2 = _parseInt$1;

var slice$5 = slice$2;

var floor$2 = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor$2(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice(array, 0, middle), comparefn),
    mergeSort(arraySlice(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

var arraySort = mergeSort;

var firefox = engineUserAgent.match(/firefox\/(\d+)/i);

var engineFfVersion = !!firefox && +firefox[1];

var engineIsIeOrEdge = /MSIE|Trident/.test(engineUserAgent);

var webkit = engineUserAgent.match(/AppleWebKit\/(\d+)\./);

var engineWebkitVersion = !!webkit && +webkit[1];

var test$1 = [];
var un$Sort = functionUncurryThis(test$1.sort);
var push$3 = functionUncurryThis(test$1.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test$1.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test$1.sort(null);
});
// Old WebKit
var STRICT_METHOD$2 = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (engineV8Version) return engineV8Version < 70;
  if (engineFfVersion && engineFfVersion > 3) return;
  if (engineIsIeOrEdge) return true;
  if (engineWebkitVersion) return engineWebkitVersion < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test$1.push({ k: chr + index, v: value });
    }
  }

  test$1.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test$1.length; index++) {
    chr = test$1[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED$2 = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD$2 || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString_1(x) > toString_1(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
_export({ target: 'Array', proto: true, forced: FORCED$2 }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? un$Sort(array) : un$Sort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push$3(items, array[index]);
    }

    arraySort(items, getSortCompare(comparefn));

    itemsLength = items.length;
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) delete array[index++];

    return array;
  }
});

var sort = entryVirtual('Array').sort;

var ArrayPrototype$6 = Array.prototype;

var sort$1 = function (it) {
  var own = it.sort;
  return it === ArrayPrototype$6 || (objectIsPrototypeOf(ArrayPrototype$6, it) && own === ArrayPrototype$6.sort) ? sort : own;
};

var sort$2 = sort$1;

var sort$3 = sort$2;

// empty

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

var flags = functionUncurryThis(regexpFlags);

var RegExpPrototype = RegExp.prototype;

var flags_1 = function (it) {
  return (it === RegExpPrototype || objectIsPrototypeOf(RegExpPrototype, it)) ? flags(it) : it.flags;
};

var flags$1 = flags_1;

var flags$2 = flags$1;

var xregexp = createCommonjsModule(function (module, exports) {





defineProperty$2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _getIterator2 = interopRequireDefault(getIterator$3);

var _isArray = interopRequireDefault(isArray$3);

var _getIteratorMethod2 = interopRequireDefault(getIteratorMethod$3);

var _symbol = interopRequireDefault(symbol$2);

var _from = interopRequireDefault(from_1$2);

var _concat = interopRequireDefault(concat$3);

var _indexOf = interopRequireDefault(indexOf$4);

var _create = interopRequireDefault(create$2);

var _slicedToArray2 = interopRequireDefault(slicedToArray);

var _forEach = interopRequireDefault(forEach$3);

var _includes = interopRequireDefault(includes$4);

var _parseInt2 = interopRequireDefault(_parseInt$2);

var _slice = interopRequireDefault(slice$5);

var _sort = interopRequireDefault(sort$3);

var _flags = interopRequireDefault(flags$2);

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof _symbol["default"] === "undefined" || (0, _getIteratorMethod2["default"])(o) == null) { if ((0, _isArray["default"])(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = (0, _getIterator2["default"])(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { var _context9; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = (0, _slice["default"])(_context9 = Object.prototype.toString.call(o)).call(_context9, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return (0, _from["default"])(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*!
 * XRegExp 4.4.1
 * <xregexp.com>
 * Steven Levithan (c) 2007-present MIT License
 */

/**
 * XRegExp provides augmented, extensible regular expressions. You get additional regex syntax and
 * flags, beyond what browsers support natively. XRegExp is also a regex utility belt with tools to
 * make your client-side grepping simpler and more powerful, while freeing you from related
 * cross-browser inconsistencies.
 */
// ==--------------------------==
// Private stuff
// ==--------------------------==
// Property name used for extended regex instance data
var REGEX_DATA = 'xregexp'; // Optional features that can be installed and uninstalled

var features = {
  astral: false,
  namespacing: false
}; // Native methods to use and restore ('native' is an ES3 reserved keyword)

var nativ = {
  exec: RegExp.prototype.exec,
  test: RegExp.prototype.test,
  match: String.prototype.match,
  replace: String.prototype.replace,
  split: String.prototype.split
}; // Storage for fixed/extended native methods

var fixed = {}; // Storage for regexes cached by `XRegExp.cache`

var regexCache = {}; // Storage for pattern details cached by the `XRegExp` constructor

var patternCache = {}; // Storage for regex syntax tokens added internally or by `XRegExp.addToken`

var tokens = []; // Token scopes

var defaultScope = 'default';
var classScope = 'class'; // Regexes that match native regex syntax, including octals

var nativeTokens = {
  // Any native multicharacter token in default scope, or any single character
  'default': /\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9]\d*|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|\(\?(?:[:=!]|<[=!])|[?*+]\?|{\d+(?:,\d*)?}\??|[\s\S]/,
  // Any native multicharacter token in character class scope, or any single character
  'class': /\\(?:[0-3][0-7]{0,2}|[4-7][0-7]?|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|[\s\S]/
}; // Any backreference or dollar-prefixed character in replacement strings

var replacementToken = /\$(?:{([\w$]+)}|<([\w$]+)>|(\d\d?|[\s\S]))/g; // Check for correct `exec` handling of nonparticipating capturing groups

var correctExecNpcg = nativ.exec.call(/()??/, '')[1] === undefined; // Check for ES6 `flags` prop support

var hasFlagsProp = (0, _flags["default"])(/x/) !== undefined; // Shortcut to `Object.prototype.toString`

var _ref = {},
    toString = _ref.toString;

function hasNativeFlag(flag) {
  // Can't check based on the presence of properties/getters since browsers might support such
  // properties even when they don't support the corresponding flag in regex construction (tested
  // in Chrome 48, where `'unicode' in /x/` is true but trying to construct a regex with flag `u`
  // throws an error)
  var isSupported = true;

  try {

    if (flag === 'y') {
      // Using function to avoid babel transform to regex literal
      var gy = function () {
        return 'gy';
      }();

      var incompleteY = '.a'.replace(new RegExp('a', gy), '.') === '..';

      if (incompleteY) {
        isSupported = false;
      }
    }
  } catch (exception) {
    isSupported = false;
  }

  return isSupported;
} // Check for ES6 `u` flag support


var hasNativeU = hasNativeFlag('u'); // Check for ES6 `y` flag support

var hasNativeY = hasNativeFlag('y'); // Tracker for known flags, including addon flags

var registeredFlags = {
  g: true,
  i: true,
  m: true,
  u: hasNativeU,
  y: hasNativeY
};
/**
 * Attaches extended data and `XRegExp.prototype` properties to a regex object.
 *
 * @private
 * @param {RegExp} regex Regex to augment.
 * @param {Array} captureNames Array with capture names, or `null`.
 * @param {String} xSource XRegExp pattern used to generate `regex`, or `null` if N/A.
 * @param {String} xFlags XRegExp flags used to generate `regex`, or `null` if N/A.
 * @param {Boolean} [isInternalOnly=false] Whether the regex will be used only for internal
 *   operations, and never exposed to users. For internal-only regexes, we can improve perf by
 *   skipping some operations like attaching `XRegExp.prototype` properties.
 * @returns {!RegExp} Augmented regex.
 */

function augment(regex, captureNames, xSource, xFlags, isInternalOnly) {
  var _context;

  regex[REGEX_DATA] = {
    captureNames: captureNames
  };

  if (isInternalOnly) {
    return regex;
  } // Can't auto-inherit these since the XRegExp constructor returns a nonprimitive value


  if (regex.__proto__) {
    regex.__proto__ = XRegExp.prototype;
  } else {
    for (var p in XRegExp.prototype) {
      // An `XRegExp.prototype.hasOwnProperty(p)` check wouldn't be worth it here, since this
      // is performance sensitive, and enumerable `Object.prototype` or `RegExp.prototype`
      // extensions exist on `regex.prototype` anyway
      regex[p] = XRegExp.prototype[p];
    }
  }

  regex[REGEX_DATA].source = xSource; // Emulate the ES6 `flags` prop by ensuring flags are in alphabetical order

  regex[REGEX_DATA].flags = xFlags ? (0, _sort["default"])(_context = xFlags.split('')).call(_context).join('') : xFlags;
  return regex;
}
/**
 * Removes any duplicate characters from the provided string.
 *
 * @private
 * @param {String} str String to remove duplicate characters from.
 * @returns {string} String with any duplicate characters removed.
 */


function clipDuplicates(str) {
  return nativ.replace.call(str, /([\s\S])(?=[\s\S]*\1)/g, '');
}
/**
 * Copies a regex object while preserving extended data and augmenting with `XRegExp.prototype`
 * properties. The copy has a fresh `lastIndex` property (set to zero). Allows adding and removing
 * flags g and y while copying the regex.
 *
 * @private
 * @param {RegExp} regex Regex to copy.
 * @param {Object} [options] Options object with optional properties:
 *   - `addG` {Boolean} Add flag g while copying the regex.
 *   - `addY` {Boolean} Add flag y while copying the regex.
 *   - `removeG` {Boolean} Remove flag g while copying the regex.
 *   - `removeY` {Boolean} Remove flag y while copying the regex.
 *   - `isInternalOnly` {Boolean} Whether the copied regex will be used only for internal
 *     operations, and never exposed to users. For internal-only regexes, we can improve perf by
 *     skipping some operations like attaching `XRegExp.prototype` properties.
 *   - `source` {String} Overrides `<regex>.source`, for special cases.
 * @returns {RegExp} Copy of the provided regex, possibly with modified flags.
 */


function copyRegex(regex, options) {
  var _context2;

  if (!XRegExp.isRegExp(regex)) {
    throw new TypeError('Type RegExp expected');
  }

  var xData = regex[REGEX_DATA] || {};
  var flags = getNativeFlags(regex);
  var flagsToAdd = '';
  var flagsToRemove = '';
  var xregexpSource = null;
  var xregexpFlags = null;
  options = options || {};

  if (options.removeG) {
    flagsToRemove += 'g';
  }

  if (options.removeY) {
    flagsToRemove += 'y';
  }

  if (flagsToRemove) {
    flags = nativ.replace.call(flags, new RegExp("[".concat(flagsToRemove, "]+"), 'g'), '');
  }

  if (options.addG) {
    flagsToAdd += 'g';
  }

  if (options.addY) {
    flagsToAdd += 'y';
  }

  if (flagsToAdd) {
    flags = clipDuplicates(flags + flagsToAdd);
  }

  if (!options.isInternalOnly) {
    if (xData.source !== undefined) {
      xregexpSource = xData.source;
    } // null or undefined; don't want to add to `flags` if the previous value was null, since
    // that indicates we're not tracking original precompilation flags


    if ((0, _flags["default"])(xData) != null) {
      // Flags are only added for non-internal regexes by `XRegExp.globalize`. Flags are never
      // removed for non-internal regexes, so don't need to handle it
      xregexpFlags = flagsToAdd ? clipDuplicates((0, _flags["default"])(xData) + flagsToAdd) : (0, _flags["default"])(xData);
    }
  } // Augment with `XRegExp.prototype` properties, but use the native `RegExp` constructor to avoid
  // searching for special tokens. That would be wrong for regexes constructed by `RegExp`, and
  // unnecessary for regexes constructed by `XRegExp` because the regex has already undergone the
  // translation to native regex syntax


  regex = augment(new RegExp(options.source || regex.source, flags), hasNamedCapture(regex) ? (0, _slice["default"])(_context2 = xData.captureNames).call(_context2, 0) : null, xregexpSource, xregexpFlags, options.isInternalOnly);
  return regex;
}
/**
 * Converts hexadecimal to decimal.
 *
 * @private
 * @param {String} hex
 * @returns {number}
 */


function dec(hex) {
  return (0, _parseInt2["default"])(hex, 16);
}
/**
 * Returns a pattern that can be used in a native RegExp in place of an ignorable token such as an
 * inline comment or whitespace with flag x. This is used directly as a token handler function
 * passed to `XRegExp.addToken`.
 *
 * @private
 * @param {String} match Match arg of `XRegExp.addToken` handler
 * @param {String} scope Scope arg of `XRegExp.addToken` handler
 * @param {String} flags Flags arg of `XRegExp.addToken` handler
 * @returns {string} Either '' or '(?:)', depending on which is needed in the context of the match.
 */


function getContextualTokenSeparator(match, scope, flags) {
  if ( // No need to separate tokens if at the beginning or end of a group
  match.input[match.index - 1] === '(' || match.input[match.index + match[0].length] === ')' || // No need to separate tokens if before or after a `|`
  match.input[match.index - 1] === '|' || match.input[match.index + match[0].length] === '|' || // No need to separate tokens if at the beginning or end of the pattern
  match.index < 1 || match.index + match[0].length >= match.input.length || // No need to separate tokens if at the beginning of a noncapturing group or lookahead.
  // The way this is written relies on:
  // - The search regex matching only 3-char strings.
  // - Although `substr` gives chars from the end of the string if given a negative index,
  //   the resulting substring will be too short to match. Ex: `'abcd'.substr(-1, 3) === 'd'`
  nativ.test.call(/^\(\?[:=!]/, match.input.substr(match.index - 3, 3)) || // Avoid separating tokens when the following token is a quantifier
  isQuantifierNext(match.input, match.index + match[0].length, flags)) {
    return '';
  } // Keep tokens separated. This avoids e.g. inadvertedly changing `\1 1` or `\1(?#)1` to `\11`.
  // This also ensures all tokens remain as discrete atoms, e.g. it avoids converting the syntax
  // error `(? :` into `(?:`.


  return '(?:)';
}
/**
 * Returns native `RegExp` flags used by a regex object.
 *
 * @private
 * @param {RegExp} regex Regex to check.
 * @returns {string} Native flags in use.
 */


function getNativeFlags(regex) {
  return hasFlagsProp ? (0, _flags["default"])(regex) : // Explicitly using `RegExp.prototype.toString` (rather than e.g. `String` or concatenation
  // with an empty string) allows this to continue working predictably when
  // `XRegExp.proptotype.toString` is overridden
  nativ.exec.call(/\/([a-z]*)$/i, RegExp.prototype.toString.call(regex))[1];
}
/**
 * Determines whether a regex has extended instance data used to track capture names.
 *
 * @private
 * @param {RegExp} regex Regex to check.
 * @returns {boolean} Whether the regex uses named capture.
 */


function hasNamedCapture(regex) {
  return !!(regex[REGEX_DATA] && regex[REGEX_DATA].captureNames);
}
/**
 * Converts decimal to hexadecimal.
 *
 * @private
 * @param {Number|String} dec
 * @returns {string}
 */


function hex(dec) {
  return (0, _parseInt2["default"])(dec, 10).toString(16);
}
/**
 * Checks whether the next nonignorable token after the specified position is a quantifier.
 *
 * @private
 * @param {String} pattern Pattern to search within.
 * @param {Number} pos Index in `pattern` to search at.
 * @param {String} flags Flags used by the pattern.
 * @returns {Boolean} Whether the next nonignorable token is a quantifier.
 */


function isQuantifierNext(pattern, pos, flags) {
  return nativ.test.call((0, _includes["default"])(flags).call(flags, 'x') ? // Ignore any leading whitespace, line comments, and inline comments
  /^(?:\s|#[^#\n]*|\(\?#[^)]*\))*(?:[?*+]|{\d+(?:,\d*)?})/ : // Ignore any leading inline comments
  /^(?:\(\?#[^)]*\))*(?:[?*+]|{\d+(?:,\d*)?})/, (0, _slice["default"])(pattern).call(pattern, pos));
}
/**
 * Determines whether a value is of the specified type, by resolving its internal [[Class]].
 *
 * @private
 * @param {*} value Object to check.
 * @param {String} type Type to check for, in TitleCase.
 * @returns {boolean} Whether the object matches the type.
 */


function isType(value, type) {
  return toString.call(value) === "[object ".concat(type, "]");
}
/**
 * Adds leading zeros if shorter than four characters. Used for fixed-length hexadecimal values.
 *
 * @private
 * @param {String} str
 * @returns {string}
 */


function pad4(str) {
  while (str.length < 4) {
    str = "0".concat(str);
  }

  return str;
}
/**
 * Checks for flag-related errors, and strips/applies flags in a leading mode modifier. Offloads
 * the flag preparation logic from the `XRegExp` constructor.
 *
 * @private
 * @param {String} pattern Regex pattern, possibly with a leading mode modifier.
 * @param {String} flags Any combination of flags.
 * @returns {!Object} Object with properties `pattern` and `flags`.
 */


function prepareFlags(pattern, flags) {
  // Recent browsers throw on duplicate flags, so copy this behavior for nonnative flags
  if (clipDuplicates(flags) !== flags) {
    throw new SyntaxError("Invalid duplicate regex flag ".concat(flags));
  } // Strip and apply a leading mode modifier with any combination of flags except g or y


  pattern = nativ.replace.call(pattern, /^\(\?([\w$]+)\)/, function ($0, $1) {
    if (nativ.test.call(/[gy]/, $1)) {
      throw new SyntaxError("Cannot use flag g or y in mode modifier ".concat($0));
    } // Allow duplicate flags within the mode modifier


    flags = clipDuplicates(flags + $1);
    return '';
  }); // Throw on unknown native or nonnative flags

  var _iterator = _createForOfIteratorHelper(flags),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var flag = _step.value;

      if (!registeredFlags[flag]) {
        throw new SyntaxError("Unknown regex flag ".concat(flag));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return {
    pattern: pattern,
    flags: flags
  };
}
/**
 * Prepares an options object from the given value.
 *
 * @private
 * @param {String|Object} value Value to convert to an options object.
 * @returns {Object} Options object.
 */


function prepareOptions(value) {
  var options = {};

  if (isType(value, 'String')) {
    (0, _forEach["default"])(XRegExp).call(XRegExp, value, /[^\s,]+/, function (match) {
      options[match] = true;
    });
    return options;
  }

  return value;
}
/**
 * Registers a flag so it doesn't throw an 'unknown flag' error.
 *
 * @private
 * @param {String} flag Single-character flag to register.
 */


function registerFlag(flag) {
  if (!/^[\w$]$/.test(flag)) {
    throw new Error('Flag must be a single character A-Za-z0-9_$');
  }

  registeredFlags[flag] = true;
}
/**
 * Runs built-in and custom regex syntax tokens in reverse insertion order at the specified
 * position, until a match is found.
 *
 * @private
 * @param {String} pattern Original pattern from which an XRegExp object is being built.
 * @param {String} flags Flags being used to construct the regex.
 * @param {Number} pos Position to search for tokens within `pattern`.
 * @param {Number} scope Regex scope to apply: 'default' or 'class'.
 * @param {Object} context Context object to use for token handler functions.
 * @returns {Object} Object with properties `matchLength`, `output`, and `reparse`; or `null`.
 */


function runTokens(pattern, flags, pos, scope, context) {
  var i = tokens.length;
  var leadChar = pattern[pos];
  var result = null;
  var match;
  var t; // Run in reverse insertion order

  while (i--) {
    t = tokens[i];

    if (t.leadChar && t.leadChar !== leadChar || t.scope !== scope && t.scope !== 'all' || t.flag && !(0, _includes["default"])(flags).call(flags, t.flag)) {
      continue;
    }

    match = XRegExp.exec(pattern, t.regex, pos, 'sticky');

    if (match) {
      result = {
        matchLength: match[0].length,
        output: t.handler.call(context, match, scope, flags),
        reparse: t.reparse
      }; // Finished with token tests

      break;
    }
  }

  return result;
}
/**
 * Enables or disables implicit astral mode opt-in. When enabled, flag A is automatically added to
 * all new regexes created by XRegExp. This causes an error to be thrown when creating regexes if
 * the Unicode Base addon is not available, since flag A is registered by that addon.
 *
 * @private
 * @param {Boolean} on `true` to enable; `false` to disable.
 */


function setAstral(on) {
  features.astral = on;
}
/**
 * Adds named capture groups to the `groups` property of match arrays. See here for details:
 * https://github.com/tc39/proposal-regexp-named-groups
 *
 * @private
 * @param {Boolean} on `true` to enable; `false` to disable.
 */


function setNamespacing(on) {
  features.namespacing = on;
}
/**
 * Returns the object, or throws an error if it is `null` or `undefined`. This is used to follow
 * the ES5 abstract operation `ToObject`.
 *
 * @private
 * @param {*} value Object to check and return.
 * @returns {*} The provided object.
 */


function toObject(value) {
  // null or undefined
  if (value == null) {
    throw new TypeError('Cannot convert null or undefined to object');
  }

  return value;
} // ==--------------------------==
// Constructor
// ==--------------------------==

/**
 * Creates an extended regular expression object for matching text with a pattern. Differs from a
 * native regular expression in that additional syntax and flags are supported. The returned object
 * is in fact a native `RegExp` and works with all native methods.
 *
 * @class XRegExp
 * @constructor
 * @param {String|RegExp} pattern Regex pattern string, or an existing regex object to copy.
 * @param {String} [flags] Any combination of flags.
 *   Native flags:
 *     - `g` - global
 *     - `i` - ignore case
 *     - `m` - multiline anchors
 *     - `u` - unicode (ES6)
 *     - `y` - sticky (Firefox 3+, ES6)
 *   Additional XRegExp flags:
 *     - `n` - explicit capture
 *     - `s` - dot matches all (aka singleline)
 *     - `x` - free-spacing and line comments (aka extended)
 *     - `A` - astral (requires the Unicode Base addon)
 *   Flags cannot be provided when constructing one `RegExp` from another.
 * @returns {RegExp} Extended regular expression object.
 * @example
 *
 * // With named capture and flag x
 * XRegExp(`(?<year>  [0-9]{4} ) -?  # year
 *          (?<month> [0-9]{2} ) -?  # month
 *          (?<day>   [0-9]{2} )     # day`, 'x');
 *
 * // Providing a regex object copies it. Native regexes are recompiled using native (not XRegExp)
 * // syntax. Copies maintain extended data, are augmented with `XRegExp.prototype` properties, and
 * // have fresh `lastIndex` properties (set to zero).
 * XRegExp(/regex/);
 */


function XRegExp(pattern, flags) {
  if (XRegExp.isRegExp(pattern)) {
    if (flags !== undefined) {
      throw new TypeError('Cannot supply flags when copying a RegExp');
    }

    return copyRegex(pattern);
  } // Copy the argument behavior of `RegExp`


  pattern = pattern === undefined ? '' : String(pattern);
  flags = flags === undefined ? '' : String(flags);

  if (XRegExp.isInstalled('astral') && !(0, _includes["default"])(flags).call(flags, 'A')) {
    // This causes an error to be thrown if the Unicode Base addon is not available
    flags += 'A';
  }

  if (!patternCache[pattern]) {
    patternCache[pattern] = {};
  }

  if (!patternCache[pattern][flags]) {
    var context = {
      hasNamedCapture: false,
      captureNames: []
    };
    var scope = defaultScope;
    var output = '';
    var pos = 0;
    var result; // Check for flag-related errors, and strip/apply flags in a leading mode modifier

    var applied = prepareFlags(pattern, flags);
    var appliedPattern = applied.pattern;
    var appliedFlags = (0, _flags["default"])(applied); // Use XRegExp's tokens to translate the pattern to a native regex pattern.
    // `appliedPattern.length` may change on each iteration if tokens use `reparse`

    while (pos < appliedPattern.length) {
      do {
        // Check for custom tokens at the current position
        result = runTokens(appliedPattern, appliedFlags, pos, scope, context); // If the matched token used the `reparse` option, splice its output into the
        // pattern before running tokens again at the same position

        if (result && result.reparse) {
          appliedPattern = (0, _slice["default"])(appliedPattern).call(appliedPattern, 0, pos) + result.output + (0, _slice["default"])(appliedPattern).call(appliedPattern, pos + result.matchLength);
        }
      } while (result && result.reparse);

      if (result) {
        output += result.output;
        pos += result.matchLength || 1;
      } else {
        // Get the native token at the current position
        var _XRegExp$exec = XRegExp.exec(appliedPattern, nativeTokens[scope], pos, 'sticky'),
            _XRegExp$exec2 = (0, _slicedToArray2["default"])(_XRegExp$exec, 1),
            token = _XRegExp$exec2[0];

        output += token;
        pos += token.length;

        if (token === '[' && scope === defaultScope) {
          scope = classScope;
        } else if (token === ']' && scope === classScope) {
          scope = defaultScope;
        }
      }
    }

    patternCache[pattern][flags] = {
      // Use basic cleanup to collapse repeated empty groups like `(?:)(?:)` to `(?:)`. Empty
      // groups are sometimes inserted during regex transpilation in order to keep tokens
      // separated. However, more than one empty group in a row is never needed.
      pattern: nativ.replace.call(output, /(?:\(\?:\))+/g, '(?:)'),
      // Strip all but native flags
      flags: nativ.replace.call(appliedFlags, /[^gimuy]+/g, ''),
      // `context.captureNames` has an item for each capturing group, even if unnamed
      captures: context.hasNamedCapture ? context.captureNames : null
    };
  }

  var generated = patternCache[pattern][flags];
  return augment(new RegExp(generated.pattern, (0, _flags["default"])(generated)), generated.captures, pattern, flags);
} // Add `RegExp.prototype` to the prototype chain


XRegExp.prototype = /(?:)/; // ==--------------------------==
// Public properties
// ==--------------------------==

/**
 * The XRegExp version number as a string containing three dot-separated parts. For example,
 * '2.0.0-beta-3'.
 *
 * @static
 * @memberOf XRegExp
 * @type String
 */

XRegExp.version = '4.4.1'; // ==--------------------------==
// Public methods
// ==--------------------------==
// Intentionally undocumented; used in tests and addons

XRegExp._clipDuplicates = clipDuplicates;
XRegExp._hasNativeFlag = hasNativeFlag;
XRegExp._dec = dec;
XRegExp._hex = hex;
XRegExp._pad4 = pad4;
/**
 * Extends XRegExp syntax and allows custom flags. This is used internally and can be used to
 * create XRegExp addons. If more than one token can match the same string, the last added wins.
 *
 * @memberOf XRegExp
 * @param {RegExp} regex Regex object that matches the new token.
 * @param {Function} handler Function that returns a new pattern string (using native regex syntax)
 *   to replace the matched token within all future XRegExp regexes. Has access to persistent
 *   properties of the regex being built, through `this`. Invoked with three arguments:
 *   - The match array, with named backreference properties.
 *   - The regex scope where the match was found: 'default' or 'class'.
 *   - The flags used by the regex, including any flags in a leading mode modifier.
 *   The handler function becomes part of the XRegExp construction process, so be careful not to
 *   construct XRegExps within the function or you will trigger infinite recursion.
 * @param {Object} [options] Options object with optional properties:
 *   - `scope` {String} Scope where the token applies: 'default', 'class', or 'all'.
 *   - `flag` {String} Single-character flag that triggers the token. This also registers the
 *     flag, which prevents XRegExp from throwing an 'unknown flag' error when the flag is used.
 *   - `optionalFlags` {String} Any custom flags checked for within the token `handler` that are
 *     not required to trigger the token. This registers the flags, to prevent XRegExp from
 *     throwing an 'unknown flag' error when any of the flags are used.
 *   - `reparse` {Boolean} Whether the `handler` function's output should not be treated as
 *     final, and instead be reparseable by other tokens (including the current token). Allows
 *     token chaining or deferring.
 *   - `leadChar` {String} Single character that occurs at the beginning of any successful match
 *     of the token (not always applicable). This doesn't change the behavior of the token unless
 *     you provide an erroneous value. However, providing it can increase the token's performance
 *     since the token can be skipped at any positions where this character doesn't appear.
 * @example
 *
 * // Basic usage: Add \a for the ALERT control code
 * XRegExp.addToken(
 *   /\\a/,
 *   () => '\\x07',
 *   {scope: 'all'}
 * );
 * XRegExp('\\a[\\a-\\n]+').test('\x07\n\x07'); // -> true
 *
 * // Add the U (ungreedy) flag from PCRE and RE2, which reverses greedy and lazy quantifiers.
 * // Since `scope` is not specified, it uses 'default' (i.e., transformations apply outside of
 * // character classes only)
 * XRegExp.addToken(
 *   /([?*+]|{\d+(?:,\d*)?})(\??)/,
 *   (match) => `${match[1]}${match[2] ? '' : '?'}`,
 *   {flag: 'U'}
 * );
 * XRegExp('a+', 'U').exec('aaa')[0]; // -> 'a'
 * XRegExp('a+?', 'U').exec('aaa')[0]; // -> 'aaa'
 */

XRegExp.addToken = function (regex, handler, options) {
  options = options || {};
  var _options = options,
      optionalFlags = _options.optionalFlags;

  if (options.flag) {
    registerFlag(options.flag);
  }

  if (optionalFlags) {
    optionalFlags = nativ.split.call(optionalFlags, '');

    var _iterator2 = _createForOfIteratorHelper(optionalFlags),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var flag = _step2.value;
        registerFlag(flag);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  } // Add to the private list of syntax tokens


  tokens.push({
    regex: copyRegex(regex, {
      addG: true,
      addY: hasNativeY,
      isInternalOnly: true
    }),
    handler: handler,
    scope: options.scope || defaultScope,
    flag: options.flag,
    reparse: options.reparse,
    leadChar: options.leadChar
  }); // Reset the pattern cache used by the `XRegExp` constructor, since the same pattern and flags
  // might now produce different results

  XRegExp.cache.flush('patterns');
};
/**
 * Caches and returns the result of calling `XRegExp(pattern, flags)`. On any subsequent call with
 * the same pattern and flag combination, the cached copy of the regex is returned.
 *
 * @memberOf XRegExp
 * @param {String} pattern Regex pattern string.
 * @param {String} [flags] Any combination of XRegExp flags.
 * @returns {RegExp} Cached XRegExp object.
 * @example
 *
 * while (match = XRegExp.cache('.', 'gs').exec(str)) {
 *   // The regex is compiled once only
 * }
 */


XRegExp.cache = function (pattern, flags) {
  if (!regexCache[pattern]) {
    regexCache[pattern] = {};
  }

  return regexCache[pattern][flags] || (regexCache[pattern][flags] = XRegExp(pattern, flags));
}; // Intentionally undocumented; used in tests


XRegExp.cache.flush = function (cacheName) {
  if (cacheName === 'patterns') {
    // Flush the pattern cache used by the `XRegExp` constructor
    patternCache = {};
  } else {
    // Flush the regex cache populated by `XRegExp.cache`
    regexCache = {};
  }
};
/**
 * Escapes any regular expression metacharacters, for use when matching literal strings. The result
 * can safely be used at any point within a regex that uses any flags.
 *
 * @memberOf XRegExp
 * @param {String} str String to escape.
 * @returns {string} String with regex metacharacters escaped.
 * @example
 *
 * XRegExp.escape('Escaped? <.>');
 * // -> 'Escaped\?\ <\.>'
 */


XRegExp.escape = function (str) {
  return nativ.replace.call(toObject(str), /[-\[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};
/**
 * Executes a regex search in a specified string. Returns a match array or `null`. If the provided
 * regex uses named capture, named backreference properties are included on the match array.
 * Optional `pos` and `sticky` arguments specify the search start position, and whether the match
 * must start at the specified position only. The `lastIndex` property of the provided regex is not
 * used, but is updated for compatibility. Also fixes browser bugs compared to the native
 * `RegExp.prototype.exec` and can be used reliably cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {Number} [pos=0] Zero-based index at which to start the search.
 * @param {Boolean|String} [sticky=false] Whether the match must start at the specified position
 *   only. The string `'sticky'` is accepted as an alternative to `true`.
 * @returns {Array} Match array with named backreference properties, or `null`.
 * @example
 *
 * // Basic use, with named backreference
 * let match = XRegExp.exec('U+2620', XRegExp('U\\+(?<hex>[0-9A-F]{4})'));
 * match.hex; // -> '2620'
 *
 * // With pos and sticky, in a loop
 * let pos = 2, result = [], match;
 * while (match = XRegExp.exec('<1><2><3><4>5<6>', /<(\d)>/, pos, 'sticky')) {
 *   result.push(match[1]);
 *   pos = match.index + match[0].length;
 * }
 * // result -> ['2', '3', '4']
 */


XRegExp.exec = function (str, regex, pos, sticky) {
  var cacheKey = 'g';
  var addY = false;
  var fakeY = false;
  var match;
  addY = hasNativeY && !!(sticky || regex.sticky && sticky !== false);

  if (addY) {
    cacheKey += 'y';
  } else if (sticky) {
    // Simulate sticky matching by appending an empty capture to the original regex. The
    // resulting regex will succeed no matter what at the current index (set with `lastIndex`),
    // and will not search the rest of the subject string. We'll know that the original regex
    // has failed if that last capture is `''` rather than `undefined` (i.e., if that last
    // capture participated in the match).
    fakeY = true;
    cacheKey += 'FakeY';
  }

  regex[REGEX_DATA] = regex[REGEX_DATA] || {}; // Shares cached copies with `XRegExp.match`/`replace`

  var r2 = regex[REGEX_DATA][cacheKey] || (regex[REGEX_DATA][cacheKey] = copyRegex(regex, {
    addG: true,
    addY: addY,
    source: fakeY ? "".concat(regex.source, "|()") : undefined,
    removeY: sticky === false,
    isInternalOnly: true
  }));
  pos = pos || 0;
  r2.lastIndex = pos; // Fixed `exec` required for `lastIndex` fix, named backreferences, etc.

  match = fixed.exec.call(r2, str); // Get rid of the capture added by the pseudo-sticky matcher if needed. An empty string means
  // the original regexp failed (see above).

  if (fakeY && match && match.pop() === '') {
    match = null;
  }

  if (regex.global) {
    regex.lastIndex = match ? r2.lastIndex : 0;
  }

  return match;
};
/**
 * Executes a provided function once per regex match. Searches always start at the beginning of the
 * string and continue until the end, regardless of the state of the regex's `global` property and
 * initial `lastIndex`.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {Function} callback Function to execute for each match. Invoked with four arguments:
 *   - The match array, with named backreference properties.
 *   - The zero-based match index.
 *   - The string being traversed.
 *   - The regex object being used to traverse the string.
 * @example
 *
 * // Extracts every other digit from a string
 * const evens = [];
 * XRegExp.forEach('1a2345', /\d/, (match, i) => {
 *   if (i % 2) evens.push(+match[0]);
 * });
 * // evens -> [2, 4]
 */


XRegExp.forEach = function (str, regex, callback) {
  var pos = 0;
  var i = -1;
  var match;

  while (match = XRegExp.exec(str, regex, pos)) {
    // Because `regex` is provided to `callback`, the function could use the deprecated/
    // nonstandard `RegExp.prototype.compile` to mutate the regex. However, since `XRegExp.exec`
    // doesn't use `lastIndex` to set the search position, this can't lead to an infinite loop,
    // at least. Actually, because of the way `XRegExp.exec` caches globalized versions of
    // regexes, mutating the regex will not have any effect on the iteration or matched strings,
    // which is a nice side effect that brings extra safety.
    callback(match, ++i, str, regex);
    pos = match.index + (match[0].length || 1);
  }
};
/**
 * Copies a regex object and adds flag `g`. The copy maintains extended data, is augmented with
 * `XRegExp.prototype` properties, and has a fresh `lastIndex` property (set to zero). Native
 * regexes are not recompiled using XRegExp syntax.
 *
 * @memberOf XRegExp
 * @param {RegExp} regex Regex to globalize.
 * @returns {RegExp} Copy of the provided regex with flag `g` added.
 * @example
 *
 * const globalCopy = XRegExp.globalize(/regex/);
 * globalCopy.global; // -> true
 */


XRegExp.globalize = function (regex) {
  return copyRegex(regex, {
    addG: true
  });
};
/**
 * Installs optional features according to the specified options. Can be undone using
 * `XRegExp.uninstall`.
 *
 * @memberOf XRegExp
 * @param {Object|String} options Options object or string.
 * @example
 *
 * // With an options object
 * XRegExp.install({
 *   // Enables support for astral code points in Unicode addons (implicitly sets flag A)
 *   astral: true,
 *
 *   // Adds named capture groups to the `groups` property of matches
 *   namespacing: true
 * });
 *
 * // With an options string
 * XRegExp.install('astral namespacing');
 */


XRegExp.install = function (options) {
  options = prepareOptions(options);

  if (!features.astral && options.astral) {
    setAstral(true);
  }

  if (!features.namespacing && options.namespacing) {
    setNamespacing(true);
  }
};
/**
 * Checks whether an individual optional feature is installed.
 *
 * @memberOf XRegExp
 * @param {String} feature Name of the feature to check. One of:
 *   - `astral`
 *   - `namespacing`
 * @returns {boolean} Whether the feature is installed.
 * @example
 *
 * XRegExp.isInstalled('astral');
 */


XRegExp.isInstalled = function (feature) {
  return !!features[feature];
};
/**
 * Returns `true` if an object is a regex; `false` if it isn't. This works correctly for regexes
 * created in another frame, when `instanceof` and `constructor` checks would fail.
 *
 * @memberOf XRegExp
 * @param {*} value Object to check.
 * @returns {boolean} Whether the object is a `RegExp` object.
 * @example
 *
 * XRegExp.isRegExp('string'); // -> false
 * XRegExp.isRegExp(/regex/i); // -> true
 * XRegExp.isRegExp(RegExp('^', 'm')); // -> true
 * XRegExp.isRegExp(XRegExp('(?s).')); // -> true
 */


XRegExp.isRegExp = function (value) {
  return toString.call(value) === '[object RegExp]';
}; // isType(value, 'RegExp');

/**
 * Returns the first matched string, or in global mode, an array containing all matched strings.
 * This is essentially a more convenient re-implementation of `String.prototype.match` that gives
 * the result types you actually want (string instead of `exec`-style array in match-first mode,
 * and an empty array instead of `null` when no matches are found in match-all mode). It also lets
 * you override flag g and ignore `lastIndex`, and fixes browser bugs.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {String} [scope='one'] Use 'one' to return the first match as a string. Use 'all' to
 *   return an array of all matched strings. If not explicitly specified and `regex` uses flag g,
 *   `scope` is 'all'.
 * @returns {String|Array} In match-first mode: First match as a string, or `null`. In match-all
 *   mode: Array of all matched strings, or an empty array.
 * @example
 *
 * // Match first
 * XRegExp.match('abc', /\w/); // -> 'a'
 * XRegExp.match('abc', /\w/g, 'one'); // -> 'a'
 * XRegExp.match('abc', /x/g, 'one'); // -> null
 *
 * // Match all
 * XRegExp.match('abc', /\w/g); // -> ['a', 'b', 'c']
 * XRegExp.match('abc', /\w/, 'all'); // -> ['a', 'b', 'c']
 * XRegExp.match('abc', /x/, 'all'); // -> []
 */


XRegExp.match = function (str, regex, scope) {
  var global = regex.global && scope !== 'one' || scope === 'all';
  var cacheKey = (global ? 'g' : '') + (regex.sticky ? 'y' : '') || 'noGY';
  regex[REGEX_DATA] = regex[REGEX_DATA] || {}; // Shares cached copies with `XRegExp.exec`/`replace`

  var r2 = regex[REGEX_DATA][cacheKey] || (regex[REGEX_DATA][cacheKey] = copyRegex(regex, {
    addG: !!global,
    removeG: scope === 'one',
    isInternalOnly: true
  }));
  var result = nativ.match.call(toObject(str), r2);

  if (regex.global) {
    regex.lastIndex = scope === 'one' && result ? // Can't use `r2.lastIndex` since `r2` is nonglobal in this case
    result.index + result[0].length : 0;
  }

  return global ? result || [] : result && result[0];
};
/**
 * Retrieves the matches from searching a string using a chain of regexes that successively search
 * within previous matches. The provided `chain` array can contain regexes and or objects with
 * `regex` and `backref` properties. When a backreference is specified, the named or numbered
 * backreference is passed forward to the next regex or returned.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {Array} chain Regexes that each search for matches within preceding results.
 * @returns {Array} Matches by the last regex in the chain, or an empty array.
 * @example
 *
 * // Basic usage; matches numbers within <b> tags
 * XRegExp.matchChain('1 <b>2</b> 3 <b>4 a 56</b>', [
 *   XRegExp('(?is)<b>.*?</b>'),
 *   /\d+/
 * ]);
 * // -> ['2', '4', '56']
 *
 * // Passing forward and returning specific backreferences
 * html = '<a href="http://xregexp.com/api/">XRegExp</a>\
 *         <a href="http://www.google.com/">Google</a>';
 * XRegExp.matchChain(html, [
 *   {regex: /<a href="([^"]+)">/i, backref: 1},
 *   {regex: XRegExp('(?i)^https?://(?<domain>[^/?#]+)'), backref: 'domain'}
 * ]);
 * // -> ['xregexp.com', 'www.google.com']
 */


XRegExp.matchChain = function (str, chain) {
  return function recurseChain(values, level) {
    var item = chain[level].regex ? chain[level] : {
      regex: chain[level]
    };
    var matches = [];

    function addMatch(match) {
      if (item.backref) {
        var ERR_UNDEFINED_GROUP = "Backreference to undefined group: ".concat(item.backref);
        var isNamedBackref = isNaN(item.backref);

        if (isNamedBackref && XRegExp.isInstalled('namespacing')) {
          // `groups` has `null` as prototype, so using `in` instead of `hasOwnProperty`
          if (!(item.backref in match.groups)) {
            throw new ReferenceError(ERR_UNDEFINED_GROUP);
          }
        } else if (!match.hasOwnProperty(item.backref)) {
          throw new ReferenceError(ERR_UNDEFINED_GROUP);
        }

        var backrefValue = isNamedBackref && XRegExp.isInstalled('namespacing') ? match.groups[item.backref] : match[item.backref];
        matches.push(backrefValue || '');
      } else {
        matches.push(match[0]);
      }
    }

    var _iterator3 = _createForOfIteratorHelper(values),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var value = _step3.value;
        (0, _forEach["default"])(XRegExp).call(XRegExp, value, item.regex, addMatch);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return level === chain.length - 1 || !matches.length ? matches : recurseChain(matches, level + 1);
  }([str], 0);
};
/**
 * Returns a new string with one or all matches of a pattern replaced. The pattern can be a string
 * or regex, and the replacement can be a string or a function to be called for each match. To
 * perform a global search and replace, use the optional `scope` argument or include flag g if using
 * a regex. Replacement strings can use `${n}` or `$<n>` for named and numbered backreferences.
 * Replacement functions can use named backreferences via `arguments[0].name`. Also fixes browser
 * bugs compared to the native `String.prototype.replace` and can be used reliably cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp|String} search Search pattern to be replaced.
 * @param {String|Function} replacement Replacement string or a function invoked to create it.
 *   Replacement strings can include special replacement syntax:
 *     - $$ - Inserts a literal $ character.
 *     - $&, $0 - Inserts the matched substring.
 *     - $` - Inserts the string that precedes the matched substring (left context).
 *     - $' - Inserts the string that follows the matched substring (right context).
 *     - $n, $nn - Where n/nn are digits referencing an existent capturing group, inserts
 *       backreference n/nn.
 *     - ${n}, $<n> - Where n is a name or any number of digits that reference an existent capturing
 *       group, inserts backreference n.
 *   Replacement functions are invoked with three or more arguments:
 *     - The matched substring (corresponds to $& above). Named backreferences are accessible as
 *       properties of this first argument.
 *     - 0..n arguments, one for each backreference (corresponding to $1, $2, etc. above).
 *     - The zero-based index of the match within the total search string.
 *     - The total string being searched.
 * @param {String} [scope='one'] Use 'one' to replace the first match only, or 'all'. If not
 *   explicitly specified and using a regex with flag g, `scope` is 'all'.
 * @returns {String} New string with one or all matches replaced.
 * @example
 *
 * // Regex search, using named backreferences in replacement string
 * const name = XRegExp('(?<first>\\w+) (?<last>\\w+)');
 * XRegExp.replace('John Smith', name, '$<last>, $<first>');
 * // -> 'Smith, John'
 *
 * // Regex search, using named backreferences in replacement function
 * XRegExp.replace('John Smith', name, (match) => `${match.last}, ${match.first}`);
 * // -> 'Smith, John'
 *
 * // String search, with replace-all
 * XRegExp.replace('RegExp builds RegExps', 'RegExp', 'XRegExp', 'all');
 * // -> 'XRegExp builds XRegExps'
 */


XRegExp.replace = function (str, search, replacement, scope) {
  var isRegex = XRegExp.isRegExp(search);
  var global = search.global && scope !== 'one' || scope === 'all';
  var cacheKey = (global ? 'g' : '') + (search.sticky ? 'y' : '') || 'noGY';
  var s2 = search;

  if (isRegex) {
    search[REGEX_DATA] = search[REGEX_DATA] || {}; // Shares cached copies with `XRegExp.exec`/`match`. Since a copy is used, `search`'s
    // `lastIndex` isn't updated *during* replacement iterations

    s2 = search[REGEX_DATA][cacheKey] || (search[REGEX_DATA][cacheKey] = copyRegex(search, {
      addG: !!global,
      removeG: scope === 'one',
      isInternalOnly: true
    }));
  } else if (global) {
    s2 = new RegExp(XRegExp.escape(String(search)), 'g');
  } // Fixed `replace` required for named backreferences, etc.


  var result = fixed.replace.call(toObject(str), s2, replacement);

  if (isRegex && search.global) {
    // Fixes IE, Safari bug (last tested IE 9, Safari 5.1)
    search.lastIndex = 0;
  }

  return result;
};
/**
 * Performs batch processing of string replacements. Used like `XRegExp.replace`, but accepts an
 * array of replacement details. Later replacements operate on the output of earlier replacements.
 * Replacement details are accepted as an array with a regex or string to search for, the
 * replacement string or function, and an optional scope of 'one' or 'all'. Uses the XRegExp
 * replacement text syntax, which supports named backreference properties via `${name}` or
 * `$<name>`.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {Array} replacements Array of replacement detail arrays.
 * @returns {String} New string with all replacements.
 * @example
 *
 * str = XRegExp.replaceEach(str, [
 *   [XRegExp('(?<name>a)'), 'z${name}'],
 *   [/b/gi, 'y'],
 *   [/c/g, 'x', 'one'], // scope 'one' overrides /g
 *   [/d/, 'w', 'all'],  // scope 'all' overrides lack of /g
 *   ['e', 'v', 'all'],  // scope 'all' allows replace-all for strings
 *   [/f/g, ($0) => $0.toUpperCase()]
 * ]);
 */


XRegExp.replaceEach = function (str, replacements) {
  var _iterator4 = _createForOfIteratorHelper(replacements),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var r = _step4.value;
      str = XRegExp.replace(str, r[0], r[1], r[2]);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return str;
};
/**
 * Splits a string into an array of strings using a regex or string separator. Matches of the
 * separator are not included in the result array. However, if `separator` is a regex that contains
 * capturing groups, backreferences are spliced into the result each time `separator` is matched.
 * Fixes browser bugs compared to the native `String.prototype.split` and can be used reliably
 * cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to split.
 * @param {RegExp|String} separator Regex or string to use for separating the string.
 * @param {Number} [limit] Maximum number of items to include in the result array.
 * @returns {Array} Array of substrings.
 * @example
 *
 * // Basic use
 * XRegExp.split('a b c', ' ');
 * // -> ['a', 'b', 'c']
 *
 * // With limit
 * XRegExp.split('a b c', ' ', 2);
 * // -> ['a', 'b']
 *
 * // Backreferences in result array
 * XRegExp.split('..word1..', /([a-z]+)(\d+)/i);
 * // -> ['..', 'word', '1', '..']
 */


XRegExp.split = function (str, separator, limit) {
  return fixed.split.call(toObject(str), separator, limit);
};
/**
 * Executes a regex search in a specified string. Returns `true` or `false`. Optional `pos` and
 * `sticky` arguments specify the search start position, and whether the match must start at the
 * specified position only. The `lastIndex` property of the provided regex is not used, but is
 * updated for compatibility. Also fixes browser bugs compared to the native
 * `RegExp.prototype.test` and can be used reliably cross-browser.
 *
 * @memberOf XRegExp
 * @param {String} str String to search.
 * @param {RegExp} regex Regex to search with.
 * @param {Number} [pos=0] Zero-based index at which to start the search.
 * @param {Boolean|String} [sticky=false] Whether the match must start at the specified position
 *   only. The string `'sticky'` is accepted as an alternative to `true`.
 * @returns {boolean} Whether the regex matched the provided value.
 * @example
 *
 * // Basic use
 * XRegExp.test('abc', /c/); // -> true
 *
 * // With pos and sticky
 * XRegExp.test('abc', /c/, 0, 'sticky'); // -> false
 * XRegExp.test('abc', /c/, 2, 'sticky'); // -> true
 */
// Do this the easy way :-)


XRegExp.test = function (str, regex, pos, sticky) {
  return !!XRegExp.exec(str, regex, pos, sticky);
};
/**
 * Uninstalls optional features according to the specified options. All optional features start out
 * uninstalled, so this is used to undo the actions of `XRegExp.install`.
 *
 * @memberOf XRegExp
 * @param {Object|String} options Options object or string.
 * @example
 *
 * // With an options object
 * XRegExp.uninstall({
 *   // Disables support for astral code points in Unicode addons
 *   astral: true,
 *
 *   // Don't add named capture groups to the `groups` property of matches
 *   namespacing: true
 * });
 *
 * // With an options string
 * XRegExp.uninstall('astral namespacing');
 */


XRegExp.uninstall = function (options) {
  options = prepareOptions(options);

  if (features.astral && options.astral) {
    setAstral(false);
  }

  if (features.namespacing && options.namespacing) {
    setNamespacing(false);
  }
};
/**
 * Returns an XRegExp object that is the union of the given patterns. Patterns can be provided as
 * regex objects or strings. Metacharacters are escaped in patterns provided as strings.
 * Backreferences in provided regex objects are automatically renumbered to work correctly within
 * the larger combined pattern. Native flags used by provided regexes are ignored in favor of the
 * `flags` argument.
 *
 * @memberOf XRegExp
 * @param {Array} patterns Regexes and strings to combine.
 * @param {String} [flags] Any combination of XRegExp flags.
 * @param {Object} [options] Options object with optional properties:
 *   - `conjunction` {String} Type of conjunction to use: 'or' (default) or 'none'.
 * @returns {RegExp} Union of the provided regexes and strings.
 * @example
 *
 * XRegExp.union(['a+b*c', /(dogs)\1/, /(cats)\1/], 'i');
 * // -> /a\+b\*c|(dogs)\1|(cats)\2/i
 *
 * XRegExp.union([/man/, /bear/, /pig/], 'i', {conjunction: 'none'});
 * // -> /manbearpig/i
 */


XRegExp.union = function (patterns, flags, options) {
  options = options || {};
  var conjunction = options.conjunction || 'or';
  var numCaptures = 0;
  var numPriorCaptures;
  var captureNames;

  function rewrite(match, paren, backref) {
    var name = captureNames[numCaptures - numPriorCaptures]; // Capturing group

    if (paren) {
      ++numCaptures; // If the current capture has a name, preserve the name

      if (name) {
        return "(?<".concat(name, ">");
      } // Backreference

    } else if (backref) {
      // Rewrite the backreference
      return "\\".concat(+backref + numPriorCaptures);
    }

    return match;
  }

  if (!(isType(patterns, 'Array') && patterns.length)) {
    throw new TypeError('Must provide a nonempty array of patterns to merge');
  }

  var parts = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g;
  var output = [];

  var _iterator5 = _createForOfIteratorHelper(patterns),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var pattern = _step5.value;

      if (XRegExp.isRegExp(pattern)) {
        numPriorCaptures = numCaptures;
        captureNames = pattern[REGEX_DATA] && pattern[REGEX_DATA].captureNames || []; // Rewrite backreferences. Passing to XRegExp dies on octals and ensures patterns are
        // independently valid; helps keep this simple. Named captures are put back

        output.push(nativ.replace.call(XRegExp(pattern.source).source, parts, rewrite));
      } else {
        output.push(XRegExp.escape(pattern));
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  var separator = conjunction === 'none' ? '' : '|';
  return XRegExp(output.join(separator), flags);
}; // ==--------------------------==
// Fixed/extended native methods
// ==--------------------------==

/**
 * Adds named capture support (with backreferences returned as `result.name`), and fixes browser
 * bugs in the native `RegExp.prototype.exec`. Use via `XRegExp.exec`.
 *
 * @memberOf RegExp
 * @param {String} str String to search.
 * @returns {Array} Match array with named backreference properties, or `null`.
 */


fixed.exec = function (str) {
  var origLastIndex = this.lastIndex;
  var match = nativ.exec.apply(this, arguments);

  if (match) {
    // Fix browsers whose `exec` methods don't return `undefined` for nonparticipating capturing
    // groups. This fixes IE 5.5-8, but not IE 9's quirks mode or emulation of older IEs. IE 9
    // in standards mode follows the spec.
    if (!correctExecNpcg && match.length > 1 && (0, _includes["default"])(match).call(match, '')) {
      var _context3;

      var r2 = copyRegex(this, {
        removeG: true,
        isInternalOnly: true
      }); // Using `str.slice(match.index)` rather than `match[0]` in case lookahead allowed
      // matching due to characters outside the match

      nativ.replace.call((0, _slice["default"])(_context3 = String(str)).call(_context3, match.index), r2, function () {
        var len = arguments.length; // Skip index 0 and the last 2

        for (var i = 1; i < len - 2; ++i) {
          if ((i < 0 || arguments.length <= i ? undefined : arguments[i]) === undefined) {
            match[i] = undefined;
          }
        }
      });
    } // Attach named capture properties


    var groupsObject = match;

    if (XRegExp.isInstalled('namespacing')) {
      // https://tc39.github.io/proposal-regexp-named-groups/#sec-regexpbuiltinexec
      match.groups = (0, _create["default"])(null);
      groupsObject = match.groups;
    }

    if (this[REGEX_DATA] && this[REGEX_DATA].captureNames) {
      // Skip index 0
      for (var i = 1; i < match.length; ++i) {
        var name = this[REGEX_DATA].captureNames[i - 1];

        if (name) {
          groupsObject[name] = match[i];
        }
      }
    } // Fix browsers that increment `lastIndex` after zero-length matches


    if (this.global && !match[0].length && this.lastIndex > match.index) {
      this.lastIndex = match.index;
    }
  }

  if (!this.global) {
    // Fixes IE, Opera bug (last tested IE 9, Opera 11.6)
    this.lastIndex = origLastIndex;
  }

  return match;
};
/**
 * Fixes browser bugs in the native `RegExp.prototype.test`.
 *
 * @memberOf RegExp
 * @param {String} str String to search.
 * @returns {boolean} Whether the regex matched the provided value.
 */


fixed.test = function (str) {
  // Do this the easy way :-)
  return !!fixed.exec.call(this, str);
};
/**
 * Adds named capture support (with backreferences returned as `result.name`), and fixes browser
 * bugs in the native `String.prototype.match`.
 *
 * @memberOf String
 * @param {RegExp|*} regex Regex to search with. If not a regex object, it is passed to `RegExp`.
 * @returns {Array} If `regex` uses flag g, an array of match strings or `null`. Without flag g,
 *   the result of calling `regex.exec(this)`.
 */


fixed.match = function (regex) {
  if (!XRegExp.isRegExp(regex)) {
    // Use the native `RegExp` rather than `XRegExp`
    regex = new RegExp(regex);
  } else if (regex.global) {
    var result = nativ.match.apply(this, arguments); // Fixes IE bug

    regex.lastIndex = 0;
    return result;
  }

  return fixed.exec.call(regex, toObject(this));
};
/**
 * Adds support for `${n}` (or `$<n>`) tokens for named and numbered backreferences in replacement
 * text, and provides named backreferences to replacement functions as `arguments[0].name`. Also
 * fixes browser bugs in replacement text syntax when performing a replacement using a nonregex
 * search value, and the value of a replacement regex's `lastIndex` property during replacement
 * iterations and upon completion. Note that this doesn't support SpiderMonkey's proprietary third
 * (`flags`) argument. Use via `XRegExp.replace`.
 *
 * @memberOf String
 * @param {RegExp|String} search Search pattern to be replaced.
 * @param {String|Function} replacement Replacement string or a function invoked to create it.
 * @returns {string} New string with one or all matches replaced.
 */


fixed.replace = function (search, replacement) {
  var isRegex = XRegExp.isRegExp(search);
  var origLastIndex;
  var captureNames;
  var result;

  if (isRegex) {
    if (search[REGEX_DATA]) {
      captureNames = search[REGEX_DATA].captureNames;
    } // Only needed if `search` is nonglobal


    origLastIndex = search.lastIndex;
  } else {
    search += ''; // Type-convert
  } // Don't use `typeof`; some older browsers return 'function' for regex objects


  if (isType(replacement, 'Function')) {
    // Stringifying `this` fixes a bug in IE < 9 where the last argument in replacement
    // functions isn't type-converted to a string
    result = nativ.replace.call(String(this), search, function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (captureNames) {
        var groupsObject;

        if (XRegExp.isInstalled('namespacing')) {
          // https://tc39.github.io/proposal-regexp-named-groups/#sec-regexpbuiltinexec
          groupsObject = (0, _create["default"])(null);
          args.push(groupsObject);
        } else {
          // Change the `args[0]` string primitive to a `String` object that can store
          // properties. This really does need to use `String` as a constructor
          args[0] = new String(args[0]);
          groupsObject = args[0];
        } // Store named backreferences


        for (var i = 0; i < captureNames.length; ++i) {
          if (captureNames[i]) {
            groupsObject[captureNames[i]] = args[i + 1];
          }
        }
      } // ES6 specs the context for replacement functions as `undefined`


      return replacement.apply(void 0, args);
    });
  } else {
    // Ensure that the last value of `args` will be a string when given nonstring `this`,
    // while still throwing on null or undefined context
    result = nativ.replace.call(this == null ? this : String(this), search, function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return nativ.replace.call(String(replacement), replacementToken, replacer);

      function replacer($0, bracketed, angled, dollarToken) {
        bracketed = bracketed || angled; // Named or numbered backreference with curly or angled braces

        if (bracketed) {
          // XRegExp behavior for `${n}` or `$<n>`:
          // 1. Backreference to numbered capture, if `n` is an integer. Use `0` for the
          //    entire match. Any number of leading zeros may be used.
          // 2. Backreference to named capture `n`, if it exists and is not an integer
          //    overridden by numbered capture. In practice, this does not overlap with
          //    numbered capture since XRegExp does not allow named capture to use a bare
          //    integer as the name.
          // 3. If the name or number does not refer to an existing capturing group, it's
          //    an error.
          var n = +bracketed; // Type-convert; drop leading zeros

          if (n <= args.length - 3) {
            return args[n] || '';
          } // Groups with the same name is an error, else would need `lastIndexOf`


          n = captureNames ? (0, _indexOf["default"])(captureNames).call(captureNames, bracketed) : -1;

          if (n < 0) {
            throw new SyntaxError("Backreference to undefined group ".concat($0));
          }

          return args[n + 1] || '';
        } // Else, special variable or numbered backreference without curly braces


        if (dollarToken === '$') {
          // $$
          return '$';
        }

        if (dollarToken === '&' || +dollarToken === 0) {
          // $&, $0 (not followed by 1-9), $00
          return args[0];
        }

        if (dollarToken === '`') {
          var _context4;

          // $` (left context)
          return (0, _slice["default"])(_context4 = args[args.length - 1]).call(_context4, 0, args[args.length - 2]);
        }

        if (dollarToken === "'") {
          var _context5;

          // $' (right context)
          return (0, _slice["default"])(_context5 = args[args.length - 1]).call(_context5, args[args.length - 2] + args[0].length);
        } // Else, numbered backreference without braces


        dollarToken = +dollarToken; // Type-convert; drop leading zero
        // XRegExp behavior for `$n` and `$nn`:
        // - Backrefs end after 1 or 2 digits. Use `${..}` or `$<..>` for more digits.
        // - `$1` is an error if no capturing groups.
        // - `$10` is an error if less than 10 capturing groups. Use `${1}0` or `$<1>0`
        //   instead.
        // - `$01` is `$1` if at least one capturing group, else it's an error.
        // - `$0` (not followed by 1-9) and `$00` are the entire match.
        // Native behavior, for comparison:
        // - Backrefs end after 1 or 2 digits. Cannot reference capturing group 100+.
        // - `$1` is a literal `$1` if no capturing groups.
        // - `$10` is `$1` followed by a literal `0` if less than 10 capturing groups.
        // - `$01` is `$1` if at least one capturing group, else it's a literal `$01`.
        // - `$0` is a literal `$0`.

        if (!isNaN(dollarToken)) {
          if (dollarToken > args.length - 3) {
            throw new SyntaxError("Backreference to undefined group ".concat($0));
          }

          return args[dollarToken] || '';
        } // `$` followed by an unsupported char is an error, unlike native JS


        throw new SyntaxError("Invalid token ".concat($0));
      }
    });
  }

  if (isRegex) {
    if (search.global) {
      // Fixes IE, Safari bug (last tested IE 9, Safari 5.1)
      search.lastIndex = 0;
    } else {
      // Fixes IE, Opera bug (last tested IE 9, Opera 11.6)
      search.lastIndex = origLastIndex;
    }
  }

  return result;
};
/**
 * Fixes browser bugs in the native `String.prototype.split`. Use via `XRegExp.split`.
 *
 * @memberOf String
 * @param {RegExp|String} separator Regex or string to use for separating the string.
 * @param {Number} [limit] Maximum number of items to include in the result array.
 * @returns {!Array} Array of substrings.
 */


fixed.split = function (separator, limit) {
  if (!XRegExp.isRegExp(separator)) {
    // Browsers handle nonregex split correctly, so use the faster native method
    return nativ.split.apply(this, arguments);
  }

  var str = String(this);
  var output = [];
  var origLastIndex = separator.lastIndex;
  var lastLastIndex = 0;
  var lastLength; // Values for `limit`, per the spec:
  // If undefined: pow(2,32) - 1
  // If 0, Infinity, or NaN: 0
  // If positive number: limit = floor(limit); if (limit >= pow(2,32)) limit -= pow(2,32);
  // If negative number: pow(2,32) - floor(abs(limit))
  // If other: Type-convert, then use the above rules
  // This line fails in very strange ways for some values of `limit` in Opera 10.5-10.63, unless
  // Opera Dragonfly is open (go figure). It works in at least Opera 9.5-10.1 and 11+

  limit = (limit === undefined ? -1 : limit) >>> 0;
  (0, _forEach["default"])(XRegExp).call(XRegExp, str, separator, function (match) {
    // This condition is not the same as `if (match[0].length)`
    if (match.index + match[0].length > lastLastIndex) {
      output.push((0, _slice["default"])(str).call(str, lastLastIndex, match.index));

      if (match.length > 1 && match.index < str.length) {
        Array.prototype.push.apply(output, (0, _slice["default"])(match).call(match, 1));
      }

      lastLength = match[0].length;
      lastLastIndex = match.index + lastLength;
    }
  });

  if (lastLastIndex === str.length) {
    if (!nativ.test.call(separator, '') || lastLength) {
      output.push('');
    }
  } else {
    output.push((0, _slice["default"])(str).call(str, lastLastIndex));
  }

  separator.lastIndex = origLastIndex;
  return output.length > limit ? (0, _slice["default"])(output).call(output, 0, limit) : output;
}; // ==--------------------------==
// Built-in syntax/flag tokens
// ==--------------------------==

/*
 * Letter escapes that natively match literal characters: `\a`, `\A`, etc. These should be
 * SyntaxErrors but are allowed in web reality. XRegExp makes them errors for cross-browser
 * consistency and to reserve their syntax, but lets them be superseded by addons.
 */


XRegExp.addToken(/\\([ABCE-RTUVXYZaeg-mopqyz]|c(?![A-Za-z])|u(?![\dA-Fa-f]{4}|{[\dA-Fa-f]+})|x(?![\dA-Fa-f]{2}))/, function (match, scope) {
  // \B is allowed in default scope only
  if (match[1] === 'B' && scope === defaultScope) {
    return match[0];
  }

  throw new SyntaxError("Invalid escape ".concat(match[0]));
}, {
  scope: 'all',
  leadChar: '\\'
});
/*
 * Unicode code point escape with curly braces: `\u{N..}`. `N..` is any one or more digit
 * hexadecimal number from 0-10FFFF, and can include leading zeros. Requires the native ES6 `u` flag
 * to support code points greater than U+FFFF. Avoids converting code points above U+FFFF to
 * surrogate pairs (which could be done without flag `u`), since that could lead to broken behavior
 * if you follow a `\u{N..}` token that references a code point above U+FFFF with a quantifier, or
 * if you use the same in a character class.
 */

XRegExp.addToken(/\\u{([\dA-Fa-f]+)}/, function (match, scope, flags) {
  var code = dec(match[1]);

  if (code > 0x10FFFF) {
    throw new SyntaxError("Invalid Unicode code point ".concat(match[0]));
  }

  if (code <= 0xFFFF) {
    // Converting to \uNNNN avoids needing to escape the literal character and keep it
    // separate from preceding tokens
    return "\\u".concat(pad4(hex(code)));
  } // If `code` is between 0xFFFF and 0x10FFFF, require and defer to native handling


  if (hasNativeU && (0, _includes["default"])(flags).call(flags, 'u')) {
    return match[0];
  }

  throw new SyntaxError('Cannot use Unicode code point above \\u{FFFF} without flag u');
}, {
  scope: 'all',
  leadChar: '\\'
});
/*
 * Empty character class: `[]` or `[^]`. This fixes a critical cross-browser syntax inconsistency.
 * Unless this is standardized (per the ES spec), regex syntax can't be accurately parsed because
 * character class endings can't be determined.
 */

XRegExp.addToken(/\[(\^?)\]/, // For cross-browser compatibility with ES3, convert [] to \b\B and [^] to [\s\S].
// (?!) should work like \b\B, but is unreliable in some versions of Firefox

/* eslint-disable no-confusing-arrow */
function (match) {
  return match[1] ? '[\\s\\S]' : '\\b\\B';
},
/* eslint-enable no-confusing-arrow */
{
  leadChar: '['
});
/*
 * Comment pattern: `(?# )`. Inline comments are an alternative to the line comments allowed in
 * free-spacing mode (flag x).
 */

XRegExp.addToken(/\(\?#[^)]*\)/, getContextualTokenSeparator, {
  leadChar: '('
});
/*
 * Whitespace and line comments, in free-spacing mode (aka extended mode, flag x) only.
 */

XRegExp.addToken(/\s+|#[^\n]*\n?/, getContextualTokenSeparator, {
  flag: 'x'
});
/*
 * Dot, in dotall mode (aka singleline mode, flag s) only.
 */

XRegExp.addToken(/\./, function () {
  return '[\\s\\S]';
}, {
  flag: 's',
  leadChar: '.'
});
/*
 * Named backreference: `\k<name>`. Backreference names can use the characters A-Z, a-z, 0-9, _,
 * and $ only. Also allows numbered backreferences as `\k<n>`.
 */

XRegExp.addToken(/\\k<([\w$]+)>/, function (match) {
  var _context6, _context7;

  // Groups with the same name is an error, else would need `lastIndexOf`
  var index = isNaN(match[1]) ? (0, _indexOf["default"])(_context6 = this.captureNames).call(_context6, match[1]) + 1 : +match[1];
  var endIndex = match.index + match[0].length;

  if (!index || index > this.captureNames.length) {
    throw new SyntaxError("Backreference to undefined group ".concat(match[0]));
  } // Keep backreferences separate from subsequent literal numbers. This avoids e.g.
  // inadvertedly changing `(?<n>)\k<n>1` to `()\11`.


  return (0, _concat["default"])(_context7 = "\\".concat(index)).call(_context7, endIndex === match.input.length || isNaN(match.input[endIndex]) ? '' : '(?:)');
}, {
  leadChar: '\\'
});
/*
 * Numbered backreference or octal, plus any following digits: `\0`, `\11`, etc. Octals except `\0`
 * not followed by 0-9 and backreferences to unopened capture groups throw an error. Other matches
 * are returned unaltered. IE < 9 doesn't support backreferences above `\99` in regex syntax.
 */

XRegExp.addToken(/\\(\d+)/, function (match, scope) {
  if (!(scope === defaultScope && /^[1-9]/.test(match[1]) && +match[1] <= this.captureNames.length) && match[1] !== '0') {
    throw new SyntaxError("Cannot use octal escape or backreference to undefined group ".concat(match[0]));
  }

  return match[0];
}, {
  scope: 'all',
  leadChar: '\\'
});
/*
 * Named capturing group; match the opening delimiter only: `(?<name>`. Capture names can use the
 * characters A-Z, a-z, 0-9, _, and $ only. Names can't be integers. Supports Python-style
 * `(?P<name>` as an alternate syntax to avoid issues in some older versions of Opera which natively
 * supported the Python-style syntax. Otherwise, XRegExp might treat numbered backreferences to
 * Python-style named capture as octals.
 */

XRegExp.addToken(/\(\?P?<([\w$]+)>/, function (match) {
  var _context8;

  // Disallow bare integers as names because named backreferences are added to match arrays
  // and therefore numeric properties may lead to incorrect lookups
  if (!isNaN(match[1])) {
    throw new SyntaxError("Cannot use integer as capture name ".concat(match[0]));
  }

  if (!XRegExp.isInstalled('namespacing') && (match[1] === 'length' || match[1] === '__proto__')) {
    throw new SyntaxError("Cannot use reserved word as capture name ".concat(match[0]));
  }

  if ((0, _includes["default"])(_context8 = this.captureNames).call(_context8, match[1])) {
    throw new SyntaxError("Cannot use same name for multiple groups ".concat(match[0]));
  }

  this.captureNames.push(match[1]);
  this.hasNamedCapture = true;
  return '(';
}, {
  leadChar: '('
});
/*
 * Capturing group; match the opening parenthesis only. Required for support of named capturing
 * groups. Also adds explicit capture mode (flag n).
 */

XRegExp.addToken(/\((?!\?)/, function (match, scope, flags) {
  if ((0, _includes["default"])(flags).call(flags, 'n')) {
    return '(?:';
  }

  this.captureNames.push(null);
  return '(';
}, {
  optionalFlags: 'n',
  leadChar: '('
});
var _default = XRegExp;
exports["default"] = _default;
module.exports = exports.default;
});

unwrapExports(xregexp);

var $map = arrayIteration.map;


var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var map$1 = entryVirtual('Array').map;

var ArrayPrototype$7 = Array.prototype;

var map$2 = function (it) {
  var own = it.map;
  return it === ArrayPrototype$7 || (objectIsPrototypeOf(ArrayPrototype$7, it) && own === ArrayPrototype$7.map) ? map$1 : own;
};

var map$3 = map$2;

var map$4 = map$3;

var TypeError$13 = global_1.TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$4 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = indexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError$13('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$4(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$4(true)
};

var engineIsNode = classofRaw(global_1.process) == 'process';

var $reduce = arrayReduce.left;




var STRICT_METHOD$3 = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !engineIsNode && engineV8Version > 79 && engineV8Version < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
_export({ target: 'Array', proto: true, forced: !STRICT_METHOD$3 || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

var reduce = entryVirtual('Array').reduce;

var ArrayPrototype$8 = Array.prototype;

var reduce$1 = function (it) {
  var own = it.reduce;
  return it === ArrayPrototype$8 || (objectIsPrototypeOf(ArrayPrototype$8, it) && own === ArrayPrototype$8.reduce) ? reduce : own;
};

var reduce$2 = reduce$1;

var reduce$3 = reduce$2;

var build = createCommonjsModule(function (module, exports) {





defineProperty$2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _concat = interopRequireDefault(concat$3);

var _includes = interopRequireDefault(includes$4);

var _map = interopRequireDefault(map$4);

var _reduce = interopRequireDefault(reduce$3);

/*!
 * XRegExp.build 4.4.1
 * <xregexp.com>
 * Steven Levithan (c) 2012-present MIT License
 */
var _default = function _default(XRegExp) {
  var REGEX_DATA = 'xregexp';
  var subParts = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g;
  var parts = XRegExp.union([/\({{([\w$]+)}}\)|{{([\w$]+)}}/, subParts], 'g', {
    conjunction: 'or'
  });
  /**
   * Strips a leading `^` and trailing unescaped `$`, if both are present.
   *
   * @private
   * @param {String} pattern Pattern to process.
   * @returns {String} Pattern with edge anchors removed.
   */

  function deanchor(pattern) {
    // Allow any number of empty noncapturing groups before/after anchors, because regexes
    // built/generated by XRegExp sometimes include them
    var leadingAnchor = /^(?:\(\?:\))*\^/;
    var trailingAnchor = /\$(?:\(\?:\))*$/;

    if (leadingAnchor.test(pattern) && trailingAnchor.test(pattern) && // Ensure that the trailing `$` isn't escaped
    trailingAnchor.test(pattern.replace(/\\[\s\S]/g, ''))) {
      return pattern.replace(leadingAnchor, '').replace(trailingAnchor, '');
    }

    return pattern;
  }
  /**
   * Converts the provided value to an XRegExp. Native RegExp flags are not preserved.
   *
   * @private
   * @param {String|RegExp} value Value to convert.
   * @param {Boolean} [addFlagX] Whether to apply the `x` flag in cases when `value` is not
   *   already a regex generated by XRegExp
   * @returns {RegExp} XRegExp object with XRegExp syntax applied.
   */


  function asXRegExp(value, addFlagX) {
    var flags = addFlagX ? 'x' : '';
    return XRegExp.isRegExp(value) ? value[REGEX_DATA] && value[REGEX_DATA].captureNames ? // Don't recompile, to preserve capture names
    value : // Recompile as XRegExp
    XRegExp(value.source, flags) : // Compile string as XRegExp
    XRegExp(value, flags);
  }

  function interpolate(substitution) {
    return substitution instanceof RegExp ? substitution : XRegExp.escape(substitution);
  }

  function reduceToSubpatternsObject(subpatterns, interpolated, subpatternIndex) {
    subpatterns["subpattern".concat(subpatternIndex)] = interpolated;
    return subpatterns;
  }

  function embedSubpatternAfter(raw, subpatternIndex, rawLiterals) {
    var hasSubpattern = subpatternIndex < rawLiterals.length - 1;
    return raw + (hasSubpattern ? "{{subpattern".concat(subpatternIndex, "}}") : '');
  }
  /**
   * Provides tagged template literals that create regexes with XRegExp syntax and flags. The
   * provided pattern is handled as a raw string, so backslashes don't need to be escaped.
   *
   * Interpolation of strings and regexes shares the features of `XRegExp.build`. Interpolated
   * patterns are treated as atomic units when quantified, interpolated strings have their special
   * characters escaped, a leading `^` and trailing unescaped `$` are stripped from interpolated
   * regexes if both are present, and any backreferences within an interpolated regex are
   * rewritten to work within the overall pattern.
   *
   * @memberOf XRegExp
   * @param {String} [flags] Any combination of XRegExp flags.
   * @returns {Function} Handler for template literals that construct regexes with XRegExp syntax.
   * @example
   *
   * const h12 = /1[0-2]|0?[1-9]/;
   * const h24 = /2[0-3]|[01][0-9]/;
   * const hours = XRegExp.tag('x')`${h12} : | ${h24}`;
   * const minutes = /^[0-5][0-9]$/;
   * // Note that explicitly naming the 'minutes' group is required for named backreferences
   * const time = XRegExp.tag('x')`^ ${hours} (?<minutes>${minutes}) $`;
   * time.test('10:59'); // -> true
   * XRegExp.exec('10:59', time).minutes; // -> '59'
   */


  XRegExp.tag = function (flags) {
    return function (literals) {
      var _context, _context2;

      for (var _len = arguments.length, substitutions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        substitutions[_key - 1] = arguments[_key];
      }

      var subpatterns = (0, _reduce["default"])(_context = (0, _map["default"])(substitutions).call(substitutions, interpolate)).call(_context, reduceToSubpatternsObject, {});
      var pattern = (0, _map["default"])(_context2 = literals.raw).call(_context2, embedSubpatternAfter).join('');
      return XRegExp.build(pattern, subpatterns, flags);
    };
  };
  /**
   * Builds regexes using named subpatterns, for readability and pattern reuse. Backreferences in
   * the outer pattern and provided subpatterns are automatically renumbered to work correctly.
   * Native flags used by provided subpatterns are ignored in favor of the `flags` argument.
   *
   * @memberOf XRegExp
   * @param {String} pattern XRegExp pattern using `{{name}}` for embedded subpatterns. Allows
   *   `({{name}})` as shorthand for `(?<name>{{name}})`. Patterns cannot be embedded within
   *   character classes.
   * @param {Object} subs Lookup object for named subpatterns. Values can be strings or regexes. A
   *   leading `^` and trailing unescaped `$` are stripped from subpatterns, if both are present.
   * @param {String} [flags] Any combination of XRegExp flags.
   * @returns {RegExp} Regex with interpolated subpatterns.
   * @example
   *
   * const time = XRegExp.build('(?x)^ {{hours}} ({{minutes}}) $', {
   *   hours: XRegExp.build('{{h12}} : | {{h24}}', {
   *     h12: /1[0-2]|0?[1-9]/,
   *     h24: /2[0-3]|[01][0-9]/
   *   }, 'x'),
   *   minutes: /^[0-5][0-9]$/
   * });
   * time.test('10:59'); // -> true
   * XRegExp.exec('10:59', time).minutes; // -> '59'
   */


  XRegExp.build = function (pattern, subs, flags) {
    flags = flags || ''; // Used with `asXRegExp` calls for `pattern` and subpatterns in `subs`, to work around how
    // some browsers convert `RegExp('\n')` to a regex that contains the literal characters `\`
    // and `n`. See more details at <https://github.com/slevithan/xregexp/pull/163>.

    var addFlagX = (0, _includes["default"])(flags).call(flags, 'x');
    var inlineFlags = /^\(\?([\w$]+)\)/.exec(pattern); // Add flags within a leading mode modifier to the overall pattern's flags

    if (inlineFlags) {
      flags = XRegExp._clipDuplicates(flags + inlineFlags[1]);
    }

    var data = {};

    for (var p in subs) {
      if (subs.hasOwnProperty(p)) {
        // Passing to XRegExp enables extended syntax and ensures independent validity,
        // lest an unescaped `(`, `)`, `[`, or trailing `\` breaks the `(?:)` wrapper. For
        // subpatterns provided as native regexes, it dies on octals and adds the property
        // used to hold extended regex instance data, for simplicity.
        var sub = asXRegExp(subs[p], addFlagX);
        data[p] = {
          // Deanchoring allows embedding independently useful anchored regexes. If you
          // really need to keep your anchors, double them (i.e., `^^...$$`).
          pattern: deanchor(sub.source),
          names: sub[REGEX_DATA].captureNames || []
        };
      }
    } // Passing to XRegExp dies on octals and ensures the outer pattern is independently valid;
    // helps keep this simple. Named captures will be put back.


    var patternAsRegex = asXRegExp(pattern, addFlagX); // 'Caps' is short for 'captures'

    var numCaps = 0;
    var numPriorCaps;
    var numOuterCaps = 0;
    var outerCapsMap = [0];
    var outerCapNames = patternAsRegex[REGEX_DATA].captureNames || [];
    var output = patternAsRegex.source.replace(parts, function ($0, $1, $2, $3, $4) {
      var subName = $1 || $2;
      var capName;
      var intro;
      var localCapIndex; // Named subpattern

      if (subName) {
        var _context3;

        if (!data.hasOwnProperty(subName)) {
          throw new ReferenceError("Undefined property ".concat($0));
        } // Named subpattern was wrapped in a capturing group


        if ($1) {
          capName = outerCapNames[numOuterCaps];
          outerCapsMap[++numOuterCaps] = ++numCaps; // If it's a named group, preserve the name. Otherwise, use the subpattern name
          // as the capture name

          intro = "(?<".concat(capName || subName, ">");
        } else {
          intro = '(?:';
        }

        numPriorCaps = numCaps;
        var rewrittenSubpattern = data[subName].pattern.replace(subParts, function (match, paren, backref) {
          // Capturing group
          if (paren) {
            capName = data[subName].names[numCaps - numPriorCaps];
            ++numCaps; // If the current capture has a name, preserve the name

            if (capName) {
              return "(?<".concat(capName, ">");
            } // Backreference

          } else if (backref) {
            localCapIndex = +backref - 1; // Rewrite the backreference

            return data[subName].names[localCapIndex] ? // Need to preserve the backreference name in case using flag `n`
            "\\k<".concat(data[subName].names[localCapIndex], ">") : "\\".concat(+backref + numPriorCaps);
          }

          return match;
        });
        return (0, _concat["default"])(_context3 = "".concat(intro)).call(_context3, rewrittenSubpattern, ")");
      } // Capturing group


      if ($3) {
        capName = outerCapNames[numOuterCaps];
        outerCapsMap[++numOuterCaps] = ++numCaps; // If the current capture has a name, preserve the name

        if (capName) {
          return "(?<".concat(capName, ">");
        } // Backreference

      } else if ($4) {
        localCapIndex = +$4 - 1; // Rewrite the backreference

        return outerCapNames[localCapIndex] ? // Need to preserve the backreference name in case using flag `n`
        "\\k<".concat(outerCapNames[localCapIndex], ">") : "\\".concat(outerCapsMap[+$4]);
      }

      return $0;
    });
    return XRegExp(output, flags);
  };
};

exports["default"] = _default;
module.exports = exports.default;
});

unwrapExports(build);

var matchrecursive = createCommonjsModule(function (module, exports) {





defineProperty$2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _slice = interopRequireDefault(slice$5);

var _concat = interopRequireDefault(concat$3);

var _includes = interopRequireDefault(includes$4);

/*!
 * XRegExp.matchRecursive 4.4.1
 * <xregexp.com>
 * Steven Levithan (c) 2009-present MIT License
 */
var _default = function _default(XRegExp) {
  /**
   * Returns a match detail object composed of the provided values.
   *
   * @private
   */
  function row(name, value, start, end) {
    return {
      name: name,
      value: value,
      start: start,
      end: end
    };
  }
  /**
   * Returns an array of match strings between outermost left and right delimiters, or an array of
   * objects with detailed match parts and position data. An error is thrown if delimiters are
   * unbalanced within the data.
   *
   * @memberOf XRegExp
   * @param {String} str String to search.
   * @param {String} left Left delimiter as an XRegExp pattern.
   * @param {String} right Right delimiter as an XRegExp pattern.
   * @param {String} [flags] Any native or XRegExp flags, used for the left and right delimiters.
   * @param {Object} [options] Lets you specify `valueNames` and `escapeChar` options.
   * @returns {!Array} Array of matches, or an empty array.
   * @example
   *
   * // Basic usage
   * let str = '(t((e))s)t()(ing)';
   * XRegExp.matchRecursive(str, '\\(', '\\)', 'g');
   * // -> ['t((e))s', '', 'ing']
   *
   * // Extended information mode with valueNames
   * str = 'Here is <div> <div>an</div></div> example';
   * XRegExp.matchRecursive(str, '<div\\s*>', '</div>', 'gi', {
   *   valueNames: ['between', 'left', 'match', 'right']
   * });
   * // -> [
   * // {name: 'between', value: 'Here is ',       start: 0,  end: 8},
   * // {name: 'left',    value: '<div>',          start: 8,  end: 13},
   * // {name: 'match',   value: ' <div>an</div>', start: 13, end: 27},
   * // {name: 'right',   value: '</div>',         start: 27, end: 33},
   * // {name: 'between', value: ' example',       start: 33, end: 41}
   * // ]
   *
   * // Omitting unneeded parts with null valueNames, and using escapeChar
   * str = '...{1}.\\{{function(x,y){return {y:x}}}';
   * XRegExp.matchRecursive(str, '{', '}', 'g', {
   *   valueNames: ['literal', null, 'value', null],
   *   escapeChar: '\\'
   * });
   * // -> [
   * // {name: 'literal', value: '...',  start: 0, end: 3},
   * // {name: 'value',   value: '1',    start: 4, end: 5},
   * // {name: 'literal', value: '.\\{', start: 6, end: 9},
   * // {name: 'value',   value: 'function(x,y){return {y:x}}', start: 10, end: 37}
   * // ]
   *
   * // Sticky mode via flag y
   * str = '<1><<<2>>><3>4<5>';
   * XRegExp.matchRecursive(str, '<', '>', 'gy');
   * // -> ['1', '<<2>>', '3']
   */


  XRegExp.matchRecursive = function (str, left, right, flags, options) {
    flags = flags || '';
    options = options || {};
    var global = (0, _includes["default"])(flags).call(flags, 'g');
    var sticky = (0, _includes["default"])(flags).call(flags, 'y'); // Flag `y` is controlled internally

    var basicFlags = flags.replace(/y/g, '');
    var _options = options,
        escapeChar = _options.escapeChar;
    var vN = options.valueNames;
    var output = [];
    var openTokens = 0;
    var delimStart = 0;
    var delimEnd = 0;
    var lastOuterEnd = 0;
    var outerStart;
    var innerStart;
    var leftMatch;
    var rightMatch;
    var esc;
    left = XRegExp(left, basicFlags);
    right = XRegExp(right, basicFlags);

    if (escapeChar) {
      var _context, _context2;

      if (escapeChar.length > 1) {
        throw new Error('Cannot use more than one escape character');
      }

      escapeChar = XRegExp.escape(escapeChar); // Example of concatenated `esc` regex:
      // `escapeChar`: '%'
      // `left`: '<'
      // `right`: '>'
      // Regex is: /(?:%[\S\s]|(?:(?!<|>)[^%])+)+/

      esc = new RegExp((0, _concat["default"])(_context = (0, _concat["default"])(_context2 = "(?:".concat(escapeChar, "[\\S\\s]|(?:(?!")).call(_context2, // Using `XRegExp.union` safely rewrites backreferences in `left` and `right`.
      // Intentionally not passing `basicFlags` to `XRegExp.union` since any syntax
      // transformation resulting from those flags was already applied to `left` and
      // `right` when they were passed through the XRegExp constructor above.
      XRegExp.union([left, right], '', {
        conjunction: 'or'
      }).source, ")[^")).call(_context, escapeChar, "])+)+"), // Flags `gy` not needed here
      flags.replace(/[^imu]+/g, ''));
    }

    while (true) {
      // If using an escape character, advance to the delimiter's next starting position,
      // skipping any escaped characters in between
      if (escapeChar) {
        delimEnd += (XRegExp.exec(str, esc, delimEnd, 'sticky') || [''])[0].length;
      }

      leftMatch = XRegExp.exec(str, left, delimEnd);
      rightMatch = XRegExp.exec(str, right, delimEnd); // Keep the leftmost match only

      if (leftMatch && rightMatch) {
        if (leftMatch.index <= rightMatch.index) {
          rightMatch = null;
        } else {
          leftMatch = null;
        }
      } // Paths (LM: leftMatch, RM: rightMatch, OT: openTokens):
      // LM | RM | OT | Result
      // 1  | 0  | 1  | loop
      // 1  | 0  | 0  | loop
      // 0  | 1  | 1  | loop
      // 0  | 1  | 0  | throw
      // 0  | 0  | 1  | throw
      // 0  | 0  | 0  | break
      // The paths above don't include the sticky mode special case. The loop ends after the
      // first completed match if not `global`.


      if (leftMatch || rightMatch) {
        delimStart = (leftMatch || rightMatch).index;
        delimEnd = delimStart + (leftMatch || rightMatch)[0].length;
      } else if (!openTokens) {
        break;
      }

      if (sticky && !openTokens && delimStart > lastOuterEnd) {
        break;
      }

      if (leftMatch) {
        if (!openTokens) {
          outerStart = delimStart;
          innerStart = delimEnd;
        }

        ++openTokens;
      } else if (rightMatch && openTokens) {
        if (! --openTokens) {
          if (vN) {
            if (vN[0] && outerStart > lastOuterEnd) {
              output.push(row(vN[0], (0, _slice["default"])(str).call(str, lastOuterEnd, outerStart), lastOuterEnd, outerStart));
            }

            if (vN[1]) {
              output.push(row(vN[1], (0, _slice["default"])(str).call(str, outerStart, innerStart), outerStart, innerStart));
            }

            if (vN[2]) {
              output.push(row(vN[2], (0, _slice["default"])(str).call(str, innerStart, delimStart), innerStart, delimStart));
            }

            if (vN[3]) {
              output.push(row(vN[3], (0, _slice["default"])(str).call(str, delimStart, delimEnd), delimStart, delimEnd));
            }
          } else {
            output.push((0, _slice["default"])(str).call(str, innerStart, delimStart));
          }

          lastOuterEnd = delimEnd;

          if (!global) {
            break;
          }
        }
      } else {
        throw new Error('Unbalanced delimiter found in string');
      } // If the delimiter matched an empty string, avoid an infinite loop


      if (delimStart === delimEnd) {
        ++delimEnd;
      }
    }

    if (global && !sticky && vN && vN[0] && str.length > lastOuterEnd) {
      output.push(row(vN[0], (0, _slice["default"])(str).call(str, lastOuterEnd), lastOuterEnd, str.length));
    }

    return output;
  };
};

exports["default"] = _default;
module.exports = exports.default;
});

unwrapExports(matchrecursive);

var unicodeBase = createCommonjsModule(function (module, exports) {





defineProperty$2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _getIterator2 = interopRequireDefault(getIterator$3);

var _isArray = interopRequireDefault(isArray$3);

var _getIteratorMethod2 = interopRequireDefault(getIteratorMethod$3);

var _symbol = interopRequireDefault(symbol$2);

var _from = interopRequireDefault(from_1$2);

var _slice = interopRequireDefault(slice$5);

var _includes = interopRequireDefault(includes$4);

var _concat = interopRequireDefault(concat$3);

var _forEach = interopRequireDefault(forEach$3);

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof _symbol["default"] === "undefined" || (0, _getIteratorMethod2["default"])(o) == null) { if ((0, _isArray["default"])(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = (0, _getIterator2["default"])(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { var _context4; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = (0, _slice["default"])(_context4 = Object.prototype.toString.call(o)).call(_context4, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return (0, _from["default"])(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*!
 * XRegExp Unicode Base 4.4.1
 * <xregexp.com>
 * Steven Levithan (c) 2008-present MIT License
 */
var _default = function _default(XRegExp) {
  /**
   * Adds base support for Unicode matching:
   * - Adds syntax `\p{..}` for matching Unicode tokens. Tokens can be inverted using `\P{..}` or
   *   `\p{^..}`. Token names ignore case, spaces, hyphens, and underscores. You can omit the
   *   braces for token names that are a single letter (e.g. `\pL` or `PL`).
   * - Adds flag A (astral), which enables 21-bit Unicode support.
   * - Adds the `XRegExp.addUnicodeData` method used by other addons to provide character data.
   *
   * Unicode Base relies on externally provided Unicode character data. Official addons are
   * available to provide data for Unicode categories, scripts, blocks, and properties.
   *
   * @requires XRegExp
   */
  // ==--------------------------==
  // Private stuff
  // ==--------------------------==
  // Storage for Unicode data
  var unicode = {}; // Reuse utils

  var dec = XRegExp._dec;
  var hex = XRegExp._hex;
  var pad4 = XRegExp._pad4; // Generates a token lookup name: lowercase, with hyphens, spaces, and underscores removed

  function normalize(name) {
    return name.replace(/[- _]+/g, '').toLowerCase();
  } // Gets the decimal code of a literal code unit, \xHH, \uHHHH, or a backslash-escaped literal


  function charCode(chr) {
    var esc = /^\\[xu](.+)/.exec(chr);
    return esc ? dec(esc[1]) : chr.charCodeAt(chr[0] === '\\' ? 1 : 0);
  } // Inverts a list of ordered BMP characters and ranges


  function invertBmp(range) {
    var output = '';
    var lastEnd = -1;
    (0, _forEach["default"])(XRegExp).call(XRegExp, range, /(\\x..|\\u....|\\?[\s\S])(?:-(\\x..|\\u....|\\?[\s\S]))?/, function (m) {
      var start = charCode(m[1]);

      if (start > lastEnd + 1) {
        output += "\\u".concat(pad4(hex(lastEnd + 1)));

        if (start > lastEnd + 2) {
          output += "-\\u".concat(pad4(hex(start - 1)));
        }
      }

      lastEnd = charCode(m[2] || m[1]);
    });

    if (lastEnd < 0xFFFF) {
      output += "\\u".concat(pad4(hex(lastEnd + 1)));

      if (lastEnd < 0xFFFE) {
        output += '-\\uFFFF';
      }
    }

    return output;
  } // Generates an inverted BMP range on first use


  function cacheInvertedBmp(slug) {
    var prop = 'b!';
    return unicode[slug][prop] || (unicode[slug][prop] = invertBmp(unicode[slug].bmp));
  } // Combines and optionally negates BMP and astral data


  function buildAstral(slug, isNegated) {
    var item = unicode[slug];
    var combined = '';

    if (item.bmp && !item.isBmpLast) {
      var _context;

      combined = (0, _concat["default"])(_context = "[".concat(item.bmp, "]")).call(_context, item.astral ? '|' : '');
    }

    if (item.astral) {
      combined += item.astral;
    }

    if (item.isBmpLast && item.bmp) {
      var _context2;

      combined += (0, _concat["default"])(_context2 = "".concat(item.astral ? '|' : '', "[")).call(_context2, item.bmp, "]");
    } // Astral Unicode tokens always match a code point, never a code unit


    return isNegated ? "(?:(?!".concat(combined, ")(?:[\uD800-\uDBFF][\uDC00-\uDFFF]|[\0-\uFFFF]))") : "(?:".concat(combined, ")");
  } // Builds a complete astral pattern on first use


  function cacheAstral(slug, isNegated) {
    var prop = isNegated ? 'a!' : 'a=';
    return unicode[slug][prop] || (unicode[slug][prop] = buildAstral(slug, isNegated));
  } // ==--------------------------==
  // Core functionality
  // ==--------------------------==

  /*
   * Add astral mode (flag A) and Unicode token syntax: `\p{..}`, `\P{..}`, `\p{^..}`, `\pC`.
   */


  XRegExp.addToken( // Use `*` instead of `+` to avoid capturing `^` as the token name in `\p{^}`
  /\\([pP])(?:{(\^?)([^}]*)}|([A-Za-z]))/, function (match, scope, flags) {
    var ERR_DOUBLE_NEG = 'Invalid double negation ';
    var ERR_UNKNOWN_NAME = 'Unknown Unicode token ';
    var ERR_UNKNOWN_REF = 'Unicode token missing data ';
    var ERR_ASTRAL_ONLY = 'Astral mode required for Unicode token ';
    var ERR_ASTRAL_IN_CLASS = 'Astral mode does not support Unicode tokens within character classes'; // Negated via \P{..} or \p{^..}

    var isNegated = match[1] === 'P' || !!match[2]; // Switch from BMP (0-FFFF) to astral (0-10FFFF) mode via flag A

    var isAstralMode = (0, _includes["default"])(flags).call(flags, 'A'); // Token lookup name. Check `[4]` first to avoid passing `undefined` via `\p{}`

    var slug = normalize(match[4] || match[3]); // Token data object

    var item = unicode[slug];

    if (match[1] === 'P' && match[2]) {
      throw new SyntaxError(ERR_DOUBLE_NEG + match[0]);
    }

    if (!unicode.hasOwnProperty(slug)) {
      throw new SyntaxError(ERR_UNKNOWN_NAME + match[0]);
    } // Switch to the negated form of the referenced Unicode token


    if (item.inverseOf) {
      slug = normalize(item.inverseOf);

      if (!unicode.hasOwnProperty(slug)) {
        var _context3;

        throw new ReferenceError((0, _concat["default"])(_context3 = "".concat(ERR_UNKNOWN_REF + match[0], " -> ")).call(_context3, item.inverseOf));
      }

      item = unicode[slug];
      isNegated = !isNegated;
    }

    if (!(item.bmp || isAstralMode)) {
      throw new SyntaxError(ERR_ASTRAL_ONLY + match[0]);
    }

    if (isAstralMode) {
      if (scope === 'class') {
        throw new SyntaxError(ERR_ASTRAL_IN_CLASS);
      }

      return cacheAstral(slug, isNegated);
    }

    return scope === 'class' ? isNegated ? cacheInvertedBmp(slug) : item.bmp : "".concat((isNegated ? '[^' : '[') + item.bmp, "]");
  }, {
    scope: 'all',
    optionalFlags: 'A',
    leadChar: '\\'
  });
  /**
   * Adds to the list of Unicode tokens that XRegExp regexes can match via `\p` or `\P`.
   *
   * @memberOf XRegExp
   * @param {Array} data Objects with named character ranges. Each object may have properties
   *   `name`, `alias`, `isBmpLast`, `inverseOf`, `bmp`, and `astral`. All but `name` are
   *   optional, although one of `bmp` or `astral` is required (unless `inverseOf` is set). If
   *   `astral` is absent, the `bmp` data is used for BMP and astral modes. If `bmp` is absent,
   *   the name errors in BMP mode but works in astral mode. If both `bmp` and `astral` are
   *   provided, the `bmp` data only is used in BMP mode, and the combination of `bmp` and
   *   `astral` data is used in astral mode. `isBmpLast` is needed when a token matches orphan
   *   high surrogates *and* uses surrogate pairs to match astral code points. The `bmp` and
   *   `astral` data should be a combination of literal characters and `\xHH` or `\uHHHH` escape
   *   sequences, with hyphens to create ranges. Any regex metacharacters in the data should be
   *   escaped, apart from range-creating hyphens. The `astral` data can additionally use
   *   character classes and alternation, and should use surrogate pairs to represent astral code
   *   points. `inverseOf` can be used to avoid duplicating character data if a Unicode token is
   *   defined as the exact inverse of another token.
   * @example
   *
   * // Basic use
   * XRegExp.addUnicodeData([{
   *   name: 'XDigit',
   *   alias: 'Hexadecimal',
   *   bmp: '0-9A-Fa-f'
   * }]);
   * XRegExp('\\p{XDigit}:\\p{Hexadecimal}+').test('0:3D'); // -> true
   */

  XRegExp.addUnicodeData = function (data) {
    var ERR_NO_NAME = 'Unicode token requires name';
    var ERR_NO_DATA = 'Unicode token has no character data ';

    var _iterator = _createForOfIteratorHelper(data),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;

        if (!item.name) {
          throw new Error(ERR_NO_NAME);
        }

        if (!(item.inverseOf || item.bmp || item.astral)) {
          throw new Error(ERR_NO_DATA + item.name);
        }

        unicode[normalize(item.name)] = item;

        if (item.alias) {
          unicode[normalize(item.alias)] = item;
        }
      } // Reset the pattern cache used by the `XRegExp` constructor, since the same pattern and
      // flags might now produce different results

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    XRegExp.cache.flush('patterns');
  };
  /**
   * @ignore
   *
   * Return a reference to the internal Unicode definition structure for the given Unicode
   * Property if the given name is a legal Unicode Property for use in XRegExp `\p` or `\P` regex
   * constructs.
   *
   * @memberOf XRegExp
   * @param {String} name Name by which the Unicode Property may be recognized (case-insensitive),
   *   e.g. `'N'` or `'Number'`. The given name is matched against all registered Unicode
   *   Properties and Property Aliases.
   * @returns {Object} Reference to definition structure when the name matches a Unicode Property.
   *
   * @note
   * For more info on Unicode Properties, see also http://unicode.org/reports/tr18/#Categories.
   *
   * @note
   * This method is *not* part of the officially documented API and may change or be removed in
   * the future. It is meant for userland code that wishes to reuse the (large) internal Unicode
   * structures set up by XRegExp.
   */


  XRegExp._getUnicodeProperty = function (name) {
    var slug = normalize(name);
    return unicode[slug];
  };
};

exports["default"] = _default;
module.exports = exports.default;
});

unwrapExports(unicodeBase);

var blocks = [
    {
        'name': 'InAdlam',
        'astral': '\uD83A[\uDD00-\uDD5F]'
    },
    {
        'name': 'InAegean_Numbers',
        'astral': '\uD800[\uDD00-\uDD3F]'
    },
    {
        'name': 'InAhom',
        'astral': '\uD805[\uDF00-\uDF3F]'
    },
    {
        'name': 'InAlchemical_Symbols',
        'astral': '\uD83D[\uDF00-\uDF7F]'
    },
    {
        'name': 'InAlphabetic_Presentation_Forms',
        'bmp': '\uFB00-\uFB4F'
    },
    {
        'name': 'InAnatolian_Hieroglyphs',
        'astral': '\uD811[\uDC00-\uDE7F]'
    },
    {
        'name': 'InAncient_Greek_Musical_Notation',
        'astral': '\uD834[\uDE00-\uDE4F]'
    },
    {
        'name': 'InAncient_Greek_Numbers',
        'astral': '\uD800[\uDD40-\uDD8F]'
    },
    {
        'name': 'InAncient_Symbols',
        'astral': '\uD800[\uDD90-\uDDCF]'
    },
    {
        'name': 'InArabic',
        'bmp': '\u0600-\u06FF'
    },
    {
        'name': 'InArabic_Extended_A',
        'bmp': '\u08A0-\u08FF'
    },
    {
        'name': 'InArabic_Mathematical_Alphabetic_Symbols',
        'astral': '\uD83B[\uDE00-\uDEFF]'
    },
    {
        'name': 'InArabic_Presentation_Forms_A',
        'bmp': '\uFB50-\uFDFF'
    },
    {
        'name': 'InArabic_Presentation_Forms_B',
        'bmp': '\uFE70-\uFEFF'
    },
    {
        'name': 'InArabic_Supplement',
        'bmp': '\u0750-\u077F'
    },
    {
        'name': 'InArmenian',
        'bmp': '\u0530-\u058F'
    },
    {
        'name': 'InArrows',
        'bmp': '\u2190-\u21FF'
    },
    {
        'name': 'InAvestan',
        'astral': '\uD802[\uDF00-\uDF3F]'
    },
    {
        'name': 'InBalinese',
        'bmp': '\u1B00-\u1B7F'
    },
    {
        'name': 'InBamum',
        'bmp': '\uA6A0-\uA6FF'
    },
    {
        'name': 'InBamum_Supplement',
        'astral': '\uD81A[\uDC00-\uDE3F]'
    },
    {
        'name': 'InBasic_Latin',
        'bmp': '\0-\x7F'
    },
    {
        'name': 'InBassa_Vah',
        'astral': '\uD81A[\uDED0-\uDEFF]'
    },
    {
        'name': 'InBatak',
        'bmp': '\u1BC0-\u1BFF'
    },
    {
        'name': 'InBengali',
        'bmp': '\u0980-\u09FF'
    },
    {
        'name': 'InBhaiksuki',
        'astral': '\uD807[\uDC00-\uDC6F]'
    },
    {
        'name': 'InBlock_Elements',
        'bmp': '\u2580-\u259F'
    },
    {
        'name': 'InBopomofo',
        'bmp': '\u3100-\u312F'
    },
    {
        'name': 'InBopomofo_Extended',
        'bmp': '\u31A0-\u31BF'
    },
    {
        'name': 'InBox_Drawing',
        'bmp': '\u2500-\u257F'
    },
    {
        'name': 'InBrahmi',
        'astral': '\uD804[\uDC00-\uDC7F]'
    },
    {
        'name': 'InBraille_Patterns',
        'bmp': '\u2800-\u28FF'
    },
    {
        'name': 'InBuginese',
        'bmp': '\u1A00-\u1A1F'
    },
    {
        'name': 'InBuhid',
        'bmp': '\u1740-\u175F'
    },
    {
        'name': 'InByzantine_Musical_Symbols',
        'astral': '\uD834[\uDC00-\uDCFF]'
    },
    {
        'name': 'InCJK_Compatibility',
        'bmp': '\u3300-\u33FF'
    },
    {
        'name': 'InCJK_Compatibility_Forms',
        'bmp': '\uFE30-\uFE4F'
    },
    {
        'name': 'InCJK_Compatibility_Ideographs',
        'bmp': '\uF900-\uFAFF'
    },
    {
        'name': 'InCJK_Compatibility_Ideographs_Supplement',
        'astral': '\uD87E[\uDC00-\uDE1F]'
    },
    {
        'name': 'InCJK_Radicals_Supplement',
        'bmp': '\u2E80-\u2EFF'
    },
    {
        'name': 'InCJK_Strokes',
        'bmp': '\u31C0-\u31EF'
    },
    {
        'name': 'InCJK_Symbols_And_Punctuation',
        'bmp': '\u3000-\u303F'
    },
    {
        'name': 'InCJK_Unified_Ideographs',
        'bmp': '\u4E00-\u9FFF'
    },
    {
        'name': 'InCJK_Unified_Ideographs_Extension_A',
        'bmp': '\u3400-\u4DBF'
    },
    {
        'name': 'InCJK_Unified_Ideographs_Extension_B',
        'astral': '[\uD840-\uD868][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDF]'
    },
    {
        'name': 'InCJK_Unified_Ideographs_Extension_C',
        'astral': '\uD869[\uDF00-\uDFFF]|[\uD86A-\uD86C][\uDC00-\uDFFF]|\uD86D[\uDC00-\uDF3F]'
    },
    {
        'name': 'InCJK_Unified_Ideographs_Extension_D',
        'astral': '\uD86D[\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1F]'
    },
    {
        'name': 'InCJK_Unified_Ideographs_Extension_E',
        'astral': '\uD86E[\uDC20-\uDFFF]|[\uD86F-\uD872][\uDC00-\uDFFF]|\uD873[\uDC00-\uDEAF]'
    },
    {
        'name': 'InCJK_Unified_Ideographs_Extension_F',
        'astral': '\uD873[\uDEB0-\uDFFF]|[\uD874-\uD879][\uDC00-\uDFFF]|\uD87A[\uDC00-\uDFEF]'
    },
    {
        'name': 'InCarian',
        'astral': '\uD800[\uDEA0-\uDEDF]'
    },
    {
        'name': 'InCaucasian_Albanian',
        'astral': '\uD801[\uDD30-\uDD6F]'
    },
    {
        'name': 'InChakma',
        'astral': '\uD804[\uDD00-\uDD4F]'
    },
    {
        'name': 'InCham',
        'bmp': '\uAA00-\uAA5F'
    },
    {
        'name': 'InCherokee',
        'bmp': '\u13A0-\u13FF'
    },
    {
        'name': 'InCherokee_Supplement',
        'bmp': '\uAB70-\uABBF'
    },
    {
        'name': 'InChess_Symbols',
        'astral': '\uD83E[\uDE00-\uDE6F]'
    },
    {
        'name': 'InCombining_Diacritical_Marks',
        'bmp': '\u0300-\u036F'
    },
    {
        'name': 'InCombining_Diacritical_Marks_Extended',
        'bmp': '\u1AB0-\u1AFF'
    },
    {
        'name': 'InCombining_Diacritical_Marks_For_Symbols',
        'bmp': '\u20D0-\u20FF'
    },
    {
        'name': 'InCombining_Diacritical_Marks_Supplement',
        'bmp': '\u1DC0-\u1DFF'
    },
    {
        'name': 'InCombining_Half_Marks',
        'bmp': '\uFE20-\uFE2F'
    },
    {
        'name': 'InCommon_Indic_Number_Forms',
        'bmp': '\uA830-\uA83F'
    },
    {
        'name': 'InControl_Pictures',
        'bmp': '\u2400-\u243F'
    },
    {
        'name': 'InCoptic',
        'bmp': '\u2C80-\u2CFF'
    },
    {
        'name': 'InCoptic_Epact_Numbers',
        'astral': '\uD800[\uDEE0-\uDEFF]'
    },
    {
        'name': 'InCounting_Rod_Numerals',
        'astral': '\uD834[\uDF60-\uDF7F]'
    },
    {
        'name': 'InCuneiform',
        'astral': '\uD808[\uDC00-\uDFFF]'
    },
    {
        'name': 'InCuneiform_Numbers_And_Punctuation',
        'astral': '\uD809[\uDC00-\uDC7F]'
    },
    {
        'name': 'InCurrency_Symbols',
        'bmp': '\u20A0-\u20CF'
    },
    {
        'name': 'InCypriot_Syllabary',
        'astral': '\uD802[\uDC00-\uDC3F]'
    },
    {
        'name': 'InCyrillic',
        'bmp': '\u0400-\u04FF'
    },
    {
        'name': 'InCyrillic_Extended_A',
        'bmp': '\u2DE0-\u2DFF'
    },
    {
        'name': 'InCyrillic_Extended_B',
        'bmp': '\uA640-\uA69F'
    },
    {
        'name': 'InCyrillic_Extended_C',
        'bmp': '\u1C80-\u1C8F'
    },
    {
        'name': 'InCyrillic_Supplement',
        'bmp': '\u0500-\u052F'
    },
    {
        'name': 'InDeseret',
        'astral': '\uD801[\uDC00-\uDC4F]'
    },
    {
        'name': 'InDevanagari',
        'bmp': '\u0900-\u097F'
    },
    {
        'name': 'InDevanagari_Extended',
        'bmp': '\uA8E0-\uA8FF'
    },
    {
        'name': 'InDingbats',
        'bmp': '\u2700-\u27BF'
    },
    {
        'name': 'InDogra',
        'astral': '\uD806[\uDC00-\uDC4F]'
    },
    {
        'name': 'InDomino_Tiles',
        'astral': '\uD83C[\uDC30-\uDC9F]'
    },
    {
        'name': 'InDuployan',
        'astral': '\uD82F[\uDC00-\uDC9F]'
    },
    {
        'name': 'InEarly_Dynastic_Cuneiform',
        'astral': '\uD809[\uDC80-\uDD4F]'
    },
    {
        'name': 'InEgyptian_Hieroglyphs',
        'astral': '\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F]'
    },
    {
        'name': 'InElbasan',
        'astral': '\uD801[\uDD00-\uDD2F]'
    },
    {
        'name': 'InEmoticons',
        'astral': '\uD83D[\uDE00-\uDE4F]'
    },
    {
        'name': 'InEnclosed_Alphanumeric_Supplement',
        'astral': '\uD83C[\uDD00-\uDDFF]'
    },
    {
        'name': 'InEnclosed_Alphanumerics',
        'bmp': '\u2460-\u24FF'
    },
    {
        'name': 'InEnclosed_CJK_Letters_And_Months',
        'bmp': '\u3200-\u32FF'
    },
    {
        'name': 'InEnclosed_Ideographic_Supplement',
        'astral': '\uD83C[\uDE00-\uDEFF]'
    },
    {
        'name': 'InEthiopic',
        'bmp': '\u1200-\u137F'
    },
    {
        'name': 'InEthiopic_Extended',
        'bmp': '\u2D80-\u2DDF'
    },
    {
        'name': 'InEthiopic_Extended_A',
        'bmp': '\uAB00-\uAB2F'
    },
    {
        'name': 'InEthiopic_Supplement',
        'bmp': '\u1380-\u139F'
    },
    {
        'name': 'InGeneral_Punctuation',
        'bmp': '\u2000-\u206F'
    },
    {
        'name': 'InGeometric_Shapes',
        'bmp': '\u25A0-\u25FF'
    },
    {
        'name': 'InGeometric_Shapes_Extended',
        'astral': '\uD83D[\uDF80-\uDFFF]'
    },
    {
        'name': 'InGeorgian',
        'bmp': '\u10A0-\u10FF'
    },
    {
        'name': 'InGeorgian_Extended',
        'bmp': '\u1C90-\u1CBF'
    },
    {
        'name': 'InGeorgian_Supplement',
        'bmp': '\u2D00-\u2D2F'
    },
    {
        'name': 'InGlagolitic',
        'bmp': '\u2C00-\u2C5F'
    },
    {
        'name': 'InGlagolitic_Supplement',
        'astral': '\uD838[\uDC00-\uDC2F]'
    },
    {
        'name': 'InGothic',
        'astral': '\uD800[\uDF30-\uDF4F]'
    },
    {
        'name': 'InGrantha',
        'astral': '\uD804[\uDF00-\uDF7F]'
    },
    {
        'name': 'InGreek_And_Coptic',
        'bmp': '\u0370-\u03FF'
    },
    {
        'name': 'InGreek_Extended',
        'bmp': '\u1F00-\u1FFF'
    },
    {
        'name': 'InGujarati',
        'bmp': '\u0A80-\u0AFF'
    },
    {
        'name': 'InGunjala_Gondi',
        'astral': '\uD807[\uDD60-\uDDAF]'
    },
    {
        'name': 'InGurmukhi',
        'bmp': '\u0A00-\u0A7F'
    },
    {
        'name': 'InHalfwidth_And_Fullwidth_Forms',
        'bmp': '\uFF00-\uFFEF'
    },
    {
        'name': 'InHangul_Compatibility_Jamo',
        'bmp': '\u3130-\u318F'
    },
    {
        'name': 'InHangul_Jamo',
        'bmp': '\u1100-\u11FF'
    },
    {
        'name': 'InHangul_Jamo_Extended_A',
        'bmp': '\uA960-\uA97F'
    },
    {
        'name': 'InHangul_Jamo_Extended_B',
        'bmp': '\uD7B0-\uD7FF'
    },
    {
        'name': 'InHangul_Syllables',
        'bmp': '\uAC00-\uD7AF'
    },
    {
        'name': 'InHanifi_Rohingya',
        'astral': '\uD803[\uDD00-\uDD3F]'
    },
    {
        'name': 'InHanunoo',
        'bmp': '\u1720-\u173F'
    },
    {
        'name': 'InHatran',
        'astral': '\uD802[\uDCE0-\uDCFF]'
    },
    {
        'name': 'InHebrew',
        'bmp': '\u0590-\u05FF'
    },
    {
        'name': 'InHigh_Private_Use_Surrogates',
        'bmp': '\uDB80-\uDBFF'
    },
    {
        'name': 'InHigh_Surrogates',
        'bmp': '\uD800-\uDB7F'
    },
    {
        'name': 'InHiragana',
        'bmp': '\u3040-\u309F'
    },
    {
        'name': 'InIPA_Extensions',
        'bmp': '\u0250-\u02AF'
    },
    {
        'name': 'InIdeographic_Description_Characters',
        'bmp': '\u2FF0-\u2FFF'
    },
    {
        'name': 'InIdeographic_Symbols_And_Punctuation',
        'astral': '\uD81B[\uDFE0-\uDFFF]'
    },
    {
        'name': 'InImperial_Aramaic',
        'astral': '\uD802[\uDC40-\uDC5F]'
    },
    {
        'name': 'InIndic_Siyaq_Numbers',
        'astral': '\uD83B[\uDC70-\uDCBF]'
    },
    {
        'name': 'InInscriptional_Pahlavi',
        'astral': '\uD802[\uDF60-\uDF7F]'
    },
    {
        'name': 'InInscriptional_Parthian',
        'astral': '\uD802[\uDF40-\uDF5F]'
    },
    {
        'name': 'InJavanese',
        'bmp': '\uA980-\uA9DF'
    },
    {
        'name': 'InKaithi',
        'astral': '\uD804[\uDC80-\uDCCF]'
    },
    {
        'name': 'InKana_Extended_A',
        'astral': '\uD82C[\uDD00-\uDD2F]'
    },
    {
        'name': 'InKana_Supplement',
        'astral': '\uD82C[\uDC00-\uDCFF]'
    },
    {
        'name': 'InKanbun',
        'bmp': '\u3190-\u319F'
    },
    {
        'name': 'InKangxi_Radicals',
        'bmp': '\u2F00-\u2FDF'
    },
    {
        'name': 'InKannada',
        'bmp': '\u0C80-\u0CFF'
    },
    {
        'name': 'InKatakana',
        'bmp': '\u30A0-\u30FF'
    },
    {
        'name': 'InKatakana_Phonetic_Extensions',
        'bmp': '\u31F0-\u31FF'
    },
    {
        'name': 'InKayah_Li',
        'bmp': '\uA900-\uA92F'
    },
    {
        'name': 'InKharoshthi',
        'astral': '\uD802[\uDE00-\uDE5F]'
    },
    {
        'name': 'InKhmer',
        'bmp': '\u1780-\u17FF'
    },
    {
        'name': 'InKhmer_Symbols',
        'bmp': '\u19E0-\u19FF'
    },
    {
        'name': 'InKhojki',
        'astral': '\uD804[\uDE00-\uDE4F]'
    },
    {
        'name': 'InKhudawadi',
        'astral': '\uD804[\uDEB0-\uDEFF]'
    },
    {
        'name': 'InLao',
        'bmp': '\u0E80-\u0EFF'
    },
    {
        'name': 'InLatin_1_Supplement',
        'bmp': '\x80-\xFF'
    },
    {
        'name': 'InLatin_Extended_A',
        'bmp': '\u0100-\u017F'
    },
    {
        'name': 'InLatin_Extended_Additional',
        'bmp': '\u1E00-\u1EFF'
    },
    {
        'name': 'InLatin_Extended_B',
        'bmp': '\u0180-\u024F'
    },
    {
        'name': 'InLatin_Extended_C',
        'bmp': '\u2C60-\u2C7F'
    },
    {
        'name': 'InLatin_Extended_D',
        'bmp': '\uA720-\uA7FF'
    },
    {
        'name': 'InLatin_Extended_E',
        'bmp': '\uAB30-\uAB6F'
    },
    {
        'name': 'InLepcha',
        'bmp': '\u1C00-\u1C4F'
    },
    {
        'name': 'InLetterlike_Symbols',
        'bmp': '\u2100-\u214F'
    },
    {
        'name': 'InLimbu',
        'bmp': '\u1900-\u194F'
    },
    {
        'name': 'InLinear_A',
        'astral': '\uD801[\uDE00-\uDF7F]'
    },
    {
        'name': 'InLinear_B_Ideograms',
        'astral': '\uD800[\uDC80-\uDCFF]'
    },
    {
        'name': 'InLinear_B_Syllabary',
        'astral': '\uD800[\uDC00-\uDC7F]'
    },
    {
        'name': 'InLisu',
        'bmp': '\uA4D0-\uA4FF'
    },
    {
        'name': 'InLow_Surrogates',
        'bmp': '\uDC00-\uDFFF'
    },
    {
        'name': 'InLycian',
        'astral': '\uD800[\uDE80-\uDE9F]'
    },
    {
        'name': 'InLydian',
        'astral': '\uD802[\uDD20-\uDD3F]'
    },
    {
        'name': 'InMahajani',
        'astral': '\uD804[\uDD50-\uDD7F]'
    },
    {
        'name': 'InMahjong_Tiles',
        'astral': '\uD83C[\uDC00-\uDC2F]'
    },
    {
        'name': 'InMakasar',
        'astral': '\uD807[\uDEE0-\uDEFF]'
    },
    {
        'name': 'InMalayalam',
        'bmp': '\u0D00-\u0D7F'
    },
    {
        'name': 'InMandaic',
        'bmp': '\u0840-\u085F'
    },
    {
        'name': 'InManichaean',
        'astral': '\uD802[\uDEC0-\uDEFF]'
    },
    {
        'name': 'InMarchen',
        'astral': '\uD807[\uDC70-\uDCBF]'
    },
    {
        'name': 'InMasaram_Gondi',
        'astral': '\uD807[\uDD00-\uDD5F]'
    },
    {
        'name': 'InMathematical_Alphanumeric_Symbols',
        'astral': '\uD835[\uDC00-\uDFFF]'
    },
    {
        'name': 'InMathematical_Operators',
        'bmp': '\u2200-\u22FF'
    },
    {
        'name': 'InMayan_Numerals',
        'astral': '\uD834[\uDEE0-\uDEFF]'
    },
    {
        'name': 'InMedefaidrin',
        'astral': '\uD81B[\uDE40-\uDE9F]'
    },
    {
        'name': 'InMeetei_Mayek',
        'bmp': '\uABC0-\uABFF'
    },
    {
        'name': 'InMeetei_Mayek_Extensions',
        'bmp': '\uAAE0-\uAAFF'
    },
    {
        'name': 'InMende_Kikakui',
        'astral': '\uD83A[\uDC00-\uDCDF]'
    },
    {
        'name': 'InMeroitic_Cursive',
        'astral': '\uD802[\uDDA0-\uDDFF]'
    },
    {
        'name': 'InMeroitic_Hieroglyphs',
        'astral': '\uD802[\uDD80-\uDD9F]'
    },
    {
        'name': 'InMiao',
        'astral': '\uD81B[\uDF00-\uDF9F]'
    },
    {
        'name': 'InMiscellaneous_Mathematical_Symbols_A',
        'bmp': '\u27C0-\u27EF'
    },
    {
        'name': 'InMiscellaneous_Mathematical_Symbols_B',
        'bmp': '\u2980-\u29FF'
    },
    {
        'name': 'InMiscellaneous_Symbols',
        'bmp': '\u2600-\u26FF'
    },
    {
        'name': 'InMiscellaneous_Symbols_And_Arrows',
        'bmp': '\u2B00-\u2BFF'
    },
    {
        'name': 'InMiscellaneous_Symbols_And_Pictographs',
        'astral': '\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF]'
    },
    {
        'name': 'InMiscellaneous_Technical',
        'bmp': '\u2300-\u23FF'
    },
    {
        'name': 'InModi',
        'astral': '\uD805[\uDE00-\uDE5F]'
    },
    {
        'name': 'InModifier_Tone_Letters',
        'bmp': '\uA700-\uA71F'
    },
    {
        'name': 'InMongolian',
        'bmp': '\u1800-\u18AF'
    },
    {
        'name': 'InMongolian_Supplement',
        'astral': '\uD805[\uDE60-\uDE7F]'
    },
    {
        'name': 'InMro',
        'astral': '\uD81A[\uDE40-\uDE6F]'
    },
    {
        'name': 'InMultani',
        'astral': '\uD804[\uDE80-\uDEAF]'
    },
    {
        'name': 'InMusical_Symbols',
        'astral': '\uD834[\uDD00-\uDDFF]'
    },
    {
        'name': 'InMyanmar',
        'bmp': '\u1000-\u109F'
    },
    {
        'name': 'InMyanmar_Extended_A',
        'bmp': '\uAA60-\uAA7F'
    },
    {
        'name': 'InMyanmar_Extended_B',
        'bmp': '\uA9E0-\uA9FF'
    },
    {
        'name': 'InNKo',
        'bmp': '\u07C0-\u07FF'
    },
    {
        'name': 'InNabataean',
        'astral': '\uD802[\uDC80-\uDCAF]'
    },
    {
        'name': 'InNew_Tai_Lue',
        'bmp': '\u1980-\u19DF'
    },
    {
        'name': 'InNewa',
        'astral': '\uD805[\uDC00-\uDC7F]'
    },
    {
        'name': 'InNumber_Forms',
        'bmp': '\u2150-\u218F'
    },
    {
        'name': 'InNushu',
        'astral': '\uD82C[\uDD70-\uDEFF]'
    },
    {
        'name': 'InOgham',
        'bmp': '\u1680-\u169F'
    },
    {
        'name': 'InOl_Chiki',
        'bmp': '\u1C50-\u1C7F'
    },
    {
        'name': 'InOld_Hungarian',
        'astral': '\uD803[\uDC80-\uDCFF]'
    },
    {
        'name': 'InOld_Italic',
        'astral': '\uD800[\uDF00-\uDF2F]'
    },
    {
        'name': 'InOld_North_Arabian',
        'astral': '\uD802[\uDE80-\uDE9F]'
    },
    {
        'name': 'InOld_Permic',
        'astral': '\uD800[\uDF50-\uDF7F]'
    },
    {
        'name': 'InOld_Persian',
        'astral': '\uD800[\uDFA0-\uDFDF]'
    },
    {
        'name': 'InOld_Sogdian',
        'astral': '\uD803[\uDF00-\uDF2F]'
    },
    {
        'name': 'InOld_South_Arabian',
        'astral': '\uD802[\uDE60-\uDE7F]'
    },
    {
        'name': 'InOld_Turkic',
        'astral': '\uD803[\uDC00-\uDC4F]'
    },
    {
        'name': 'InOptical_Character_Recognition',
        'bmp': '\u2440-\u245F'
    },
    {
        'name': 'InOriya',
        'bmp': '\u0B00-\u0B7F'
    },
    {
        'name': 'InOrnamental_Dingbats',
        'astral': '\uD83D[\uDE50-\uDE7F]'
    },
    {
        'name': 'InOsage',
        'astral': '\uD801[\uDCB0-\uDCFF]'
    },
    {
        'name': 'InOsmanya',
        'astral': '\uD801[\uDC80-\uDCAF]'
    },
    {
        'name': 'InPahawh_Hmong',
        'astral': '\uD81A[\uDF00-\uDF8F]'
    },
    {
        'name': 'InPalmyrene',
        'astral': '\uD802[\uDC60-\uDC7F]'
    },
    {
        'name': 'InPau_Cin_Hau',
        'astral': '\uD806[\uDEC0-\uDEFF]'
    },
    {
        'name': 'InPhags_Pa',
        'bmp': '\uA840-\uA87F'
    },
    {
        'name': 'InPhaistos_Disc',
        'astral': '\uD800[\uDDD0-\uDDFF]'
    },
    {
        'name': 'InPhoenician',
        'astral': '\uD802[\uDD00-\uDD1F]'
    },
    {
        'name': 'InPhonetic_Extensions',
        'bmp': '\u1D00-\u1D7F'
    },
    {
        'name': 'InPhonetic_Extensions_Supplement',
        'bmp': '\u1D80-\u1DBF'
    },
    {
        'name': 'InPlaying_Cards',
        'astral': '\uD83C[\uDCA0-\uDCFF]'
    },
    {
        'name': 'InPrivate_Use_Area',
        'bmp': '\uE000-\uF8FF'
    },
    {
        'name': 'InPsalter_Pahlavi',
        'astral': '\uD802[\uDF80-\uDFAF]'
    },
    {
        'name': 'InRejang',
        'bmp': '\uA930-\uA95F'
    },
    {
        'name': 'InRumi_Numeral_Symbols',
        'astral': '\uD803[\uDE60-\uDE7F]'
    },
    {
        'name': 'InRunic',
        'bmp': '\u16A0-\u16FF'
    },
    {
        'name': 'InSamaritan',
        'bmp': '\u0800-\u083F'
    },
    {
        'name': 'InSaurashtra',
        'bmp': '\uA880-\uA8DF'
    },
    {
        'name': 'InSharada',
        'astral': '\uD804[\uDD80-\uDDDF]'
    },
    {
        'name': 'InShavian',
        'astral': '\uD801[\uDC50-\uDC7F]'
    },
    {
        'name': 'InShorthand_Format_Controls',
        'astral': '\uD82F[\uDCA0-\uDCAF]'
    },
    {
        'name': 'InSiddham',
        'astral': '\uD805[\uDD80-\uDDFF]'
    },
    {
        'name': 'InSinhala',
        'bmp': '\u0D80-\u0DFF'
    },
    {
        'name': 'InSinhala_Archaic_Numbers',
        'astral': '\uD804[\uDDE0-\uDDFF]'
    },
    {
        'name': 'InSmall_Form_Variants',
        'bmp': '\uFE50-\uFE6F'
    },
    {
        'name': 'InSogdian',
        'astral': '\uD803[\uDF30-\uDF6F]'
    },
    {
        'name': 'InSora_Sompeng',
        'astral': '\uD804[\uDCD0-\uDCFF]'
    },
    {
        'name': 'InSoyombo',
        'astral': '\uD806[\uDE50-\uDEAF]'
    },
    {
        'name': 'InSpacing_Modifier_Letters',
        'bmp': '\u02B0-\u02FF'
    },
    {
        'name': 'InSpecials',
        'bmp': '\uFFF0-\uFFFF'
    },
    {
        'name': 'InSundanese',
        'bmp': '\u1B80-\u1BBF'
    },
    {
        'name': 'InSundanese_Supplement',
        'bmp': '\u1CC0-\u1CCF'
    },
    {
        'name': 'InSuperscripts_And_Subscripts',
        'bmp': '\u2070-\u209F'
    },
    {
        'name': 'InSupplemental_Arrows_A',
        'bmp': '\u27F0-\u27FF'
    },
    {
        'name': 'InSupplemental_Arrows_B',
        'bmp': '\u2900-\u297F'
    },
    {
        'name': 'InSupplemental_Arrows_C',
        'astral': '\uD83E[\uDC00-\uDCFF]'
    },
    {
        'name': 'InSupplemental_Mathematical_Operators',
        'bmp': '\u2A00-\u2AFF'
    },
    {
        'name': 'InSupplemental_Punctuation',
        'bmp': '\u2E00-\u2E7F'
    },
    {
        'name': 'InSupplemental_Symbols_And_Pictographs',
        'astral': '\uD83E[\uDD00-\uDDFF]'
    },
    {
        'name': 'InSupplementary_Private_Use_Area_A',
        'astral': '[\uDB80-\uDBBF][\uDC00-\uDFFF]'
    },
    {
        'name': 'InSupplementary_Private_Use_Area_B',
        'astral': '[\uDBC0-\uDBFF][\uDC00-\uDFFF]'
    },
    {
        'name': 'InSutton_SignWriting',
        'astral': '\uD836[\uDC00-\uDEAF]'
    },
    {
        'name': 'InSyloti_Nagri',
        'bmp': '\uA800-\uA82F'
    },
    {
        'name': 'InSyriac',
        'bmp': '\u0700-\u074F'
    },
    {
        'name': 'InSyriac_Supplement',
        'bmp': '\u0860-\u086F'
    },
    {
        'name': 'InTagalog',
        'bmp': '\u1700-\u171F'
    },
    {
        'name': 'InTagbanwa',
        'bmp': '\u1760-\u177F'
    },
    {
        'name': 'InTags',
        'astral': '\uDB40[\uDC00-\uDC7F]'
    },
    {
        'name': 'InTai_Le',
        'bmp': '\u1950-\u197F'
    },
    {
        'name': 'InTai_Tham',
        'bmp': '\u1A20-\u1AAF'
    },
    {
        'name': 'InTai_Viet',
        'bmp': '\uAA80-\uAADF'
    },
    {
        'name': 'InTai_Xuan_Jing_Symbols',
        'astral': '\uD834[\uDF00-\uDF5F]'
    },
    {
        'name': 'InTakri',
        'astral': '\uD805[\uDE80-\uDECF]'
    },
    {
        'name': 'InTamil',
        'bmp': '\u0B80-\u0BFF'
    },
    {
        'name': 'InTangut',
        'astral': '[\uD81C-\uD821][\uDC00-\uDFFF]'
    },
    {
        'name': 'InTangut_Components',
        'astral': '\uD822[\uDC00-\uDEFF]'
    },
    {
        'name': 'InTelugu',
        'bmp': '\u0C00-\u0C7F'
    },
    {
        'name': 'InThaana',
        'bmp': '\u0780-\u07BF'
    },
    {
        'name': 'InThai',
        'bmp': '\u0E00-\u0E7F'
    },
    {
        'name': 'InTibetan',
        'bmp': '\u0F00-\u0FFF'
    },
    {
        'name': 'InTifinagh',
        'bmp': '\u2D30-\u2D7F'
    },
    {
        'name': 'InTirhuta',
        'astral': '\uD805[\uDC80-\uDCDF]'
    },
    {
        'name': 'InTransport_And_Map_Symbols',
        'astral': '\uD83D[\uDE80-\uDEFF]'
    },
    {
        'name': 'InUgaritic',
        'astral': '\uD800[\uDF80-\uDF9F]'
    },
    {
        'name': 'InUnified_Canadian_Aboriginal_Syllabics',
        'bmp': '\u1400-\u167F'
    },
    {
        'name': 'InUnified_Canadian_Aboriginal_Syllabics_Extended',
        'bmp': '\u18B0-\u18FF'
    },
    {
        'name': 'InVai',
        'bmp': '\uA500-\uA63F'
    },
    {
        'name': 'InVariation_Selectors',
        'bmp': '\uFE00-\uFE0F'
    },
    {
        'name': 'InVariation_Selectors_Supplement',
        'astral': '\uDB40[\uDD00-\uDDEF]'
    },
    {
        'name': 'InVedic_Extensions',
        'bmp': '\u1CD0-\u1CFF'
    },
    {
        'name': 'InVertical_Forms',
        'bmp': '\uFE10-\uFE1F'
    },
    {
        'name': 'InWarang_Citi',
        'astral': '\uD806[\uDCA0-\uDCFF]'
    },
    {
        'name': 'InYi_Radicals',
        'bmp': '\uA490-\uA4CF'
    },
    {
        'name': 'InYi_Syllables',
        'bmp': '\uA000-\uA48F'
    },
    {
        'name': 'InYijing_Hexagram_Symbols',
        'bmp': '\u4DC0-\u4DFF'
    },
    {
        'name': 'InZanabazar_Square',
        'astral': '\uD806[\uDE00-\uDE4F]'
    },
    {
        'name': 'Inundefined',
        'astral': '\uD803[\uDE80-\uDEBF\uDFB0-\uDFFF]|\uD806[\uDD00-\uDD5F\uDDA0-\uDDFF]|\uD807[\uDFB0-\uDFFF]|\uD80D[\uDC30-\uDC3F]|\uD822[\uDF00-\uDFFF]|\uD823[\uDC00-\uDD8F]|\uD82C[\uDD30-\uDD6F]|\uD838[\uDD00-\uDD4F\uDEC0-\uDEFF]|\uD83B[\uDD00-\uDD4F]|\uD83E[\uDE70-\uDFFF]|[\uD880-\uD883][\uDC00-\uDFFF]|\uD884[\uDC00-\uDF4F]'
    }
];

var unicodeBlocks = createCommonjsModule(function (module, exports) {





defineProperty$2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _blocks = interopRequireDefault(blocks);

/*!
 * XRegExp Unicode Blocks 4.4.1
 * <xregexp.com>
 * Steven Levithan (c) 2010-present MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */
var _default = function _default(XRegExp) {
  /**
   * Adds support for all Unicode blocks. Block names use the prefix 'In'. E.g.,
   * `\p{InBasicLatin}`. Token names are case insensitive, and any spaces, hyphens, and
   * underscores are ignored.
   *
   * Uses Unicode 13.0.0.
   *
   * @requires XRegExp, Unicode Base
   */
  if (!XRegExp.addUnicodeData) {
    throw new ReferenceError('Unicode Base must be loaded before Unicode Blocks');
  }

  XRegExp.addUnicodeData(_blocks["default"]);
};

exports["default"] = _default;
module.exports = exports.default;
});

unwrapExports(unicodeBlocks);

var categories = [
    {
        'name': 'C',
        'alias': 'Other',
        'isBmpLast': true,
        'bmp': '\0-\x1F\x7F-\x9F\xAD\u0378\u0379\u0380-\u0383\u038B\u038D\u03A2\u0530\u0557\u0558\u058B\u058C\u0590\u05C8-\u05CF\u05EB-\u05EE\u05F5-\u0605\u061C\u061D\u06DD\u070E\u070F\u074B\u074C\u07B2-\u07BF\u07FB\u07FC\u082E\u082F\u083F\u085C\u085D\u085F\u086B-\u089F\u08B5\u08C8-\u08D2\u08E2\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FF\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A77-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0AF8\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B54\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0BFF\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C76\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0CFF\u0D0D\u0D11\u0D45\u0D49\u0D50-\u0D53\u0D64\u0D65\u0D80\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E8B\u0EA4\u0EA6\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F6\u13F7\u13FE\u13FF\u169D-\u169F\u16F9-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180E\u180F\u181A-\u181F\u1879-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE\u1AAF\u1AC1-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C89-\u1C8F\u1CBB\u1CBC\u1CC8-\u1CCF\u1CFB-\u1CFF\u1DFA\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u200B-\u200F\u202A-\u202E\u2060-\u206F\u2072\u2073\u208F\u209D-\u209F\u20C0-\u20CF\u20F1-\u20FF\u218C-\u218F\u2427-\u243F\u244B-\u245F\u2B74\u2B75\u2B96\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E53-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u3130\u318F\u31E4-\u31EF\u321F\u9FFD-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA6F8-\uA6FF\uA7C0\uA7C1\uA7CB-\uA7F4\uA82D-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C6-\uA8CD\uA8DA-\uA8DF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB6C-\uAB6F\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD-\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFFB\uFFFE\uFFFF',
        'astral': '\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9D-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2C\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD70-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE36\uDE37\uDE3B-\uDE3E\uDE49-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD28-\uDD2F\uDD3A-\uDE5F\uDE7F\uDEAA\uDEAE\uDEAF\uDEB2-\uDEFF\uDF28-\uDF2F\uDF5A-\uDFAF\uDFCC-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC70-\uDC7E\uDCBD\uDCC2-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD48-\uDD4F\uDD77-\uDD7F\uDDE0\uDDF5-\uDDFF\uDE12\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC5C\uDC62-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDE7F\uDEB9-\uDEBF\uDECA-\uDEFF\uDF1B\uDF1C\uDF2C-\uDF2F\uDF40-\uDFFF]|\uD806[\uDC3C-\uDC9F\uDCF3-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD36\uDD39\uDD3A\uDD47-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD8\uDDD9\uDDE5-\uDDFF\uDE48-\uDE4F\uDEA3-\uDEBF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC46-\uDC4F\uDC6D-\uDC6F\uDC90\uDC91\uDCA8\uDCB7-\uDCFF\uDD07\uDD0A\uDD37-\uDD39\uDD3B\uDD3E\uDD48-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8F\uDD92\uDD99-\uDD9F\uDDAA-\uDEDF\uDEF9-\uDFAF\uDFB1-\uDFBF\uDFF2-\uDFFE]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD824-\uD82B\uD82D\uD82E\uD830-\uD833\uD837\uD839\uD83F\uD87B-\uD87D\uD87F\uD885-\uDB3F\uDB41-\uDBFF][\uDC00-\uDFFF]|\uD80D[\uDC2F-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDE70-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE9B-\uDEFF\uDF4B-\uDF4E\uDF88-\uDF8E\uDFA0-\uDFDF\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82C[\uDD1F-\uDD4F\uDD53-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA0-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDD73-\uDD7A\uDDE9-\uDDFF\uDE46-\uDEDF\uDEF4-\uDEFF\uDF57-\uDF5F\uDF79-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDCFF\uDD2D-\uDD2F\uDD3E\uDD3F\uDD4A-\uDD4D\uDD50-\uDEBF\uDEFA-\uDEFE\uDF00-\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4C-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDC70\uDCB5-\uDD00\uDD3E-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDDAE-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDE5F\uDE66-\uDEFF]|\uD83D[\uDED8-\uDEDF\uDEED-\uDEEF\uDEFD-\uDEFF\uDF74-\uDF7F\uDFD9-\uDFDF\uDFEC-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE\uDCAF\uDCB2-\uDCFF\uDD79\uDDCC\uDE54-\uDE5F\uDE6E\uDE6F\uDE75-\uDE77\uDE7B-\uDE7F\uDE87-\uDE8F\uDEA9-\uDEAF\uDEB7-\uDEBF\uDEC3-\uDECF\uDED7-\uDEFF\uDF93\uDFCB-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEDE-\uDEFF]|\uD86D[\uDF35-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDFFF]|\uDB40[\uDC00-\uDCFF\uDDF0-\uDFFF]'
    },
    {
        'name': 'Cc',
        'alias': 'Control',
        'bmp': '\0-\x1F\x7F-\x9F'
    },
    {
        'name': 'Cf',
        'alias': 'Format',
        'bmp': '\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB',
        'astral': '\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC38]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]'
    },
    {
        'name': 'Cn',
        'alias': 'Unassigned',
        'bmp': '\u0378\u0379\u0380-\u0383\u038B\u038D\u03A2\u0530\u0557\u0558\u058B\u058C\u0590\u05C8-\u05CF\u05EB-\u05EE\u05F5-\u05FF\u061D\u070E\u074B\u074C\u07B2-\u07BF\u07FB\u07FC\u082E\u082F\u083F\u085C\u085D\u085F\u086B-\u089F\u08B5\u08C8-\u08D2\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA\u09BB\u09C5\u09C6\u09C9\u09CA\u09CF-\u09D6\u09D8-\u09DB\u09DE\u09E4\u09E5\u09FF\u0A00\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A\u0A3B\u0A3D\u0A43-\u0A46\u0A49\u0A4A\u0A4E-\u0A50\u0A52-\u0A58\u0A5D\u0A5F-\u0A65\u0A77-\u0A80\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA\u0ABB\u0AC6\u0ACA\u0ACE\u0ACF\u0AD1-\u0ADF\u0AE4\u0AE5\u0AF2-\u0AF8\u0B00\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A\u0B3B\u0B45\u0B46\u0B49\u0B4A\u0B4E-\u0B54\u0B58-\u0B5B\u0B5E\u0B64\u0B65\u0B78-\u0B81\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BBD\u0BC3-\u0BC5\u0BC9\u0BCE\u0BCF\u0BD1-\u0BD6\u0BD8-\u0BE5\u0BFB-\u0BFF\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C45\u0C49\u0C4E-\u0C54\u0C57\u0C5B-\u0C5F\u0C64\u0C65\u0C70-\u0C76\u0C8D\u0C91\u0CA9\u0CB4\u0CBA\u0CBB\u0CC5\u0CC9\u0CCE-\u0CD4\u0CD7-\u0CDD\u0CDF\u0CE4\u0CE5\u0CF0\u0CF3-\u0CFF\u0D0D\u0D11\u0D45\u0D49\u0D50-\u0D53\u0D64\u0D65\u0D80\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DC9\u0DCB-\u0DCE\u0DD5\u0DD7\u0DE0-\u0DE5\u0DF0\u0DF1\u0DF5-\u0E00\u0E3B-\u0E3E\u0E5C-\u0E80\u0E83\u0E85\u0E8B\u0EA4\u0EA6\u0EBE\u0EBF\u0EC5\u0EC7\u0ECE\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F48\u0F6D-\u0F70\u0F98\u0FBD\u0FCD\u0FDB-\u0FFF\u10C6\u10C8-\u10CC\u10CE\u10CF\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B\u135C\u137D-\u137F\u139A-\u139F\u13F6\u13F7\u13FE\u13FF\u169D-\u169F\u16F9-\u16FF\u170D\u1715-\u171F\u1737-\u173F\u1754-\u175F\u176D\u1771\u1774-\u177F\u17DE\u17DF\u17EA-\u17EF\u17FA-\u17FF\u180F\u181A-\u181F\u1879-\u187F\u18AB-\u18AF\u18F6-\u18FF\u191F\u192C-\u192F\u193C-\u193F\u1941-\u1943\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19DD\u1A1C\u1A1D\u1A5F\u1A7D\u1A7E\u1A8A-\u1A8F\u1A9A-\u1A9F\u1AAE\u1AAF\u1AC1-\u1AFF\u1B4C-\u1B4F\u1B7D-\u1B7F\u1BF4-\u1BFB\u1C38-\u1C3A\u1C4A-\u1C4C\u1C89-\u1C8F\u1CBB\u1CBC\u1CC8-\u1CCF\u1CFB-\u1CFF\u1DFA\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FC5\u1FD4\u1FD5\u1FDC\u1FF0\u1FF1\u1FF5\u1FFF\u2065\u2072\u2073\u208F\u209D-\u209F\u20C0-\u20CF\u20F1-\u20FF\u218C-\u218F\u2427-\u243F\u244B-\u245F\u2B74\u2B75\u2B96\u2C2F\u2C5F\u2CF4-\u2CF8\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D71-\u2D7E\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF\u2E53-\u2E7F\u2E9A\u2EF4-\u2EFF\u2FD6-\u2FEF\u2FFC-\u2FFF\u3040\u3097\u3098\u3100-\u3104\u3130\u318F\u31E4-\u31EF\u321F\u9FFD-\u9FFF\uA48D-\uA48F\uA4C7-\uA4CF\uA62C-\uA63F\uA6F8-\uA6FF\uA7C0\uA7C1\uA7CB-\uA7F4\uA82D-\uA82F\uA83A-\uA83F\uA878-\uA87F\uA8C6-\uA8CD\uA8DA-\uA8DF\uA954-\uA95E\uA97D-\uA97F\uA9CE\uA9DA-\uA9DD\uA9FF\uAA37-\uAA3F\uAA4E\uAA4F\uAA5A\uAA5B\uAAC3-\uAADA\uAAF7-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB6C-\uAB6F\uABEE\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uD7FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBC2-\uFBD2\uFD40-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFE\uFDFF\uFE1A-\uFE1F\uFE53\uFE67\uFE6C-\uFE6F\uFE75\uFEFD\uFEFE\uFF00\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFDF\uFFE7\uFFEF-\uFFF8\uFFFE\uFFFF',
        'astral': '\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDCFF\uDD03-\uDD06\uDD34-\uDD36\uDD8F\uDD9D-\uDD9F\uDDA1-\uDDCF\uDDFE-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEDF\uDEFC-\uDEFF\uDF24-\uDF2C\uDF4B-\uDF4F\uDF7B-\uDF7F\uDF9E\uDFC4-\uDFC7\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6E\uDD70-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1E\uDD3A-\uDD3E\uDD40-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE04\uDE07-\uDE0B\uDE14\uDE18\uDE36\uDE37\uDE3B-\uDE3E\uDE49-\uDE4F\uDE59-\uDE5F\uDEA0-\uDEBF\uDEE7-\uDEEA\uDEF7-\uDEFF\uDF36-\uDF38\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDF98\uDF9D-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD28-\uDD2F\uDD3A-\uDE5F\uDE7F\uDEAA\uDEAE\uDEAF\uDEB2-\uDEFF\uDF28-\uDF2F\uDF5A-\uDFAF\uDFCC-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC4E-\uDC51\uDC70-\uDC7E\uDCC2-\uDCCC\uDCCE\uDCCF\uDCE9-\uDCEF\uDCFA-\uDCFF\uDD35\uDD48-\uDD4F\uDD77-\uDD7F\uDDE0\uDDF5-\uDDFF\uDE12\uDE3F-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEAA-\uDEAF\uDEEB-\uDEEF\uDEFA-\uDEFF\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A\uDF45\uDF46\uDF49\uDF4A\uDF4E\uDF4F\uDF51-\uDF56\uDF58-\uDF5C\uDF64\uDF65\uDF6D-\uDF6F\uDF75-\uDFFF]|\uD805[\uDC5C\uDC62-\uDC7F\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDB6\uDDB7\uDDDE-\uDDFF\uDE45-\uDE4F\uDE5A-\uDE5F\uDE6D-\uDE7F\uDEB9-\uDEBF\uDECA-\uDEFF\uDF1B\uDF1C\uDF2C-\uDF2F\uDF40-\uDFFF]|\uD806[\uDC3C-\uDC9F\uDCF3-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD36\uDD39\uDD3A\uDD47-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD8\uDDD9\uDDE5-\uDDFF\uDE48-\uDE4F\uDEA3-\uDEBF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC37\uDC46-\uDC4F\uDC6D-\uDC6F\uDC90\uDC91\uDCA8\uDCB7-\uDCFF\uDD07\uDD0A\uDD37-\uDD39\uDD3B\uDD3E\uDD48-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8F\uDD92\uDD99-\uDD9F\uDDAA-\uDEDF\uDEF9-\uDFAF\uDFB1-\uDFBF\uDFF2-\uDFFE]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F\uDC75-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80B\uD80E-\uD810\uD812-\uD819\uD824-\uD82B\uD82D\uD82E\uD830-\uD833\uD837\uD839\uD83F\uD87B-\uD87D\uD87F\uD885-\uDB3F\uDB41-\uDB7F][\uDC00-\uDFFF]|\uD80D[\uDC2F\uDC39-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6D\uDE70-\uDECF\uDEEE\uDEEF\uDEF6-\uDEFF\uDF46-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE9B-\uDEFF\uDF4B-\uDF4E\uDF88-\uDF8E\uDFA0-\uDFDF\uDFE5-\uDFEF\uDFF2-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82C[\uDD1F-\uDD4F\uDD53-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A\uDC9B\uDCA4-\uDFFF]|\uD834[\uDCF6-\uDCFF\uDD27\uDD28\uDDE9-\uDDFF\uDE46-\uDEDF\uDEF4-\uDEFF\uDF57-\uDF5F\uDF79-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]|\uD836[\uDE8C-\uDE9A\uDEA0\uDEB0-\uDFFF]|\uD838[\uDC07\uDC19\uDC1A\uDC22\uDC25\uDC2B-\uDCFF\uDD2D-\uDD2F\uDD3E\uDD3F\uDD4A-\uDD4D\uDD50-\uDEBF\uDEFA-\uDEFE\uDF00-\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD7-\uDCFF\uDD4C-\uDD4F\uDD5A-\uDD5D\uDD60-\uDFFF]|\uD83B[\uDC00-\uDC70\uDCB5-\uDD00\uDD3E-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDEEF\uDEF2-\uDFFF]|\uD83C[\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCD0\uDCF6-\uDCFF\uDDAE-\uDDE5\uDE03-\uDE0F\uDE3C-\uDE3F\uDE49-\uDE4F\uDE52-\uDE5F\uDE66-\uDEFF]|\uD83D[\uDED8-\uDEDF\uDEED-\uDEEF\uDEFD-\uDEFF\uDF74-\uDF7F\uDFD9-\uDFDF\uDFEC-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE\uDCAF\uDCB2-\uDCFF\uDD79\uDDCC\uDE54-\uDE5F\uDE6E\uDE6F\uDE75-\uDE77\uDE7B-\uDE7F\uDE87-\uDE8F\uDEA9-\uDEAF\uDEB7-\uDEBF\uDEC3-\uDECF\uDED7-\uDEFF\uDF93\uDFCB-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEDE-\uDEFF]|\uD86D[\uDF35-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDFFF]|\uDB40[\uDC00\uDC02-\uDC1F\uDC80-\uDCFF\uDDF0-\uDFFF]|[\uDBBF\uDBFF][\uDFFE\uDFFF]'
    },
    {
        'name': 'Co',
        'alias': 'Private_Use',
        'bmp': '\uE000-\uF8FF',
        'astral': '[\uDB80-\uDBBE\uDBC0-\uDBFE][\uDC00-\uDFFF]|[\uDBBF\uDBFF][\uDC00-\uDFFD]'
    },
    {
        'name': 'Cs',
        'alias': 'Surrogate',
        'bmp': '\uD800-\uDFFF'
    },
    {
        'name': 'L',
        'alias': 'Letter',
        'bmp': 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08C7\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\u9FFC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7BF\uA7C2-\uA7CA\uA7F5-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC',
        'astral': '\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82C[\uDC00-\uDD1E\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDEC0-\uDEEB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDD\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]'
    },
    {
        'name': 'LC',
        'alias': 'Cased_Letter',
        'bmp': 'A-Za-z\xB5\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BC-\u01BF\u01C4-\u0293\u0295-\u02AF\u0370-\u0373\u0376\u0377\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0560-\u0588\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FD-\u10FF\u13A0-\u13F5\u13F8-\u13FD\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7E-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA640-\uA66D\uA680-\uA69B\uA722-\uA76F\uA771-\uA787\uA78B-\uA78E\uA790-\uA7BF\uA7C2-\uA7CA\uA7F5\uA7F6\uA7FA\uAB30-\uAB5A\uAB60-\uAB68\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A',
        'astral': '\uD801[\uDC00-\uDC4F\uDCB0-\uDCD3\uDCD8-\uDCFB]|\uD803[\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD806[\uDCA0-\uDCDF]|\uD81B[\uDE40-\uDE7F]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDD00-\uDD43]'
    },
    {
        'name': 'Ll',
        'alias': 'Lowercase_Letter',
        'bmp': 'a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0560-\u0588\u10D0-\u10FA\u10FD-\u10FF\u13F8-\u13FD\u1C80-\u1C88\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7AF\uA7B5\uA7B7\uA7B9\uA7BB\uA7BD\uA7BF\uA7C3\uA7C8\uA7CA\uA7F6\uA7FA\uAB30-\uAB5A\uAB60-\uAB68\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A',
        'astral': '\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD81B[\uDE60-\uDE7F]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD83A[\uDD22-\uDD43]'
    },
    {
        'name': 'Lm',
        'alias': 'Modifier_Letter',
        'bmp': '\u02B0-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0374\u037A\u0559\u0640\u06E5\u06E6\u07F4\u07F5\u07FA\u081A\u0824\u0828\u0971\u0E46\u0EC6\u10FC\u17D7\u1843\u1AA7\u1C78-\u1C7D\u1D2C-\u1D6A\u1D78\u1D9B-\u1DBF\u2071\u207F\u2090-\u209C\u2C7C\u2C7D\u2D6F\u2E2F\u3005\u3031-\u3035\u303B\u309D\u309E\u30FC-\u30FE\uA015\uA4F8-\uA4FD\uA60C\uA67F\uA69C\uA69D\uA717-\uA71F\uA770\uA788\uA7F8\uA7F9\uA9CF\uA9E6\uAA70\uAADD\uAAF3\uAAF4\uAB5C-\uAB5F\uAB69\uFF70\uFF9E\uFF9F',
        'astral': '\uD81A[\uDF40-\uDF43]|\uD81B[\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD838[\uDD37-\uDD3D]|\uD83A\uDD4B'
    },
    {
        'name': 'Lo',
        'alias': 'Other_Letter',
        'bmp': '\xAA\xBA\u01BB\u01C0-\u01C3\u0294\u05D0-\u05EA\u05EF-\u05F2\u0620-\u063F\u0641-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u0800-\u0815\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08C7\u0904-\u0939\u093D\u0950\u0958-\u0961\u0972-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E45\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1100-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17DC\u1820-\u1842\u1844-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C77\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u2135-\u2138\u2D30-\u2D67\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3006\u303C\u3041-\u3096\u309F\u30A1-\u30FA\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\u9FFC\uA000-\uA014\uA016-\uA48C\uA4D0-\uA4F7\uA500-\uA60B\uA610-\uA61F\uA62A\uA62B\uA66E\uA6A0-\uA6E5\uA78F\uA7F7\uA7FB-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9E0-\uA9E4\uA9E7-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA6F\uAA71-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB\uAADC\uAAE0-\uAAEA\uAAF2\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF66-\uFF6F\uFF71-\uFF9D\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC',
        'astral': '\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC50-\uDC9D\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A]|\uD806[\uDC00-\uDC2B\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF4A\uDF50]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82C[\uDC00-\uDD1E\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD838[\uDD00-\uDD2C\uDD4E\uDEC0-\uDEEB]|\uD83A[\uDC00-\uDCC4]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDD\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]'
    },
    {
        'name': 'Lt',
        'alias': 'Titlecase_Letter',
        'bmp': '\u01C5\u01C8\u01CB\u01F2\u1F88-\u1F8F\u1F98-\u1F9F\u1FA8-\u1FAF\u1FBC\u1FCC\u1FFC'
    },
    {
        'name': 'Lu',
        'alias': 'Uppercase_Letter',
        'bmp': 'A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1C90-\u1CBA\u1CBD-\u1CBF\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AE\uA7B0-\uA7B4\uA7B6\uA7B8\uA7BA\uA7BC\uA7BE\uA7C2\uA7C4-\uA7C7\uA7C9\uA7F5\uFF21-\uFF3A',
        'astral': '\uD801[\uDC00-\uDC27\uDCB0-\uDCD3]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD81B[\uDE40-\uDE5F]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]'
    },
    {
        'name': 'M',
        'alias': 'Mark',
        'bmp': '\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F',
        'astral': '\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC7F-\uDC82\uDCB0-\uDCBA\uDD00-\uDD02\uDD27-\uDD34\uDD45\uDD46\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDC9-\uDDCC\uDDCE\uDDCF\uDE2C-\uDE37\uDE3E\uDEDF-\uDEEA\uDF00-\uDF03\uDF3B\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC35-\uDC46\uDC5E\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF2B]|\uD806[\uDC2C-\uDC3A\uDD30-\uDD35\uDD37\uDD38\uDD3B-\uDD3E\uDD40\uDD42\uDD43\uDDD1-\uDDD7\uDDDA-\uDDE0\uDDE4\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE3E\uDE47\uDE51-\uDE5B\uDE8A-\uDE99]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD8A-\uDD8E\uDD90\uDD91\uDD93-\uDD97\uDEF3-\uDEF6]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF51-\uDF87\uDF8F-\uDF92\uDFE4\uDFF0\uDFF1]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]'
    },
    {
        'name': 'Mc',
        'alias': 'Spacing_Mark',
        'bmp': '\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BE-\u09C0\u09C7\u09C8\u09CB\u09CC\u09D7\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B3E\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0B57\u0BBE\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD7\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0-\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0CD5\u0CD6\u0D02\u0D03\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D57\u0D82\u0D83\u0DCF-\u0DD1\u0DD8-\u0DDF\u0DF2\u0DF3\u0F3E\u0F3F\u0F7F\u102B\u102C\u1031\u1038\u103B\u103C\u1056\u1057\u1062-\u1064\u1067-\u106D\u1083\u1084\u1087-\u108C\u108F\u109A-\u109C\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A61\u1A63\u1A64\u1A6D-\u1A72\u1B04\u1B35\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\u302E\u302F\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAA7B\uAA7D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC',
        'astral': '\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3E\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB0-\uDCB2\uDCB9\uDCBB-\uDCBE\uDCC1\uDDAF-\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF20\uDF21\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD30-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD65\uDD66\uDD6D-\uDD72]'
    },
    {
        'name': 'Me',
        'alias': 'Enclosing_Mark',
        'bmp': '\u0488\u0489\u1ABE\u20DD-\u20E0\u20E2-\u20E4\uA670-\uA672'
    },
    {
        'name': 'Mn',
        'alias': 'Nonspacing_Mark',
        'bmp': '\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B55\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0D81\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1ABF\u1AC0\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F',
        'astral': '\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF40\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB3-\uDCB8\uDCBA\uDCBF\uDCC0\uDCC2\uDCC3\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uDB40[\uDD00-\uDDEF]'
    },
    {
        'name': 'N',
        'alias': 'Number',
        'bmp': '0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19',
        'astral': '\uD800[\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23\uDF41\uDF4A\uDFD1-\uDFD5]|\uD801[\uDCA0-\uDCA9]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE48\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDD30-\uDD39\uDE60-\uDE7E\uDF1D-\uDF26\uDF51-\uDF54\uDFC5-\uDFCB]|\uD804[\uDC52-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDDE1-\uDDF4\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF3B]|\uD806[\uDCE0-\uDCF2\uDD50-\uDD59]|\uD807[\uDC50-\uDC6C\uDD50-\uDD59\uDDA0-\uDDA9\uDFC0-\uDFD4]|\uD809[\uDC00-\uDC6E]|\uD81A[\uDE60-\uDE69\uDF50-\uDF59\uDF5B-\uDF61]|\uD81B[\uDE80-\uDE96]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDFCE-\uDFFF]|\uD838[\uDD40-\uDD49\uDEF0-\uDEF9]|\uD83A[\uDCC7-\uDCCF\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]'
    },
    {
        'name': 'Nd',
        'alias': 'Decimal_Number',
        'bmp': '0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19',
        'astral': '\uD801[\uDCA0-\uDCA9]|\uD803[\uDD30-\uDD39]|\uD804[\uDC66-\uDC6F\uDCF0-\uDCF9\uDD36-\uDD3F\uDDD0-\uDDD9\uDEF0-\uDEF9]|\uD805[\uDC50-\uDC59\uDCD0-\uDCD9\uDE50-\uDE59\uDEC0-\uDEC9\uDF30-\uDF39]|\uD806[\uDCE0-\uDCE9\uDD50-\uDD59]|\uD807[\uDC50-\uDC59\uDD50-\uDD59\uDDA0-\uDDA9]|\uD81A[\uDE60-\uDE69\uDF50-\uDF59]|\uD835[\uDFCE-\uDFFF]|\uD838[\uDD40-\uDD49\uDEF0-\uDEF9]|\uD83A[\uDD50-\uDD59]|\uD83E[\uDFF0-\uDFF9]'
    },
    {
        'name': 'Nl',
        'alias': 'Letter_Number',
        'bmp': '\u16EE-\u16F0\u2160-\u2182\u2185-\u2188\u3007\u3021-\u3029\u3038-\u303A\uA6E6-\uA6EF',
        'astral': '\uD800[\uDD40-\uDD74\uDF41\uDF4A\uDFD1-\uDFD5]|\uD809[\uDC00-\uDC6E]'
    },
    {
        'name': 'No',
        'alias': 'Other_Number',
        'bmp': '\xB2\xB3\xB9\xBC-\xBE\u09F4-\u09F9\u0B72-\u0B77\u0BF0-\u0BF2\u0C78-\u0C7E\u0D58-\u0D5E\u0D70-\u0D78\u0F2A-\u0F33\u1369-\u137C\u17F0-\u17F9\u19DA\u2070\u2074-\u2079\u2080-\u2089\u2150-\u215F\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA830-\uA835',
        'astral': '\uD800[\uDD07-\uDD33\uDD75-\uDD78\uDD8A\uDD8B\uDEE1-\uDEFB\uDF20-\uDF23]|\uD802[\uDC58-\uDC5F\uDC79-\uDC7F\uDCA7-\uDCAF\uDCFB-\uDCFF\uDD16-\uDD1B\uDDBC\uDDBD\uDDC0-\uDDCF\uDDD2-\uDDFF\uDE40-\uDE48\uDE7D\uDE7E\uDE9D-\uDE9F\uDEEB-\uDEEF\uDF58-\uDF5F\uDF78-\uDF7F\uDFA9-\uDFAF]|\uD803[\uDCFA-\uDCFF\uDE60-\uDE7E\uDF1D-\uDF26\uDF51-\uDF54\uDFC5-\uDFCB]|\uD804[\uDC52-\uDC65\uDDE1-\uDDF4]|\uD805[\uDF3A\uDF3B]|\uD806[\uDCEA-\uDCF2]|\uD807[\uDC5A-\uDC6C\uDFC0-\uDFD4]|\uD81A[\uDF5B-\uDF61]|\uD81B[\uDE80-\uDE96]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD83A[\uDCC7-\uDCCF]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D]|\uD83C[\uDD00-\uDD0C]'
    },
    {
        'name': 'P',
        'alias': 'Punctuation',
        'bmp': '!-#%-\\*,-\\/:;\\?@\\[-\\]_\\{\\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65',
        'astral': '\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDFFF]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]'
    },
    {
        'name': 'Pc',
        'alias': 'Connector_Punctuation',
        'bmp': '_\u203F\u2040\u2054\uFE33\uFE34\uFE4D-\uFE4F\uFF3F'
    },
    {
        'name': 'Pd',
        'alias': 'Dash_Punctuation',
        'bmp': '\\-\u058A\u05BE\u1400\u1806\u2010-\u2015\u2E17\u2E1A\u2E3A\u2E3B\u2E40\u301C\u3030\u30A0\uFE31\uFE32\uFE58\uFE63\uFF0D',
        'astral': '\uD803\uDEAD'
    },
    {
        'name': 'Pe',
        'alias': 'Close_Punctuation',
        'bmp': '\\)\\]\\}\u0F3B\u0F3D\u169C\u2046\u207E\u208E\u2309\u230B\u232A\u2769\u276B\u276D\u276F\u2771\u2773\u2775\u27C6\u27E7\u27E9\u27EB\u27ED\u27EF\u2984\u2986\u2988\u298A\u298C\u298E\u2990\u2992\u2994\u2996\u2998\u29D9\u29DB\u29FD\u2E23\u2E25\u2E27\u2E29\u3009\u300B\u300D\u300F\u3011\u3015\u3017\u3019\u301B\u301E\u301F\uFD3E\uFE18\uFE36\uFE38\uFE3A\uFE3C\uFE3E\uFE40\uFE42\uFE44\uFE48\uFE5A\uFE5C\uFE5E\uFF09\uFF3D\uFF5D\uFF60\uFF63'
    },
    {
        'name': 'Pf',
        'alias': 'Final_Punctuation',
        'bmp': '\xBB\u2019\u201D\u203A\u2E03\u2E05\u2E0A\u2E0D\u2E1D\u2E21'
    },
    {
        'name': 'Pi',
        'alias': 'Initial_Punctuation',
        'bmp': '\xAB\u2018\u201B\u201C\u201F\u2039\u2E02\u2E04\u2E09\u2E0C\u2E1C\u2E20'
    },
    {
        'name': 'Po',
        'alias': 'Other_Punctuation',
        'bmp': '!-#%-\'\\*,\\.\\/:;\\?@\\\xA1\xA7\xB6\xB7\xBF\u037E\u0387\u055A-\u055F\u0589\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u166E\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u1805\u1807-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2016\u2017\u2020-\u2027\u2030-\u2038\u203B-\u203E\u2041-\u2043\u2047-\u2051\u2053\u2055-\u205E\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00\u2E01\u2E06-\u2E08\u2E0B\u2E0E-\u2E16\u2E18\u2E19\u2E1B\u2E1E\u2E1F\u2E2A-\u2E2E\u2E30-\u2E39\u2E3C-\u2E3F\u2E41\u2E43-\u2E4F\u2E52\u3001-\u3003\u303D\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFE10-\uFE16\uFE19\uFE30\uFE45\uFE46\uFE49-\uFE4C\uFE50-\uFE52\uFE54-\uFE57\uFE5F-\uFE61\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF07\uFF0A\uFF0C\uFF0E\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3C\uFF61\uFF64\uFF65',
        'astral': '\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDFFF]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]'
    },
    {
        'name': 'Ps',
        'alias': 'Open_Punctuation',
        'bmp': '\\(\\[\\{\u0F3A\u0F3C\u169B\u201A\u201E\u2045\u207D\u208D\u2308\u230A\u2329\u2768\u276A\u276C\u276E\u2770\u2772\u2774\u27C5\u27E6\u27E8\u27EA\u27EC\u27EE\u2983\u2985\u2987\u2989\u298B\u298D\u298F\u2991\u2993\u2995\u2997\u29D8\u29DA\u29FC\u2E22\u2E24\u2E26\u2E28\u2E42\u3008\u300A\u300C\u300E\u3010\u3014\u3016\u3018\u301A\u301D\uFD3F\uFE17\uFE35\uFE37\uFE39\uFE3B\uFE3D\uFE3F\uFE41\uFE43\uFE47\uFE59\uFE5B\uFE5D\uFF08\uFF3B\uFF5B\uFF5F\uFF62'
    },
    {
        'name': 'S',
        'alias': 'Symbol',
        'bmp': '\\$\\+<->\\^`\\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20BF\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC1\uFDFC\uFDFD\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD',
        'astral': '\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEE0-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDD78\uDD7A-\uDDCB\uDDCD-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6\uDF00-\uDF92\uDF94-\uDFCA]'
    },
    {
        'name': 'Sc',
        'alias': 'Currency_Symbol',
        'bmp': '\\$\xA2-\xA5\u058F\u060B\u07FE\u07FF\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BF\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6',
        'astral': '\uD807[\uDFDD-\uDFE0]|\uD838\uDEFF|\uD83B\uDCB0'
    },
    {
        'name': 'Sk',
        'alias': 'Modifier_Symbol',
        'bmp': '\\^`\xA8\xAF\xB4\xB8\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u309B\u309C\uA700-\uA716\uA720\uA721\uA789\uA78A\uAB5B\uAB6A\uAB6B\uFBB2-\uFBC1\uFF3E\uFF40\uFFE3',
        'astral': '\uD83C[\uDFFB-\uDFFF]'
    },
    {
        'name': 'Sm',
        'alias': 'Math_Symbol',
        'bmp': '\\+<->\\|~\xAC\xB1\xD7\xF7\u03F6\u0606-\u0608\u2044\u2052\u207A-\u207C\u208A-\u208C\u2118\u2140-\u2144\u214B\u2190-\u2194\u219A\u219B\u21A0\u21A3\u21A6\u21AE\u21CE\u21CF\u21D2\u21D4\u21F4-\u22FF\u2320\u2321\u237C\u239B-\u23B3\u23DC-\u23E1\u25B7\u25C1\u25F8-\u25FF\u266F\u27C0-\u27C4\u27C7-\u27E5\u27F0-\u27FF\u2900-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2AFF\u2B30-\u2B44\u2B47-\u2B4C\uFB29\uFE62\uFE64-\uFE66\uFF0B\uFF1C-\uFF1E\uFF5C\uFF5E\uFFE2\uFFE9-\uFFEC',
        'astral': '\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD83B[\uDEF0\uDEF1]'
    },
    {
        'name': 'So',
        'alias': 'Other_Symbol',
        'bmp': '\xA6\xA9\xAE\xB0\u0482\u058D\u058E\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u09FA\u0B70\u0BF3-\u0BF8\u0BFA\u0C7F\u0D4F\u0D79\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116\u2117\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u214A\u214C\u214D\u214F\u218A\u218B\u2195-\u2199\u219C-\u219F\u21A1\u21A2\u21A4\u21A5\u21A7-\u21AD\u21AF-\u21CD\u21D0\u21D1\u21D3\u21D5-\u21F3\u2300-\u2307\u230C-\u231F\u2322-\u2328\u232B-\u237B\u237D-\u239A\u23B4-\u23DB\u23E2-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u25B6\u25B8-\u25C0\u25C2-\u25F7\u2600-\u266E\u2670-\u2767\u2794-\u27BF\u2800-\u28FF\u2B00-\u2B2F\u2B45\u2B46\u2B4D-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA828-\uA82B\uA836\uA837\uA839\uAA77-\uAA79\uFDFD\uFFE4\uFFE8\uFFED\uFFEE\uFFFC\uFFFD',
        'astral': '\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFDC\uDFE1-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838\uDD4F|\uD83B[\uDCAC\uDD2E]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFA]|\uD83D[\uDC00-\uDED7\uDEE0-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDD78\uDD7A-\uDDCB\uDDCD-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6\uDF00-\uDF92\uDF94-\uDFCA]'
    },
    {
        'name': 'Z',
        'alias': 'Separator',
        'bmp': ' \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000'
    },
    {
        'name': 'Zl',
        'alias': 'Line_Separator',
        'bmp': '\u2028'
    },
    {
        'name': 'Zp',
        'alias': 'Paragraph_Separator',
        'bmp': '\u2029'
    },
    {
        'name': 'Zs',
        'alias': 'Space_Separator',
        'bmp': ' \xA0\u1680\u2000-\u200A\u202F\u205F\u3000'
    }
];

var unicodeCategories = createCommonjsModule(function (module, exports) {





defineProperty$2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _categories = interopRequireDefault(categories);

/*!
 * XRegExp Unicode Categories 4.4.1
 * <xregexp.com>
 * Steven Levithan (c) 2010-present MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */
var _default = function _default(XRegExp) {
  /**
   * Adds support for Unicode's general categories. E.g., `\p{Lu}` or `\p{Uppercase Letter}`. See
   * category descriptions in UAX #44 <http://unicode.org/reports/tr44/#GC_Values_Table>. Token
   * names are case insensitive, and any spaces, hyphens, and underscores are ignored.
   *
   * Uses Unicode 13.0.0.
   *
   * @requires XRegExp, Unicode Base
   */
  if (!XRegExp.addUnicodeData) {
    throw new ReferenceError('Unicode Base must be loaded before Unicode Categories');
  }

  XRegExp.addUnicodeData(_categories["default"]);
};

exports["default"] = _default;
module.exports = exports.default;
});

unwrapExports(unicodeCategories);

var properties = [
    {
        'name': 'ASCII',
        'bmp': '\0-\x7F'
    },
    {
        'name': 'Alphabetic',
        'bmp': 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0345\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05B0-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05EF-\u05F2\u0610-\u061A\u0620-\u0657\u0659-\u065F\u066E-\u06D3\u06D5-\u06DC\u06E1-\u06E8\u06ED-\u06EF\u06FA-\u06FC\u06FF\u0710-\u073F\u074D-\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0817\u081A-\u082C\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08C7\u08D4-\u08DF\u08E3-\u08E9\u08F0-\u093B\u093D-\u094C\u094E-\u0950\u0955-\u0963\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD-\u09C4\u09C7\u09C8\u09CB\u09CC\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09F0\u09F1\u09FC\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3E-\u0A42\u0A47\u0A48\u0A4B\u0A4C\u0A51\u0A59-\u0A5C\u0A5E\u0A70-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD-\u0AC5\u0AC7-\u0AC9\u0ACB\u0ACC\u0AD0\u0AE0-\u0AE3\u0AF9-\u0AFC\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D-\u0B44\u0B47\u0B48\u0B4B\u0B4C\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4C\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCC\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CF1\u0CF2\u0D00-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D7A-\u0D7F\u0D81-\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E46\u0E4D\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0ECD\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F71-\u0F81\u0F88-\u0F97\u0F99-\u0FBC\u1000-\u1036\u1038\u103B-\u103F\u1050-\u108F\u109A-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1713\u1720-\u1733\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17B3\u17B6-\u17C8\u17D7\u17DC\u1820-\u1878\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u1938\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A1B\u1A20-\u1A5E\u1A61-\u1A74\u1AA7\u1ABF\u1AC0\u1B00-\u1B33\u1B35-\u1B43\u1B45-\u1B4B\u1B80-\u1BA9\u1BAC-\u1BAF\u1BBA-\u1BE5\u1BE7-\u1BF1\u1C00-\u1C36\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1DE7-\u1DF4\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u24B6-\u24E9\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\u9FFC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA674-\uA67B\uA67F-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7BF\uA7C2-\uA7CA\uA7F5-\uA805\uA807-\uA827\uA840-\uA873\uA880-\uA8C3\uA8C5\uA8F2-\uA8F7\uA8FB\uA8FD-\uA8FF\uA90A-\uA92A\uA930-\uA952\uA960-\uA97C\uA980-\uA9B2\uA9B4-\uA9BF\uA9CF\uA9E0-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA60-\uAA76\uAA7A-\uAABE\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF5\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABEA\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC',
        'astral': '\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD27\uDE80-\uDEA9\uDEAB\uDEAC\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC00-\uDC45\uDC82-\uDCB8\uDCD0-\uDCE8\uDD00-\uDD32\uDD44-\uDD47\uDD50-\uDD72\uDD76\uDD80-\uDDBF\uDDC1-\uDDC4\uDDCE\uDDCF\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE34\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEE8\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D-\uDF44\uDF47\uDF48\uDF4B\uDF4C\uDF50\uDF57\uDF5D-\uDF63]|\uD805[\uDC00-\uDC41\uDC43-\uDC45\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCC1\uDCC4\uDCC5\uDCC7\uDD80-\uDDB5\uDDB8-\uDDBE\uDDD8-\uDDDD\uDE00-\uDE3E\uDE40\uDE44\uDE80-\uDEB5\uDEB8\uDF00-\uDF1A\uDF1D-\uDF2A]|\uD806[\uDC00-\uDC38\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD35\uDD37\uDD38\uDD3B\uDD3C\uDD3F-\uDD42\uDDA0-\uDDA7\uDDAA-\uDDD7\uDDDA-\uDDDF\uDDE1\uDDE3\uDDE4\uDE00-\uDE32\uDE35-\uDE3E\uDE50-\uDE97\uDE9D\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC3E\uDC40\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD41\uDD43\uDD46\uDD47\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD8E\uDD90\uDD91\uDD93-\uDD96\uDD98\uDEE0-\uDEF6\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF4F-\uDF87\uDF8F-\uDF9F\uDFE0\uDFE1\uDFE3\uDFF0\uDFF1]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82C[\uDC00-\uDD1E\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9E]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDEC0-\uDEEB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD47\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]|\uD869[\uDC00-\uDEDD\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]'
    },
    {
        'name': 'Any',
        'isBmpLast': true,
        'bmp': '\0-\uFFFF',
        'astral': '[\uD800-\uDBFF][\uDC00-\uDFFF]'
    },
    {
        'name': 'Default_Ignorable_Code_Point',
        'bmp': '\xAD\u034F\u061C\u115F\u1160\u17B4\u17B5\u180B-\u180E\u200B-\u200F\u202A-\u202E\u2060-\u206F\u3164\uFE00-\uFE0F\uFEFF\uFFA0\uFFF0-\uFFF8',
        'astral': '\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|[\uDB40-\uDB43][\uDC00-\uDFFF]'
    },
    {
        'name': 'Lowercase',
        'bmp': 'a-z\xAA\xB5\xBA\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02B8\u02C0\u02C1\u02E0-\u02E4\u0345\u0371\u0373\u0377\u037A-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0560-\u0588\u10D0-\u10FA\u10FD-\u10FF\u13F8-\u13FD\u1C80-\u1C88\u1D00-\u1DBF\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u2071\u207F\u2090-\u209C\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2170-\u217F\u2184\u24D0-\u24E9\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7D\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B-\uA69D\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7AF\uA7B5\uA7B7\uA7B9\uA7BB\uA7BD\uA7BF\uA7C3\uA7C8\uA7CA\uA7F6\uA7F8-\uA7FA\uAB30-\uAB5A\uAB5C-\uAB68\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A',
        'astral': '\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB]|\uD803[\uDCC0-\uDCF2]|\uD806[\uDCC0-\uDCDF]|\uD81B[\uDE60-\uDE7F]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD83A[\uDD22-\uDD43]'
    },
    {
        'name': 'Noncharacter_Code_Point',
        'bmp': '\uFDD0-\uFDEF\uFFFE\uFFFF',
        'astral': '[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]'
    },
    {
        'name': 'Uppercase',
        'bmp': 'A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1C90-\u1CBA\u1CBD-\u1CBF\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2160-\u216F\u2183\u24B6-\u24CF\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AE\uA7B0-\uA7B4\uA7B6\uA7B8\uA7BA\uA7BC\uA7BE\uA7C2\uA7C4-\uA7C7\uA7C9\uA7F5\uFF21-\uFF3A',
        'astral': '\uD801[\uDC00-\uDC27\uDCB0-\uDCD3]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD81B[\uDE40-\uDE5F]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21]|\uD83C[\uDD30-\uDD49\uDD50-\uDD69\uDD70-\uDD89]'
    },
    {
        'name': 'White_Space',
        'bmp': '\t-\r \x85\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000'
    }
];

var unicodeProperties = createCommonjsModule(function (module, exports) {





defineProperty$2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _properties = interopRequireDefault(properties);

/*!
 * XRegExp Unicode Properties 4.4.1
 * <xregexp.com>
 * Steven Levithan (c) 2012-present MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */
var _default = function _default(XRegExp) {
  /**
   * Adds properties to meet the UTS #18 Level 1 RL1.2 requirements for Unicode regex support. See
   * <http://unicode.org/reports/tr18/#RL1.2>. Following are definitions of these properties from
   * UAX #44 <http://unicode.org/reports/tr44/>:
   *
   * - Alphabetic
   *   Characters with the Alphabetic property. Generated from: Lowercase + Uppercase + Lt + Lm +
   *   Lo + Nl + Other_Alphabetic.
   *
   * - Default_Ignorable_Code_Point
   *   For programmatic determination of default ignorable code points. New characters that should
   *   be ignored in rendering (unless explicitly supported) will be assigned in these ranges,
   *   permitting programs to correctly handle the default rendering of such characters when not
   *   otherwise supported.
   *
   * - Lowercase
   *   Characters with the Lowercase property. Generated from: Ll + Other_Lowercase.
   *
   * - Noncharacter_Code_Point
   *   Code points permanently reserved for internal use.
   *
   * - Uppercase
   *   Characters with the Uppercase property. Generated from: Lu + Other_Uppercase.
   *
   * - White_Space
   *   Spaces, separator characters and other control characters which should be treated by
   *   programming languages as "white space" for the purpose of parsing elements.
   *
   * The properties ASCII, Any, and Assigned are also included but are not defined in UAX #44. UTS
   * #18 RL1.2 additionally requires support for Unicode scripts and general categories. These are
   * included in XRegExp's Unicode Categories and Unicode Scripts addons.
   *
   * Token names are case insensitive, and any spaces, hyphens, and underscores are ignored.
   *
   * Uses Unicode 13.0.0.
   *
   * @requires XRegExp, Unicode Base
   */
  if (!XRegExp.addUnicodeData) {
    throw new ReferenceError('Unicode Base must be loaded before Unicode Properties');
  }

  var unicodeData = _properties["default"]; // Add non-generated data

  unicodeData.push({
    name: 'Assigned',
    // Since this is defined as the inverse of Unicode category Cn (Unassigned), the Unicode
    // Categories addon is required to use this property
    inverseOf: 'Cn'
  });
  XRegExp.addUnicodeData(unicodeData);
};

exports["default"] = _default;
module.exports = exports.default;
});

unwrapExports(unicodeProperties);

var scripts = [
    {
        'name': 'Adlam',
        'astral': '\uD83A[\uDD00-\uDD4B\uDD50-\uDD59\uDD5E\uDD5F]'
    },
    {
        'name': 'Ahom',
        'astral': '\uD805[\uDF00-\uDF1A\uDF1D-\uDF2B\uDF30-\uDF3F]'
    },
    {
        'name': 'Anatolian_Hieroglyphs',
        'astral': '\uD811[\uDC00-\uDE46]'
    },
    {
        'name': 'Arabic',
        'bmp': '\u0600-\u0604\u0606-\u060B\u060D-\u061A\u061C\u061E\u0620-\u063F\u0641-\u064A\u0656-\u066F\u0671-\u06DC\u06DE-\u06FF\u0750-\u077F\u08A0-\u08B4\u08B6-\u08C7\u08D3-\u08E1\u08E3-\u08FF\uFB50-\uFBC1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFD\uFE70-\uFE74\uFE76-\uFEFC',
        'astral': '\uD803[\uDE60-\uDE7E]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB\uDEF0\uDEF1]'
    },
    {
        'name': 'Armenian',
        'bmp': '\u0531-\u0556\u0559-\u058A\u058D-\u058F\uFB13-\uFB17'
    },
    {
        'name': 'Avestan',
        'astral': '\uD802[\uDF00-\uDF35\uDF39-\uDF3F]'
    },
    {
        'name': 'Balinese',
        'bmp': '\u1B00-\u1B4B\u1B50-\u1B7C'
    },
    {
        'name': 'Bamum',
        'bmp': '\uA6A0-\uA6F7',
        'astral': '\uD81A[\uDC00-\uDE38]'
    },
    {
        'name': 'Bassa_Vah',
        'astral': '\uD81A[\uDED0-\uDEED\uDEF0-\uDEF5]'
    },
    {
        'name': 'Batak',
        'bmp': '\u1BC0-\u1BF3\u1BFC-\u1BFF'
    },
    {
        'name': 'Bengali',
        'bmp': '\u0980-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09FE'
    },
    {
        'name': 'Bhaiksuki',
        'astral': '\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC45\uDC50-\uDC6C]'
    },
    {
        'name': 'Bopomofo',
        'bmp': '\u02EA\u02EB\u3105-\u312F\u31A0-\u31BF'
    },
    {
        'name': 'Brahmi',
        'astral': '\uD804[\uDC00-\uDC4D\uDC52-\uDC6F\uDC7F]'
    },
    {
        'name': 'Braille',
        'bmp': '\u2800-\u28FF'
    },
    {
        'name': 'Buginese',
        'bmp': '\u1A00-\u1A1B\u1A1E\u1A1F'
    },
    {
        'name': 'Buhid',
        'bmp': '\u1740-\u1753'
    },
    {
        'name': 'Canadian_Aboriginal',
        'bmp': '\u1400-\u167F\u18B0-\u18F5'
    },
    {
        'name': 'Carian',
        'astral': '\uD800[\uDEA0-\uDED0]'
    },
    {
        'name': 'Caucasian_Albanian',
        'astral': '\uD801[\uDD30-\uDD63\uDD6F]'
    },
    {
        'name': 'Chakma',
        'astral': '\uD804[\uDD00-\uDD34\uDD36-\uDD47]'
    },
    {
        'name': 'Cham',
        'bmp': '\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F'
    },
    {
        'name': 'Cherokee',
        'bmp': '\u13A0-\u13F5\u13F8-\u13FD\uAB70-\uABBF'
    },
    {
        'name': 'Chorasmian',
        'astral': '\uD803[\uDFB0-\uDFCB]'
    },
    {
        'name': 'Common',
        'bmp': '\0-@\\[-`\\{-\xA9\xAB-\xB9\xBB-\xBF\xD7\xF7\u02B9-\u02DF\u02E5-\u02E9\u02EC-\u02FF\u0374\u037E\u0385\u0387\u0605\u060C\u061B\u061F\u0640\u06DD\u08E2\u0964\u0965\u0E3F\u0FD5-\u0FD8\u10FB\u16EB-\u16ED\u1735\u1736\u1802\u1803\u1805\u1CD3\u1CE1\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5-\u1CF7\u1CFA\u2000-\u200B\u200E-\u2064\u2066-\u2070\u2074-\u207E\u2080-\u208E\u20A0-\u20BF\u2100-\u2125\u2127-\u2129\u212C-\u2131\u2133-\u214D\u214F-\u215F\u2189-\u218B\u2190-\u2426\u2440-\u244A\u2460-\u27FF\u2900-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2E00-\u2E52\u2FF0-\u2FFB\u3000-\u3004\u3006\u3008-\u3020\u3030-\u3037\u303C-\u303F\u309B\u309C\u30A0\u30FB\u30FC\u3190-\u319F\u31C0-\u31E3\u3220-\u325F\u327F-\u32CF\u32FF\u3358-\u33FF\u4DC0-\u4DFF\uA700-\uA721\uA788-\uA78A\uA830-\uA839\uA92E\uA9CF\uAB5B\uAB6A\uAB6B\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE66\uFE68-\uFE6B\uFEFF\uFF01-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFF70\uFF9E\uFF9F\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFF9-\uFFFD',
        'astral': '\uD800[\uDD00-\uDD02\uDD07-\uDD33\uDD37-\uDD3F\uDD90-\uDD9C\uDDD0-\uDDFC\uDEE1-\uDEFB]|\uD81B[\uDFE2\uDFE3]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD66\uDD6A-\uDD7A\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDEE0-\uDEF3\uDF00-\uDF56\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDFCB\uDFCE-\uDFFF]|\uD83B[\uDC71-\uDCB4\uDD01-\uDD3D]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD00-\uDDAD\uDDE6-\uDDFF\uDE01\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEE0-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDD78\uDD7A-\uDDCB\uDDCD-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6\uDF00-\uDF92\uDF94-\uDFCA\uDFF0-\uDFF9]|\uDB40[\uDC01\uDC20-\uDC7F]'
    },
    {
        'name': 'Coptic',
        'bmp': '\u03E2-\u03EF\u2C80-\u2CF3\u2CF9-\u2CFF'
    },
    {
        'name': 'Cuneiform',
        'astral': '\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC70-\uDC74\uDC80-\uDD43]'
    },
    {
        'name': 'Cypriot',
        'astral': '\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F]'
    },
    {
        'name': 'Cyrillic',
        'bmp': '\u0400-\u0484\u0487-\u052F\u1C80-\u1C88\u1D2B\u1D78\u2DE0-\u2DFF\uA640-\uA69F\uFE2E\uFE2F'
    },
    {
        'name': 'Deseret',
        'astral': '\uD801[\uDC00-\uDC4F]'
    },
    {
        'name': 'Devanagari',
        'bmp': '\u0900-\u0950\u0955-\u0963\u0966-\u097F\uA8E0-\uA8FF'
    },
    {
        'name': 'Dives_Akuru',
        'astral': '\uD806[\uDD00-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD35\uDD37\uDD38\uDD3B-\uDD46\uDD50-\uDD59]'
    },
    {
        'name': 'Dogra',
        'astral': '\uD806[\uDC00-\uDC3B]'
    },
    {
        'name': 'Duployan',
        'astral': '\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9C-\uDC9F]'
    },
    {
        'name': 'Egyptian_Hieroglyphs',
        'astral': '\uD80C[\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E\uDC30-\uDC38]'
    },
    {
        'name': 'Elbasan',
        'astral': '\uD801[\uDD00-\uDD27]'
    },
    {
        'name': 'Elymaic',
        'astral': '\uD803[\uDFE0-\uDFF6]'
    },
    {
        'name': 'Ethiopic',
        'bmp': '\u1200-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u137C\u1380-\u1399\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E'
    },
    {
        'name': 'Georgian',
        'bmp': '\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u10FF\u1C90-\u1CBA\u1CBD-\u1CBF\u2D00-\u2D25\u2D27\u2D2D'
    },
    {
        'name': 'Glagolitic',
        'bmp': '\u2C00-\u2C2E\u2C30-\u2C5E',
        'astral': '\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]'
    },
    {
        'name': 'Gothic',
        'astral': '\uD800[\uDF30-\uDF4A]'
    },
    {
        'name': 'Grantha',
        'astral': '\uD804[\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]'
    },
    {
        'name': 'Greek',
        'bmp': '\u0370-\u0373\u0375-\u0377\u037A-\u037D\u037F\u0384\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03E1\u03F0-\u03FF\u1D26-\u1D2A\u1D5D-\u1D61\u1D66-\u1D6A\u1DBF\u1F00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FC4\u1FC6-\u1FD3\u1FD6-\u1FDB\u1FDD-\u1FEF\u1FF2-\u1FF4\u1FF6-\u1FFE\u2126\uAB65',
        'astral': '\uD800[\uDD40-\uDD8E\uDDA0]|\uD834[\uDE00-\uDE45]'
    },
    {
        'name': 'Gujarati',
        'bmp': '\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AF1\u0AF9-\u0AFF'
    },
    {
        'name': 'Gunjala_Gondi',
        'astral': '\uD807[\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD8E\uDD90\uDD91\uDD93-\uDD98\uDDA0-\uDDA9]'
    },
    {
        'name': 'Gurmukhi',
        'bmp': '\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A76'
    },
    {
        'name': 'Han',
        'bmp': '\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DBF\u4E00-\u9FFC\uF900-\uFA6D\uFA70-\uFAD9',
        'astral': '\uD81B[\uDFF0\uDFF1]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDD\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A]'
    },
    {
        'name': 'Hangul',
        'bmp': '\u1100-\u11FF\u302E\u302F\u3131-\u318E\u3200-\u321E\u3260-\u327E\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC'
    },
    {
        'name': 'Hanifi_Rohingya',
        'astral': '\uD803[\uDD00-\uDD27\uDD30-\uDD39]'
    },
    {
        'name': 'Hanunoo',
        'bmp': '\u1720-\u1734'
    },
    {
        'name': 'Hatran',
        'astral': '\uD802[\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDCFF]'
    },
    {
        'name': 'Hebrew',
        'bmp': '\u0591-\u05C7\u05D0-\u05EA\u05EF-\u05F4\uFB1D-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFB4F'
    },
    {
        'name': 'Hiragana',
        'bmp': '\u3041-\u3096\u309D-\u309F',
        'astral': '\uD82C[\uDC01-\uDD1E\uDD50-\uDD52]|\uD83C\uDE00'
    },
    {
        'name': 'Imperial_Aramaic',
        'astral': '\uD802[\uDC40-\uDC55\uDC57-\uDC5F]'
    },
    {
        'name': 'Inherited',
        'bmp': '\u0300-\u036F\u0485\u0486\u064B-\u0655\u0670\u0951-\u0954\u1AB0-\u1AC0\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u200D\u20D0-\u20F0\u302A-\u302D\u3099\u309A\uFE00-\uFE0F\uFE20-\uFE2D',
        'astral': '\uD800[\uDDFD\uDEE0]|\uD804\uDF3B|\uD834[\uDD67-\uDD69\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD]|\uDB40[\uDD00-\uDDEF]'
    },
    {
        'name': 'Inscriptional_Pahlavi',
        'astral': '\uD802[\uDF60-\uDF72\uDF78-\uDF7F]'
    },
    {
        'name': 'Inscriptional_Parthian',
        'astral': '\uD802[\uDF40-\uDF55\uDF58-\uDF5F]'
    },
    {
        'name': 'Javanese',
        'bmp': '\uA980-\uA9CD\uA9D0-\uA9D9\uA9DE\uA9DF'
    },
    {
        'name': 'Kaithi',
        'astral': '\uD804[\uDC80-\uDCC1\uDCCD]'
    },
    {
        'name': 'Kannada',
        'bmp': '\u0C80-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2'
    },
    {
        'name': 'Katakana',
        'bmp': '\u30A1-\u30FA\u30FD-\u30FF\u31F0-\u31FF\u32D0-\u32FE\u3300-\u3357\uFF66-\uFF6F\uFF71-\uFF9D',
        'astral': '\uD82C[\uDC00\uDD64-\uDD67]'
    },
    {
        'name': 'Kayah_Li',
        'bmp': '\uA900-\uA92D\uA92F'
    },
    {
        'name': 'Kharoshthi',
        'astral': '\uD802[\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE38-\uDE3A\uDE3F-\uDE48\uDE50-\uDE58]'
    },
    {
        'name': 'Khitan_Small_Script',
        'astral': '\uD81B\uDFE4|\uD822[\uDF00-\uDFFF]|\uD823[\uDC00-\uDCD5]'
    },
    {
        'name': 'Khmer',
        'bmp': '\u1780-\u17DD\u17E0-\u17E9\u17F0-\u17F9\u19E0-\u19FF'
    },
    {
        'name': 'Khojki',
        'astral': '\uD804[\uDE00-\uDE11\uDE13-\uDE3E]'
    },
    {
        'name': 'Khudawadi',
        'astral': '\uD804[\uDEB0-\uDEEA\uDEF0-\uDEF9]'
    },
    {
        'name': 'Lao',
        'bmp': '\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF'
    },
    {
        'name': 'Latin',
        'bmp': 'A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7BF\uA7C2-\uA7CA\uA7F5-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uAB66-\uAB69\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A'
    },
    {
        'name': 'Lepcha',
        'bmp': '\u1C00-\u1C37\u1C3B-\u1C49\u1C4D-\u1C4F'
    },
    {
        'name': 'Limbu',
        'bmp': '\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1940\u1944-\u194F'
    },
    {
        'name': 'Linear_A',
        'astral': '\uD801[\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]'
    },
    {
        'name': 'Linear_B',
        'astral': '\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA]'
    },
    {
        'name': 'Lisu',
        'bmp': '\uA4D0-\uA4FF',
        'astral': '\uD807\uDFB0'
    },
    {
        'name': 'Lycian',
        'astral': '\uD800[\uDE80-\uDE9C]'
    },
    {
        'name': 'Lydian',
        'astral': '\uD802[\uDD20-\uDD39\uDD3F]'
    },
    {
        'name': 'Mahajani',
        'astral': '\uD804[\uDD50-\uDD76]'
    },
    {
        'name': 'Makasar',
        'astral': '\uD807[\uDEE0-\uDEF8]'
    },
    {
        'name': 'Malayalam',
        'bmp': '\u0D00-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4F\u0D54-\u0D63\u0D66-\u0D7F'
    },
    {
        'name': 'Mandaic',
        'bmp': '\u0840-\u085B\u085E'
    },
    {
        'name': 'Manichaean',
        'astral': '\uD802[\uDEC0-\uDEE6\uDEEB-\uDEF6]'
    },
    {
        'name': 'Marchen',
        'astral': '\uD807[\uDC70-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]'
    },
    {
        'name': 'Masaram_Gondi',
        'astral': '\uD807[\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59]'
    },
    {
        'name': 'Medefaidrin',
        'astral': '\uD81B[\uDE40-\uDE9A]'
    },
    {
        'name': 'Meetei_Mayek',
        'bmp': '\uAAE0-\uAAF6\uABC0-\uABED\uABF0-\uABF9'
    },
    {
        'name': 'Mende_Kikakui',
        'astral': '\uD83A[\uDC00-\uDCC4\uDCC7-\uDCD6]'
    },
    {
        'name': 'Meroitic_Cursive',
        'astral': '\uD802[\uDDA0-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDDFF]'
    },
    {
        'name': 'Meroitic_Hieroglyphs',
        'astral': '\uD802[\uDD80-\uDD9F]'
    },
    {
        'name': 'Miao',
        'astral': '\uD81B[\uDF00-\uDF4A\uDF4F-\uDF87\uDF8F-\uDF9F]'
    },
    {
        'name': 'Modi',
        'astral': '\uD805[\uDE00-\uDE44\uDE50-\uDE59]'
    },
    {
        'name': 'Mongolian',
        'bmp': '\u1800\u1801\u1804\u1806-\u180E\u1810-\u1819\u1820-\u1878\u1880-\u18AA',
        'astral': '\uD805[\uDE60-\uDE6C]'
    },
    {
        'name': 'Mro',
        'astral': '\uD81A[\uDE40-\uDE5E\uDE60-\uDE69\uDE6E\uDE6F]'
    },
    {
        'name': 'Multani',
        'astral': '\uD804[\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA9]'
    },
    {
        'name': 'Myanmar',
        'bmp': '\u1000-\u109F\uA9E0-\uA9FE\uAA60-\uAA7F'
    },
    {
        'name': 'Nabataean',
        'astral': '\uD802[\uDC80-\uDC9E\uDCA7-\uDCAF]'
    },
    {
        'name': 'Nandinagari',
        'astral': '\uD806[\uDDA0-\uDDA7\uDDAA-\uDDD7\uDDDA-\uDDE4]'
    },
    {
        'name': 'New_Tai_Lue',
        'bmp': '\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u19DE\u19DF'
    },
    {
        'name': 'Newa',
        'astral': '\uD805[\uDC00-\uDC5B\uDC5D-\uDC61]'
    },
    {
        'name': 'Nko',
        'bmp': '\u07C0-\u07FA\u07FD-\u07FF'
    },
    {
        'name': 'Nushu',
        'astral': '\uD81B\uDFE1|\uD82C[\uDD70-\uDEFB]'
    },
    {
        'name': 'Nyiakeng_Puachue_Hmong',
        'astral': '\uD838[\uDD00-\uDD2C\uDD30-\uDD3D\uDD40-\uDD49\uDD4E\uDD4F]'
    },
    {
        'name': 'Ogham',
        'bmp': '\u1680-\u169C'
    },
    {
        'name': 'Ol_Chiki',
        'bmp': '\u1C50-\u1C7F'
    },
    {
        'name': 'Old_Hungarian',
        'astral': '\uD803[\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDCFF]'
    },
    {
        'name': 'Old_Italic',
        'astral': '\uD800[\uDF00-\uDF23\uDF2D-\uDF2F]'
    },
    {
        'name': 'Old_North_Arabian',
        'astral': '\uD802[\uDE80-\uDE9F]'
    },
    {
        'name': 'Old_Permic',
        'astral': '\uD800[\uDF50-\uDF7A]'
    },
    {
        'name': 'Old_Persian',
        'astral': '\uD800[\uDFA0-\uDFC3\uDFC8-\uDFD5]'
    },
    {
        'name': 'Old_Sogdian',
        'astral': '\uD803[\uDF00-\uDF27]'
    },
    {
        'name': 'Old_South_Arabian',
        'astral': '\uD802[\uDE60-\uDE7F]'
    },
    {
        'name': 'Old_Turkic',
        'astral': '\uD803[\uDC00-\uDC48]'
    },
    {
        'name': 'Oriya',
        'bmp': '\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B77'
    },
    {
        'name': 'Osage',
        'astral': '\uD801[\uDCB0-\uDCD3\uDCD8-\uDCFB]'
    },
    {
        'name': 'Osmanya',
        'astral': '\uD801[\uDC80-\uDC9D\uDCA0-\uDCA9]'
    },
    {
        'name': 'Pahawh_Hmong',
        'astral': '\uD81A[\uDF00-\uDF45\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]'
    },
    {
        'name': 'Palmyrene',
        'astral': '\uD802[\uDC60-\uDC7F]'
    },
    {
        'name': 'Pau_Cin_Hau',
        'astral': '\uD806[\uDEC0-\uDEF8]'
    },
    {
        'name': 'Phags_Pa',
        'bmp': '\uA840-\uA877'
    },
    {
        'name': 'Phoenician',
        'astral': '\uD802[\uDD00-\uDD1B\uDD1F]'
    },
    {
        'name': 'Psalter_Pahlavi',
        'astral': '\uD802[\uDF80-\uDF91\uDF99-\uDF9C\uDFA9-\uDFAF]'
    },
    {
        'name': 'Rejang',
        'bmp': '\uA930-\uA953\uA95F'
    },
    {
        'name': 'Runic',
        'bmp': '\u16A0-\u16EA\u16EE-\u16F8'
    },
    {
        'name': 'Samaritan',
        'bmp': '\u0800-\u082D\u0830-\u083E'
    },
    {
        'name': 'Saurashtra',
        'bmp': '\uA880-\uA8C5\uA8CE-\uA8D9'
    },
    {
        'name': 'Sharada',
        'astral': '\uD804[\uDD80-\uDDDF]'
    },
    {
        'name': 'Shavian',
        'astral': '\uD801[\uDC50-\uDC7F]'
    },
    {
        'name': 'Siddham',
        'astral': '\uD805[\uDD80-\uDDB5\uDDB8-\uDDDD]'
    },
    {
        'name': 'SignWriting',
        'astral': '\uD836[\uDC00-\uDE8B\uDE9B-\uDE9F\uDEA1-\uDEAF]'
    },
    {
        'name': 'Sinhala',
        'bmp': '\u0D81-\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2-\u0DF4',
        'astral': '\uD804[\uDDE1-\uDDF4]'
    },
    {
        'name': 'Sogdian',
        'astral': '\uD803[\uDF30-\uDF59]'
    },
    {
        'name': 'Sora_Sompeng',
        'astral': '\uD804[\uDCD0-\uDCE8\uDCF0-\uDCF9]'
    },
    {
        'name': 'Soyombo',
        'astral': '\uD806[\uDE50-\uDEA2]'
    },
    {
        'name': 'Sundanese',
        'bmp': '\u1B80-\u1BBF\u1CC0-\u1CC7'
    },
    {
        'name': 'Syloti_Nagri',
        'bmp': '\uA800-\uA82C'
    },
    {
        'name': 'Syriac',
        'bmp': '\u0700-\u070D\u070F-\u074A\u074D-\u074F\u0860-\u086A'
    },
    {
        'name': 'Tagalog',
        'bmp': '\u1700-\u170C\u170E-\u1714'
    },
    {
        'name': 'Tagbanwa',
        'bmp': '\u1760-\u176C\u176E-\u1770\u1772\u1773'
    },
    {
        'name': 'Tai_Le',
        'bmp': '\u1950-\u196D\u1970-\u1974'
    },
    {
        'name': 'Tai_Tham',
        'bmp': '\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA0-\u1AAD'
    },
    {
        'name': 'Tai_Viet',
        'bmp': '\uAA80-\uAAC2\uAADB-\uAADF'
    },
    {
        'name': 'Takri',
        'astral': '\uD805[\uDE80-\uDEB8\uDEC0-\uDEC9]'
    },
    {
        'name': 'Tamil',
        'bmp': '\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BFA',
        'astral': '\uD807[\uDFC0-\uDFF1\uDFFF]'
    },
    {
        'name': 'Tangut',
        'astral': '\uD81B\uDFE0|[\uD81C-\uD820][\uDC00-\uDFFF]|\uD821[\uDC00-\uDFF7]|\uD822[\uDC00-\uDEFF]|\uD823[\uDD00-\uDD08]'
    },
    {
        'name': 'Telugu',
        'bmp': '\u0C00-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C77-\u0C7F'
    },
    {
        'name': 'Thaana',
        'bmp': '\u0780-\u07B1'
    },
    {
        'name': 'Thai',
        'bmp': '\u0E01-\u0E3A\u0E40-\u0E5B'
    },
    {
        'name': 'Tibetan',
        'bmp': '\u0F00-\u0F47\u0F49-\u0F6C\u0F71-\u0F97\u0F99-\u0FBC\u0FBE-\u0FCC\u0FCE-\u0FD4\u0FD9\u0FDA'
    },
    {
        'name': 'Tifinagh',
        'bmp': '\u2D30-\u2D67\u2D6F\u2D70\u2D7F'
    },
    {
        'name': 'Tirhuta',
        'astral': '\uD805[\uDC80-\uDCC7\uDCD0-\uDCD9]'
    },
    {
        'name': 'Ugaritic',
        'astral': '\uD800[\uDF80-\uDF9D\uDF9F]'
    },
    {
        'name': 'Vai',
        'bmp': '\uA500-\uA62B'
    },
    {
        'name': 'Wancho',
        'astral': '\uD838[\uDEC0-\uDEF9\uDEFF]'
    },
    {
        'name': 'Warang_Citi',
        'astral': '\uD806[\uDCA0-\uDCF2\uDCFF]'
    },
    {
        'name': 'Yezidi',
        'astral': '\uD803[\uDE80-\uDEA9\uDEAB-\uDEAD\uDEB0\uDEB1]'
    },
    {
        'name': 'Yi',
        'bmp': '\uA000-\uA48C\uA490-\uA4C6'
    },
    {
        'name': 'Zanabazar_Square',
        'astral': '\uD806[\uDE00-\uDE47]'
    }
];

var unicodeScripts = createCommonjsModule(function (module, exports) {





defineProperty$2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _scripts = interopRequireDefault(scripts);

/*!
 * XRegExp Unicode Scripts 4.4.1
 * <xregexp.com>
 * Steven Levithan (c) 2010-present MIT License
 * Unicode data by Mathias Bynens <mathiasbynens.be>
 */
var _default = function _default(XRegExp) {
  /**
   * Adds support for all Unicode scripts. E.g., `\p{Latin}`. Token names are case insensitive,
   * and any spaces, hyphens, and underscores are ignored.
   *
   * Uses Unicode 13.0.0.
   *
   * @requires XRegExp, Unicode Base
   */
  if (!XRegExp.addUnicodeData) {
    throw new ReferenceError('Unicode Base must be loaded before Unicode Scripts');
  }

  XRegExp.addUnicodeData(_scripts["default"]);
};

exports["default"] = _default;
module.exports = exports.default;
});

unwrapExports(unicodeScripts);

var lib = createCommonjsModule(function (module, exports) {





defineProperty$2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _xregexp = interopRequireDefault(xregexp);

var _build = interopRequireDefault(build);

var _matchrecursive = interopRequireDefault(matchrecursive);

var _unicodeBase = interopRequireDefault(unicodeBase);

var _unicodeBlocks = interopRequireDefault(unicodeBlocks);

var _unicodeCategories = interopRequireDefault(unicodeCategories);

var _unicodeProperties = interopRequireDefault(unicodeProperties);

var _unicodeScripts = interopRequireDefault(unicodeScripts);

(0, _build["default"])(_xregexp["default"]);
(0, _matchrecursive["default"])(_xregexp["default"]);
(0, _unicodeBase["default"])(_xregexp["default"]);
(0, _unicodeBlocks["default"])(_xregexp["default"]);
(0, _unicodeCategories["default"])(_xregexp["default"]);
(0, _unicodeProperties["default"])(_xregexp["default"]);
(0, _unicodeScripts["default"])(_xregexp["default"]);
var _default = _xregexp["default"];
exports["default"] = _default;
module.exports = exports.default;
});

var X = unwrapExports(lib);
var lib_1 = lib.OuterXRegExp;

// Dangerous pattern https://cs.chromium.org/chromium/src/components/url_formatter/url_formatter.cc?rcl=0&l=393
const dangerousPatterns = [
    /([^\\p{scx=kana}\\p{scx=hira}\\p{scx=hani}])/,
    /([\u30ce\u30f3\u30bd\u30be])/,
    /([^\\p{scx=kana}\\p{scx=hira}\\p{scx=hani}]|)/,
    /([^\\p{scx=kana}\\p{scx=hira}]\u30fc|^\u30fc|)/,
    /([^\\p{scx=kana}][\u30fd\u30fe]|^[\u30fd\u30fe]|)/,
    /(^[\\p{scx=kana}]+[\u3078-\u307a][\\p{scx=kana}]+$|)/,
    /(^[\\p{scx=hira}]+[\u30d8-\u30da][\\p{scx=hira}]+$|)/,
    /([a-z]\u30fb|\u30fb[a-z]|)/,
    /([^\\p{scx=latn}\\p{scx=grek}\\p{scx=cyrl}][\u0300-\u0339]|)/,
    /(\u0131[\u0300-\u0339]|)/,
    /([ijl]\u0307)/,
];

const deviation = /[\u00df\u03c2\u200c\u200d]/;
const nonAsciiLatin = /[\u0080–\u024f]/;
const kanaCharacterException = /[\u3078-\u307a\u30d8-\u30da\u30fb-\u30fe]/;
const combiningDiacriticException = /[\u0300-\u0339]/;
const cyrillicLikeLatin = /[асԁеһіјӏорԛѕԝхуъЬҽпгѵѡ]/;
// const scriptExtensionsInherited = '[\u200c-\u200d]'
const identifierStatusAllowed = '[\u0300-\u0339]';
const latinGreekCyrillicAscii = X(`([\\p{Latin}][\\p{Greek}][\\p{Cyrillic}][0-9\u002e_\u002d]${identifierStatusAllowed})`);
const recommended = X('[0-9A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u0131\\u0134-\\u013E\\u0141-\\u0148\\u014A-\\u017E\\u018F\\u01A0\\u01A1\\u01AF\\u01B0\\u01CD-\\u01DC\\u01DE-\\u01E3\\u01E6-\\u01F0\\u01F4\\u01F5\\u01F8-\\u021B\\u021E\\u021F\\u0226-\\u0233\\u0259\\u02BB\\u02BC\\u02EC\\u0300-\\u0304\\u0306-\\u030C\\u030F-\\u0311\\u0313\\u0314\\u031B\\u0323-\\u0328\\u032D\\u032E\\u0330\\u0331\\u0335\\u0338\\u0339\\u0342\\u0345\\u037B-\\u037D\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03CE\\u03FC-\\u045F\\u048A-\\u0529\\u052E\\u052F\\u0531-\\u0556\\u0559\\u0561-\\u0586\\u05B4\\u05D0-\\u05EA\\u05F0-\\u05F2\\u0620-\\u063F\\u0641-\\u0655\\u0660-\\u0669\\u0670-\\u0672\\u0674\\u0679-\\u068D\\u068F-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE-\\u06FC\\u06FF\\u0750-\\u07B1\\u08A0-\\u08AC\\u08B2\\u08B6-\\u08BD\\u0901-\\u094D\\u094F\\u0950\\u0956\\u0957\\u0960-\\u0963\\u0966-\\u096F\\u0971-\\u0977\\u0979-\\u097F\\u0981-\\u0983\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BC-\\u09C4\\u09C7\\u09C8\\u09CB-\\u09CE\\u09D7\\u09E0-\\u09E3\\u09E6-\\u09F1\\u0A01-\\u0A03\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A35\\u0A38\\u0A39\\u0A3C\\u0A3E-\\u0A42\\u0A47\\u0A48\\u0A4B-\\u0A4D\\u0A5C\\u0A66-\\u0A74\\u0A81-\\u0A83\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABC-\\u0AC5\\u0AC7-\\u0AC9\\u0ACB-\\u0ACD\\u0AD0\\u0AE0-\\u0AE3\\u0AE6-\\u0AEF\\u0B01-\\u0B03\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3C-\\u0B43\\u0B47\\u0B48\\u0B4B-\\u0B4D\\u0B56\\u0B57\\u0B5F-\\u0B61\\u0B66-\\u0B6F\\u0B71\\u0B82\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BBE-\\u0BC2\\u0BC6-\\u0BC8\\u0BCA-\\u0BCD\\u0BD0\\u0BD7\\u0BE6-\\u0BEF\\u0C01-\\u0C03\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C33\\u0C35-\\u0C39\\u0C3D-\\u0C44\\u0C46-\\u0C48\\u0C4A-\\u0C4D\\u0C55\\u0C56\\u0C60\\u0C61\\u0C66-\\u0C6F\\u0C80\\u0C82\\u0C83\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBC-\\u0CC4\\u0CC6-\\u0CC8\\u0CCA-\\u0CCD\\u0CD5\\u0CD6\\u0CE0-\\u0CE3\\u0CE6-\\u0CEF\\u0CF1\\u0CF2\\u0D02\\u0D03\\u0D05-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D-\\u0D43\\u0D46-\\u0D48\\u0D4A-\\u0D4E\\u0D54-\\u0D57\\u0D60\\u0D61\\u0D66-\\u0D6F\\u0D7A-\\u0D7F\\u0D82\\u0D83\\u0D85-\\u0D8E\\u0D91-\\u0D96\\u0D9A-\\u0DA5\\u0DA7-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0DCA\\u0DCF-\\u0DD4\\u0DD6\\u0DD8-\\u0DDE\\u0DF2\\u0E01-\\u0E32\\u0E34-\\u0E3A\\u0E40-\\u0E4E\\u0E50-\\u0E59\\u0E81\\u0E82\\u0E84\\u0E87\\u0E88\\u0E8A\\u0E8D\\u0E94-\\u0E97\\u0E99-\\u0E9F\\u0EA1-\\u0EA3\\u0EA5\\u0EA7\\u0EAA\\u0EAB\\u0EAD-\\u0EB2\\u0EB4-\\u0EB9\\u0EBB-\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EC8-\\u0ECD\\u0ED0-\\u0ED9\\u0EDE\\u0EDF\\u0F00\\u0F20-\\u0F29\\u0F35\\u0F37\\u0F3E-\\u0F42\\u0F44-\\u0F47\\u0F49-\\u0F4C\\u0F4E-\\u0F51\\u0F53-\\u0F56\\u0F58-\\u0F5B\\u0F5D-\\u0F68\\u0F6A-\\u0F6C\\u0F71\\u0F72\\u0F74\\u0F7A-\\u0F80\\u0F82-\\u0F84\\u0F86-\\u0F92\\u0F94-\\u0F97\\u0F99-\\u0F9C\\u0F9E-\\u0FA1\\u0FA3-\\u0FA6\\u0FA8-\\u0FAB\\u0FAD-\\u0FB8\\u0FBA-\\u0FBC\\u0FC6\\u1000-\\u1049\\u1050-\\u109D\\u10C7\\u10CD\\u10D0-\\u10F0\\u10F7-\\u10FA\\u10FD-\\u10FF\\u1200-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u135D-\\u135F\\u1380-\\u138F\\u1780-\\u17A2\\u17A5-\\u17A7\\u17A9-\\u17B3\\u17B6-\\u17CA\\u17D2\\u17D7\\u17DC\\u17E0-\\u17E9\\u1C80-\\u1C88\\u1E00-\\u1E99\\u1E9E\\u1EA0-\\u1EF9\\u1F00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F70\\u1F72\\u1F74\\u1F76\\u1F78\\u1F7A\\u1F7C\\u1F80-\\u1FB4\\u1FB6-\\u1FBA\\u1FBC\\u1FC2-\\u1FC4\\u1FC6-\\u1FC8\\u1FCA\\u1FCC\\u1FD0-\\u1FD2\\u1FD6-\\u1FDA\\u1FE0-\\u1FE2\\u1FE4-\\u1FEA\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FF8\\u1FFA\\u1FFC\\u2D27\\u2D2D\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u3005-\\u3007\\u3041-\\u3096\\u3099\\u309A\\u309D\\u309E\\u30A1-\\u30FA\\u30FC-\\u30FE\\u3105-\\u312D\\u31A0-\\u31BA\\u3400-\\u4DB5\\u4E00-\\u9FD5\\uA660\\uA661\\uA674-\\uA67B\\uA67F\\uA69F\\uA717-\\uA71F\\uA788\\uA78D\\uA78E\\uA790-\\uA793\\uA7A0-\\uA7AA\\uA7AE\\uA7FA\\uA9E7-\\uA9FE\\uAA60-\\uAA76\\uAA7A-\\uAA7F\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAC00-\\uD7A3\\uFA0E\\uFA0F\\uFA11\\uFA13\\uFA14\\uFA1F\\uFA21\\uFA23\\uFA24\\uFA27-\\uFA29\\u20000-\\u2A6D6\\u2A700-\\u2B734\\u2B740-\\u2B81D\\u2B820-\\u2CEA1]');
const inclusion = X("['\\-.\\:\\u00B7\\u0375\\u058A\\u05F3\\u05F4\\u06FD\\u06FE\\u0F0B\\u200C\\u200D\\u2010\\u2019\\u2027\\u30A0\\u30FB]");
const allowed = X.union([inclusion, recommended], 'i');
const removed = X('[\\u0338\\u058a\\u2010\\u2019\\u2027\\u30a0\\u02bb\\u02bc\\u0620\\u0F8C\\u0F8D\\u0F8E\\u0F8F\\u01CD-\\u01DC\\u1C80-\\u1C8F\\u1E00-\\u1E9B\\u1F00-\\u1FFF\\uA640-\\uA69F\\uA720-\\uA7FF]');

// import * as X from 'xregexp';
const inBasicLatin = X('\\p{InBasic_Latin}'); // U+0000–U+007F
const inLatin1Supplement = X('\\p{InLatin-1_Supplement}'); // U+0080–U+00FF
const inLatinExtendedA = X('\\p{InLatin_Extended-A}'); // U+0100–U+017F
const inLatinExtendedB = X('\\p{InLatin_Extended-B}'); // U+0180–U+024F
const inIpaExtensions = X('\\p{InIPA_Extensions}'); // U+0250–U+02AF
const inSpacingModifierLetters = X('\\p{InSpacing_Modifier_Letters}'); // U+02B0–U+02FF
const inCombiningDiacriticalMarks = X('\\p{InCombining_Diacritical_Marks}'); // U+0300–U+036F
const inGreekAndCoptic = X('\\p{InGreek_and_Coptic}'); // U+0370–U+03FF
const inCyrillic = X('\\p{InCyrillic}'); // U+0400–U+04FF
// export const inCyrillicSupplementary = X('\\p{InCyrillic_Supplementary}'); // U+0500–U+052F
const inArmenian = X('\\p{InArmenian}'); // U+0530–U+058F
const inHebrew = X('\\p{InHebrew}'); // U+0590–U+05FF
const inArabic = X('\\p{InArabic}'); // U+0600–U+06FF
const inSyriac = X('\\p{InSyriac}'); // U+0700–U+074F
const inThaana = X('\\p{InThaana}'); // U+0780–U+07BF
const inDevanagari = X('\\p{InDevanagari}'); // U+0900–U+097F
const inBengali = X('\\p{InBengali}'); // U+0980–U+09FF
const inGurmukhi = X('\\p{InGurmukhi}'); // U+0A00–U+0A7F
const inGujarati = X('\\p{InGujarati}'); // U+0A80–U+0AFF
const inOriya = X('\\p{InOriya}'); // U+0B00–U+0B7F
const inTamil = X('\\p{InTamil}'); // U+0B80–U+0BFF
const inTelugu = X('\\p{InTelugu}'); // U+0C00–U+0C7F
const inKannada = X('\\p{InKannada}'); // U+0C80–U+0CFF
const inMalayalam = X('\\p{InMalayalam}'); // U+0D00–U+0D7F
const inSinhala = X('\\p{InSinhala}'); // U+0D80–U+0DFF
const inThai = X('\\p{InThai}'); // U+0E00–U+0E7F
const inLao = X('\\p{InLao}'); // U+0E80–U+0EFF
const inTibetan = X('\\p{InTibetan}'); // U+0F00–U+0FFF
const inMyanmar = X('\\p{InMyanmar}'); // U+1000–U+109F
const inGeorgian = X('\\p{InGeorgian}'); // U+10A0–U+10FF
const inHangulJamo = X('\\p{InHangul_Jamo}'); // U+1100–U+11FF
const inEthiopic = X('\\p{InEthiopic}'); // U+1200–U+137F
const inCherokee = X('\\p{InCherokee}'); // U+13A0–U+13FF
const inUnifiedCanadianAboriginalSyllabics = X('\\p{InUnified_Canadian_Aboriginal_Syllabics}'); // U+1400–U+167F
const inOgham = X('\\p{InOgham}'); // U+1680–U+169F
const inRunic = X('\\p{InRunic}'); // U+16A0–U+16FF
const inTagalog = X('\\p{InTagalog}'); // U+1700–U+171F
const inHanunoo = X('\\p{InHanunoo}'); // U+1720–U+173F
const inBuhid = X('\\p{InBuhid}'); // U+1740–U+175F
const inTagbanwa = X('\\p{InTagbanwa}'); // U+1760–U+177F
const inKhmer = X('\\p{InKhmer}'); // U+1780–U+17FF
const inMongolian = X('\\p{InMongolian}'); // U+1800–U+18AF
const inLimbu = X('\\p{InLimbu}'); // U+1900–U+194F
const inTaiLe = X('\\p{InTai_Le}'); // U+1950–U+197F
const inKhmerSymbols = X('\\p{InKhmer_Symbols}'); // U+19E0–U+19FF
const inPhoneticExtensions = X('\\p{InPhonetic_Extensions}'); // U+1D00–U+1D7F
const inLatinExtendedAdditional = X('\\p{InLatin_Extended_Additional}'); // U+1E00–U+1EFF
const inGreekExtended = X('\\p{InGreek_Extended}'); // U+1F00–U+1FFF
const inGeneralPunctuation = X('\\p{InGeneral_Punctuation}'); // U+2000–U+206F
const inSuperscriptsAndSubscripts = X('\\p{InSuperscripts_and_Subscripts}'); // U+2070–U+209F
const inCurrencySymbols = X('\\p{InCurrency_Symbols}'); // U+20A0–U+20CF
const inCombiningDiacriticalMarksForSymbols = X('\\p{InCombining_Diacritical_Marks_for_Symbols}'); // U+20D0–U+20FF
const inLetterlikeSymbols = X('\\p{InLetterlike_Symbols}'); // U+2100–U+214F
const inNumberForms = X('\\p{InNumber_Forms}'); // U+2150–U+218F
const inArrows = X('\\p{InArrows}'); // U+2190–U+21FF
const inMathematicalOperators = X('\\p{InMathematical_Operators}'); // U+2200–U+22FF
const inMiscellaneousTechnical = X('\\p{InMiscellaneous_Technical}'); // U+2300–U+23FF
const inControlPictures = X('\\p{InControl_Pictures}'); // U+2400–U+243F
const inOpticalCharacterRecognition = X('\\p{InOptical_Character_Recognition}'); // U+2440–U+245F
const inEnclosedAlphanumerics = X('\\p{InEnclosed_Alphanumerics}'); // U+2460–U+24FF
const inBoxDrawing = X('\\p{InBox_Drawing}'); // U+2500–U+257F
const inBlockElements = X('\\p{InBlock_Elements}'); // U+2580–U+259F
const inGeometricShapes = X('\\p{InGeometric_Shapes}'); // U+25A0–U+25FF
const inMiscellaneousSymbols = X('\\p{InMiscellaneous_Symbols}'); // U+2600–U+26FF
const inDingbats = X('\\p{InDingbats}'); // U+2700–U+27BF
const inMiscellaneousMathematicalSymbolsA = X('\\p{InMiscellaneous_Mathematical_Symbols-A}'); // U+27C0–U+27EF
const inSupplementalArrowsA = X('\\p{InSupplemental_Arrows-A}'); // U+27F0–U+27FF
const inBraillePatterns = X('\\p{InBraille_Patterns}'); // U+2800–U+28FF
const inSupplementalArrowsB = X('\\p{InSupplemental_Arrows-B}'); // U+2900–U+297F
const inMiscellaneousMathematicalSymbolsB = X('\\p{InMiscellaneous_Mathematical_Symbols-B}'); // U+2980–U+29FF
const inSupplementalMathematicalOperators = X('\\p{InSupplemental_Mathematical_Operators}'); // U+2A00–U+2AFF
const inMiscellaneousSymbolsAndArrows = X('\\p{InMiscellaneous_Symbols_and_Arrows}'); // U+2B00–U+2BFF
const inCjkRadicalsSupplement = X('\\p{InCJK_Radicals_Supplement}'); // U+2E80–U+2EFF
const inKangxiRadicals = X('\\p{InKangxi_Radicals}'); // U+2F00–U+2FDF
const inIdeographicDescriptionCharacters = X('\\p{InIdeographic_Description_Characters}'); // U+2FF0–U+2FFF
const inCjkSymbolsAndPunctuation = X('\\p{InCJK_Symbols_and_Punctuation}'); // U+3000–U+303F
const inHiragana = X('\\p{InHiragana}'); // U+3040–U+309F
const inKatakana = X('\\p{InKatakana}'); // U+30A0–U+30FF
const inBopomofo = X('\\p{InBopomofo}'); // U+3100–U+312F
const inHangulCompatibilityJamo = X('\\p{InHangul_Compatibility_Jamo}'); // U+3130–U+318F
const inKanbun = X('\\p{InKanbun}'); // U+3190–U+319F
const inBopomofoExtended = X('\\p{InBopomofo_Extended}'); // U+31A0–U+31BF
const inKatakanaPhoneticExtensions = X('\\p{InKatakana_Phonetic_Extensions}'); // U+31F0–U+31FF
const inEnclosedCjkLettersAndMonths = X('\\p{InEnclosed_CJK_Letters_and_Months}'); // U+3200–U+32FF
const inCjkCompatibility = X('\\p{InCJK_Compatibility}'); // U+3300–U+33FF
const inCjkUnifiedIdeographsExtensionA = X('\\p{InCJK_Unified_Ideographs_Extension_A}'); // U+3400–U+4DBF
const inYijingHexagramSymbols = X('\\p{InYijing_Hexagram_Symbols}'); // U+4DC0–U+4DFF
const inCJKUnifiedIdeographs = X('\\p{InCJK_Unified_Ideographs}'); // U+4E00–U+9FFF
const inYiSyllables = X('\\p{InYi_Syllables}'); // U+A000–U+A48F
const inYiRadicals = X('\\p{InYi_Radicals}'); // U+A490–U+A4CF
const inHangulSyllables = X('\\p{InHangul_Syllables}'); // U+AC00–U+D7AF
const inHighSurrogates = X('\\p{InHigh_Surrogates}'); // U+D800–U+DB7F
const inHighPrivateUseSurrogates = X('\\p{InHigh_Private_Use_Surrogates}'); // U+DB80–U+DBFF
const inLowSurrogates = X('\\p{InLow_Surrogates}'); // U+DC00–U+DFFF
const inPrivateUseArea = X('\\p{InPrivate_Use_Area}'); // U+E000–U+F8FF
const inCjkCompatibilityIdeographs = X('\\p{InCJK_Compatibility_Ideographs}'); // U+F900–U+FAFF
const inAlphabeticPresentationForms = X('\\p{InAlphabetic_Presentation_Forms}'); // U+FB00–U+FB4F
const inArabicPresentationFormsA = X('\\p{InArabic_Presentation_Forms-A}'); // U+FB50–U+FDFF
const inVariationSelectors = X('\\p{InVariation_Selectors}'); // U+FE00–U+FE0F
const inCombiningHalfMarks = X('\\p{InCombining_Half_Marks}'); // U+FE20–U+FE2F
const inCjkCompatibilityForms = X('\\p{InCJK_Compatibility_Forms}'); // U+FE30–U+FE4F
const inSmallFormVariants = X('\\p{InSmall_Form_Variants}'); // U+FE50–U+FE6F
const inArabicPresentationFormsB = X('\\p{InArabic_Presentation_Forms-B}'); // U+FE70–U+FEFF
const inHalfwidthAndFullwidthForms = X('\\p{InHalfwidth_and_Fullwidth_Forms}'); // U+FF00–U+FFEF
const inSpecials = X('\\p{InSpecials}'); // U+FFF0–U+FFFF

var emojiRegex = () => {
	// https://mths.be/emoji
	return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764(?:\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?|\u200D(?:\uD83D\uDC8B\u200D)?)\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])|\uD83E\uDEF1\uD83C\uDFFF\u200D\uD83E\uDEF2)(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764(?:\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?|\u200D(?:\uD83D\uDC8B\u200D)?)\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])|\uD83E\uDEF1\uD83C\uDFFE\u200D\uD83E\uDEF2)(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764(?:\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?|\u200D(?:\uD83D\uDC8B\u200D)?)\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])|\uD83E\uDEF1\uD83C\uDFFD\u200D\uD83E\uDEF2)(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764(?:\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?|\u200D(?:\uD83D\uDC8B\u200D)?)\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])|\uD83E\uDEF1\uD83C\uDFFC\u200D\uD83E\uDEF2)(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764(?:\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?|\u200D(?:\uD83D\uDC8B\u200D)?)\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])|\uD83E\uDEF1\uD83C\uDFFB\u200D\uD83E\uDEF2)(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764(?:\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|[\u2695\u2696\u2708]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764(?:\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])))|\u200D(?:\u2764(?:\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?|\u200D(?:\uD83D\uDC8B\u200D)?)\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\u200D[\u2695\u2696\u2708])?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764(?:\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764(?:\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764(?:\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F?\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F?\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3C-\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83D\uDC41\uFE0F?\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83C\uDFF3\uFE0F?\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F?\u200D\u26A7|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDEF1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764(?:\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\u200D(?:\uD83D\uDD25|\uD83E\uDE79))|\uD83D\uDC41\uFE0F?|\uD83C\uDFF3\uFE0F?|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3C-\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F?\u20E3|\uD83E\uDD3C(?:\uD83C[\uDFFB-\uDFFF])|\u2764\uFE0F?|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF6])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD3C\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF6]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDDDE\uDDDF]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B50]|\uD83C[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDD-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC2\uDED0-\uDED9\uDEE0-\uDEE7]/g;
};

const letter = X('\\p{Letter}'); // any kind of letter from any language.
const lowercaseLetter = X('\\p{Lowercase_Letter}'); // a lowercase letter that has an uppercase variant.
const uppercaseLetter = X('\\p{Uppercase_Letter}'); // an uppercase letter that has a lowercase variant.
const titlecaseLetter = X('\\p{Titlecase_Letter}'); // a letter that appears at the start of a word when only the first letter of the word is capitalized.
const casedLetter = X('\\p{Cased_Letter}'); // a letter that exists in lowercase and uppercase variants (combination of Ll, Lu and Lt).
const modifiedLetter = X('\\p{Modifier_Letter}'); // a special character that is used like a letter.
const otherLetter = X('\\p{Other_Letter}'); // a letter or ideograph that does not have lowercase and uppercase variants.
const mark = X('\\p{Mark}'); // a character intended to be combined with another character (e.g. accents, umlauts, enclosing boxes, etc.).
const nonSpacingMark = X('\\p{Non_Spacing_Mark}'); // a character intended to be combined with another character without taking up extra space (e.g. accents, umlauts, etc.).
// export const spacingCombiningMark = X('\\p{Spacing_Combining_Mark}');  // a character intended to be combined with another character that takes up extra space (vowel signs in many Eastern languages).
const enclosingMark = X('\\p{Enclosing_Mark}'); // a character that encloses the character is is combined with (circle, square, keycap, etc.).
const separator = X('\\p{Separator}'); // any kind of whitespace or invisible separator.
const spaceSeparator = X('\\p{Space_Separator}'); // a whitespace character that is invisible, but does take up space.
const lineSeparator = X('\\p{Line_Separator}'); // line separator character U+2028.
const paragraphSeparator = X('\\p{Paragraph_Separator}'); // paragraph separator character U+2029.
const symbol$5 = X('\\p{Symbol}'); // math symbols, currency signs, dingbats, box-drawing characters, etc.
const mathSymbol = X('\\p{Math_Symbol}'); // any mathematical symbol.
const currencySymbol = X('\\p{Currency_Symbol}'); // any currency sign.
const modifierSymbol = X('\\p{Modifier_Symbol}'); // a combining character (mark) as a full character on its own.
const otherSymbol = X('\\p{Other_Symbol}'); // various symbols that are not math symbols, currency signs, or combining characters.
/* tslint:disable-next-line */
const number = X('\\p{Number}'); // any kind of numeric character in any script.
const decimalDigitNumber = X('\\p{Nd}'); // a digit zero through nine in any script except ideographic scripts.
const letterNumber = X('\\p{Letter_Number}'); // a number that looks like a letter, such as a Roman numeral.
const otherNumber = X('\\p{Other_Number}'); // a superscript or subscript digit, or a number that is not a digit 0–9 (excluding numbers from ideographic scripts).
const punctuation = X('\\p{Punctuation}'); // any kind of punctuation character.
const dashPunctuation = X('\\p{Dash_Punctuation}'); // any kind of hyphen or dash.
const openPunctuation = X('\\p{Open_Punctuation}'); // any kind of opening bracket.
const closePunctuation = X('\\p{Close_Punctuation}'); // any kind of closing bracket.
const initialPunctuation = X('\\p{Initial_Punctuation}'); // any kind of opening quote.
const finalPunctuation = X('\\p{Final_Punctuation}'); // any kind of closing quote.
const connectorPunctuation = X('\\p{Connector_Punctuation}'); // a punctuation character such as an underscore that connects words.
const otherPunctuation = X('\\p{Other_Punctuation}'); // any kind of punctuation character that is not a dash, bracket, quote or connector.
const other = X('\\p{Other}'); // invisible control characters and unused code points.
const control = X('\\p{Control}'); // an ASCII or Latin-1 control character: 0x00–0x1F and 0x7F–0x9F.
const format = X('\\p{Format}'); // invisible formatting indicator.
const privateUse = X('\\p{Private_Use}'); // any code point reserved for private use.
const surrogate = X('\\p{Surrogate}'); // one half of a surrogate pair in UTF-16 encoding.
const unassigned = X('\\p{Unassigned}'); // any code point to which no character has been assigned.
const emoji = X(emojiRegex());

const common = X('\\p{Common}');
const arabic = X('\\p{Arabic}');
const armenian = X('\\p{Armenian}');
const bengali = X('\\p{Bengali}');
const bopomofo = X('\\p{Bopomofo}');
const braille = X('\\p{Braille}');
const buhid = X('\\p{Buhid}');
const canadianAboriginal = X('\\p{Canadian_Aboriginal}');
const cherokee = X('\\p{Cherokee}');
const cyrillic = X('\\p{Cyrillic}');
const devanagari = X('\\p{Devanagari}');
const ethiopic = X('\\p{Ethiopic}');
const georgian = X('\\p{Georgian}');
const greek = X('\\p{Greek}');
const gujarati = X('\\p{Gujarati}');
const gurmukhi = X('\\p{Gurmukhi}');
const han = X('\\p{Han}');
const hangul = X('\\p{Hangul}');
const hanunoo = X('\\p{Hanunoo}');
const hebrew = X('\\p{Hebrew}');
const hiragana = X('\\p{Hiragana}');
const inherited = X('\\p{Inherited}');
const kannada = X('\\p{Kannada}');
const katakana = X('\\p{Katakana}');
const khmer = X('\\p{Khmer}');
const lao = X('\\p{Lao}');
const latin = X('\\p{Latin}');
const limbu = X('\\p{Limbu}');
const malayalam = X('\\p{Malayalam}');
const mongolian = X('\\p{Mongolian}');
const myanmar = X('\\p{Myanmar}');
const ogham = X('\\p{Ogham}');
const oriya = X('\\p{Oriya}');
const runic = X('\\p{Runic}');
const sinhala = X('\\p{Sinhala}');
const syriac = X('\\p{Syriac}');
const tagalog = X('\\p{Tagalog}');
const tagbanwa = X('\\p{Tagbanwa}');
const taile = X('\\p{TaiLe}');
const tamil = X('\\p{Tamil}');
const telugu = X('\\p{Telugu}');
const thaana = X('\\p{Thaana}');
const thai = X('\\p{Thai}');
const tibetan = X('\\p{Tibetan}');
const yi = X('\\p{Yi}');

var scripts$1 = /*#__PURE__*/Object.freeze({
  common: common,
  arabic: arabic,
  armenian: armenian,
  bengali: bengali,
  bopomofo: bopomofo,
  braille: braille,
  buhid: buhid,
  canadianAboriginal: canadianAboriginal,
  cherokee: cherokee,
  cyrillic: cyrillic,
  devanagari: devanagari,
  ethiopic: ethiopic,
  georgian: georgian,
  greek: greek,
  gujarati: gujarati,
  gurmukhi: gurmukhi,
  han: han,
  hangul: hangul,
  hanunoo: hanunoo,
  hebrew: hebrew,
  hiragana: hiragana,
  inherited: inherited,
  kannada: kannada,
  katakana: katakana,
  khmer: khmer,
  lao: lao,
  latin: latin,
  limbu: limbu,
  malayalam: malayalam,
  mongolian: mongolian,
  myanmar: myanmar,
  ogham: ogham,
  oriya: oriya,
  runic: runic,
  sinhala: sinhala,
  syriac: syriac,
  tagalog: tagalog,
  tagbanwa: tagbanwa,
  taile: taile,
  tamil: tamil,
  telugu: telugu,
  thaana: thaana,
  thai: thai,
  tibetan: tibetan,
  yi: yi
});

// https://www.regular-expressions.info/unicode.html

class ScriptResolver {
    constructor(url) {
        this.resolvedScripts = Object.entries(scripts$1)
            .filter(script => {
            return script[1].test(url);
        })
            .reduce((previousValue, currentValue) => {
            return Object.assign(Object.assign({}, previousValue), { [currentValue[0]]: true });
        }, {});
    }
    singleScript() {
        if (Object.keys(this.resolvedScripts).length === 1) {
            return true;
        }
        // any of these combinations are considered a "singleScript".
        const scriptCombinations = [
            // common, bopomofo, han
            ['common', 'bopomofo'],
            ['common', 'han'],
            ['common', 'bopomofo', 'han'],
            ['bopomofo', 'han'],
            // common, katakana, hiragana, katakana, han
            ['common', 'katakana'],
            ['common', 'hiragana'],
            ['common', 'katakana', 'hiragana'],
            ['katakana', 'hiragana'],
            ['common', 'han'],
            ['common', 'katakana', 'han'],
            ['katakana', 'han'],
            ['common', 'hiragana', 'han'],
            ['common', 'katakana', 'hiragana', 'han'],
            ['katakana', 'hiragana', 'han'],
            ['hiragana', 'han'],
            // common, han, hangul
            ['common', 'han'],
            ['common', 'hangul'],
            ['common', 'han', 'hangul'],
            ['han', 'hangul'],
        ];
        return scriptCombinations.some(combination => combination.every(scriptName => this.resolvedScripts.hasOwnProperty(scriptName)));
    }
}

class SpoofChecker {
    constructor() {
        this.status = ErrorCode.ZERO_ERROR;
        this.checks = SpoofChecks.ALL_CHECKS;
        this.restrictionLevel = RestrictionLevel.HIGHLY_RESTRICTIVE;
    }
    safeToDisplayAsUnicode(label, isTldAscii) {
        this.status = ErrorCode.ZERO_ERROR;
        // mask all emojis with a regular letter for the rest of the validation
        label = label.replace(emoji, 'a');
        let result = this.check(label);
        if (this.status > ErrorCode.ZERO_ERROR || result & SpoofChecks.ALL_CHECKS) {
            //console.log('Spoof check failuire');
            return false;
        }
        result &= RestrictionLevel.RESTRICTION_LEVEL_MASK;
        // deviation
        if (deviation.test(label)) {
            return false;
        }
        // ascii
        if (result === RestrictionLevel.ASCII) {
            return true;
        }
        // single script
        if (result === RestrictionLevel.SINGLE_SCRIPT_RESTRICTIVE &&
            !kanaCharacterException.test(label) &&
            !combiningDiacriticException.test(label)) {
            // Check Cyrillic confusable only for ASCII TLDs.
            return !isTldAscii || !this.isMadeOfLatinAlikeCyrillic(label);
        }
        if (nonAsciiLatin.test(label) && !latinGreekCyrillicAscii.test(label)) {
            return false;
        }
        return !dangerousPatterns.some(d => d.test(label));
    }
    check(input) {
        let result = 0;
        const checkResult = new CheckResult();
        if ((this.checks & SpoofChecks.RESTRICTION_LEVEL) !== 0) {
            const restrictionLevel = this.getRestrictionLevel(input);
            if (restrictionLevel > this.restrictionLevel) {
                result |= SpoofChecks.RESTRICTION_LEVEL;
            }
            checkResult.restrictionLevel = restrictionLevel;
        }
        if (0 !== (this.checks & SpoofChecks.MIXED_NUMBERS)) {
            // console.log('MIXED_NUMBERS', result)
            const numerics = this.getNumerics(input);
            if (numerics.length > 1) {
                result |= SpoofChecks.MIXED_NUMBERS;
            }
            checkResult.numerics = numerics;
        }
        if (0 !== (this.checks & SpoofChecks.CHAR_LIMIT)) {
            // console.log('CHAR_LIMIT', result);
            for (let i = 0; i < input.length;) {
                i++;
                if (!allowed.test(input[i])) {
                    result |= SpoofChecks.CHAR_LIMIT;
                    break;
                }
            }
        }
        if (0 !== (this.checks & SpoofChecks.INVISIBLE)) {
            // console.log('INVISIBLE', result);
            // This check needs to be done on NFD input
            const nfdText = input.normalize('NFD');
            const nfdLength = nfdText.length;
            // scan for more than one occurence of the same non-spacing mark
            // in a sequence of non-spacing marks.
            let i;
            let c;
            let firstNonspacingMark = 0;
            let haveMultipleMarks = false;
            let marksSeenSoFar = []; // Set of combining marks in a single combining sequence.
            for (i = 0; i < nfdLength;) {
                c = nfdText.charCodeAt(i);
                i++;
                if (!nonSpacingMark.test(nfdText[i])) {
                    firstNonspacingMark = 0;
                    if (haveMultipleMarks) {
                        marksSeenSoFar = [];
                        haveMultipleMarks = false;
                    }
                    continue;
                }
                if (firstNonspacingMark === 0) {
                    firstNonspacingMark = c;
                    continue;
                }
                if (!haveMultipleMarks) {
                    marksSeenSoFar.push(firstNonspacingMark);
                    haveMultipleMarks = true;
                }
                if (marksSeenSoFar.indexOf(c) > -1) {
                    // report the error, and stop scanning.
                    // No need to find more than the first failure.
                    result |= SpoofChecks.INVISIBLE;
                    break;
                }
                marksSeenSoFar.push(c);
            }
        }
        checkResult.checks = result;
        return checkResult.toCombinedBitmask(this.checks);
    }
    getRestrictionLevel(input) {
        if (!Array.from(input).every(character => allowed.test(character) && !removed.test(character))) {
            return RestrictionLevel.UNRESTRICTIVE;
        }
        let ascii = true;
        for (let i = 0; i < input.length; i++) {
            if (input.charCodeAt(i) > 0x7f) {
                ascii = false;
                break;
            }
        }
        if (ascii) {
            return RestrictionLevel.ASCII;
        }
        const scriptResolver = new ScriptResolver(input);
        if (scriptResolver.singleScript()) {
            return RestrictionLevel.SINGLE_SCRIPT_RESTRICTIVE;
        }
        else {
            return RestrictionLevel.HIGHLY_RESTRICTIVE;
        }
    }
    getNumerics(input) {
        const result = [];
        let charCode;
        for (let i = 0; i < input.length; i++) {
            charCode = input.charCodeAt(i);
            if (decimalDigitNumber.test(input[i])) {
                const zero = String.fromCharCode(charCode - parseInt(input[i], 16));
                if (result.includes(zero)) {
                    continue;
                }
                result.push(zero);
            }
        }
        return result;
    }
    isMadeOfLatinAlikeCyrillic(label) {
        const cyrillicInLabel = Array.from(label).filter(character => cyrillic.test(character));
        return (cyrillicInLabel.length > 0 &&
            cyrillicInLabel.every(character => {
                return cyrillicLikeLatin.test(character);
            }));
    }
}

var global$1 = (typeof global !== "undefined" ? global :
            typeof self !== "undefined" ? self :
            typeof window !== "undefined" ? window : {});

// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
var cachedSetTimeout = defaultSetTimout;
var cachedClearTimeout = defaultClearTimeout;
if (typeof global$1.setTimeout === 'function') {
    cachedSetTimeout = setTimeout;
}
if (typeof global$1.clearTimeout === 'function') {
    cachedClearTimeout = clearTimeout;
}

function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
function nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
}
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
var title = 'browser';
var platform = 'browser';
var browser = true;
var env = {};
var argv = [];
var version$2 = ''; // empty string to avoid regexp issues
var versions$1 = {};
var release = {};
var config = {};

function noop$1() {}

var on = noop$1;
var addListener = noop$1;
var once = noop$1;
var off = noop$1;
var removeListener = noop$1;
var removeAllListeners = noop$1;
var emit = noop$1;

function binding(name) {
    throw new Error('process.binding is not supported');
}

function cwd () { return '/' }
function chdir (dir) {
    throw new Error('process.chdir is not supported');
}function umask() { return 0; }

// from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var performance = global$1.performance || {};
var performanceNow =
  performance.now        ||
  performance.mozNow     ||
  performance.msNow      ||
  performance.oNow       ||
  performance.webkitNow  ||
  function(){ return (new Date()).getTime() };

// generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime
function hrtime(previousTimestamp){
  var clocktime = performanceNow.call(performance)*1e-3;
  var seconds = Math.floor(clocktime);
  var nanoseconds = Math.floor((clocktime%1)*1e9);
  if (previousTimestamp) {
    seconds = seconds - previousTimestamp[0];
    nanoseconds = nanoseconds - previousTimestamp[1];
    if (nanoseconds<0) {
      seconds--;
      nanoseconds += 1e9;
    }
  }
  return [seconds,nanoseconds]
}

var startTime = new Date();
function uptime() {
  var currentTime = new Date();
  var dif = currentTime - startTime;
  return dif / 1000;
}

var process$1 = {
  nextTick: nextTick,
  title: title,
  browser: browser,
  env: env,
  argv: argv,
  version: version$2,
  versions: versions$1,
  on: on,
  addListener: addListener,
  once: once,
  off: off,
  removeListener: removeListener,
  removeAllListeners: removeAllListeners,
  emit: emit,
  binding: binding,
  cwd: cwd,
  chdir: chdir,
  umask: umask,
  hrtime: hrtime,
  platform: platform,
  release: release,
  config: config,
  uptime: uptime
};

var sha3 = createCommonjsModule(function (module) {
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.9.3
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2023
 * @license MIT
 */
/*jslint bitwise: true */
(function () {

  var INPUT_ERROR = 'input is invalid type';
  var FINALIZE_ERROR = 'finalize already called';
  var WINDOW = typeof window === 'object';
  var root = WINDOW ? window : {};
  if (root.JS_SHA3_NO_WINDOW) {
    WINDOW = false;
  }
  var WEB_WORKER = !WINDOW && typeof self === 'object';
  var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof process$1 === 'object' && process$1.versions && process$1.versions.node;
  if (NODE_JS) {
    root = commonjsGlobal;
  } else if (WEB_WORKER) {
    root = self;
  }
  var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && 'object' === 'object' && module.exports;
  var AMD = typeof undefined === 'function' && undefined.amd;
  var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
  var HEX_CHARS = '0123456789abcdef'.split('');
  var SHAKE_PADDING = [31, 7936, 2031616, 520093696];
  var CSHAKE_PADDING = [4, 1024, 262144, 67108864];
  var KECCAK_PADDING = [1, 256, 65536, 16777216];
  var PADDING = [6, 1536, 393216, 100663296];
  var SHIFT = [0, 8, 16, 24];
  var RC = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649,
    0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0,
    2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771,
    2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648,
    2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];
  var BITS = [224, 256, 384, 512];
  var SHAKE_BITS = [128, 256];
  var OUTPUT_TYPES = ['hex', 'buffer', 'arrayBuffer', 'array', 'digest'];
  var CSHAKE_BYTEPAD = {
    '128': 168,
    '256': 136
  };


  var isArray = root.JS_SHA3_NO_NODE_JS || !Array.isArray
    ? function (obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
      }
    : Array.isArray;

  var isView = (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView))
    ? function (obj) {
        return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
      }
    : ArrayBuffer.isView;

  // [message: string, isString: bool]
  var formatMessage = function (message) {
    var type = typeof message;
    if (type === 'string') {
      return [message, true];
    }
    if (type !== 'object' || message === null) {
      throw new Error(INPUT_ERROR);
    }
    if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
      return [new Uint8Array(message), false];
    }
    if (!isArray(message) && !isView(message)) {
      throw new Error(INPUT_ERROR);
    }
    return [message, false];
  };

  var empty = function (message) {
    return formatMessage(message)[0].length === 0;
  };

  var cloneArray = function (array) {
    var newArray = [];
    for (var i = 0; i < array.length; ++i) {
      newArray[i] = array[i];
    }
    return newArray;
  };

  var createOutputMethod = function (bits, padding, outputType) {
    return function (message) {
      return new Keccak(bits, padding, bits).update(message)[outputType]();
    };
  };

  var createShakeOutputMethod = function (bits, padding, outputType) {
    return function (message, outputBits) {
      return new Keccak(bits, padding, outputBits).update(message)[outputType]();
    };
  };

  var createCshakeOutputMethod = function (bits, padding, outputType) {
    return function (message, outputBits, n, s) {
      return methods['cshake' + bits].update(message, outputBits, n, s)[outputType]();
    };
  };

  var createKmacOutputMethod = function (bits, padding, outputType) {
    return function (key, message, outputBits, s) {
      return methods['kmac' + bits].update(key, message, outputBits, s)[outputType]();
    };
  };

  var createOutputMethods = function (method, createMethod, bits, padding) {
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createMethod(bits, padding, type);
    }
    return method;
  };

  var createMethod = function (bits, padding) {
    var method = createOutputMethod(bits, padding, 'hex');
    method.create = function () {
      return new Keccak(bits, padding, bits);
    };
    method.update = function (message) {
      return method.create().update(message);
    };
    return createOutputMethods(method, createOutputMethod, bits, padding);
  };

  var createShakeMethod = function (bits, padding) {
    var method = createShakeOutputMethod(bits, padding, 'hex');
    method.create = function (outputBits) {
      return new Keccak(bits, padding, outputBits);
    };
    method.update = function (message, outputBits) {
      return method.create(outputBits).update(message);
    };
    return createOutputMethods(method, createShakeOutputMethod, bits, padding);
  };

  var createCshakeMethod = function (bits, padding) {
    var w = CSHAKE_BYTEPAD[bits];
    var method = createCshakeOutputMethod(bits, padding, 'hex');
    method.create = function (outputBits, n, s) {
      if (empty(n) && empty(s)) {
        return methods['shake' + bits].create(outputBits);
      } else {
        return new Keccak(bits, padding, outputBits).bytepad([n, s], w);
      }
    };
    method.update = function (message, outputBits, n, s) {
      return method.create(outputBits, n, s).update(message);
    };
    return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
  };

  var createKmacMethod = function (bits, padding) {
    var w = CSHAKE_BYTEPAD[bits];
    var method = createKmacOutputMethod(bits, padding, 'hex');
    method.create = function (key, outputBits, s) {
      return new Kmac(bits, padding, outputBits).bytepad(['KMAC', s], w).bytepad([key], w);
    };
    method.update = function (key, message, outputBits, s) {
      return method.create(key, outputBits, s).update(message);
    };
    return createOutputMethods(method, createKmacOutputMethod, bits, padding);
  };

  var algorithms = [
    { name: 'keccak', padding: KECCAK_PADDING, bits: BITS, createMethod: createMethod },
    { name: 'sha3', padding: PADDING, bits: BITS, createMethod: createMethod },
    { name: 'shake', padding: SHAKE_PADDING, bits: SHAKE_BITS, createMethod: createShakeMethod },
    { name: 'cshake', padding: CSHAKE_PADDING, bits: SHAKE_BITS, createMethod: createCshakeMethod },
    { name: 'kmac', padding: CSHAKE_PADDING, bits: SHAKE_BITS, createMethod: createKmacMethod }
  ];

  var methods = {}, methodNames = [];

  for (var i = 0; i < algorithms.length; ++i) {
    var algorithm = algorithms[i];
    var bits = algorithm.bits;
    for (var j = 0; j < bits.length; ++j) {
      var methodName = algorithm.name + '_' + bits[j];
      methodNames.push(methodName);
      methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
      if (algorithm.name !== 'sha3') {
        var newMethodName = algorithm.name + bits[j];
        methodNames.push(newMethodName);
        methods[newMethodName] = methods[methodName];
      }
    }
  }

  function Keccak(bits, padding, outputBits) {
    this.blocks = [];
    this.s = [];
    this.padding = padding;
    this.outputBits = outputBits;
    this.reset = true;
    this.finalized = false;
    this.block = 0;
    this.start = 0;
    this.blockCount = (1600 - (bits << 1)) >> 5;
    this.byteCount = this.blockCount << 2;
    this.outputBlocks = outputBits >> 5;
    this.extraBytes = (outputBits & 31) >> 3;

    for (var i = 0; i < 50; ++i) {
      this.s[i] = 0;
    }
  }

  Keccak.prototype.update = function (message) {
    if (this.finalized) {
      throw new Error(FINALIZE_ERROR);
    }
    var result = formatMessage(message);
    message = result[0];
    var isString = result[1];
    var blocks = this.blocks, byteCount = this.byteCount, length = message.length,
      blockCount = this.blockCount, index = 0, s = this.s, i, code;

    while (index < length) {
      if (this.reset) {
        this.reset = false;
        blocks[0] = this.block;
        for (i = 1; i < blockCount + 1; ++i) {
          blocks[i] = 0;
        }
      }
      if (isString) {
        for (i = this.start; index < length && i < byteCount; ++index) {
          code = message.charCodeAt(index);
          if (code < 0x80) {
            blocks[i >> 2] |= code << SHIFT[i++ & 3];
          } else if (code < 0x800) {
            blocks[i >> 2] |= (0xc0 | (code >> 6)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else if (code < 0xd800 || code >= 0xe000) {
            blocks[i >> 2] |= (0xe0 | (code >> 12)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else {
            code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
            blocks[i >> 2] |= (0xf0 | (code >> 18)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 12) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          }
        }
      } else {
        for (i = this.start; index < length && i < byteCount; ++index) {
          blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
        }
      }
      this.lastByteIndex = i;
      if (i >= byteCount) {
        this.start = i - byteCount;
        this.block = blocks[blockCount];
        for (i = 0; i < blockCount; ++i) {
          s[i] ^= blocks[i];
        }
        f(s);
        this.reset = true;
      } else {
        this.start = i;
      }
    }
    return this;
  };

  Keccak.prototype.encode = function (x, right) {
    var o = x & 255, n = 1;
    var bytes = [o];
    x = x >> 8;
    o = x & 255;
    while (o > 0) {
      bytes.unshift(o);
      x = x >> 8;
      o = x & 255;
      ++n;
    }
    if (right) {
      bytes.push(n);
    } else {
      bytes.unshift(n);
    }
    this.update(bytes);
    return bytes.length;
  };

  Keccak.prototype.encodeString = function (str) {
    var result = formatMessage(str);
    str = result[0];
    var isString = result[1];
    var bytes = 0, length = str.length;
    if (isString) {
      for (var i = 0; i < str.length; ++i) {
        var code = str.charCodeAt(i);
        if (code < 0x80) {
          bytes += 1;
        } else if (code < 0x800) {
          bytes += 2;
        } else if (code < 0xd800 || code >= 0xe000) {
          bytes += 3;
        } else {
          code = 0x10000 + (((code & 0x3ff) << 10) | (str.charCodeAt(++i) & 0x3ff));
          bytes += 4;
        }
      }
    } else {
      bytes = length;
    }
    bytes += this.encode(bytes * 8);
    this.update(str);
    return bytes;
  };

  Keccak.prototype.bytepad = function (strs, w) {
    var bytes = this.encode(w);
    for (var i = 0; i < strs.length; ++i) {
      bytes += this.encodeString(strs[i]);
    }
    var paddingBytes = (w - bytes % w) % w;
    var zeros = [];
    zeros.length = paddingBytes;
    this.update(zeros);
    return this;
  };

  Keccak.prototype.finalize = function () {
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
    blocks[i >> 2] |= this.padding[i & 3];
    if (this.lastByteIndex === this.byteCount) {
      blocks[0] = blocks[blockCount];
      for (i = 1; i < blockCount + 1; ++i) {
        blocks[i] = 0;
      }
    }
    blocks[blockCount - 1] |= 0x80000000;
    for (i = 0; i < blockCount; ++i) {
      s[i] ^= blocks[i];
    }
    f(s);
  };

  Keccak.prototype.toString = Keccak.prototype.hex = function () {
    this.finalize();

    var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks,
      extraBytes = this.extraBytes, i = 0, j = 0;
    var hex = '', block;
    while (j < outputBlocks) {
      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
        block = s[i];
        hex += HEX_CHARS[(block >> 4) & 0x0F] + HEX_CHARS[block & 0x0F] +
          HEX_CHARS[(block >> 12) & 0x0F] + HEX_CHARS[(block >> 8) & 0x0F] +
          HEX_CHARS[(block >> 20) & 0x0F] + HEX_CHARS[(block >> 16) & 0x0F] +
          HEX_CHARS[(block >> 28) & 0x0F] + HEX_CHARS[(block >> 24) & 0x0F];
      }
      if (j % blockCount === 0) {
        s = cloneArray(s);
        f(s);
        i = 0;
      }
    }
    if (extraBytes) {
      block = s[i];
      hex += HEX_CHARS[(block >> 4) & 0x0F] + HEX_CHARS[block & 0x0F];
      if (extraBytes > 1) {
        hex += HEX_CHARS[(block >> 12) & 0x0F] + HEX_CHARS[(block >> 8) & 0x0F];
      }
      if (extraBytes > 2) {
        hex += HEX_CHARS[(block >> 20) & 0x0F] + HEX_CHARS[(block >> 16) & 0x0F];
      }
    }
    return hex;
  };

  Keccak.prototype.arrayBuffer = function () {
    this.finalize();

    var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks,
      extraBytes = this.extraBytes, i = 0, j = 0;
    var bytes = this.outputBits >> 3;
    var buffer;
    if (extraBytes) {
      buffer = new ArrayBuffer((outputBlocks + 1) << 2);
    } else {
      buffer = new ArrayBuffer(bytes);
    }
    var array = new Uint32Array(buffer);
    while (j < outputBlocks) {
      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
        array[j] = s[i];
      }
      if (j % blockCount === 0) {
        s = cloneArray(s);
        f(s);
      }
    }
    if (extraBytes) {
      array[j] = s[i];
      buffer = buffer.slice(0, bytes);
    }
    return buffer;
  };

  Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;

  Keccak.prototype.digest = Keccak.prototype.array = function () {
    this.finalize();

    var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks,
      extraBytes = this.extraBytes, i = 0, j = 0;
    var array = [], offset, block;
    while (j < outputBlocks) {
      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
        offset = j << 2;
        block = s[i];
        array[offset] = block & 0xFF;
        array[offset + 1] = (block >> 8) & 0xFF;
        array[offset + 2] = (block >> 16) & 0xFF;
        array[offset + 3] = (block >> 24) & 0xFF;
      }
      if (j % blockCount === 0) {
        s = cloneArray(s);
        f(s);
      }
    }
    if (extraBytes) {
      offset = j << 2;
      block = s[i];
      array[offset] = block & 0xFF;
      if (extraBytes > 1) {
        array[offset + 1] = (block >> 8) & 0xFF;
      }
      if (extraBytes > 2) {
        array[offset + 2] = (block >> 16) & 0xFF;
      }
    }
    return array;
  };

  function Kmac(bits, padding, outputBits) {
    Keccak.call(this, bits, padding, outputBits);
  }

  Kmac.prototype = new Keccak();

  Kmac.prototype.finalize = function () {
    this.encode(this.outputBits, true);
    return Keccak.prototype.finalize.call(this);
  };

  var f = function (s) {
    var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9,
      b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17,
      b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33,
      b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
    for (n = 0; n < 48; n += 2) {
      c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
      c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
      c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
      c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
      c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
      c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
      c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
      c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
      c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
      c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];

      h = c8 ^ ((c2 << 1) | (c3 >>> 31));
      l = c9 ^ ((c3 << 1) | (c2 >>> 31));
      s[0] ^= h;
      s[1] ^= l;
      s[10] ^= h;
      s[11] ^= l;
      s[20] ^= h;
      s[21] ^= l;
      s[30] ^= h;
      s[31] ^= l;
      s[40] ^= h;
      s[41] ^= l;
      h = c0 ^ ((c4 << 1) | (c5 >>> 31));
      l = c1 ^ ((c5 << 1) | (c4 >>> 31));
      s[2] ^= h;
      s[3] ^= l;
      s[12] ^= h;
      s[13] ^= l;
      s[22] ^= h;
      s[23] ^= l;
      s[32] ^= h;
      s[33] ^= l;
      s[42] ^= h;
      s[43] ^= l;
      h = c2 ^ ((c6 << 1) | (c7 >>> 31));
      l = c3 ^ ((c7 << 1) | (c6 >>> 31));
      s[4] ^= h;
      s[5] ^= l;
      s[14] ^= h;
      s[15] ^= l;
      s[24] ^= h;
      s[25] ^= l;
      s[34] ^= h;
      s[35] ^= l;
      s[44] ^= h;
      s[45] ^= l;
      h = c4 ^ ((c8 << 1) | (c9 >>> 31));
      l = c5 ^ ((c9 << 1) | (c8 >>> 31));
      s[6] ^= h;
      s[7] ^= l;
      s[16] ^= h;
      s[17] ^= l;
      s[26] ^= h;
      s[27] ^= l;
      s[36] ^= h;
      s[37] ^= l;
      s[46] ^= h;
      s[47] ^= l;
      h = c6 ^ ((c0 << 1) | (c1 >>> 31));
      l = c7 ^ ((c1 << 1) | (c0 >>> 31));
      s[8] ^= h;
      s[9] ^= l;
      s[18] ^= h;
      s[19] ^= l;
      s[28] ^= h;
      s[29] ^= l;
      s[38] ^= h;
      s[39] ^= l;
      s[48] ^= h;
      s[49] ^= l;

      b0 = s[0];
      b1 = s[1];
      b32 = (s[11] << 4) | (s[10] >>> 28);
      b33 = (s[10] << 4) | (s[11] >>> 28);
      b14 = (s[20] << 3) | (s[21] >>> 29);
      b15 = (s[21] << 3) | (s[20] >>> 29);
      b46 = (s[31] << 9) | (s[30] >>> 23);
      b47 = (s[30] << 9) | (s[31] >>> 23);
      b28 = (s[40] << 18) | (s[41] >>> 14);
      b29 = (s[41] << 18) | (s[40] >>> 14);
      b20 = (s[2] << 1) | (s[3] >>> 31);
      b21 = (s[3] << 1) | (s[2] >>> 31);
      b2 = (s[13] << 12) | (s[12] >>> 20);
      b3 = (s[12] << 12) | (s[13] >>> 20);
      b34 = (s[22] << 10) | (s[23] >>> 22);
      b35 = (s[23] << 10) | (s[22] >>> 22);
      b16 = (s[33] << 13) | (s[32] >>> 19);
      b17 = (s[32] << 13) | (s[33] >>> 19);
      b48 = (s[42] << 2) | (s[43] >>> 30);
      b49 = (s[43] << 2) | (s[42] >>> 30);
      b40 = (s[5] << 30) | (s[4] >>> 2);
      b41 = (s[4] << 30) | (s[5] >>> 2);
      b22 = (s[14] << 6) | (s[15] >>> 26);
      b23 = (s[15] << 6) | (s[14] >>> 26);
      b4 = (s[25] << 11) | (s[24] >>> 21);
      b5 = (s[24] << 11) | (s[25] >>> 21);
      b36 = (s[34] << 15) | (s[35] >>> 17);
      b37 = (s[35] << 15) | (s[34] >>> 17);
      b18 = (s[45] << 29) | (s[44] >>> 3);
      b19 = (s[44] << 29) | (s[45] >>> 3);
      b10 = (s[6] << 28) | (s[7] >>> 4);
      b11 = (s[7] << 28) | (s[6] >>> 4);
      b42 = (s[17] << 23) | (s[16] >>> 9);
      b43 = (s[16] << 23) | (s[17] >>> 9);
      b24 = (s[26] << 25) | (s[27] >>> 7);
      b25 = (s[27] << 25) | (s[26] >>> 7);
      b6 = (s[36] << 21) | (s[37] >>> 11);
      b7 = (s[37] << 21) | (s[36] >>> 11);
      b38 = (s[47] << 24) | (s[46] >>> 8);
      b39 = (s[46] << 24) | (s[47] >>> 8);
      b30 = (s[8] << 27) | (s[9] >>> 5);
      b31 = (s[9] << 27) | (s[8] >>> 5);
      b12 = (s[18] << 20) | (s[19] >>> 12);
      b13 = (s[19] << 20) | (s[18] >>> 12);
      b44 = (s[29] << 7) | (s[28] >>> 25);
      b45 = (s[28] << 7) | (s[29] >>> 25);
      b26 = (s[38] << 8) | (s[39] >>> 24);
      b27 = (s[39] << 8) | (s[38] >>> 24);
      b8 = (s[48] << 14) | (s[49] >>> 18);
      b9 = (s[49] << 14) | (s[48] >>> 18);

      s[0] = b0 ^ (~b2 & b4);
      s[1] = b1 ^ (~b3 & b5);
      s[10] = b10 ^ (~b12 & b14);
      s[11] = b11 ^ (~b13 & b15);
      s[20] = b20 ^ (~b22 & b24);
      s[21] = b21 ^ (~b23 & b25);
      s[30] = b30 ^ (~b32 & b34);
      s[31] = b31 ^ (~b33 & b35);
      s[40] = b40 ^ (~b42 & b44);
      s[41] = b41 ^ (~b43 & b45);
      s[2] = b2 ^ (~b4 & b6);
      s[3] = b3 ^ (~b5 & b7);
      s[12] = b12 ^ (~b14 & b16);
      s[13] = b13 ^ (~b15 & b17);
      s[22] = b22 ^ (~b24 & b26);
      s[23] = b23 ^ (~b25 & b27);
      s[32] = b32 ^ (~b34 & b36);
      s[33] = b33 ^ (~b35 & b37);
      s[42] = b42 ^ (~b44 & b46);
      s[43] = b43 ^ (~b45 & b47);
      s[4] = b4 ^ (~b6 & b8);
      s[5] = b5 ^ (~b7 & b9);
      s[14] = b14 ^ (~b16 & b18);
      s[15] = b15 ^ (~b17 & b19);
      s[24] = b24 ^ (~b26 & b28);
      s[25] = b25 ^ (~b27 & b29);
      s[34] = b34 ^ (~b36 & b38);
      s[35] = b35 ^ (~b37 & b39);
      s[44] = b44 ^ (~b46 & b48);
      s[45] = b45 ^ (~b47 & b49);
      s[6] = b6 ^ (~b8 & b0);
      s[7] = b7 ^ (~b9 & b1);
      s[16] = b16 ^ (~b18 & b10);
      s[17] = b17 ^ (~b19 & b11);
      s[26] = b26 ^ (~b28 & b20);
      s[27] = b27 ^ (~b29 & b21);
      s[36] = b36 ^ (~b38 & b30);
      s[37] = b37 ^ (~b39 & b31);
      s[46] = b46 ^ (~b48 & b40);
      s[47] = b47 ^ (~b49 & b41);
      s[8] = b8 ^ (~b0 & b2);
      s[9] = b9 ^ (~b1 & b3);
      s[18] = b18 ^ (~b10 & b12);
      s[19] = b19 ^ (~b11 & b13);
      s[28] = b28 ^ (~b20 & b22);
      s[29] = b29 ^ (~b21 & b23);
      s[38] = b38 ^ (~b30 & b32);
      s[39] = b39 ^ (~b31 & b33);
      s[48] = b48 ^ (~b40 & b42);
      s[49] = b49 ^ (~b41 & b43);

      s[0] ^= RC[n];
      s[1] ^= RC[n + 1];
    }
  };

  if (COMMON_JS) {
    module.exports = methods;
  } else {
    for (i = 0; i < methodNames.length; ++i) {
      root[methodNames[i]] = methods[methodNames[i]];
    }
    if (AMD) {
      undefined(function () {
        return methods;
      });
    }
  }
})();
});

var SortedRangeList_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Represents a sorted list of ranges.
 */
class SortedRangeList {
    constructor() {
        this._items = [];
    }
    /**
     * Adds a new range of values.
     *
     * @param min - minimum value
     * @param max - maximum value
     * @param value - value
     */
    add(min, max, value) {
        this._items.push([min, max, value]);
    }
    /**
     * Gets a value.
     *
     * @param key - a key
     */
    get(key) {
        return this._binarySearch(key, 0, this._items.length - 1);
    }
    /**
     * Binary searches a key between the given array indices.
     *
     * @param key - a key
     */
    _binarySearch(key, left, right) {
        if (key < this._items[left][0]) {
            return undefined;
        }
        else if (key > this._items[right][1]) {
            return undefined;
        }
        else if (left === right) {
            return this._items[left][2];
        }
        else {
            const mid = Math.floor((left + right) / 2);
            const itemMid = this._items[mid];
            if (key < itemMid[0]) {
                return this._binarySearch(key, left, mid - 1);
            }
            else if (key > itemMid[1]) {
                return this._binarySearch(key, mid + 1, right);
            }
            else {
                return this._binarySearch(key, mid, mid);
            }
        }
    }
}
exports.SortedRangeList = SortedRangeList;

});

unwrapExports(SortedRangeList_1);
var SortedRangeList_2 = SortedRangeList_1.SortedRangeList;

var IDNAMappingTable_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

var Status;
(function (Status) {
    Status[Status["Valid"] = 0] = "Valid";
    Status[Status["Ignored"] = 1] = "Ignored";
    Status[Status["Mapped"] = 2] = "Mapped";
    Status[Status["Deviation"] = 3] = "Deviation";
    Status[Status["Disallowed"] = 4] = "Disallowed";
    Status[Status["DisallowedSTD3Valid"] = 5] = "DisallowedSTD3Valid";
    Status[Status["DisallowedSTD3Mapped"] = 6] = "DisallowedSTD3Mapped";
})(Status = exports.Status || (exports.Status = {}));
var IDNA2008Status;
(function (IDNA2008Status) {
    IDNA2008Status[IDNA2008Status["None"] = 0] = "None";
    IDNA2008Status[IDNA2008Status["NV8"] = 1] = "NV8";
    IDNA2008Status[IDNA2008Status["XV8"] = 2] = "XV8";
})(IDNA2008Status = exports.IDNA2008Status || (exports.IDNA2008Status = {}));
/**
 * Contains lookup values from the:
 * http://www.unicode.org/reports/tr46
 * Version: 12.1.0
 * Date: 2019-04-01, 09:17:25 GMT
 */
class IDNAMappingTable {
    /**
     * Initializes a new `IDNAMappingTable`.
     */
    constructor() {
        this._table = new SortedRangeList_1.SortedRangeList();
        this._tableInit = false;
    }
    /**
     * Gets the `IDNAMappingTable` instance.
     */
    static get instance() {
        if (IDNAMappingTable._instance === undefined) {
            IDNAMappingTable._instance = new IDNAMappingTable();
        }
        return IDNAMappingTable._instance;
    }
    /**
     * Gets a value from the lookup table.
     */
    get(key) {
        this._init();
        const item = this._table.get(key);
        if (item === undefined) {
            throw new Error(`Code point: ${key} not found in IDNA Mapping table.`);
        }
        return item;
    }
    /**
     * Initializes the lookup table.
     */
    _init() {
        if (this._tableInit)
            return;
        this._populate1(this._table);
        this._populate2(this._table);
        this._tableInit = true;
    }
    /**
     * Initializes the lookup table.
     */
    _populate1(t) {
        t.add(0x0, 0x2c, [5, [], 0]);
        t.add(0x2d, 0x2e, [0, [], 0]);
        t.add(0x2f, 0x2f, [5, [], 0]);
        t.add(0x30, 0x39, [0, [], 0]);
        t.add(0x3a, 0x40, [5, [], 0]);
        t.add(0x41, 0x41, [2, [0x0061], 0]);
        t.add(0x42, 0x42, [2, [0x0062], 0]);
        t.add(0x43, 0x43, [2, [0x0063], 0]);
        t.add(0x44, 0x44, [2, [0x0064], 0]);
        t.add(0x45, 0x45, [2, [0x0065], 0]);
        t.add(0x46, 0x46, [2, [0x0066], 0]);
        t.add(0x47, 0x47, [2, [0x0067], 0]);
        t.add(0x48, 0x48, [2, [0x0068], 0]);
        t.add(0x49, 0x49, [2, [0x0069], 0]);
        t.add(0x4a, 0x4a, [2, [0x006A], 0]);
        t.add(0x4b, 0x4b, [2, [0x006B], 0]);
        t.add(0x4c, 0x4c, [2, [0x006C], 0]);
        t.add(0x4d, 0x4d, [2, [0x006D], 0]);
        t.add(0x4e, 0x4e, [2, [0x006E], 0]);
        t.add(0x4f, 0x4f, [2, [0x006F], 0]);
        t.add(0x50, 0x50, [2, [0x0070], 0]);
        t.add(0x51, 0x51, [2, [0x0071], 0]);
        t.add(0x52, 0x52, [2, [0x0072], 0]);
        t.add(0x53, 0x53, [2, [0x0073], 0]);
        t.add(0x54, 0x54, [2, [0x0074], 0]);
        t.add(0x55, 0x55, [2, [0x0075], 0]);
        t.add(0x56, 0x56, [2, [0x0076], 0]);
        t.add(0x57, 0x57, [2, [0x0077], 0]);
        t.add(0x58, 0x58, [2, [0x0078], 0]);
        t.add(0x59, 0x59, [2, [0x0079], 0]);
        t.add(0x5a, 0x5a, [2, [0x007A], 0]);
        t.add(0x5b, 0x60, [5, [], 0]);
        t.add(0x61, 0x7a, [0, [], 0]);
        t.add(0x7b, 0x7f, [5, [], 0]);
        t.add(0x80, 0x9f, [4, [], 0]);
        t.add(0xa0, 0xa0, [6, [0x0020], 0]);
        t.add(0xa1, 0xa7, [0, [], 1]);
        t.add(0xa8, 0xa8, [6, [0x0020, 0x0308], 0]);
        t.add(0xa9, 0xa9, [0, [], 1]);
        t.add(0xaa, 0xaa, [2, [0x0061], 0]);
        t.add(0xab, 0xac, [0, [], 1]);
        t.add(0xad, 0xad, [1, [], 0]);
        t.add(0xae, 0xae, [0, [], 1]);
        t.add(0xaf, 0xaf, [6, [0x0020, 0x0304], 0]);
        t.add(0xb0, 0xb1, [0, [], 1]);
        t.add(0xb2, 0xb2, [2, [0x0032], 0]);
        t.add(0xb3, 0xb3, [2, [0x0033], 0]);
        t.add(0xb4, 0xb4, [6, [0x0020, 0x0301], 0]);
        t.add(0xb5, 0xb5, [2, [0x03BC], 0]);
        t.add(0xb6, 0xb6, [0, [], 1]);
        t.add(0xb7, 0xb7, [0, [], 0]);
        t.add(0xb8, 0xb8, [6, [0x0020, 0x0327], 0]);
        t.add(0xb9, 0xb9, [2, [0x0031], 0]);
        t.add(0xba, 0xba, [2, [0x006F], 0]);
        t.add(0xbb, 0xbb, [0, [], 1]);
        t.add(0xbc, 0xbc, [2, [0x0031, 0x2044, 0x0034], 0]);
        t.add(0xbd, 0xbd, [2, [0x0031, 0x2044, 0x0032], 0]);
        t.add(0xbe, 0xbe, [2, [0x0033, 0x2044, 0x0034], 0]);
        t.add(0xbf, 0xbf, [0, [], 1]);
        t.add(0xc0, 0xc0, [2, [0x00E0], 0]);
        t.add(0xc1, 0xc1, [2, [0x00E1], 0]);
        t.add(0xc2, 0xc2, [2, [0x00E2], 0]);
        t.add(0xc3, 0xc3, [2, [0x00E3], 0]);
        t.add(0xc4, 0xc4, [2, [0x00E4], 0]);
        t.add(0xc5, 0xc5, [2, [0x00E5], 0]);
        t.add(0xc6, 0xc6, [2, [0x00E6], 0]);
        t.add(0xc7, 0xc7, [2, [0x00E7], 0]);
        t.add(0xc8, 0xc8, [2, [0x00E8], 0]);
        t.add(0xc9, 0xc9, [2, [0x00E9], 0]);
        t.add(0xca, 0xca, [2, [0x00EA], 0]);
        t.add(0xcb, 0xcb, [2, [0x00EB], 0]);
        t.add(0xcc, 0xcc, [2, [0x00EC], 0]);
        t.add(0xcd, 0xcd, [2, [0x00ED], 0]);
        t.add(0xce, 0xce, [2, [0x00EE], 0]);
        t.add(0xcf, 0xcf, [2, [0x00EF], 0]);
        t.add(0xd0, 0xd0, [2, [0x00F0], 0]);
        t.add(0xd1, 0xd1, [2, [0x00F1], 0]);
        t.add(0xd2, 0xd2, [2, [0x00F2], 0]);
        t.add(0xd3, 0xd3, [2, [0x00F3], 0]);
        t.add(0xd4, 0xd4, [2, [0x00F4], 0]);
        t.add(0xd5, 0xd5, [2, [0x00F5], 0]);
        t.add(0xd6, 0xd6, [2, [0x00F6], 0]);
        t.add(0xd7, 0xd7, [0, [], 1]);
        t.add(0xd8, 0xd8, [2, [0x00F8], 0]);
        t.add(0xd9, 0xd9, [2, [0x00F9], 0]);
        t.add(0xda, 0xda, [2, [0x00FA], 0]);
        t.add(0xdb, 0xdb, [2, [0x00FB], 0]);
        t.add(0xdc, 0xdc, [2, [0x00FC], 0]);
        t.add(0xdd, 0xdd, [2, [0x00FD], 0]);
        t.add(0xde, 0xde, [2, [0x00FE], 0]);
        t.add(0xdf, 0xdf, [3, [0x0073, 0x0073], 0]);
        t.add(0xe0, 0xf6, [0, [], 0]);
        t.add(0xf7, 0xf7, [0, [], 1]);
        t.add(0xf8, 0xff, [0, [], 0]);
        t.add(0x100, 0x100, [2, [0x0101], 0]);
        t.add(0x101, 0x101, [0, [], 0]);
        t.add(0x102, 0x102, [2, [0x0103], 0]);
        t.add(0x103, 0x103, [0, [], 0]);
        t.add(0x104, 0x104, [2, [0x0105], 0]);
        t.add(0x105, 0x105, [0, [], 0]);
        t.add(0x106, 0x106, [2, [0x0107], 0]);
        t.add(0x107, 0x107, [0, [], 0]);
        t.add(0x108, 0x108, [2, [0x0109], 0]);
        t.add(0x109, 0x109, [0, [], 0]);
        t.add(0x10a, 0x10a, [2, [0x010B], 0]);
        t.add(0x10b, 0x10b, [0, [], 0]);
        t.add(0x10c, 0x10c, [2, [0x010D], 0]);
        t.add(0x10d, 0x10d, [0, [], 0]);
        t.add(0x10e, 0x10e, [2, [0x010F], 0]);
        t.add(0x10f, 0x10f, [0, [], 0]);
        t.add(0x110, 0x110, [2, [0x0111], 0]);
        t.add(0x111, 0x111, [0, [], 0]);
        t.add(0x112, 0x112, [2, [0x0113], 0]);
        t.add(0x113, 0x113, [0, [], 0]);
        t.add(0x114, 0x114, [2, [0x0115], 0]);
        t.add(0x115, 0x115, [0, [], 0]);
        t.add(0x116, 0x116, [2, [0x0117], 0]);
        t.add(0x117, 0x117, [0, [], 0]);
        t.add(0x118, 0x118, [2, [0x0119], 0]);
        t.add(0x119, 0x119, [0, [], 0]);
        t.add(0x11a, 0x11a, [2, [0x011B], 0]);
        t.add(0x11b, 0x11b, [0, [], 0]);
        t.add(0x11c, 0x11c, [2, [0x011D], 0]);
        t.add(0x11d, 0x11d, [0, [], 0]);
        t.add(0x11e, 0x11e, [2, [0x011F], 0]);
        t.add(0x11f, 0x11f, [0, [], 0]);
        t.add(0x120, 0x120, [2, [0x0121], 0]);
        t.add(0x121, 0x121, [0, [], 0]);
        t.add(0x122, 0x122, [2, [0x0123], 0]);
        t.add(0x123, 0x123, [0, [], 0]);
        t.add(0x124, 0x124, [2, [0x0125], 0]);
        t.add(0x125, 0x125, [0, [], 0]);
        t.add(0x126, 0x126, [2, [0x0127], 0]);
        t.add(0x127, 0x127, [0, [], 0]);
        t.add(0x128, 0x128, [2, [0x0129], 0]);
        t.add(0x129, 0x129, [0, [], 0]);
        t.add(0x12a, 0x12a, [2, [0x012B], 0]);
        t.add(0x12b, 0x12b, [0, [], 0]);
        t.add(0x12c, 0x12c, [2, [0x012D], 0]);
        t.add(0x12d, 0x12d, [0, [], 0]);
        t.add(0x12e, 0x12e, [2, [0x012F], 0]);
        t.add(0x12f, 0x12f, [0, [], 0]);
        t.add(0x130, 0x130, [2, [0x0069, 0x0307], 0]);
        t.add(0x131, 0x131, [0, [], 0]);
        t.add(0x132, 0x133, [2, [0x0069, 0x006A], 0]);
        t.add(0x134, 0x134, [2, [0x0135], 0]);
        t.add(0x135, 0x135, [0, [], 0]);
        t.add(0x136, 0x136, [2, [0x0137], 0]);
        t.add(0x137, 0x138, [0, [], 0]);
        t.add(0x139, 0x139, [2, [0x013A], 0]);
        t.add(0x13a, 0x13a, [0, [], 0]);
        t.add(0x13b, 0x13b, [2, [0x013C], 0]);
        t.add(0x13c, 0x13c, [0, [], 0]);
        t.add(0x13d, 0x13d, [2, [0x013E], 0]);
        t.add(0x13e, 0x13e, [0, [], 0]);
        t.add(0x13f, 0x140, [2, [0x006C, 0x00B7], 0]);
        t.add(0x141, 0x141, [2, [0x0142], 0]);
        t.add(0x142, 0x142, [0, [], 0]);
        t.add(0x143, 0x143, [2, [0x0144], 0]);
        t.add(0x144, 0x144, [0, [], 0]);
        t.add(0x145, 0x145, [2, [0x0146], 0]);
        t.add(0x146, 0x146, [0, [], 0]);
        t.add(0x147, 0x147, [2, [0x0148], 0]);
        t.add(0x148, 0x148, [0, [], 0]);
        t.add(0x149, 0x149, [2, [0x02BC, 0x006E], 0]);
        t.add(0x14a, 0x14a, [2, [0x014B], 0]);
        t.add(0x14b, 0x14b, [0, [], 0]);
        t.add(0x14c, 0x14c, [2, [0x014D], 0]);
        t.add(0x14d, 0x14d, [0, [], 0]);
        t.add(0x14e, 0x14e, [2, [0x014F], 0]);
        t.add(0x14f, 0x14f, [0, [], 0]);
        t.add(0x150, 0x150, [2, [0x0151], 0]);
        t.add(0x151, 0x151, [0, [], 0]);
        t.add(0x152, 0x152, [2, [0x0153], 0]);
        t.add(0x153, 0x153, [0, [], 0]);
        t.add(0x154, 0x154, [2, [0x0155], 0]);
        t.add(0x155, 0x155, [0, [], 0]);
        t.add(0x156, 0x156, [2, [0x0157], 0]);
        t.add(0x157, 0x157, [0, [], 0]);
        t.add(0x158, 0x158, [2, [0x0159], 0]);
        t.add(0x159, 0x159, [0, [], 0]);
        t.add(0x15a, 0x15a, [2, [0x015B], 0]);
        t.add(0x15b, 0x15b, [0, [], 0]);
        t.add(0x15c, 0x15c, [2, [0x015D], 0]);
        t.add(0x15d, 0x15d, [0, [], 0]);
        t.add(0x15e, 0x15e, [2, [0x015F], 0]);
        t.add(0x15f, 0x15f, [0, [], 0]);
        t.add(0x160, 0x160, [2, [0x0161], 0]);
        t.add(0x161, 0x161, [0, [], 0]);
        t.add(0x162, 0x162, [2, [0x0163], 0]);
        t.add(0x163, 0x163, [0, [], 0]);
        t.add(0x164, 0x164, [2, [0x0165], 0]);
        t.add(0x165, 0x165, [0, [], 0]);
        t.add(0x166, 0x166, [2, [0x0167], 0]);
        t.add(0x167, 0x167, [0, [], 0]);
        t.add(0x168, 0x168, [2, [0x0169], 0]);
        t.add(0x169, 0x169, [0, [], 0]);
        t.add(0x16a, 0x16a, [2, [0x016B], 0]);
        t.add(0x16b, 0x16b, [0, [], 0]);
        t.add(0x16c, 0x16c, [2, [0x016D], 0]);
        t.add(0x16d, 0x16d, [0, [], 0]);
        t.add(0x16e, 0x16e, [2, [0x016F], 0]);
        t.add(0x16f, 0x16f, [0, [], 0]);
        t.add(0x170, 0x170, [2, [0x0171], 0]);
        t.add(0x171, 0x171, [0, [], 0]);
        t.add(0x172, 0x172, [2, [0x0173], 0]);
        t.add(0x173, 0x173, [0, [], 0]);
        t.add(0x174, 0x174, [2, [0x0175], 0]);
        t.add(0x175, 0x175, [0, [], 0]);
        t.add(0x176, 0x176, [2, [0x0177], 0]);
        t.add(0x177, 0x177, [0, [], 0]);
        t.add(0x178, 0x178, [2, [0x00FF], 0]);
        t.add(0x179, 0x179, [2, [0x017A], 0]);
        t.add(0x17a, 0x17a, [0, [], 0]);
        t.add(0x17b, 0x17b, [2, [0x017C], 0]);
        t.add(0x17c, 0x17c, [0, [], 0]);
        t.add(0x17d, 0x17d, [2, [0x017E], 0]);
        t.add(0x17e, 0x17e, [0, [], 0]);
        t.add(0x17f, 0x17f, [2, [0x0073], 0]);
        t.add(0x180, 0x180, [0, [], 0]);
        t.add(0x181, 0x181, [2, [0x0253], 0]);
        t.add(0x182, 0x182, [2, [0x0183], 0]);
        t.add(0x183, 0x183, [0, [], 0]);
        t.add(0x184, 0x184, [2, [0x0185], 0]);
        t.add(0x185, 0x185, [0, [], 0]);
        t.add(0x186, 0x186, [2, [0x0254], 0]);
        t.add(0x187, 0x187, [2, [0x0188], 0]);
        t.add(0x188, 0x188, [0, [], 0]);
        t.add(0x189, 0x189, [2, [0x0256], 0]);
        t.add(0x18a, 0x18a, [2, [0x0257], 0]);
        t.add(0x18b, 0x18b, [2, [0x018C], 0]);
        t.add(0x18c, 0x18d, [0, [], 0]);
        t.add(0x18e, 0x18e, [2, [0x01DD], 0]);
        t.add(0x18f, 0x18f, [2, [0x0259], 0]);
        t.add(0x190, 0x190, [2, [0x025B], 0]);
        t.add(0x191, 0x191, [2, [0x0192], 0]);
        t.add(0x192, 0x192, [0, [], 0]);
        t.add(0x193, 0x193, [2, [0x0260], 0]);
        t.add(0x194, 0x194, [2, [0x0263], 0]);
        t.add(0x195, 0x195, [0, [], 0]);
        t.add(0x196, 0x196, [2, [0x0269], 0]);
        t.add(0x197, 0x197, [2, [0x0268], 0]);
        t.add(0x198, 0x198, [2, [0x0199], 0]);
        t.add(0x199, 0x19b, [0, [], 0]);
        t.add(0x19c, 0x19c, [2, [0x026F], 0]);
        t.add(0x19d, 0x19d, [2, [0x0272], 0]);
        t.add(0x19e, 0x19e, [0, [], 0]);
        t.add(0x19f, 0x19f, [2, [0x0275], 0]);
        t.add(0x1a0, 0x1a0, [2, [0x01A1], 0]);
        t.add(0x1a1, 0x1a1, [0, [], 0]);
        t.add(0x1a2, 0x1a2, [2, [0x01A3], 0]);
        t.add(0x1a3, 0x1a3, [0, [], 0]);
        t.add(0x1a4, 0x1a4, [2, [0x01A5], 0]);
        t.add(0x1a5, 0x1a5, [0, [], 0]);
        t.add(0x1a6, 0x1a6, [2, [0x0280], 0]);
        t.add(0x1a7, 0x1a7, [2, [0x01A8], 0]);
        t.add(0x1a8, 0x1a8, [0, [], 0]);
        t.add(0x1a9, 0x1a9, [2, [0x0283], 0]);
        t.add(0x1aa, 0x1ab, [0, [], 0]);
        t.add(0x1ac, 0x1ac, [2, [0x01AD], 0]);
        t.add(0x1ad, 0x1ad, [0, [], 0]);
        t.add(0x1ae, 0x1ae, [2, [0x0288], 0]);
        t.add(0x1af, 0x1af, [2, [0x01B0], 0]);
        t.add(0x1b0, 0x1b0, [0, [], 0]);
        t.add(0x1b1, 0x1b1, [2, [0x028A], 0]);
        t.add(0x1b2, 0x1b2, [2, [0x028B], 0]);
        t.add(0x1b3, 0x1b3, [2, [0x01B4], 0]);
        t.add(0x1b4, 0x1b4, [0, [], 0]);
        t.add(0x1b5, 0x1b5, [2, [0x01B6], 0]);
        t.add(0x1b6, 0x1b6, [0, [], 0]);
        t.add(0x1b7, 0x1b7, [2, [0x0292], 0]);
        t.add(0x1b8, 0x1b8, [2, [0x01B9], 0]);
        t.add(0x1b9, 0x1bb, [0, [], 0]);
        t.add(0x1bc, 0x1bc, [2, [0x01BD], 0]);
        t.add(0x1bd, 0x1c3, [0, [], 0]);
        t.add(0x1c4, 0x1c6, [2, [0x0064, 0x017E], 0]);
        t.add(0x1c7, 0x1c9, [2, [0x006C, 0x006A], 0]);
        t.add(0x1ca, 0x1cc, [2, [0x006E, 0x006A], 0]);
        t.add(0x1cd, 0x1cd, [2, [0x01CE], 0]);
        t.add(0x1ce, 0x1ce, [0, [], 0]);
        t.add(0x1cf, 0x1cf, [2, [0x01D0], 0]);
        t.add(0x1d0, 0x1d0, [0, [], 0]);
        t.add(0x1d1, 0x1d1, [2, [0x01D2], 0]);
        t.add(0x1d2, 0x1d2, [0, [], 0]);
        t.add(0x1d3, 0x1d3, [2, [0x01D4], 0]);
        t.add(0x1d4, 0x1d4, [0, [], 0]);
        t.add(0x1d5, 0x1d5, [2, [0x01D6], 0]);
        t.add(0x1d6, 0x1d6, [0, [], 0]);
        t.add(0x1d7, 0x1d7, [2, [0x01D8], 0]);
        t.add(0x1d8, 0x1d8, [0, [], 0]);
        t.add(0x1d9, 0x1d9, [2, [0x01DA], 0]);
        t.add(0x1da, 0x1da, [0, [], 0]);
        t.add(0x1db, 0x1db, [2, [0x01DC], 0]);
        t.add(0x1dc, 0x1dd, [0, [], 0]);
        t.add(0x1de, 0x1de, [2, [0x01DF], 0]);
        t.add(0x1df, 0x1df, [0, [], 0]);
        t.add(0x1e0, 0x1e0, [2, [0x01E1], 0]);
        t.add(0x1e1, 0x1e1, [0, [], 0]);
        t.add(0x1e2, 0x1e2, [2, [0x01E3], 0]);
        t.add(0x1e3, 0x1e3, [0, [], 0]);
        t.add(0x1e4, 0x1e4, [2, [0x01E5], 0]);
        t.add(0x1e5, 0x1e5, [0, [], 0]);
        t.add(0x1e6, 0x1e6, [2, [0x01E7], 0]);
        t.add(0x1e7, 0x1e7, [0, [], 0]);
        t.add(0x1e8, 0x1e8, [2, [0x01E9], 0]);
        t.add(0x1e9, 0x1e9, [0, [], 0]);
        t.add(0x1ea, 0x1ea, [2, [0x01EB], 0]);
        t.add(0x1eb, 0x1eb, [0, [], 0]);
        t.add(0x1ec, 0x1ec, [2, [0x01ED], 0]);
        t.add(0x1ed, 0x1ed, [0, [], 0]);
        t.add(0x1ee, 0x1ee, [2, [0x01EF], 0]);
        t.add(0x1ef, 0x1f0, [0, [], 0]);
        t.add(0x1f1, 0x1f3, [2, [0x0064, 0x007A], 0]);
        t.add(0x1f4, 0x1f4, [2, [0x01F5], 0]);
        t.add(0x1f5, 0x1f5, [0, [], 0]);
        t.add(0x1f6, 0x1f6, [2, [0x0195], 0]);
        t.add(0x1f7, 0x1f7, [2, [0x01BF], 0]);
        t.add(0x1f8, 0x1f8, [2, [0x01F9], 0]);
        t.add(0x1f9, 0x1f9, [0, [], 0]);
        t.add(0x1fa, 0x1fa, [2, [0x01FB], 0]);
        t.add(0x1fb, 0x1fb, [0, [], 0]);
        t.add(0x1fc, 0x1fc, [2, [0x01FD], 0]);
        t.add(0x1fd, 0x1fd, [0, [], 0]);
        t.add(0x1fe, 0x1fe, [2, [0x01FF], 0]);
        t.add(0x1ff, 0x1ff, [0, [], 0]);
        t.add(0x200, 0x200, [2, [0x0201], 0]);
        t.add(0x201, 0x201, [0, [], 0]);
        t.add(0x202, 0x202, [2, [0x0203], 0]);
        t.add(0x203, 0x203, [0, [], 0]);
        t.add(0x204, 0x204, [2, [0x0205], 0]);
        t.add(0x205, 0x205, [0, [], 0]);
        t.add(0x206, 0x206, [2, [0x0207], 0]);
        t.add(0x207, 0x207, [0, [], 0]);
        t.add(0x208, 0x208, [2, [0x0209], 0]);
        t.add(0x209, 0x209, [0, [], 0]);
        t.add(0x20a, 0x20a, [2, [0x020B], 0]);
        t.add(0x20b, 0x20b, [0, [], 0]);
        t.add(0x20c, 0x20c, [2, [0x020D], 0]);
        t.add(0x20d, 0x20d, [0, [], 0]);
        t.add(0x20e, 0x20e, [2, [0x020F], 0]);
        t.add(0x20f, 0x20f, [0, [], 0]);
        t.add(0x210, 0x210, [2, [0x0211], 0]);
        t.add(0x211, 0x211, [0, [], 0]);
        t.add(0x212, 0x212, [2, [0x0213], 0]);
        t.add(0x213, 0x213, [0, [], 0]);
        t.add(0x214, 0x214, [2, [0x0215], 0]);
        t.add(0x215, 0x215, [0, [], 0]);
        t.add(0x216, 0x216, [2, [0x0217], 0]);
        t.add(0x217, 0x217, [0, [], 0]);
        t.add(0x218, 0x218, [2, [0x0219], 0]);
        t.add(0x219, 0x219, [0, [], 0]);
        t.add(0x21a, 0x21a, [2, [0x021B], 0]);
        t.add(0x21b, 0x21b, [0, [], 0]);
        t.add(0x21c, 0x21c, [2, [0x021D], 0]);
        t.add(0x21d, 0x21d, [0, [], 0]);
        t.add(0x21e, 0x21e, [2, [0x021F], 0]);
        t.add(0x21f, 0x21f, [0, [], 0]);
        t.add(0x220, 0x220, [2, [0x019E], 0]);
        t.add(0x221, 0x221, [0, [], 0]);
        t.add(0x222, 0x222, [2, [0x0223], 0]);
        t.add(0x223, 0x223, [0, [], 0]);
        t.add(0x224, 0x224, [2, [0x0225], 0]);
        t.add(0x225, 0x225, [0, [], 0]);
        t.add(0x226, 0x226, [2, [0x0227], 0]);
        t.add(0x227, 0x227, [0, [], 0]);
        t.add(0x228, 0x228, [2, [0x0229], 0]);
        t.add(0x229, 0x229, [0, [], 0]);
        t.add(0x22a, 0x22a, [2, [0x022B], 0]);
        t.add(0x22b, 0x22b, [0, [], 0]);
        t.add(0x22c, 0x22c, [2, [0x022D], 0]);
        t.add(0x22d, 0x22d, [0, [], 0]);
        t.add(0x22e, 0x22e, [2, [0x022F], 0]);
        t.add(0x22f, 0x22f, [0, [], 0]);
        t.add(0x230, 0x230, [2, [0x0231], 0]);
        t.add(0x231, 0x231, [0, [], 0]);
        t.add(0x232, 0x232, [2, [0x0233], 0]);
        t.add(0x233, 0x233, [0, [], 0]);
        t.add(0x234, 0x236, [0, [], 0]);
        t.add(0x237, 0x239, [0, [], 0]);
        t.add(0x23a, 0x23a, [2, [0x2C65], 0]);
        t.add(0x23b, 0x23b, [2, [0x023C], 0]);
        t.add(0x23c, 0x23c, [0, [], 0]);
        t.add(0x23d, 0x23d, [2, [0x019A], 0]);
        t.add(0x23e, 0x23e, [2, [0x2C66], 0]);
        t.add(0x23f, 0x240, [0, [], 0]);
        t.add(0x241, 0x241, [2, [0x0242], 0]);
        t.add(0x242, 0x242, [0, [], 0]);
        t.add(0x243, 0x243, [2, [0x0180], 0]);
        t.add(0x244, 0x244, [2, [0x0289], 0]);
        t.add(0x245, 0x245, [2, [0x028C], 0]);
        t.add(0x246, 0x246, [2, [0x0247], 0]);
        t.add(0x247, 0x247, [0, [], 0]);
        t.add(0x248, 0x248, [2, [0x0249], 0]);
        t.add(0x249, 0x249, [0, [], 0]);
        t.add(0x24a, 0x24a, [2, [0x024B], 0]);
        t.add(0x24b, 0x24b, [0, [], 0]);
        t.add(0x24c, 0x24c, [2, [0x024D], 0]);
        t.add(0x24d, 0x24d, [0, [], 0]);
        t.add(0x24e, 0x24e, [2, [0x024F], 0]);
        t.add(0x24f, 0x24f, [0, [], 0]);
        t.add(0x250, 0x2a8, [0, [], 0]);
        t.add(0x2a9, 0x2ad, [0, [], 0]);
        t.add(0x2ae, 0x2af, [0, [], 0]);
        t.add(0x2b0, 0x2b0, [2, [0x0068], 0]);
        t.add(0x2b1, 0x2b1, [2, [0x0266], 0]);
        t.add(0x2b2, 0x2b2, [2, [0x006A], 0]);
        t.add(0x2b3, 0x2b3, [2, [0x0072], 0]);
        t.add(0x2b4, 0x2b4, [2, [0x0279], 0]);
        t.add(0x2b5, 0x2b5, [2, [0x027B], 0]);
        t.add(0x2b6, 0x2b6, [2, [0x0281], 0]);
        t.add(0x2b7, 0x2b7, [2, [0x0077], 0]);
        t.add(0x2b8, 0x2b8, [2, [0x0079], 0]);
        t.add(0x2b9, 0x2c1, [0, [], 0]);
        t.add(0x2c2, 0x2c5, [0, [], 1]);
        t.add(0x2c6, 0x2d1, [0, [], 0]);
        t.add(0x2d2, 0x2d7, [0, [], 1]);
        t.add(0x2d8, 0x2d8, [6, [0x0020, 0x0306], 0]);
        t.add(0x2d9, 0x2d9, [6, [0x0020, 0x0307], 0]);
        t.add(0x2da, 0x2da, [6, [0x0020, 0x030A], 0]);
        t.add(0x2db, 0x2db, [6, [0x0020, 0x0328], 0]);
        t.add(0x2dc, 0x2dc, [6, [0x0020, 0x0303], 0]);
        t.add(0x2dd, 0x2dd, [6, [0x0020, 0x030B], 0]);
        t.add(0x2de, 0x2de, [0, [], 1]);
        t.add(0x2df, 0x2df, [0, [], 1]);
        t.add(0x2e0, 0x2e0, [2, [0x0263], 0]);
        t.add(0x2e1, 0x2e1, [2, [0x006C], 0]);
        t.add(0x2e2, 0x2e2, [2, [0x0073], 0]);
        t.add(0x2e3, 0x2e3, [2, [0x0078], 0]);
        t.add(0x2e4, 0x2e4, [2, [0x0295], 0]);
        t.add(0x2e5, 0x2e9, [0, [], 1]);
        t.add(0x2ea, 0x2eb, [0, [], 1]);
        t.add(0x2ec, 0x2ec, [0, [], 0]);
        t.add(0x2ed, 0x2ed, [0, [], 1]);
        t.add(0x2ee, 0x2ee, [0, [], 0]);
        t.add(0x2ef, 0x2ff, [0, [], 1]);
        t.add(0x300, 0x33f, [0, [], 0]);
        t.add(0x340, 0x340, [2, [0x0300], 0]);
        t.add(0x341, 0x341, [2, [0x0301], 0]);
        t.add(0x342, 0x342, [0, [], 0]);
        t.add(0x343, 0x343, [2, [0x0313], 0]);
        t.add(0x344, 0x344, [2, [0x0308, 0x0301], 0]);
        t.add(0x345, 0x345, [2, [0x03B9], 0]);
        t.add(0x346, 0x34e, [0, [], 0]);
        t.add(0x34f, 0x34f, [1, [], 0]);
        t.add(0x350, 0x357, [0, [], 0]);
        t.add(0x358, 0x35c, [0, [], 0]);
        t.add(0x35d, 0x35f, [0, [], 0]);
        t.add(0x360, 0x361, [0, [], 0]);
        t.add(0x362, 0x362, [0, [], 0]);
        t.add(0x363, 0x36f, [0, [], 0]);
        t.add(0x370, 0x370, [2, [0x0371], 0]);
        t.add(0x371, 0x371, [0, [], 0]);
        t.add(0x372, 0x372, [2, [0x0373], 0]);
        t.add(0x373, 0x373, [0, [], 0]);
        t.add(0x374, 0x374, [2, [0x02B9], 0]);
        t.add(0x375, 0x375, [0, [], 0]);
        t.add(0x376, 0x376, [2, [0x0377], 0]);
        t.add(0x377, 0x377, [0, [], 0]);
        t.add(0x378, 0x379, [4, [], 0]);
        t.add(0x37a, 0x37a, [6, [0x0020, 0x03B9], 0]);
        t.add(0x37b, 0x37d, [0, [], 0]);
        t.add(0x37e, 0x37e, [6, [0x003B], 0]);
        t.add(0x37f, 0x37f, [2, [0x03F3], 0]);
        t.add(0x380, 0x383, [4, [], 0]);
        t.add(0x384, 0x384, [6, [0x0020, 0x0301], 0]);
        t.add(0x385, 0x385, [6, [0x0020, 0x0308, 0x0301], 0]);
        t.add(0x386, 0x386, [2, [0x03AC], 0]);
        t.add(0x387, 0x387, [2, [0x00B7], 0]);
        t.add(0x388, 0x388, [2, [0x03AD], 0]);
        t.add(0x389, 0x389, [2, [0x03AE], 0]);
        t.add(0x38a, 0x38a, [2, [0x03AF], 0]);
        t.add(0x38b, 0x38b, [4, [], 0]);
        t.add(0x38c, 0x38c, [2, [0x03CC], 0]);
        t.add(0x38d, 0x38d, [4, [], 0]);
        t.add(0x38e, 0x38e, [2, [0x03CD], 0]);
        t.add(0x38f, 0x38f, [2, [0x03CE], 0]);
        t.add(0x390, 0x390, [0, [], 0]);
        t.add(0x391, 0x391, [2, [0x03B1], 0]);
        t.add(0x392, 0x392, [2, [0x03B2], 0]);
        t.add(0x393, 0x393, [2, [0x03B3], 0]);
        t.add(0x394, 0x394, [2, [0x03B4], 0]);
        t.add(0x395, 0x395, [2, [0x03B5], 0]);
        t.add(0x396, 0x396, [2, [0x03B6], 0]);
        t.add(0x397, 0x397, [2, [0x03B7], 0]);
        t.add(0x398, 0x398, [2, [0x03B8], 0]);
        t.add(0x399, 0x399, [2, [0x03B9], 0]);
        t.add(0x39a, 0x39a, [2, [0x03BA], 0]);
        t.add(0x39b, 0x39b, [2, [0x03BB], 0]);
        t.add(0x39c, 0x39c, [2, [0x03BC], 0]);
        t.add(0x39d, 0x39d, [2, [0x03BD], 0]);
        t.add(0x39e, 0x39e, [2, [0x03BE], 0]);
        t.add(0x39f, 0x39f, [2, [0x03BF], 0]);
        t.add(0x3a0, 0x3a0, [2, [0x03C0], 0]);
        t.add(0x3a1, 0x3a1, [2, [0x03C1], 0]);
        t.add(0x3a2, 0x3a2, [4, [], 0]);
        t.add(0x3a3, 0x3a3, [2, [0x03C3], 0]);
        t.add(0x3a4, 0x3a4, [2, [0x03C4], 0]);
        t.add(0x3a5, 0x3a5, [2, [0x03C5], 0]);
        t.add(0x3a6, 0x3a6, [2, [0x03C6], 0]);
        t.add(0x3a7, 0x3a7, [2, [0x03C7], 0]);
        t.add(0x3a8, 0x3a8, [2, [0x03C8], 0]);
        t.add(0x3a9, 0x3a9, [2, [0x03C9], 0]);
        t.add(0x3aa, 0x3aa, [2, [0x03CA], 0]);
        t.add(0x3ab, 0x3ab, [2, [0x03CB], 0]);
        t.add(0x3ac, 0x3c1, [0, [], 0]);
        t.add(0x3c2, 0x3c2, [3, [0x03C3], 0]);
        t.add(0x3c3, 0x3ce, [0, [], 0]);
        t.add(0x3cf, 0x3cf, [2, [0x03D7], 0]);
        t.add(0x3d0, 0x3d0, [2, [0x03B2], 0]);
        t.add(0x3d1, 0x3d1, [2, [0x03B8], 0]);
        t.add(0x3d2, 0x3d2, [2, [0x03C5], 0]);
        t.add(0x3d3, 0x3d3, [2, [0x03CD], 0]);
        t.add(0x3d4, 0x3d4, [2, [0x03CB], 0]);
        t.add(0x3d5, 0x3d5, [2, [0x03C6], 0]);
        t.add(0x3d6, 0x3d6, [2, [0x03C0], 0]);
        t.add(0x3d7, 0x3d7, [0, [], 0]);
        t.add(0x3d8, 0x3d8, [2, [0x03D9], 0]);
        t.add(0x3d9, 0x3d9, [0, [], 0]);
        t.add(0x3da, 0x3da, [2, [0x03DB], 0]);
        t.add(0x3db, 0x3db, [0, [], 0]);
        t.add(0x3dc, 0x3dc, [2, [0x03DD], 0]);
        t.add(0x3dd, 0x3dd, [0, [], 0]);
        t.add(0x3de, 0x3de, [2, [0x03DF], 0]);
        t.add(0x3df, 0x3df, [0, [], 0]);
        t.add(0x3e0, 0x3e0, [2, [0x03E1], 0]);
        t.add(0x3e1, 0x3e1, [0, [], 0]);
        t.add(0x3e2, 0x3e2, [2, [0x03E3], 0]);
        t.add(0x3e3, 0x3e3, [0, [], 0]);
        t.add(0x3e4, 0x3e4, [2, [0x03E5], 0]);
        t.add(0x3e5, 0x3e5, [0, [], 0]);
        t.add(0x3e6, 0x3e6, [2, [0x03E7], 0]);
        t.add(0x3e7, 0x3e7, [0, [], 0]);
        t.add(0x3e8, 0x3e8, [2, [0x03E9], 0]);
        t.add(0x3e9, 0x3e9, [0, [], 0]);
        t.add(0x3ea, 0x3ea, [2, [0x03EB], 0]);
        t.add(0x3eb, 0x3eb, [0, [], 0]);
        t.add(0x3ec, 0x3ec, [2, [0x03ED], 0]);
        t.add(0x3ed, 0x3ed, [0, [], 0]);
        t.add(0x3ee, 0x3ee, [2, [0x03EF], 0]);
        t.add(0x3ef, 0x3ef, [0, [], 0]);
        t.add(0x3f0, 0x3f0, [2, [0x03BA], 0]);
        t.add(0x3f1, 0x3f1, [2, [0x03C1], 0]);
        t.add(0x3f2, 0x3f2, [2, [0x03C3], 0]);
        t.add(0x3f3, 0x3f3, [0, [], 0]);
        t.add(0x3f4, 0x3f4, [2, [0x03B8], 0]);
        t.add(0x3f5, 0x3f5, [2, [0x03B5], 0]);
        t.add(0x3f6, 0x3f6, [0, [], 1]);
        t.add(0x3f7, 0x3f7, [2, [0x03F8], 0]);
        t.add(0x3f8, 0x3f8, [0, [], 0]);
        t.add(0x3f9, 0x3f9, [2, [0x03C3], 0]);
        t.add(0x3fa, 0x3fa, [2, [0x03FB], 0]);
        t.add(0x3fb, 0x3fb, [0, [], 0]);
        t.add(0x3fc, 0x3fc, [0, [], 0]);
        t.add(0x3fd, 0x3fd, [2, [0x037B], 0]);
        t.add(0x3fe, 0x3fe, [2, [0x037C], 0]);
        t.add(0x3ff, 0x3ff, [2, [0x037D], 0]);
        t.add(0x400, 0x400, [2, [0x0450], 0]);
        t.add(0x401, 0x401, [2, [0x0451], 0]);
        t.add(0x402, 0x402, [2, [0x0452], 0]);
        t.add(0x403, 0x403, [2, [0x0453], 0]);
        t.add(0x404, 0x404, [2, [0x0454], 0]);
        t.add(0x405, 0x405, [2, [0x0455], 0]);
        t.add(0x406, 0x406, [2, [0x0456], 0]);
        t.add(0x407, 0x407, [2, [0x0457], 0]);
        t.add(0x408, 0x408, [2, [0x0458], 0]);
        t.add(0x409, 0x409, [2, [0x0459], 0]);
        t.add(0x40a, 0x40a, [2, [0x045A], 0]);
        t.add(0x40b, 0x40b, [2, [0x045B], 0]);
        t.add(0x40c, 0x40c, [2, [0x045C], 0]);
        t.add(0x40d, 0x40d, [2, [0x045D], 0]);
        t.add(0x40e, 0x40e, [2, [0x045E], 0]);
        t.add(0x40f, 0x40f, [2, [0x045F], 0]);
        t.add(0x410, 0x410, [2, [0x0430], 0]);
        t.add(0x411, 0x411, [2, [0x0431], 0]);
        t.add(0x412, 0x412, [2, [0x0432], 0]);
        t.add(0x413, 0x413, [2, [0x0433], 0]);
        t.add(0x414, 0x414, [2, [0x0434], 0]);
        t.add(0x415, 0x415, [2, [0x0435], 0]);
        t.add(0x416, 0x416, [2, [0x0436], 0]);
        t.add(0x417, 0x417, [2, [0x0437], 0]);
        t.add(0x418, 0x418, [2, [0x0438], 0]);
        t.add(0x419, 0x419, [2, [0x0439], 0]);
        t.add(0x41a, 0x41a, [2, [0x043A], 0]);
        t.add(0x41b, 0x41b, [2, [0x043B], 0]);
        t.add(0x41c, 0x41c, [2, [0x043C], 0]);
        t.add(0x41d, 0x41d, [2, [0x043D], 0]);
        t.add(0x41e, 0x41e, [2, [0x043E], 0]);
        t.add(0x41f, 0x41f, [2, [0x043F], 0]);
        t.add(0x420, 0x420, [2, [0x0440], 0]);
        t.add(0x421, 0x421, [2, [0x0441], 0]);
        t.add(0x422, 0x422, [2, [0x0442], 0]);
        t.add(0x423, 0x423, [2, [0x0443], 0]);
        t.add(0x424, 0x424, [2, [0x0444], 0]);
        t.add(0x425, 0x425, [2, [0x0445], 0]);
        t.add(0x426, 0x426, [2, [0x0446], 0]);
        t.add(0x427, 0x427, [2, [0x0447], 0]);
        t.add(0x428, 0x428, [2, [0x0448], 0]);
        t.add(0x429, 0x429, [2, [0x0449], 0]);
        t.add(0x42a, 0x42a, [2, [0x044A], 0]);
        t.add(0x42b, 0x42b, [2, [0x044B], 0]);
        t.add(0x42c, 0x42c, [2, [0x044C], 0]);
        t.add(0x42d, 0x42d, [2, [0x044D], 0]);
        t.add(0x42e, 0x42e, [2, [0x044E], 0]);
        t.add(0x42f, 0x42f, [2, [0x044F], 0]);
        t.add(0x430, 0x44f, [0, [], 0]);
        t.add(0x450, 0x450, [0, [], 0]);
        t.add(0x451, 0x45c, [0, [], 0]);
        t.add(0x45d, 0x45d, [0, [], 0]);
        t.add(0x45e, 0x45f, [0, [], 0]);
        t.add(0x460, 0x460, [2, [0x0461], 0]);
        t.add(0x461, 0x461, [0, [], 0]);
        t.add(0x462, 0x462, [2, [0x0463], 0]);
        t.add(0x463, 0x463, [0, [], 0]);
        t.add(0x464, 0x464, [2, [0x0465], 0]);
        t.add(0x465, 0x465, [0, [], 0]);
        t.add(0x466, 0x466, [2, [0x0467], 0]);
        t.add(0x467, 0x467, [0, [], 0]);
        t.add(0x468, 0x468, [2, [0x0469], 0]);
        t.add(0x469, 0x469, [0, [], 0]);
        t.add(0x46a, 0x46a, [2, [0x046B], 0]);
        t.add(0x46b, 0x46b, [0, [], 0]);
        t.add(0x46c, 0x46c, [2, [0x046D], 0]);
        t.add(0x46d, 0x46d, [0, [], 0]);
        t.add(0x46e, 0x46e, [2, [0x046F], 0]);
        t.add(0x46f, 0x46f, [0, [], 0]);
        t.add(0x470, 0x470, [2, [0x0471], 0]);
        t.add(0x471, 0x471, [0, [], 0]);
        t.add(0x472, 0x472, [2, [0x0473], 0]);
        t.add(0x473, 0x473, [0, [], 0]);
        t.add(0x474, 0x474, [2, [0x0475], 0]);
        t.add(0x475, 0x475, [0, [], 0]);
        t.add(0x476, 0x476, [2, [0x0477], 0]);
        t.add(0x477, 0x477, [0, [], 0]);
        t.add(0x478, 0x478, [2, [0x0479], 0]);
        t.add(0x479, 0x479, [0, [], 0]);
        t.add(0x47a, 0x47a, [2, [0x047B], 0]);
        t.add(0x47b, 0x47b, [0, [], 0]);
        t.add(0x47c, 0x47c, [2, [0x047D], 0]);
        t.add(0x47d, 0x47d, [0, [], 0]);
        t.add(0x47e, 0x47e, [2, [0x047F], 0]);
        t.add(0x47f, 0x47f, [0, [], 0]);
        t.add(0x480, 0x480, [2, [0x0481], 0]);
        t.add(0x481, 0x481, [0, [], 0]);
        t.add(0x482, 0x482, [0, [], 1]);
        t.add(0x483, 0x486, [0, [], 0]);
        t.add(0x487, 0x487, [0, [], 0]);
        t.add(0x488, 0x489, [0, [], 1]);
        t.add(0x48a, 0x48a, [2, [0x048B], 0]);
        t.add(0x48b, 0x48b, [0, [], 0]);
        t.add(0x48c, 0x48c, [2, [0x048D], 0]);
        t.add(0x48d, 0x48d, [0, [], 0]);
        t.add(0x48e, 0x48e, [2, [0x048F], 0]);
        t.add(0x48f, 0x48f, [0, [], 0]);
        t.add(0x490, 0x490, [2, [0x0491], 0]);
        t.add(0x491, 0x491, [0, [], 0]);
        t.add(0x492, 0x492, [2, [0x0493], 0]);
        t.add(0x493, 0x493, [0, [], 0]);
        t.add(0x494, 0x494, [2, [0x0495], 0]);
        t.add(0x495, 0x495, [0, [], 0]);
        t.add(0x496, 0x496, [2, [0x0497], 0]);
        t.add(0x497, 0x497, [0, [], 0]);
        t.add(0x498, 0x498, [2, [0x0499], 0]);
        t.add(0x499, 0x499, [0, [], 0]);
        t.add(0x49a, 0x49a, [2, [0x049B], 0]);
        t.add(0x49b, 0x49b, [0, [], 0]);
        t.add(0x49c, 0x49c, [2, [0x049D], 0]);
        t.add(0x49d, 0x49d, [0, [], 0]);
        t.add(0x49e, 0x49e, [2, [0x049F], 0]);
        t.add(0x49f, 0x49f, [0, [], 0]);
        t.add(0x4a0, 0x4a0, [2, [0x04A1], 0]);
        t.add(0x4a1, 0x4a1, [0, [], 0]);
        t.add(0x4a2, 0x4a2, [2, [0x04A3], 0]);
        t.add(0x4a3, 0x4a3, [0, [], 0]);
        t.add(0x4a4, 0x4a4, [2, [0x04A5], 0]);
        t.add(0x4a5, 0x4a5, [0, [], 0]);
        t.add(0x4a6, 0x4a6, [2, [0x04A7], 0]);
        t.add(0x4a7, 0x4a7, [0, [], 0]);
        t.add(0x4a8, 0x4a8, [2, [0x04A9], 0]);
        t.add(0x4a9, 0x4a9, [0, [], 0]);
        t.add(0x4aa, 0x4aa, [2, [0x04AB], 0]);
        t.add(0x4ab, 0x4ab, [0, [], 0]);
        t.add(0x4ac, 0x4ac, [2, [0x04AD], 0]);
        t.add(0x4ad, 0x4ad, [0, [], 0]);
        t.add(0x4ae, 0x4ae, [2, [0x04AF], 0]);
        t.add(0x4af, 0x4af, [0, [], 0]);
        t.add(0x4b0, 0x4b0, [2, [0x04B1], 0]);
        t.add(0x4b1, 0x4b1, [0, [], 0]);
        t.add(0x4b2, 0x4b2, [2, [0x04B3], 0]);
        t.add(0x4b3, 0x4b3, [0, [], 0]);
        t.add(0x4b4, 0x4b4, [2, [0x04B5], 0]);
        t.add(0x4b5, 0x4b5, [0, [], 0]);
        t.add(0x4b6, 0x4b6, [2, [0x04B7], 0]);
        t.add(0x4b7, 0x4b7, [0, [], 0]);
        t.add(0x4b8, 0x4b8, [2, [0x04B9], 0]);
        t.add(0x4b9, 0x4b9, [0, [], 0]);
        t.add(0x4ba, 0x4ba, [2, [0x04BB], 0]);
        t.add(0x4bb, 0x4bb, [0, [], 0]);
        t.add(0x4bc, 0x4bc, [2, [0x04BD], 0]);
        t.add(0x4bd, 0x4bd, [0, [], 0]);
        t.add(0x4be, 0x4be, [2, [0x04BF], 0]);
        t.add(0x4bf, 0x4bf, [0, [], 0]);
        t.add(0x4c0, 0x4c0, [4, [], 0]);
        t.add(0x4c1, 0x4c1, [2, [0x04C2], 0]);
        t.add(0x4c2, 0x4c2, [0, [], 0]);
        t.add(0x4c3, 0x4c3, [2, [0x04C4], 0]);
        t.add(0x4c4, 0x4c4, [0, [], 0]);
        t.add(0x4c5, 0x4c5, [2, [0x04C6], 0]);
        t.add(0x4c6, 0x4c6, [0, [], 0]);
        t.add(0x4c7, 0x4c7, [2, [0x04C8], 0]);
        t.add(0x4c8, 0x4c8, [0, [], 0]);
        t.add(0x4c9, 0x4c9, [2, [0x04CA], 0]);
        t.add(0x4ca, 0x4ca, [0, [], 0]);
        t.add(0x4cb, 0x4cb, [2, [0x04CC], 0]);
        t.add(0x4cc, 0x4cc, [0, [], 0]);
        t.add(0x4cd, 0x4cd, [2, [0x04CE], 0]);
        t.add(0x4ce, 0x4ce, [0, [], 0]);
        t.add(0x4cf, 0x4cf, [0, [], 0]);
        t.add(0x4d0, 0x4d0, [2, [0x04D1], 0]);
        t.add(0x4d1, 0x4d1, [0, [], 0]);
        t.add(0x4d2, 0x4d2, [2, [0x04D3], 0]);
        t.add(0x4d3, 0x4d3, [0, [], 0]);
        t.add(0x4d4, 0x4d4, [2, [0x04D5], 0]);
        t.add(0x4d5, 0x4d5, [0, [], 0]);
        t.add(0x4d6, 0x4d6, [2, [0x04D7], 0]);
        t.add(0x4d7, 0x4d7, [0, [], 0]);
        t.add(0x4d8, 0x4d8, [2, [0x04D9], 0]);
        t.add(0x4d9, 0x4d9, [0, [], 0]);
        t.add(0x4da, 0x4da, [2, [0x04DB], 0]);
        t.add(0x4db, 0x4db, [0, [], 0]);
        t.add(0x4dc, 0x4dc, [2, [0x04DD], 0]);
        t.add(0x4dd, 0x4dd, [0, [], 0]);
        t.add(0x4de, 0x4de, [2, [0x04DF], 0]);
        t.add(0x4df, 0x4df, [0, [], 0]);
        t.add(0x4e0, 0x4e0, [2, [0x04E1], 0]);
        t.add(0x4e1, 0x4e1, [0, [], 0]);
        t.add(0x4e2, 0x4e2, [2, [0x04E3], 0]);
        t.add(0x4e3, 0x4e3, [0, [], 0]);
        t.add(0x4e4, 0x4e4, [2, [0x04E5], 0]);
        t.add(0x4e5, 0x4e5, [0, [], 0]);
        t.add(0x4e6, 0x4e6, [2, [0x04E7], 0]);
        t.add(0x4e7, 0x4e7, [0, [], 0]);
        t.add(0x4e8, 0x4e8, [2, [0x04E9], 0]);
        t.add(0x4e9, 0x4e9, [0, [], 0]);
        t.add(0x4ea, 0x4ea, [2, [0x04EB], 0]);
        t.add(0x4eb, 0x4eb, [0, [], 0]);
        t.add(0x4ec, 0x4ec, [2, [0x04ED], 0]);
        t.add(0x4ed, 0x4ed, [0, [], 0]);
        t.add(0x4ee, 0x4ee, [2, [0x04EF], 0]);
        t.add(0x4ef, 0x4ef, [0, [], 0]);
        t.add(0x4f0, 0x4f0, [2, [0x04F1], 0]);
        t.add(0x4f1, 0x4f1, [0, [], 0]);
        t.add(0x4f2, 0x4f2, [2, [0x04F3], 0]);
        t.add(0x4f3, 0x4f3, [0, [], 0]);
        t.add(0x4f4, 0x4f4, [2, [0x04F5], 0]);
        t.add(0x4f5, 0x4f5, [0, [], 0]);
        t.add(0x4f6, 0x4f6, [2, [0x04F7], 0]);
        t.add(0x4f7, 0x4f7, [0, [], 0]);
        t.add(0x4f8, 0x4f8, [2, [0x04F9], 0]);
        t.add(0x4f9, 0x4f9, [0, [], 0]);
        t.add(0x4fa, 0x4fa, [2, [0x04FB], 0]);
        t.add(0x4fb, 0x4fb, [0, [], 0]);
        t.add(0x4fc, 0x4fc, [2, [0x04FD], 0]);
        t.add(0x4fd, 0x4fd, [0, [], 0]);
        t.add(0x4fe, 0x4fe, [2, [0x04FF], 0]);
        t.add(0x4ff, 0x4ff, [0, [], 0]);
        t.add(0x500, 0x500, [2, [0x0501], 0]);
        t.add(0x501, 0x501, [0, [], 0]);
        t.add(0x502, 0x502, [2, [0x0503], 0]);
        t.add(0x503, 0x503, [0, [], 0]);
        t.add(0x504, 0x504, [2, [0x0505], 0]);
        t.add(0x505, 0x505, [0, [], 0]);
        t.add(0x506, 0x506, [2, [0x0507], 0]);
        t.add(0x507, 0x507, [0, [], 0]);
        t.add(0x508, 0x508, [2, [0x0509], 0]);
        t.add(0x509, 0x509, [0, [], 0]);
        t.add(0x50a, 0x50a, [2, [0x050B], 0]);
        t.add(0x50b, 0x50b, [0, [], 0]);
        t.add(0x50c, 0x50c, [2, [0x050D], 0]);
        t.add(0x50d, 0x50d, [0, [], 0]);
        t.add(0x50e, 0x50e, [2, [0x050F], 0]);
        t.add(0x50f, 0x50f, [0, [], 0]);
        t.add(0x510, 0x510, [2, [0x0511], 0]);
        t.add(0x511, 0x511, [0, [], 0]);
        t.add(0x512, 0x512, [2, [0x0513], 0]);
        t.add(0x513, 0x513, [0, [], 0]);
        t.add(0x514, 0x514, [2, [0x0515], 0]);
        t.add(0x515, 0x515, [0, [], 0]);
        t.add(0x516, 0x516, [2, [0x0517], 0]);
        t.add(0x517, 0x517, [0, [], 0]);
        t.add(0x518, 0x518, [2, [0x0519], 0]);
        t.add(0x519, 0x519, [0, [], 0]);
        t.add(0x51a, 0x51a, [2, [0x051B], 0]);
        t.add(0x51b, 0x51b, [0, [], 0]);
        t.add(0x51c, 0x51c, [2, [0x051D], 0]);
        t.add(0x51d, 0x51d, [0, [], 0]);
        t.add(0x51e, 0x51e, [2, [0x051F], 0]);
        t.add(0x51f, 0x51f, [0, [], 0]);
        t.add(0x520, 0x520, [2, [0x0521], 0]);
        t.add(0x521, 0x521, [0, [], 0]);
        t.add(0x522, 0x522, [2, [0x0523], 0]);
        t.add(0x523, 0x523, [0, [], 0]);
        t.add(0x524, 0x524, [2, [0x0525], 0]);
        t.add(0x525, 0x525, [0, [], 0]);
        t.add(0x526, 0x526, [2, [0x0527], 0]);
        t.add(0x527, 0x527, [0, [], 0]);
        t.add(0x528, 0x528, [2, [0x0529], 0]);
        t.add(0x529, 0x529, [0, [], 0]);
        t.add(0x52a, 0x52a, [2, [0x052B], 0]);
        t.add(0x52b, 0x52b, [0, [], 0]);
        t.add(0x52c, 0x52c, [2, [0x052D], 0]);
        t.add(0x52d, 0x52d, [0, [], 0]);
        t.add(0x52e, 0x52e, [2, [0x052F], 0]);
        t.add(0x52f, 0x52f, [0, [], 0]);
        t.add(0x530, 0x530, [4, [], 0]);
        t.add(0x531, 0x531, [2, [0x0561], 0]);
        t.add(0x532, 0x532, [2, [0x0562], 0]);
        t.add(0x533, 0x533, [2, [0x0563], 0]);
        t.add(0x534, 0x534, [2, [0x0564], 0]);
        t.add(0x535, 0x535, [2, [0x0565], 0]);
        t.add(0x536, 0x536, [2, [0x0566], 0]);
        t.add(0x537, 0x537, [2, [0x0567], 0]);
        t.add(0x538, 0x538, [2, [0x0568], 0]);
        t.add(0x539, 0x539, [2, [0x0569], 0]);
        t.add(0x53a, 0x53a, [2, [0x056A], 0]);
        t.add(0x53b, 0x53b, [2, [0x056B], 0]);
        t.add(0x53c, 0x53c, [2, [0x056C], 0]);
        t.add(0x53d, 0x53d, [2, [0x056D], 0]);
        t.add(0x53e, 0x53e, [2, [0x056E], 0]);
        t.add(0x53f, 0x53f, [2, [0x056F], 0]);
        t.add(0x540, 0x540, [2, [0x0570], 0]);
        t.add(0x541, 0x541, [2, [0x0571], 0]);
        t.add(0x542, 0x542, [2, [0x0572], 0]);
        t.add(0x543, 0x543, [2, [0x0573], 0]);
        t.add(0x544, 0x544, [2, [0x0574], 0]);
        t.add(0x545, 0x545, [2, [0x0575], 0]);
        t.add(0x546, 0x546, [2, [0x0576], 0]);
        t.add(0x547, 0x547, [2, [0x0577], 0]);
        t.add(0x548, 0x548, [2, [0x0578], 0]);
        t.add(0x549, 0x549, [2, [0x0579], 0]);
        t.add(0x54a, 0x54a, [2, [0x057A], 0]);
        t.add(0x54b, 0x54b, [2, [0x057B], 0]);
        t.add(0x54c, 0x54c, [2, [0x057C], 0]);
        t.add(0x54d, 0x54d, [2, [0x057D], 0]);
        t.add(0x54e, 0x54e, [2, [0x057E], 0]);
        t.add(0x54f, 0x54f, [2, [0x057F], 0]);
        t.add(0x550, 0x550, [2, [0x0580], 0]);
        t.add(0x551, 0x551, [2, [0x0581], 0]);
        t.add(0x552, 0x552, [2, [0x0582], 0]);
        t.add(0x553, 0x553, [2, [0x0583], 0]);
        t.add(0x554, 0x554, [2, [0x0584], 0]);
        t.add(0x555, 0x555, [2, [0x0585], 0]);
        t.add(0x556, 0x556, [2, [0x0586], 0]);
        t.add(0x557, 0x558, [4, [], 0]);
        t.add(0x559, 0x559, [0, [], 0]);
        t.add(0x55a, 0x55f, [0, [], 1]);
        t.add(0x560, 0x560, [0, [], 0]);
        t.add(0x561, 0x586, [0, [], 0]);
        t.add(0x587, 0x587, [2, [0x0565, 0x0582], 0]);
        t.add(0x588, 0x588, [0, [], 0]);
        t.add(0x589, 0x589, [0, [], 1]);
        t.add(0x58a, 0x58a, [0, [], 1]);
        t.add(0x58b, 0x58c, [4, [], 0]);
        t.add(0x58d, 0x58e, [0, [], 1]);
        t.add(0x58f, 0x58f, [0, [], 1]);
        t.add(0x590, 0x590, [4, [], 0]);
        t.add(0x591, 0x5a1, [0, [], 0]);
        t.add(0x5a2, 0x5a2, [0, [], 0]);
        t.add(0x5a3, 0x5af, [0, [], 0]);
        t.add(0x5b0, 0x5b9, [0, [], 0]);
        t.add(0x5ba, 0x5ba, [0, [], 0]);
        t.add(0x5bb, 0x5bd, [0, [], 0]);
        t.add(0x5be, 0x5be, [0, [], 1]);
        t.add(0x5bf, 0x5bf, [0, [], 0]);
        t.add(0x5c0, 0x5c0, [0, [], 1]);
        t.add(0x5c1, 0x5c2, [0, [], 0]);
        t.add(0x5c3, 0x5c3, [0, [], 1]);
        t.add(0x5c4, 0x5c4, [0, [], 0]);
        t.add(0x5c5, 0x5c5, [0, [], 0]);
        t.add(0x5c6, 0x5c6, [0, [], 1]);
        t.add(0x5c7, 0x5c7, [0, [], 0]);
        t.add(0x5c8, 0x5cf, [4, [], 0]);
        t.add(0x5d0, 0x5ea, [0, [], 0]);
        t.add(0x5eb, 0x5ee, [4, [], 0]);
        t.add(0x5ef, 0x5ef, [0, [], 0]);
        t.add(0x5f0, 0x5f4, [0, [], 0]);
        t.add(0x5f5, 0x5ff, [4, [], 0]);
        t.add(0x600, 0x603, [4, [], 0]);
        t.add(0x604, 0x604, [4, [], 0]);
        t.add(0x605, 0x605, [4, [], 0]);
        t.add(0x606, 0x60a, [0, [], 1]);
        t.add(0x60b, 0x60b, [0, [], 1]);
        t.add(0x60c, 0x60c, [0, [], 1]);
        t.add(0x60d, 0x60f, [0, [], 1]);
        t.add(0x610, 0x615, [0, [], 0]);
        t.add(0x616, 0x61a, [0, [], 0]);
        t.add(0x61b, 0x61b, [0, [], 1]);
        t.add(0x61c, 0x61c, [4, [], 0]);
        t.add(0x61d, 0x61d, [4, [], 0]);
        t.add(0x61e, 0x61e, [0, [], 1]);
        t.add(0x61f, 0x61f, [0, [], 1]);
        t.add(0x620, 0x620, [0, [], 0]);
        t.add(0x621, 0x63a, [0, [], 0]);
        t.add(0x63b, 0x63f, [0, [], 0]);
        t.add(0x640, 0x640, [0, [], 1]);
        t.add(0x641, 0x652, [0, [], 0]);
        t.add(0x653, 0x655, [0, [], 0]);
        t.add(0x656, 0x658, [0, [], 0]);
        t.add(0x659, 0x65e, [0, [], 0]);
        t.add(0x65f, 0x65f, [0, [], 0]);
        t.add(0x660, 0x669, [0, [], 0]);
        t.add(0x66a, 0x66d, [0, [], 1]);
        t.add(0x66e, 0x66f, [0, [], 0]);
        t.add(0x670, 0x674, [0, [], 0]);
        t.add(0x675, 0x675, [2, [0x0627, 0x0674], 0]);
        t.add(0x676, 0x676, [2, [0x0648, 0x0674], 0]);
        t.add(0x677, 0x677, [2, [0x06C7, 0x0674], 0]);
        t.add(0x678, 0x678, [2, [0x064A, 0x0674], 0]);
        t.add(0x679, 0x6b7, [0, [], 0]);
        t.add(0x6b8, 0x6b9, [0, [], 0]);
        t.add(0x6ba, 0x6be, [0, [], 0]);
        t.add(0x6bf, 0x6bf, [0, [], 0]);
        t.add(0x6c0, 0x6ce, [0, [], 0]);
        t.add(0x6cf, 0x6cf, [0, [], 0]);
        t.add(0x6d0, 0x6d3, [0, [], 0]);
        t.add(0x6d4, 0x6d4, [0, [], 1]);
        t.add(0x6d5, 0x6dc, [0, [], 0]);
        t.add(0x6dd, 0x6dd, [4, [], 0]);
        t.add(0x6de, 0x6de, [0, [], 1]);
        t.add(0x6df, 0x6e8, [0, [], 0]);
        t.add(0x6e9, 0x6e9, [0, [], 1]);
        t.add(0x6ea, 0x6ed, [0, [], 0]);
        t.add(0x6ee, 0x6ef, [0, [], 0]);
        t.add(0x6f0, 0x6f9, [0, [], 0]);
        t.add(0x6fa, 0x6fe, [0, [], 0]);
        t.add(0x6ff, 0x6ff, [0, [], 0]);
        t.add(0x700, 0x70d, [0, [], 1]);
        t.add(0x70e, 0x70e, [4, [], 0]);
        t.add(0x70f, 0x70f, [4, [], 0]);
        t.add(0x710, 0x72c, [0, [], 0]);
        t.add(0x72d, 0x72f, [0, [], 0]);
        t.add(0x730, 0x74a, [0, [], 0]);
        t.add(0x74b, 0x74c, [4, [], 0]);
        t.add(0x74d, 0x74f, [0, [], 0]);
        t.add(0x750, 0x76d, [0, [], 0]);
        t.add(0x76e, 0x77f, [0, [], 0]);
        t.add(0x780, 0x7b0, [0, [], 0]);
        t.add(0x7b1, 0x7b1, [0, [], 0]);
        t.add(0x7b2, 0x7bf, [4, [], 0]);
        t.add(0x7c0, 0x7f5, [0, [], 0]);
        t.add(0x7f6, 0x7fa, [0, [], 1]);
        t.add(0x7fb, 0x7fc, [4, [], 0]);
        t.add(0x7fd, 0x7fd, [0, [], 0]);
        t.add(0x7fe, 0x7ff, [0, [], 1]);
        t.add(0x800, 0x82d, [0, [], 0]);
        t.add(0x82e, 0x82f, [4, [], 0]);
        t.add(0x830, 0x83e, [0, [], 1]);
        t.add(0x83f, 0x83f, [4, [], 0]);
        t.add(0x840, 0x85b, [0, [], 0]);
        t.add(0x85c, 0x85d, [4, [], 0]);
        t.add(0x85e, 0x85e, [0, [], 1]);
        t.add(0x85f, 0x85f, [4, [], 0]);
        t.add(0x860, 0x86a, [0, [], 0]);
        t.add(0x86b, 0x89f, [4, [], 0]);
        t.add(0x8a0, 0x8a0, [0, [], 0]);
        t.add(0x8a1, 0x8a1, [0, [], 0]);
        t.add(0x8a2, 0x8ac, [0, [], 0]);
        t.add(0x8ad, 0x8b2, [0, [], 0]);
        t.add(0x8b3, 0x8b4, [0, [], 0]);
        t.add(0x8b5, 0x8b5, [4, [], 0]);
        t.add(0x8b6, 0x8bd, [0, [], 0]);
        t.add(0x8be, 0x8d2, [4, [], 0]);
        t.add(0x8d3, 0x8d3, [0, [], 0]);
        t.add(0x8d4, 0x8e1, [0, [], 0]);
        t.add(0x8e2, 0x8e2, [4, [], 0]);
        t.add(0x8e3, 0x8e3, [0, [], 0]);
        t.add(0x8e4, 0x8fe, [0, [], 0]);
        t.add(0x8ff, 0x8ff, [0, [], 0]);
        t.add(0x900, 0x900, [0, [], 0]);
        t.add(0x901, 0x903, [0, [], 0]);
        t.add(0x904, 0x904, [0, [], 0]);
        t.add(0x905, 0x939, [0, [], 0]);
        t.add(0x93a, 0x93b, [0, [], 0]);
        t.add(0x93c, 0x94d, [0, [], 0]);
        t.add(0x94e, 0x94e, [0, [], 0]);
        t.add(0x94f, 0x94f, [0, [], 0]);
        t.add(0x950, 0x954, [0, [], 0]);
        t.add(0x955, 0x955, [0, [], 0]);
        t.add(0x956, 0x957, [0, [], 0]);
        t.add(0x958, 0x958, [2, [0x0915, 0x093C], 0]);
        t.add(0x959, 0x959, [2, [0x0916, 0x093C], 0]);
        t.add(0x95a, 0x95a, [2, [0x0917, 0x093C], 0]);
        t.add(0x95b, 0x95b, [2, [0x091C, 0x093C], 0]);
        t.add(0x95c, 0x95c, [2, [0x0921, 0x093C], 0]);
        t.add(0x95d, 0x95d, [2, [0x0922, 0x093C], 0]);
        t.add(0x95e, 0x95e, [2, [0x092B, 0x093C], 0]);
        t.add(0x95f, 0x95f, [2, [0x092F, 0x093C], 0]);
        t.add(0x960, 0x963, [0, [], 0]);
        t.add(0x964, 0x965, [0, [], 1]);
        t.add(0x966, 0x96f, [0, [], 0]);
        t.add(0x970, 0x970, [0, [], 1]);
        t.add(0x971, 0x972, [0, [], 0]);
        t.add(0x973, 0x977, [0, [], 0]);
        t.add(0x978, 0x978, [0, [], 0]);
        t.add(0x979, 0x97a, [0, [], 0]);
        t.add(0x97b, 0x97c, [0, [], 0]);
        t.add(0x97d, 0x97d, [0, [], 0]);
        t.add(0x97e, 0x97f, [0, [], 0]);
        t.add(0x980, 0x980, [0, [], 0]);
        t.add(0x981, 0x983, [0, [], 0]);
        t.add(0x984, 0x984, [4, [], 0]);
        t.add(0x985, 0x98c, [0, [], 0]);
        t.add(0x98d, 0x98e, [4, [], 0]);
        t.add(0x98f, 0x990, [0, [], 0]);
        t.add(0x991, 0x992, [4, [], 0]);
        t.add(0x993, 0x9a8, [0, [], 0]);
        t.add(0x9a9, 0x9a9, [4, [], 0]);
        t.add(0x9aa, 0x9b0, [0, [], 0]);
        t.add(0x9b1, 0x9b1, [4, [], 0]);
        t.add(0x9b2, 0x9b2, [0, [], 0]);
        t.add(0x9b3, 0x9b5, [4, [], 0]);
        t.add(0x9b6, 0x9b9, [0, [], 0]);
        t.add(0x9ba, 0x9bb, [4, [], 0]);
        t.add(0x9bc, 0x9bc, [0, [], 0]);
        t.add(0x9bd, 0x9bd, [0, [], 0]);
        t.add(0x9be, 0x9c4, [0, [], 0]);
        t.add(0x9c5, 0x9c6, [4, [], 0]);
        t.add(0x9c7, 0x9c8, [0, [], 0]);
        t.add(0x9c9, 0x9ca, [4, [], 0]);
        t.add(0x9cb, 0x9cd, [0, [], 0]);
        t.add(0x9ce, 0x9ce, [0, [], 0]);
        t.add(0x9cf, 0x9d6, [4, [], 0]);
        t.add(0x9d7, 0x9d7, [0, [], 0]);
        t.add(0x9d8, 0x9db, [4, [], 0]);
        t.add(0x9dc, 0x9dc, [2, [0x09A1, 0x09BC], 0]);
        t.add(0x9dd, 0x9dd, [2, [0x09A2, 0x09BC], 0]);
        t.add(0x9de, 0x9de, [4, [], 0]);
        t.add(0x9df, 0x9df, [2, [0x09AF, 0x09BC], 0]);
        t.add(0x9e0, 0x9e3, [0, [], 0]);
        t.add(0x9e4, 0x9e5, [4, [], 0]);
        t.add(0x9e6, 0x9f1, [0, [], 0]);
        t.add(0x9f2, 0x9fa, [0, [], 1]);
        t.add(0x9fb, 0x9fb, [0, [], 1]);
        t.add(0x9fc, 0x9fc, [0, [], 0]);
        t.add(0x9fd, 0x9fd, [0, [], 1]);
        t.add(0x9fe, 0x9fe, [0, [], 0]);
        t.add(0x9ff, 0xa00, [4, [], 0]);
        t.add(0xa01, 0xa01, [0, [], 0]);
        t.add(0xa02, 0xa02, [0, [], 0]);
        t.add(0xa03, 0xa03, [0, [], 0]);
        t.add(0xa04, 0xa04, [4, [], 0]);
        t.add(0xa05, 0xa0a, [0, [], 0]);
        t.add(0xa0b, 0xa0e, [4, [], 0]);
        t.add(0xa0f, 0xa10, [0, [], 0]);
        t.add(0xa11, 0xa12, [4, [], 0]);
        t.add(0xa13, 0xa28, [0, [], 0]);
        t.add(0xa29, 0xa29, [4, [], 0]);
        t.add(0xa2a, 0xa30, [0, [], 0]);
        t.add(0xa31, 0xa31, [4, [], 0]);
        t.add(0xa32, 0xa32, [0, [], 0]);
        t.add(0xa33, 0xa33, [2, [0x0A32, 0x0A3C], 0]);
        t.add(0xa34, 0xa34, [4, [], 0]);
        t.add(0xa35, 0xa35, [0, [], 0]);
        t.add(0xa36, 0xa36, [2, [0x0A38, 0x0A3C], 0]);
        t.add(0xa37, 0xa37, [4, [], 0]);
        t.add(0xa38, 0xa39, [0, [], 0]);
        t.add(0xa3a, 0xa3b, [4, [], 0]);
        t.add(0xa3c, 0xa3c, [0, [], 0]);
        t.add(0xa3d, 0xa3d, [4, [], 0]);
        t.add(0xa3e, 0xa42, [0, [], 0]);
        t.add(0xa43, 0xa46, [4, [], 0]);
        t.add(0xa47, 0xa48, [0, [], 0]);
        t.add(0xa49, 0xa4a, [4, [], 0]);
        t.add(0xa4b, 0xa4d, [0, [], 0]);
        t.add(0xa4e, 0xa50, [4, [], 0]);
        t.add(0xa51, 0xa51, [0, [], 0]);
        t.add(0xa52, 0xa58, [4, [], 0]);
        t.add(0xa59, 0xa59, [2, [0x0A16, 0x0A3C], 0]);
        t.add(0xa5a, 0xa5a, [2, [0x0A17, 0x0A3C], 0]);
        t.add(0xa5b, 0xa5b, [2, [0x0A1C, 0x0A3C], 0]);
        t.add(0xa5c, 0xa5c, [0, [], 0]);
        t.add(0xa5d, 0xa5d, [4, [], 0]);
        t.add(0xa5e, 0xa5e, [2, [0x0A2B, 0x0A3C], 0]);
        t.add(0xa5f, 0xa65, [4, [], 0]);
        t.add(0xa66, 0xa74, [0, [], 0]);
        t.add(0xa75, 0xa75, [0, [], 0]);
        t.add(0xa76, 0xa76, [0, [], 1]);
        t.add(0xa77, 0xa80, [4, [], 0]);
        t.add(0xa81, 0xa83, [0, [], 0]);
        t.add(0xa84, 0xa84, [4, [], 0]);
        t.add(0xa85, 0xa8b, [0, [], 0]);
        t.add(0xa8c, 0xa8c, [0, [], 0]);
        t.add(0xa8d, 0xa8d, [0, [], 0]);
        t.add(0xa8e, 0xa8e, [4, [], 0]);
        t.add(0xa8f, 0xa91, [0, [], 0]);
        t.add(0xa92, 0xa92, [4, [], 0]);
        t.add(0xa93, 0xaa8, [0, [], 0]);
        t.add(0xaa9, 0xaa9, [4, [], 0]);
        t.add(0xaaa, 0xab0, [0, [], 0]);
        t.add(0xab1, 0xab1, [4, [], 0]);
        t.add(0xab2, 0xab3, [0, [], 0]);
        t.add(0xab4, 0xab4, [4, [], 0]);
        t.add(0xab5, 0xab9, [0, [], 0]);
        t.add(0xaba, 0xabb, [4, [], 0]);
        t.add(0xabc, 0xac5, [0, [], 0]);
        t.add(0xac6, 0xac6, [4, [], 0]);
        t.add(0xac7, 0xac9, [0, [], 0]);
        t.add(0xaca, 0xaca, [4, [], 0]);
        t.add(0xacb, 0xacd, [0, [], 0]);
        t.add(0xace, 0xacf, [4, [], 0]);
        t.add(0xad0, 0xad0, [0, [], 0]);
        t.add(0xad1, 0xadf, [4, [], 0]);
        t.add(0xae0, 0xae0, [0, [], 0]);
        t.add(0xae1, 0xae3, [0, [], 0]);
        t.add(0xae4, 0xae5, [4, [], 0]);
        t.add(0xae6, 0xaef, [0, [], 0]);
        t.add(0xaf0, 0xaf0, [0, [], 1]);
        t.add(0xaf1, 0xaf1, [0, [], 1]);
        t.add(0xaf2, 0xaf8, [4, [], 0]);
        t.add(0xaf9, 0xaf9, [0, [], 0]);
        t.add(0xafa, 0xaff, [0, [], 0]);
        t.add(0xb00, 0xb00, [4, [], 0]);
        t.add(0xb01, 0xb03, [0, [], 0]);
        t.add(0xb04, 0xb04, [4, [], 0]);
        t.add(0xb05, 0xb0c, [0, [], 0]);
        t.add(0xb0d, 0xb0e, [4, [], 0]);
        t.add(0xb0f, 0xb10, [0, [], 0]);
        t.add(0xb11, 0xb12, [4, [], 0]);
        t.add(0xb13, 0xb28, [0, [], 0]);
        t.add(0xb29, 0xb29, [4, [], 0]);
        t.add(0xb2a, 0xb30, [0, [], 0]);
        t.add(0xb31, 0xb31, [4, [], 0]);
        t.add(0xb32, 0xb33, [0, [], 0]);
        t.add(0xb34, 0xb34, [4, [], 0]);
        t.add(0xb35, 0xb35, [0, [], 0]);
        t.add(0xb36, 0xb39, [0, [], 0]);
        t.add(0xb3a, 0xb3b, [4, [], 0]);
        t.add(0xb3c, 0xb43, [0, [], 0]);
        t.add(0xb44, 0xb44, [0, [], 0]);
        t.add(0xb45, 0xb46, [4, [], 0]);
        t.add(0xb47, 0xb48, [0, [], 0]);
        t.add(0xb49, 0xb4a, [4, [], 0]);
        t.add(0xb4b, 0xb4d, [0, [], 0]);
        t.add(0xb4e, 0xb55, [4, [], 0]);
        t.add(0xb56, 0xb57, [0, [], 0]);
        t.add(0xb58, 0xb5b, [4, [], 0]);
        t.add(0xb5c, 0xb5c, [2, [0x0B21, 0x0B3C], 0]);
        t.add(0xb5d, 0xb5d, [2, [0x0B22, 0x0B3C], 0]);
        t.add(0xb5e, 0xb5e, [4, [], 0]);
        t.add(0xb5f, 0xb61, [0, [], 0]);
        t.add(0xb62, 0xb63, [0, [], 0]);
        t.add(0xb64, 0xb65, [4, [], 0]);
        t.add(0xb66, 0xb6f, [0, [], 0]);
        t.add(0xb70, 0xb70, [0, [], 1]);
        t.add(0xb71, 0xb71, [0, [], 0]);
        t.add(0xb72, 0xb77, [0, [], 1]);
        t.add(0xb78, 0xb81, [4, [], 0]);
        t.add(0xb82, 0xb83, [0, [], 0]);
        t.add(0xb84, 0xb84, [4, [], 0]);
        t.add(0xb85, 0xb8a, [0, [], 0]);
        t.add(0xb8b, 0xb8d, [4, [], 0]);
        t.add(0xb8e, 0xb90, [0, [], 0]);
        t.add(0xb91, 0xb91, [4, [], 0]);
        t.add(0xb92, 0xb95, [0, [], 0]);
        t.add(0xb96, 0xb98, [4, [], 0]);
        t.add(0xb99, 0xb9a, [0, [], 0]);
        t.add(0xb9b, 0xb9b, [4, [], 0]);
        t.add(0xb9c, 0xb9c, [0, [], 0]);
        t.add(0xb9d, 0xb9d, [4, [], 0]);
        t.add(0xb9e, 0xb9f, [0, [], 0]);
        t.add(0xba0, 0xba2, [4, [], 0]);
        t.add(0xba3, 0xba4, [0, [], 0]);
        t.add(0xba5, 0xba7, [4, [], 0]);
        t.add(0xba8, 0xbaa, [0, [], 0]);
        t.add(0xbab, 0xbad, [4, [], 0]);
        t.add(0xbae, 0xbb5, [0, [], 0]);
        t.add(0xbb6, 0xbb6, [0, [], 0]);
        t.add(0xbb7, 0xbb9, [0, [], 0]);
        t.add(0xbba, 0xbbd, [4, [], 0]);
        t.add(0xbbe, 0xbc2, [0, [], 0]);
        t.add(0xbc3, 0xbc5, [4, [], 0]);
        t.add(0xbc6, 0xbc8, [0, [], 0]);
        t.add(0xbc9, 0xbc9, [4, [], 0]);
        t.add(0xbca, 0xbcd, [0, [], 0]);
        t.add(0xbce, 0xbcf, [4, [], 0]);
        t.add(0xbd0, 0xbd0, [0, [], 0]);
        t.add(0xbd1, 0xbd6, [4, [], 0]);
        t.add(0xbd7, 0xbd7, [0, [], 0]);
        t.add(0xbd8, 0xbe5, [4, [], 0]);
        t.add(0xbe6, 0xbe6, [0, [], 0]);
        t.add(0xbe7, 0xbef, [0, [], 0]);
        t.add(0xbf0, 0xbf2, [0, [], 1]);
        t.add(0xbf3, 0xbfa, [0, [], 1]);
        t.add(0xbfb, 0xbff, [4, [], 0]);
        t.add(0xc00, 0xc00, [0, [], 0]);
        t.add(0xc01, 0xc03, [0, [], 0]);
        t.add(0xc04, 0xc04, [0, [], 0]);
        t.add(0xc05, 0xc0c, [0, [], 0]);
        t.add(0xc0d, 0xc0d, [4, [], 0]);
        t.add(0xc0e, 0xc10, [0, [], 0]);
        t.add(0xc11, 0xc11, [4, [], 0]);
        t.add(0xc12, 0xc28, [0, [], 0]);
        t.add(0xc29, 0xc29, [4, [], 0]);
        t.add(0xc2a, 0xc33, [0, [], 0]);
        t.add(0xc34, 0xc34, [0, [], 0]);
        t.add(0xc35, 0xc39, [0, [], 0]);
        t.add(0xc3a, 0xc3c, [4, [], 0]);
        t.add(0xc3d, 0xc3d, [0, [], 0]);
        t.add(0xc3e, 0xc44, [0, [], 0]);
        t.add(0xc45, 0xc45, [4, [], 0]);
        t.add(0xc46, 0xc48, [0, [], 0]);
        t.add(0xc49, 0xc49, [4, [], 0]);
        t.add(0xc4a, 0xc4d, [0, [], 0]);
        t.add(0xc4e, 0xc54, [4, [], 0]);
        t.add(0xc55, 0xc56, [0, [], 0]);
        t.add(0xc57, 0xc57, [4, [], 0]);
        t.add(0xc58, 0xc59, [0, [], 0]);
        t.add(0xc5a, 0xc5a, [0, [], 0]);
        t.add(0xc5b, 0xc5f, [4, [], 0]);
        t.add(0xc60, 0xc61, [0, [], 0]);
        t.add(0xc62, 0xc63, [0, [], 0]);
        t.add(0xc64, 0xc65, [4, [], 0]);
        t.add(0xc66, 0xc6f, [0, [], 0]);
        t.add(0xc70, 0xc76, [4, [], 0]);
        t.add(0xc77, 0xc77, [0, [], 1]);
        t.add(0xc78, 0xc7f, [0, [], 1]);
        t.add(0xc80, 0xc80, [0, [], 0]);
        t.add(0xc81, 0xc81, [0, [], 0]);
        t.add(0xc82, 0xc83, [0, [], 0]);
        t.add(0xc84, 0xc84, [0, [], 1]);
        t.add(0xc85, 0xc8c, [0, [], 0]);
        t.add(0xc8d, 0xc8d, [4, [], 0]);
        t.add(0xc8e, 0xc90, [0, [], 0]);
        t.add(0xc91, 0xc91, [4, [], 0]);
        t.add(0xc92, 0xca8, [0, [], 0]);
        t.add(0xca9, 0xca9, [4, [], 0]);
        t.add(0xcaa, 0xcb3, [0, [], 0]);
        t.add(0xcb4, 0xcb4, [4, [], 0]);
        t.add(0xcb5, 0xcb9, [0, [], 0]);
        t.add(0xcba, 0xcbb, [4, [], 0]);
        t.add(0xcbc, 0xcbd, [0, [], 0]);
        t.add(0xcbe, 0xcc4, [0, [], 0]);
        t.add(0xcc5, 0xcc5, [4, [], 0]);
        t.add(0xcc6, 0xcc8, [0, [], 0]);
        t.add(0xcc9, 0xcc9, [4, [], 0]);
        t.add(0xcca, 0xccd, [0, [], 0]);
        t.add(0xcce, 0xcd4, [4, [], 0]);
        t.add(0xcd5, 0xcd6, [0, [], 0]);
        t.add(0xcd7, 0xcdd, [4, [], 0]);
        t.add(0xcde, 0xcde, [0, [], 0]);
        t.add(0xcdf, 0xcdf, [4, [], 0]);
        t.add(0xce0, 0xce1, [0, [], 0]);
        t.add(0xce2, 0xce3, [0, [], 0]);
        t.add(0xce4, 0xce5, [4, [], 0]);
        t.add(0xce6, 0xcef, [0, [], 0]);
        t.add(0xcf0, 0xcf0, [4, [], 0]);
        t.add(0xcf1, 0xcf2, [0, [], 0]);
        t.add(0xcf3, 0xcff, [4, [], 0]);
        t.add(0xd00, 0xd00, [0, [], 0]);
        t.add(0xd01, 0xd01, [0, [], 0]);
        t.add(0xd02, 0xd03, [0, [], 0]);
        t.add(0xd04, 0xd04, [4, [], 0]);
        t.add(0xd05, 0xd0c, [0, [], 0]);
        t.add(0xd0d, 0xd0d, [4, [], 0]);
        t.add(0xd0e, 0xd10, [0, [], 0]);
        t.add(0xd11, 0xd11, [4, [], 0]);
        t.add(0xd12, 0xd28, [0, [], 0]);
        t.add(0xd29, 0xd29, [0, [], 0]);
        t.add(0xd2a, 0xd39, [0, [], 0]);
        t.add(0xd3a, 0xd3a, [0, [], 0]);
        t.add(0xd3b, 0xd3c, [0, [], 0]);
        t.add(0xd3d, 0xd3d, [0, [], 0]);
        t.add(0xd3e, 0xd43, [0, [], 0]);
        t.add(0xd44, 0xd44, [0, [], 0]);
        t.add(0xd45, 0xd45, [4, [], 0]);
        t.add(0xd46, 0xd48, [0, [], 0]);
        t.add(0xd49, 0xd49, [4, [], 0]);
        t.add(0xd4a, 0xd4d, [0, [], 0]);
        t.add(0xd4e, 0xd4e, [0, [], 0]);
        t.add(0xd4f, 0xd4f, [0, [], 1]);
        t.add(0xd50, 0xd53, [4, [], 0]);
        t.add(0xd54, 0xd56, [0, [], 0]);
        t.add(0xd57, 0xd57, [0, [], 0]);
        t.add(0xd58, 0xd5e, [0, [], 1]);
        t.add(0xd5f, 0xd5f, [0, [], 0]);
        t.add(0xd60, 0xd61, [0, [], 0]);
        t.add(0xd62, 0xd63, [0, [], 0]);
        t.add(0xd64, 0xd65, [4, [], 0]);
        t.add(0xd66, 0xd6f, [0, [], 0]);
        t.add(0xd70, 0xd75, [0, [], 1]);
        t.add(0xd76, 0xd78, [0, [], 1]);
        t.add(0xd79, 0xd79, [0, [], 1]);
        t.add(0xd7a, 0xd7f, [0, [], 0]);
        t.add(0xd80, 0xd81, [4, [], 0]);
        t.add(0xd82, 0xd83, [0, [], 0]);
        t.add(0xd84, 0xd84, [4, [], 0]);
        t.add(0xd85, 0xd96, [0, [], 0]);
        t.add(0xd97, 0xd99, [4, [], 0]);
        t.add(0xd9a, 0xdb1, [0, [], 0]);
        t.add(0xdb2, 0xdb2, [4, [], 0]);
        t.add(0xdb3, 0xdbb, [0, [], 0]);
        t.add(0xdbc, 0xdbc, [4, [], 0]);
        t.add(0xdbd, 0xdbd, [0, [], 0]);
        t.add(0xdbe, 0xdbf, [4, [], 0]);
        t.add(0xdc0, 0xdc6, [0, [], 0]);
        t.add(0xdc7, 0xdc9, [4, [], 0]);
        t.add(0xdca, 0xdca, [0, [], 0]);
        t.add(0xdcb, 0xdce, [4, [], 0]);
        t.add(0xdcf, 0xdd4, [0, [], 0]);
        t.add(0xdd5, 0xdd5, [4, [], 0]);
        t.add(0xdd6, 0xdd6, [0, [], 0]);
        t.add(0xdd7, 0xdd7, [4, [], 0]);
        t.add(0xdd8, 0xddf, [0, [], 0]);
        t.add(0xde0, 0xde5, [4, [], 0]);
        t.add(0xde6, 0xdef, [0, [], 0]);
        t.add(0xdf0, 0xdf1, [4, [], 0]);
        t.add(0xdf2, 0xdf3, [0, [], 0]);
        t.add(0xdf4, 0xdf4, [0, [], 1]);
        t.add(0xdf5, 0xe00, [4, [], 0]);
        t.add(0xe01, 0xe32, [0, [], 0]);
        t.add(0xe33, 0xe33, [2, [0x0E4D, 0x0E32], 0]);
        t.add(0xe34, 0xe3a, [0, [], 0]);
        t.add(0xe3b, 0xe3e, [4, [], 0]);
        t.add(0xe3f, 0xe3f, [0, [], 1]);
        t.add(0xe40, 0xe4e, [0, [], 0]);
        t.add(0xe4f, 0xe4f, [0, [], 1]);
        t.add(0xe50, 0xe59, [0, [], 0]);
        t.add(0xe5a, 0xe5b, [0, [], 1]);
        t.add(0xe5c, 0xe80, [4, [], 0]);
        t.add(0xe81, 0xe82, [0, [], 0]);
        t.add(0xe83, 0xe83, [4, [], 0]);
        t.add(0xe84, 0xe84, [0, [], 0]);
        t.add(0xe85, 0xe85, [4, [], 0]);
        t.add(0xe86, 0xe86, [0, [], 0]);
        t.add(0xe87, 0xe88, [0, [], 0]);
        t.add(0xe89, 0xe89, [0, [], 0]);
        t.add(0xe8a, 0xe8a, [0, [], 0]);
        t.add(0xe8b, 0xe8b, [4, [], 0]);
        t.add(0xe8c, 0xe8c, [0, [], 0]);
        t.add(0xe8d, 0xe8d, [0, [], 0]);
        t.add(0xe8e, 0xe93, [0, [], 0]);
        t.add(0xe94, 0xe97, [0, [], 0]);
        t.add(0xe98, 0xe98, [0, [], 0]);
        t.add(0xe99, 0xe9f, [0, [], 0]);
        t.add(0xea0, 0xea0, [0, [], 0]);
        t.add(0xea1, 0xea3, [0, [], 0]);
        t.add(0xea4, 0xea4, [4, [], 0]);
        t.add(0xea5, 0xea5, [0, [], 0]);
        t.add(0xea6, 0xea6, [4, [], 0]);
        t.add(0xea7, 0xea7, [0, [], 0]);
        t.add(0xea8, 0xea9, [0, [], 0]);
        t.add(0xeaa, 0xeab, [0, [], 0]);
        t.add(0xeac, 0xeac, [0, [], 0]);
        t.add(0xead, 0xeb2, [0, [], 0]);
        t.add(0xeb3, 0xeb3, [2, [0x0ECD, 0x0EB2], 0]);
        t.add(0xeb4, 0xeb9, [0, [], 0]);
        t.add(0xeba, 0xeba, [0, [], 0]);
        t.add(0xebb, 0xebd, [0, [], 0]);
        t.add(0xebe, 0xebf, [4, [], 0]);
        t.add(0xec0, 0xec4, [0, [], 0]);
        t.add(0xec5, 0xec5, [4, [], 0]);
        t.add(0xec6, 0xec6, [0, [], 0]);
        t.add(0xec7, 0xec7, [4, [], 0]);
        t.add(0xec8, 0xecd, [0, [], 0]);
        t.add(0xece, 0xecf, [4, [], 0]);
        t.add(0xed0, 0xed9, [0, [], 0]);
        t.add(0xeda, 0xedb, [4, [], 0]);
        t.add(0xedc, 0xedc, [2, [0x0EAB, 0x0E99], 0]);
        t.add(0xedd, 0xedd, [2, [0x0EAB, 0x0EA1], 0]);
        t.add(0xede, 0xedf, [0, [], 0]);
        t.add(0xee0, 0xeff, [4, [], 0]);
        t.add(0xf00, 0xf00, [0, [], 0]);
        t.add(0xf01, 0xf0a, [0, [], 1]);
        t.add(0xf0b, 0xf0b, [0, [], 0]);
        t.add(0xf0c, 0xf0c, [2, [0x0F0B], 0]);
        t.add(0xf0d, 0xf17, [0, [], 1]);
        t.add(0xf18, 0xf19, [0, [], 0]);
        t.add(0xf1a, 0xf1f, [0, [], 1]);
        t.add(0xf20, 0xf29, [0, [], 0]);
        t.add(0xf2a, 0xf34, [0, [], 1]);
        t.add(0xf35, 0xf35, [0, [], 0]);
        t.add(0xf36, 0xf36, [0, [], 1]);
        t.add(0xf37, 0xf37, [0, [], 0]);
        t.add(0xf38, 0xf38, [0, [], 1]);
        t.add(0xf39, 0xf39, [0, [], 0]);
        t.add(0xf3a, 0xf3d, [0, [], 1]);
        t.add(0xf3e, 0xf42, [0, [], 0]);
        t.add(0xf43, 0xf43, [2, [0x0F42, 0x0FB7], 0]);
        t.add(0xf44, 0xf47, [0, [], 0]);
        t.add(0xf48, 0xf48, [4, [], 0]);
        t.add(0xf49, 0xf4c, [0, [], 0]);
        t.add(0xf4d, 0xf4d, [2, [0x0F4C, 0x0FB7], 0]);
        t.add(0xf4e, 0xf51, [0, [], 0]);
        t.add(0xf52, 0xf52, [2, [0x0F51, 0x0FB7], 0]);
        t.add(0xf53, 0xf56, [0, [], 0]);
        t.add(0xf57, 0xf57, [2, [0x0F56, 0x0FB7], 0]);
        t.add(0xf58, 0xf5b, [0, [], 0]);
        t.add(0xf5c, 0xf5c, [2, [0x0F5B, 0x0FB7], 0]);
        t.add(0xf5d, 0xf68, [0, [], 0]);
        t.add(0xf69, 0xf69, [2, [0x0F40, 0x0FB5], 0]);
        t.add(0xf6a, 0xf6a, [0, [], 0]);
        t.add(0xf6b, 0xf6c, [0, [], 0]);
        t.add(0xf6d, 0xf70, [4, [], 0]);
        t.add(0xf71, 0xf72, [0, [], 0]);
        t.add(0xf73, 0xf73, [2, [0x0F71, 0x0F72], 0]);
        t.add(0xf74, 0xf74, [0, [], 0]);
        t.add(0xf75, 0xf75, [2, [0x0F71, 0x0F74], 0]);
        t.add(0xf76, 0xf76, [2, [0x0FB2, 0x0F80], 0]);
        t.add(0xf77, 0xf77, [2, [0x0FB2, 0x0F71, 0x0F80], 0]);
        t.add(0xf78, 0xf78, [2, [0x0FB3, 0x0F80], 0]);
        t.add(0xf79, 0xf79, [2, [0x0FB3, 0x0F71, 0x0F80], 0]);
        t.add(0xf7a, 0xf80, [0, [], 0]);
        t.add(0xf81, 0xf81, [2, [0x0F71, 0x0F80], 0]);
        t.add(0xf82, 0xf84, [0, [], 0]);
        t.add(0xf85, 0xf85, [0, [], 1]);
        t.add(0xf86, 0xf8b, [0, [], 0]);
        t.add(0xf8c, 0xf8f, [0, [], 0]);
        t.add(0xf90, 0xf92, [0, [], 0]);
        t.add(0xf93, 0xf93, [2, [0x0F92, 0x0FB7], 0]);
        t.add(0xf94, 0xf95, [0, [], 0]);
        t.add(0xf96, 0xf96, [0, [], 0]);
        t.add(0xf97, 0xf97, [0, [], 0]);
        t.add(0xf98, 0xf98, [4, [], 0]);
        t.add(0xf99, 0xf9c, [0, [], 0]);
        t.add(0xf9d, 0xf9d, [2, [0x0F9C, 0x0FB7], 0]);
        t.add(0xf9e, 0xfa1, [0, [], 0]);
        t.add(0xfa2, 0xfa2, [2, [0x0FA1, 0x0FB7], 0]);
        t.add(0xfa3, 0xfa6, [0, [], 0]);
        t.add(0xfa7, 0xfa7, [2, [0x0FA6, 0x0FB7], 0]);
        t.add(0xfa8, 0xfab, [0, [], 0]);
        t.add(0xfac, 0xfac, [2, [0x0FAB, 0x0FB7], 0]);
        t.add(0xfad, 0xfad, [0, [], 0]);
        t.add(0xfae, 0xfb0, [0, [], 0]);
        t.add(0xfb1, 0xfb7, [0, [], 0]);
        t.add(0xfb8, 0xfb8, [0, [], 0]);
        t.add(0xfb9, 0xfb9, [2, [0x0F90, 0x0FB5], 0]);
        t.add(0xfba, 0xfbc, [0, [], 0]);
        t.add(0xfbd, 0xfbd, [4, [], 0]);
        t.add(0xfbe, 0xfc5, [0, [], 1]);
        t.add(0xfc6, 0xfc6, [0, [], 0]);
        t.add(0xfc7, 0xfcc, [0, [], 1]);
        t.add(0xfcd, 0xfcd, [4, [], 0]);
        t.add(0xfce, 0xfce, [0, [], 1]);
        t.add(0xfcf, 0xfcf, [0, [], 1]);
        t.add(0xfd0, 0xfd1, [0, [], 1]);
        t.add(0xfd2, 0xfd4, [0, [], 1]);
        t.add(0xfd5, 0xfd8, [0, [], 1]);
        t.add(0xfd9, 0xfda, [0, [], 1]);
        t.add(0xfdb, 0xfff, [4, [], 0]);
        t.add(0x1000, 0x1021, [0, [], 0]);
        t.add(0x1022, 0x1022, [0, [], 0]);
        t.add(0x1023, 0x1027, [0, [], 0]);
        t.add(0x1028, 0x1028, [0, [], 0]);
        t.add(0x1029, 0x102a, [0, [], 0]);
        t.add(0x102b, 0x102b, [0, [], 0]);
        t.add(0x102c, 0x1032, [0, [], 0]);
        t.add(0x1033, 0x1035, [0, [], 0]);
        t.add(0x1036, 0x1039, [0, [], 0]);
        t.add(0x103a, 0x103f, [0, [], 0]);
        t.add(0x1040, 0x1049, [0, [], 0]);
        t.add(0x104a, 0x104f, [0, [], 1]);
        t.add(0x1050, 0x1059, [0, [], 0]);
        t.add(0x105a, 0x1099, [0, [], 0]);
        t.add(0x109a, 0x109d, [0, [], 0]);
        t.add(0x109e, 0x109f, [0, [], 1]);
        t.add(0x10a0, 0x10c5, [4, [], 0]);
        t.add(0x10c6, 0x10c6, [4, [], 0]);
        t.add(0x10c7, 0x10c7, [2, [0x2D27], 0]);
        t.add(0x10c8, 0x10cc, [4, [], 0]);
        t.add(0x10cd, 0x10cd, [2, [0x2D2D], 0]);
        t.add(0x10ce, 0x10cf, [4, [], 0]);
        t.add(0x10d0, 0x10f6, [0, [], 0]);
        t.add(0x10f7, 0x10f8, [0, [], 0]);
        t.add(0x10f9, 0x10fa, [0, [], 0]);
        t.add(0x10fb, 0x10fb, [0, [], 1]);
        t.add(0x10fc, 0x10fc, [2, [0x10DC], 0]);
        t.add(0x10fd, 0x10ff, [0, [], 0]);
        t.add(0x1100, 0x1159, [0, [], 1]);
        t.add(0x115a, 0x115e, [0, [], 1]);
        t.add(0x115f, 0x1160, [4, [], 0]);
        t.add(0x1161, 0x11a2, [0, [], 1]);
        t.add(0x11a3, 0x11a7, [0, [], 1]);
        t.add(0x11a8, 0x11f9, [0, [], 1]);
        t.add(0x11fa, 0x11ff, [0, [], 1]);
        t.add(0x1200, 0x1206, [0, [], 0]);
        t.add(0x1207, 0x1207, [0, [], 0]);
        t.add(0x1208, 0x1246, [0, [], 0]);
        t.add(0x1247, 0x1247, [0, [], 0]);
        t.add(0x1248, 0x1248, [0, [], 0]);
        t.add(0x1249, 0x1249, [4, [], 0]);
        t.add(0x124a, 0x124d, [0, [], 0]);
        t.add(0x124e, 0x124f, [4, [], 0]);
        t.add(0x1250, 0x1256, [0, [], 0]);
        t.add(0x1257, 0x1257, [4, [], 0]);
        t.add(0x1258, 0x1258, [0, [], 0]);
        t.add(0x1259, 0x1259, [4, [], 0]);
        t.add(0x125a, 0x125d, [0, [], 0]);
        t.add(0x125e, 0x125f, [4, [], 0]);
        t.add(0x1260, 0x1286, [0, [], 0]);
        t.add(0x1287, 0x1287, [0, [], 0]);
        t.add(0x1288, 0x1288, [0, [], 0]);
        t.add(0x1289, 0x1289, [4, [], 0]);
        t.add(0x128a, 0x128d, [0, [], 0]);
        t.add(0x128e, 0x128f, [4, [], 0]);
        t.add(0x1290, 0x12ae, [0, [], 0]);
        t.add(0x12af, 0x12af, [0, [], 0]);
        t.add(0x12b0, 0x12b0, [0, [], 0]);
        t.add(0x12b1, 0x12b1, [4, [], 0]);
        t.add(0x12b2, 0x12b5, [0, [], 0]);
        t.add(0x12b6, 0x12b7, [4, [], 0]);
        t.add(0x12b8, 0x12be, [0, [], 0]);
        t.add(0x12bf, 0x12bf, [4, [], 0]);
        t.add(0x12c0, 0x12c0, [0, [], 0]);
        t.add(0x12c1, 0x12c1, [4, [], 0]);
        t.add(0x12c2, 0x12c5, [0, [], 0]);
        t.add(0x12c6, 0x12c7, [4, [], 0]);
        t.add(0x12c8, 0x12ce, [0, [], 0]);
        t.add(0x12cf, 0x12cf, [0, [], 0]);
        t.add(0x12d0, 0x12d6, [0, [], 0]);
        t.add(0x12d7, 0x12d7, [4, [], 0]);
        t.add(0x12d8, 0x12ee, [0, [], 0]);
        t.add(0x12ef, 0x12ef, [0, [], 0]);
        t.add(0x12f0, 0x130e, [0, [], 0]);
        t.add(0x130f, 0x130f, [0, [], 0]);
        t.add(0x1310, 0x1310, [0, [], 0]);
        t.add(0x1311, 0x1311, [4, [], 0]);
        t.add(0x1312, 0x1315, [0, [], 0]);
        t.add(0x1316, 0x1317, [4, [], 0]);
        t.add(0x1318, 0x131e, [0, [], 0]);
        t.add(0x131f, 0x131f, [0, [], 0]);
        t.add(0x1320, 0x1346, [0, [], 0]);
        t.add(0x1347, 0x1347, [0, [], 0]);
        t.add(0x1348, 0x135a, [0, [], 0]);
        t.add(0x135b, 0x135c, [4, [], 0]);
        t.add(0x135d, 0x135e, [0, [], 0]);
        t.add(0x135f, 0x135f, [0, [], 0]);
        t.add(0x1360, 0x1360, [0, [], 1]);
        t.add(0x1361, 0x137c, [0, [], 1]);
        t.add(0x137d, 0x137f, [4, [], 0]);
        t.add(0x1380, 0x138f, [0, [], 0]);
        t.add(0x1390, 0x1399, [0, [], 1]);
        t.add(0x139a, 0x139f, [4, [], 0]);
        t.add(0x13a0, 0x13f4, [0, [], 0]);
        t.add(0x13f5, 0x13f5, [0, [], 0]);
        t.add(0x13f6, 0x13f7, [4, [], 0]);
        t.add(0x13f8, 0x13f8, [2, [0x13F0], 0]);
        t.add(0x13f9, 0x13f9, [2, [0x13F1], 0]);
        t.add(0x13fa, 0x13fa, [2, [0x13F2], 0]);
        t.add(0x13fb, 0x13fb, [2, [0x13F3], 0]);
        t.add(0x13fc, 0x13fc, [2, [0x13F4], 0]);
        t.add(0x13fd, 0x13fd, [2, [0x13F5], 0]);
        t.add(0x13fe, 0x13ff, [4, [], 0]);
        t.add(0x1400, 0x1400, [0, [], 1]);
        t.add(0x1401, 0x166c, [0, [], 0]);
        t.add(0x166d, 0x166e, [0, [], 1]);
        t.add(0x166f, 0x1676, [0, [], 0]);
        t.add(0x1677, 0x167f, [0, [], 0]);
        t.add(0x1680, 0x1680, [4, [], 0]);
        t.add(0x1681, 0x169a, [0, [], 0]);
        t.add(0x169b, 0x169c, [0, [], 1]);
        t.add(0x169d, 0x169f, [4, [], 0]);
        t.add(0x16a0, 0x16ea, [0, [], 0]);
        t.add(0x16eb, 0x16f0, [0, [], 1]);
        t.add(0x16f1, 0x16f8, [0, [], 0]);
        t.add(0x16f9, 0x16ff, [4, [], 0]);
        t.add(0x1700, 0x170c, [0, [], 0]);
        t.add(0x170d, 0x170d, [4, [], 0]);
        t.add(0x170e, 0x1714, [0, [], 0]);
        t.add(0x1715, 0x171f, [4, [], 0]);
        t.add(0x1720, 0x1734, [0, [], 0]);
        t.add(0x1735, 0x1736, [0, [], 1]);
        t.add(0x1737, 0x173f, [4, [], 0]);
        t.add(0x1740, 0x1753, [0, [], 0]);
        t.add(0x1754, 0x175f, [4, [], 0]);
        t.add(0x1760, 0x176c, [0, [], 0]);
        t.add(0x176d, 0x176d, [4, [], 0]);
        t.add(0x176e, 0x1770, [0, [], 0]);
        t.add(0x1771, 0x1771, [4, [], 0]);
        t.add(0x1772, 0x1773, [0, [], 0]);
        t.add(0x1774, 0x177f, [4, [], 0]);
        t.add(0x1780, 0x17b3, [0, [], 0]);
        t.add(0x17b4, 0x17b5, [4, [], 0]);
        t.add(0x17b6, 0x17d3, [0, [], 0]);
        t.add(0x17d4, 0x17d6, [0, [], 1]);
        t.add(0x17d7, 0x17d7, [0, [], 0]);
        t.add(0x17d8, 0x17db, [0, [], 1]);
        t.add(0x17dc, 0x17dc, [0, [], 0]);
        t.add(0x17dd, 0x17dd, [0, [], 0]);
        t.add(0x17de, 0x17df, [4, [], 0]);
        t.add(0x17e0, 0x17e9, [0, [], 0]);
        t.add(0x17ea, 0x17ef, [4, [], 0]);
        t.add(0x17f0, 0x17f9, [0, [], 1]);
        t.add(0x17fa, 0x17ff, [4, [], 0]);
        t.add(0x1800, 0x1805, [0, [], 1]);
        t.add(0x1806, 0x1806, [4, [], 0]);
        t.add(0x1807, 0x180a, [0, [], 1]);
        t.add(0x180b, 0x180d, [1, [], 0]);
        t.add(0x180e, 0x180e, [4, [], 0]);
        t.add(0x180f, 0x180f, [4, [], 0]);
        t.add(0x1810, 0x1819, [0, [], 0]);
        t.add(0x181a, 0x181f, [4, [], 0]);
        t.add(0x1820, 0x1877, [0, [], 0]);
        t.add(0x1878, 0x1878, [0, [], 0]);
        t.add(0x1879, 0x187f, [4, [], 0]);
        t.add(0x1880, 0x18a9, [0, [], 0]);
        t.add(0x18aa, 0x18aa, [0, [], 0]);
        t.add(0x18ab, 0x18af, [4, [], 0]);
        t.add(0x18b0, 0x18f5, [0, [], 0]);
        t.add(0x18f6, 0x18ff, [4, [], 0]);
        t.add(0x1900, 0x191c, [0, [], 0]);
        t.add(0x191d, 0x191e, [0, [], 0]);
        t.add(0x191f, 0x191f, [4, [], 0]);
        t.add(0x1920, 0x192b, [0, [], 0]);
        t.add(0x192c, 0x192f, [4, [], 0]);
        t.add(0x1930, 0x193b, [0, [], 0]);
        t.add(0x193c, 0x193f, [4, [], 0]);
        t.add(0x1940, 0x1940, [0, [], 1]);
        t.add(0x1941, 0x1943, [4, [], 0]);
        t.add(0x1944, 0x1945, [0, [], 1]);
        t.add(0x1946, 0x196d, [0, [], 0]);
        t.add(0x196e, 0x196f, [4, [], 0]);
        t.add(0x1970, 0x1974, [0, [], 0]);
        t.add(0x1975, 0x197f, [4, [], 0]);
        t.add(0x1980, 0x19a9, [0, [], 0]);
        t.add(0x19aa, 0x19ab, [0, [], 0]);
        t.add(0x19ac, 0x19af, [4, [], 0]);
        t.add(0x19b0, 0x19c9, [0, [], 0]);
        t.add(0x19ca, 0x19cf, [4, [], 0]);
        t.add(0x19d0, 0x19d9, [0, [], 0]);
        t.add(0x19da, 0x19da, [0, [], 2]);
        t.add(0x19db, 0x19dd, [4, [], 0]);
        t.add(0x19de, 0x19df, [0, [], 1]);
        t.add(0x19e0, 0x19ff, [0, [], 1]);
        t.add(0x1a00, 0x1a1b, [0, [], 0]);
        t.add(0x1a1c, 0x1a1d, [4, [], 0]);
        t.add(0x1a1e, 0x1a1f, [0, [], 1]);
        t.add(0x1a20, 0x1a5e, [0, [], 0]);
        t.add(0x1a5f, 0x1a5f, [4, [], 0]);
        t.add(0x1a60, 0x1a7c, [0, [], 0]);
        t.add(0x1a7d, 0x1a7e, [4, [], 0]);
        t.add(0x1a7f, 0x1a89, [0, [], 0]);
        t.add(0x1a8a, 0x1a8f, [4, [], 0]);
        t.add(0x1a90, 0x1a99, [0, [], 0]);
        t.add(0x1a9a, 0x1a9f, [4, [], 0]);
        t.add(0x1aa0, 0x1aa6, [0, [], 1]);
        t.add(0x1aa7, 0x1aa7, [0, [], 0]);
        t.add(0x1aa8, 0x1aad, [0, [], 1]);
        t.add(0x1aae, 0x1aaf, [4, [], 0]);
        t.add(0x1ab0, 0x1abd, [0, [], 0]);
        t.add(0x1abe, 0x1abe, [0, [], 1]);
        t.add(0x1abf, 0x1aff, [4, [], 0]);
        t.add(0x1b00, 0x1b4b, [0, [], 0]);
        t.add(0x1b4c, 0x1b4f, [4, [], 0]);
        t.add(0x1b50, 0x1b59, [0, [], 0]);
        t.add(0x1b5a, 0x1b6a, [0, [], 1]);
        t.add(0x1b6b, 0x1b73, [0, [], 0]);
        t.add(0x1b74, 0x1b7c, [0, [], 1]);
        t.add(0x1b7d, 0x1b7f, [4, [], 0]);
        t.add(0x1b80, 0x1baa, [0, [], 0]);
        t.add(0x1bab, 0x1bad, [0, [], 0]);
        t.add(0x1bae, 0x1bb9, [0, [], 0]);
        t.add(0x1bba, 0x1bbf, [0, [], 0]);
        t.add(0x1bc0, 0x1bf3, [0, [], 0]);
        t.add(0x1bf4, 0x1bfb, [4, [], 0]);
        t.add(0x1bfc, 0x1bff, [0, [], 1]);
        t.add(0x1c00, 0x1c37, [0, [], 0]);
        t.add(0x1c38, 0x1c3a, [4, [], 0]);
        t.add(0x1c3b, 0x1c3f, [0, [], 1]);
        t.add(0x1c40, 0x1c49, [0, [], 0]);
        t.add(0x1c4a, 0x1c4c, [4, [], 0]);
        t.add(0x1c4d, 0x1c7d, [0, [], 0]);
        t.add(0x1c7e, 0x1c7f, [0, [], 1]);
        t.add(0x1c80, 0x1c80, [2, [0x0432], 0]);
        t.add(0x1c81, 0x1c81, [2, [0x0434], 0]);
        t.add(0x1c82, 0x1c82, [2, [0x043E], 0]);
        t.add(0x1c83, 0x1c83, [2, [0x0441], 0]);
        t.add(0x1c84, 0x1c85, [2, [0x0442], 0]);
        t.add(0x1c86, 0x1c86, [2, [0x044A], 0]);
        t.add(0x1c87, 0x1c87, [2, [0x0463], 0]);
        t.add(0x1c88, 0x1c88, [2, [0xA64B], 0]);
        t.add(0x1c89, 0x1c8f, [4, [], 0]);
        t.add(0x1c90, 0x1c90, [2, [0x10D0], 0]);
        t.add(0x1c91, 0x1c91, [2, [0x10D1], 0]);
        t.add(0x1c92, 0x1c92, [2, [0x10D2], 0]);
        t.add(0x1c93, 0x1c93, [2, [0x10D3], 0]);
        t.add(0x1c94, 0x1c94, [2, [0x10D4], 0]);
        t.add(0x1c95, 0x1c95, [2, [0x10D5], 0]);
        t.add(0x1c96, 0x1c96, [2, [0x10D6], 0]);
        t.add(0x1c97, 0x1c97, [2, [0x10D7], 0]);
        t.add(0x1c98, 0x1c98, [2, [0x10D8], 0]);
        t.add(0x1c99, 0x1c99, [2, [0x10D9], 0]);
        t.add(0x1c9a, 0x1c9a, [2, [0x10DA], 0]);
        t.add(0x1c9b, 0x1c9b, [2, [0x10DB], 0]);
        t.add(0x1c9c, 0x1c9c, [2, [0x10DC], 0]);
        t.add(0x1c9d, 0x1c9d, [2, [0x10DD], 0]);
        t.add(0x1c9e, 0x1c9e, [2, [0x10DE], 0]);
        t.add(0x1c9f, 0x1c9f, [2, [0x10DF], 0]);
        t.add(0x1ca0, 0x1ca0, [2, [0x10E0], 0]);
        t.add(0x1ca1, 0x1ca1, [2, [0x10E1], 0]);
        t.add(0x1ca2, 0x1ca2, [2, [0x10E2], 0]);
        t.add(0x1ca3, 0x1ca3, [2, [0x10E3], 0]);
        t.add(0x1ca4, 0x1ca4, [2, [0x10E4], 0]);
        t.add(0x1ca5, 0x1ca5, [2, [0x10E5], 0]);
        t.add(0x1ca6, 0x1ca6, [2, [0x10E6], 0]);
        t.add(0x1ca7, 0x1ca7, [2, [0x10E7], 0]);
        t.add(0x1ca8, 0x1ca8, [2, [0x10E8], 0]);
        t.add(0x1ca9, 0x1ca9, [2, [0x10E9], 0]);
        t.add(0x1caa, 0x1caa, [2, [0x10EA], 0]);
        t.add(0x1cab, 0x1cab, [2, [0x10EB], 0]);
        t.add(0x1cac, 0x1cac, [2, [0x10EC], 0]);
        t.add(0x1cad, 0x1cad, [2, [0x10ED], 0]);
        t.add(0x1cae, 0x1cae, [2, [0x10EE], 0]);
        t.add(0x1caf, 0x1caf, [2, [0x10EF], 0]);
        t.add(0x1cb0, 0x1cb0, [2, [0x10F0], 0]);
        t.add(0x1cb1, 0x1cb1, [2, [0x10F1], 0]);
        t.add(0x1cb2, 0x1cb2, [2, [0x10F2], 0]);
        t.add(0x1cb3, 0x1cb3, [2, [0x10F3], 0]);
        t.add(0x1cb4, 0x1cb4, [2, [0x10F4], 0]);
        t.add(0x1cb5, 0x1cb5, [2, [0x10F5], 0]);
        t.add(0x1cb6, 0x1cb6, [2, [0x10F6], 0]);
        t.add(0x1cb7, 0x1cb7, [2, [0x10F7], 0]);
        t.add(0x1cb8, 0x1cb8, [2, [0x10F8], 0]);
        t.add(0x1cb9, 0x1cb9, [2, [0x10F9], 0]);
        t.add(0x1cba, 0x1cba, [2, [0x10FA], 0]);
        t.add(0x1cbb, 0x1cbc, [4, [], 0]);
        t.add(0x1cbd, 0x1cbd, [2, [0x10FD], 0]);
        t.add(0x1cbe, 0x1cbe, [2, [0x10FE], 0]);
        t.add(0x1cbf, 0x1cbf, [2, [0x10FF], 0]);
        t.add(0x1cc0, 0x1cc7, [0, [], 1]);
        t.add(0x1cc8, 0x1ccf, [4, [], 0]);
        t.add(0x1cd0, 0x1cd2, [0, [], 0]);
        t.add(0x1cd3, 0x1cd3, [0, [], 1]);
        t.add(0x1cd4, 0x1cf2, [0, [], 0]);
        t.add(0x1cf3, 0x1cf6, [0, [], 0]);
        t.add(0x1cf7, 0x1cf7, [0, [], 0]);
        t.add(0x1cf8, 0x1cf9, [0, [], 0]);
        t.add(0x1cfa, 0x1cfa, [0, [], 0]);
        t.add(0x1cfb, 0x1cff, [4, [], 0]);
        t.add(0x1d00, 0x1d2b, [0, [], 0]);
        t.add(0x1d2c, 0x1d2c, [2, [0x0061], 0]);
        t.add(0x1d2d, 0x1d2d, [2, [0x00E6], 0]);
        t.add(0x1d2e, 0x1d2e, [2, [0x0062], 0]);
        t.add(0x1d2f, 0x1d2f, [0, [], 0]);
        t.add(0x1d30, 0x1d30, [2, [0x0064], 0]);
        t.add(0x1d31, 0x1d31, [2, [0x0065], 0]);
        t.add(0x1d32, 0x1d32, [2, [0x01DD], 0]);
        t.add(0x1d33, 0x1d33, [2, [0x0067], 0]);
        t.add(0x1d34, 0x1d34, [2, [0x0068], 0]);
        t.add(0x1d35, 0x1d35, [2, [0x0069], 0]);
        t.add(0x1d36, 0x1d36, [2, [0x006A], 0]);
        t.add(0x1d37, 0x1d37, [2, [0x006B], 0]);
        t.add(0x1d38, 0x1d38, [2, [0x006C], 0]);
        t.add(0x1d39, 0x1d39, [2, [0x006D], 0]);
        t.add(0x1d3a, 0x1d3a, [2, [0x006E], 0]);
        t.add(0x1d3b, 0x1d3b, [0, [], 0]);
        t.add(0x1d3c, 0x1d3c, [2, [0x006F], 0]);
        t.add(0x1d3d, 0x1d3d, [2, [0x0223], 0]);
        t.add(0x1d3e, 0x1d3e, [2, [0x0070], 0]);
        t.add(0x1d3f, 0x1d3f, [2, [0x0072], 0]);
        t.add(0x1d40, 0x1d40, [2, [0x0074], 0]);
        t.add(0x1d41, 0x1d41, [2, [0x0075], 0]);
        t.add(0x1d42, 0x1d42, [2, [0x0077], 0]);
        t.add(0x1d43, 0x1d43, [2, [0x0061], 0]);
        t.add(0x1d44, 0x1d44, [2, [0x0250], 0]);
        t.add(0x1d45, 0x1d45, [2, [0x0251], 0]);
        t.add(0x1d46, 0x1d46, [2, [0x1D02], 0]);
        t.add(0x1d47, 0x1d47, [2, [0x0062], 0]);
        t.add(0x1d48, 0x1d48, [2, [0x0064], 0]);
        t.add(0x1d49, 0x1d49, [2, [0x0065], 0]);
        t.add(0x1d4a, 0x1d4a, [2, [0x0259], 0]);
        t.add(0x1d4b, 0x1d4b, [2, [0x025B], 0]);
        t.add(0x1d4c, 0x1d4c, [2, [0x025C], 0]);
        t.add(0x1d4d, 0x1d4d, [2, [0x0067], 0]);
        t.add(0x1d4e, 0x1d4e, [0, [], 0]);
        t.add(0x1d4f, 0x1d4f, [2, [0x006B], 0]);
        t.add(0x1d50, 0x1d50, [2, [0x006D], 0]);
        t.add(0x1d51, 0x1d51, [2, [0x014B], 0]);
        t.add(0x1d52, 0x1d52, [2, [0x006F], 0]);
        t.add(0x1d53, 0x1d53, [2, [0x0254], 0]);
        t.add(0x1d54, 0x1d54, [2, [0x1D16], 0]);
        t.add(0x1d55, 0x1d55, [2, [0x1D17], 0]);
        t.add(0x1d56, 0x1d56, [2, [0x0070], 0]);
        t.add(0x1d57, 0x1d57, [2, [0x0074], 0]);
        t.add(0x1d58, 0x1d58, [2, [0x0075], 0]);
        t.add(0x1d59, 0x1d59, [2, [0x1D1D], 0]);
        t.add(0x1d5a, 0x1d5a, [2, [0x026F], 0]);
        t.add(0x1d5b, 0x1d5b, [2, [0x0076], 0]);
        t.add(0x1d5c, 0x1d5c, [2, [0x1D25], 0]);
        t.add(0x1d5d, 0x1d5d, [2, [0x03B2], 0]);
        t.add(0x1d5e, 0x1d5e, [2, [0x03B3], 0]);
        t.add(0x1d5f, 0x1d5f, [2, [0x03B4], 0]);
        t.add(0x1d60, 0x1d60, [2, [0x03C6], 0]);
        t.add(0x1d61, 0x1d61, [2, [0x03C7], 0]);
        t.add(0x1d62, 0x1d62, [2, [0x0069], 0]);
        t.add(0x1d63, 0x1d63, [2, [0x0072], 0]);
        t.add(0x1d64, 0x1d64, [2, [0x0075], 0]);
        t.add(0x1d65, 0x1d65, [2, [0x0076], 0]);
        t.add(0x1d66, 0x1d66, [2, [0x03B2], 0]);
        t.add(0x1d67, 0x1d67, [2, [0x03B3], 0]);
        t.add(0x1d68, 0x1d68, [2, [0x03C1], 0]);
        t.add(0x1d69, 0x1d69, [2, [0x03C6], 0]);
        t.add(0x1d6a, 0x1d6a, [2, [0x03C7], 0]);
        t.add(0x1d6b, 0x1d6b, [0, [], 0]);
        t.add(0x1d6c, 0x1d77, [0, [], 0]);
        t.add(0x1d78, 0x1d78, [2, [0x043D], 0]);
        t.add(0x1d79, 0x1d9a, [0, [], 0]);
        t.add(0x1d9b, 0x1d9b, [2, [0x0252], 0]);
        t.add(0x1d9c, 0x1d9c, [2, [0x0063], 0]);
        t.add(0x1d9d, 0x1d9d, [2, [0x0255], 0]);
        t.add(0x1d9e, 0x1d9e, [2, [0x00F0], 0]);
        t.add(0x1d9f, 0x1d9f, [2, [0x025C], 0]);
        t.add(0x1da0, 0x1da0, [2, [0x0066], 0]);
        t.add(0x1da1, 0x1da1, [2, [0x025F], 0]);
        t.add(0x1da2, 0x1da2, [2, [0x0261], 0]);
        t.add(0x1da3, 0x1da3, [2, [0x0265], 0]);
        t.add(0x1da4, 0x1da4, [2, [0x0268], 0]);
        t.add(0x1da5, 0x1da5, [2, [0x0269], 0]);
        t.add(0x1da6, 0x1da6, [2, [0x026A], 0]);
        t.add(0x1da7, 0x1da7, [2, [0x1D7B], 0]);
        t.add(0x1da8, 0x1da8, [2, [0x029D], 0]);
        t.add(0x1da9, 0x1da9, [2, [0x026D], 0]);
        t.add(0x1daa, 0x1daa, [2, [0x1D85], 0]);
        t.add(0x1dab, 0x1dab, [2, [0x029F], 0]);
        t.add(0x1dac, 0x1dac, [2, [0x0271], 0]);
        t.add(0x1dad, 0x1dad, [2, [0x0270], 0]);
        t.add(0x1dae, 0x1dae, [2, [0x0272], 0]);
        t.add(0x1daf, 0x1daf, [2, [0x0273], 0]);
        t.add(0x1db0, 0x1db0, [2, [0x0274], 0]);
        t.add(0x1db1, 0x1db1, [2, [0x0275], 0]);
        t.add(0x1db2, 0x1db2, [2, [0x0278], 0]);
        t.add(0x1db3, 0x1db3, [2, [0x0282], 0]);
        t.add(0x1db4, 0x1db4, [2, [0x0283], 0]);
        t.add(0x1db5, 0x1db5, [2, [0x01AB], 0]);
        t.add(0x1db6, 0x1db6, [2, [0x0289], 0]);
        t.add(0x1db7, 0x1db7, [2, [0x028A], 0]);
        t.add(0x1db8, 0x1db8, [2, [0x1D1C], 0]);
        t.add(0x1db9, 0x1db9, [2, [0x028B], 0]);
        t.add(0x1dba, 0x1dba, [2, [0x028C], 0]);
        t.add(0x1dbb, 0x1dbb, [2, [0x007A], 0]);
        t.add(0x1dbc, 0x1dbc, [2, [0x0290], 0]);
        t.add(0x1dbd, 0x1dbd, [2, [0x0291], 0]);
        t.add(0x1dbe, 0x1dbe, [2, [0x0292], 0]);
        t.add(0x1dbf, 0x1dbf, [2, [0x03B8], 0]);
        t.add(0x1dc0, 0x1dc3, [0, [], 0]);
        t.add(0x1dc4, 0x1dca, [0, [], 0]);
        t.add(0x1dcb, 0x1de6, [0, [], 0]);
        t.add(0x1de7, 0x1df5, [0, [], 0]);
        t.add(0x1df6, 0x1df9, [0, [], 0]);
        t.add(0x1dfa, 0x1dfa, [4, [], 0]);
        t.add(0x1dfb, 0x1dfb, [0, [], 0]);
        t.add(0x1dfc, 0x1dfc, [0, [], 0]);
        t.add(0x1dfd, 0x1dfd, [0, [], 0]);
        t.add(0x1dfe, 0x1dff, [0, [], 0]);
        t.add(0x1e00, 0x1e00, [2, [0x1E01], 0]);
        t.add(0x1e01, 0x1e01, [0, [], 0]);
        t.add(0x1e02, 0x1e02, [2, [0x1E03], 0]);
        t.add(0x1e03, 0x1e03, [0, [], 0]);
        t.add(0x1e04, 0x1e04, [2, [0x1E05], 0]);
        t.add(0x1e05, 0x1e05, [0, [], 0]);
        t.add(0x1e06, 0x1e06, [2, [0x1E07], 0]);
        t.add(0x1e07, 0x1e07, [0, [], 0]);
        t.add(0x1e08, 0x1e08, [2, [0x1E09], 0]);
        t.add(0x1e09, 0x1e09, [0, [], 0]);
        t.add(0x1e0a, 0x1e0a, [2, [0x1E0B], 0]);
        t.add(0x1e0b, 0x1e0b, [0, [], 0]);
        t.add(0x1e0c, 0x1e0c, [2, [0x1E0D], 0]);
        t.add(0x1e0d, 0x1e0d, [0, [], 0]);
        t.add(0x1e0e, 0x1e0e, [2, [0x1E0F], 0]);
        t.add(0x1e0f, 0x1e0f, [0, [], 0]);
        t.add(0x1e10, 0x1e10, [2, [0x1E11], 0]);
        t.add(0x1e11, 0x1e11, [0, [], 0]);
        t.add(0x1e12, 0x1e12, [2, [0x1E13], 0]);
        t.add(0x1e13, 0x1e13, [0, [], 0]);
        t.add(0x1e14, 0x1e14, [2, [0x1E15], 0]);
        t.add(0x1e15, 0x1e15, [0, [], 0]);
        t.add(0x1e16, 0x1e16, [2, [0x1E17], 0]);
        t.add(0x1e17, 0x1e17, [0, [], 0]);
        t.add(0x1e18, 0x1e18, [2, [0x1E19], 0]);
        t.add(0x1e19, 0x1e19, [0, [], 0]);
        t.add(0x1e1a, 0x1e1a, [2, [0x1E1B], 0]);
        t.add(0x1e1b, 0x1e1b, [0, [], 0]);
        t.add(0x1e1c, 0x1e1c, [2, [0x1E1D], 0]);
        t.add(0x1e1d, 0x1e1d, [0, [], 0]);
        t.add(0x1e1e, 0x1e1e, [2, [0x1E1F], 0]);
        t.add(0x1e1f, 0x1e1f, [0, [], 0]);
        t.add(0x1e20, 0x1e20, [2, [0x1E21], 0]);
        t.add(0x1e21, 0x1e21, [0, [], 0]);
        t.add(0x1e22, 0x1e22, [2, [0x1E23], 0]);
        t.add(0x1e23, 0x1e23, [0, [], 0]);
        t.add(0x1e24, 0x1e24, [2, [0x1E25], 0]);
        t.add(0x1e25, 0x1e25, [0, [], 0]);
        t.add(0x1e26, 0x1e26, [2, [0x1E27], 0]);
        t.add(0x1e27, 0x1e27, [0, [], 0]);
        t.add(0x1e28, 0x1e28, [2, [0x1E29], 0]);
        t.add(0x1e29, 0x1e29, [0, [], 0]);
        t.add(0x1e2a, 0x1e2a, [2, [0x1E2B], 0]);
        t.add(0x1e2b, 0x1e2b, [0, [], 0]);
        t.add(0x1e2c, 0x1e2c, [2, [0x1E2D], 0]);
        t.add(0x1e2d, 0x1e2d, [0, [], 0]);
        t.add(0x1e2e, 0x1e2e, [2, [0x1E2F], 0]);
        t.add(0x1e2f, 0x1e2f, [0, [], 0]);
        t.add(0x1e30, 0x1e30, [2, [0x1E31], 0]);
        t.add(0x1e31, 0x1e31, [0, [], 0]);
        t.add(0x1e32, 0x1e32, [2, [0x1E33], 0]);
        t.add(0x1e33, 0x1e33, [0, [], 0]);
        t.add(0x1e34, 0x1e34, [2, [0x1E35], 0]);
        t.add(0x1e35, 0x1e35, [0, [], 0]);
        t.add(0x1e36, 0x1e36, [2, [0x1E37], 0]);
        t.add(0x1e37, 0x1e37, [0, [], 0]);
        t.add(0x1e38, 0x1e38, [2, [0x1E39], 0]);
        t.add(0x1e39, 0x1e39, [0, [], 0]);
        t.add(0x1e3a, 0x1e3a, [2, [0x1E3B], 0]);
        t.add(0x1e3b, 0x1e3b, [0, [], 0]);
        t.add(0x1e3c, 0x1e3c, [2, [0x1E3D], 0]);
        t.add(0x1e3d, 0x1e3d, [0, [], 0]);
        t.add(0x1e3e, 0x1e3e, [2, [0x1E3F], 0]);
        t.add(0x1e3f, 0x1e3f, [0, [], 0]);
        t.add(0x1e40, 0x1e40, [2, [0x1E41], 0]);
        t.add(0x1e41, 0x1e41, [0, [], 0]);
        t.add(0x1e42, 0x1e42, [2, [0x1E43], 0]);
        t.add(0x1e43, 0x1e43, [0, [], 0]);
        t.add(0x1e44, 0x1e44, [2, [0x1E45], 0]);
        t.add(0x1e45, 0x1e45, [0, [], 0]);
        t.add(0x1e46, 0x1e46, [2, [0x1E47], 0]);
        t.add(0x1e47, 0x1e47, [0, [], 0]);
        t.add(0x1e48, 0x1e48, [2, [0x1E49], 0]);
        t.add(0x1e49, 0x1e49, [0, [], 0]);
        t.add(0x1e4a, 0x1e4a, [2, [0x1E4B], 0]);
        t.add(0x1e4b, 0x1e4b, [0, [], 0]);
        t.add(0x1e4c, 0x1e4c, [2, [0x1E4D], 0]);
        t.add(0x1e4d, 0x1e4d, [0, [], 0]);
        t.add(0x1e4e, 0x1e4e, [2, [0x1E4F], 0]);
        t.add(0x1e4f, 0x1e4f, [0, [], 0]);
        t.add(0x1e50, 0x1e50, [2, [0x1E51], 0]);
        t.add(0x1e51, 0x1e51, [0, [], 0]);
        t.add(0x1e52, 0x1e52, [2, [0x1E53], 0]);
        t.add(0x1e53, 0x1e53, [0, [], 0]);
        t.add(0x1e54, 0x1e54, [2, [0x1E55], 0]);
        t.add(0x1e55, 0x1e55, [0, [], 0]);
        t.add(0x1e56, 0x1e56, [2, [0x1E57], 0]);
        t.add(0x1e57, 0x1e57, [0, [], 0]);
        t.add(0x1e58, 0x1e58, [2, [0x1E59], 0]);
        t.add(0x1e59, 0x1e59, [0, [], 0]);
        t.add(0x1e5a, 0x1e5a, [2, [0x1E5B], 0]);
        t.add(0x1e5b, 0x1e5b, [0, [], 0]);
        t.add(0x1e5c, 0x1e5c, [2, [0x1E5D], 0]);
        t.add(0x1e5d, 0x1e5d, [0, [], 0]);
        t.add(0x1e5e, 0x1e5e, [2, [0x1E5F], 0]);
        t.add(0x1e5f, 0x1e5f, [0, [], 0]);
        t.add(0x1e60, 0x1e60, [2, [0x1E61], 0]);
        t.add(0x1e61, 0x1e61, [0, [], 0]);
        t.add(0x1e62, 0x1e62, [2, [0x1E63], 0]);
        t.add(0x1e63, 0x1e63, [0, [], 0]);
        t.add(0x1e64, 0x1e64, [2, [0x1E65], 0]);
        t.add(0x1e65, 0x1e65, [0, [], 0]);
        t.add(0x1e66, 0x1e66, [2, [0x1E67], 0]);
        t.add(0x1e67, 0x1e67, [0, [], 0]);
        t.add(0x1e68, 0x1e68, [2, [0x1E69], 0]);
        t.add(0x1e69, 0x1e69, [0, [], 0]);
        t.add(0x1e6a, 0x1e6a, [2, [0x1E6B], 0]);
        t.add(0x1e6b, 0x1e6b, [0, [], 0]);
        t.add(0x1e6c, 0x1e6c, [2, [0x1E6D], 0]);
        t.add(0x1e6d, 0x1e6d, [0, [], 0]);
        t.add(0x1e6e, 0x1e6e, [2, [0x1E6F], 0]);
        t.add(0x1e6f, 0x1e6f, [0, [], 0]);
        t.add(0x1e70, 0x1e70, [2, [0x1E71], 0]);
        t.add(0x1e71, 0x1e71, [0, [], 0]);
        t.add(0x1e72, 0x1e72, [2, [0x1E73], 0]);
        t.add(0x1e73, 0x1e73, [0, [], 0]);
        t.add(0x1e74, 0x1e74, [2, [0x1E75], 0]);
        t.add(0x1e75, 0x1e75, [0, [], 0]);
        t.add(0x1e76, 0x1e76, [2, [0x1E77], 0]);
        t.add(0x1e77, 0x1e77, [0, [], 0]);
        t.add(0x1e78, 0x1e78, [2, [0x1E79], 0]);
        t.add(0x1e79, 0x1e79, [0, [], 0]);
        t.add(0x1e7a, 0x1e7a, [2, [0x1E7B], 0]);
        t.add(0x1e7b, 0x1e7b, [0, [], 0]);
        t.add(0x1e7c, 0x1e7c, [2, [0x1E7D], 0]);
        t.add(0x1e7d, 0x1e7d, [0, [], 0]);
        t.add(0x1e7e, 0x1e7e, [2, [0x1E7F], 0]);
        t.add(0x1e7f, 0x1e7f, [0, [], 0]);
        t.add(0x1e80, 0x1e80, [2, [0x1E81], 0]);
        t.add(0x1e81, 0x1e81, [0, [], 0]);
        t.add(0x1e82, 0x1e82, [2, [0x1E83], 0]);
        t.add(0x1e83, 0x1e83, [0, [], 0]);
        t.add(0x1e84, 0x1e84, [2, [0x1E85], 0]);
        t.add(0x1e85, 0x1e85, [0, [], 0]);
        t.add(0x1e86, 0x1e86, [2, [0x1E87], 0]);
        t.add(0x1e87, 0x1e87, [0, [], 0]);
        t.add(0x1e88, 0x1e88, [2, [0x1E89], 0]);
        t.add(0x1e89, 0x1e89, [0, [], 0]);
        t.add(0x1e8a, 0x1e8a, [2, [0x1E8B], 0]);
        t.add(0x1e8b, 0x1e8b, [0, [], 0]);
        t.add(0x1e8c, 0x1e8c, [2, [0x1E8D], 0]);
        t.add(0x1e8d, 0x1e8d, [0, [], 0]);
        t.add(0x1e8e, 0x1e8e, [2, [0x1E8F], 0]);
        t.add(0x1e8f, 0x1e8f, [0, [], 0]);
        t.add(0x1e90, 0x1e90, [2, [0x1E91], 0]);
        t.add(0x1e91, 0x1e91, [0, [], 0]);
        t.add(0x1e92, 0x1e92, [2, [0x1E93], 0]);
        t.add(0x1e93, 0x1e93, [0, [], 0]);
        t.add(0x1e94, 0x1e94, [2, [0x1E95], 0]);
        t.add(0x1e95, 0x1e99, [0, [], 0]);
        t.add(0x1e9a, 0x1e9a, [2, [0x0061, 0x02BE], 0]);
        t.add(0x1e9b, 0x1e9b, [2, [0x1E61], 0]);
        t.add(0x1e9c, 0x1e9d, [0, [], 0]);
        t.add(0x1e9e, 0x1e9e, [2, [0x0073, 0x0073], 0]);
        t.add(0x1e9f, 0x1e9f, [0, [], 0]);
        t.add(0x1ea0, 0x1ea0, [2, [0x1EA1], 0]);
        t.add(0x1ea1, 0x1ea1, [0, [], 0]);
        t.add(0x1ea2, 0x1ea2, [2, [0x1EA3], 0]);
        t.add(0x1ea3, 0x1ea3, [0, [], 0]);
        t.add(0x1ea4, 0x1ea4, [2, [0x1EA5], 0]);
        t.add(0x1ea5, 0x1ea5, [0, [], 0]);
        t.add(0x1ea6, 0x1ea6, [2, [0x1EA7], 0]);
        t.add(0x1ea7, 0x1ea7, [0, [], 0]);
        t.add(0x1ea8, 0x1ea8, [2, [0x1EA9], 0]);
        t.add(0x1ea9, 0x1ea9, [0, [], 0]);
        t.add(0x1eaa, 0x1eaa, [2, [0x1EAB], 0]);
        t.add(0x1eab, 0x1eab, [0, [], 0]);
        t.add(0x1eac, 0x1eac, [2, [0x1EAD], 0]);
        t.add(0x1ead, 0x1ead, [0, [], 0]);
        t.add(0x1eae, 0x1eae, [2, [0x1EAF], 0]);
        t.add(0x1eaf, 0x1eaf, [0, [], 0]);
        t.add(0x1eb0, 0x1eb0, [2, [0x1EB1], 0]);
        t.add(0x1eb1, 0x1eb1, [0, [], 0]);
        t.add(0x1eb2, 0x1eb2, [2, [0x1EB3], 0]);
        t.add(0x1eb3, 0x1eb3, [0, [], 0]);
        t.add(0x1eb4, 0x1eb4, [2, [0x1EB5], 0]);
        t.add(0x1eb5, 0x1eb5, [0, [], 0]);
        t.add(0x1eb6, 0x1eb6, [2, [0x1EB7], 0]);
        t.add(0x1eb7, 0x1eb7, [0, [], 0]);
        t.add(0x1eb8, 0x1eb8, [2, [0x1EB9], 0]);
        t.add(0x1eb9, 0x1eb9, [0, [], 0]);
        t.add(0x1eba, 0x1eba, [2, [0x1EBB], 0]);
        t.add(0x1ebb, 0x1ebb, [0, [], 0]);
        t.add(0x1ebc, 0x1ebc, [2, [0x1EBD], 0]);
        t.add(0x1ebd, 0x1ebd, [0, [], 0]);
        t.add(0x1ebe, 0x1ebe, [2, [0x1EBF], 0]);
        t.add(0x1ebf, 0x1ebf, [0, [], 0]);
        t.add(0x1ec0, 0x1ec0, [2, [0x1EC1], 0]);
        t.add(0x1ec1, 0x1ec1, [0, [], 0]);
        t.add(0x1ec2, 0x1ec2, [2, [0x1EC3], 0]);
        t.add(0x1ec3, 0x1ec3, [0, [], 0]);
        t.add(0x1ec4, 0x1ec4, [2, [0x1EC5], 0]);
        t.add(0x1ec5, 0x1ec5, [0, [], 0]);
        t.add(0x1ec6, 0x1ec6, [2, [0x1EC7], 0]);
        t.add(0x1ec7, 0x1ec7, [0, [], 0]);
        t.add(0x1ec8, 0x1ec8, [2, [0x1EC9], 0]);
        t.add(0x1ec9, 0x1ec9, [0, [], 0]);
        t.add(0x1eca, 0x1eca, [2, [0x1ECB], 0]);
        t.add(0x1ecb, 0x1ecb, [0, [], 0]);
        t.add(0x1ecc, 0x1ecc, [2, [0x1ECD], 0]);
        t.add(0x1ecd, 0x1ecd, [0, [], 0]);
        t.add(0x1ece, 0x1ece, [2, [0x1ECF], 0]);
        t.add(0x1ecf, 0x1ecf, [0, [], 0]);
        t.add(0x1ed0, 0x1ed0, [2, [0x1ED1], 0]);
        t.add(0x1ed1, 0x1ed1, [0, [], 0]);
        t.add(0x1ed2, 0x1ed2, [2, [0x1ED3], 0]);
        t.add(0x1ed3, 0x1ed3, [0, [], 0]);
        t.add(0x1ed4, 0x1ed4, [2, [0x1ED5], 0]);
        t.add(0x1ed5, 0x1ed5, [0, [], 0]);
        t.add(0x1ed6, 0x1ed6, [2, [0x1ED7], 0]);
        t.add(0x1ed7, 0x1ed7, [0, [], 0]);
        t.add(0x1ed8, 0x1ed8, [2, [0x1ED9], 0]);
        t.add(0x1ed9, 0x1ed9, [0, [], 0]);
        t.add(0x1eda, 0x1eda, [2, [0x1EDB], 0]);
        t.add(0x1edb, 0x1edb, [0, [], 0]);
        t.add(0x1edc, 0x1edc, [2, [0x1EDD], 0]);
        t.add(0x1edd, 0x1edd, [0, [], 0]);
        t.add(0x1ede, 0x1ede, [2, [0x1EDF], 0]);
        t.add(0x1edf, 0x1edf, [0, [], 0]);
        t.add(0x1ee0, 0x1ee0, [2, [0x1EE1], 0]);
        t.add(0x1ee1, 0x1ee1, [0, [], 0]);
        t.add(0x1ee2, 0x1ee2, [2, [0x1EE3], 0]);
        t.add(0x1ee3, 0x1ee3, [0, [], 0]);
        t.add(0x1ee4, 0x1ee4, [2, [0x1EE5], 0]);
        t.add(0x1ee5, 0x1ee5, [0, [], 0]);
        t.add(0x1ee6, 0x1ee6, [2, [0x1EE7], 0]);
        t.add(0x1ee7, 0x1ee7, [0, [], 0]);
        t.add(0x1ee8, 0x1ee8, [2, [0x1EE9], 0]);
        t.add(0x1ee9, 0x1ee9, [0, [], 0]);
        t.add(0x1eea, 0x1eea, [2, [0x1EEB], 0]);
        t.add(0x1eeb, 0x1eeb, [0, [], 0]);
        t.add(0x1eec, 0x1eec, [2, [0x1EED], 0]);
        t.add(0x1eed, 0x1eed, [0, [], 0]);
        t.add(0x1eee, 0x1eee, [2, [0x1EEF], 0]);
        t.add(0x1eef, 0x1eef, [0, [], 0]);
        t.add(0x1ef0, 0x1ef0, [2, [0x1EF1], 0]);
        t.add(0x1ef1, 0x1ef1, [0, [], 0]);
        t.add(0x1ef2, 0x1ef2, [2, [0x1EF3], 0]);
        t.add(0x1ef3, 0x1ef3, [0, [], 0]);
        t.add(0x1ef4, 0x1ef4, [2, [0x1EF5], 0]);
        t.add(0x1ef5, 0x1ef5, [0, [], 0]);
        t.add(0x1ef6, 0x1ef6, [2, [0x1EF7], 0]);
        t.add(0x1ef7, 0x1ef7, [0, [], 0]);
        t.add(0x1ef8, 0x1ef8, [2, [0x1EF9], 0]);
        t.add(0x1ef9, 0x1ef9, [0, [], 0]);
        t.add(0x1efa, 0x1efa, [2, [0x1EFB], 0]);
        t.add(0x1efb, 0x1efb, [0, [], 0]);
        t.add(0x1efc, 0x1efc, [2, [0x1EFD], 0]);
        t.add(0x1efd, 0x1efd, [0, [], 0]);
        t.add(0x1efe, 0x1efe, [2, [0x1EFF], 0]);
        t.add(0x1eff, 0x1eff, [0, [], 0]);
        t.add(0x1f00, 0x1f07, [0, [], 0]);
        t.add(0x1f08, 0x1f08, [2, [0x1F00], 0]);
        t.add(0x1f09, 0x1f09, [2, [0x1F01], 0]);
        t.add(0x1f0a, 0x1f0a, [2, [0x1F02], 0]);
        t.add(0x1f0b, 0x1f0b, [2, [0x1F03], 0]);
        t.add(0x1f0c, 0x1f0c, [2, [0x1F04], 0]);
        t.add(0x1f0d, 0x1f0d, [2, [0x1F05], 0]);
        t.add(0x1f0e, 0x1f0e, [2, [0x1F06], 0]);
        t.add(0x1f0f, 0x1f0f, [2, [0x1F07], 0]);
        t.add(0x1f10, 0x1f15, [0, [], 0]);
        t.add(0x1f16, 0x1f17, [4, [], 0]);
        t.add(0x1f18, 0x1f18, [2, [0x1F10], 0]);
        t.add(0x1f19, 0x1f19, [2, [0x1F11], 0]);
        t.add(0x1f1a, 0x1f1a, [2, [0x1F12], 0]);
        t.add(0x1f1b, 0x1f1b, [2, [0x1F13], 0]);
        t.add(0x1f1c, 0x1f1c, [2, [0x1F14], 0]);
        t.add(0x1f1d, 0x1f1d, [2, [0x1F15], 0]);
        t.add(0x1f1e, 0x1f1f, [4, [], 0]);
        t.add(0x1f20, 0x1f27, [0, [], 0]);
        t.add(0x1f28, 0x1f28, [2, [0x1F20], 0]);
        t.add(0x1f29, 0x1f29, [2, [0x1F21], 0]);
        t.add(0x1f2a, 0x1f2a, [2, [0x1F22], 0]);
        t.add(0x1f2b, 0x1f2b, [2, [0x1F23], 0]);
        t.add(0x1f2c, 0x1f2c, [2, [0x1F24], 0]);
        t.add(0x1f2d, 0x1f2d, [2, [0x1F25], 0]);
        t.add(0x1f2e, 0x1f2e, [2, [0x1F26], 0]);
        t.add(0x1f2f, 0x1f2f, [2, [0x1F27], 0]);
        t.add(0x1f30, 0x1f37, [0, [], 0]);
        t.add(0x1f38, 0x1f38, [2, [0x1F30], 0]);
        t.add(0x1f39, 0x1f39, [2, [0x1F31], 0]);
        t.add(0x1f3a, 0x1f3a, [2, [0x1F32], 0]);
        t.add(0x1f3b, 0x1f3b, [2, [0x1F33], 0]);
        t.add(0x1f3c, 0x1f3c, [2, [0x1F34], 0]);
        t.add(0x1f3d, 0x1f3d, [2, [0x1F35], 0]);
        t.add(0x1f3e, 0x1f3e, [2, [0x1F36], 0]);
        t.add(0x1f3f, 0x1f3f, [2, [0x1F37], 0]);
        t.add(0x1f40, 0x1f45, [0, [], 0]);
        t.add(0x1f46, 0x1f47, [4, [], 0]);
        t.add(0x1f48, 0x1f48, [2, [0x1F40], 0]);
        t.add(0x1f49, 0x1f49, [2, [0x1F41], 0]);
        t.add(0x1f4a, 0x1f4a, [2, [0x1F42], 0]);
        t.add(0x1f4b, 0x1f4b, [2, [0x1F43], 0]);
        t.add(0x1f4c, 0x1f4c, [2, [0x1F44], 0]);
        t.add(0x1f4d, 0x1f4d, [2, [0x1F45], 0]);
        t.add(0x1f4e, 0x1f4f, [4, [], 0]);
        t.add(0x1f50, 0x1f57, [0, [], 0]);
        t.add(0x1f58, 0x1f58, [4, [], 0]);
        t.add(0x1f59, 0x1f59, [2, [0x1F51], 0]);
        t.add(0x1f5a, 0x1f5a, [4, [], 0]);
        t.add(0x1f5b, 0x1f5b, [2, [0x1F53], 0]);
        t.add(0x1f5c, 0x1f5c, [4, [], 0]);
        t.add(0x1f5d, 0x1f5d, [2, [0x1F55], 0]);
        t.add(0x1f5e, 0x1f5e, [4, [], 0]);
        t.add(0x1f5f, 0x1f5f, [2, [0x1F57], 0]);
        t.add(0x1f60, 0x1f67, [0, [], 0]);
        t.add(0x1f68, 0x1f68, [2, [0x1F60], 0]);
        t.add(0x1f69, 0x1f69, [2, [0x1F61], 0]);
        t.add(0x1f6a, 0x1f6a, [2, [0x1F62], 0]);
        t.add(0x1f6b, 0x1f6b, [2, [0x1F63], 0]);
        t.add(0x1f6c, 0x1f6c, [2, [0x1F64], 0]);
        t.add(0x1f6d, 0x1f6d, [2, [0x1F65], 0]);
        t.add(0x1f6e, 0x1f6e, [2, [0x1F66], 0]);
        t.add(0x1f6f, 0x1f6f, [2, [0x1F67], 0]);
        t.add(0x1f70, 0x1f70, [0, [], 0]);
        t.add(0x1f71, 0x1f71, [2, [0x03AC], 0]);
        t.add(0x1f72, 0x1f72, [0, [], 0]);
        t.add(0x1f73, 0x1f73, [2, [0x03AD], 0]);
        t.add(0x1f74, 0x1f74, [0, [], 0]);
        t.add(0x1f75, 0x1f75, [2, [0x03AE], 0]);
        t.add(0x1f76, 0x1f76, [0, [], 0]);
        t.add(0x1f77, 0x1f77, [2, [0x03AF], 0]);
        t.add(0x1f78, 0x1f78, [0, [], 0]);
        t.add(0x1f79, 0x1f79, [2, [0x03CC], 0]);
        t.add(0x1f7a, 0x1f7a, [0, [], 0]);
        t.add(0x1f7b, 0x1f7b, [2, [0x03CD], 0]);
        t.add(0x1f7c, 0x1f7c, [0, [], 0]);
        t.add(0x1f7d, 0x1f7d, [2, [0x03CE], 0]);
        t.add(0x1f7e, 0x1f7f, [4, [], 0]);
        t.add(0x1f80, 0x1f80, [2, [0x1F00, 0x03B9], 0]);
        t.add(0x1f81, 0x1f81, [2, [0x1F01, 0x03B9], 0]);
        t.add(0x1f82, 0x1f82, [2, [0x1F02, 0x03B9], 0]);
        t.add(0x1f83, 0x1f83, [2, [0x1F03, 0x03B9], 0]);
        t.add(0x1f84, 0x1f84, [2, [0x1F04, 0x03B9], 0]);
        t.add(0x1f85, 0x1f85, [2, [0x1F05, 0x03B9], 0]);
        t.add(0x1f86, 0x1f86, [2, [0x1F06, 0x03B9], 0]);
        t.add(0x1f87, 0x1f87, [2, [0x1F07, 0x03B9], 0]);
        t.add(0x1f88, 0x1f88, [2, [0x1F00, 0x03B9], 0]);
        t.add(0x1f89, 0x1f89, [2, [0x1F01, 0x03B9], 0]);
        t.add(0x1f8a, 0x1f8a, [2, [0x1F02, 0x03B9], 0]);
        t.add(0x1f8b, 0x1f8b, [2, [0x1F03, 0x03B9], 0]);
        t.add(0x1f8c, 0x1f8c, [2, [0x1F04, 0x03B9], 0]);
        t.add(0x1f8d, 0x1f8d, [2, [0x1F05, 0x03B9], 0]);
        t.add(0x1f8e, 0x1f8e, [2, [0x1F06, 0x03B9], 0]);
        t.add(0x1f8f, 0x1f8f, [2, [0x1F07, 0x03B9], 0]);
        t.add(0x1f90, 0x1f90, [2, [0x1F20, 0x03B9], 0]);
        t.add(0x1f91, 0x1f91, [2, [0x1F21, 0x03B9], 0]);
        t.add(0x1f92, 0x1f92, [2, [0x1F22, 0x03B9], 0]);
        t.add(0x1f93, 0x1f93, [2, [0x1F23, 0x03B9], 0]);
        t.add(0x1f94, 0x1f94, [2, [0x1F24, 0x03B9], 0]);
        t.add(0x1f95, 0x1f95, [2, [0x1F25, 0x03B9], 0]);
        t.add(0x1f96, 0x1f96, [2, [0x1F26, 0x03B9], 0]);
        t.add(0x1f97, 0x1f97, [2, [0x1F27, 0x03B9], 0]);
        t.add(0x1f98, 0x1f98, [2, [0x1F20, 0x03B9], 0]);
        t.add(0x1f99, 0x1f99, [2, [0x1F21, 0x03B9], 0]);
        t.add(0x1f9a, 0x1f9a, [2, [0x1F22, 0x03B9], 0]);
        t.add(0x1f9b, 0x1f9b, [2, [0x1F23, 0x03B9], 0]);
        t.add(0x1f9c, 0x1f9c, [2, [0x1F24, 0x03B9], 0]);
        t.add(0x1f9d, 0x1f9d, [2, [0x1F25, 0x03B9], 0]);
        t.add(0x1f9e, 0x1f9e, [2, [0x1F26, 0x03B9], 0]);
        t.add(0x1f9f, 0x1f9f, [2, [0x1F27, 0x03B9], 0]);
        t.add(0x1fa0, 0x1fa0, [2, [0x1F60, 0x03B9], 0]);
        t.add(0x1fa1, 0x1fa1, [2, [0x1F61, 0x03B9], 0]);
        t.add(0x1fa2, 0x1fa2, [2, [0x1F62, 0x03B9], 0]);
        t.add(0x1fa3, 0x1fa3, [2, [0x1F63, 0x03B9], 0]);
        t.add(0x1fa4, 0x1fa4, [2, [0x1F64, 0x03B9], 0]);
        t.add(0x1fa5, 0x1fa5, [2, [0x1F65, 0x03B9], 0]);
        t.add(0x1fa6, 0x1fa6, [2, [0x1F66, 0x03B9], 0]);
        t.add(0x1fa7, 0x1fa7, [2, [0x1F67, 0x03B9], 0]);
        t.add(0x1fa8, 0x1fa8, [2, [0x1F60, 0x03B9], 0]);
        t.add(0x1fa9, 0x1fa9, [2, [0x1F61, 0x03B9], 0]);
        t.add(0x1faa, 0x1faa, [2, [0x1F62, 0x03B9], 0]);
        t.add(0x1fab, 0x1fab, [2, [0x1F63, 0x03B9], 0]);
        t.add(0x1fac, 0x1fac, [2, [0x1F64, 0x03B9], 0]);
        t.add(0x1fad, 0x1fad, [2, [0x1F65, 0x03B9], 0]);
        t.add(0x1fae, 0x1fae, [2, [0x1F66, 0x03B9], 0]);
        t.add(0x1faf, 0x1faf, [2, [0x1F67, 0x03B9], 0]);
        t.add(0x1fb0, 0x1fb1, [0, [], 0]);
        t.add(0x1fb2, 0x1fb2, [2, [0x1F70, 0x03B9], 0]);
        t.add(0x1fb3, 0x1fb3, [2, [0x03B1, 0x03B9], 0]);
        t.add(0x1fb4, 0x1fb4, [2, [0x03AC, 0x03B9], 0]);
        t.add(0x1fb5, 0x1fb5, [4, [], 0]);
        t.add(0x1fb6, 0x1fb6, [0, [], 0]);
        t.add(0x1fb7, 0x1fb7, [2, [0x1FB6, 0x03B9], 0]);
        t.add(0x1fb8, 0x1fb8, [2, [0x1FB0], 0]);
        t.add(0x1fb9, 0x1fb9, [2, [0x1FB1], 0]);
        t.add(0x1fba, 0x1fba, [2, [0x1F70], 0]);
        t.add(0x1fbb, 0x1fbb, [2, [0x03AC], 0]);
        t.add(0x1fbc, 0x1fbc, [2, [0x03B1, 0x03B9], 0]);
        t.add(0x1fbd, 0x1fbd, [6, [0x0020, 0x0313], 0]);
        t.add(0x1fbe, 0x1fbe, [2, [0x03B9], 0]);
        t.add(0x1fbf, 0x1fbf, [6, [0x0020, 0x0313], 0]);
        t.add(0x1fc0, 0x1fc0, [6, [0x0020, 0x0342], 0]);
        t.add(0x1fc1, 0x1fc1, [6, [0x0020, 0x0308, 0x0342], 0]);
        t.add(0x1fc2, 0x1fc2, [2, [0x1F74, 0x03B9], 0]);
        t.add(0x1fc3, 0x1fc3, [2, [0x03B7, 0x03B9], 0]);
        t.add(0x1fc4, 0x1fc4, [2, [0x03AE, 0x03B9], 0]);
        t.add(0x1fc5, 0x1fc5, [4, [], 0]);
        t.add(0x1fc6, 0x1fc6, [0, [], 0]);
        t.add(0x1fc7, 0x1fc7, [2, [0x1FC6, 0x03B9], 0]);
        t.add(0x1fc8, 0x1fc8, [2, [0x1F72], 0]);
        t.add(0x1fc9, 0x1fc9, [2, [0x03AD], 0]);
        t.add(0x1fca, 0x1fca, [2, [0x1F74], 0]);
        t.add(0x1fcb, 0x1fcb, [2, [0x03AE], 0]);
        t.add(0x1fcc, 0x1fcc, [2, [0x03B7, 0x03B9], 0]);
        t.add(0x1fcd, 0x1fcd, [6, [0x0020, 0x0313, 0x0300], 0]);
        t.add(0x1fce, 0x1fce, [6, [0x0020, 0x0313, 0x0301], 0]);
        t.add(0x1fcf, 0x1fcf, [6, [0x0020, 0x0313, 0x0342], 0]);
        t.add(0x1fd0, 0x1fd2, [0, [], 0]);
        t.add(0x1fd3, 0x1fd3, [2, [0x0390], 0]);
        t.add(0x1fd4, 0x1fd5, [4, [], 0]);
        t.add(0x1fd6, 0x1fd7, [0, [], 0]);
        t.add(0x1fd8, 0x1fd8, [2, [0x1FD0], 0]);
        t.add(0x1fd9, 0x1fd9, [2, [0x1FD1], 0]);
        t.add(0x1fda, 0x1fda, [2, [0x1F76], 0]);
        t.add(0x1fdb, 0x1fdb, [2, [0x03AF], 0]);
        t.add(0x1fdc, 0x1fdc, [4, [], 0]);
        t.add(0x1fdd, 0x1fdd, [6, [0x0020, 0x0314, 0x0300], 0]);
        t.add(0x1fde, 0x1fde, [6, [0x0020, 0x0314, 0x0301], 0]);
        t.add(0x1fdf, 0x1fdf, [6, [0x0020, 0x0314, 0x0342], 0]);
        t.add(0x1fe0, 0x1fe2, [0, [], 0]);
        t.add(0x1fe3, 0x1fe3, [2, [0x03B0], 0]);
        t.add(0x1fe4, 0x1fe7, [0, [], 0]);
        t.add(0x1fe8, 0x1fe8, [2, [0x1FE0], 0]);
        t.add(0x1fe9, 0x1fe9, [2, [0x1FE1], 0]);
        t.add(0x1fea, 0x1fea, [2, [0x1F7A], 0]);
        t.add(0x1feb, 0x1feb, [2, [0x03CD], 0]);
        t.add(0x1fec, 0x1fec, [2, [0x1FE5], 0]);
        t.add(0x1fed, 0x1fed, [6, [0x0020, 0x0308, 0x0300], 0]);
        t.add(0x1fee, 0x1fee, [6, [0x0020, 0x0308, 0x0301], 0]);
        t.add(0x1fef, 0x1fef, [6, [0x0060], 0]);
        t.add(0x1ff0, 0x1ff1, [4, [], 0]);
        t.add(0x1ff2, 0x1ff2, [2, [0x1F7C, 0x03B9], 0]);
        t.add(0x1ff3, 0x1ff3, [2, [0x03C9, 0x03B9], 0]);
        t.add(0x1ff4, 0x1ff4, [2, [0x03CE, 0x03B9], 0]);
        t.add(0x1ff5, 0x1ff5, [4, [], 0]);
        t.add(0x1ff6, 0x1ff6, [0, [], 0]);
        t.add(0x1ff7, 0x1ff7, [2, [0x1FF6, 0x03B9], 0]);
        t.add(0x1ff8, 0x1ff8, [2, [0x1F78], 0]);
        t.add(0x1ff9, 0x1ff9, [2, [0x03CC], 0]);
        t.add(0x1ffa, 0x1ffa, [2, [0x1F7C], 0]);
        t.add(0x1ffb, 0x1ffb, [2, [0x03CE], 0]);
        t.add(0x1ffc, 0x1ffc, [2, [0x03C9, 0x03B9], 0]);
        t.add(0x1ffd, 0x1ffd, [6, [0x0020, 0x0301], 0]);
        t.add(0x1ffe, 0x1ffe, [6, [0x0020, 0x0314], 0]);
        t.add(0x1fff, 0x1fff, [4, [], 0]);
        t.add(0x2000, 0x200a, [6, [0x0020], 0]);
        t.add(0x200b, 0x200b, [1, [], 0]);
        t.add(0x200c, 0x200d, [3, [], 0]);
        t.add(0x200e, 0x200f, [4, [], 0]);
        t.add(0x2010, 0x2010, [0, [], 1]);
        t.add(0x2011, 0x2011, [2, [0x2010], 0]);
        t.add(0x2012, 0x2016, [0, [], 1]);
        t.add(0x2017, 0x2017, [6, [0x0020, 0x0333], 0]);
        t.add(0x2018, 0x2023, [0, [], 1]);
        t.add(0x2024, 0x2026, [4, [], 0]);
        t.add(0x2027, 0x2027, [0, [], 1]);
        t.add(0x2028, 0x202e, [4, [], 0]);
        t.add(0x202f, 0x202f, [6, [0x0020], 0]);
        t.add(0x2030, 0x2032, [0, [], 1]);
        t.add(0x2033, 0x2033, [2, [0x2032, 0x2032], 0]);
        t.add(0x2034, 0x2034, [2, [0x2032, 0x2032, 0x2032], 0]);
        t.add(0x2035, 0x2035, [0, [], 1]);
        t.add(0x2036, 0x2036, [2, [0x2035, 0x2035], 0]);
        t.add(0x2037, 0x2037, [2, [0x2035, 0x2035, 0x2035], 0]);
        t.add(0x2038, 0x203b, [0, [], 1]);
        t.add(0x203c, 0x203c, [6, [0x0021, 0x0021], 0]);
        t.add(0x203d, 0x203d, [0, [], 1]);
        t.add(0x203e, 0x203e, [6, [0x0020, 0x0305], 0]);
        t.add(0x203f, 0x2046, [0, [], 1]);
        t.add(0x2047, 0x2047, [6, [0x003F, 0x003F], 0]);
        t.add(0x2048, 0x2048, [6, [0x003F, 0x0021], 0]);
        t.add(0x2049, 0x2049, [6, [0x0021, 0x003F], 0]);
        t.add(0x204a, 0x204d, [0, [], 1]);
        t.add(0x204e, 0x2052, [0, [], 1]);
        t.add(0x2053, 0x2054, [0, [], 1]);
        t.add(0x2055, 0x2056, [0, [], 1]);
        t.add(0x2057, 0x2057, [2, [0x2032, 0x2032, 0x2032, 0x2032], 0]);
        t.add(0x2058, 0x205e, [0, [], 1]);
        t.add(0x205f, 0x205f, [6, [0x0020], 0]);
        t.add(0x2060, 0x2060, [1, [], 0]);
        t.add(0x2061, 0x2063, [4, [], 0]);
        t.add(0x2064, 0x2064, [1, [], 0]);
        t.add(0x2065, 0x2065, [4, [], 0]);
        t.add(0x2066, 0x2069, [4, [], 0]);
        t.add(0x206a, 0x206f, [4, [], 0]);
        t.add(0x2070, 0x2070, [2, [0x0030], 0]);
        t.add(0x2071, 0x2071, [2, [0x0069], 0]);
        t.add(0x2072, 0x2073, [4, [], 0]);
        t.add(0x2074, 0x2074, [2, [0x0034], 0]);
        t.add(0x2075, 0x2075, [2, [0x0035], 0]);
        t.add(0x2076, 0x2076, [2, [0x0036], 0]);
        t.add(0x2077, 0x2077, [2, [0x0037], 0]);
        t.add(0x2078, 0x2078, [2, [0x0038], 0]);
        t.add(0x2079, 0x2079, [2, [0x0039], 0]);
        t.add(0x207a, 0x207a, [6, [0x002B], 0]);
        t.add(0x207b, 0x207b, [2, [0x2212], 0]);
        t.add(0x207c, 0x207c, [6, [0x003D], 0]);
        t.add(0x207d, 0x207d, [6, [0x0028], 0]);
        t.add(0x207e, 0x207e, [6, [0x0029], 0]);
        t.add(0x207f, 0x207f, [2, [0x006E], 0]);
        t.add(0x2080, 0x2080, [2, [0x0030], 0]);
        t.add(0x2081, 0x2081, [2, [0x0031], 0]);
        t.add(0x2082, 0x2082, [2, [0x0032], 0]);
        t.add(0x2083, 0x2083, [2, [0x0033], 0]);
        t.add(0x2084, 0x2084, [2, [0x0034], 0]);
        t.add(0x2085, 0x2085, [2, [0x0035], 0]);
        t.add(0x2086, 0x2086, [2, [0x0036], 0]);
        t.add(0x2087, 0x2087, [2, [0x0037], 0]);
        t.add(0x2088, 0x2088, [2, [0x0038], 0]);
        t.add(0x2089, 0x2089, [2, [0x0039], 0]);
        t.add(0x208a, 0x208a, [6, [0x002B], 0]);
        t.add(0x208b, 0x208b, [2, [0x2212], 0]);
        t.add(0x208c, 0x208c, [6, [0x003D], 0]);
        t.add(0x208d, 0x208d, [6, [0x0028], 0]);
        t.add(0x208e, 0x208e, [6, [0x0029], 0]);
        t.add(0x208f, 0x208f, [4, [], 0]);
        t.add(0x2090, 0x2090, [2, [0x0061], 0]);
        t.add(0x2091, 0x2091, [2, [0x0065], 0]);
        t.add(0x2092, 0x2092, [2, [0x006F], 0]);
        t.add(0x2093, 0x2093, [2, [0x0078], 0]);
        t.add(0x2094, 0x2094, [2, [0x0259], 0]);
        t.add(0x2095, 0x2095, [2, [0x0068], 0]);
        t.add(0x2096, 0x2096, [2, [0x006B], 0]);
        t.add(0x2097, 0x2097, [2, [0x006C], 0]);
        t.add(0x2098, 0x2098, [2, [0x006D], 0]);
        t.add(0x2099, 0x2099, [2, [0x006E], 0]);
        t.add(0x209a, 0x209a, [2, [0x0070], 0]);
        t.add(0x209b, 0x209b, [2, [0x0073], 0]);
        t.add(0x209c, 0x209c, [2, [0x0074], 0]);
        t.add(0x209d, 0x209f, [4, [], 0]);
        t.add(0x20a0, 0x20a7, [0, [], 1]);
        t.add(0x20a8, 0x20a8, [2, [0x0072, 0x0073], 0]);
        t.add(0x20a9, 0x20aa, [0, [], 1]);
        t.add(0x20ab, 0x20ab, [0, [], 1]);
        t.add(0x20ac, 0x20ac, [0, [], 1]);
        t.add(0x20ad, 0x20af, [0, [], 1]);
        t.add(0x20b0, 0x20b1, [0, [], 1]);
        t.add(0x20b2, 0x20b5, [0, [], 1]);
        t.add(0x20b6, 0x20b8, [0, [], 1]);
        t.add(0x20b9, 0x20b9, [0, [], 1]);
        t.add(0x20ba, 0x20ba, [0, [], 1]);
        t.add(0x20bb, 0x20bd, [0, [], 1]);
        t.add(0x20be, 0x20be, [0, [], 1]);
        t.add(0x20bf, 0x20bf, [0, [], 1]);
        t.add(0x20c0, 0x20cf, [4, [], 0]);
        t.add(0x20d0, 0x20e1, [0, [], 1]);
        t.add(0x20e2, 0x20e3, [0, [], 1]);
        t.add(0x20e4, 0x20ea, [0, [], 1]);
        t.add(0x20eb, 0x20eb, [0, [], 1]);
        t.add(0x20ec, 0x20ef, [0, [], 1]);
        t.add(0x20f0, 0x20f0, [0, [], 1]);
        t.add(0x20f1, 0x20ff, [4, [], 0]);
        t.add(0x2100, 0x2100, [6, [0x0061, 0x002F, 0x0063], 0]);
        t.add(0x2101, 0x2101, [6, [0x0061, 0x002F, 0x0073], 0]);
        t.add(0x2102, 0x2102, [2, [0x0063], 0]);
        t.add(0x2103, 0x2103, [2, [0x00B0, 0x0063], 0]);
        t.add(0x2104, 0x2104, [0, [], 1]);
        t.add(0x2105, 0x2105, [6, [0x0063, 0x002F, 0x006F], 0]);
        t.add(0x2106, 0x2106, [6, [0x0063, 0x002F, 0x0075], 0]);
        t.add(0x2107, 0x2107, [2, [0x025B], 0]);
        t.add(0x2108, 0x2108, [0, [], 1]);
        t.add(0x2109, 0x2109, [2, [0x00B0, 0x0066], 0]);
        t.add(0x210a, 0x210a, [2, [0x0067], 0]);
        t.add(0x210b, 0x210e, [2, [0x0068], 0]);
        t.add(0x210f, 0x210f, [2, [0x0127], 0]);
        t.add(0x2110, 0x2111, [2, [0x0069], 0]);
        t.add(0x2112, 0x2113, [2, [0x006C], 0]);
        t.add(0x2114, 0x2114, [0, [], 1]);
        t.add(0x2115, 0x2115, [2, [0x006E], 0]);
        t.add(0x2116, 0x2116, [2, [0x006E, 0x006F], 0]);
        t.add(0x2117, 0x2118, [0, [], 1]);
        t.add(0x2119, 0x2119, [2, [0x0070], 0]);
        t.add(0x211a, 0x211a, [2, [0x0071], 0]);
        t.add(0x211b, 0x211d, [2, [0x0072], 0]);
        t.add(0x211e, 0x211f, [0, [], 1]);
        t.add(0x2120, 0x2120, [2, [0x0073, 0x006D], 0]);
        t.add(0x2121, 0x2121, [2, [0x0074, 0x0065, 0x006C], 0]);
        t.add(0x2122, 0x2122, [2, [0x0074, 0x006D], 0]);
        t.add(0x2123, 0x2123, [0, [], 1]);
        t.add(0x2124, 0x2124, [2, [0x007A], 0]);
        t.add(0x2125, 0x2125, [0, [], 1]);
        t.add(0x2126, 0x2126, [2, [0x03C9], 0]);
        t.add(0x2127, 0x2127, [0, [], 1]);
        t.add(0x2128, 0x2128, [2, [0x007A], 0]);
        t.add(0x2129, 0x2129, [0, [], 1]);
        t.add(0x212a, 0x212a, [2, [0x006B], 0]);
        t.add(0x212b, 0x212b, [2, [0x00E5], 0]);
        t.add(0x212c, 0x212c, [2, [0x0062], 0]);
        t.add(0x212d, 0x212d, [2, [0x0063], 0]);
        t.add(0x212e, 0x212e, [0, [], 1]);
        t.add(0x212f, 0x2130, [2, [0x0065], 0]);
        t.add(0x2131, 0x2131, [2, [0x0066], 0]);
        t.add(0x2132, 0x2132, [4, [], 0]);
        t.add(0x2133, 0x2133, [2, [0x006D], 0]);
        t.add(0x2134, 0x2134, [2, [0x006F], 0]);
        t.add(0x2135, 0x2135, [2, [0x05D0], 0]);
        t.add(0x2136, 0x2136, [2, [0x05D1], 0]);
        t.add(0x2137, 0x2137, [2, [0x05D2], 0]);
        t.add(0x2138, 0x2138, [2, [0x05D3], 0]);
        t.add(0x2139, 0x2139, [2, [0x0069], 0]);
        t.add(0x213a, 0x213a, [0, [], 1]);
        t.add(0x213b, 0x213b, [2, [0x0066, 0x0061, 0x0078], 0]);
        t.add(0x213c, 0x213c, [2, [0x03C0], 0]);
        t.add(0x213d, 0x213e, [2, [0x03B3], 0]);
        t.add(0x213f, 0x213f, [2, [0x03C0], 0]);
        t.add(0x2140, 0x2140, [2, [0x2211], 0]);
        t.add(0x2141, 0x2144, [0, [], 1]);
        t.add(0x2145, 0x2146, [2, [0x0064], 0]);
        t.add(0x2147, 0x2147, [2, [0x0065], 0]);
        t.add(0x2148, 0x2148, [2, [0x0069], 0]);
        t.add(0x2149, 0x2149, [2, [0x006A], 0]);
        t.add(0x214a, 0x214b, [0, [], 1]);
        t.add(0x214c, 0x214c, [0, [], 1]);
        t.add(0x214d, 0x214d, [0, [], 1]);
        t.add(0x214e, 0x214e, [0, [], 0]);
        t.add(0x214f, 0x214f, [0, [], 1]);
        t.add(0x2150, 0x2150, [2, [0x0031, 0x2044, 0x0037], 0]);
        t.add(0x2151, 0x2151, [2, [0x0031, 0x2044, 0x0039], 0]);
        t.add(0x2152, 0x2152, [2, [0x0031, 0x2044, 0x0031, 0x0030], 0]);
        t.add(0x2153, 0x2153, [2, [0x0031, 0x2044, 0x0033], 0]);
        t.add(0x2154, 0x2154, [2, [0x0032, 0x2044, 0x0033], 0]);
        t.add(0x2155, 0x2155, [2, [0x0031, 0x2044, 0x0035], 0]);
        t.add(0x2156, 0x2156, [2, [0x0032, 0x2044, 0x0035], 0]);
        t.add(0x2157, 0x2157, [2, [0x0033, 0x2044, 0x0035], 0]);
        t.add(0x2158, 0x2158, [2, [0x0034, 0x2044, 0x0035], 0]);
        t.add(0x2159, 0x2159, [2, [0x0031, 0x2044, 0x0036], 0]);
        t.add(0x215a, 0x215a, [2, [0x0035, 0x2044, 0x0036], 0]);
        t.add(0x215b, 0x215b, [2, [0x0031, 0x2044, 0x0038], 0]);
        t.add(0x215c, 0x215c, [2, [0x0033, 0x2044, 0x0038], 0]);
        t.add(0x215d, 0x215d, [2, [0x0035, 0x2044, 0x0038], 0]);
        t.add(0x215e, 0x215e, [2, [0x0037, 0x2044, 0x0038], 0]);
        t.add(0x215f, 0x215f, [2, [0x0031, 0x2044], 0]);
        t.add(0x2160, 0x2160, [2, [0x0069], 0]);
        t.add(0x2161, 0x2161, [2, [0x0069, 0x0069], 0]);
        t.add(0x2162, 0x2162, [2, [0x0069, 0x0069, 0x0069], 0]);
        t.add(0x2163, 0x2163, [2, [0x0069, 0x0076], 0]);
        t.add(0x2164, 0x2164, [2, [0x0076], 0]);
        t.add(0x2165, 0x2165, [2, [0x0076, 0x0069], 0]);
        t.add(0x2166, 0x2166, [2, [0x0076, 0x0069, 0x0069], 0]);
        t.add(0x2167, 0x2167, [2, [0x0076, 0x0069, 0x0069, 0x0069], 0]);
        t.add(0x2168, 0x2168, [2, [0x0069, 0x0078], 0]);
        t.add(0x2169, 0x2169, [2, [0x0078], 0]);
        t.add(0x216a, 0x216a, [2, [0x0078, 0x0069], 0]);
        t.add(0x216b, 0x216b, [2, [0x0078, 0x0069, 0x0069], 0]);
        t.add(0x216c, 0x216c, [2, [0x006C], 0]);
        t.add(0x216d, 0x216d, [2, [0x0063], 0]);
        t.add(0x216e, 0x216e, [2, [0x0064], 0]);
        t.add(0x216f, 0x216f, [2, [0x006D], 0]);
        t.add(0x2170, 0x2170, [2, [0x0069], 0]);
        t.add(0x2171, 0x2171, [2, [0x0069, 0x0069], 0]);
        t.add(0x2172, 0x2172, [2, [0x0069, 0x0069, 0x0069], 0]);
        t.add(0x2173, 0x2173, [2, [0x0069, 0x0076], 0]);
        t.add(0x2174, 0x2174, [2, [0x0076], 0]);
        t.add(0x2175, 0x2175, [2, [0x0076, 0x0069], 0]);
        t.add(0x2176, 0x2176, [2, [0x0076, 0x0069, 0x0069], 0]);
        t.add(0x2177, 0x2177, [2, [0x0076, 0x0069, 0x0069, 0x0069], 0]);
        t.add(0x2178, 0x2178, [2, [0x0069, 0x0078], 0]);
        t.add(0x2179, 0x2179, [2, [0x0078], 0]);
        t.add(0x217a, 0x217a, [2, [0x0078, 0x0069], 0]);
        t.add(0x217b, 0x217b, [2, [0x0078, 0x0069, 0x0069], 0]);
        t.add(0x217c, 0x217c, [2, [0x006C], 0]);
        t.add(0x217d, 0x217d, [2, [0x0063], 0]);
        t.add(0x217e, 0x217e, [2, [0x0064], 0]);
        t.add(0x217f, 0x217f, [2, [0x006D], 0]);
        t.add(0x2180, 0x2182, [0, [], 1]);
        t.add(0x2183, 0x2183, [4, [], 0]);
        t.add(0x2184, 0x2184, [0, [], 0]);
        t.add(0x2185, 0x2188, [0, [], 1]);
        t.add(0x2189, 0x2189, [2, [0x0030, 0x2044, 0x0033], 0]);
        t.add(0x218a, 0x218b, [0, [], 1]);
        t.add(0x218c, 0x218f, [4, [], 0]);
        t.add(0x2190, 0x21ea, [0, [], 1]);
        t.add(0x21eb, 0x21f3, [0, [], 1]);
        t.add(0x21f4, 0x21ff, [0, [], 1]);
        t.add(0x2200, 0x222b, [0, [], 1]);
        t.add(0x222c, 0x222c, [2, [0x222B, 0x222B], 0]);
        t.add(0x222d, 0x222d, [2, [0x222B, 0x222B, 0x222B], 0]);
        t.add(0x222e, 0x222e, [0, [], 1]);
        t.add(0x222f, 0x222f, [2, [0x222E, 0x222E], 0]);
        t.add(0x2230, 0x2230, [2, [0x222E, 0x222E, 0x222E], 0]);
        t.add(0x2231, 0x225f, [0, [], 1]);
        t.add(0x2260, 0x2260, [5, [], 0]);
        t.add(0x2261, 0x226d, [0, [], 1]);
        t.add(0x226e, 0x226f, [5, [], 0]);
        t.add(0x2270, 0x22f1, [0, [], 1]);
        t.add(0x22f2, 0x22ff, [0, [], 1]);
        t.add(0x2300, 0x2300, [0, [], 1]);
        t.add(0x2301, 0x2301, [0, [], 1]);
        t.add(0x2302, 0x2328, [0, [], 1]);
        t.add(0x2329, 0x2329, [2, [0x3008], 0]);
        t.add(0x232a, 0x232a, [2, [0x3009], 0]);
        t.add(0x232b, 0x237a, [0, [], 1]);
        t.add(0x237b, 0x237b, [0, [], 1]);
        t.add(0x237c, 0x237c, [0, [], 1]);
        t.add(0x237d, 0x239a, [0, [], 1]);
        t.add(0x239b, 0x23ce, [0, [], 1]);
        t.add(0x23cf, 0x23d0, [0, [], 1]);
        t.add(0x23d1, 0x23db, [0, [], 1]);
        t.add(0x23dc, 0x23e7, [0, [], 1]);
        t.add(0x23e8, 0x23e8, [0, [], 1]);
        t.add(0x23e9, 0x23f3, [0, [], 1]);
        t.add(0x23f4, 0x23fa, [0, [], 1]);
        t.add(0x23fb, 0x23fe, [0, [], 1]);
        t.add(0x23ff, 0x23ff, [0, [], 1]);
        t.add(0x2400, 0x2424, [0, [], 1]);
        t.add(0x2425, 0x2426, [0, [], 1]);
        t.add(0x2427, 0x243f, [4, [], 0]);
        t.add(0x2440, 0x244a, [0, [], 1]);
        t.add(0x244b, 0x245f, [4, [], 0]);
        t.add(0x2460, 0x2460, [2, [0x0031], 0]);
        t.add(0x2461, 0x2461, [2, [0x0032], 0]);
        t.add(0x2462, 0x2462, [2, [0x0033], 0]);
        t.add(0x2463, 0x2463, [2, [0x0034], 0]);
        t.add(0x2464, 0x2464, [2, [0x0035], 0]);
        t.add(0x2465, 0x2465, [2, [0x0036], 0]);
        t.add(0x2466, 0x2466, [2, [0x0037], 0]);
        t.add(0x2467, 0x2467, [2, [0x0038], 0]);
        t.add(0x2468, 0x2468, [2, [0x0039], 0]);
        t.add(0x2469, 0x2469, [2, [0x0031, 0x0030], 0]);
        t.add(0x246a, 0x246a, [2, [0x0031, 0x0031], 0]);
        t.add(0x246b, 0x246b, [2, [0x0031, 0x0032], 0]);
        t.add(0x246c, 0x246c, [2, [0x0031, 0x0033], 0]);
        t.add(0x246d, 0x246d, [2, [0x0031, 0x0034], 0]);
        t.add(0x246e, 0x246e, [2, [0x0031, 0x0035], 0]);
        t.add(0x246f, 0x246f, [2, [0x0031, 0x0036], 0]);
        t.add(0x2470, 0x2470, [2, [0x0031, 0x0037], 0]);
        t.add(0x2471, 0x2471, [2, [0x0031, 0x0038], 0]);
        t.add(0x2472, 0x2472, [2, [0x0031, 0x0039], 0]);
        t.add(0x2473, 0x2473, [2, [0x0032, 0x0030], 0]);
        t.add(0x2474, 0x2474, [6, [0x0028, 0x0031, 0x0029], 0]);
        t.add(0x2475, 0x2475, [6, [0x0028, 0x0032, 0x0029], 0]);
        t.add(0x2476, 0x2476, [6, [0x0028, 0x0033, 0x0029], 0]);
        t.add(0x2477, 0x2477, [6, [0x0028, 0x0034, 0x0029], 0]);
        t.add(0x2478, 0x2478, [6, [0x0028, 0x0035, 0x0029], 0]);
        t.add(0x2479, 0x2479, [6, [0x0028, 0x0036, 0x0029], 0]);
        t.add(0x247a, 0x247a, [6, [0x0028, 0x0037, 0x0029], 0]);
        t.add(0x247b, 0x247b, [6, [0x0028, 0x0038, 0x0029], 0]);
        t.add(0x247c, 0x247c, [6, [0x0028, 0x0039, 0x0029], 0]);
        t.add(0x247d, 0x247d, [6, [0x0028, 0x0031, 0x0030, 0x0029], 0]);
        t.add(0x247e, 0x247e, [6, [0x0028, 0x0031, 0x0031, 0x0029], 0]);
        t.add(0x247f, 0x247f, [6, [0x0028, 0x0031, 0x0032, 0x0029], 0]);
        t.add(0x2480, 0x2480, [6, [0x0028, 0x0031, 0x0033, 0x0029], 0]);
        t.add(0x2481, 0x2481, [6, [0x0028, 0x0031, 0x0034, 0x0029], 0]);
        t.add(0x2482, 0x2482, [6, [0x0028, 0x0031, 0x0035, 0x0029], 0]);
        t.add(0x2483, 0x2483, [6, [0x0028, 0x0031, 0x0036, 0x0029], 0]);
        t.add(0x2484, 0x2484, [6, [0x0028, 0x0031, 0x0037, 0x0029], 0]);
        t.add(0x2485, 0x2485, [6, [0x0028, 0x0031, 0x0038, 0x0029], 0]);
        t.add(0x2486, 0x2486, [6, [0x0028, 0x0031, 0x0039, 0x0029], 0]);
        t.add(0x2487, 0x2487, [6, [0x0028, 0x0032, 0x0030, 0x0029], 0]);
        t.add(0x2488, 0x249b, [4, [], 0]);
        t.add(0x249c, 0x249c, [6, [0x0028, 0x0061, 0x0029], 0]);
        t.add(0x249d, 0x249d, [6, [0x0028, 0x0062, 0x0029], 0]);
        t.add(0x249e, 0x249e, [6, [0x0028, 0x0063, 0x0029], 0]);
        t.add(0x249f, 0x249f, [6, [0x0028, 0x0064, 0x0029], 0]);
        t.add(0x24a0, 0x24a0, [6, [0x0028, 0x0065, 0x0029], 0]);
        t.add(0x24a1, 0x24a1, [6, [0x0028, 0x0066, 0x0029], 0]);
        t.add(0x24a2, 0x24a2, [6, [0x0028, 0x0067, 0x0029], 0]);
        t.add(0x24a3, 0x24a3, [6, [0x0028, 0x0068, 0x0029], 0]);
        t.add(0x24a4, 0x24a4, [6, [0x0028, 0x0069, 0x0029], 0]);
        t.add(0x24a5, 0x24a5, [6, [0x0028, 0x006A, 0x0029], 0]);
        t.add(0x24a6, 0x24a6, [6, [0x0028, 0x006B, 0x0029], 0]);
        t.add(0x24a7, 0x24a7, [6, [0x0028, 0x006C, 0x0029], 0]);
        t.add(0x24a8, 0x24a8, [6, [0x0028, 0x006D, 0x0029], 0]);
        t.add(0x24a9, 0x24a9, [6, [0x0028, 0x006E, 0x0029], 0]);
        t.add(0x24aa, 0x24aa, [6, [0x0028, 0x006F, 0x0029], 0]);
        t.add(0x24ab, 0x24ab, [6, [0x0028, 0x0070, 0x0029], 0]);
        t.add(0x24ac, 0x24ac, [6, [0x0028, 0x0071, 0x0029], 0]);
        t.add(0x24ad, 0x24ad, [6, [0x0028, 0x0072, 0x0029], 0]);
        t.add(0x24ae, 0x24ae, [6, [0x0028, 0x0073, 0x0029], 0]);
        t.add(0x24af, 0x24af, [6, [0x0028, 0x0074, 0x0029], 0]);
        t.add(0x24b0, 0x24b0, [6, [0x0028, 0x0075, 0x0029], 0]);
        t.add(0x24b1, 0x24b1, [6, [0x0028, 0x0076, 0x0029], 0]);
        t.add(0x24b2, 0x24b2, [6, [0x0028, 0x0077, 0x0029], 0]);
        t.add(0x24b3, 0x24b3, [6, [0x0028, 0x0078, 0x0029], 0]);
        t.add(0x24b4, 0x24b4, [6, [0x0028, 0x0079, 0x0029], 0]);
        t.add(0x24b5, 0x24b5, [6, [0x0028, 0x007A, 0x0029], 0]);
        t.add(0x24b6, 0x24b6, [2, [0x0061], 0]);
        t.add(0x24b7, 0x24b7, [2, [0x0062], 0]);
        t.add(0x24b8, 0x24b8, [2, [0x0063], 0]);
        t.add(0x24b9, 0x24b9, [2, [0x0064], 0]);
        t.add(0x24ba, 0x24ba, [2, [0x0065], 0]);
        t.add(0x24bb, 0x24bb, [2, [0x0066], 0]);
        t.add(0x24bc, 0x24bc, [2, [0x0067], 0]);
        t.add(0x24bd, 0x24bd, [2, [0x0068], 0]);
        t.add(0x24be, 0x24be, [2, [0x0069], 0]);
        t.add(0x24bf, 0x24bf, [2, [0x006A], 0]);
        t.add(0x24c0, 0x24c0, [2, [0x006B], 0]);
        t.add(0x24c1, 0x24c1, [2, [0x006C], 0]);
        t.add(0x24c2, 0x24c2, [2, [0x006D], 0]);
        t.add(0x24c3, 0x24c3, [2, [0x006E], 0]);
        t.add(0x24c4, 0x24c4, [2, [0x006F], 0]);
        t.add(0x24c5, 0x24c5, [2, [0x0070], 0]);
        t.add(0x24c6, 0x24c6, [2, [0x0071], 0]);
        t.add(0x24c7, 0x24c7, [2, [0x0072], 0]);
        t.add(0x24c8, 0x24c8, [2, [0x0073], 0]);
        t.add(0x24c9, 0x24c9, [2, [0x0074], 0]);
        t.add(0x24ca, 0x24ca, [2, [0x0075], 0]);
        t.add(0x24cb, 0x24cb, [2, [0x0076], 0]);
        t.add(0x24cc, 0x24cc, [2, [0x0077], 0]);
        t.add(0x24cd, 0x24cd, [2, [0x0078], 0]);
        t.add(0x24ce, 0x24ce, [2, [0x0079], 0]);
        t.add(0x24cf, 0x24cf, [2, [0x007A], 0]);
        t.add(0x24d0, 0x24d0, [2, [0x0061], 0]);
        t.add(0x24d1, 0x24d1, [2, [0x0062], 0]);
        t.add(0x24d2, 0x24d2, [2, [0x0063], 0]);
        t.add(0x24d3, 0x24d3, [2, [0x0064], 0]);
        t.add(0x24d4, 0x24d4, [2, [0x0065], 0]);
        t.add(0x24d5, 0x24d5, [2, [0x0066], 0]);
        t.add(0x24d6, 0x24d6, [2, [0x0067], 0]);
        t.add(0x24d7, 0x24d7, [2, [0x0068], 0]);
        t.add(0x24d8, 0x24d8, [2, [0x0069], 0]);
        t.add(0x24d9, 0x24d9, [2, [0x006A], 0]);
        t.add(0x24da, 0x24da, [2, [0x006B], 0]);
        t.add(0x24db, 0x24db, [2, [0x006C], 0]);
        t.add(0x24dc, 0x24dc, [2, [0x006D], 0]);
        t.add(0x24dd, 0x24dd, [2, [0x006E], 0]);
        t.add(0x24de, 0x24de, [2, [0x006F], 0]);
        t.add(0x24df, 0x24df, [2, [0x0070], 0]);
        t.add(0x24e0, 0x24e0, [2, [0x0071], 0]);
        t.add(0x24e1, 0x24e1, [2, [0x0072], 0]);
        t.add(0x24e2, 0x24e2, [2, [0x0073], 0]);
        t.add(0x24e3, 0x24e3, [2, [0x0074], 0]);
        t.add(0x24e4, 0x24e4, [2, [0x0075], 0]);
        t.add(0x24e5, 0x24e5, [2, [0x0076], 0]);
        t.add(0x24e6, 0x24e6, [2, [0x0077], 0]);
        t.add(0x24e7, 0x24e7, [2, [0x0078], 0]);
        t.add(0x24e8, 0x24e8, [2, [0x0079], 0]);
        t.add(0x24e9, 0x24e9, [2, [0x007A], 0]);
        t.add(0x24ea, 0x24ea, [2, [0x0030], 0]);
        t.add(0x24eb, 0x24fe, [0, [], 1]);
        t.add(0x24ff, 0x24ff, [0, [], 1]);
        t.add(0x2500, 0x2595, [0, [], 1]);
        t.add(0x2596, 0x259f, [0, [], 1]);
        t.add(0x25a0, 0x25ef, [0, [], 1]);
        t.add(0x25f0, 0x25f7, [0, [], 1]);
        t.add(0x25f8, 0x25ff, [0, [], 1]);
        t.add(0x2600, 0x2613, [0, [], 1]);
        t.add(0x2614, 0x2615, [0, [], 1]);
        t.add(0x2616, 0x2617, [0, [], 1]);
        t.add(0x2618, 0x2618, [0, [], 1]);
        t.add(0x2619, 0x2619, [0, [], 1]);
        t.add(0x261a, 0x266f, [0, [], 1]);
        t.add(0x2670, 0x2671, [0, [], 1]);
        t.add(0x2672, 0x267d, [0, [], 1]);
        t.add(0x267e, 0x267f, [0, [], 1]);
        t.add(0x2680, 0x2689, [0, [], 1]);
        t.add(0x268a, 0x2691, [0, [], 1]);
        t.add(0x2692, 0x269c, [0, [], 1]);
        t.add(0x269d, 0x269d, [0, [], 1]);
        t.add(0x269e, 0x269f, [0, [], 1]);
        t.add(0x26a0, 0x26a1, [0, [], 1]);
        t.add(0x26a2, 0x26b1, [0, [], 1]);
        t.add(0x26b2, 0x26b2, [0, [], 1]);
        t.add(0x26b3, 0x26bc, [0, [], 1]);
        t.add(0x26bd, 0x26bf, [0, [], 1]);
        t.add(0x26c0, 0x26c3, [0, [], 1]);
        t.add(0x26c4, 0x26cd, [0, [], 1]);
        t.add(0x26ce, 0x26ce, [0, [], 1]);
        t.add(0x26cf, 0x26e1, [0, [], 1]);
        t.add(0x26e2, 0x26e2, [0, [], 1]);
        t.add(0x26e3, 0x26e3, [0, [], 1]);
        t.add(0x26e4, 0x26e7, [0, [], 1]);
        t.add(0x26e8, 0x26ff, [0, [], 1]);
        t.add(0x2700, 0x2700, [0, [], 1]);
        t.add(0x2701, 0x2704, [0, [], 1]);
        t.add(0x2705, 0x2705, [0, [], 1]);
        t.add(0x2706, 0x2709, [0, [], 1]);
        t.add(0x270a, 0x270b, [0, [], 1]);
        t.add(0x270c, 0x2727, [0, [], 1]);
        t.add(0x2728, 0x2728, [0, [], 1]);
        t.add(0x2729, 0x274b, [0, [], 1]);
        t.add(0x274c, 0x274c, [0, [], 1]);
        t.add(0x274d, 0x274d, [0, [], 1]);
        t.add(0x274e, 0x274e, [0, [], 1]);
        t.add(0x274f, 0x2752, [0, [], 1]);
        t.add(0x2753, 0x2755, [0, [], 1]);
        t.add(0x2756, 0x2756, [0, [], 1]);
        t.add(0x2757, 0x2757, [0, [], 1]);
        t.add(0x2758, 0x275e, [0, [], 1]);
        t.add(0x275f, 0x2760, [0, [], 1]);
        t.add(0x2761, 0x2767, [0, [], 1]);
        t.add(0x2768, 0x2775, [0, [], 1]);
        t.add(0x2776, 0x2794, [0, [], 1]);
        t.add(0x2795, 0x2797, [0, [], 1]);
        t.add(0x2798, 0x27af, [0, [], 1]);
        t.add(0x27b0, 0x27b0, [0, [], 1]);
        t.add(0x27b1, 0x27be, [0, [], 1]);
        t.add(0x27bf, 0x27bf, [0, [], 1]);
        t.add(0x27c0, 0x27c6, [0, [], 1]);
        t.add(0x27c7, 0x27ca, [0, [], 1]);
        t.add(0x27cb, 0x27cb, [0, [], 1]);
        t.add(0x27cc, 0x27cc, [0, [], 1]);
        t.add(0x27cd, 0x27cd, [0, [], 1]);
        t.add(0x27ce, 0x27cf, [0, [], 1]);
        t.add(0x27d0, 0x27eb, [0, [], 1]);
        t.add(0x27ec, 0x27ef, [0, [], 1]);
        t.add(0x27f0, 0x27ff, [0, [], 1]);
        t.add(0x2800, 0x28ff, [0, [], 1]);
        t.add(0x2900, 0x2a0b, [0, [], 1]);
        t.add(0x2a0c, 0x2a0c, [2, [0x222B, 0x222B, 0x222B, 0x222B], 0]);
        t.add(0x2a0d, 0x2a73, [0, [], 1]);
        t.add(0x2a74, 0x2a74, [6, [0x003A, 0x003A, 0x003D], 0]);
        t.add(0x2a75, 0x2a75, [6, [0x003D, 0x003D], 0]);
        t.add(0x2a76, 0x2a76, [6, [0x003D, 0x003D, 0x003D], 0]);
        t.add(0x2a77, 0x2adb, [0, [], 1]);
        t.add(0x2adc, 0x2adc, [2, [0x2ADD, 0x0338], 0]);
        t.add(0x2add, 0x2aff, [0, [], 1]);
        t.add(0x2b00, 0x2b0d, [0, [], 1]);
        t.add(0x2b0e, 0x2b13, [0, [], 1]);
        t.add(0x2b14, 0x2b1a, [0, [], 1]);
        t.add(0x2b1b, 0x2b1f, [0, [], 1]);
        t.add(0x2b20, 0x2b23, [0, [], 1]);
        t.add(0x2b24, 0x2b4c, [0, [], 1]);
        t.add(0x2b4d, 0x2b4f, [0, [], 1]);
        t.add(0x2b50, 0x2b54, [0, [], 1]);
        t.add(0x2b55, 0x2b59, [0, [], 1]);
        t.add(0x2b5a, 0x2b73, [0, [], 1]);
        t.add(0x2b74, 0x2b75, [4, [], 0]);
        t.add(0x2b76, 0x2b95, [0, [], 1]);
        t.add(0x2b96, 0x2b97, [4, [], 0]);
        t.add(0x2b98, 0x2bb9, [0, [], 1]);
        t.add(0x2bba, 0x2bbc, [0, [], 1]);
        t.add(0x2bbd, 0x2bc8, [0, [], 1]);
        t.add(0x2bc9, 0x2bc9, [0, [], 1]);
        t.add(0x2bca, 0x2bd1, [0, [], 1]);
        t.add(0x2bd2, 0x2bd2, [0, [], 1]);
        t.add(0x2bd3, 0x2beb, [0, [], 1]);
        t.add(0x2bec, 0x2bef, [0, [], 1]);
        t.add(0x2bf0, 0x2bfe, [0, [], 1]);
        t.add(0x2bff, 0x2bff, [0, [], 1]);
        t.add(0x2c00, 0x2c00, [2, [0x2C30], 0]);
        t.add(0x2c01, 0x2c01, [2, [0x2C31], 0]);
        t.add(0x2c02, 0x2c02, [2, [0x2C32], 0]);
        t.add(0x2c03, 0x2c03, [2, [0x2C33], 0]);
        t.add(0x2c04, 0x2c04, [2, [0x2C34], 0]);
        t.add(0x2c05, 0x2c05, [2, [0x2C35], 0]);
        t.add(0x2c06, 0x2c06, [2, [0x2C36], 0]);
        t.add(0x2c07, 0x2c07, [2, [0x2C37], 0]);
        t.add(0x2c08, 0x2c08, [2, [0x2C38], 0]);
        t.add(0x2c09, 0x2c09, [2, [0x2C39], 0]);
        t.add(0x2c0a, 0x2c0a, [2, [0x2C3A], 0]);
        t.add(0x2c0b, 0x2c0b, [2, [0x2C3B], 0]);
        t.add(0x2c0c, 0x2c0c, [2, [0x2C3C], 0]);
        t.add(0x2c0d, 0x2c0d, [2, [0x2C3D], 0]);
        t.add(0x2c0e, 0x2c0e, [2, [0x2C3E], 0]);
        t.add(0x2c0f, 0x2c0f, [2, [0x2C3F], 0]);
        t.add(0x2c10, 0x2c10, [2, [0x2C40], 0]);
        t.add(0x2c11, 0x2c11, [2, [0x2C41], 0]);
        t.add(0x2c12, 0x2c12, [2, [0x2C42], 0]);
        t.add(0x2c13, 0x2c13, [2, [0x2C43], 0]);
        t.add(0x2c14, 0x2c14, [2, [0x2C44], 0]);
        t.add(0x2c15, 0x2c15, [2, [0x2C45], 0]);
        t.add(0x2c16, 0x2c16, [2, [0x2C46], 0]);
        t.add(0x2c17, 0x2c17, [2, [0x2C47], 0]);
        t.add(0x2c18, 0x2c18, [2, [0x2C48], 0]);
        t.add(0x2c19, 0x2c19, [2, [0x2C49], 0]);
        t.add(0x2c1a, 0x2c1a, [2, [0x2C4A], 0]);
        t.add(0x2c1b, 0x2c1b, [2, [0x2C4B], 0]);
        t.add(0x2c1c, 0x2c1c, [2, [0x2C4C], 0]);
        t.add(0x2c1d, 0x2c1d, [2, [0x2C4D], 0]);
        t.add(0x2c1e, 0x2c1e, [2, [0x2C4E], 0]);
        t.add(0x2c1f, 0x2c1f, [2, [0x2C4F], 0]);
        t.add(0x2c20, 0x2c20, [2, [0x2C50], 0]);
        t.add(0x2c21, 0x2c21, [2, [0x2C51], 0]);
        t.add(0x2c22, 0x2c22, [2, [0x2C52], 0]);
        t.add(0x2c23, 0x2c23, [2, [0x2C53], 0]);
        t.add(0x2c24, 0x2c24, [2, [0x2C54], 0]);
        t.add(0x2c25, 0x2c25, [2, [0x2C55], 0]);
        t.add(0x2c26, 0x2c26, [2, [0x2C56], 0]);
        t.add(0x2c27, 0x2c27, [2, [0x2C57], 0]);
        t.add(0x2c28, 0x2c28, [2, [0x2C58], 0]);
        t.add(0x2c29, 0x2c29, [2, [0x2C59], 0]);
        t.add(0x2c2a, 0x2c2a, [2, [0x2C5A], 0]);
        t.add(0x2c2b, 0x2c2b, [2, [0x2C5B], 0]);
        t.add(0x2c2c, 0x2c2c, [2, [0x2C5C], 0]);
        t.add(0x2c2d, 0x2c2d, [2, [0x2C5D], 0]);
        t.add(0x2c2e, 0x2c2e, [2, [0x2C5E], 0]);
        t.add(0x2c2f, 0x2c2f, [4, [], 0]);
        t.add(0x2c30, 0x2c5e, [0, [], 0]);
        t.add(0x2c5f, 0x2c5f, [4, [], 0]);
        t.add(0x2c60, 0x2c60, [2, [0x2C61], 0]);
        t.add(0x2c61, 0x2c61, [0, [], 0]);
        t.add(0x2c62, 0x2c62, [2, [0x026B], 0]);
        t.add(0x2c63, 0x2c63, [2, [0x1D7D], 0]);
        t.add(0x2c64, 0x2c64, [2, [0x027D], 0]);
        t.add(0x2c65, 0x2c66, [0, [], 0]);
        t.add(0x2c67, 0x2c67, [2, [0x2C68], 0]);
        t.add(0x2c68, 0x2c68, [0, [], 0]);
        t.add(0x2c69, 0x2c69, [2, [0x2C6A], 0]);
        t.add(0x2c6a, 0x2c6a, [0, [], 0]);
        t.add(0x2c6b, 0x2c6b, [2, [0x2C6C], 0]);
        t.add(0x2c6c, 0x2c6c, [0, [], 0]);
        t.add(0x2c6d, 0x2c6d, [2, [0x0251], 0]);
        t.add(0x2c6e, 0x2c6e, [2, [0x0271], 0]);
        t.add(0x2c6f, 0x2c6f, [2, [0x0250], 0]);
        t.add(0x2c70, 0x2c70, [2, [0x0252], 0]);
        t.add(0x2c71, 0x2c71, [0, [], 0]);
        t.add(0x2c72, 0x2c72, [2, [0x2C73], 0]);
        t.add(0x2c73, 0x2c73, [0, [], 0]);
        t.add(0x2c74, 0x2c74, [0, [], 0]);
        t.add(0x2c75, 0x2c75, [2, [0x2C76], 0]);
        t.add(0x2c76, 0x2c77, [0, [], 0]);
        t.add(0x2c78, 0x2c7b, [0, [], 0]);
        t.add(0x2c7c, 0x2c7c, [2, [0x006A], 0]);
        t.add(0x2c7d, 0x2c7d, [2, [0x0076], 0]);
        t.add(0x2c7e, 0x2c7e, [2, [0x023F], 0]);
        t.add(0x2c7f, 0x2c7f, [2, [0x0240], 0]);
        t.add(0x2c80, 0x2c80, [2, [0x2C81], 0]);
        t.add(0x2c81, 0x2c81, [0, [], 0]);
        t.add(0x2c82, 0x2c82, [2, [0x2C83], 0]);
        t.add(0x2c83, 0x2c83, [0, [], 0]);
        t.add(0x2c84, 0x2c84, [2, [0x2C85], 0]);
        t.add(0x2c85, 0x2c85, [0, [], 0]);
        t.add(0x2c86, 0x2c86, [2, [0x2C87], 0]);
        t.add(0x2c87, 0x2c87, [0, [], 0]);
        t.add(0x2c88, 0x2c88, [2, [0x2C89], 0]);
        t.add(0x2c89, 0x2c89, [0, [], 0]);
        t.add(0x2c8a, 0x2c8a, [2, [0x2C8B], 0]);
        t.add(0x2c8b, 0x2c8b, [0, [], 0]);
        t.add(0x2c8c, 0x2c8c, [2, [0x2C8D], 0]);
        t.add(0x2c8d, 0x2c8d, [0, [], 0]);
        t.add(0x2c8e, 0x2c8e, [2, [0x2C8F], 0]);
        t.add(0x2c8f, 0x2c8f, [0, [], 0]);
        t.add(0x2c90, 0x2c90, [2, [0x2C91], 0]);
        t.add(0x2c91, 0x2c91, [0, [], 0]);
        t.add(0x2c92, 0x2c92, [2, [0x2C93], 0]);
        t.add(0x2c93, 0x2c93, [0, [], 0]);
        t.add(0x2c94, 0x2c94, [2, [0x2C95], 0]);
        t.add(0x2c95, 0x2c95, [0, [], 0]);
        t.add(0x2c96, 0x2c96, [2, [0x2C97], 0]);
        t.add(0x2c97, 0x2c97, [0, [], 0]);
        t.add(0x2c98, 0x2c98, [2, [0x2C99], 0]);
        t.add(0x2c99, 0x2c99, [0, [], 0]);
        t.add(0x2c9a, 0x2c9a, [2, [0x2C9B], 0]);
        t.add(0x2c9b, 0x2c9b, [0, [], 0]);
        t.add(0x2c9c, 0x2c9c, [2, [0x2C9D], 0]);
        t.add(0x2c9d, 0x2c9d, [0, [], 0]);
        t.add(0x2c9e, 0x2c9e, [2, [0x2C9F], 0]);
        t.add(0x2c9f, 0x2c9f, [0, [], 0]);
        t.add(0x2ca0, 0x2ca0, [2, [0x2CA1], 0]);
        t.add(0x2ca1, 0x2ca1, [0, [], 0]);
        t.add(0x2ca2, 0x2ca2, [2, [0x2CA3], 0]);
        t.add(0x2ca3, 0x2ca3, [0, [], 0]);
        t.add(0x2ca4, 0x2ca4, [2, [0x2CA5], 0]);
        t.add(0x2ca5, 0x2ca5, [0, [], 0]);
        t.add(0x2ca6, 0x2ca6, [2, [0x2CA7], 0]);
        t.add(0x2ca7, 0x2ca7, [0, [], 0]);
        t.add(0x2ca8, 0x2ca8, [2, [0x2CA9], 0]);
        t.add(0x2ca9, 0x2ca9, [0, [], 0]);
        t.add(0x2caa, 0x2caa, [2, [0x2CAB], 0]);
        t.add(0x2cab, 0x2cab, [0, [], 0]);
        t.add(0x2cac, 0x2cac, [2, [0x2CAD], 0]);
        t.add(0x2cad, 0x2cad, [0, [], 0]);
        t.add(0x2cae, 0x2cae, [2, [0x2CAF], 0]);
        t.add(0x2caf, 0x2caf, [0, [], 0]);
        t.add(0x2cb0, 0x2cb0, [2, [0x2CB1], 0]);
        t.add(0x2cb1, 0x2cb1, [0, [], 0]);
        t.add(0x2cb2, 0x2cb2, [2, [0x2CB3], 0]);
        t.add(0x2cb3, 0x2cb3, [0, [], 0]);
        t.add(0x2cb4, 0x2cb4, [2, [0x2CB5], 0]);
        t.add(0x2cb5, 0x2cb5, [0, [], 0]);
        t.add(0x2cb6, 0x2cb6, [2, [0x2CB7], 0]);
        t.add(0x2cb7, 0x2cb7, [0, [], 0]);
        t.add(0x2cb8, 0x2cb8, [2, [0x2CB9], 0]);
        t.add(0x2cb9, 0x2cb9, [0, [], 0]);
        t.add(0x2cba, 0x2cba, [2, [0x2CBB], 0]);
        t.add(0x2cbb, 0x2cbb, [0, [], 0]);
        t.add(0x2cbc, 0x2cbc, [2, [0x2CBD], 0]);
        t.add(0x2cbd, 0x2cbd, [0, [], 0]);
        t.add(0x2cbe, 0x2cbe, [2, [0x2CBF], 0]);
        t.add(0x2cbf, 0x2cbf, [0, [], 0]);
        t.add(0x2cc0, 0x2cc0, [2, [0x2CC1], 0]);
        t.add(0x2cc1, 0x2cc1, [0, [], 0]);
        t.add(0x2cc2, 0x2cc2, [2, [0x2CC3], 0]);
        t.add(0x2cc3, 0x2cc3, [0, [], 0]);
        t.add(0x2cc4, 0x2cc4, [2, [0x2CC5], 0]);
        t.add(0x2cc5, 0x2cc5, [0, [], 0]);
        t.add(0x2cc6, 0x2cc6, [2, [0x2CC7], 0]);
        t.add(0x2cc7, 0x2cc7, [0, [], 0]);
        t.add(0x2cc8, 0x2cc8, [2, [0x2CC9], 0]);
        t.add(0x2cc9, 0x2cc9, [0, [], 0]);
        t.add(0x2cca, 0x2cca, [2, [0x2CCB], 0]);
        t.add(0x2ccb, 0x2ccb, [0, [], 0]);
        t.add(0x2ccc, 0x2ccc, [2, [0x2CCD], 0]);
        t.add(0x2ccd, 0x2ccd, [0, [], 0]);
        t.add(0x2cce, 0x2cce, [2, [0x2CCF], 0]);
        t.add(0x2ccf, 0x2ccf, [0, [], 0]);
        t.add(0x2cd0, 0x2cd0, [2, [0x2CD1], 0]);
        t.add(0x2cd1, 0x2cd1, [0, [], 0]);
        t.add(0x2cd2, 0x2cd2, [2, [0x2CD3], 0]);
        t.add(0x2cd3, 0x2cd3, [0, [], 0]);
        t.add(0x2cd4, 0x2cd4, [2, [0x2CD5], 0]);
        t.add(0x2cd5, 0x2cd5, [0, [], 0]);
        t.add(0x2cd6, 0x2cd6, [2, [0x2CD7], 0]);
        t.add(0x2cd7, 0x2cd7, [0, [], 0]);
        t.add(0x2cd8, 0x2cd8, [2, [0x2CD9], 0]);
        t.add(0x2cd9, 0x2cd9, [0, [], 0]);
        t.add(0x2cda, 0x2cda, [2, [0x2CDB], 0]);
        t.add(0x2cdb, 0x2cdb, [0, [], 0]);
        t.add(0x2cdc, 0x2cdc, [2, [0x2CDD], 0]);
        t.add(0x2cdd, 0x2cdd, [0, [], 0]);
        t.add(0x2cde, 0x2cde, [2, [0x2CDF], 0]);
        t.add(0x2cdf, 0x2cdf, [0, [], 0]);
        t.add(0x2ce0, 0x2ce0, [2, [0x2CE1], 0]);
        t.add(0x2ce1, 0x2ce1, [0, [], 0]);
        t.add(0x2ce2, 0x2ce2, [2, [0x2CE3], 0]);
        t.add(0x2ce3, 0x2ce4, [0, [], 0]);
        t.add(0x2ce5, 0x2cea, [0, [], 1]);
        t.add(0x2ceb, 0x2ceb, [2, [0x2CEC], 0]);
        t.add(0x2cec, 0x2cec, [0, [], 0]);
        t.add(0x2ced, 0x2ced, [2, [0x2CEE], 0]);
        t.add(0x2cee, 0x2cf1, [0, [], 0]);
        t.add(0x2cf2, 0x2cf2, [2, [0x2CF3], 0]);
        t.add(0x2cf3, 0x2cf3, [0, [], 0]);
        t.add(0x2cf4, 0x2cf8, [4, [], 0]);
        t.add(0x2cf9, 0x2cff, [0, [], 1]);
        t.add(0x2d00, 0x2d25, [0, [], 0]);
        t.add(0x2d26, 0x2d26, [4, [], 0]);
        t.add(0x2d27, 0x2d27, [0, [], 0]);
        t.add(0x2d28, 0x2d2c, [4, [], 0]);
        t.add(0x2d2d, 0x2d2d, [0, [], 0]);
        t.add(0x2d2e, 0x2d2f, [4, [], 0]);
        t.add(0x2d30, 0x2d65, [0, [], 0]);
        t.add(0x2d66, 0x2d67, [0, [], 0]);
        t.add(0x2d68, 0x2d6e, [4, [], 0]);
        t.add(0x2d6f, 0x2d6f, [2, [0x2D61], 0]);
        t.add(0x2d70, 0x2d70, [0, [], 1]);
        t.add(0x2d71, 0x2d7e, [4, [], 0]);
        t.add(0x2d7f, 0x2d7f, [0, [], 0]);
        t.add(0x2d80, 0x2d96, [0, [], 0]);
        t.add(0x2d97, 0x2d9f, [4, [], 0]);
        t.add(0x2da0, 0x2da6, [0, [], 0]);
        t.add(0x2da7, 0x2da7, [4, [], 0]);
        t.add(0x2da8, 0x2dae, [0, [], 0]);
        t.add(0x2daf, 0x2daf, [4, [], 0]);
        t.add(0x2db0, 0x2db6, [0, [], 0]);
        t.add(0x2db7, 0x2db7, [4, [], 0]);
        t.add(0x2db8, 0x2dbe, [0, [], 0]);
        t.add(0x2dbf, 0x2dbf, [4, [], 0]);
        t.add(0x2dc0, 0x2dc6, [0, [], 0]);
        t.add(0x2dc7, 0x2dc7, [4, [], 0]);
        t.add(0x2dc8, 0x2dce, [0, [], 0]);
        t.add(0x2dcf, 0x2dcf, [4, [], 0]);
        t.add(0x2dd0, 0x2dd6, [0, [], 0]);
        t.add(0x2dd7, 0x2dd7, [4, [], 0]);
        t.add(0x2dd8, 0x2dde, [0, [], 0]);
        t.add(0x2ddf, 0x2ddf, [4, [], 0]);
        t.add(0x2de0, 0x2dff, [0, [], 0]);
        t.add(0x2e00, 0x2e17, [0, [], 1]);
        t.add(0x2e18, 0x2e1b, [0, [], 1]);
        t.add(0x2e1c, 0x2e1d, [0, [], 1]);
        t.add(0x2e1e, 0x2e2e, [0, [], 1]);
        t.add(0x2e2f, 0x2e2f, [0, [], 0]);
        t.add(0x2e30, 0x2e30, [0, [], 1]);
        t.add(0x2e31, 0x2e31, [0, [], 1]);
        t.add(0x2e32, 0x2e3b, [0, [], 1]);
        t.add(0x2e3c, 0x2e42, [0, [], 1]);
        t.add(0x2e43, 0x2e44, [0, [], 1]);
        t.add(0x2e45, 0x2e49, [0, [], 1]);
        t.add(0x2e4a, 0x2e4e, [0, [], 1]);
        t.add(0x2e4f, 0x2e4f, [0, [], 1]);
        t.add(0x2e50, 0x2e7f, [4, [], 0]);
        t.add(0x2e80, 0x2e99, [0, [], 1]);
        t.add(0x2e9a, 0x2e9a, [4, [], 0]);
        t.add(0x2e9b, 0x2e9e, [0, [], 1]);
        t.add(0x2e9f, 0x2e9f, [2, [0x6BCD], 0]);
        t.add(0x2ea0, 0x2ef2, [0, [], 1]);
        t.add(0x2ef3, 0x2ef3, [2, [0x9F9F], 0]);
        t.add(0x2ef4, 0x2eff, [4, [], 0]);
        t.add(0x2f00, 0x2f00, [2, [0x4E00], 0]);
        t.add(0x2f01, 0x2f01, [2, [0x4E28], 0]);
        t.add(0x2f02, 0x2f02, [2, [0x4E36], 0]);
        t.add(0x2f03, 0x2f03, [2, [0x4E3F], 0]);
        t.add(0x2f04, 0x2f04, [2, [0x4E59], 0]);
        t.add(0x2f05, 0x2f05, [2, [0x4E85], 0]);
        t.add(0x2f06, 0x2f06, [2, [0x4E8C], 0]);
        t.add(0x2f07, 0x2f07, [2, [0x4EA0], 0]);
        t.add(0x2f08, 0x2f08, [2, [0x4EBA], 0]);
        t.add(0x2f09, 0x2f09, [2, [0x513F], 0]);
        t.add(0x2f0a, 0x2f0a, [2, [0x5165], 0]);
        t.add(0x2f0b, 0x2f0b, [2, [0x516B], 0]);
        t.add(0x2f0c, 0x2f0c, [2, [0x5182], 0]);
        t.add(0x2f0d, 0x2f0d, [2, [0x5196], 0]);
        t.add(0x2f0e, 0x2f0e, [2, [0x51AB], 0]);
        t.add(0x2f0f, 0x2f0f, [2, [0x51E0], 0]);
        t.add(0x2f10, 0x2f10, [2, [0x51F5], 0]);
        t.add(0x2f11, 0x2f11, [2, [0x5200], 0]);
        t.add(0x2f12, 0x2f12, [2, [0x529B], 0]);
        t.add(0x2f13, 0x2f13, [2, [0x52F9], 0]);
        t.add(0x2f14, 0x2f14, [2, [0x5315], 0]);
        t.add(0x2f15, 0x2f15, [2, [0x531A], 0]);
        t.add(0x2f16, 0x2f16, [2, [0x5338], 0]);
        t.add(0x2f17, 0x2f17, [2, [0x5341], 0]);
        t.add(0x2f18, 0x2f18, [2, [0x535C], 0]);
        t.add(0x2f19, 0x2f19, [2, [0x5369], 0]);
        t.add(0x2f1a, 0x2f1a, [2, [0x5382], 0]);
        t.add(0x2f1b, 0x2f1b, [2, [0x53B6], 0]);
        t.add(0x2f1c, 0x2f1c, [2, [0x53C8], 0]);
        t.add(0x2f1d, 0x2f1d, [2, [0x53E3], 0]);
        t.add(0x2f1e, 0x2f1e, [2, [0x56D7], 0]);
        t.add(0x2f1f, 0x2f1f, [2, [0x571F], 0]);
        t.add(0x2f20, 0x2f20, [2, [0x58EB], 0]);
        t.add(0x2f21, 0x2f21, [2, [0x5902], 0]);
        t.add(0x2f22, 0x2f22, [2, [0x590A], 0]);
        t.add(0x2f23, 0x2f23, [2, [0x5915], 0]);
        t.add(0x2f24, 0x2f24, [2, [0x5927], 0]);
        t.add(0x2f25, 0x2f25, [2, [0x5973], 0]);
        t.add(0x2f26, 0x2f26, [2, [0x5B50], 0]);
        t.add(0x2f27, 0x2f27, [2, [0x5B80], 0]);
        t.add(0x2f28, 0x2f28, [2, [0x5BF8], 0]);
        t.add(0x2f29, 0x2f29, [2, [0x5C0F], 0]);
        t.add(0x2f2a, 0x2f2a, [2, [0x5C22], 0]);
        t.add(0x2f2b, 0x2f2b, [2, [0x5C38], 0]);
        t.add(0x2f2c, 0x2f2c, [2, [0x5C6E], 0]);
        t.add(0x2f2d, 0x2f2d, [2, [0x5C71], 0]);
        t.add(0x2f2e, 0x2f2e, [2, [0x5DDB], 0]);
        t.add(0x2f2f, 0x2f2f, [2, [0x5DE5], 0]);
        t.add(0x2f30, 0x2f30, [2, [0x5DF1], 0]);
        t.add(0x2f31, 0x2f31, [2, [0x5DFE], 0]);
        t.add(0x2f32, 0x2f32, [2, [0x5E72], 0]);
        t.add(0x2f33, 0x2f33, [2, [0x5E7A], 0]);
        t.add(0x2f34, 0x2f34, [2, [0x5E7F], 0]);
        t.add(0x2f35, 0x2f35, [2, [0x5EF4], 0]);
        t.add(0x2f36, 0x2f36, [2, [0x5EFE], 0]);
        t.add(0x2f37, 0x2f37, [2, [0x5F0B], 0]);
        t.add(0x2f38, 0x2f38, [2, [0x5F13], 0]);
        t.add(0x2f39, 0x2f39, [2, [0x5F50], 0]);
        t.add(0x2f3a, 0x2f3a, [2, [0x5F61], 0]);
        t.add(0x2f3b, 0x2f3b, [2, [0x5F73], 0]);
        t.add(0x2f3c, 0x2f3c, [2, [0x5FC3], 0]);
        t.add(0x2f3d, 0x2f3d, [2, [0x6208], 0]);
        t.add(0x2f3e, 0x2f3e, [2, [0x6236], 0]);
        t.add(0x2f3f, 0x2f3f, [2, [0x624B], 0]);
        t.add(0x2f40, 0x2f40, [2, [0x652F], 0]);
        t.add(0x2f41, 0x2f41, [2, [0x6534], 0]);
        t.add(0x2f42, 0x2f42, [2, [0x6587], 0]);
        t.add(0x2f43, 0x2f43, [2, [0x6597], 0]);
        t.add(0x2f44, 0x2f44, [2, [0x65A4], 0]);
        t.add(0x2f45, 0x2f45, [2, [0x65B9], 0]);
        t.add(0x2f46, 0x2f46, [2, [0x65E0], 0]);
        t.add(0x2f47, 0x2f47, [2, [0x65E5], 0]);
        t.add(0x2f48, 0x2f48, [2, [0x66F0], 0]);
        t.add(0x2f49, 0x2f49, [2, [0x6708], 0]);
        t.add(0x2f4a, 0x2f4a, [2, [0x6728], 0]);
        t.add(0x2f4b, 0x2f4b, [2, [0x6B20], 0]);
        t.add(0x2f4c, 0x2f4c, [2, [0x6B62], 0]);
        t.add(0x2f4d, 0x2f4d, [2, [0x6B79], 0]);
        t.add(0x2f4e, 0x2f4e, [2, [0x6BB3], 0]);
        t.add(0x2f4f, 0x2f4f, [2, [0x6BCB], 0]);
        t.add(0x2f50, 0x2f50, [2, [0x6BD4], 0]);
        t.add(0x2f51, 0x2f51, [2, [0x6BDB], 0]);
        t.add(0x2f52, 0x2f52, [2, [0x6C0F], 0]);
        t.add(0x2f53, 0x2f53, [2, [0x6C14], 0]);
        t.add(0x2f54, 0x2f54, [2, [0x6C34], 0]);
        t.add(0x2f55, 0x2f55, [2, [0x706B], 0]);
        t.add(0x2f56, 0x2f56, [2, [0x722A], 0]);
        t.add(0x2f57, 0x2f57, [2, [0x7236], 0]);
        t.add(0x2f58, 0x2f58, [2, [0x723B], 0]);
        t.add(0x2f59, 0x2f59, [2, [0x723F], 0]);
        t.add(0x2f5a, 0x2f5a, [2, [0x7247], 0]);
        t.add(0x2f5b, 0x2f5b, [2, [0x7259], 0]);
        t.add(0x2f5c, 0x2f5c, [2, [0x725B], 0]);
        t.add(0x2f5d, 0x2f5d, [2, [0x72AC], 0]);
        t.add(0x2f5e, 0x2f5e, [2, [0x7384], 0]);
        t.add(0x2f5f, 0x2f5f, [2, [0x7389], 0]);
        t.add(0x2f60, 0x2f60, [2, [0x74DC], 0]);
        t.add(0x2f61, 0x2f61, [2, [0x74E6], 0]);
        t.add(0x2f62, 0x2f62, [2, [0x7518], 0]);
        t.add(0x2f63, 0x2f63, [2, [0x751F], 0]);
        t.add(0x2f64, 0x2f64, [2, [0x7528], 0]);
        t.add(0x2f65, 0x2f65, [2, [0x7530], 0]);
        t.add(0x2f66, 0x2f66, [2, [0x758B], 0]);
        t.add(0x2f67, 0x2f67, [2, [0x7592], 0]);
        t.add(0x2f68, 0x2f68, [2, [0x7676], 0]);
        t.add(0x2f69, 0x2f69, [2, [0x767D], 0]);
        t.add(0x2f6a, 0x2f6a, [2, [0x76AE], 0]);
        t.add(0x2f6b, 0x2f6b, [2, [0x76BF], 0]);
        t.add(0x2f6c, 0x2f6c, [2, [0x76EE], 0]);
        t.add(0x2f6d, 0x2f6d, [2, [0x77DB], 0]);
        t.add(0x2f6e, 0x2f6e, [2, [0x77E2], 0]);
        t.add(0x2f6f, 0x2f6f, [2, [0x77F3], 0]);
        t.add(0x2f70, 0x2f70, [2, [0x793A], 0]);
        t.add(0x2f71, 0x2f71, [2, [0x79B8], 0]);
        t.add(0x2f72, 0x2f72, [2, [0x79BE], 0]);
        t.add(0x2f73, 0x2f73, [2, [0x7A74], 0]);
        t.add(0x2f74, 0x2f74, [2, [0x7ACB], 0]);
        t.add(0x2f75, 0x2f75, [2, [0x7AF9], 0]);
        t.add(0x2f76, 0x2f76, [2, [0x7C73], 0]);
        t.add(0x2f77, 0x2f77, [2, [0x7CF8], 0]);
        t.add(0x2f78, 0x2f78, [2, [0x7F36], 0]);
        t.add(0x2f79, 0x2f79, [2, [0x7F51], 0]);
        t.add(0x2f7a, 0x2f7a, [2, [0x7F8A], 0]);
        t.add(0x2f7b, 0x2f7b, [2, [0x7FBD], 0]);
        t.add(0x2f7c, 0x2f7c, [2, [0x8001], 0]);
        t.add(0x2f7d, 0x2f7d, [2, [0x800C], 0]);
        t.add(0x2f7e, 0x2f7e, [2, [0x8012], 0]);
        t.add(0x2f7f, 0x2f7f, [2, [0x8033], 0]);
        t.add(0x2f80, 0x2f80, [2, [0x807F], 0]);
        t.add(0x2f81, 0x2f81, [2, [0x8089], 0]);
        t.add(0x2f82, 0x2f82, [2, [0x81E3], 0]);
        t.add(0x2f83, 0x2f83, [2, [0x81EA], 0]);
        t.add(0x2f84, 0x2f84, [2, [0x81F3], 0]);
        t.add(0x2f85, 0x2f85, [2, [0x81FC], 0]);
        t.add(0x2f86, 0x2f86, [2, [0x820C], 0]);
        t.add(0x2f87, 0x2f87, [2, [0x821B], 0]);
        t.add(0x2f88, 0x2f88, [2, [0x821F], 0]);
        t.add(0x2f89, 0x2f89, [2, [0x826E], 0]);
        t.add(0x2f8a, 0x2f8a, [2, [0x8272], 0]);
        t.add(0x2f8b, 0x2f8b, [2, [0x8278], 0]);
        t.add(0x2f8c, 0x2f8c, [2, [0x864D], 0]);
        t.add(0x2f8d, 0x2f8d, [2, [0x866B], 0]);
        t.add(0x2f8e, 0x2f8e, [2, [0x8840], 0]);
        t.add(0x2f8f, 0x2f8f, [2, [0x884C], 0]);
        t.add(0x2f90, 0x2f90, [2, [0x8863], 0]);
        t.add(0x2f91, 0x2f91, [2, [0x897E], 0]);
        t.add(0x2f92, 0x2f92, [2, [0x898B], 0]);
        t.add(0x2f93, 0x2f93, [2, [0x89D2], 0]);
        t.add(0x2f94, 0x2f94, [2, [0x8A00], 0]);
        t.add(0x2f95, 0x2f95, [2, [0x8C37], 0]);
        t.add(0x2f96, 0x2f96, [2, [0x8C46], 0]);
        t.add(0x2f97, 0x2f97, [2, [0x8C55], 0]);
        t.add(0x2f98, 0x2f98, [2, [0x8C78], 0]);
        t.add(0x2f99, 0x2f99, [2, [0x8C9D], 0]);
        t.add(0x2f9a, 0x2f9a, [2, [0x8D64], 0]);
        t.add(0x2f9b, 0x2f9b, [2, [0x8D70], 0]);
        t.add(0x2f9c, 0x2f9c, [2, [0x8DB3], 0]);
        t.add(0x2f9d, 0x2f9d, [2, [0x8EAB], 0]);
        t.add(0x2f9e, 0x2f9e, [2, [0x8ECA], 0]);
        t.add(0x2f9f, 0x2f9f, [2, [0x8F9B], 0]);
        t.add(0x2fa0, 0x2fa0, [2, [0x8FB0], 0]);
        t.add(0x2fa1, 0x2fa1, [2, [0x8FB5], 0]);
        t.add(0x2fa2, 0x2fa2, [2, [0x9091], 0]);
        t.add(0x2fa3, 0x2fa3, [2, [0x9149], 0]);
        t.add(0x2fa4, 0x2fa4, [2, [0x91C6], 0]);
        t.add(0x2fa5, 0x2fa5, [2, [0x91CC], 0]);
        t.add(0x2fa6, 0x2fa6, [2, [0x91D1], 0]);
        t.add(0x2fa7, 0x2fa7, [2, [0x9577], 0]);
        t.add(0x2fa8, 0x2fa8, [2, [0x9580], 0]);
        t.add(0x2fa9, 0x2fa9, [2, [0x961C], 0]);
        t.add(0x2faa, 0x2faa, [2, [0x96B6], 0]);
        t.add(0x2fab, 0x2fab, [2, [0x96B9], 0]);
        t.add(0x2fac, 0x2fac, [2, [0x96E8], 0]);
        t.add(0x2fad, 0x2fad, [2, [0x9751], 0]);
        t.add(0x2fae, 0x2fae, [2, [0x975E], 0]);
        t.add(0x2faf, 0x2faf, [2, [0x9762], 0]);
        t.add(0x2fb0, 0x2fb0, [2, [0x9769], 0]);
        t.add(0x2fb1, 0x2fb1, [2, [0x97CB], 0]);
        t.add(0x2fb2, 0x2fb2, [2, [0x97ED], 0]);
        t.add(0x2fb3, 0x2fb3, [2, [0x97F3], 0]);
        t.add(0x2fb4, 0x2fb4, [2, [0x9801], 0]);
        t.add(0x2fb5, 0x2fb5, [2, [0x98A8], 0]);
        t.add(0x2fb6, 0x2fb6, [2, [0x98DB], 0]);
        t.add(0x2fb7, 0x2fb7, [2, [0x98DF], 0]);
        t.add(0x2fb8, 0x2fb8, [2, [0x9996], 0]);
        t.add(0x2fb9, 0x2fb9, [2, [0x9999], 0]);
        t.add(0x2fba, 0x2fba, [2, [0x99AC], 0]);
        t.add(0x2fbb, 0x2fbb, [2, [0x9AA8], 0]);
        t.add(0x2fbc, 0x2fbc, [2, [0x9AD8], 0]);
        t.add(0x2fbd, 0x2fbd, [2, [0x9ADF], 0]);
        t.add(0x2fbe, 0x2fbe, [2, [0x9B25], 0]);
        t.add(0x2fbf, 0x2fbf, [2, [0x9B2F], 0]);
        t.add(0x2fc0, 0x2fc0, [2, [0x9B32], 0]);
        t.add(0x2fc1, 0x2fc1, [2, [0x9B3C], 0]);
        t.add(0x2fc2, 0x2fc2, [2, [0x9B5A], 0]);
        t.add(0x2fc3, 0x2fc3, [2, [0x9CE5], 0]);
        t.add(0x2fc4, 0x2fc4, [2, [0x9E75], 0]);
        t.add(0x2fc5, 0x2fc5, [2, [0x9E7F], 0]);
        t.add(0x2fc6, 0x2fc6, [2, [0x9EA5], 0]);
        t.add(0x2fc7, 0x2fc7, [2, [0x9EBB], 0]);
        t.add(0x2fc8, 0x2fc8, [2, [0x9EC3], 0]);
        t.add(0x2fc9, 0x2fc9, [2, [0x9ECD], 0]);
        t.add(0x2fca, 0x2fca, [2, [0x9ED1], 0]);
        t.add(0x2fcb, 0x2fcb, [2, [0x9EF9], 0]);
        t.add(0x2fcc, 0x2fcc, [2, [0x9EFD], 0]);
        t.add(0x2fcd, 0x2fcd, [2, [0x9F0E], 0]);
        t.add(0x2fce, 0x2fce, [2, [0x9F13], 0]);
        t.add(0x2fcf, 0x2fcf, [2, [0x9F20], 0]);
        t.add(0x2fd0, 0x2fd0, [2, [0x9F3B], 0]);
        t.add(0x2fd1, 0x2fd1, [2, [0x9F4A], 0]);
        t.add(0x2fd2, 0x2fd2, [2, [0x9F52], 0]);
        t.add(0x2fd3, 0x2fd3, [2, [0x9F8D], 0]);
        t.add(0x2fd4, 0x2fd4, [2, [0x9F9C], 0]);
        t.add(0x2fd5, 0x2fd5, [2, [0x9FA0], 0]);
        t.add(0x2fd6, 0x2fef, [4, [], 0]);
        t.add(0x2ff0, 0x2ffb, [4, [], 0]);
        t.add(0x2ffc, 0x2fff, [4, [], 0]);
        t.add(0x3000, 0x3000, [6, [0x0020], 0]);
        t.add(0x3001, 0x3001, [0, [], 1]);
        t.add(0x3002, 0x3002, [2, [0x002E], 0]);
        t.add(0x3003, 0x3004, [0, [], 1]);
        t.add(0x3005, 0x3007, [0, [], 0]);
        t.add(0x3008, 0x3029, [0, [], 1]);
        t.add(0x302a, 0x302d, [0, [], 0]);
        t.add(0x302e, 0x3035, [0, [], 1]);
        t.add(0x3036, 0x3036, [2, [0x3012], 0]);
        t.add(0x3037, 0x3037, [0, [], 1]);
        t.add(0x3038, 0x3038, [2, [0x5341], 0]);
        t.add(0x3039, 0x3039, [2, [0x5344], 0]);
        t.add(0x303a, 0x303a, [2, [0x5345], 0]);
        t.add(0x303b, 0x303b, [0, [], 1]);
        t.add(0x303c, 0x303c, [0, [], 0]);
        t.add(0x303d, 0x303d, [0, [], 1]);
        t.add(0x303e, 0x303e, [0, [], 1]);
        t.add(0x303f, 0x303f, [0, [], 1]);
        t.add(0x3040, 0x3040, [4, [], 0]);
        t.add(0x3041, 0x3094, [0, [], 0]);
        t.add(0x3095, 0x3096, [0, [], 0]);
        t.add(0x3097, 0x3098, [4, [], 0]);
        t.add(0x3099, 0x309a, [0, [], 0]);
        t.add(0x309b, 0x309b, [6, [0x0020, 0x3099], 0]);
        t.add(0x309c, 0x309c, [6, [0x0020, 0x309A], 0]);
        t.add(0x309d, 0x309e, [0, [], 0]);
        t.add(0x309f, 0x309f, [2, [0x3088, 0x308A], 0]);
        t.add(0x30a0, 0x30a0, [0, [], 1]);
        t.add(0x30a1, 0x30fe, [0, [], 0]);
        t.add(0x30ff, 0x30ff, [2, [0x30B3, 0x30C8], 0]);
        t.add(0x3100, 0x3104, [4, [], 0]);
        t.add(0x3105, 0x312c, [0, [], 0]);
        t.add(0x312d, 0x312d, [0, [], 0]);
        t.add(0x312e, 0x312e, [0, [], 0]);
        t.add(0x312f, 0x312f, [0, [], 0]);
        t.add(0x3130, 0x3130, [4, [], 0]);
        t.add(0x3131, 0x3131, [2, [0x1100], 0]);
        t.add(0x3132, 0x3132, [2, [0x1101], 0]);
        t.add(0x3133, 0x3133, [2, [0x11AA], 0]);
        t.add(0x3134, 0x3134, [2, [0x1102], 0]);
        t.add(0x3135, 0x3135, [2, [0x11AC], 0]);
        t.add(0x3136, 0x3136, [2, [0x11AD], 0]);
        t.add(0x3137, 0x3137, [2, [0x1103], 0]);
        t.add(0x3138, 0x3138, [2, [0x1104], 0]);
        t.add(0x3139, 0x3139, [2, [0x1105], 0]);
        t.add(0x313a, 0x313a, [2, [0x11B0], 0]);
        t.add(0x313b, 0x313b, [2, [0x11B1], 0]);
        t.add(0x313c, 0x313c, [2, [0x11B2], 0]);
        t.add(0x313d, 0x313d, [2, [0x11B3], 0]);
        t.add(0x313e, 0x313e, [2, [0x11B4], 0]);
        t.add(0x313f, 0x313f, [2, [0x11B5], 0]);
        t.add(0x3140, 0x3140, [2, [0x111A], 0]);
        t.add(0x3141, 0x3141, [2, [0x1106], 0]);
        t.add(0x3142, 0x3142, [2, [0x1107], 0]);
        t.add(0x3143, 0x3143, [2, [0x1108], 0]);
        t.add(0x3144, 0x3144, [2, [0x1121], 0]);
        t.add(0x3145, 0x3145, [2, [0x1109], 0]);
        t.add(0x3146, 0x3146, [2, [0x110A], 0]);
        t.add(0x3147, 0x3147, [2, [0x110B], 0]);
        t.add(0x3148, 0x3148, [2, [0x110C], 0]);
        t.add(0x3149, 0x3149, [2, [0x110D], 0]);
        t.add(0x314a, 0x314a, [2, [0x110E], 0]);
        t.add(0x314b, 0x314b, [2, [0x110F], 0]);
        t.add(0x314c, 0x314c, [2, [0x1110], 0]);
        t.add(0x314d, 0x314d, [2, [0x1111], 0]);
        t.add(0x314e, 0x314e, [2, [0x1112], 0]);
        t.add(0x314f, 0x314f, [2, [0x1161], 0]);
        t.add(0x3150, 0x3150, [2, [0x1162], 0]);
        t.add(0x3151, 0x3151, [2, [0x1163], 0]);
        t.add(0x3152, 0x3152, [2, [0x1164], 0]);
        t.add(0x3153, 0x3153, [2, [0x1165], 0]);
        t.add(0x3154, 0x3154, [2, [0x1166], 0]);
        t.add(0x3155, 0x3155, [2, [0x1167], 0]);
        t.add(0x3156, 0x3156, [2, [0x1168], 0]);
        t.add(0x3157, 0x3157, [2, [0x1169], 0]);
        t.add(0x3158, 0x3158, [2, [0x116A], 0]);
        t.add(0x3159, 0x3159, [2, [0x116B], 0]);
        t.add(0x315a, 0x315a, [2, [0x116C], 0]);
        t.add(0x315b, 0x315b, [2, [0x116D], 0]);
        t.add(0x315c, 0x315c, [2, [0x116E], 0]);
        t.add(0x315d, 0x315d, [2, [0x116F], 0]);
        t.add(0x315e, 0x315e, [2, [0x1170], 0]);
        t.add(0x315f, 0x315f, [2, [0x1171], 0]);
        t.add(0x3160, 0x3160, [2, [0x1172], 0]);
        t.add(0x3161, 0x3161, [2, [0x1173], 0]);
        t.add(0x3162, 0x3162, [2, [0x1174], 0]);
        t.add(0x3163, 0x3163, [2, [0x1175], 0]);
        t.add(0x3164, 0x3164, [4, [], 0]);
        t.add(0x3165, 0x3165, [2, [0x1114], 0]);
        t.add(0x3166, 0x3166, [2, [0x1115], 0]);
        t.add(0x3167, 0x3167, [2, [0x11C7], 0]);
        t.add(0x3168, 0x3168, [2, [0x11C8], 0]);
        t.add(0x3169, 0x3169, [2, [0x11CC], 0]);
        t.add(0x316a, 0x316a, [2, [0x11CE], 0]);
        t.add(0x316b, 0x316b, [2, [0x11D3], 0]);
        t.add(0x316c, 0x316c, [2, [0x11D7], 0]);
        t.add(0x316d, 0x316d, [2, [0x11D9], 0]);
        t.add(0x316e, 0x316e, [2, [0x111C], 0]);
        t.add(0x316f, 0x316f, [2, [0x11DD], 0]);
        t.add(0x3170, 0x3170, [2, [0x11DF], 0]);
        t.add(0x3171, 0x3171, [2, [0x111D], 0]);
        t.add(0x3172, 0x3172, [2, [0x111E], 0]);
        t.add(0x3173, 0x3173, [2, [0x1120], 0]);
        t.add(0x3174, 0x3174, [2, [0x1122], 0]);
        t.add(0x3175, 0x3175, [2, [0x1123], 0]);
        t.add(0x3176, 0x3176, [2, [0x1127], 0]);
        t.add(0x3177, 0x3177, [2, [0x1129], 0]);
        t.add(0x3178, 0x3178, [2, [0x112B], 0]);
        t.add(0x3179, 0x3179, [2, [0x112C], 0]);
        t.add(0x317a, 0x317a, [2, [0x112D], 0]);
        t.add(0x317b, 0x317b, [2, [0x112E], 0]);
        t.add(0x317c, 0x317c, [2, [0x112F], 0]);
        t.add(0x317d, 0x317d, [2, [0x1132], 0]);
        t.add(0x317e, 0x317e, [2, [0x1136], 0]);
        t.add(0x317f, 0x317f, [2, [0x1140], 0]);
        t.add(0x3180, 0x3180, [2, [0x1147], 0]);
        t.add(0x3181, 0x3181, [2, [0x114C], 0]);
        t.add(0x3182, 0x3182, [2, [0x11F1], 0]);
        t.add(0x3183, 0x3183, [2, [0x11F2], 0]);
        t.add(0x3184, 0x3184, [2, [0x1157], 0]);
        t.add(0x3185, 0x3185, [2, [0x1158], 0]);
        t.add(0x3186, 0x3186, [2, [0x1159], 0]);
        t.add(0x3187, 0x3187, [2, [0x1184], 0]);
        t.add(0x3188, 0x3188, [2, [0x1185], 0]);
        t.add(0x3189, 0x3189, [2, [0x1188], 0]);
        t.add(0x318a, 0x318a, [2, [0x1191], 0]);
        t.add(0x318b, 0x318b, [2, [0x1192], 0]);
        t.add(0x318c, 0x318c, [2, [0x1194], 0]);
        t.add(0x318d, 0x318d, [2, [0x119E], 0]);
        t.add(0x318e, 0x318e, [2, [0x11A1], 0]);
        t.add(0x318f, 0x318f, [4, [], 0]);
        t.add(0x3190, 0x3191, [0, [], 1]);
        t.add(0x3192, 0x3192, [2, [0x4E00], 0]);
        t.add(0x3193, 0x3193, [2, [0x4E8C], 0]);
        t.add(0x3194, 0x3194, [2, [0x4E09], 0]);
        t.add(0x3195, 0x3195, [2, [0x56DB], 0]);
        t.add(0x3196, 0x3196, [2, [0x4E0A], 0]);
        t.add(0x3197, 0x3197, [2, [0x4E2D], 0]);
        t.add(0x3198, 0x3198, [2, [0x4E0B], 0]);
        t.add(0x3199, 0x3199, [2, [0x7532], 0]);
        t.add(0x319a, 0x319a, [2, [0x4E59], 0]);
        t.add(0x319b, 0x319b, [2, [0x4E19], 0]);
        t.add(0x319c, 0x319c, [2, [0x4E01], 0]);
        t.add(0x319d, 0x319d, [2, [0x5929], 0]);
        t.add(0x319e, 0x319e, [2, [0x5730], 0]);
        t.add(0x319f, 0x319f, [2, [0x4EBA], 0]);
        t.add(0x31a0, 0x31b7, [0, [], 0]);
        t.add(0x31b8, 0x31ba, [0, [], 0]);
        t.add(0x31bb, 0x31bf, [4, [], 0]);
        t.add(0x31c0, 0x31cf, [0, [], 1]);
        t.add(0x31d0, 0x31e3, [0, [], 1]);
        t.add(0x31e4, 0x31ef, [4, [], 0]);
        t.add(0x31f0, 0x31ff, [0, [], 0]);
        t.add(0x3200, 0x3200, [6, [0x0028, 0x1100, 0x0029], 0]);
        t.add(0x3201, 0x3201, [6, [0x0028, 0x1102, 0x0029], 0]);
        t.add(0x3202, 0x3202, [6, [0x0028, 0x1103, 0x0029], 0]);
        t.add(0x3203, 0x3203, [6, [0x0028, 0x1105, 0x0029], 0]);
        t.add(0x3204, 0x3204, [6, [0x0028, 0x1106, 0x0029], 0]);
        t.add(0x3205, 0x3205, [6, [0x0028, 0x1107, 0x0029], 0]);
        t.add(0x3206, 0x3206, [6, [0x0028, 0x1109, 0x0029], 0]);
        t.add(0x3207, 0x3207, [6, [0x0028, 0x110B, 0x0029], 0]);
        t.add(0x3208, 0x3208, [6, [0x0028, 0x110C, 0x0029], 0]);
        t.add(0x3209, 0x3209, [6, [0x0028, 0x110E, 0x0029], 0]);
        t.add(0x320a, 0x320a, [6, [0x0028, 0x110F, 0x0029], 0]);
        t.add(0x320b, 0x320b, [6, [0x0028, 0x1110, 0x0029], 0]);
        t.add(0x320c, 0x320c, [6, [0x0028, 0x1111, 0x0029], 0]);
        t.add(0x320d, 0x320d, [6, [0x0028, 0x1112, 0x0029], 0]);
        t.add(0x320e, 0x320e, [6, [0x0028, 0xAC00, 0x0029], 0]);
        t.add(0x320f, 0x320f, [6, [0x0028, 0xB098, 0x0029], 0]);
        t.add(0x3210, 0x3210, [6, [0x0028, 0xB2E4, 0x0029], 0]);
        t.add(0x3211, 0x3211, [6, [0x0028, 0xB77C, 0x0029], 0]);
        t.add(0x3212, 0x3212, [6, [0x0028, 0xB9C8, 0x0029], 0]);
        t.add(0x3213, 0x3213, [6, [0x0028, 0xBC14, 0x0029], 0]);
        t.add(0x3214, 0x3214, [6, [0x0028, 0xC0AC, 0x0029], 0]);
        t.add(0x3215, 0x3215, [6, [0x0028, 0xC544, 0x0029], 0]);
        t.add(0x3216, 0x3216, [6, [0x0028, 0xC790, 0x0029], 0]);
        t.add(0x3217, 0x3217, [6, [0x0028, 0xCC28, 0x0029], 0]);
        t.add(0x3218, 0x3218, [6, [0x0028, 0xCE74, 0x0029], 0]);
        t.add(0x3219, 0x3219, [6, [0x0028, 0xD0C0, 0x0029], 0]);
        t.add(0x321a, 0x321a, [6, [0x0028, 0xD30C, 0x0029], 0]);
        t.add(0x321b, 0x321b, [6, [0x0028, 0xD558, 0x0029], 0]);
        t.add(0x321c, 0x321c, [6, [0x0028, 0xC8FC, 0x0029], 0]);
        t.add(0x321d, 0x321d, [6, [0x0028, 0xC624, 0xC804, 0x0029], 0]);
        t.add(0x321e, 0x321e, [6, [0x0028, 0xC624, 0xD6C4, 0x0029], 0]);
        t.add(0x321f, 0x321f, [4, [], 0]);
        t.add(0x3220, 0x3220, [6, [0x0028, 0x4E00, 0x0029], 0]);
        t.add(0x3221, 0x3221, [6, [0x0028, 0x4E8C, 0x0029], 0]);
        t.add(0x3222, 0x3222, [6, [0x0028, 0x4E09, 0x0029], 0]);
        t.add(0x3223, 0x3223, [6, [0x0028, 0x56DB, 0x0029], 0]);
        t.add(0x3224, 0x3224, [6, [0x0028, 0x4E94, 0x0029], 0]);
        t.add(0x3225, 0x3225, [6, [0x0028, 0x516D, 0x0029], 0]);
        t.add(0x3226, 0x3226, [6, [0x0028, 0x4E03, 0x0029], 0]);
        t.add(0x3227, 0x3227, [6, [0x0028, 0x516B, 0x0029], 0]);
        t.add(0x3228, 0x3228, [6, [0x0028, 0x4E5D, 0x0029], 0]);
        t.add(0x3229, 0x3229, [6, [0x0028, 0x5341, 0x0029], 0]);
        t.add(0x322a, 0x322a, [6, [0x0028, 0x6708, 0x0029], 0]);
        t.add(0x322b, 0x322b, [6, [0x0028, 0x706B, 0x0029], 0]);
        t.add(0x322c, 0x322c, [6, [0x0028, 0x6C34, 0x0029], 0]);
        t.add(0x322d, 0x322d, [6, [0x0028, 0x6728, 0x0029], 0]);
        t.add(0x322e, 0x322e, [6, [0x0028, 0x91D1, 0x0029], 0]);
        t.add(0x322f, 0x322f, [6, [0x0028, 0x571F, 0x0029], 0]);
        t.add(0x3230, 0x3230, [6, [0x0028, 0x65E5, 0x0029], 0]);
        t.add(0x3231, 0x3231, [6, [0x0028, 0x682A, 0x0029], 0]);
        t.add(0x3232, 0x3232, [6, [0x0028, 0x6709, 0x0029], 0]);
        t.add(0x3233, 0x3233, [6, [0x0028, 0x793E, 0x0029], 0]);
        t.add(0x3234, 0x3234, [6, [0x0028, 0x540D, 0x0029], 0]);
        t.add(0x3235, 0x3235, [6, [0x0028, 0x7279, 0x0029], 0]);
        t.add(0x3236, 0x3236, [6, [0x0028, 0x8CA1, 0x0029], 0]);
        t.add(0x3237, 0x3237, [6, [0x0028, 0x795D, 0x0029], 0]);
        t.add(0x3238, 0x3238, [6, [0x0028, 0x52B4, 0x0029], 0]);
        t.add(0x3239, 0x3239, [6, [0x0028, 0x4EE3, 0x0029], 0]);
        t.add(0x323a, 0x323a, [6, [0x0028, 0x547C, 0x0029], 0]);
        t.add(0x323b, 0x323b, [6, [0x0028, 0x5B66, 0x0029], 0]);
        t.add(0x323c, 0x323c, [6, [0x0028, 0x76E3, 0x0029], 0]);
        t.add(0x323d, 0x323d, [6, [0x0028, 0x4F01, 0x0029], 0]);
        t.add(0x323e, 0x323e, [6, [0x0028, 0x8CC7, 0x0029], 0]);
        t.add(0x323f, 0x323f, [6, [0x0028, 0x5354, 0x0029], 0]);
        t.add(0x3240, 0x3240, [6, [0x0028, 0x796D, 0x0029], 0]);
        t.add(0x3241, 0x3241, [6, [0x0028, 0x4F11, 0x0029], 0]);
        t.add(0x3242, 0x3242, [6, [0x0028, 0x81EA, 0x0029], 0]);
        t.add(0x3243, 0x3243, [6, [0x0028, 0x81F3, 0x0029], 0]);
        t.add(0x3244, 0x3244, [2, [0x554F], 0]);
        t.add(0x3245, 0x3245, [2, [0x5E7C], 0]);
        t.add(0x3246, 0x3246, [2, [0x6587], 0]);
        t.add(0x3247, 0x3247, [2, [0x7B8F], 0]);
        t.add(0x3248, 0x324f, [0, [], 1]);
        t.add(0x3250, 0x3250, [2, [0x0070, 0x0074, 0x0065], 0]);
        t.add(0x3251, 0x3251, [2, [0x0032, 0x0031], 0]);
        t.add(0x3252, 0x3252, [2, [0x0032, 0x0032], 0]);
        t.add(0x3253, 0x3253, [2, [0x0032, 0x0033], 0]);
        t.add(0x3254, 0x3254, [2, [0x0032, 0x0034], 0]);
        t.add(0x3255, 0x3255, [2, [0x0032, 0x0035], 0]);
        t.add(0x3256, 0x3256, [2, [0x0032, 0x0036], 0]);
        t.add(0x3257, 0x3257, [2, [0x0032, 0x0037], 0]);
        t.add(0x3258, 0x3258, [2, [0x0032, 0x0038], 0]);
        t.add(0x3259, 0x3259, [2, [0x0032, 0x0039], 0]);
        t.add(0x325a, 0x325a, [2, [0x0033, 0x0030], 0]);
        t.add(0x325b, 0x325b, [2, [0x0033, 0x0031], 0]);
        t.add(0x325c, 0x325c, [2, [0x0033, 0x0032], 0]);
        t.add(0x325d, 0x325d, [2, [0x0033, 0x0033], 0]);
        t.add(0x325e, 0x325e, [2, [0x0033, 0x0034], 0]);
        t.add(0x325f, 0x325f, [2, [0x0033, 0x0035], 0]);
        t.add(0x3260, 0x3260, [2, [0x1100], 0]);
        t.add(0x3261, 0x3261, [2, [0x1102], 0]);
        t.add(0x3262, 0x3262, [2, [0x1103], 0]);
        t.add(0x3263, 0x3263, [2, [0x1105], 0]);
        t.add(0x3264, 0x3264, [2, [0x1106], 0]);
        t.add(0x3265, 0x3265, [2, [0x1107], 0]);
        t.add(0x3266, 0x3266, [2, [0x1109], 0]);
        t.add(0x3267, 0x3267, [2, [0x110B], 0]);
        t.add(0x3268, 0x3268, [2, [0x110C], 0]);
        t.add(0x3269, 0x3269, [2, [0x110E], 0]);
        t.add(0x326a, 0x326a, [2, [0x110F], 0]);
        t.add(0x326b, 0x326b, [2, [0x1110], 0]);
        t.add(0x326c, 0x326c, [2, [0x1111], 0]);
        t.add(0x326d, 0x326d, [2, [0x1112], 0]);
        t.add(0x326e, 0x326e, [2, [0xAC00], 0]);
        t.add(0x326f, 0x326f, [2, [0xB098], 0]);
        t.add(0x3270, 0x3270, [2, [0xB2E4], 0]);
        t.add(0x3271, 0x3271, [2, [0xB77C], 0]);
        t.add(0x3272, 0x3272, [2, [0xB9C8], 0]);
        t.add(0x3273, 0x3273, [2, [0xBC14], 0]);
        t.add(0x3274, 0x3274, [2, [0xC0AC], 0]);
        t.add(0x3275, 0x3275, [2, [0xC544], 0]);
        t.add(0x3276, 0x3276, [2, [0xC790], 0]);
        t.add(0x3277, 0x3277, [2, [0xCC28], 0]);
        t.add(0x3278, 0x3278, [2, [0xCE74], 0]);
        t.add(0x3279, 0x3279, [2, [0xD0C0], 0]);
        t.add(0x327a, 0x327a, [2, [0xD30C], 0]);
        t.add(0x327b, 0x327b, [2, [0xD558], 0]);
        t.add(0x327c, 0x327c, [2, [0xCC38, 0xACE0], 0]);
        t.add(0x327d, 0x327d, [2, [0xC8FC, 0xC758], 0]);
        t.add(0x327e, 0x327e, [2, [0xC6B0], 0]);
        t.add(0x327f, 0x327f, [0, [], 1]);
        t.add(0x3280, 0x3280, [2, [0x4E00], 0]);
        t.add(0x3281, 0x3281, [2, [0x4E8C], 0]);
        t.add(0x3282, 0x3282, [2, [0x4E09], 0]);
        t.add(0x3283, 0x3283, [2, [0x56DB], 0]);
        t.add(0x3284, 0x3284, [2, [0x4E94], 0]);
        t.add(0x3285, 0x3285, [2, [0x516D], 0]);
        t.add(0x3286, 0x3286, [2, [0x4E03], 0]);
        t.add(0x3287, 0x3287, [2, [0x516B], 0]);
        t.add(0x3288, 0x3288, [2, [0x4E5D], 0]);
        t.add(0x3289, 0x3289, [2, [0x5341], 0]);
        t.add(0x328a, 0x328a, [2, [0x6708], 0]);
        t.add(0x328b, 0x328b, [2, [0x706B], 0]);
        t.add(0x328c, 0x328c, [2, [0x6C34], 0]);
        t.add(0x328d, 0x328d, [2, [0x6728], 0]);
        t.add(0x328e, 0x328e, [2, [0x91D1], 0]);
        t.add(0x328f, 0x328f, [2, [0x571F], 0]);
        t.add(0x3290, 0x3290, [2, [0x65E5], 0]);
        t.add(0x3291, 0x3291, [2, [0x682A], 0]);
        t.add(0x3292, 0x3292, [2, [0x6709], 0]);
        t.add(0x3293, 0x3293, [2, [0x793E], 0]);
        t.add(0x3294, 0x3294, [2, [0x540D], 0]);
        t.add(0x3295, 0x3295, [2, [0x7279], 0]);
        t.add(0x3296, 0x3296, [2, [0x8CA1], 0]);
        t.add(0x3297, 0x3297, [2, [0x795D], 0]);
        t.add(0x3298, 0x3298, [2, [0x52B4], 0]);
        t.add(0x3299, 0x3299, [2, [0x79D8], 0]);
        t.add(0x329a, 0x329a, [2, [0x7537], 0]);
        t.add(0x329b, 0x329b, [2, [0x5973], 0]);
        t.add(0x329c, 0x329c, [2, [0x9069], 0]);
        t.add(0x329d, 0x329d, [2, [0x512A], 0]);
        t.add(0x329e, 0x329e, [2, [0x5370], 0]);
        t.add(0x329f, 0x329f, [2, [0x6CE8], 0]);
        t.add(0x32a0, 0x32a0, [2, [0x9805], 0]);
        t.add(0x32a1, 0x32a1, [2, [0x4F11], 0]);
        t.add(0x32a2, 0x32a2, [2, [0x5199], 0]);
        t.add(0x32a3, 0x32a3, [2, [0x6B63], 0]);
        t.add(0x32a4, 0x32a4, [2, [0x4E0A], 0]);
        t.add(0x32a5, 0x32a5, [2, [0x4E2D], 0]);
        t.add(0x32a6, 0x32a6, [2, [0x4E0B], 0]);
        t.add(0x32a7, 0x32a7, [2, [0x5DE6], 0]);
        t.add(0x32a8, 0x32a8, [2, [0x53F3], 0]);
        t.add(0x32a9, 0x32a9, [2, [0x533B], 0]);
        t.add(0x32aa, 0x32aa, [2, [0x5B97], 0]);
        t.add(0x32ab, 0x32ab, [2, [0x5B66], 0]);
        t.add(0x32ac, 0x32ac, [2, [0x76E3], 0]);
        t.add(0x32ad, 0x32ad, [2, [0x4F01], 0]);
        t.add(0x32ae, 0x32ae, [2, [0x8CC7], 0]);
        t.add(0x32af, 0x32af, [2, [0x5354], 0]);
        t.add(0x32b0, 0x32b0, [2, [0x591C], 0]);
        t.add(0x32b1, 0x32b1, [2, [0x0033, 0x0036], 0]);
        t.add(0x32b2, 0x32b2, [2, [0x0033, 0x0037], 0]);
        t.add(0x32b3, 0x32b3, [2, [0x0033, 0x0038], 0]);
        t.add(0x32b4, 0x32b4, [2, [0x0033, 0x0039], 0]);
        t.add(0x32b5, 0x32b5, [2, [0x0034, 0x0030], 0]);
        t.add(0x32b6, 0x32b6, [2, [0x0034, 0x0031], 0]);
        t.add(0x32b7, 0x32b7, [2, [0x0034, 0x0032], 0]);
        t.add(0x32b8, 0x32b8, [2, [0x0034, 0x0033], 0]);
        t.add(0x32b9, 0x32b9, [2, [0x0034, 0x0034], 0]);
        t.add(0x32ba, 0x32ba, [2, [0x0034, 0x0035], 0]);
        t.add(0x32bb, 0x32bb, [2, [0x0034, 0x0036], 0]);
        t.add(0x32bc, 0x32bc, [2, [0x0034, 0x0037], 0]);
        t.add(0x32bd, 0x32bd, [2, [0x0034, 0x0038], 0]);
        t.add(0x32be, 0x32be, [2, [0x0034, 0x0039], 0]);
        t.add(0x32bf, 0x32bf, [2, [0x0035, 0x0030], 0]);
        t.add(0x32c0, 0x32c0, [2, [0x0031, 0x6708], 0]);
        t.add(0x32c1, 0x32c1, [2, [0x0032, 0x6708], 0]);
        t.add(0x32c2, 0x32c2, [2, [0x0033, 0x6708], 0]);
        t.add(0x32c3, 0x32c3, [2, [0x0034, 0x6708], 0]);
        t.add(0x32c4, 0x32c4, [2, [0x0035, 0x6708], 0]);
        t.add(0x32c5, 0x32c5, [2, [0x0036, 0x6708], 0]);
        t.add(0x32c6, 0x32c6, [2, [0x0037, 0x6708], 0]);
        t.add(0x32c7, 0x32c7, [2, [0x0038, 0x6708], 0]);
        t.add(0x32c8, 0x32c8, [2, [0x0039, 0x6708], 0]);
        t.add(0x32c9, 0x32c9, [2, [0x0031, 0x0030, 0x6708], 0]);
        t.add(0x32ca, 0x32ca, [2, [0x0031, 0x0031, 0x6708], 0]);
        t.add(0x32cb, 0x32cb, [2, [0x0031, 0x0032, 0x6708], 0]);
        t.add(0x32cc, 0x32cc, [2, [0x0068, 0x0067], 0]);
        t.add(0x32cd, 0x32cd, [2, [0x0065, 0x0072, 0x0067], 0]);
        t.add(0x32ce, 0x32ce, [2, [0x0065, 0x0076], 0]);
        t.add(0x32cf, 0x32cf, [2, [0x006C, 0x0074, 0x0064], 0]);
        t.add(0x32d0, 0x32d0, [2, [0x30A2], 0]);
        t.add(0x32d1, 0x32d1, [2, [0x30A4], 0]);
        t.add(0x32d2, 0x32d2, [2, [0x30A6], 0]);
        t.add(0x32d3, 0x32d3, [2, [0x30A8], 0]);
        t.add(0x32d4, 0x32d4, [2, [0x30AA], 0]);
        t.add(0x32d5, 0x32d5, [2, [0x30AB], 0]);
        t.add(0x32d6, 0x32d6, [2, [0x30AD], 0]);
        t.add(0x32d7, 0x32d7, [2, [0x30AF], 0]);
        t.add(0x32d8, 0x32d8, [2, [0x30B1], 0]);
        t.add(0x32d9, 0x32d9, [2, [0x30B3], 0]);
        t.add(0x32da, 0x32da, [2, [0x30B5], 0]);
        t.add(0x32db, 0x32db, [2, [0x30B7], 0]);
        t.add(0x32dc, 0x32dc, [2, [0x30B9], 0]);
        t.add(0x32dd, 0x32dd, [2, [0x30BB], 0]);
        t.add(0x32de, 0x32de, [2, [0x30BD], 0]);
        t.add(0x32df, 0x32df, [2, [0x30BF], 0]);
        t.add(0x32e0, 0x32e0, [2, [0x30C1], 0]);
        t.add(0x32e1, 0x32e1, [2, [0x30C4], 0]);
        t.add(0x32e2, 0x32e2, [2, [0x30C6], 0]);
        t.add(0x32e3, 0x32e3, [2, [0x30C8], 0]);
        t.add(0x32e4, 0x32e4, [2, [0x30CA], 0]);
        t.add(0x32e5, 0x32e5, [2, [0x30CB], 0]);
        t.add(0x32e6, 0x32e6, [2, [0x30CC], 0]);
        t.add(0x32e7, 0x32e7, [2, [0x30CD], 0]);
        t.add(0x32e8, 0x32e8, [2, [0x30CE], 0]);
        t.add(0x32e9, 0x32e9, [2, [0x30CF], 0]);
        t.add(0x32ea, 0x32ea, [2, [0x30D2], 0]);
        t.add(0x32eb, 0x32eb, [2, [0x30D5], 0]);
        t.add(0x32ec, 0x32ec, [2, [0x30D8], 0]);
        t.add(0x32ed, 0x32ed, [2, [0x30DB], 0]);
        t.add(0x32ee, 0x32ee, [2, [0x30DE], 0]);
        t.add(0x32ef, 0x32ef, [2, [0x30DF], 0]);
        t.add(0x32f0, 0x32f0, [2, [0x30E0], 0]);
        t.add(0x32f1, 0x32f1, [2, [0x30E1], 0]);
        t.add(0x32f2, 0x32f2, [2, [0x30E2], 0]);
        t.add(0x32f3, 0x32f3, [2, [0x30E4], 0]);
        t.add(0x32f4, 0x32f4, [2, [0x30E6], 0]);
        t.add(0x32f5, 0x32f5, [2, [0x30E8], 0]);
        t.add(0x32f6, 0x32f6, [2, [0x30E9], 0]);
        t.add(0x32f7, 0x32f7, [2, [0x30EA], 0]);
        t.add(0x32f8, 0x32f8, [2, [0x30EB], 0]);
        t.add(0x32f9, 0x32f9, [2, [0x30EC], 0]);
        t.add(0x32fa, 0x32fa, [2, [0x30ED], 0]);
        t.add(0x32fb, 0x32fb, [2, [0x30EF], 0]);
        t.add(0x32fc, 0x32fc, [2, [0x30F0], 0]);
        t.add(0x32fd, 0x32fd, [2, [0x30F1], 0]);
        t.add(0x32fe, 0x32fe, [2, [0x30F2], 0]);
        t.add(0x32ff, 0x32ff, [2, [0x4EE4, 0x548C], 0]);
        t.add(0x3300, 0x3300, [2, [0x30A2, 0x30D1, 0x30FC, 0x30C8], 0]);
        t.add(0x3301, 0x3301, [2, [0x30A2, 0x30EB, 0x30D5, 0x30A1], 0]);
        t.add(0x3302, 0x3302, [2, [0x30A2, 0x30F3, 0x30DA, 0x30A2], 0]);
        t.add(0x3303, 0x3303, [2, [0x30A2, 0x30FC, 0x30EB], 0]);
        t.add(0x3304, 0x3304, [2, [0x30A4, 0x30CB, 0x30F3, 0x30B0], 0]);
        t.add(0x3305, 0x3305, [2, [0x30A4, 0x30F3, 0x30C1], 0]);
        t.add(0x3306, 0x3306, [2, [0x30A6, 0x30A9, 0x30F3], 0]);
        t.add(0x3307, 0x3307, [2, [0x30A8, 0x30B9, 0x30AF, 0x30FC, 0x30C9], 0]);
        t.add(0x3308, 0x3308, [2, [0x30A8, 0x30FC, 0x30AB, 0x30FC], 0]);
        t.add(0x3309, 0x3309, [2, [0x30AA, 0x30F3, 0x30B9], 0]);
        t.add(0x330a, 0x330a, [2, [0x30AA, 0x30FC, 0x30E0], 0]);
        t.add(0x330b, 0x330b, [2, [0x30AB, 0x30A4, 0x30EA], 0]);
        t.add(0x330c, 0x330c, [2, [0x30AB, 0x30E9, 0x30C3, 0x30C8], 0]);
        t.add(0x330d, 0x330d, [2, [0x30AB, 0x30ED, 0x30EA, 0x30FC], 0]);
        t.add(0x330e, 0x330e, [2, [0x30AC, 0x30ED, 0x30F3], 0]);
        t.add(0x330f, 0x330f, [2, [0x30AC, 0x30F3, 0x30DE], 0]);
        t.add(0x3310, 0x3310, [2, [0x30AE, 0x30AC], 0]);
        t.add(0x3311, 0x3311, [2, [0x30AE, 0x30CB, 0x30FC], 0]);
        t.add(0x3312, 0x3312, [2, [0x30AD, 0x30E5, 0x30EA, 0x30FC], 0]);
        t.add(0x3313, 0x3313, [2, [0x30AE, 0x30EB, 0x30C0, 0x30FC], 0]);
        t.add(0x3314, 0x3314, [2, [0x30AD, 0x30ED], 0]);
        t.add(0x3315, 0x3315, [2, [0x30AD, 0x30ED, 0x30B0, 0x30E9, 0x30E0], 0]);
        t.add(0x3316, 0x3316, [2, [0x30AD, 0x30ED, 0x30E1, 0x30FC, 0x30C8, 0x30EB], 0]);
        t.add(0x3317, 0x3317, [2, [0x30AD, 0x30ED, 0x30EF, 0x30C3, 0x30C8], 0]);
        t.add(0x3318, 0x3318, [2, [0x30B0, 0x30E9, 0x30E0], 0]);
        t.add(0x3319, 0x3319, [2, [0x30B0, 0x30E9, 0x30E0, 0x30C8, 0x30F3], 0]);
        t.add(0x331a, 0x331a, [2, [0x30AF, 0x30EB, 0x30BC, 0x30A4, 0x30ED], 0]);
        t.add(0x331b, 0x331b, [2, [0x30AF, 0x30ED, 0x30FC, 0x30CD], 0]);
        t.add(0x331c, 0x331c, [2, [0x30B1, 0x30FC, 0x30B9], 0]);
        t.add(0x331d, 0x331d, [2, [0x30B3, 0x30EB, 0x30CA], 0]);
        t.add(0x331e, 0x331e, [2, [0x30B3, 0x30FC, 0x30DD], 0]);
        t.add(0x331f, 0x331f, [2, [0x30B5, 0x30A4, 0x30AF, 0x30EB], 0]);
        t.add(0x3320, 0x3320, [2, [0x30B5, 0x30F3, 0x30C1, 0x30FC, 0x30E0], 0]);
        t.add(0x3321, 0x3321, [2, [0x30B7, 0x30EA, 0x30F3, 0x30B0], 0]);
        t.add(0x3322, 0x3322, [2, [0x30BB, 0x30F3, 0x30C1], 0]);
        t.add(0x3323, 0x3323, [2, [0x30BB, 0x30F3, 0x30C8], 0]);
        t.add(0x3324, 0x3324, [2, [0x30C0, 0x30FC, 0x30B9], 0]);
        t.add(0x3325, 0x3325, [2, [0x30C7, 0x30B7], 0]);
        t.add(0x3326, 0x3326, [2, [0x30C9, 0x30EB], 0]);
        t.add(0x3327, 0x3327, [2, [0x30C8, 0x30F3], 0]);
        t.add(0x3328, 0x3328, [2, [0x30CA, 0x30CE], 0]);
        t.add(0x3329, 0x3329, [2, [0x30CE, 0x30C3, 0x30C8], 0]);
        t.add(0x332a, 0x332a, [2, [0x30CF, 0x30A4, 0x30C4], 0]);
        t.add(0x332b, 0x332b, [2, [0x30D1, 0x30FC, 0x30BB, 0x30F3, 0x30C8], 0]);
        t.add(0x332c, 0x332c, [2, [0x30D1, 0x30FC, 0x30C4], 0]);
        t.add(0x332d, 0x332d, [2, [0x30D0, 0x30FC, 0x30EC, 0x30EB], 0]);
        t.add(0x332e, 0x332e, [2, [0x30D4, 0x30A2, 0x30B9, 0x30C8, 0x30EB], 0]);
        t.add(0x332f, 0x332f, [2, [0x30D4, 0x30AF, 0x30EB], 0]);
        t.add(0x3330, 0x3330, [2, [0x30D4, 0x30B3], 0]);
        t.add(0x3331, 0x3331, [2, [0x30D3, 0x30EB], 0]);
        t.add(0x3332, 0x3332, [2, [0x30D5, 0x30A1, 0x30E9, 0x30C3, 0x30C9], 0]);
        t.add(0x3333, 0x3333, [2, [0x30D5, 0x30A3, 0x30FC, 0x30C8], 0]);
        t.add(0x3334, 0x3334, [2, [0x30D6, 0x30C3, 0x30B7, 0x30A7, 0x30EB], 0]);
        t.add(0x3335, 0x3335, [2, [0x30D5, 0x30E9, 0x30F3], 0]);
        t.add(0x3336, 0x3336, [2, [0x30D8, 0x30AF, 0x30BF, 0x30FC, 0x30EB], 0]);
        t.add(0x3337, 0x3337, [2, [0x30DA, 0x30BD], 0]);
        t.add(0x3338, 0x3338, [2, [0x30DA, 0x30CB, 0x30D2], 0]);
        t.add(0x3339, 0x3339, [2, [0x30D8, 0x30EB, 0x30C4], 0]);
        t.add(0x333a, 0x333a, [2, [0x30DA, 0x30F3, 0x30B9], 0]);
        t.add(0x333b, 0x333b, [2, [0x30DA, 0x30FC, 0x30B8], 0]);
        t.add(0x333c, 0x333c, [2, [0x30D9, 0x30FC, 0x30BF], 0]);
        t.add(0x333d, 0x333d, [2, [0x30DD, 0x30A4, 0x30F3, 0x30C8], 0]);
        t.add(0x333e, 0x333e, [2, [0x30DC, 0x30EB, 0x30C8], 0]);
        t.add(0x333f, 0x333f, [2, [0x30DB, 0x30F3], 0]);
        t.add(0x3340, 0x3340, [2, [0x30DD, 0x30F3, 0x30C9], 0]);
        t.add(0x3341, 0x3341, [2, [0x30DB, 0x30FC, 0x30EB], 0]);
        t.add(0x3342, 0x3342, [2, [0x30DB, 0x30FC, 0x30F3], 0]);
        t.add(0x3343, 0x3343, [2, [0x30DE, 0x30A4, 0x30AF, 0x30ED], 0]);
        t.add(0x3344, 0x3344, [2, [0x30DE, 0x30A4, 0x30EB], 0]);
        t.add(0x3345, 0x3345, [2, [0x30DE, 0x30C3, 0x30CF], 0]);
        t.add(0x3346, 0x3346, [2, [0x30DE, 0x30EB, 0x30AF], 0]);
        t.add(0x3347, 0x3347, [2, [0x30DE, 0x30F3, 0x30B7, 0x30E7, 0x30F3], 0]);
        t.add(0x3348, 0x3348, [2, [0x30DF, 0x30AF, 0x30ED, 0x30F3], 0]);
        t.add(0x3349, 0x3349, [2, [0x30DF, 0x30EA], 0]);
        t.add(0x334a, 0x334a, [2, [0x30DF, 0x30EA, 0x30D0, 0x30FC, 0x30EB], 0]);
        t.add(0x334b, 0x334b, [2, [0x30E1, 0x30AC], 0]);
        t.add(0x334c, 0x334c, [2, [0x30E1, 0x30AC, 0x30C8, 0x30F3], 0]);
        t.add(0x334d, 0x334d, [2, [0x30E1, 0x30FC, 0x30C8, 0x30EB], 0]);
        t.add(0x334e, 0x334e, [2, [0x30E4, 0x30FC, 0x30C9], 0]);
        t.add(0x334f, 0x334f, [2, [0x30E4, 0x30FC, 0x30EB], 0]);
        t.add(0x3350, 0x3350, [2, [0x30E6, 0x30A2, 0x30F3], 0]);
        t.add(0x3351, 0x3351, [2, [0x30EA, 0x30C3, 0x30C8, 0x30EB], 0]);
        t.add(0x3352, 0x3352, [2, [0x30EA, 0x30E9], 0]);
        t.add(0x3353, 0x3353, [2, [0x30EB, 0x30D4, 0x30FC], 0]);
        t.add(0x3354, 0x3354, [2, [0x30EB, 0x30FC, 0x30D6, 0x30EB], 0]);
        t.add(0x3355, 0x3355, [2, [0x30EC, 0x30E0], 0]);
        t.add(0x3356, 0x3356, [2, [0x30EC, 0x30F3, 0x30C8, 0x30B2, 0x30F3], 0]);
        t.add(0x3357, 0x3357, [2, [0x30EF, 0x30C3, 0x30C8], 0]);
        t.add(0x3358, 0x3358, [2, [0x0030, 0x70B9], 0]);
        t.add(0x3359, 0x3359, [2, [0x0031, 0x70B9], 0]);
        t.add(0x335a, 0x335a, [2, [0x0032, 0x70B9], 0]);
        t.add(0x335b, 0x335b, [2, [0x0033, 0x70B9], 0]);
        t.add(0x335c, 0x335c, [2, [0x0034, 0x70B9], 0]);
        t.add(0x335d, 0x335d, [2, [0x0035, 0x70B9], 0]);
        t.add(0x335e, 0x335e, [2, [0x0036, 0x70B9], 0]);
        t.add(0x335f, 0x335f, [2, [0x0037, 0x70B9], 0]);
        t.add(0x3360, 0x3360, [2, [0x0038, 0x70B9], 0]);
        t.add(0x3361, 0x3361, [2, [0x0039, 0x70B9], 0]);
        t.add(0x3362, 0x3362, [2, [0x0031, 0x0030, 0x70B9], 0]);
        t.add(0x3363, 0x3363, [2, [0x0031, 0x0031, 0x70B9], 0]);
        t.add(0x3364, 0x3364, [2, [0x0031, 0x0032, 0x70B9], 0]);
        t.add(0x3365, 0x3365, [2, [0x0031, 0x0033, 0x70B9], 0]);
        t.add(0x3366, 0x3366, [2, [0x0031, 0x0034, 0x70B9], 0]);
        t.add(0x3367, 0x3367, [2, [0x0031, 0x0035, 0x70B9], 0]);
        t.add(0x3368, 0x3368, [2, [0x0031, 0x0036, 0x70B9], 0]);
        t.add(0x3369, 0x3369, [2, [0x0031, 0x0037, 0x70B9], 0]);
        t.add(0x336a, 0x336a, [2, [0x0031, 0x0038, 0x70B9], 0]);
        t.add(0x336b, 0x336b, [2, [0x0031, 0x0039, 0x70B9], 0]);
        t.add(0x336c, 0x336c, [2, [0x0032, 0x0030, 0x70B9], 0]);
        t.add(0x336d, 0x336d, [2, [0x0032, 0x0031, 0x70B9], 0]);
        t.add(0x336e, 0x336e, [2, [0x0032, 0x0032, 0x70B9], 0]);
        t.add(0x336f, 0x336f, [2, [0x0032, 0x0033, 0x70B9], 0]);
        t.add(0x3370, 0x3370, [2, [0x0032, 0x0034, 0x70B9], 0]);
        t.add(0x3371, 0x3371, [2, [0x0068, 0x0070, 0x0061], 0]);
        t.add(0x3372, 0x3372, [2, [0x0064, 0x0061], 0]);
        t.add(0x3373, 0x3373, [2, [0x0061, 0x0075], 0]);
        t.add(0x3374, 0x3374, [2, [0x0062, 0x0061, 0x0072], 0]);
        t.add(0x3375, 0x3375, [2, [0x006F, 0x0076], 0]);
        t.add(0x3376, 0x3376, [2, [0x0070, 0x0063], 0]);
        t.add(0x3377, 0x3377, [2, [0x0064, 0x006D], 0]);
        t.add(0x3378, 0x3378, [2, [0x0064, 0x006D, 0x0032], 0]);
        t.add(0x3379, 0x3379, [2, [0x0064, 0x006D, 0x0033], 0]);
        t.add(0x337a, 0x337a, [2, [0x0069, 0x0075], 0]);
        t.add(0x337b, 0x337b, [2, [0x5E73, 0x6210], 0]);
        t.add(0x337c, 0x337c, [2, [0x662D, 0x548C], 0]);
        t.add(0x337d, 0x337d, [2, [0x5927, 0x6B63], 0]);
        t.add(0x337e, 0x337e, [2, [0x660E, 0x6CBB], 0]);
        t.add(0x337f, 0x337f, [2, [0x682A, 0x5F0F, 0x4F1A, 0x793E], 0]);
        t.add(0x3380, 0x3380, [2, [0x0070, 0x0061], 0]);
        t.add(0x3381, 0x3381, [2, [0x006E, 0x0061], 0]);
        t.add(0x3382, 0x3382, [2, [0x03BC, 0x0061], 0]);
        t.add(0x3383, 0x3383, [2, [0x006D, 0x0061], 0]);
        t.add(0x3384, 0x3384, [2, [0x006B, 0x0061], 0]);
        t.add(0x3385, 0x3385, [2, [0x006B, 0x0062], 0]);
        t.add(0x3386, 0x3386, [2, [0x006D, 0x0062], 0]);
        t.add(0x3387, 0x3387, [2, [0x0067, 0x0062], 0]);
        t.add(0x3388, 0x3388, [2, [0x0063, 0x0061, 0x006C], 0]);
        t.add(0x3389, 0x3389, [2, [0x006B, 0x0063, 0x0061, 0x006C], 0]);
        t.add(0x338a, 0x338a, [2, [0x0070, 0x0066], 0]);
        t.add(0x338b, 0x338b, [2, [0x006E, 0x0066], 0]);
        t.add(0x338c, 0x338c, [2, [0x03BC, 0x0066], 0]);
        t.add(0x338d, 0x338d, [2, [0x03BC, 0x0067], 0]);
        t.add(0x338e, 0x338e, [2, [0x006D, 0x0067], 0]);
        t.add(0x338f, 0x338f, [2, [0x006B, 0x0067], 0]);
        t.add(0x3390, 0x3390, [2, [0x0068, 0x007A], 0]);
        t.add(0x3391, 0x3391, [2, [0x006B, 0x0068, 0x007A], 0]);
        t.add(0x3392, 0x3392, [2, [0x006D, 0x0068, 0x007A], 0]);
        t.add(0x3393, 0x3393, [2, [0x0067, 0x0068, 0x007A], 0]);
        t.add(0x3394, 0x3394, [2, [0x0074, 0x0068, 0x007A], 0]);
        t.add(0x3395, 0x3395, [2, [0x03BC, 0x006C], 0]);
        t.add(0x3396, 0x3396, [2, [0x006D, 0x006C], 0]);
        t.add(0x3397, 0x3397, [2, [0x0064, 0x006C], 0]);
        t.add(0x3398, 0x3398, [2, [0x006B, 0x006C], 0]);
        t.add(0x3399, 0x3399, [2, [0x0066, 0x006D], 0]);
        t.add(0x339a, 0x339a, [2, [0x006E, 0x006D], 0]);
        t.add(0x339b, 0x339b, [2, [0x03BC, 0x006D], 0]);
        t.add(0x339c, 0x339c, [2, [0x006D, 0x006D], 0]);
        t.add(0x339d, 0x339d, [2, [0x0063, 0x006D], 0]);
        t.add(0x339e, 0x339e, [2, [0x006B, 0x006D], 0]);
        t.add(0x339f, 0x339f, [2, [0x006D, 0x006D, 0x0032], 0]);
        t.add(0x33a0, 0x33a0, [2, [0x0063, 0x006D, 0x0032], 0]);
        t.add(0x33a1, 0x33a1, [2, [0x006D, 0x0032], 0]);
        t.add(0x33a2, 0x33a2, [2, [0x006B, 0x006D, 0x0032], 0]);
        t.add(0x33a3, 0x33a3, [2, [0x006D, 0x006D, 0x0033], 0]);
        t.add(0x33a4, 0x33a4, [2, [0x0063, 0x006D, 0x0033], 0]);
        t.add(0x33a5, 0x33a5, [2, [0x006D, 0x0033], 0]);
        t.add(0x33a6, 0x33a6, [2, [0x006B, 0x006D, 0x0033], 0]);
        t.add(0x33a7, 0x33a7, [2, [0x006D, 0x2215, 0x0073], 0]);
        t.add(0x33a8, 0x33a8, [2, [0x006D, 0x2215, 0x0073, 0x0032], 0]);
        t.add(0x33a9, 0x33a9, [2, [0x0070, 0x0061], 0]);
        t.add(0x33aa, 0x33aa, [2, [0x006B, 0x0070, 0x0061], 0]);
        t.add(0x33ab, 0x33ab, [2, [0x006D, 0x0070, 0x0061], 0]);
        t.add(0x33ac, 0x33ac, [2, [0x0067, 0x0070, 0x0061], 0]);
        t.add(0x33ad, 0x33ad, [2, [0x0072, 0x0061, 0x0064], 0]);
        t.add(0x33ae, 0x33ae, [2, [0x0072, 0x0061, 0x0064, 0x2215, 0x0073], 0]);
        t.add(0x33af, 0x33af, [2, [0x0072, 0x0061, 0x0064, 0x2215, 0x0073, 0x0032], 0]);
        t.add(0x33b0, 0x33b0, [2, [0x0070, 0x0073], 0]);
        t.add(0x33b1, 0x33b1, [2, [0x006E, 0x0073], 0]);
        t.add(0x33b2, 0x33b2, [2, [0x03BC, 0x0073], 0]);
        t.add(0x33b3, 0x33b3, [2, [0x006D, 0x0073], 0]);
        t.add(0x33b4, 0x33b4, [2, [0x0070, 0x0076], 0]);
        t.add(0x33b5, 0x33b5, [2, [0x006E, 0x0076], 0]);
        t.add(0x33b6, 0x33b6, [2, [0x03BC, 0x0076], 0]);
        t.add(0x33b7, 0x33b7, [2, [0x006D, 0x0076], 0]);
        t.add(0x33b8, 0x33b8, [2, [0x006B, 0x0076], 0]);
        t.add(0x33b9, 0x33b9, [2, [0x006D, 0x0076], 0]);
        t.add(0x33ba, 0x33ba, [2, [0x0070, 0x0077], 0]);
        t.add(0x33bb, 0x33bb, [2, [0x006E, 0x0077], 0]);
        t.add(0x33bc, 0x33bc, [2, [0x03BC, 0x0077], 0]);
        t.add(0x33bd, 0x33bd, [2, [0x006D, 0x0077], 0]);
        t.add(0x33be, 0x33be, [2, [0x006B, 0x0077], 0]);
        t.add(0x33bf, 0x33bf, [2, [0x006D, 0x0077], 0]);
        t.add(0x33c0, 0x33c0, [2, [0x006B, 0x03C9], 0]);
        t.add(0x33c1, 0x33c1, [2, [0x006D, 0x03C9], 0]);
        t.add(0x33c2, 0x33c2, [4, [], 0]);
        t.add(0x33c3, 0x33c3, [2, [0x0062, 0x0071], 0]);
        t.add(0x33c4, 0x33c4, [2, [0x0063, 0x0063], 0]);
        t.add(0x33c5, 0x33c5, [2, [0x0063, 0x0064], 0]);
        t.add(0x33c6, 0x33c6, [2, [0x0063, 0x2215, 0x006B, 0x0067], 0]);
        t.add(0x33c7, 0x33c7, [4, [], 0]);
        t.add(0x33c8, 0x33c8, [2, [0x0064, 0x0062], 0]);
        t.add(0x33c9, 0x33c9, [2, [0x0067, 0x0079], 0]);
        t.add(0x33ca, 0x33ca, [2, [0x0068, 0x0061], 0]);
        t.add(0x33cb, 0x33cb, [2, [0x0068, 0x0070], 0]);
        t.add(0x33cc, 0x33cc, [2, [0x0069, 0x006E], 0]);
        t.add(0x33cd, 0x33cd, [2, [0x006B, 0x006B], 0]);
        t.add(0x33ce, 0x33ce, [2, [0x006B, 0x006D], 0]);
        t.add(0x33cf, 0x33cf, [2, [0x006B, 0x0074], 0]);
        t.add(0x33d0, 0x33d0, [2, [0x006C, 0x006D], 0]);
        t.add(0x33d1, 0x33d1, [2, [0x006C, 0x006E], 0]);
        t.add(0x33d2, 0x33d2, [2, [0x006C, 0x006F, 0x0067], 0]);
        t.add(0x33d3, 0x33d3, [2, [0x006C, 0x0078], 0]);
        t.add(0x33d4, 0x33d4, [2, [0x006D, 0x0062], 0]);
        t.add(0x33d5, 0x33d5, [2, [0x006D, 0x0069, 0x006C], 0]);
        t.add(0x33d6, 0x33d6, [2, [0x006D, 0x006F, 0x006C], 0]);
        t.add(0x33d7, 0x33d7, [2, [0x0070, 0x0068], 0]);
        t.add(0x33d8, 0x33d8, [4, [], 0]);
        t.add(0x33d9, 0x33d9, [2, [0x0070, 0x0070, 0x006D], 0]);
        t.add(0x33da, 0x33da, [2, [0x0070, 0x0072], 0]);
        t.add(0x33db, 0x33db, [2, [0x0073, 0x0072], 0]);
        t.add(0x33dc, 0x33dc, [2, [0x0073, 0x0076], 0]);
        t.add(0x33dd, 0x33dd, [2, [0x0077, 0x0062], 0]);
        t.add(0x33de, 0x33de, [2, [0x0076, 0x2215, 0x006D], 0]);
        t.add(0x33df, 0x33df, [2, [0x0061, 0x2215, 0x006D], 0]);
        t.add(0x33e0, 0x33e0, [2, [0x0031, 0x65E5], 0]);
        t.add(0x33e1, 0x33e1, [2, [0x0032, 0x65E5], 0]);
        t.add(0x33e2, 0x33e2, [2, [0x0033, 0x65E5], 0]);
        t.add(0x33e3, 0x33e3, [2, [0x0034, 0x65E5], 0]);
        t.add(0x33e4, 0x33e4, [2, [0x0035, 0x65E5], 0]);
        t.add(0x33e5, 0x33e5, [2, [0x0036, 0x65E5], 0]);
        t.add(0x33e6, 0x33e6, [2, [0x0037, 0x65E5], 0]);
        t.add(0x33e7, 0x33e7, [2, [0x0038, 0x65E5], 0]);
        t.add(0x33e8, 0x33e8, [2, [0x0039, 0x65E5], 0]);
        t.add(0x33e9, 0x33e9, [2, [0x0031, 0x0030, 0x65E5], 0]);
        t.add(0x33ea, 0x33ea, [2, [0x0031, 0x0031, 0x65E5], 0]);
        t.add(0x33eb, 0x33eb, [2, [0x0031, 0x0032, 0x65E5], 0]);
        t.add(0x33ec, 0x33ec, [2, [0x0031, 0x0033, 0x65E5], 0]);
        t.add(0x33ed, 0x33ed, [2, [0x0031, 0x0034, 0x65E5], 0]);
        t.add(0x33ee, 0x33ee, [2, [0x0031, 0x0035, 0x65E5], 0]);
        t.add(0x33ef, 0x33ef, [2, [0x0031, 0x0036, 0x65E5], 0]);
        t.add(0x33f0, 0x33f0, [2, [0x0031, 0x0037, 0x65E5], 0]);
        t.add(0x33f1, 0x33f1, [2, [0x0031, 0x0038, 0x65E5], 0]);
        t.add(0x33f2, 0x33f2, [2, [0x0031, 0x0039, 0x65E5], 0]);
        t.add(0x33f3, 0x33f3, [2, [0x0032, 0x0030, 0x65E5], 0]);
        t.add(0x33f4, 0x33f4, [2, [0x0032, 0x0031, 0x65E5], 0]);
        t.add(0x33f5, 0x33f5, [2, [0x0032, 0x0032, 0x65E5], 0]);
        t.add(0x33f6, 0x33f6, [2, [0x0032, 0x0033, 0x65E5], 0]);
        t.add(0x33f7, 0x33f7, [2, [0x0032, 0x0034, 0x65E5], 0]);
        t.add(0x33f8, 0x33f8, [2, [0x0032, 0x0035, 0x65E5], 0]);
        t.add(0x33f9, 0x33f9, [2, [0x0032, 0x0036, 0x65E5], 0]);
        t.add(0x33fa, 0x33fa, [2, [0x0032, 0x0037, 0x65E5], 0]);
        t.add(0x33fb, 0x33fb, [2, [0x0032, 0x0038, 0x65E5], 0]);
        t.add(0x33fc, 0x33fc, [2, [0x0032, 0x0039, 0x65E5], 0]);
        t.add(0x33fd, 0x33fd, [2, [0x0033, 0x0030, 0x65E5], 0]);
        t.add(0x33fe, 0x33fe, [2, [0x0033, 0x0031, 0x65E5], 0]);
        t.add(0x33ff, 0x33ff, [2, [0x0067, 0x0061, 0x006C], 0]);
        t.add(0x3400, 0x4db5, [0, [], 0]);
        t.add(0x4db6, 0x4dbf, [4, [], 0]);
        t.add(0x4dc0, 0x4dff, [0, [], 1]);
        t.add(0x4e00, 0x9fa5, [0, [], 0]);
        t.add(0x9fa6, 0x9fbb, [0, [], 0]);
        t.add(0x9fbc, 0x9fc3, [0, [], 0]);
        t.add(0x9fc4, 0x9fcb, [0, [], 0]);
        t.add(0x9fcc, 0x9fcc, [0, [], 0]);
        t.add(0x9fcd, 0x9fd5, [0, [], 0]);
        t.add(0x9fd6, 0x9fea, [0, [], 0]);
        t.add(0x9feb, 0x9fef, [0, [], 0]);
        t.add(0x9ff0, 0x9fff, [4, [], 0]);
        t.add(0xa000, 0xa48c, [0, [], 0]);
        t.add(0xa48d, 0xa48f, [4, [], 0]);
        t.add(0xa490, 0xa4a1, [0, [], 1]);
        t.add(0xa4a2, 0xa4a3, [0, [], 1]);
        t.add(0xa4a4, 0xa4b3, [0, [], 1]);
        t.add(0xa4b4, 0xa4b4, [0, [], 1]);
        t.add(0xa4b5, 0xa4c0, [0, [], 1]);
        t.add(0xa4c1, 0xa4c1, [0, [], 1]);
        t.add(0xa4c2, 0xa4c4, [0, [], 1]);
        t.add(0xa4c5, 0xa4c5, [0, [], 1]);
        t.add(0xa4c6, 0xa4c6, [0, [], 1]);
        t.add(0xa4c7, 0xa4cf, [4, [], 0]);
        t.add(0xa4d0, 0xa4fd, [0, [], 0]);
        t.add(0xa4fe, 0xa4ff, [0, [], 1]);
        t.add(0xa500, 0xa60c, [0, [], 0]);
        t.add(0xa60d, 0xa60f, [0, [], 1]);
        t.add(0xa610, 0xa62b, [0, [], 0]);
        t.add(0xa62c, 0xa63f, [4, [], 0]);
        t.add(0xa640, 0xa640, [2, [0xA641], 0]);
        t.add(0xa641, 0xa641, [0, [], 0]);
        t.add(0xa642, 0xa642, [2, [0xA643], 0]);
        t.add(0xa643, 0xa643, [0, [], 0]);
        t.add(0xa644, 0xa644, [2, [0xA645], 0]);
        t.add(0xa645, 0xa645, [0, [], 0]);
        t.add(0xa646, 0xa646, [2, [0xA647], 0]);
        t.add(0xa647, 0xa647, [0, [], 0]);
        t.add(0xa648, 0xa648, [2, [0xA649], 0]);
        t.add(0xa649, 0xa649, [0, [], 0]);
        t.add(0xa64a, 0xa64a, [2, [0xA64B], 0]);
        t.add(0xa64b, 0xa64b, [0, [], 0]);
        t.add(0xa64c, 0xa64c, [2, [0xA64D], 0]);
        t.add(0xa64d, 0xa64d, [0, [], 0]);
        t.add(0xa64e, 0xa64e, [2, [0xA64F], 0]);
        t.add(0xa64f, 0xa64f, [0, [], 0]);
        t.add(0xa650, 0xa650, [2, [0xA651], 0]);
        t.add(0xa651, 0xa651, [0, [], 0]);
        t.add(0xa652, 0xa652, [2, [0xA653], 0]);
        t.add(0xa653, 0xa653, [0, [], 0]);
        t.add(0xa654, 0xa654, [2, [0xA655], 0]);
        t.add(0xa655, 0xa655, [0, [], 0]);
        t.add(0xa656, 0xa656, [2, [0xA657], 0]);
        t.add(0xa657, 0xa657, [0, [], 0]);
        t.add(0xa658, 0xa658, [2, [0xA659], 0]);
        t.add(0xa659, 0xa659, [0, [], 0]);
        t.add(0xa65a, 0xa65a, [2, [0xA65B], 0]);
        t.add(0xa65b, 0xa65b, [0, [], 0]);
        t.add(0xa65c, 0xa65c, [2, [0xA65D], 0]);
        t.add(0xa65d, 0xa65d, [0, [], 0]);
        t.add(0xa65e, 0xa65e, [2, [0xA65F], 0]);
        t.add(0xa65f, 0xa65f, [0, [], 0]);
        t.add(0xa660, 0xa660, [2, [0xA661], 0]);
        t.add(0xa661, 0xa661, [0, [], 0]);
        t.add(0xa662, 0xa662, [2, [0xA663], 0]);
        t.add(0xa663, 0xa663, [0, [], 0]);
        t.add(0xa664, 0xa664, [2, [0xA665], 0]);
        t.add(0xa665, 0xa665, [0, [], 0]);
        t.add(0xa666, 0xa666, [2, [0xA667], 0]);
        t.add(0xa667, 0xa667, [0, [], 0]);
        t.add(0xa668, 0xa668, [2, [0xA669], 0]);
        t.add(0xa669, 0xa669, [0, [], 0]);
        t.add(0xa66a, 0xa66a, [2, [0xA66B], 0]);
        t.add(0xa66b, 0xa66b, [0, [], 0]);
        t.add(0xa66c, 0xa66c, [2, [0xA66D], 0]);
        t.add(0xa66d, 0xa66f, [0, [], 0]);
        t.add(0xa670, 0xa673, [0, [], 1]);
        t.add(0xa674, 0xa67b, [0, [], 0]);
        t.add(0xa67c, 0xa67d, [0, [], 0]);
        t.add(0xa67e, 0xa67e, [0, [], 1]);
        t.add(0xa67f, 0xa67f, [0, [], 0]);
        t.add(0xa680, 0xa680, [2, [0xA681], 0]);
        t.add(0xa681, 0xa681, [0, [], 0]);
        t.add(0xa682, 0xa682, [2, [0xA683], 0]);
        t.add(0xa683, 0xa683, [0, [], 0]);
        t.add(0xa684, 0xa684, [2, [0xA685], 0]);
        t.add(0xa685, 0xa685, [0, [], 0]);
        t.add(0xa686, 0xa686, [2, [0xA687], 0]);
        t.add(0xa687, 0xa687, [0, [], 0]);
        t.add(0xa688, 0xa688, [2, [0xA689], 0]);
        t.add(0xa689, 0xa689, [0, [], 0]);
        t.add(0xa68a, 0xa68a, [2, [0xA68B], 0]);
        t.add(0xa68b, 0xa68b, [0, [], 0]);
        t.add(0xa68c, 0xa68c, [2, [0xA68D], 0]);
        t.add(0xa68d, 0xa68d, [0, [], 0]);
        t.add(0xa68e, 0xa68e, [2, [0xA68F], 0]);
        t.add(0xa68f, 0xa68f, [0, [], 0]);
        t.add(0xa690, 0xa690, [2, [0xA691], 0]);
        t.add(0xa691, 0xa691, [0, [], 0]);
        t.add(0xa692, 0xa692, [2, [0xA693], 0]);
        t.add(0xa693, 0xa693, [0, [], 0]);
        t.add(0xa694, 0xa694, [2, [0xA695], 0]);
        t.add(0xa695, 0xa695, [0, [], 0]);
        t.add(0xa696, 0xa696, [2, [0xA697], 0]);
        t.add(0xa697, 0xa697, [0, [], 0]);
        t.add(0xa698, 0xa698, [2, [0xA699], 0]);
        t.add(0xa699, 0xa699, [0, [], 0]);
        t.add(0xa69a, 0xa69a, [2, [0xA69B], 0]);
        t.add(0xa69b, 0xa69b, [0, [], 0]);
        t.add(0xa69c, 0xa69c, [2, [0x044A], 0]);
        t.add(0xa69d, 0xa69d, [2, [0x044C], 0]);
        t.add(0xa69e, 0xa69e, [0, [], 0]);
        t.add(0xa69f, 0xa69f, [0, [], 0]);
        t.add(0xa6a0, 0xa6e5, [0, [], 0]);
        t.add(0xa6e6, 0xa6ef, [0, [], 1]);
        t.add(0xa6f0, 0xa6f1, [0, [], 0]);
        t.add(0xa6f2, 0xa6f7, [0, [], 1]);
        t.add(0xa6f8, 0xa6ff, [4, [], 0]);
        t.add(0xa700, 0xa716, [0, [], 1]);
        t.add(0xa717, 0xa71a, [0, [], 0]);
        t.add(0xa71b, 0xa71f, [0, [], 0]);
        t.add(0xa720, 0xa721, [0, [], 1]);
        t.add(0xa722, 0xa722, [2, [0xA723], 0]);
        t.add(0xa723, 0xa723, [0, [], 0]);
        t.add(0xa724, 0xa724, [2, [0xA725], 0]);
        t.add(0xa725, 0xa725, [0, [], 0]);
        t.add(0xa726, 0xa726, [2, [0xA727], 0]);
        t.add(0xa727, 0xa727, [0, [], 0]);
        t.add(0xa728, 0xa728, [2, [0xA729], 0]);
        t.add(0xa729, 0xa729, [0, [], 0]);
        t.add(0xa72a, 0xa72a, [2, [0xA72B], 0]);
        t.add(0xa72b, 0xa72b, [0, [], 0]);
        t.add(0xa72c, 0xa72c, [2, [0xA72D], 0]);
        t.add(0xa72d, 0xa72d, [0, [], 0]);
        t.add(0xa72e, 0xa72e, [2, [0xA72F], 0]);
        t.add(0xa72f, 0xa731, [0, [], 0]);
        t.add(0xa732, 0xa732, [2, [0xA733], 0]);
        t.add(0xa733, 0xa733, [0, [], 0]);
        t.add(0xa734, 0xa734, [2, [0xA735], 0]);
        t.add(0xa735, 0xa735, [0, [], 0]);
        t.add(0xa736, 0xa736, [2, [0xA737], 0]);
        t.add(0xa737, 0xa737, [0, [], 0]);
        t.add(0xa738, 0xa738, [2, [0xA739], 0]);
        t.add(0xa739, 0xa739, [0, [], 0]);
        t.add(0xa73a, 0xa73a, [2, [0xA73B], 0]);
        t.add(0xa73b, 0xa73b, [0, [], 0]);
        t.add(0xa73c, 0xa73c, [2, [0xA73D], 0]);
        t.add(0xa73d, 0xa73d, [0, [], 0]);
        t.add(0xa73e, 0xa73e, [2, [0xA73F], 0]);
        t.add(0xa73f, 0xa73f, [0, [], 0]);
        t.add(0xa740, 0xa740, [2, [0xA741], 0]);
        t.add(0xa741, 0xa741, [0, [], 0]);
        t.add(0xa742, 0xa742, [2, [0xA743], 0]);
        t.add(0xa743, 0xa743, [0, [], 0]);
        t.add(0xa744, 0xa744, [2, [0xA745], 0]);
        t.add(0xa745, 0xa745, [0, [], 0]);
        t.add(0xa746, 0xa746, [2, [0xA747], 0]);
        t.add(0xa747, 0xa747, [0, [], 0]);
        t.add(0xa748, 0xa748, [2, [0xA749], 0]);
        t.add(0xa749, 0xa749, [0, [], 0]);
        t.add(0xa74a, 0xa74a, [2, [0xA74B], 0]);
        t.add(0xa74b, 0xa74b, [0, [], 0]);
        t.add(0xa74c, 0xa74c, [2, [0xA74D], 0]);
        t.add(0xa74d, 0xa74d, [0, [], 0]);
        t.add(0xa74e, 0xa74e, [2, [0xA74F], 0]);
        t.add(0xa74f, 0xa74f, [0, [], 0]);
        t.add(0xa750, 0xa750, [2, [0xA751], 0]);
        t.add(0xa751, 0xa751, [0, [], 0]);
        t.add(0xa752, 0xa752, [2, [0xA753], 0]);
        t.add(0xa753, 0xa753, [0, [], 0]);
        t.add(0xa754, 0xa754, [2, [0xA755], 0]);
        t.add(0xa755, 0xa755, [0, [], 0]);
        t.add(0xa756, 0xa756, [2, [0xA757], 0]);
        t.add(0xa757, 0xa757, [0, [], 0]);
        t.add(0xa758, 0xa758, [2, [0xA759], 0]);
        t.add(0xa759, 0xa759, [0, [], 0]);
        t.add(0xa75a, 0xa75a, [2, [0xA75B], 0]);
        t.add(0xa75b, 0xa75b, [0, [], 0]);
        t.add(0xa75c, 0xa75c, [2, [0xA75D], 0]);
        t.add(0xa75d, 0xa75d, [0, [], 0]);
        t.add(0xa75e, 0xa75e, [2, [0xA75F], 0]);
        t.add(0xa75f, 0xa75f, [0, [], 0]);
        t.add(0xa760, 0xa760, [2, [0xA761], 0]);
        t.add(0xa761, 0xa761, [0, [], 0]);
        t.add(0xa762, 0xa762, [2, [0xA763], 0]);
        t.add(0xa763, 0xa763, [0, [], 0]);
        t.add(0xa764, 0xa764, [2, [0xA765], 0]);
        t.add(0xa765, 0xa765, [0, [], 0]);
        t.add(0xa766, 0xa766, [2, [0xA767], 0]);
        t.add(0xa767, 0xa767, [0, [], 0]);
        t.add(0xa768, 0xa768, [2, [0xA769], 0]);
        t.add(0xa769, 0xa769, [0, [], 0]);
        t.add(0xa76a, 0xa76a, [2, [0xA76B], 0]);
        t.add(0xa76b, 0xa76b, [0, [], 0]);
        t.add(0xa76c, 0xa76c, [2, [0xA76D], 0]);
        t.add(0xa76d, 0xa76d, [0, [], 0]);
        t.add(0xa76e, 0xa76e, [2, [0xA76F], 0]);
        t.add(0xa76f, 0xa76f, [0, [], 0]);
        t.add(0xa770, 0xa770, [2, [0xA76F], 0]);
        t.add(0xa771, 0xa778, [0, [], 0]);
        t.add(0xa779, 0xa779, [2, [0xA77A], 0]);
        t.add(0xa77a, 0xa77a, [0, [], 0]);
        t.add(0xa77b, 0xa77b, [2, [0xA77C], 0]);
        t.add(0xa77c, 0xa77c, [0, [], 0]);
        t.add(0xa77d, 0xa77d, [2, [0x1D79], 0]);
        t.add(0xa77e, 0xa77e, [2, [0xA77F], 0]);
        t.add(0xa77f, 0xa77f, [0, [], 0]);
        t.add(0xa780, 0xa780, [2, [0xA781], 0]);
        t.add(0xa781, 0xa781, [0, [], 0]);
        t.add(0xa782, 0xa782, [2, [0xA783], 0]);
        t.add(0xa783, 0xa783, [0, [], 0]);
        t.add(0xa784, 0xa784, [2, [0xA785], 0]);
        t.add(0xa785, 0xa785, [0, [], 0]);
        t.add(0xa786, 0xa786, [2, [0xA787], 0]);
        t.add(0xa787, 0xa788, [0, [], 0]);
        t.add(0xa789, 0xa78a, [0, [], 1]);
        t.add(0xa78b, 0xa78b, [2, [0xA78C], 0]);
        t.add(0xa78c, 0xa78c, [0, [], 0]);
        t.add(0xa78d, 0xa78d, [2, [0x0265], 0]);
        t.add(0xa78e, 0xa78e, [0, [], 0]);
        t.add(0xa78f, 0xa78f, [0, [], 0]);
        t.add(0xa790, 0xa790, [2, [0xA791], 0]);
        t.add(0xa791, 0xa791, [0, [], 0]);
        t.add(0xa792, 0xa792, [2, [0xA793], 0]);
        t.add(0xa793, 0xa793, [0, [], 0]);
        t.add(0xa794, 0xa795, [0, [], 0]);
        t.add(0xa796, 0xa796, [2, [0xA797], 0]);
        t.add(0xa797, 0xa797, [0, [], 0]);
        t.add(0xa798, 0xa798, [2, [0xA799], 0]);
        t.add(0xa799, 0xa799, [0, [], 0]);
        t.add(0xa79a, 0xa79a, [2, [0xA79B], 0]);
        t.add(0xa79b, 0xa79b, [0, [], 0]);
        t.add(0xa79c, 0xa79c, [2, [0xA79D], 0]);
        t.add(0xa79d, 0xa79d, [0, [], 0]);
        t.add(0xa79e, 0xa79e, [2, [0xA79F], 0]);
        t.add(0xa79f, 0xa79f, [0, [], 0]);
        t.add(0xa7a0, 0xa7a0, [2, [0xA7A1], 0]);
        t.add(0xa7a1, 0xa7a1, [0, [], 0]);
        t.add(0xa7a2, 0xa7a2, [2, [0xA7A3], 0]);
        t.add(0xa7a3, 0xa7a3, [0, [], 0]);
        t.add(0xa7a4, 0xa7a4, [2, [0xA7A5], 0]);
        t.add(0xa7a5, 0xa7a5, [0, [], 0]);
        t.add(0xa7a6, 0xa7a6, [2, [0xA7A7], 0]);
        t.add(0xa7a7, 0xa7a7, [0, [], 0]);
        t.add(0xa7a8, 0xa7a8, [2, [0xA7A9], 0]);
        t.add(0xa7a9, 0xa7a9, [0, [], 0]);
        t.add(0xa7aa, 0xa7aa, [2, [0x0266], 0]);
        t.add(0xa7ab, 0xa7ab, [2, [0x025C], 0]);
        t.add(0xa7ac, 0xa7ac, [2, [0x0261], 0]);
        t.add(0xa7ad, 0xa7ad, [2, [0x026C], 0]);
        t.add(0xa7ae, 0xa7ae, [2, [0x026A], 0]);
        t.add(0xa7af, 0xa7af, [0, [], 0]);
        t.add(0xa7b0, 0xa7b0, [2, [0x029E], 0]);
        t.add(0xa7b1, 0xa7b1, [2, [0x0287], 0]);
        t.add(0xa7b2, 0xa7b2, [2, [0x029D], 0]);
        t.add(0xa7b3, 0xa7b3, [2, [0xAB53], 0]);
        t.add(0xa7b4, 0xa7b4, [2, [0xA7B5], 0]);
        t.add(0xa7b5, 0xa7b5, [0, [], 0]);
        t.add(0xa7b6, 0xa7b6, [2, [0xA7B7], 0]);
        t.add(0xa7b7, 0xa7b7, [0, [], 0]);
        t.add(0xa7b8, 0xa7b8, [2, [0xA7B9], 0]);
        t.add(0xa7b9, 0xa7b9, [0, [], 0]);
        t.add(0xa7ba, 0xa7ba, [2, [0xA7BB], 0]);
        t.add(0xa7bb, 0xa7bb, [0, [], 0]);
        t.add(0xa7bc, 0xa7bc, [2, [0xA7BD], 0]);
        t.add(0xa7bd, 0xa7bd, [0, [], 0]);
        t.add(0xa7be, 0xa7be, [2, [0xA7BF], 0]);
        t.add(0xa7bf, 0xa7bf, [0, [], 0]);
        t.add(0xa7c0, 0xa7c1, [4, [], 0]);
        t.add(0xa7c2, 0xa7c2, [2, [0xA7C3], 0]);
        t.add(0xa7c3, 0xa7c3, [0, [], 0]);
        t.add(0xa7c4, 0xa7c4, [2, [0xA794], 0]);
        t.add(0xa7c5, 0xa7c5, [2, [0x0282], 0]);
        t.add(0xa7c6, 0xa7c6, [2, [0x1D8E], 0]);
        t.add(0xa7c7, 0xa7f6, [4, [], 0]);
        t.add(0xa7f7, 0xa7f7, [0, [], 0]);
        t.add(0xa7f8, 0xa7f8, [2, [0x0127], 0]);
        t.add(0xa7f9, 0xa7f9, [2, [0x0153], 0]);
        t.add(0xa7fa, 0xa7fa, [0, [], 0]);
        t.add(0xa7fb, 0xa7ff, [0, [], 0]);
        t.add(0xa800, 0xa827, [0, [], 0]);
        t.add(0xa828, 0xa82b, [0, [], 1]);
        t.add(0xa82c, 0xa82f, [4, [], 0]);
        t.add(0xa830, 0xa839, [0, [], 1]);
        t.add(0xa83a, 0xa83f, [4, [], 0]);
        t.add(0xa840, 0xa873, [0, [], 0]);
        t.add(0xa874, 0xa877, [0, [], 1]);
        t.add(0xa878, 0xa87f, [4, [], 0]);
        t.add(0xa880, 0xa8c4, [0, [], 0]);
        t.add(0xa8c5, 0xa8c5, [0, [], 0]);
        t.add(0xa8c6, 0xa8cd, [4, [], 0]);
        t.add(0xa8ce, 0xa8cf, [0, [], 1]);
        t.add(0xa8d0, 0xa8d9, [0, [], 0]);
        t.add(0xa8da, 0xa8df, [4, [], 0]);
        t.add(0xa8e0, 0xa8f7, [0, [], 0]);
        t.add(0xa8f8, 0xa8fa, [0, [], 1]);
        t.add(0xa8fb, 0xa8fb, [0, [], 0]);
        t.add(0xa8fc, 0xa8fc, [0, [], 1]);
        t.add(0xa8fd, 0xa8fd, [0, [], 0]);
        t.add(0xa8fe, 0xa8ff, [0, [], 0]);
        t.add(0xa900, 0xa92d, [0, [], 0]);
        t.add(0xa92e, 0xa92f, [0, [], 1]);
        t.add(0xa930, 0xa953, [0, [], 0]);
        t.add(0xa954, 0xa95e, [4, [], 0]);
        t.add(0xa95f, 0xa95f, [0, [], 1]);
        t.add(0xa960, 0xa97c, [0, [], 1]);
        t.add(0xa97d, 0xa97f, [4, [], 0]);
        t.add(0xa980, 0xa9c0, [0, [], 0]);
        t.add(0xa9c1, 0xa9cd, [0, [], 1]);
        t.add(0xa9ce, 0xa9ce, [4, [], 0]);
        t.add(0xa9cf, 0xa9d9, [0, [], 0]);
        t.add(0xa9da, 0xa9dd, [4, [], 0]);
        t.add(0xa9de, 0xa9df, [0, [], 1]);
        t.add(0xa9e0, 0xa9fe, [0, [], 0]);
        t.add(0xa9ff, 0xa9ff, [4, [], 0]);
        t.add(0xaa00, 0xaa36, [0, [], 0]);
        t.add(0xaa37, 0xaa3f, [4, [], 0]);
        t.add(0xaa40, 0xaa4d, [0, [], 0]);
        t.add(0xaa4e, 0xaa4f, [4, [], 0]);
        t.add(0xaa50, 0xaa59, [0, [], 0]);
        t.add(0xaa5a, 0xaa5b, [4, [], 0]);
        t.add(0xaa5c, 0xaa5f, [0, [], 1]);
        t.add(0xaa60, 0xaa76, [0, [], 0]);
        t.add(0xaa77, 0xaa79, [0, [], 1]);
        t.add(0xaa7a, 0xaa7b, [0, [], 0]);
        t.add(0xaa7c, 0xaa7f, [0, [], 0]);
        t.add(0xaa80, 0xaac2, [0, [], 0]);
        t.add(0xaac3, 0xaada, [4, [], 0]);
        t.add(0xaadb, 0xaadd, [0, [], 0]);
        t.add(0xaade, 0xaadf, [0, [], 1]);
        t.add(0xaae0, 0xaaef, [0, [], 0]);
        t.add(0xaaf0, 0xaaf1, [0, [], 1]);
        t.add(0xaaf2, 0xaaf6, [0, [], 0]);
        t.add(0xaaf7, 0xab00, [4, [], 0]);
        t.add(0xab01, 0xab06, [0, [], 0]);
        t.add(0xab07, 0xab08, [4, [], 0]);
        t.add(0xab09, 0xab0e, [0, [], 0]);
        t.add(0xab0f, 0xab10, [4, [], 0]);
        t.add(0xab11, 0xab16, [0, [], 0]);
        t.add(0xab17, 0xab1f, [4, [], 0]);
        t.add(0xab20, 0xab26, [0, [], 0]);
        t.add(0xab27, 0xab27, [4, [], 0]);
        t.add(0xab28, 0xab2e, [0, [], 0]);
        t.add(0xab2f, 0xab2f, [4, [], 0]);
        t.add(0xab30, 0xab5a, [0, [], 0]);
        t.add(0xab5b, 0xab5b, [0, [], 1]);
        t.add(0xab5c, 0xab5c, [2, [0xA727], 0]);
        t.add(0xab5d, 0xab5d, [2, [0xAB37], 0]);
        t.add(0xab5e, 0xab5e, [2, [0x026B], 0]);
        t.add(0xab5f, 0xab5f, [2, [0xAB52], 0]);
        t.add(0xab60, 0xab63, [0, [], 0]);
        t.add(0xab64, 0xab65, [0, [], 0]);
        t.add(0xab66, 0xab67, [0, [], 0]);
        t.add(0xab68, 0xab6f, [4, [], 0]);
        t.add(0xab70, 0xab70, [2, [0x13A0], 0]);
        t.add(0xab71, 0xab71, [2, [0x13A1], 0]);
        t.add(0xab72, 0xab72, [2, [0x13A2], 0]);
        t.add(0xab73, 0xab73, [2, [0x13A3], 0]);
        t.add(0xab74, 0xab74, [2, [0x13A4], 0]);
        t.add(0xab75, 0xab75, [2, [0x13A5], 0]);
        t.add(0xab76, 0xab76, [2, [0x13A6], 0]);
        t.add(0xab77, 0xab77, [2, [0x13A7], 0]);
        t.add(0xab78, 0xab78, [2, [0x13A8], 0]);
        t.add(0xab79, 0xab79, [2, [0x13A9], 0]);
        t.add(0xab7a, 0xab7a, [2, [0x13AA], 0]);
        t.add(0xab7b, 0xab7b, [2, [0x13AB], 0]);
        t.add(0xab7c, 0xab7c, [2, [0x13AC], 0]);
        t.add(0xab7d, 0xab7d, [2, [0x13AD], 0]);
        t.add(0xab7e, 0xab7e, [2, [0x13AE], 0]);
        t.add(0xab7f, 0xab7f, [2, [0x13AF], 0]);
        t.add(0xab80, 0xab80, [2, [0x13B0], 0]);
        t.add(0xab81, 0xab81, [2, [0x13B1], 0]);
        t.add(0xab82, 0xab82, [2, [0x13B2], 0]);
        t.add(0xab83, 0xab83, [2, [0x13B3], 0]);
        t.add(0xab84, 0xab84, [2, [0x13B4], 0]);
        t.add(0xab85, 0xab85, [2, [0x13B5], 0]);
        t.add(0xab86, 0xab86, [2, [0x13B6], 0]);
        t.add(0xab87, 0xab87, [2, [0x13B7], 0]);
        t.add(0xab88, 0xab88, [2, [0x13B8], 0]);
        t.add(0xab89, 0xab89, [2, [0x13B9], 0]);
        t.add(0xab8a, 0xab8a, [2, [0x13BA], 0]);
        t.add(0xab8b, 0xab8b, [2, [0x13BB], 0]);
        t.add(0xab8c, 0xab8c, [2, [0x13BC], 0]);
        t.add(0xab8d, 0xab8d, [2, [0x13BD], 0]);
        t.add(0xab8e, 0xab8e, [2, [0x13BE], 0]);
        t.add(0xab8f, 0xab8f, [2, [0x13BF], 0]);
        t.add(0xab90, 0xab90, [2, [0x13C0], 0]);
        t.add(0xab91, 0xab91, [2, [0x13C1], 0]);
        t.add(0xab92, 0xab92, [2, [0x13C2], 0]);
        t.add(0xab93, 0xab93, [2, [0x13C3], 0]);
        t.add(0xab94, 0xab94, [2, [0x13C4], 0]);
        t.add(0xab95, 0xab95, [2, [0x13C5], 0]);
        t.add(0xab96, 0xab96, [2, [0x13C6], 0]);
        t.add(0xab97, 0xab97, [2, [0x13C7], 0]);
        t.add(0xab98, 0xab98, [2, [0x13C8], 0]);
        t.add(0xab99, 0xab99, [2, [0x13C9], 0]);
        t.add(0xab9a, 0xab9a, [2, [0x13CA], 0]);
        t.add(0xab9b, 0xab9b, [2, [0x13CB], 0]);
        t.add(0xab9c, 0xab9c, [2, [0x13CC], 0]);
        t.add(0xab9d, 0xab9d, [2, [0x13CD], 0]);
        t.add(0xab9e, 0xab9e, [2, [0x13CE], 0]);
        t.add(0xab9f, 0xab9f, [2, [0x13CF], 0]);
        t.add(0xaba0, 0xaba0, [2, [0x13D0], 0]);
        t.add(0xaba1, 0xaba1, [2, [0x13D1], 0]);
        t.add(0xaba2, 0xaba2, [2, [0x13D2], 0]);
        t.add(0xaba3, 0xaba3, [2, [0x13D3], 0]);
        t.add(0xaba4, 0xaba4, [2, [0x13D4], 0]);
        t.add(0xaba5, 0xaba5, [2, [0x13D5], 0]);
        t.add(0xaba6, 0xaba6, [2, [0x13D6], 0]);
        t.add(0xaba7, 0xaba7, [2, [0x13D7], 0]);
        t.add(0xaba8, 0xaba8, [2, [0x13D8], 0]);
        t.add(0xaba9, 0xaba9, [2, [0x13D9], 0]);
        t.add(0xabaa, 0xabaa, [2, [0x13DA], 0]);
        t.add(0xabab, 0xabab, [2, [0x13DB], 0]);
        t.add(0xabac, 0xabac, [2, [0x13DC], 0]);
        t.add(0xabad, 0xabad, [2, [0x13DD], 0]);
        t.add(0xabae, 0xabae, [2, [0x13DE], 0]);
        t.add(0xabaf, 0xabaf, [2, [0x13DF], 0]);
        t.add(0xabb0, 0xabb0, [2, [0x13E0], 0]);
        t.add(0xabb1, 0xabb1, [2, [0x13E1], 0]);
        t.add(0xabb2, 0xabb2, [2, [0x13E2], 0]);
        t.add(0xabb3, 0xabb3, [2, [0x13E3], 0]);
        t.add(0xabb4, 0xabb4, [2, [0x13E4], 0]);
        t.add(0xabb5, 0xabb5, [2, [0x13E5], 0]);
        t.add(0xabb6, 0xabb6, [2, [0x13E6], 0]);
        t.add(0xabb7, 0xabb7, [2, [0x13E7], 0]);
        t.add(0xabb8, 0xabb8, [2, [0x13E8], 0]);
        t.add(0xabb9, 0xabb9, [2, [0x13E9], 0]);
        t.add(0xabba, 0xabba, [2, [0x13EA], 0]);
        t.add(0xabbb, 0xabbb, [2, [0x13EB], 0]);
        t.add(0xabbc, 0xabbc, [2, [0x13EC], 0]);
        t.add(0xabbd, 0xabbd, [2, [0x13ED], 0]);
        t.add(0xabbe, 0xabbe, [2, [0x13EE], 0]);
        t.add(0xabbf, 0xabbf, [2, [0x13EF], 0]);
    }
    /**
     * Initializes the lookup table.
     */
    _populate2(t) {
        t.add(0xabc0, 0xabea, [0, [], 0]);
        t.add(0xabeb, 0xabeb, [0, [], 1]);
        t.add(0xabec, 0xabed, [0, [], 0]);
        t.add(0xabee, 0xabef, [4, [], 0]);
        t.add(0xabf0, 0xabf9, [0, [], 0]);
        t.add(0xabfa, 0xabff, [4, [], 0]);
        t.add(0xac00, 0xd7a3, [0, [], 0]);
        t.add(0xd7a4, 0xd7af, [4, [], 0]);
        t.add(0xd7b0, 0xd7c6, [0, [], 1]);
        t.add(0xd7c7, 0xd7ca, [4, [], 0]);
        t.add(0xd7cb, 0xd7fb, [0, [], 1]);
        t.add(0xd7fc, 0xd7ff, [4, [], 0]);
        t.add(0xd800, 0xdfff, [4, [], 0]);
        t.add(0xe000, 0xf8ff, [4, [], 0]);
        t.add(0xf900, 0xf900, [2, [0x8C48], 0]);
        t.add(0xf901, 0xf901, [2, [0x66F4], 0]);
        t.add(0xf902, 0xf902, [2, [0x8ECA], 0]);
        t.add(0xf903, 0xf903, [2, [0x8CC8], 0]);
        t.add(0xf904, 0xf904, [2, [0x6ED1], 0]);
        t.add(0xf905, 0xf905, [2, [0x4E32], 0]);
        t.add(0xf906, 0xf906, [2, [0x53E5], 0]);
        t.add(0xf907, 0xf908, [2, [0x9F9C], 0]);
        t.add(0xf909, 0xf909, [2, [0x5951], 0]);
        t.add(0xf90a, 0xf90a, [2, [0x91D1], 0]);
        t.add(0xf90b, 0xf90b, [2, [0x5587], 0]);
        t.add(0xf90c, 0xf90c, [2, [0x5948], 0]);
        t.add(0xf90d, 0xf90d, [2, [0x61F6], 0]);
        t.add(0xf90e, 0xf90e, [2, [0x7669], 0]);
        t.add(0xf90f, 0xf90f, [2, [0x7F85], 0]);
        t.add(0xf910, 0xf910, [2, [0x863F], 0]);
        t.add(0xf911, 0xf911, [2, [0x87BA], 0]);
        t.add(0xf912, 0xf912, [2, [0x88F8], 0]);
        t.add(0xf913, 0xf913, [2, [0x908F], 0]);
        t.add(0xf914, 0xf914, [2, [0x6A02], 0]);
        t.add(0xf915, 0xf915, [2, [0x6D1B], 0]);
        t.add(0xf916, 0xf916, [2, [0x70D9], 0]);
        t.add(0xf917, 0xf917, [2, [0x73DE], 0]);
        t.add(0xf918, 0xf918, [2, [0x843D], 0]);
        t.add(0xf919, 0xf919, [2, [0x916A], 0]);
        t.add(0xf91a, 0xf91a, [2, [0x99F1], 0]);
        t.add(0xf91b, 0xf91b, [2, [0x4E82], 0]);
        t.add(0xf91c, 0xf91c, [2, [0x5375], 0]);
        t.add(0xf91d, 0xf91d, [2, [0x6B04], 0]);
        t.add(0xf91e, 0xf91e, [2, [0x721B], 0]);
        t.add(0xf91f, 0xf91f, [2, [0x862D], 0]);
        t.add(0xf920, 0xf920, [2, [0x9E1E], 0]);
        t.add(0xf921, 0xf921, [2, [0x5D50], 0]);
        t.add(0xf922, 0xf922, [2, [0x6FEB], 0]);
        t.add(0xf923, 0xf923, [2, [0x85CD], 0]);
        t.add(0xf924, 0xf924, [2, [0x8964], 0]);
        t.add(0xf925, 0xf925, [2, [0x62C9], 0]);
        t.add(0xf926, 0xf926, [2, [0x81D8], 0]);
        t.add(0xf927, 0xf927, [2, [0x881F], 0]);
        t.add(0xf928, 0xf928, [2, [0x5ECA], 0]);
        t.add(0xf929, 0xf929, [2, [0x6717], 0]);
        t.add(0xf92a, 0xf92a, [2, [0x6D6A], 0]);
        t.add(0xf92b, 0xf92b, [2, [0x72FC], 0]);
        t.add(0xf92c, 0xf92c, [2, [0x90CE], 0]);
        t.add(0xf92d, 0xf92d, [2, [0x4F86], 0]);
        t.add(0xf92e, 0xf92e, [2, [0x51B7], 0]);
        t.add(0xf92f, 0xf92f, [2, [0x52DE], 0]);
        t.add(0xf930, 0xf930, [2, [0x64C4], 0]);
        t.add(0xf931, 0xf931, [2, [0x6AD3], 0]);
        t.add(0xf932, 0xf932, [2, [0x7210], 0]);
        t.add(0xf933, 0xf933, [2, [0x76E7], 0]);
        t.add(0xf934, 0xf934, [2, [0x8001], 0]);
        t.add(0xf935, 0xf935, [2, [0x8606], 0]);
        t.add(0xf936, 0xf936, [2, [0x865C], 0]);
        t.add(0xf937, 0xf937, [2, [0x8DEF], 0]);
        t.add(0xf938, 0xf938, [2, [0x9732], 0]);
        t.add(0xf939, 0xf939, [2, [0x9B6F], 0]);
        t.add(0xf93a, 0xf93a, [2, [0x9DFA], 0]);
        t.add(0xf93b, 0xf93b, [2, [0x788C], 0]);
        t.add(0xf93c, 0xf93c, [2, [0x797F], 0]);
        t.add(0xf93d, 0xf93d, [2, [0x7DA0], 0]);
        t.add(0xf93e, 0xf93e, [2, [0x83C9], 0]);
        t.add(0xf93f, 0xf93f, [2, [0x9304], 0]);
        t.add(0xf940, 0xf940, [2, [0x9E7F], 0]);
        t.add(0xf941, 0xf941, [2, [0x8AD6], 0]);
        t.add(0xf942, 0xf942, [2, [0x58DF], 0]);
        t.add(0xf943, 0xf943, [2, [0x5F04], 0]);
        t.add(0xf944, 0xf944, [2, [0x7C60], 0]);
        t.add(0xf945, 0xf945, [2, [0x807E], 0]);
        t.add(0xf946, 0xf946, [2, [0x7262], 0]);
        t.add(0xf947, 0xf947, [2, [0x78CA], 0]);
        t.add(0xf948, 0xf948, [2, [0x8CC2], 0]);
        t.add(0xf949, 0xf949, [2, [0x96F7], 0]);
        t.add(0xf94a, 0xf94a, [2, [0x58D8], 0]);
        t.add(0xf94b, 0xf94b, [2, [0x5C62], 0]);
        t.add(0xf94c, 0xf94c, [2, [0x6A13], 0]);
        t.add(0xf94d, 0xf94d, [2, [0x6DDA], 0]);
        t.add(0xf94e, 0xf94e, [2, [0x6F0F], 0]);
        t.add(0xf94f, 0xf94f, [2, [0x7D2F], 0]);
        t.add(0xf950, 0xf950, [2, [0x7E37], 0]);
        t.add(0xf951, 0xf951, [2, [0x964B], 0]);
        t.add(0xf952, 0xf952, [2, [0x52D2], 0]);
        t.add(0xf953, 0xf953, [2, [0x808B], 0]);
        t.add(0xf954, 0xf954, [2, [0x51DC], 0]);
        t.add(0xf955, 0xf955, [2, [0x51CC], 0]);
        t.add(0xf956, 0xf956, [2, [0x7A1C], 0]);
        t.add(0xf957, 0xf957, [2, [0x7DBE], 0]);
        t.add(0xf958, 0xf958, [2, [0x83F1], 0]);
        t.add(0xf959, 0xf959, [2, [0x9675], 0]);
        t.add(0xf95a, 0xf95a, [2, [0x8B80], 0]);
        t.add(0xf95b, 0xf95b, [2, [0x62CF], 0]);
        t.add(0xf95c, 0xf95c, [2, [0x6A02], 0]);
        t.add(0xf95d, 0xf95d, [2, [0x8AFE], 0]);
        t.add(0xf95e, 0xf95e, [2, [0x4E39], 0]);
        t.add(0xf95f, 0xf95f, [2, [0x5BE7], 0]);
        t.add(0xf960, 0xf960, [2, [0x6012], 0]);
        t.add(0xf961, 0xf961, [2, [0x7387], 0]);
        t.add(0xf962, 0xf962, [2, [0x7570], 0]);
        t.add(0xf963, 0xf963, [2, [0x5317], 0]);
        t.add(0xf964, 0xf964, [2, [0x78FB], 0]);
        t.add(0xf965, 0xf965, [2, [0x4FBF], 0]);
        t.add(0xf966, 0xf966, [2, [0x5FA9], 0]);
        t.add(0xf967, 0xf967, [2, [0x4E0D], 0]);
        t.add(0xf968, 0xf968, [2, [0x6CCC], 0]);
        t.add(0xf969, 0xf969, [2, [0x6578], 0]);
        t.add(0xf96a, 0xf96a, [2, [0x7D22], 0]);
        t.add(0xf96b, 0xf96b, [2, [0x53C3], 0]);
        t.add(0xf96c, 0xf96c, [2, [0x585E], 0]);
        t.add(0xf96d, 0xf96d, [2, [0x7701], 0]);
        t.add(0xf96e, 0xf96e, [2, [0x8449], 0]);
        t.add(0xf96f, 0xf96f, [2, [0x8AAA], 0]);
        t.add(0xf970, 0xf970, [2, [0x6BBA], 0]);
        t.add(0xf971, 0xf971, [2, [0x8FB0], 0]);
        t.add(0xf972, 0xf972, [2, [0x6C88], 0]);
        t.add(0xf973, 0xf973, [2, [0x62FE], 0]);
        t.add(0xf974, 0xf974, [2, [0x82E5], 0]);
        t.add(0xf975, 0xf975, [2, [0x63A0], 0]);
        t.add(0xf976, 0xf976, [2, [0x7565], 0]);
        t.add(0xf977, 0xf977, [2, [0x4EAE], 0]);
        t.add(0xf978, 0xf978, [2, [0x5169], 0]);
        t.add(0xf979, 0xf979, [2, [0x51C9], 0]);
        t.add(0xf97a, 0xf97a, [2, [0x6881], 0]);
        t.add(0xf97b, 0xf97b, [2, [0x7CE7], 0]);
        t.add(0xf97c, 0xf97c, [2, [0x826F], 0]);
        t.add(0xf97d, 0xf97d, [2, [0x8AD2], 0]);
        t.add(0xf97e, 0xf97e, [2, [0x91CF], 0]);
        t.add(0xf97f, 0xf97f, [2, [0x52F5], 0]);
        t.add(0xf980, 0xf980, [2, [0x5442], 0]);
        t.add(0xf981, 0xf981, [2, [0x5973], 0]);
        t.add(0xf982, 0xf982, [2, [0x5EEC], 0]);
        t.add(0xf983, 0xf983, [2, [0x65C5], 0]);
        t.add(0xf984, 0xf984, [2, [0x6FFE], 0]);
        t.add(0xf985, 0xf985, [2, [0x792A], 0]);
        t.add(0xf986, 0xf986, [2, [0x95AD], 0]);
        t.add(0xf987, 0xf987, [2, [0x9A6A], 0]);
        t.add(0xf988, 0xf988, [2, [0x9E97], 0]);
        t.add(0xf989, 0xf989, [2, [0x9ECE], 0]);
        t.add(0xf98a, 0xf98a, [2, [0x529B], 0]);
        t.add(0xf98b, 0xf98b, [2, [0x66C6], 0]);
        t.add(0xf98c, 0xf98c, [2, [0x6B77], 0]);
        t.add(0xf98d, 0xf98d, [2, [0x8F62], 0]);
        t.add(0xf98e, 0xf98e, [2, [0x5E74], 0]);
        t.add(0xf98f, 0xf98f, [2, [0x6190], 0]);
        t.add(0xf990, 0xf990, [2, [0x6200], 0]);
        t.add(0xf991, 0xf991, [2, [0x649A], 0]);
        t.add(0xf992, 0xf992, [2, [0x6F23], 0]);
        t.add(0xf993, 0xf993, [2, [0x7149], 0]);
        t.add(0xf994, 0xf994, [2, [0x7489], 0]);
        t.add(0xf995, 0xf995, [2, [0x79CA], 0]);
        t.add(0xf996, 0xf996, [2, [0x7DF4], 0]);
        t.add(0xf997, 0xf997, [2, [0x806F], 0]);
        t.add(0xf998, 0xf998, [2, [0x8F26], 0]);
        t.add(0xf999, 0xf999, [2, [0x84EE], 0]);
        t.add(0xf99a, 0xf99a, [2, [0x9023], 0]);
        t.add(0xf99b, 0xf99b, [2, [0x934A], 0]);
        t.add(0xf99c, 0xf99c, [2, [0x5217], 0]);
        t.add(0xf99d, 0xf99d, [2, [0x52A3], 0]);
        t.add(0xf99e, 0xf99e, [2, [0x54BD], 0]);
        t.add(0xf99f, 0xf99f, [2, [0x70C8], 0]);
        t.add(0xf9a0, 0xf9a0, [2, [0x88C2], 0]);
        t.add(0xf9a1, 0xf9a1, [2, [0x8AAA], 0]);
        t.add(0xf9a2, 0xf9a2, [2, [0x5EC9], 0]);
        t.add(0xf9a3, 0xf9a3, [2, [0x5FF5], 0]);
        t.add(0xf9a4, 0xf9a4, [2, [0x637B], 0]);
        t.add(0xf9a5, 0xf9a5, [2, [0x6BAE], 0]);
        t.add(0xf9a6, 0xf9a6, [2, [0x7C3E], 0]);
        t.add(0xf9a7, 0xf9a7, [2, [0x7375], 0]);
        t.add(0xf9a8, 0xf9a8, [2, [0x4EE4], 0]);
        t.add(0xf9a9, 0xf9a9, [2, [0x56F9], 0]);
        t.add(0xf9aa, 0xf9aa, [2, [0x5BE7], 0]);
        t.add(0xf9ab, 0xf9ab, [2, [0x5DBA], 0]);
        t.add(0xf9ac, 0xf9ac, [2, [0x601C], 0]);
        t.add(0xf9ad, 0xf9ad, [2, [0x73B2], 0]);
        t.add(0xf9ae, 0xf9ae, [2, [0x7469], 0]);
        t.add(0xf9af, 0xf9af, [2, [0x7F9A], 0]);
        t.add(0xf9b0, 0xf9b0, [2, [0x8046], 0]);
        t.add(0xf9b1, 0xf9b1, [2, [0x9234], 0]);
        t.add(0xf9b2, 0xf9b2, [2, [0x96F6], 0]);
        t.add(0xf9b3, 0xf9b3, [2, [0x9748], 0]);
        t.add(0xf9b4, 0xf9b4, [2, [0x9818], 0]);
        t.add(0xf9b5, 0xf9b5, [2, [0x4F8B], 0]);
        t.add(0xf9b6, 0xf9b6, [2, [0x79AE], 0]);
        t.add(0xf9b7, 0xf9b7, [2, [0x91B4], 0]);
        t.add(0xf9b8, 0xf9b8, [2, [0x96B8], 0]);
        t.add(0xf9b9, 0xf9b9, [2, [0x60E1], 0]);
        t.add(0xf9ba, 0xf9ba, [2, [0x4E86], 0]);
        t.add(0xf9bb, 0xf9bb, [2, [0x50DA], 0]);
        t.add(0xf9bc, 0xf9bc, [2, [0x5BEE], 0]);
        t.add(0xf9bd, 0xf9bd, [2, [0x5C3F], 0]);
        t.add(0xf9be, 0xf9be, [2, [0x6599], 0]);
        t.add(0xf9bf, 0xf9bf, [2, [0x6A02], 0]);
        t.add(0xf9c0, 0xf9c0, [2, [0x71CE], 0]);
        t.add(0xf9c1, 0xf9c1, [2, [0x7642], 0]);
        t.add(0xf9c2, 0xf9c2, [2, [0x84FC], 0]);
        t.add(0xf9c3, 0xf9c3, [2, [0x907C], 0]);
        t.add(0xf9c4, 0xf9c4, [2, [0x9F8D], 0]);
        t.add(0xf9c5, 0xf9c5, [2, [0x6688], 0]);
        t.add(0xf9c6, 0xf9c6, [2, [0x962E], 0]);
        t.add(0xf9c7, 0xf9c7, [2, [0x5289], 0]);
        t.add(0xf9c8, 0xf9c8, [2, [0x677B], 0]);
        t.add(0xf9c9, 0xf9c9, [2, [0x67F3], 0]);
        t.add(0xf9ca, 0xf9ca, [2, [0x6D41], 0]);
        t.add(0xf9cb, 0xf9cb, [2, [0x6E9C], 0]);
        t.add(0xf9cc, 0xf9cc, [2, [0x7409], 0]);
        t.add(0xf9cd, 0xf9cd, [2, [0x7559], 0]);
        t.add(0xf9ce, 0xf9ce, [2, [0x786B], 0]);
        t.add(0xf9cf, 0xf9cf, [2, [0x7D10], 0]);
        t.add(0xf9d0, 0xf9d0, [2, [0x985E], 0]);
        t.add(0xf9d1, 0xf9d1, [2, [0x516D], 0]);
        t.add(0xf9d2, 0xf9d2, [2, [0x622E], 0]);
        t.add(0xf9d3, 0xf9d3, [2, [0x9678], 0]);
        t.add(0xf9d4, 0xf9d4, [2, [0x502B], 0]);
        t.add(0xf9d5, 0xf9d5, [2, [0x5D19], 0]);
        t.add(0xf9d6, 0xf9d6, [2, [0x6DEA], 0]);
        t.add(0xf9d7, 0xf9d7, [2, [0x8F2A], 0]);
        t.add(0xf9d8, 0xf9d8, [2, [0x5F8B], 0]);
        t.add(0xf9d9, 0xf9d9, [2, [0x6144], 0]);
        t.add(0xf9da, 0xf9da, [2, [0x6817], 0]);
        t.add(0xf9db, 0xf9db, [2, [0x7387], 0]);
        t.add(0xf9dc, 0xf9dc, [2, [0x9686], 0]);
        t.add(0xf9dd, 0xf9dd, [2, [0x5229], 0]);
        t.add(0xf9de, 0xf9de, [2, [0x540F], 0]);
        t.add(0xf9df, 0xf9df, [2, [0x5C65], 0]);
        t.add(0xf9e0, 0xf9e0, [2, [0x6613], 0]);
        t.add(0xf9e1, 0xf9e1, [2, [0x674E], 0]);
        t.add(0xf9e2, 0xf9e2, [2, [0x68A8], 0]);
        t.add(0xf9e3, 0xf9e3, [2, [0x6CE5], 0]);
        t.add(0xf9e4, 0xf9e4, [2, [0x7406], 0]);
        t.add(0xf9e5, 0xf9e5, [2, [0x75E2], 0]);
        t.add(0xf9e6, 0xf9e6, [2, [0x7F79], 0]);
        t.add(0xf9e7, 0xf9e7, [2, [0x88CF], 0]);
        t.add(0xf9e8, 0xf9e8, [2, [0x88E1], 0]);
        t.add(0xf9e9, 0xf9e9, [2, [0x91CC], 0]);
        t.add(0xf9ea, 0xf9ea, [2, [0x96E2], 0]);
        t.add(0xf9eb, 0xf9eb, [2, [0x533F], 0]);
        t.add(0xf9ec, 0xf9ec, [2, [0x6EBA], 0]);
        t.add(0xf9ed, 0xf9ed, [2, [0x541D], 0]);
        t.add(0xf9ee, 0xf9ee, [2, [0x71D0], 0]);
        t.add(0xf9ef, 0xf9ef, [2, [0x7498], 0]);
        t.add(0xf9f0, 0xf9f0, [2, [0x85FA], 0]);
        t.add(0xf9f1, 0xf9f1, [2, [0x96A3], 0]);
        t.add(0xf9f2, 0xf9f2, [2, [0x9C57], 0]);
        t.add(0xf9f3, 0xf9f3, [2, [0x9E9F], 0]);
        t.add(0xf9f4, 0xf9f4, [2, [0x6797], 0]);
        t.add(0xf9f5, 0xf9f5, [2, [0x6DCB], 0]);
        t.add(0xf9f6, 0xf9f6, [2, [0x81E8], 0]);
        t.add(0xf9f7, 0xf9f7, [2, [0x7ACB], 0]);
        t.add(0xf9f8, 0xf9f8, [2, [0x7B20], 0]);
        t.add(0xf9f9, 0xf9f9, [2, [0x7C92], 0]);
        t.add(0xf9fa, 0xf9fa, [2, [0x72C0], 0]);
        t.add(0xf9fb, 0xf9fb, [2, [0x7099], 0]);
        t.add(0xf9fc, 0xf9fc, [2, [0x8B58], 0]);
        t.add(0xf9fd, 0xf9fd, [2, [0x4EC0], 0]);
        t.add(0xf9fe, 0xf9fe, [2, [0x8336], 0]);
        t.add(0xf9ff, 0xf9ff, [2, [0x523A], 0]);
        t.add(0xfa00, 0xfa00, [2, [0x5207], 0]);
        t.add(0xfa01, 0xfa01, [2, [0x5EA6], 0]);
        t.add(0xfa02, 0xfa02, [2, [0x62D3], 0]);
        t.add(0xfa03, 0xfa03, [2, [0x7CD6], 0]);
        t.add(0xfa04, 0xfa04, [2, [0x5B85], 0]);
        t.add(0xfa05, 0xfa05, [2, [0x6D1E], 0]);
        t.add(0xfa06, 0xfa06, [2, [0x66B4], 0]);
        t.add(0xfa07, 0xfa07, [2, [0x8F3B], 0]);
        t.add(0xfa08, 0xfa08, [2, [0x884C], 0]);
        t.add(0xfa09, 0xfa09, [2, [0x964D], 0]);
        t.add(0xfa0a, 0xfa0a, [2, [0x898B], 0]);
        t.add(0xfa0b, 0xfa0b, [2, [0x5ED3], 0]);
        t.add(0xfa0c, 0xfa0c, [2, [0x5140], 0]);
        t.add(0xfa0d, 0xfa0d, [2, [0x55C0], 0]);
        t.add(0xfa0e, 0xfa0f, [0, [], 0]);
        t.add(0xfa10, 0xfa10, [2, [0x585A], 0]);
        t.add(0xfa11, 0xfa11, [0, [], 0]);
        t.add(0xfa12, 0xfa12, [2, [0x6674], 0]);
        t.add(0xfa13, 0xfa14, [0, [], 0]);
        t.add(0xfa15, 0xfa15, [2, [0x51DE], 0]);
        t.add(0xfa16, 0xfa16, [2, [0x732A], 0]);
        t.add(0xfa17, 0xfa17, [2, [0x76CA], 0]);
        t.add(0xfa18, 0xfa18, [2, [0x793C], 0]);
        t.add(0xfa19, 0xfa19, [2, [0x795E], 0]);
        t.add(0xfa1a, 0xfa1a, [2, [0x7965], 0]);
        t.add(0xfa1b, 0xfa1b, [2, [0x798F], 0]);
        t.add(0xfa1c, 0xfa1c, [2, [0x9756], 0]);
        t.add(0xfa1d, 0xfa1d, [2, [0x7CBE], 0]);
        t.add(0xfa1e, 0xfa1e, [2, [0x7FBD], 0]);
        t.add(0xfa1f, 0xfa1f, [0, [], 0]);
        t.add(0xfa20, 0xfa20, [2, [0x8612], 0]);
        t.add(0xfa21, 0xfa21, [0, [], 0]);
        t.add(0xfa22, 0xfa22, [2, [0x8AF8], 0]);
        t.add(0xfa23, 0xfa24, [0, [], 0]);
        t.add(0xfa25, 0xfa25, [2, [0x9038], 0]);
        t.add(0xfa26, 0xfa26, [2, [0x90FD], 0]);
        t.add(0xfa27, 0xfa29, [0, [], 0]);
        t.add(0xfa2a, 0xfa2a, [2, [0x98EF], 0]);
        t.add(0xfa2b, 0xfa2b, [2, [0x98FC], 0]);
        t.add(0xfa2c, 0xfa2c, [2, [0x9928], 0]);
        t.add(0xfa2d, 0xfa2d, [2, [0x9DB4], 0]);
        t.add(0xfa2e, 0xfa2e, [2, [0x90DE], 0]);
        t.add(0xfa2f, 0xfa2f, [2, [0x96B7], 0]);
        t.add(0xfa30, 0xfa30, [2, [0x4FAE], 0]);
        t.add(0xfa31, 0xfa31, [2, [0x50E7], 0]);
        t.add(0xfa32, 0xfa32, [2, [0x514D], 0]);
        t.add(0xfa33, 0xfa33, [2, [0x52C9], 0]);
        t.add(0xfa34, 0xfa34, [2, [0x52E4], 0]);
        t.add(0xfa35, 0xfa35, [2, [0x5351], 0]);
        t.add(0xfa36, 0xfa36, [2, [0x559D], 0]);
        t.add(0xfa37, 0xfa37, [2, [0x5606], 0]);
        t.add(0xfa38, 0xfa38, [2, [0x5668], 0]);
        t.add(0xfa39, 0xfa39, [2, [0x5840], 0]);
        t.add(0xfa3a, 0xfa3a, [2, [0x58A8], 0]);
        t.add(0xfa3b, 0xfa3b, [2, [0x5C64], 0]);
        t.add(0xfa3c, 0xfa3c, [2, [0x5C6E], 0]);
        t.add(0xfa3d, 0xfa3d, [2, [0x6094], 0]);
        t.add(0xfa3e, 0xfa3e, [2, [0x6168], 0]);
        t.add(0xfa3f, 0xfa3f, [2, [0x618E], 0]);
        t.add(0xfa40, 0xfa40, [2, [0x61F2], 0]);
        t.add(0xfa41, 0xfa41, [2, [0x654F], 0]);
        t.add(0xfa42, 0xfa42, [2, [0x65E2], 0]);
        t.add(0xfa43, 0xfa43, [2, [0x6691], 0]);
        t.add(0xfa44, 0xfa44, [2, [0x6885], 0]);
        t.add(0xfa45, 0xfa45, [2, [0x6D77], 0]);
        t.add(0xfa46, 0xfa46, [2, [0x6E1A], 0]);
        t.add(0xfa47, 0xfa47, [2, [0x6F22], 0]);
        t.add(0xfa48, 0xfa48, [2, [0x716E], 0]);
        t.add(0xfa49, 0xfa49, [2, [0x722B], 0]);
        t.add(0xfa4a, 0xfa4a, [2, [0x7422], 0]);
        t.add(0xfa4b, 0xfa4b, [2, [0x7891], 0]);
        t.add(0xfa4c, 0xfa4c, [2, [0x793E], 0]);
        t.add(0xfa4d, 0xfa4d, [2, [0x7949], 0]);
        t.add(0xfa4e, 0xfa4e, [2, [0x7948], 0]);
        t.add(0xfa4f, 0xfa4f, [2, [0x7950], 0]);
        t.add(0xfa50, 0xfa50, [2, [0x7956], 0]);
        t.add(0xfa51, 0xfa51, [2, [0x795D], 0]);
        t.add(0xfa52, 0xfa52, [2, [0x798D], 0]);
        t.add(0xfa53, 0xfa53, [2, [0x798E], 0]);
        t.add(0xfa54, 0xfa54, [2, [0x7A40], 0]);
        t.add(0xfa55, 0xfa55, [2, [0x7A81], 0]);
        t.add(0xfa56, 0xfa56, [2, [0x7BC0], 0]);
        t.add(0xfa57, 0xfa57, [2, [0x7DF4], 0]);
        t.add(0xfa58, 0xfa58, [2, [0x7E09], 0]);
        t.add(0xfa59, 0xfa59, [2, [0x7E41], 0]);
        t.add(0xfa5a, 0xfa5a, [2, [0x7F72], 0]);
        t.add(0xfa5b, 0xfa5b, [2, [0x8005], 0]);
        t.add(0xfa5c, 0xfa5c, [2, [0x81ED], 0]);
        t.add(0xfa5d, 0xfa5e, [2, [0x8279], 0]);
        t.add(0xfa5f, 0xfa5f, [2, [0x8457], 0]);
        t.add(0xfa60, 0xfa60, [2, [0x8910], 0]);
        t.add(0xfa61, 0xfa61, [2, [0x8996], 0]);
        t.add(0xfa62, 0xfa62, [2, [0x8B01], 0]);
        t.add(0xfa63, 0xfa63, [2, [0x8B39], 0]);
        t.add(0xfa64, 0xfa64, [2, [0x8CD3], 0]);
        t.add(0xfa65, 0xfa65, [2, [0x8D08], 0]);
        t.add(0xfa66, 0xfa66, [2, [0x8FB6], 0]);
        t.add(0xfa67, 0xfa67, [2, [0x9038], 0]);
        t.add(0xfa68, 0xfa68, [2, [0x96E3], 0]);
        t.add(0xfa69, 0xfa69, [2, [0x97FF], 0]);
        t.add(0xfa6a, 0xfa6a, [2, [0x983B], 0]);
        t.add(0xfa6b, 0xfa6b, [2, [0x6075], 0]);
        t.add(0xfa6c, 0xfa6c, [2, [0x242EE], 0]);
        t.add(0xfa6d, 0xfa6d, [2, [0x8218], 0]);
        t.add(0xfa6e, 0xfa6f, [4, [], 0]);
        t.add(0xfa70, 0xfa70, [2, [0x4E26], 0]);
        t.add(0xfa71, 0xfa71, [2, [0x51B5], 0]);
        t.add(0xfa72, 0xfa72, [2, [0x5168], 0]);
        t.add(0xfa73, 0xfa73, [2, [0x4F80], 0]);
        t.add(0xfa74, 0xfa74, [2, [0x5145], 0]);
        t.add(0xfa75, 0xfa75, [2, [0x5180], 0]);
        t.add(0xfa76, 0xfa76, [2, [0x52C7], 0]);
        t.add(0xfa77, 0xfa77, [2, [0x52FA], 0]);
        t.add(0xfa78, 0xfa78, [2, [0x559D], 0]);
        t.add(0xfa79, 0xfa79, [2, [0x5555], 0]);
        t.add(0xfa7a, 0xfa7a, [2, [0x5599], 0]);
        t.add(0xfa7b, 0xfa7b, [2, [0x55E2], 0]);
        t.add(0xfa7c, 0xfa7c, [2, [0x585A], 0]);
        t.add(0xfa7d, 0xfa7d, [2, [0x58B3], 0]);
        t.add(0xfa7e, 0xfa7e, [2, [0x5944], 0]);
        t.add(0xfa7f, 0xfa7f, [2, [0x5954], 0]);
        t.add(0xfa80, 0xfa80, [2, [0x5A62], 0]);
        t.add(0xfa81, 0xfa81, [2, [0x5B28], 0]);
        t.add(0xfa82, 0xfa82, [2, [0x5ED2], 0]);
        t.add(0xfa83, 0xfa83, [2, [0x5ED9], 0]);
        t.add(0xfa84, 0xfa84, [2, [0x5F69], 0]);
        t.add(0xfa85, 0xfa85, [2, [0x5FAD], 0]);
        t.add(0xfa86, 0xfa86, [2, [0x60D8], 0]);
        t.add(0xfa87, 0xfa87, [2, [0x614E], 0]);
        t.add(0xfa88, 0xfa88, [2, [0x6108], 0]);
        t.add(0xfa89, 0xfa89, [2, [0x618E], 0]);
        t.add(0xfa8a, 0xfa8a, [2, [0x6160], 0]);
        t.add(0xfa8b, 0xfa8b, [2, [0x61F2], 0]);
        t.add(0xfa8c, 0xfa8c, [2, [0x6234], 0]);
        t.add(0xfa8d, 0xfa8d, [2, [0x63C4], 0]);
        t.add(0xfa8e, 0xfa8e, [2, [0x641C], 0]);
        t.add(0xfa8f, 0xfa8f, [2, [0x6452], 0]);
        t.add(0xfa90, 0xfa90, [2, [0x6556], 0]);
        t.add(0xfa91, 0xfa91, [2, [0x6674], 0]);
        t.add(0xfa92, 0xfa92, [2, [0x6717], 0]);
        t.add(0xfa93, 0xfa93, [2, [0x671B], 0]);
        t.add(0xfa94, 0xfa94, [2, [0x6756], 0]);
        t.add(0xfa95, 0xfa95, [2, [0x6B79], 0]);
        t.add(0xfa96, 0xfa96, [2, [0x6BBA], 0]);
        t.add(0xfa97, 0xfa97, [2, [0x6D41], 0]);
        t.add(0xfa98, 0xfa98, [2, [0x6EDB], 0]);
        t.add(0xfa99, 0xfa99, [2, [0x6ECB], 0]);
        t.add(0xfa9a, 0xfa9a, [2, [0x6F22], 0]);
        t.add(0xfa9b, 0xfa9b, [2, [0x701E], 0]);
        t.add(0xfa9c, 0xfa9c, [2, [0x716E], 0]);
        t.add(0xfa9d, 0xfa9d, [2, [0x77A7], 0]);
        t.add(0xfa9e, 0xfa9e, [2, [0x7235], 0]);
        t.add(0xfa9f, 0xfa9f, [2, [0x72AF], 0]);
        t.add(0xfaa0, 0xfaa0, [2, [0x732A], 0]);
        t.add(0xfaa1, 0xfaa1, [2, [0x7471], 0]);
        t.add(0xfaa2, 0xfaa2, [2, [0x7506], 0]);
        t.add(0xfaa3, 0xfaa3, [2, [0x753B], 0]);
        t.add(0xfaa4, 0xfaa4, [2, [0x761D], 0]);
        t.add(0xfaa5, 0xfaa5, [2, [0x761F], 0]);
        t.add(0xfaa6, 0xfaa6, [2, [0x76CA], 0]);
        t.add(0xfaa7, 0xfaa7, [2, [0x76DB], 0]);
        t.add(0xfaa8, 0xfaa8, [2, [0x76F4], 0]);
        t.add(0xfaa9, 0xfaa9, [2, [0x774A], 0]);
        t.add(0xfaaa, 0xfaaa, [2, [0x7740], 0]);
        t.add(0xfaab, 0xfaab, [2, [0x78CC], 0]);
        t.add(0xfaac, 0xfaac, [2, [0x7AB1], 0]);
        t.add(0xfaad, 0xfaad, [2, [0x7BC0], 0]);
        t.add(0xfaae, 0xfaae, [2, [0x7C7B], 0]);
        t.add(0xfaaf, 0xfaaf, [2, [0x7D5B], 0]);
        t.add(0xfab0, 0xfab0, [2, [0x7DF4], 0]);
        t.add(0xfab1, 0xfab1, [2, [0x7F3E], 0]);
        t.add(0xfab2, 0xfab2, [2, [0x8005], 0]);
        t.add(0xfab3, 0xfab3, [2, [0x8352], 0]);
        t.add(0xfab4, 0xfab4, [2, [0x83EF], 0]);
        t.add(0xfab5, 0xfab5, [2, [0x8779], 0]);
        t.add(0xfab6, 0xfab6, [2, [0x8941], 0]);
        t.add(0xfab7, 0xfab7, [2, [0x8986], 0]);
        t.add(0xfab8, 0xfab8, [2, [0x8996], 0]);
        t.add(0xfab9, 0xfab9, [2, [0x8ABF], 0]);
        t.add(0xfaba, 0xfaba, [2, [0x8AF8], 0]);
        t.add(0xfabb, 0xfabb, [2, [0x8ACB], 0]);
        t.add(0xfabc, 0xfabc, [2, [0x8B01], 0]);
        t.add(0xfabd, 0xfabd, [2, [0x8AFE], 0]);
        t.add(0xfabe, 0xfabe, [2, [0x8AED], 0]);
        t.add(0xfabf, 0xfabf, [2, [0x8B39], 0]);
        t.add(0xfac0, 0xfac0, [2, [0x8B8A], 0]);
        t.add(0xfac1, 0xfac1, [2, [0x8D08], 0]);
        t.add(0xfac2, 0xfac2, [2, [0x8F38], 0]);
        t.add(0xfac3, 0xfac3, [2, [0x9072], 0]);
        t.add(0xfac4, 0xfac4, [2, [0x9199], 0]);
        t.add(0xfac5, 0xfac5, [2, [0x9276], 0]);
        t.add(0xfac6, 0xfac6, [2, [0x967C], 0]);
        t.add(0xfac7, 0xfac7, [2, [0x96E3], 0]);
        t.add(0xfac8, 0xfac8, [2, [0x9756], 0]);
        t.add(0xfac9, 0xfac9, [2, [0x97DB], 0]);
        t.add(0xfaca, 0xfaca, [2, [0x97FF], 0]);
        t.add(0xfacb, 0xfacb, [2, [0x980B], 0]);
        t.add(0xfacc, 0xfacc, [2, [0x983B], 0]);
        t.add(0xfacd, 0xfacd, [2, [0x9B12], 0]);
        t.add(0xface, 0xface, [2, [0x9F9C], 0]);
        t.add(0xfacf, 0xfacf, [2, [0x2284A], 0]);
        t.add(0xfad0, 0xfad0, [2, [0x22844], 0]);
        t.add(0xfad1, 0xfad1, [2, [0x233D5], 0]);
        t.add(0xfad2, 0xfad2, [2, [0x3B9D], 0]);
        t.add(0xfad3, 0xfad3, [2, [0x4018], 0]);
        t.add(0xfad4, 0xfad4, [2, [0x4039], 0]);
        t.add(0xfad5, 0xfad5, [2, [0x25249], 0]);
        t.add(0xfad6, 0xfad6, [2, [0x25CD0], 0]);
        t.add(0xfad7, 0xfad7, [2, [0x27ED3], 0]);
        t.add(0xfad8, 0xfad8, [2, [0x9F43], 0]);
        t.add(0xfad9, 0xfad9, [2, [0x9F8E], 0]);
        t.add(0xfada, 0xfaff, [4, [], 0]);
        t.add(0xfb00, 0xfb00, [2, [0x0066, 0x0066], 0]);
        t.add(0xfb01, 0xfb01, [2, [0x0066, 0x0069], 0]);
        t.add(0xfb02, 0xfb02, [2, [0x0066, 0x006C], 0]);
        t.add(0xfb03, 0xfb03, [2, [0x0066, 0x0066, 0x0069], 0]);
        t.add(0xfb04, 0xfb04, [2, [0x0066, 0x0066, 0x006C], 0]);
        t.add(0xfb05, 0xfb06, [2, [0x0073, 0x0074], 0]);
        t.add(0xfb07, 0xfb12, [4, [], 0]);
        t.add(0xfb13, 0xfb13, [2, [0x0574, 0x0576], 0]);
        t.add(0xfb14, 0xfb14, [2, [0x0574, 0x0565], 0]);
        t.add(0xfb15, 0xfb15, [2, [0x0574, 0x056B], 0]);
        t.add(0xfb16, 0xfb16, [2, [0x057E, 0x0576], 0]);
        t.add(0xfb17, 0xfb17, [2, [0x0574, 0x056D], 0]);
        t.add(0xfb18, 0xfb1c, [4, [], 0]);
        t.add(0xfb1d, 0xfb1d, [2, [0x05D9, 0x05B4], 0]);
        t.add(0xfb1e, 0xfb1e, [0, [], 0]);
        t.add(0xfb1f, 0xfb1f, [2, [0x05F2, 0x05B7], 0]);
        t.add(0xfb20, 0xfb20, [2, [0x05E2], 0]);
        t.add(0xfb21, 0xfb21, [2, [0x05D0], 0]);
        t.add(0xfb22, 0xfb22, [2, [0x05D3], 0]);
        t.add(0xfb23, 0xfb23, [2, [0x05D4], 0]);
        t.add(0xfb24, 0xfb24, [2, [0x05DB], 0]);
        t.add(0xfb25, 0xfb25, [2, [0x05DC], 0]);
        t.add(0xfb26, 0xfb26, [2, [0x05DD], 0]);
        t.add(0xfb27, 0xfb27, [2, [0x05E8], 0]);
        t.add(0xfb28, 0xfb28, [2, [0x05EA], 0]);
        t.add(0xfb29, 0xfb29, [6, [0x002B], 0]);
        t.add(0xfb2a, 0xfb2a, [2, [0x05E9, 0x05C1], 0]);
        t.add(0xfb2b, 0xfb2b, [2, [0x05E9, 0x05C2], 0]);
        t.add(0xfb2c, 0xfb2c, [2, [0x05E9, 0x05BC, 0x05C1], 0]);
        t.add(0xfb2d, 0xfb2d, [2, [0x05E9, 0x05BC, 0x05C2], 0]);
        t.add(0xfb2e, 0xfb2e, [2, [0x05D0, 0x05B7], 0]);
        t.add(0xfb2f, 0xfb2f, [2, [0x05D0, 0x05B8], 0]);
        t.add(0xfb30, 0xfb30, [2, [0x05D0, 0x05BC], 0]);
        t.add(0xfb31, 0xfb31, [2, [0x05D1, 0x05BC], 0]);
        t.add(0xfb32, 0xfb32, [2, [0x05D2, 0x05BC], 0]);
        t.add(0xfb33, 0xfb33, [2, [0x05D3, 0x05BC], 0]);
        t.add(0xfb34, 0xfb34, [2, [0x05D4, 0x05BC], 0]);
        t.add(0xfb35, 0xfb35, [2, [0x05D5, 0x05BC], 0]);
        t.add(0xfb36, 0xfb36, [2, [0x05D6, 0x05BC], 0]);
        t.add(0xfb37, 0xfb37, [4, [], 0]);
        t.add(0xfb38, 0xfb38, [2, [0x05D8, 0x05BC], 0]);
        t.add(0xfb39, 0xfb39, [2, [0x05D9, 0x05BC], 0]);
        t.add(0xfb3a, 0xfb3a, [2, [0x05DA, 0x05BC], 0]);
        t.add(0xfb3b, 0xfb3b, [2, [0x05DB, 0x05BC], 0]);
        t.add(0xfb3c, 0xfb3c, [2, [0x05DC, 0x05BC], 0]);
        t.add(0xfb3d, 0xfb3d, [4, [], 0]);
        t.add(0xfb3e, 0xfb3e, [2, [0x05DE, 0x05BC], 0]);
        t.add(0xfb3f, 0xfb3f, [4, [], 0]);
        t.add(0xfb40, 0xfb40, [2, [0x05E0, 0x05BC], 0]);
        t.add(0xfb41, 0xfb41, [2, [0x05E1, 0x05BC], 0]);
        t.add(0xfb42, 0xfb42, [4, [], 0]);
        t.add(0xfb43, 0xfb43, [2, [0x05E3, 0x05BC], 0]);
        t.add(0xfb44, 0xfb44, [2, [0x05E4, 0x05BC], 0]);
        t.add(0xfb45, 0xfb45, [4, [], 0]);
        t.add(0xfb46, 0xfb46, [2, [0x05E6, 0x05BC], 0]);
        t.add(0xfb47, 0xfb47, [2, [0x05E7, 0x05BC], 0]);
        t.add(0xfb48, 0xfb48, [2, [0x05E8, 0x05BC], 0]);
        t.add(0xfb49, 0xfb49, [2, [0x05E9, 0x05BC], 0]);
        t.add(0xfb4a, 0xfb4a, [2, [0x05EA, 0x05BC], 0]);
        t.add(0xfb4b, 0xfb4b, [2, [0x05D5, 0x05B9], 0]);
        t.add(0xfb4c, 0xfb4c, [2, [0x05D1, 0x05BF], 0]);
        t.add(0xfb4d, 0xfb4d, [2, [0x05DB, 0x05BF], 0]);
        t.add(0xfb4e, 0xfb4e, [2, [0x05E4, 0x05BF], 0]);
        t.add(0xfb4f, 0xfb4f, [2, [0x05D0, 0x05DC], 0]);
        t.add(0xfb50, 0xfb51, [2, [0x0671], 0]);
        t.add(0xfb52, 0xfb55, [2, [0x067B], 0]);
        t.add(0xfb56, 0xfb59, [2, [0x067E], 0]);
        t.add(0xfb5a, 0xfb5d, [2, [0x0680], 0]);
        t.add(0xfb5e, 0xfb61, [2, [0x067A], 0]);
        t.add(0xfb62, 0xfb65, [2, [0x067F], 0]);
        t.add(0xfb66, 0xfb69, [2, [0x0679], 0]);
        t.add(0xfb6a, 0xfb6d, [2, [0x06A4], 0]);
        t.add(0xfb6e, 0xfb71, [2, [0x06A6], 0]);
        t.add(0xfb72, 0xfb75, [2, [0x0684], 0]);
        t.add(0xfb76, 0xfb79, [2, [0x0683], 0]);
        t.add(0xfb7a, 0xfb7d, [2, [0x0686], 0]);
        t.add(0xfb7e, 0xfb81, [2, [0x0687], 0]);
        t.add(0xfb82, 0xfb83, [2, [0x068D], 0]);
        t.add(0xfb84, 0xfb85, [2, [0x068C], 0]);
        t.add(0xfb86, 0xfb87, [2, [0x068E], 0]);
        t.add(0xfb88, 0xfb89, [2, [0x0688], 0]);
        t.add(0xfb8a, 0xfb8b, [2, [0x0698], 0]);
        t.add(0xfb8c, 0xfb8d, [2, [0x0691], 0]);
        t.add(0xfb8e, 0xfb91, [2, [0x06A9], 0]);
        t.add(0xfb92, 0xfb95, [2, [0x06AF], 0]);
        t.add(0xfb96, 0xfb99, [2, [0x06B3], 0]);
        t.add(0xfb9a, 0xfb9d, [2, [0x06B1], 0]);
        t.add(0xfb9e, 0xfb9f, [2, [0x06BA], 0]);
        t.add(0xfba0, 0xfba3, [2, [0x06BB], 0]);
        t.add(0xfba4, 0xfba5, [2, [0x06C0], 0]);
        t.add(0xfba6, 0xfba9, [2, [0x06C1], 0]);
        t.add(0xfbaa, 0xfbad, [2, [0x06BE], 0]);
        t.add(0xfbae, 0xfbaf, [2, [0x06D2], 0]);
        t.add(0xfbb0, 0xfbb1, [2, [0x06D3], 0]);
        t.add(0xfbb2, 0xfbc1, [0, [], 1]);
        t.add(0xfbc2, 0xfbd2, [4, [], 0]);
        t.add(0xfbd3, 0xfbd6, [2, [0x06AD], 0]);
        t.add(0xfbd7, 0xfbd8, [2, [0x06C7], 0]);
        t.add(0xfbd9, 0xfbda, [2, [0x06C6], 0]);
        t.add(0xfbdb, 0xfbdc, [2, [0x06C8], 0]);
        t.add(0xfbdd, 0xfbdd, [2, [0x06C7, 0x0674], 0]);
        t.add(0xfbde, 0xfbdf, [2, [0x06CB], 0]);
        t.add(0xfbe0, 0xfbe1, [2, [0x06C5], 0]);
        t.add(0xfbe2, 0xfbe3, [2, [0x06C9], 0]);
        t.add(0xfbe4, 0xfbe7, [2, [0x06D0], 0]);
        t.add(0xfbe8, 0xfbe9, [2, [0x0649], 0]);
        t.add(0xfbea, 0xfbeb, [2, [0x0626, 0x0627], 0]);
        t.add(0xfbec, 0xfbed, [2, [0x0626, 0x06D5], 0]);
        t.add(0xfbee, 0xfbef, [2, [0x0626, 0x0648], 0]);
        t.add(0xfbf0, 0xfbf1, [2, [0x0626, 0x06C7], 0]);
        t.add(0xfbf2, 0xfbf3, [2, [0x0626, 0x06C6], 0]);
        t.add(0xfbf4, 0xfbf5, [2, [0x0626, 0x06C8], 0]);
        t.add(0xfbf6, 0xfbf8, [2, [0x0626, 0x06D0], 0]);
        t.add(0xfbf9, 0xfbfb, [2, [0x0626, 0x0649], 0]);
        t.add(0xfbfc, 0xfbff, [2, [0x06CC], 0]);
        t.add(0xfc00, 0xfc00, [2, [0x0626, 0x062C], 0]);
        t.add(0xfc01, 0xfc01, [2, [0x0626, 0x062D], 0]);
        t.add(0xfc02, 0xfc02, [2, [0x0626, 0x0645], 0]);
        t.add(0xfc03, 0xfc03, [2, [0x0626, 0x0649], 0]);
        t.add(0xfc04, 0xfc04, [2, [0x0626, 0x064A], 0]);
        t.add(0xfc05, 0xfc05, [2, [0x0628, 0x062C], 0]);
        t.add(0xfc06, 0xfc06, [2, [0x0628, 0x062D], 0]);
        t.add(0xfc07, 0xfc07, [2, [0x0628, 0x062E], 0]);
        t.add(0xfc08, 0xfc08, [2, [0x0628, 0x0645], 0]);
        t.add(0xfc09, 0xfc09, [2, [0x0628, 0x0649], 0]);
        t.add(0xfc0a, 0xfc0a, [2, [0x0628, 0x064A], 0]);
        t.add(0xfc0b, 0xfc0b, [2, [0x062A, 0x062C], 0]);
        t.add(0xfc0c, 0xfc0c, [2, [0x062A, 0x062D], 0]);
        t.add(0xfc0d, 0xfc0d, [2, [0x062A, 0x062E], 0]);
        t.add(0xfc0e, 0xfc0e, [2, [0x062A, 0x0645], 0]);
        t.add(0xfc0f, 0xfc0f, [2, [0x062A, 0x0649], 0]);
        t.add(0xfc10, 0xfc10, [2, [0x062A, 0x064A], 0]);
        t.add(0xfc11, 0xfc11, [2, [0x062B, 0x062C], 0]);
        t.add(0xfc12, 0xfc12, [2, [0x062B, 0x0645], 0]);
        t.add(0xfc13, 0xfc13, [2, [0x062B, 0x0649], 0]);
        t.add(0xfc14, 0xfc14, [2, [0x062B, 0x064A], 0]);
        t.add(0xfc15, 0xfc15, [2, [0x062C, 0x062D], 0]);
        t.add(0xfc16, 0xfc16, [2, [0x062C, 0x0645], 0]);
        t.add(0xfc17, 0xfc17, [2, [0x062D, 0x062C], 0]);
        t.add(0xfc18, 0xfc18, [2, [0x062D, 0x0645], 0]);
        t.add(0xfc19, 0xfc19, [2, [0x062E, 0x062C], 0]);
        t.add(0xfc1a, 0xfc1a, [2, [0x062E, 0x062D], 0]);
        t.add(0xfc1b, 0xfc1b, [2, [0x062E, 0x0645], 0]);
        t.add(0xfc1c, 0xfc1c, [2, [0x0633, 0x062C], 0]);
        t.add(0xfc1d, 0xfc1d, [2, [0x0633, 0x062D], 0]);
        t.add(0xfc1e, 0xfc1e, [2, [0x0633, 0x062E], 0]);
        t.add(0xfc1f, 0xfc1f, [2, [0x0633, 0x0645], 0]);
        t.add(0xfc20, 0xfc20, [2, [0x0635, 0x062D], 0]);
        t.add(0xfc21, 0xfc21, [2, [0x0635, 0x0645], 0]);
        t.add(0xfc22, 0xfc22, [2, [0x0636, 0x062C], 0]);
        t.add(0xfc23, 0xfc23, [2, [0x0636, 0x062D], 0]);
        t.add(0xfc24, 0xfc24, [2, [0x0636, 0x062E], 0]);
        t.add(0xfc25, 0xfc25, [2, [0x0636, 0x0645], 0]);
        t.add(0xfc26, 0xfc26, [2, [0x0637, 0x062D], 0]);
        t.add(0xfc27, 0xfc27, [2, [0x0637, 0x0645], 0]);
        t.add(0xfc28, 0xfc28, [2, [0x0638, 0x0645], 0]);
        t.add(0xfc29, 0xfc29, [2, [0x0639, 0x062C], 0]);
        t.add(0xfc2a, 0xfc2a, [2, [0x0639, 0x0645], 0]);
        t.add(0xfc2b, 0xfc2b, [2, [0x063A, 0x062C], 0]);
        t.add(0xfc2c, 0xfc2c, [2, [0x063A, 0x0645], 0]);
        t.add(0xfc2d, 0xfc2d, [2, [0x0641, 0x062C], 0]);
        t.add(0xfc2e, 0xfc2e, [2, [0x0641, 0x062D], 0]);
        t.add(0xfc2f, 0xfc2f, [2, [0x0641, 0x062E], 0]);
        t.add(0xfc30, 0xfc30, [2, [0x0641, 0x0645], 0]);
        t.add(0xfc31, 0xfc31, [2, [0x0641, 0x0649], 0]);
        t.add(0xfc32, 0xfc32, [2, [0x0641, 0x064A], 0]);
        t.add(0xfc33, 0xfc33, [2, [0x0642, 0x062D], 0]);
        t.add(0xfc34, 0xfc34, [2, [0x0642, 0x0645], 0]);
        t.add(0xfc35, 0xfc35, [2, [0x0642, 0x0649], 0]);
        t.add(0xfc36, 0xfc36, [2, [0x0642, 0x064A], 0]);
        t.add(0xfc37, 0xfc37, [2, [0x0643, 0x0627], 0]);
        t.add(0xfc38, 0xfc38, [2, [0x0643, 0x062C], 0]);
        t.add(0xfc39, 0xfc39, [2, [0x0643, 0x062D], 0]);
        t.add(0xfc3a, 0xfc3a, [2, [0x0643, 0x062E], 0]);
        t.add(0xfc3b, 0xfc3b, [2, [0x0643, 0x0644], 0]);
        t.add(0xfc3c, 0xfc3c, [2, [0x0643, 0x0645], 0]);
        t.add(0xfc3d, 0xfc3d, [2, [0x0643, 0x0649], 0]);
        t.add(0xfc3e, 0xfc3e, [2, [0x0643, 0x064A], 0]);
        t.add(0xfc3f, 0xfc3f, [2, [0x0644, 0x062C], 0]);
        t.add(0xfc40, 0xfc40, [2, [0x0644, 0x062D], 0]);
        t.add(0xfc41, 0xfc41, [2, [0x0644, 0x062E], 0]);
        t.add(0xfc42, 0xfc42, [2, [0x0644, 0x0645], 0]);
        t.add(0xfc43, 0xfc43, [2, [0x0644, 0x0649], 0]);
        t.add(0xfc44, 0xfc44, [2, [0x0644, 0x064A], 0]);
        t.add(0xfc45, 0xfc45, [2, [0x0645, 0x062C], 0]);
        t.add(0xfc46, 0xfc46, [2, [0x0645, 0x062D], 0]);
        t.add(0xfc47, 0xfc47, [2, [0x0645, 0x062E], 0]);
        t.add(0xfc48, 0xfc48, [2, [0x0645, 0x0645], 0]);
        t.add(0xfc49, 0xfc49, [2, [0x0645, 0x0649], 0]);
        t.add(0xfc4a, 0xfc4a, [2, [0x0645, 0x064A], 0]);
        t.add(0xfc4b, 0xfc4b, [2, [0x0646, 0x062C], 0]);
        t.add(0xfc4c, 0xfc4c, [2, [0x0646, 0x062D], 0]);
        t.add(0xfc4d, 0xfc4d, [2, [0x0646, 0x062E], 0]);
        t.add(0xfc4e, 0xfc4e, [2, [0x0646, 0x0645], 0]);
        t.add(0xfc4f, 0xfc4f, [2, [0x0646, 0x0649], 0]);
        t.add(0xfc50, 0xfc50, [2, [0x0646, 0x064A], 0]);
        t.add(0xfc51, 0xfc51, [2, [0x0647, 0x062C], 0]);
        t.add(0xfc52, 0xfc52, [2, [0x0647, 0x0645], 0]);
        t.add(0xfc53, 0xfc53, [2, [0x0647, 0x0649], 0]);
        t.add(0xfc54, 0xfc54, [2, [0x0647, 0x064A], 0]);
        t.add(0xfc55, 0xfc55, [2, [0x064A, 0x062C], 0]);
        t.add(0xfc56, 0xfc56, [2, [0x064A, 0x062D], 0]);
        t.add(0xfc57, 0xfc57, [2, [0x064A, 0x062E], 0]);
        t.add(0xfc58, 0xfc58, [2, [0x064A, 0x0645], 0]);
        t.add(0xfc59, 0xfc59, [2, [0x064A, 0x0649], 0]);
        t.add(0xfc5a, 0xfc5a, [2, [0x064A, 0x064A], 0]);
        t.add(0xfc5b, 0xfc5b, [2, [0x0630, 0x0670], 0]);
        t.add(0xfc5c, 0xfc5c, [2, [0x0631, 0x0670], 0]);
        t.add(0xfc5d, 0xfc5d, [2, [0x0649, 0x0670], 0]);
        t.add(0xfc5e, 0xfc5e, [6, [0x0020, 0x064C, 0x0651], 0]);
        t.add(0xfc5f, 0xfc5f, [6, [0x0020, 0x064D, 0x0651], 0]);
        t.add(0xfc60, 0xfc60, [6, [0x0020, 0x064E, 0x0651], 0]);
        t.add(0xfc61, 0xfc61, [6, [0x0020, 0x064F, 0x0651], 0]);
        t.add(0xfc62, 0xfc62, [6, [0x0020, 0x0650, 0x0651], 0]);
        t.add(0xfc63, 0xfc63, [6, [0x0020, 0x0651, 0x0670], 0]);
        t.add(0xfc64, 0xfc64, [2, [0x0626, 0x0631], 0]);
        t.add(0xfc65, 0xfc65, [2, [0x0626, 0x0632], 0]);
        t.add(0xfc66, 0xfc66, [2, [0x0626, 0x0645], 0]);
        t.add(0xfc67, 0xfc67, [2, [0x0626, 0x0646], 0]);
        t.add(0xfc68, 0xfc68, [2, [0x0626, 0x0649], 0]);
        t.add(0xfc69, 0xfc69, [2, [0x0626, 0x064A], 0]);
        t.add(0xfc6a, 0xfc6a, [2, [0x0628, 0x0631], 0]);
        t.add(0xfc6b, 0xfc6b, [2, [0x0628, 0x0632], 0]);
        t.add(0xfc6c, 0xfc6c, [2, [0x0628, 0x0645], 0]);
        t.add(0xfc6d, 0xfc6d, [2, [0x0628, 0x0646], 0]);
        t.add(0xfc6e, 0xfc6e, [2, [0x0628, 0x0649], 0]);
        t.add(0xfc6f, 0xfc6f, [2, [0x0628, 0x064A], 0]);
        t.add(0xfc70, 0xfc70, [2, [0x062A, 0x0631], 0]);
        t.add(0xfc71, 0xfc71, [2, [0x062A, 0x0632], 0]);
        t.add(0xfc72, 0xfc72, [2, [0x062A, 0x0645], 0]);
        t.add(0xfc73, 0xfc73, [2, [0x062A, 0x0646], 0]);
        t.add(0xfc74, 0xfc74, [2, [0x062A, 0x0649], 0]);
        t.add(0xfc75, 0xfc75, [2, [0x062A, 0x064A], 0]);
        t.add(0xfc76, 0xfc76, [2, [0x062B, 0x0631], 0]);
        t.add(0xfc77, 0xfc77, [2, [0x062B, 0x0632], 0]);
        t.add(0xfc78, 0xfc78, [2, [0x062B, 0x0645], 0]);
        t.add(0xfc79, 0xfc79, [2, [0x062B, 0x0646], 0]);
        t.add(0xfc7a, 0xfc7a, [2, [0x062B, 0x0649], 0]);
        t.add(0xfc7b, 0xfc7b, [2, [0x062B, 0x064A], 0]);
        t.add(0xfc7c, 0xfc7c, [2, [0x0641, 0x0649], 0]);
        t.add(0xfc7d, 0xfc7d, [2, [0x0641, 0x064A], 0]);
        t.add(0xfc7e, 0xfc7e, [2, [0x0642, 0x0649], 0]);
        t.add(0xfc7f, 0xfc7f, [2, [0x0642, 0x064A], 0]);
        t.add(0xfc80, 0xfc80, [2, [0x0643, 0x0627], 0]);
        t.add(0xfc81, 0xfc81, [2, [0x0643, 0x0644], 0]);
        t.add(0xfc82, 0xfc82, [2, [0x0643, 0x0645], 0]);
        t.add(0xfc83, 0xfc83, [2, [0x0643, 0x0649], 0]);
        t.add(0xfc84, 0xfc84, [2, [0x0643, 0x064A], 0]);
        t.add(0xfc85, 0xfc85, [2, [0x0644, 0x0645], 0]);
        t.add(0xfc86, 0xfc86, [2, [0x0644, 0x0649], 0]);
        t.add(0xfc87, 0xfc87, [2, [0x0644, 0x064A], 0]);
        t.add(0xfc88, 0xfc88, [2, [0x0645, 0x0627], 0]);
        t.add(0xfc89, 0xfc89, [2, [0x0645, 0x0645], 0]);
        t.add(0xfc8a, 0xfc8a, [2, [0x0646, 0x0631], 0]);
        t.add(0xfc8b, 0xfc8b, [2, [0x0646, 0x0632], 0]);
        t.add(0xfc8c, 0xfc8c, [2, [0x0646, 0x0645], 0]);
        t.add(0xfc8d, 0xfc8d, [2, [0x0646, 0x0646], 0]);
        t.add(0xfc8e, 0xfc8e, [2, [0x0646, 0x0649], 0]);
        t.add(0xfc8f, 0xfc8f, [2, [0x0646, 0x064A], 0]);
        t.add(0xfc90, 0xfc90, [2, [0x0649, 0x0670], 0]);
        t.add(0xfc91, 0xfc91, [2, [0x064A, 0x0631], 0]);
        t.add(0xfc92, 0xfc92, [2, [0x064A, 0x0632], 0]);
        t.add(0xfc93, 0xfc93, [2, [0x064A, 0x0645], 0]);
        t.add(0xfc94, 0xfc94, [2, [0x064A, 0x0646], 0]);
        t.add(0xfc95, 0xfc95, [2, [0x064A, 0x0649], 0]);
        t.add(0xfc96, 0xfc96, [2, [0x064A, 0x064A], 0]);
        t.add(0xfc97, 0xfc97, [2, [0x0626, 0x062C], 0]);
        t.add(0xfc98, 0xfc98, [2, [0x0626, 0x062D], 0]);
        t.add(0xfc99, 0xfc99, [2, [0x0626, 0x062E], 0]);
        t.add(0xfc9a, 0xfc9a, [2, [0x0626, 0x0645], 0]);
        t.add(0xfc9b, 0xfc9b, [2, [0x0626, 0x0647], 0]);
        t.add(0xfc9c, 0xfc9c, [2, [0x0628, 0x062C], 0]);
        t.add(0xfc9d, 0xfc9d, [2, [0x0628, 0x062D], 0]);
        t.add(0xfc9e, 0xfc9e, [2, [0x0628, 0x062E], 0]);
        t.add(0xfc9f, 0xfc9f, [2, [0x0628, 0x0645], 0]);
        t.add(0xfca0, 0xfca0, [2, [0x0628, 0x0647], 0]);
        t.add(0xfca1, 0xfca1, [2, [0x062A, 0x062C], 0]);
        t.add(0xfca2, 0xfca2, [2, [0x062A, 0x062D], 0]);
        t.add(0xfca3, 0xfca3, [2, [0x062A, 0x062E], 0]);
        t.add(0xfca4, 0xfca4, [2, [0x062A, 0x0645], 0]);
        t.add(0xfca5, 0xfca5, [2, [0x062A, 0x0647], 0]);
        t.add(0xfca6, 0xfca6, [2, [0x062B, 0x0645], 0]);
        t.add(0xfca7, 0xfca7, [2, [0x062C, 0x062D], 0]);
        t.add(0xfca8, 0xfca8, [2, [0x062C, 0x0645], 0]);
        t.add(0xfca9, 0xfca9, [2, [0x062D, 0x062C], 0]);
        t.add(0xfcaa, 0xfcaa, [2, [0x062D, 0x0645], 0]);
        t.add(0xfcab, 0xfcab, [2, [0x062E, 0x062C], 0]);
        t.add(0xfcac, 0xfcac, [2, [0x062E, 0x0645], 0]);
        t.add(0xfcad, 0xfcad, [2, [0x0633, 0x062C], 0]);
        t.add(0xfcae, 0xfcae, [2, [0x0633, 0x062D], 0]);
        t.add(0xfcaf, 0xfcaf, [2, [0x0633, 0x062E], 0]);
        t.add(0xfcb0, 0xfcb0, [2, [0x0633, 0x0645], 0]);
        t.add(0xfcb1, 0xfcb1, [2, [0x0635, 0x062D], 0]);
        t.add(0xfcb2, 0xfcb2, [2, [0x0635, 0x062E], 0]);
        t.add(0xfcb3, 0xfcb3, [2, [0x0635, 0x0645], 0]);
        t.add(0xfcb4, 0xfcb4, [2, [0x0636, 0x062C], 0]);
        t.add(0xfcb5, 0xfcb5, [2, [0x0636, 0x062D], 0]);
        t.add(0xfcb6, 0xfcb6, [2, [0x0636, 0x062E], 0]);
        t.add(0xfcb7, 0xfcb7, [2, [0x0636, 0x0645], 0]);
        t.add(0xfcb8, 0xfcb8, [2, [0x0637, 0x062D], 0]);
        t.add(0xfcb9, 0xfcb9, [2, [0x0638, 0x0645], 0]);
        t.add(0xfcba, 0xfcba, [2, [0x0639, 0x062C], 0]);
        t.add(0xfcbb, 0xfcbb, [2, [0x0639, 0x0645], 0]);
        t.add(0xfcbc, 0xfcbc, [2, [0x063A, 0x062C], 0]);
        t.add(0xfcbd, 0xfcbd, [2, [0x063A, 0x0645], 0]);
        t.add(0xfcbe, 0xfcbe, [2, [0x0641, 0x062C], 0]);
        t.add(0xfcbf, 0xfcbf, [2, [0x0641, 0x062D], 0]);
        t.add(0xfcc0, 0xfcc0, [2, [0x0641, 0x062E], 0]);
        t.add(0xfcc1, 0xfcc1, [2, [0x0641, 0x0645], 0]);
        t.add(0xfcc2, 0xfcc2, [2, [0x0642, 0x062D], 0]);
        t.add(0xfcc3, 0xfcc3, [2, [0x0642, 0x0645], 0]);
        t.add(0xfcc4, 0xfcc4, [2, [0x0643, 0x062C], 0]);
        t.add(0xfcc5, 0xfcc5, [2, [0x0643, 0x062D], 0]);
        t.add(0xfcc6, 0xfcc6, [2, [0x0643, 0x062E], 0]);
        t.add(0xfcc7, 0xfcc7, [2, [0x0643, 0x0644], 0]);
        t.add(0xfcc8, 0xfcc8, [2, [0x0643, 0x0645], 0]);
        t.add(0xfcc9, 0xfcc9, [2, [0x0644, 0x062C], 0]);
        t.add(0xfcca, 0xfcca, [2, [0x0644, 0x062D], 0]);
        t.add(0xfccb, 0xfccb, [2, [0x0644, 0x062E], 0]);
        t.add(0xfccc, 0xfccc, [2, [0x0644, 0x0645], 0]);
        t.add(0xfccd, 0xfccd, [2, [0x0644, 0x0647], 0]);
        t.add(0xfcce, 0xfcce, [2, [0x0645, 0x062C], 0]);
        t.add(0xfccf, 0xfccf, [2, [0x0645, 0x062D], 0]);
        t.add(0xfcd0, 0xfcd0, [2, [0x0645, 0x062E], 0]);
        t.add(0xfcd1, 0xfcd1, [2, [0x0645, 0x0645], 0]);
        t.add(0xfcd2, 0xfcd2, [2, [0x0646, 0x062C], 0]);
        t.add(0xfcd3, 0xfcd3, [2, [0x0646, 0x062D], 0]);
        t.add(0xfcd4, 0xfcd4, [2, [0x0646, 0x062E], 0]);
        t.add(0xfcd5, 0xfcd5, [2, [0x0646, 0x0645], 0]);
        t.add(0xfcd6, 0xfcd6, [2, [0x0646, 0x0647], 0]);
        t.add(0xfcd7, 0xfcd7, [2, [0x0647, 0x062C], 0]);
        t.add(0xfcd8, 0xfcd8, [2, [0x0647, 0x0645], 0]);
        t.add(0xfcd9, 0xfcd9, [2, [0x0647, 0x0670], 0]);
        t.add(0xfcda, 0xfcda, [2, [0x064A, 0x062C], 0]);
        t.add(0xfcdb, 0xfcdb, [2, [0x064A, 0x062D], 0]);
        t.add(0xfcdc, 0xfcdc, [2, [0x064A, 0x062E], 0]);
        t.add(0xfcdd, 0xfcdd, [2, [0x064A, 0x0645], 0]);
        t.add(0xfcde, 0xfcde, [2, [0x064A, 0x0647], 0]);
        t.add(0xfcdf, 0xfcdf, [2, [0x0626, 0x0645], 0]);
        t.add(0xfce0, 0xfce0, [2, [0x0626, 0x0647], 0]);
        t.add(0xfce1, 0xfce1, [2, [0x0628, 0x0645], 0]);
        t.add(0xfce2, 0xfce2, [2, [0x0628, 0x0647], 0]);
        t.add(0xfce3, 0xfce3, [2, [0x062A, 0x0645], 0]);
        t.add(0xfce4, 0xfce4, [2, [0x062A, 0x0647], 0]);
        t.add(0xfce5, 0xfce5, [2, [0x062B, 0x0645], 0]);
        t.add(0xfce6, 0xfce6, [2, [0x062B, 0x0647], 0]);
        t.add(0xfce7, 0xfce7, [2, [0x0633, 0x0645], 0]);
        t.add(0xfce8, 0xfce8, [2, [0x0633, 0x0647], 0]);
        t.add(0xfce9, 0xfce9, [2, [0x0634, 0x0645], 0]);
        t.add(0xfcea, 0xfcea, [2, [0x0634, 0x0647], 0]);
        t.add(0xfceb, 0xfceb, [2, [0x0643, 0x0644], 0]);
        t.add(0xfcec, 0xfcec, [2, [0x0643, 0x0645], 0]);
        t.add(0xfced, 0xfced, [2, [0x0644, 0x0645], 0]);
        t.add(0xfcee, 0xfcee, [2, [0x0646, 0x0645], 0]);
        t.add(0xfcef, 0xfcef, [2, [0x0646, 0x0647], 0]);
        t.add(0xfcf0, 0xfcf0, [2, [0x064A, 0x0645], 0]);
        t.add(0xfcf1, 0xfcf1, [2, [0x064A, 0x0647], 0]);
        t.add(0xfcf2, 0xfcf2, [2, [0x0640, 0x064E, 0x0651], 0]);
        t.add(0xfcf3, 0xfcf3, [2, [0x0640, 0x064F, 0x0651], 0]);
        t.add(0xfcf4, 0xfcf4, [2, [0x0640, 0x0650, 0x0651], 0]);
        t.add(0xfcf5, 0xfcf5, [2, [0x0637, 0x0649], 0]);
        t.add(0xfcf6, 0xfcf6, [2, [0x0637, 0x064A], 0]);
        t.add(0xfcf7, 0xfcf7, [2, [0x0639, 0x0649], 0]);
        t.add(0xfcf8, 0xfcf8, [2, [0x0639, 0x064A], 0]);
        t.add(0xfcf9, 0xfcf9, [2, [0x063A, 0x0649], 0]);
        t.add(0xfcfa, 0xfcfa, [2, [0x063A, 0x064A], 0]);
        t.add(0xfcfb, 0xfcfb, [2, [0x0633, 0x0649], 0]);
        t.add(0xfcfc, 0xfcfc, [2, [0x0633, 0x064A], 0]);
        t.add(0xfcfd, 0xfcfd, [2, [0x0634, 0x0649], 0]);
        t.add(0xfcfe, 0xfcfe, [2, [0x0634, 0x064A], 0]);
        t.add(0xfcff, 0xfcff, [2, [0x062D, 0x0649], 0]);
        t.add(0xfd00, 0xfd00, [2, [0x062D, 0x064A], 0]);
        t.add(0xfd01, 0xfd01, [2, [0x062C, 0x0649], 0]);
        t.add(0xfd02, 0xfd02, [2, [0x062C, 0x064A], 0]);
        t.add(0xfd03, 0xfd03, [2, [0x062E, 0x0649], 0]);
        t.add(0xfd04, 0xfd04, [2, [0x062E, 0x064A], 0]);
        t.add(0xfd05, 0xfd05, [2, [0x0635, 0x0649], 0]);
        t.add(0xfd06, 0xfd06, [2, [0x0635, 0x064A], 0]);
        t.add(0xfd07, 0xfd07, [2, [0x0636, 0x0649], 0]);
        t.add(0xfd08, 0xfd08, [2, [0x0636, 0x064A], 0]);
        t.add(0xfd09, 0xfd09, [2, [0x0634, 0x062C], 0]);
        t.add(0xfd0a, 0xfd0a, [2, [0x0634, 0x062D], 0]);
        t.add(0xfd0b, 0xfd0b, [2, [0x0634, 0x062E], 0]);
        t.add(0xfd0c, 0xfd0c, [2, [0x0634, 0x0645], 0]);
        t.add(0xfd0d, 0xfd0d, [2, [0x0634, 0x0631], 0]);
        t.add(0xfd0e, 0xfd0e, [2, [0x0633, 0x0631], 0]);
        t.add(0xfd0f, 0xfd0f, [2, [0x0635, 0x0631], 0]);
        t.add(0xfd10, 0xfd10, [2, [0x0636, 0x0631], 0]);
        t.add(0xfd11, 0xfd11, [2, [0x0637, 0x0649], 0]);
        t.add(0xfd12, 0xfd12, [2, [0x0637, 0x064A], 0]);
        t.add(0xfd13, 0xfd13, [2, [0x0639, 0x0649], 0]);
        t.add(0xfd14, 0xfd14, [2, [0x0639, 0x064A], 0]);
        t.add(0xfd15, 0xfd15, [2, [0x063A, 0x0649], 0]);
        t.add(0xfd16, 0xfd16, [2, [0x063A, 0x064A], 0]);
        t.add(0xfd17, 0xfd17, [2, [0x0633, 0x0649], 0]);
        t.add(0xfd18, 0xfd18, [2, [0x0633, 0x064A], 0]);
        t.add(0xfd19, 0xfd19, [2, [0x0634, 0x0649], 0]);
        t.add(0xfd1a, 0xfd1a, [2, [0x0634, 0x064A], 0]);
        t.add(0xfd1b, 0xfd1b, [2, [0x062D, 0x0649], 0]);
        t.add(0xfd1c, 0xfd1c, [2, [0x062D, 0x064A], 0]);
        t.add(0xfd1d, 0xfd1d, [2, [0x062C, 0x0649], 0]);
        t.add(0xfd1e, 0xfd1e, [2, [0x062C, 0x064A], 0]);
        t.add(0xfd1f, 0xfd1f, [2, [0x062E, 0x0649], 0]);
        t.add(0xfd20, 0xfd20, [2, [0x062E, 0x064A], 0]);
        t.add(0xfd21, 0xfd21, [2, [0x0635, 0x0649], 0]);
        t.add(0xfd22, 0xfd22, [2, [0x0635, 0x064A], 0]);
        t.add(0xfd23, 0xfd23, [2, [0x0636, 0x0649], 0]);
        t.add(0xfd24, 0xfd24, [2, [0x0636, 0x064A], 0]);
        t.add(0xfd25, 0xfd25, [2, [0x0634, 0x062C], 0]);
        t.add(0xfd26, 0xfd26, [2, [0x0634, 0x062D], 0]);
        t.add(0xfd27, 0xfd27, [2, [0x0634, 0x062E], 0]);
        t.add(0xfd28, 0xfd28, [2, [0x0634, 0x0645], 0]);
        t.add(0xfd29, 0xfd29, [2, [0x0634, 0x0631], 0]);
        t.add(0xfd2a, 0xfd2a, [2, [0x0633, 0x0631], 0]);
        t.add(0xfd2b, 0xfd2b, [2, [0x0635, 0x0631], 0]);
        t.add(0xfd2c, 0xfd2c, [2, [0x0636, 0x0631], 0]);
        t.add(0xfd2d, 0xfd2d, [2, [0x0634, 0x062C], 0]);
        t.add(0xfd2e, 0xfd2e, [2, [0x0634, 0x062D], 0]);
        t.add(0xfd2f, 0xfd2f, [2, [0x0634, 0x062E], 0]);
        t.add(0xfd30, 0xfd30, [2, [0x0634, 0x0645], 0]);
        t.add(0xfd31, 0xfd31, [2, [0x0633, 0x0647], 0]);
        t.add(0xfd32, 0xfd32, [2, [0x0634, 0x0647], 0]);
        t.add(0xfd33, 0xfd33, [2, [0x0637, 0x0645], 0]);
        t.add(0xfd34, 0xfd34, [2, [0x0633, 0x062C], 0]);
        t.add(0xfd35, 0xfd35, [2, [0x0633, 0x062D], 0]);
        t.add(0xfd36, 0xfd36, [2, [0x0633, 0x062E], 0]);
        t.add(0xfd37, 0xfd37, [2, [0x0634, 0x062C], 0]);
        t.add(0xfd38, 0xfd38, [2, [0x0634, 0x062D], 0]);
        t.add(0xfd39, 0xfd39, [2, [0x0634, 0x062E], 0]);
        t.add(0xfd3a, 0xfd3a, [2, [0x0637, 0x0645], 0]);
        t.add(0xfd3b, 0xfd3b, [2, [0x0638, 0x0645], 0]);
        t.add(0xfd3c, 0xfd3d, [2, [0x0627, 0x064B], 0]);
        t.add(0xfd3e, 0xfd3f, [0, [], 1]);
        t.add(0xfd40, 0xfd4f, [4, [], 0]);
        t.add(0xfd50, 0xfd50, [2, [0x062A, 0x062C, 0x0645], 0]);
        t.add(0xfd51, 0xfd52, [2, [0x062A, 0x062D, 0x062C], 0]);
        t.add(0xfd53, 0xfd53, [2, [0x062A, 0x062D, 0x0645], 0]);
        t.add(0xfd54, 0xfd54, [2, [0x062A, 0x062E, 0x0645], 0]);
        t.add(0xfd55, 0xfd55, [2, [0x062A, 0x0645, 0x062C], 0]);
        t.add(0xfd56, 0xfd56, [2, [0x062A, 0x0645, 0x062D], 0]);
        t.add(0xfd57, 0xfd57, [2, [0x062A, 0x0645, 0x062E], 0]);
        t.add(0xfd58, 0xfd59, [2, [0x062C, 0x0645, 0x062D], 0]);
        t.add(0xfd5a, 0xfd5a, [2, [0x062D, 0x0645, 0x064A], 0]);
        t.add(0xfd5b, 0xfd5b, [2, [0x062D, 0x0645, 0x0649], 0]);
        t.add(0xfd5c, 0xfd5c, [2, [0x0633, 0x062D, 0x062C], 0]);
        t.add(0xfd5d, 0xfd5d, [2, [0x0633, 0x062C, 0x062D], 0]);
        t.add(0xfd5e, 0xfd5e, [2, [0x0633, 0x062C, 0x0649], 0]);
        t.add(0xfd5f, 0xfd60, [2, [0x0633, 0x0645, 0x062D], 0]);
        t.add(0xfd61, 0xfd61, [2, [0x0633, 0x0645, 0x062C], 0]);
        t.add(0xfd62, 0xfd63, [2, [0x0633, 0x0645, 0x0645], 0]);
        t.add(0xfd64, 0xfd65, [2, [0x0635, 0x062D, 0x062D], 0]);
        t.add(0xfd66, 0xfd66, [2, [0x0635, 0x0645, 0x0645], 0]);
        t.add(0xfd67, 0xfd68, [2, [0x0634, 0x062D, 0x0645], 0]);
        t.add(0xfd69, 0xfd69, [2, [0x0634, 0x062C, 0x064A], 0]);
        t.add(0xfd6a, 0xfd6b, [2, [0x0634, 0x0645, 0x062E], 0]);
        t.add(0xfd6c, 0xfd6d, [2, [0x0634, 0x0645, 0x0645], 0]);
        t.add(0xfd6e, 0xfd6e, [2, [0x0636, 0x062D, 0x0649], 0]);
        t.add(0xfd6f, 0xfd70, [2, [0x0636, 0x062E, 0x0645], 0]);
        t.add(0xfd71, 0xfd72, [2, [0x0637, 0x0645, 0x062D], 0]);
        t.add(0xfd73, 0xfd73, [2, [0x0637, 0x0645, 0x0645], 0]);
        t.add(0xfd74, 0xfd74, [2, [0x0637, 0x0645, 0x064A], 0]);
        t.add(0xfd75, 0xfd75, [2, [0x0639, 0x062C, 0x0645], 0]);
        t.add(0xfd76, 0xfd77, [2, [0x0639, 0x0645, 0x0645], 0]);
        t.add(0xfd78, 0xfd78, [2, [0x0639, 0x0645, 0x0649], 0]);
        t.add(0xfd79, 0xfd79, [2, [0x063A, 0x0645, 0x0645], 0]);
        t.add(0xfd7a, 0xfd7a, [2, [0x063A, 0x0645, 0x064A], 0]);
        t.add(0xfd7b, 0xfd7b, [2, [0x063A, 0x0645, 0x0649], 0]);
        t.add(0xfd7c, 0xfd7d, [2, [0x0641, 0x062E, 0x0645], 0]);
        t.add(0xfd7e, 0xfd7e, [2, [0x0642, 0x0645, 0x062D], 0]);
        t.add(0xfd7f, 0xfd7f, [2, [0x0642, 0x0645, 0x0645], 0]);
        t.add(0xfd80, 0xfd80, [2, [0x0644, 0x062D, 0x0645], 0]);
        t.add(0xfd81, 0xfd81, [2, [0x0644, 0x062D, 0x064A], 0]);
        t.add(0xfd82, 0xfd82, [2, [0x0644, 0x062D, 0x0649], 0]);
        t.add(0xfd83, 0xfd84, [2, [0x0644, 0x062C, 0x062C], 0]);
        t.add(0xfd85, 0xfd86, [2, [0x0644, 0x062E, 0x0645], 0]);
        t.add(0xfd87, 0xfd88, [2, [0x0644, 0x0645, 0x062D], 0]);
        t.add(0xfd89, 0xfd89, [2, [0x0645, 0x062D, 0x062C], 0]);
        t.add(0xfd8a, 0xfd8a, [2, [0x0645, 0x062D, 0x0645], 0]);
        t.add(0xfd8b, 0xfd8b, [2, [0x0645, 0x062D, 0x064A], 0]);
        t.add(0xfd8c, 0xfd8c, [2, [0x0645, 0x062C, 0x062D], 0]);
        t.add(0xfd8d, 0xfd8d, [2, [0x0645, 0x062C, 0x0645], 0]);
        t.add(0xfd8e, 0xfd8e, [2, [0x0645, 0x062E, 0x062C], 0]);
        t.add(0xfd8f, 0xfd8f, [2, [0x0645, 0x062E, 0x0645], 0]);
        t.add(0xfd90, 0xfd91, [4, [], 0]);
        t.add(0xfd92, 0xfd92, [2, [0x0645, 0x062C, 0x062E], 0]);
        t.add(0xfd93, 0xfd93, [2, [0x0647, 0x0645, 0x062C], 0]);
        t.add(0xfd94, 0xfd94, [2, [0x0647, 0x0645, 0x0645], 0]);
        t.add(0xfd95, 0xfd95, [2, [0x0646, 0x062D, 0x0645], 0]);
        t.add(0xfd96, 0xfd96, [2, [0x0646, 0x062D, 0x0649], 0]);
        t.add(0xfd97, 0xfd98, [2, [0x0646, 0x062C, 0x0645], 0]);
        t.add(0xfd99, 0xfd99, [2, [0x0646, 0x062C, 0x0649], 0]);
        t.add(0xfd9a, 0xfd9a, [2, [0x0646, 0x0645, 0x064A], 0]);
        t.add(0xfd9b, 0xfd9b, [2, [0x0646, 0x0645, 0x0649], 0]);
        t.add(0xfd9c, 0xfd9d, [2, [0x064A, 0x0645, 0x0645], 0]);
        t.add(0xfd9e, 0xfd9e, [2, [0x0628, 0x062E, 0x064A], 0]);
        t.add(0xfd9f, 0xfd9f, [2, [0x062A, 0x062C, 0x064A], 0]);
        t.add(0xfda0, 0xfda0, [2, [0x062A, 0x062C, 0x0649], 0]);
        t.add(0xfda1, 0xfda1, [2, [0x062A, 0x062E, 0x064A], 0]);
        t.add(0xfda2, 0xfda2, [2, [0x062A, 0x062E, 0x0649], 0]);
        t.add(0xfda3, 0xfda3, [2, [0x062A, 0x0645, 0x064A], 0]);
        t.add(0xfda4, 0xfda4, [2, [0x062A, 0x0645, 0x0649], 0]);
        t.add(0xfda5, 0xfda5, [2, [0x062C, 0x0645, 0x064A], 0]);
        t.add(0xfda6, 0xfda6, [2, [0x062C, 0x062D, 0x0649], 0]);
        t.add(0xfda7, 0xfda7, [2, [0x062C, 0x0645, 0x0649], 0]);
        t.add(0xfda8, 0xfda8, [2, [0x0633, 0x062E, 0x0649], 0]);
        t.add(0xfda9, 0xfda9, [2, [0x0635, 0x062D, 0x064A], 0]);
        t.add(0xfdaa, 0xfdaa, [2, [0x0634, 0x062D, 0x064A], 0]);
        t.add(0xfdab, 0xfdab, [2, [0x0636, 0x062D, 0x064A], 0]);
        t.add(0xfdac, 0xfdac, [2, [0x0644, 0x062C, 0x064A], 0]);
        t.add(0xfdad, 0xfdad, [2, [0x0644, 0x0645, 0x064A], 0]);
        t.add(0xfdae, 0xfdae, [2, [0x064A, 0x062D, 0x064A], 0]);
        t.add(0xfdaf, 0xfdaf, [2, [0x064A, 0x062C, 0x064A], 0]);
        t.add(0xfdb0, 0xfdb0, [2, [0x064A, 0x0645, 0x064A], 0]);
        t.add(0xfdb1, 0xfdb1, [2, [0x0645, 0x0645, 0x064A], 0]);
        t.add(0xfdb2, 0xfdb2, [2, [0x0642, 0x0645, 0x064A], 0]);
        t.add(0xfdb3, 0xfdb3, [2, [0x0646, 0x062D, 0x064A], 0]);
        t.add(0xfdb4, 0xfdb4, [2, [0x0642, 0x0645, 0x062D], 0]);
        t.add(0xfdb5, 0xfdb5, [2, [0x0644, 0x062D, 0x0645], 0]);
        t.add(0xfdb6, 0xfdb6, [2, [0x0639, 0x0645, 0x064A], 0]);
        t.add(0xfdb7, 0xfdb7, [2, [0x0643, 0x0645, 0x064A], 0]);
        t.add(0xfdb8, 0xfdb8, [2, [0x0646, 0x062C, 0x062D], 0]);
        t.add(0xfdb9, 0xfdb9, [2, [0x0645, 0x062E, 0x064A], 0]);
        t.add(0xfdba, 0xfdba, [2, [0x0644, 0x062C, 0x0645], 0]);
        t.add(0xfdbb, 0xfdbb, [2, [0x0643, 0x0645, 0x0645], 0]);
        t.add(0xfdbc, 0xfdbc, [2, [0x0644, 0x062C, 0x0645], 0]);
        t.add(0xfdbd, 0xfdbd, [2, [0x0646, 0x062C, 0x062D], 0]);
        t.add(0xfdbe, 0xfdbe, [2, [0x062C, 0x062D, 0x064A], 0]);
        t.add(0xfdbf, 0xfdbf, [2, [0x062D, 0x062C, 0x064A], 0]);
        t.add(0xfdc0, 0xfdc0, [2, [0x0645, 0x062C, 0x064A], 0]);
        t.add(0xfdc1, 0xfdc1, [2, [0x0641, 0x0645, 0x064A], 0]);
        t.add(0xfdc2, 0xfdc2, [2, [0x0628, 0x062D, 0x064A], 0]);
        t.add(0xfdc3, 0xfdc3, [2, [0x0643, 0x0645, 0x0645], 0]);
        t.add(0xfdc4, 0xfdc4, [2, [0x0639, 0x062C, 0x0645], 0]);
        t.add(0xfdc5, 0xfdc5, [2, [0x0635, 0x0645, 0x0645], 0]);
        t.add(0xfdc6, 0xfdc6, [2, [0x0633, 0x062E, 0x064A], 0]);
        t.add(0xfdc7, 0xfdc7, [2, [0x0646, 0x062C, 0x064A], 0]);
        t.add(0xfdc8, 0xfdcf, [4, [], 0]);
        t.add(0xfdd0, 0xfdef, [4, [], 0]);
        t.add(0xfdf0, 0xfdf0, [2, [0x0635, 0x0644, 0x06D2], 0]);
        t.add(0xfdf1, 0xfdf1, [2, [0x0642, 0x0644, 0x06D2], 0]);
        t.add(0xfdf2, 0xfdf2, [2, [0x0627, 0x0644, 0x0644, 0x0647], 0]);
        t.add(0xfdf3, 0xfdf3, [2, [0x0627, 0x0643, 0x0628, 0x0631], 0]);
        t.add(0xfdf4, 0xfdf4, [2, [0x0645, 0x062D, 0x0645, 0x062F], 0]);
        t.add(0xfdf5, 0xfdf5, [2, [0x0635, 0x0644, 0x0639, 0x0645], 0]);
        t.add(0xfdf6, 0xfdf6, [2, [0x0631, 0x0633, 0x0648, 0x0644], 0]);
        t.add(0xfdf7, 0xfdf7, [2, [0x0639, 0x0644, 0x064A, 0x0647], 0]);
        t.add(0xfdf8, 0xfdf8, [2, [0x0648, 0x0633, 0x0644, 0x0645], 0]);
        t.add(0xfdf9, 0xfdf9, [2, [0x0635, 0x0644, 0x0649], 0]);
        t.add(0xfdfa, 0xfdfa, [6, [0x0635, 0x0644, 0x0649, 0x0020, 0x0627, 0x0644, 0x0644, 0x0647, 0x0020, 0x0639, 0x0644, 0x064A, 0x0647, 0x0020, 0x0648, 0x0633, 0x0644, 0x0645], 0]);
        t.add(0xfdfb, 0xfdfb, [6, [0x062C, 0x0644, 0x0020, 0x062C, 0x0644, 0x0627, 0x0644, 0x0647], 0]);
        t.add(0xfdfc, 0xfdfc, [2, [0x0631, 0x06CC, 0x0627, 0x0644], 0]);
        t.add(0xfdfd, 0xfdfd, [0, [], 1]);
        t.add(0xfdfe, 0xfdff, [4, [], 0]);
        t.add(0xfe00, 0xfe0f, [1, [], 0]);
        t.add(0xfe10, 0xfe10, [6, [0x002C], 0]);
        t.add(0xfe11, 0xfe11, [2, [0x3001], 0]);
        t.add(0xfe12, 0xfe12, [4, [], 0]);
        t.add(0xfe13, 0xfe13, [6, [0x003A], 0]);
        t.add(0xfe14, 0xfe14, [6, [0x003B], 0]);
        t.add(0xfe15, 0xfe15, [6, [0x0021], 0]);
        t.add(0xfe16, 0xfe16, [6, [0x003F], 0]);
        t.add(0xfe17, 0xfe17, [2, [0x3016], 0]);
        t.add(0xfe18, 0xfe18, [2, [0x3017], 0]);
        t.add(0xfe19, 0xfe19, [4, [], 0]);
        t.add(0xfe1a, 0xfe1f, [4, [], 0]);
        t.add(0xfe20, 0xfe23, [0, [], 0]);
        t.add(0xfe24, 0xfe26, [0, [], 0]);
        t.add(0xfe27, 0xfe2d, [0, [], 0]);
        t.add(0xfe2e, 0xfe2f, [0, [], 0]);
        t.add(0xfe30, 0xfe30, [4, [], 0]);
        t.add(0xfe31, 0xfe31, [2, [0x2014], 0]);
        t.add(0xfe32, 0xfe32, [2, [0x2013], 0]);
        t.add(0xfe33, 0xfe34, [6, [0x005F], 0]);
        t.add(0xfe35, 0xfe35, [6, [0x0028], 0]);
        t.add(0xfe36, 0xfe36, [6, [0x0029], 0]);
        t.add(0xfe37, 0xfe37, [6, [0x007B], 0]);
        t.add(0xfe38, 0xfe38, [6, [0x007D], 0]);
        t.add(0xfe39, 0xfe39, [2, [0x3014], 0]);
        t.add(0xfe3a, 0xfe3a, [2, [0x3015], 0]);
        t.add(0xfe3b, 0xfe3b, [2, [0x3010], 0]);
        t.add(0xfe3c, 0xfe3c, [2, [0x3011], 0]);
        t.add(0xfe3d, 0xfe3d, [2, [0x300A], 0]);
        t.add(0xfe3e, 0xfe3e, [2, [0x300B], 0]);
        t.add(0xfe3f, 0xfe3f, [2, [0x3008], 0]);
        t.add(0xfe40, 0xfe40, [2, [0x3009], 0]);
        t.add(0xfe41, 0xfe41, [2, [0x300C], 0]);
        t.add(0xfe42, 0xfe42, [2, [0x300D], 0]);
        t.add(0xfe43, 0xfe43, [2, [0x300E], 0]);
        t.add(0xfe44, 0xfe44, [2, [0x300F], 0]);
        t.add(0xfe45, 0xfe46, [0, [], 1]);
        t.add(0xfe47, 0xfe47, [6, [0x005B], 0]);
        t.add(0xfe48, 0xfe48, [6, [0x005D], 0]);
        t.add(0xfe49, 0xfe4c, [6, [0x0020, 0x0305], 0]);
        t.add(0xfe4d, 0xfe4f, [6, [0x005F], 0]);
        t.add(0xfe50, 0xfe50, [6, [0x002C], 0]);
        t.add(0xfe51, 0xfe51, [2, [0x3001], 0]);
        t.add(0xfe52, 0xfe52, [4, [], 0]);
        t.add(0xfe53, 0xfe53, [4, [], 0]);
        t.add(0xfe54, 0xfe54, [6, [0x003B], 0]);
        t.add(0xfe55, 0xfe55, [6, [0x003A], 0]);
        t.add(0xfe56, 0xfe56, [6, [0x003F], 0]);
        t.add(0xfe57, 0xfe57, [6, [0x0021], 0]);
        t.add(0xfe58, 0xfe58, [2, [0x2014], 0]);
        t.add(0xfe59, 0xfe59, [6, [0x0028], 0]);
        t.add(0xfe5a, 0xfe5a, [6, [0x0029], 0]);
        t.add(0xfe5b, 0xfe5b, [6, [0x007B], 0]);
        t.add(0xfe5c, 0xfe5c, [6, [0x007D], 0]);
        t.add(0xfe5d, 0xfe5d, [2, [0x3014], 0]);
        t.add(0xfe5e, 0xfe5e, [2, [0x3015], 0]);
        t.add(0xfe5f, 0xfe5f, [6, [0x0023], 0]);
        t.add(0xfe60, 0xfe60, [6, [0x0026], 0]);
        t.add(0xfe61, 0xfe61, [6, [0x002A], 0]);
        t.add(0xfe62, 0xfe62, [6, [0x002B], 0]);
        t.add(0xfe63, 0xfe63, [2, [0x002D], 0]);
        t.add(0xfe64, 0xfe64, [6, [0x003C], 0]);
        t.add(0xfe65, 0xfe65, [6, [0x003E], 0]);
        t.add(0xfe66, 0xfe66, [6, [0x003D], 0]);
        t.add(0xfe67, 0xfe67, [4, [], 0]);
        t.add(0xfe68, 0xfe68, [6, [0x005C], 0]);
        t.add(0xfe69, 0xfe69, [6, [0x0024], 0]);
        t.add(0xfe6a, 0xfe6a, [6, [0x0025], 0]);
        t.add(0xfe6b, 0xfe6b, [6, [0x0040], 0]);
        t.add(0xfe6c, 0xfe6f, [4, [], 0]);
        t.add(0xfe70, 0xfe70, [6, [0x0020, 0x064B], 0]);
        t.add(0xfe71, 0xfe71, [2, [0x0640, 0x064B], 0]);
        t.add(0xfe72, 0xfe72, [6, [0x0020, 0x064C], 0]);
        t.add(0xfe73, 0xfe73, [0, [], 0]);
        t.add(0xfe74, 0xfe74, [6, [0x0020, 0x064D], 0]);
        t.add(0xfe75, 0xfe75, [4, [], 0]);
        t.add(0xfe76, 0xfe76, [6, [0x0020, 0x064E], 0]);
        t.add(0xfe77, 0xfe77, [2, [0x0640, 0x064E], 0]);
        t.add(0xfe78, 0xfe78, [6, [0x0020, 0x064F], 0]);
        t.add(0xfe79, 0xfe79, [2, [0x0640, 0x064F], 0]);
        t.add(0xfe7a, 0xfe7a, [6, [0x0020, 0x0650], 0]);
        t.add(0xfe7b, 0xfe7b, [2, [0x0640, 0x0650], 0]);
        t.add(0xfe7c, 0xfe7c, [6, [0x0020, 0x0651], 0]);
        t.add(0xfe7d, 0xfe7d, [2, [0x0640, 0x0651], 0]);
        t.add(0xfe7e, 0xfe7e, [6, [0x0020, 0x0652], 0]);
        t.add(0xfe7f, 0xfe7f, [2, [0x0640, 0x0652], 0]);
        t.add(0xfe80, 0xfe80, [2, [0x0621], 0]);
        t.add(0xfe81, 0xfe82, [2, [0x0622], 0]);
        t.add(0xfe83, 0xfe84, [2, [0x0623], 0]);
        t.add(0xfe85, 0xfe86, [2, [0x0624], 0]);
        t.add(0xfe87, 0xfe88, [2, [0x0625], 0]);
        t.add(0xfe89, 0xfe8c, [2, [0x0626], 0]);
        t.add(0xfe8d, 0xfe8e, [2, [0x0627], 0]);
        t.add(0xfe8f, 0xfe92, [2, [0x0628], 0]);
        t.add(0xfe93, 0xfe94, [2, [0x0629], 0]);
        t.add(0xfe95, 0xfe98, [2, [0x062A], 0]);
        t.add(0xfe99, 0xfe9c, [2, [0x062B], 0]);
        t.add(0xfe9d, 0xfea0, [2, [0x062C], 0]);
        t.add(0xfea1, 0xfea4, [2, [0x062D], 0]);
        t.add(0xfea5, 0xfea8, [2, [0x062E], 0]);
        t.add(0xfea9, 0xfeaa, [2, [0x062F], 0]);
        t.add(0xfeab, 0xfeac, [2, [0x0630], 0]);
        t.add(0xfead, 0xfeae, [2, [0x0631], 0]);
        t.add(0xfeaf, 0xfeb0, [2, [0x0632], 0]);
        t.add(0xfeb1, 0xfeb4, [2, [0x0633], 0]);
        t.add(0xfeb5, 0xfeb8, [2, [0x0634], 0]);
        t.add(0xfeb9, 0xfebc, [2, [0x0635], 0]);
        t.add(0xfebd, 0xfec0, [2, [0x0636], 0]);
        t.add(0xfec1, 0xfec4, [2, [0x0637], 0]);
        t.add(0xfec5, 0xfec8, [2, [0x0638], 0]);
        t.add(0xfec9, 0xfecc, [2, [0x0639], 0]);
        t.add(0xfecd, 0xfed0, [2, [0x063A], 0]);
        t.add(0xfed1, 0xfed4, [2, [0x0641], 0]);
        t.add(0xfed5, 0xfed8, [2, [0x0642], 0]);
        t.add(0xfed9, 0xfedc, [2, [0x0643], 0]);
        t.add(0xfedd, 0xfee0, [2, [0x0644], 0]);
        t.add(0xfee1, 0xfee4, [2, [0x0645], 0]);
        t.add(0xfee5, 0xfee8, [2, [0x0646], 0]);
        t.add(0xfee9, 0xfeec, [2, [0x0647], 0]);
        t.add(0xfeed, 0xfeee, [2, [0x0648], 0]);
        t.add(0xfeef, 0xfef0, [2, [0x0649], 0]);
        t.add(0xfef1, 0xfef4, [2, [0x064A], 0]);
        t.add(0xfef5, 0xfef6, [2, [0x0644, 0x0622], 0]);
        t.add(0xfef7, 0xfef8, [2, [0x0644, 0x0623], 0]);
        t.add(0xfef9, 0xfefa, [2, [0x0644, 0x0625], 0]);
        t.add(0xfefb, 0xfefc, [2, [0x0644, 0x0627], 0]);
        t.add(0xfefd, 0xfefe, [4, [], 0]);
        t.add(0xfeff, 0xfeff, [1, [], 0]);
        t.add(0xff00, 0xff00, [4, [], 0]);
        t.add(0xff01, 0xff01, [6, [0x0021], 0]);
        t.add(0xff02, 0xff02, [6, [0x0022], 0]);
        t.add(0xff03, 0xff03, [6, [0x0023], 0]);
        t.add(0xff04, 0xff04, [6, [0x0024], 0]);
        t.add(0xff05, 0xff05, [6, [0x0025], 0]);
        t.add(0xff06, 0xff06, [6, [0x0026], 0]);
        t.add(0xff07, 0xff07, [6, [0x0027], 0]);
        t.add(0xff08, 0xff08, [6, [0x0028], 0]);
        t.add(0xff09, 0xff09, [6, [0x0029], 0]);
        t.add(0xff0a, 0xff0a, [6, [0x002A], 0]);
        t.add(0xff0b, 0xff0b, [6, [0x002B], 0]);
        t.add(0xff0c, 0xff0c, [6, [0x002C], 0]);
        t.add(0xff0d, 0xff0d, [2, [0x002D], 0]);
        t.add(0xff0e, 0xff0e, [2, [0x002E], 0]);
        t.add(0xff0f, 0xff0f, [6, [0x002F], 0]);
        t.add(0xff10, 0xff10, [2, [0x0030], 0]);
        t.add(0xff11, 0xff11, [2, [0x0031], 0]);
        t.add(0xff12, 0xff12, [2, [0x0032], 0]);
        t.add(0xff13, 0xff13, [2, [0x0033], 0]);
        t.add(0xff14, 0xff14, [2, [0x0034], 0]);
        t.add(0xff15, 0xff15, [2, [0x0035], 0]);
        t.add(0xff16, 0xff16, [2, [0x0036], 0]);
        t.add(0xff17, 0xff17, [2, [0x0037], 0]);
        t.add(0xff18, 0xff18, [2, [0x0038], 0]);
        t.add(0xff19, 0xff19, [2, [0x0039], 0]);
        t.add(0xff1a, 0xff1a, [6, [0x003A], 0]);
        t.add(0xff1b, 0xff1b, [6, [0x003B], 0]);
        t.add(0xff1c, 0xff1c, [6, [0x003C], 0]);
        t.add(0xff1d, 0xff1d, [6, [0x003D], 0]);
        t.add(0xff1e, 0xff1e, [6, [0x003E], 0]);
        t.add(0xff1f, 0xff1f, [6, [0x003F], 0]);
        t.add(0xff20, 0xff20, [6, [0x0040], 0]);
        t.add(0xff21, 0xff21, [2, [0x0061], 0]);
        t.add(0xff22, 0xff22, [2, [0x0062], 0]);
        t.add(0xff23, 0xff23, [2, [0x0063], 0]);
        t.add(0xff24, 0xff24, [2, [0x0064], 0]);
        t.add(0xff25, 0xff25, [2, [0x0065], 0]);
        t.add(0xff26, 0xff26, [2, [0x0066], 0]);
        t.add(0xff27, 0xff27, [2, [0x0067], 0]);
        t.add(0xff28, 0xff28, [2, [0x0068], 0]);
        t.add(0xff29, 0xff29, [2, [0x0069], 0]);
        t.add(0xff2a, 0xff2a, [2, [0x006A], 0]);
        t.add(0xff2b, 0xff2b, [2, [0x006B], 0]);
        t.add(0xff2c, 0xff2c, [2, [0x006C], 0]);
        t.add(0xff2d, 0xff2d, [2, [0x006D], 0]);
        t.add(0xff2e, 0xff2e, [2, [0x006E], 0]);
        t.add(0xff2f, 0xff2f, [2, [0x006F], 0]);
        t.add(0xff30, 0xff30, [2, [0x0070], 0]);
        t.add(0xff31, 0xff31, [2, [0x0071], 0]);
        t.add(0xff32, 0xff32, [2, [0x0072], 0]);
        t.add(0xff33, 0xff33, [2, [0x0073], 0]);
        t.add(0xff34, 0xff34, [2, [0x0074], 0]);
        t.add(0xff35, 0xff35, [2, [0x0075], 0]);
        t.add(0xff36, 0xff36, [2, [0x0076], 0]);
        t.add(0xff37, 0xff37, [2, [0x0077], 0]);
        t.add(0xff38, 0xff38, [2, [0x0078], 0]);
        t.add(0xff39, 0xff39, [2, [0x0079], 0]);
        t.add(0xff3a, 0xff3a, [2, [0x007A], 0]);
        t.add(0xff3b, 0xff3b, [6, [0x005B], 0]);
        t.add(0xff3c, 0xff3c, [6, [0x005C], 0]);
        t.add(0xff3d, 0xff3d, [6, [0x005D], 0]);
        t.add(0xff3e, 0xff3e, [6, [0x005E], 0]);
        t.add(0xff3f, 0xff3f, [6, [0x005F], 0]);
        t.add(0xff40, 0xff40, [6, [0x0060], 0]);
        t.add(0xff41, 0xff41, [2, [0x0061], 0]);
        t.add(0xff42, 0xff42, [2, [0x0062], 0]);
        t.add(0xff43, 0xff43, [2, [0x0063], 0]);
        t.add(0xff44, 0xff44, [2, [0x0064], 0]);
        t.add(0xff45, 0xff45, [2, [0x0065], 0]);
        t.add(0xff46, 0xff46, [2, [0x0066], 0]);
        t.add(0xff47, 0xff47, [2, [0x0067], 0]);
        t.add(0xff48, 0xff48, [2, [0x0068], 0]);
        t.add(0xff49, 0xff49, [2, [0x0069], 0]);
        t.add(0xff4a, 0xff4a, [2, [0x006A], 0]);
        t.add(0xff4b, 0xff4b, [2, [0x006B], 0]);
        t.add(0xff4c, 0xff4c, [2, [0x006C], 0]);
        t.add(0xff4d, 0xff4d, [2, [0x006D], 0]);
        t.add(0xff4e, 0xff4e, [2, [0x006E], 0]);
        t.add(0xff4f, 0xff4f, [2, [0x006F], 0]);
        t.add(0xff50, 0xff50, [2, [0x0070], 0]);
        t.add(0xff51, 0xff51, [2, [0x0071], 0]);
        t.add(0xff52, 0xff52, [2, [0x0072], 0]);
        t.add(0xff53, 0xff53, [2, [0x0073], 0]);
        t.add(0xff54, 0xff54, [2, [0x0074], 0]);
        t.add(0xff55, 0xff55, [2, [0x0075], 0]);
        t.add(0xff56, 0xff56, [2, [0x0076], 0]);
        t.add(0xff57, 0xff57, [2, [0x0077], 0]);
        t.add(0xff58, 0xff58, [2, [0x0078], 0]);
        t.add(0xff59, 0xff59, [2, [0x0079], 0]);
        t.add(0xff5a, 0xff5a, [2, [0x007A], 0]);
        t.add(0xff5b, 0xff5b, [6, [0x007B], 0]);
        t.add(0xff5c, 0xff5c, [6, [0x007C], 0]);
        t.add(0xff5d, 0xff5d, [6, [0x007D], 0]);
        t.add(0xff5e, 0xff5e, [6, [0x007E], 0]);
        t.add(0xff5f, 0xff5f, [2, [0x2985], 0]);
        t.add(0xff60, 0xff60, [2, [0x2986], 0]);
        t.add(0xff61, 0xff61, [2, [0x002E], 0]);
        t.add(0xff62, 0xff62, [2, [0x300C], 0]);
        t.add(0xff63, 0xff63, [2, [0x300D], 0]);
        t.add(0xff64, 0xff64, [2, [0x3001], 0]);
        t.add(0xff65, 0xff65, [2, [0x30FB], 0]);
        t.add(0xff66, 0xff66, [2, [0x30F2], 0]);
        t.add(0xff67, 0xff67, [2, [0x30A1], 0]);
        t.add(0xff68, 0xff68, [2, [0x30A3], 0]);
        t.add(0xff69, 0xff69, [2, [0x30A5], 0]);
        t.add(0xff6a, 0xff6a, [2, [0x30A7], 0]);
        t.add(0xff6b, 0xff6b, [2, [0x30A9], 0]);
        t.add(0xff6c, 0xff6c, [2, [0x30E3], 0]);
        t.add(0xff6d, 0xff6d, [2, [0x30E5], 0]);
        t.add(0xff6e, 0xff6e, [2, [0x30E7], 0]);
        t.add(0xff6f, 0xff6f, [2, [0x30C3], 0]);
        t.add(0xff70, 0xff70, [2, [0x30FC], 0]);
        t.add(0xff71, 0xff71, [2, [0x30A2], 0]);
        t.add(0xff72, 0xff72, [2, [0x30A4], 0]);
        t.add(0xff73, 0xff73, [2, [0x30A6], 0]);
        t.add(0xff74, 0xff74, [2, [0x30A8], 0]);
        t.add(0xff75, 0xff75, [2, [0x30AA], 0]);
        t.add(0xff76, 0xff76, [2, [0x30AB], 0]);
        t.add(0xff77, 0xff77, [2, [0x30AD], 0]);
        t.add(0xff78, 0xff78, [2, [0x30AF], 0]);
        t.add(0xff79, 0xff79, [2, [0x30B1], 0]);
        t.add(0xff7a, 0xff7a, [2, [0x30B3], 0]);
        t.add(0xff7b, 0xff7b, [2, [0x30B5], 0]);
        t.add(0xff7c, 0xff7c, [2, [0x30B7], 0]);
        t.add(0xff7d, 0xff7d, [2, [0x30B9], 0]);
        t.add(0xff7e, 0xff7e, [2, [0x30BB], 0]);
        t.add(0xff7f, 0xff7f, [2, [0x30BD], 0]);
        t.add(0xff80, 0xff80, [2, [0x30BF], 0]);
        t.add(0xff81, 0xff81, [2, [0x30C1], 0]);
        t.add(0xff82, 0xff82, [2, [0x30C4], 0]);
        t.add(0xff83, 0xff83, [2, [0x30C6], 0]);
        t.add(0xff84, 0xff84, [2, [0x30C8], 0]);
        t.add(0xff85, 0xff85, [2, [0x30CA], 0]);
        t.add(0xff86, 0xff86, [2, [0x30CB], 0]);
        t.add(0xff87, 0xff87, [2, [0x30CC], 0]);
        t.add(0xff88, 0xff88, [2, [0x30CD], 0]);
        t.add(0xff89, 0xff89, [2, [0x30CE], 0]);
        t.add(0xff8a, 0xff8a, [2, [0x30CF], 0]);
        t.add(0xff8b, 0xff8b, [2, [0x30D2], 0]);
        t.add(0xff8c, 0xff8c, [2, [0x30D5], 0]);
        t.add(0xff8d, 0xff8d, [2, [0x30D8], 0]);
        t.add(0xff8e, 0xff8e, [2, [0x30DB], 0]);
        t.add(0xff8f, 0xff8f, [2, [0x30DE], 0]);
        t.add(0xff90, 0xff90, [2, [0x30DF], 0]);
        t.add(0xff91, 0xff91, [2, [0x30E0], 0]);
        t.add(0xff92, 0xff92, [2, [0x30E1], 0]);
        t.add(0xff93, 0xff93, [2, [0x30E2], 0]);
        t.add(0xff94, 0xff94, [2, [0x30E4], 0]);
        t.add(0xff95, 0xff95, [2, [0x30E6], 0]);
        t.add(0xff96, 0xff96, [2, [0x30E8], 0]);
        t.add(0xff97, 0xff97, [2, [0x30E9], 0]);
        t.add(0xff98, 0xff98, [2, [0x30EA], 0]);
        t.add(0xff99, 0xff99, [2, [0x30EB], 0]);
        t.add(0xff9a, 0xff9a, [2, [0x30EC], 0]);
        t.add(0xff9b, 0xff9b, [2, [0x30ED], 0]);
        t.add(0xff9c, 0xff9c, [2, [0x30EF], 0]);
        t.add(0xff9d, 0xff9d, [2, [0x30F3], 0]);
        t.add(0xff9e, 0xff9e, [2, [0x3099], 0]);
        t.add(0xff9f, 0xff9f, [2, [0x309A], 0]);
        t.add(0xffa0, 0xffa0, [4, [], 0]);
        t.add(0xffa1, 0xffa1, [2, [0x1100], 0]);
        t.add(0xffa2, 0xffa2, [2, [0x1101], 0]);
        t.add(0xffa3, 0xffa3, [2, [0x11AA], 0]);
        t.add(0xffa4, 0xffa4, [2, [0x1102], 0]);
        t.add(0xffa5, 0xffa5, [2, [0x11AC], 0]);
        t.add(0xffa6, 0xffa6, [2, [0x11AD], 0]);
        t.add(0xffa7, 0xffa7, [2, [0x1103], 0]);
        t.add(0xffa8, 0xffa8, [2, [0x1104], 0]);
        t.add(0xffa9, 0xffa9, [2, [0x1105], 0]);
        t.add(0xffaa, 0xffaa, [2, [0x11B0], 0]);
        t.add(0xffab, 0xffab, [2, [0x11B1], 0]);
        t.add(0xffac, 0xffac, [2, [0x11B2], 0]);
        t.add(0xffad, 0xffad, [2, [0x11B3], 0]);
        t.add(0xffae, 0xffae, [2, [0x11B4], 0]);
        t.add(0xffaf, 0xffaf, [2, [0x11B5], 0]);
        t.add(0xffb0, 0xffb0, [2, [0x111A], 0]);
        t.add(0xffb1, 0xffb1, [2, [0x1106], 0]);
        t.add(0xffb2, 0xffb2, [2, [0x1107], 0]);
        t.add(0xffb3, 0xffb3, [2, [0x1108], 0]);
        t.add(0xffb4, 0xffb4, [2, [0x1121], 0]);
        t.add(0xffb5, 0xffb5, [2, [0x1109], 0]);
        t.add(0xffb6, 0xffb6, [2, [0x110A], 0]);
        t.add(0xffb7, 0xffb7, [2, [0x110B], 0]);
        t.add(0xffb8, 0xffb8, [2, [0x110C], 0]);
        t.add(0xffb9, 0xffb9, [2, [0x110D], 0]);
        t.add(0xffba, 0xffba, [2, [0x110E], 0]);
        t.add(0xffbb, 0xffbb, [2, [0x110F], 0]);
        t.add(0xffbc, 0xffbc, [2, [0x1110], 0]);
        t.add(0xffbd, 0xffbd, [2, [0x1111], 0]);
        t.add(0xffbe, 0xffbe, [2, [0x1112], 0]);
        t.add(0xffbf, 0xffc1, [4, [], 0]);
        t.add(0xffc2, 0xffc2, [2, [0x1161], 0]);
        t.add(0xffc3, 0xffc3, [2, [0x1162], 0]);
        t.add(0xffc4, 0xffc4, [2, [0x1163], 0]);
        t.add(0xffc5, 0xffc5, [2, [0x1164], 0]);
        t.add(0xffc6, 0xffc6, [2, [0x1165], 0]);
        t.add(0xffc7, 0xffc7, [2, [0x1166], 0]);
        t.add(0xffc8, 0xffc9, [4, [], 0]);
        t.add(0xffca, 0xffca, [2, [0x1167], 0]);
        t.add(0xffcb, 0xffcb, [2, [0x1168], 0]);
        t.add(0xffcc, 0xffcc, [2, [0x1169], 0]);
        t.add(0xffcd, 0xffcd, [2, [0x116A], 0]);
        t.add(0xffce, 0xffce, [2, [0x116B], 0]);
        t.add(0xffcf, 0xffcf, [2, [0x116C], 0]);
        t.add(0xffd0, 0xffd1, [4, [], 0]);
        t.add(0xffd2, 0xffd2, [2, [0x116D], 0]);
        t.add(0xffd3, 0xffd3, [2, [0x116E], 0]);
        t.add(0xffd4, 0xffd4, [2, [0x116F], 0]);
        t.add(0xffd5, 0xffd5, [2, [0x1170], 0]);
        t.add(0xffd6, 0xffd6, [2, [0x1171], 0]);
        t.add(0xffd7, 0xffd7, [2, [0x1172], 0]);
        t.add(0xffd8, 0xffd9, [4, [], 0]);
        t.add(0xffda, 0xffda, [2, [0x1173], 0]);
        t.add(0xffdb, 0xffdb, [2, [0x1174], 0]);
        t.add(0xffdc, 0xffdc, [2, [0x1175], 0]);
        t.add(0xffdd, 0xffdf, [4, [], 0]);
        t.add(0xffe0, 0xffe0, [2, [0x00A2], 0]);
        t.add(0xffe1, 0xffe1, [2, [0x00A3], 0]);
        t.add(0xffe2, 0xffe2, [2, [0x00AC], 0]);
        t.add(0xffe3, 0xffe3, [6, [0x0020, 0x0304], 0]);
        t.add(0xffe4, 0xffe4, [2, [0x00A6], 0]);
        t.add(0xffe5, 0xffe5, [2, [0x00A5], 0]);
        t.add(0xffe6, 0xffe6, [2, [0x20A9], 0]);
        t.add(0xffe7, 0xffe7, [4, [], 0]);
        t.add(0xffe8, 0xffe8, [2, [0x2502], 0]);
        t.add(0xffe9, 0xffe9, [2, [0x2190], 0]);
        t.add(0xffea, 0xffea, [2, [0x2191], 0]);
        t.add(0xffeb, 0xffeb, [2, [0x2192], 0]);
        t.add(0xffec, 0xffec, [2, [0x2193], 0]);
        t.add(0xffed, 0xffed, [2, [0x25A0], 0]);
        t.add(0xffee, 0xffee, [2, [0x25CB], 0]);
        t.add(0xffef, 0xfff8, [4, [], 0]);
        t.add(0xfff9, 0xfffb, [4, [], 0]);
        t.add(0xfffc, 0xfffc, [4, [], 0]);
        t.add(0xfffd, 0xfffd, [4, [], 0]);
        t.add(0xfffe, 0xffff, [4, [], 0]);
        t.add(0x10000, 0x1000b, [0, [], 0]);
        t.add(0x1000c, 0x1000c, [4, [], 0]);
        t.add(0x1000d, 0x10026, [0, [], 0]);
        t.add(0x10027, 0x10027, [4, [], 0]);
        t.add(0x10028, 0x1003a, [0, [], 0]);
        t.add(0x1003b, 0x1003b, [4, [], 0]);
        t.add(0x1003c, 0x1003d, [0, [], 0]);
        t.add(0x1003e, 0x1003e, [4, [], 0]);
        t.add(0x1003f, 0x1004d, [0, [], 0]);
        t.add(0x1004e, 0x1004f, [4, [], 0]);
        t.add(0x10050, 0x1005d, [0, [], 0]);
        t.add(0x1005e, 0x1007f, [4, [], 0]);
        t.add(0x10080, 0x100fa, [0, [], 0]);
        t.add(0x100fb, 0x100ff, [4, [], 0]);
        t.add(0x10100, 0x10102, [0, [], 1]);
        t.add(0x10103, 0x10106, [4, [], 0]);
        t.add(0x10107, 0x10133, [0, [], 1]);
        t.add(0x10134, 0x10136, [4, [], 0]);
        t.add(0x10137, 0x1013f, [0, [], 1]);
        t.add(0x10140, 0x1018a, [0, [], 1]);
        t.add(0x1018b, 0x1018c, [0, [], 1]);
        t.add(0x1018d, 0x1018e, [0, [], 1]);
        t.add(0x1018f, 0x1018f, [4, [], 0]);
        t.add(0x10190, 0x1019b, [0, [], 1]);
        t.add(0x1019c, 0x1019f, [4, [], 0]);
        t.add(0x101a0, 0x101a0, [0, [], 1]);
        t.add(0x101a1, 0x101cf, [4, [], 0]);
        t.add(0x101d0, 0x101fc, [0, [], 1]);
        t.add(0x101fd, 0x101fd, [0, [], 0]);
        t.add(0x101fe, 0x1027f, [4, [], 0]);
        t.add(0x10280, 0x1029c, [0, [], 0]);
        t.add(0x1029d, 0x1029f, [4, [], 0]);
        t.add(0x102a0, 0x102d0, [0, [], 0]);
        t.add(0x102d1, 0x102df, [4, [], 0]);
        t.add(0x102e0, 0x102e0, [0, [], 0]);
        t.add(0x102e1, 0x102fb, [0, [], 1]);
        t.add(0x102fc, 0x102ff, [4, [], 0]);
        t.add(0x10300, 0x1031e, [0, [], 0]);
        t.add(0x1031f, 0x1031f, [0, [], 0]);
        t.add(0x10320, 0x10323, [0, [], 1]);
        t.add(0x10324, 0x1032c, [4, [], 0]);
        t.add(0x1032d, 0x1032f, [0, [], 0]);
        t.add(0x10330, 0x10340, [0, [], 0]);
        t.add(0x10341, 0x10341, [0, [], 1]);
        t.add(0x10342, 0x10349, [0, [], 0]);
        t.add(0x1034a, 0x1034a, [0, [], 1]);
        t.add(0x1034b, 0x1034f, [4, [], 0]);
        t.add(0x10350, 0x1037a, [0, [], 0]);
        t.add(0x1037b, 0x1037f, [4, [], 0]);
        t.add(0x10380, 0x1039d, [0, [], 0]);
        t.add(0x1039e, 0x1039e, [4, [], 0]);
        t.add(0x1039f, 0x1039f, [0, [], 1]);
        t.add(0x103a0, 0x103c3, [0, [], 0]);
        t.add(0x103c4, 0x103c7, [4, [], 0]);
        t.add(0x103c8, 0x103cf, [0, [], 0]);
        t.add(0x103d0, 0x103d5, [0, [], 1]);
        t.add(0x103d6, 0x103ff, [4, [], 0]);
        t.add(0x10400, 0x10400, [2, [0x10428], 0]);
        t.add(0x10401, 0x10401, [2, [0x10429], 0]);
        t.add(0x10402, 0x10402, [2, [0x1042A], 0]);
        t.add(0x10403, 0x10403, [2, [0x1042B], 0]);
        t.add(0x10404, 0x10404, [2, [0x1042C], 0]);
        t.add(0x10405, 0x10405, [2, [0x1042D], 0]);
        t.add(0x10406, 0x10406, [2, [0x1042E], 0]);
        t.add(0x10407, 0x10407, [2, [0x1042F], 0]);
        t.add(0x10408, 0x10408, [2, [0x10430], 0]);
        t.add(0x10409, 0x10409, [2, [0x10431], 0]);
        t.add(0x1040a, 0x1040a, [2, [0x10432], 0]);
        t.add(0x1040b, 0x1040b, [2, [0x10433], 0]);
        t.add(0x1040c, 0x1040c, [2, [0x10434], 0]);
        t.add(0x1040d, 0x1040d, [2, [0x10435], 0]);
        t.add(0x1040e, 0x1040e, [2, [0x10436], 0]);
        t.add(0x1040f, 0x1040f, [2, [0x10437], 0]);
        t.add(0x10410, 0x10410, [2, [0x10438], 0]);
        t.add(0x10411, 0x10411, [2, [0x10439], 0]);
        t.add(0x10412, 0x10412, [2, [0x1043A], 0]);
        t.add(0x10413, 0x10413, [2, [0x1043B], 0]);
        t.add(0x10414, 0x10414, [2, [0x1043C], 0]);
        t.add(0x10415, 0x10415, [2, [0x1043D], 0]);
        t.add(0x10416, 0x10416, [2, [0x1043E], 0]);
        t.add(0x10417, 0x10417, [2, [0x1043F], 0]);
        t.add(0x10418, 0x10418, [2, [0x10440], 0]);
        t.add(0x10419, 0x10419, [2, [0x10441], 0]);
        t.add(0x1041a, 0x1041a, [2, [0x10442], 0]);
        t.add(0x1041b, 0x1041b, [2, [0x10443], 0]);
        t.add(0x1041c, 0x1041c, [2, [0x10444], 0]);
        t.add(0x1041d, 0x1041d, [2, [0x10445], 0]);
        t.add(0x1041e, 0x1041e, [2, [0x10446], 0]);
        t.add(0x1041f, 0x1041f, [2, [0x10447], 0]);
        t.add(0x10420, 0x10420, [2, [0x10448], 0]);
        t.add(0x10421, 0x10421, [2, [0x10449], 0]);
        t.add(0x10422, 0x10422, [2, [0x1044A], 0]);
        t.add(0x10423, 0x10423, [2, [0x1044B], 0]);
        t.add(0x10424, 0x10424, [2, [0x1044C], 0]);
        t.add(0x10425, 0x10425, [2, [0x1044D], 0]);
        t.add(0x10426, 0x10426, [2, [0x1044E], 0]);
        t.add(0x10427, 0x10427, [2, [0x1044F], 0]);
        t.add(0x10428, 0x1044d, [0, [], 0]);
        t.add(0x1044e, 0x1049d, [0, [], 0]);
        t.add(0x1049e, 0x1049f, [4, [], 0]);
        t.add(0x104a0, 0x104a9, [0, [], 0]);
        t.add(0x104aa, 0x104af, [4, [], 0]);
        t.add(0x104b0, 0x104b0, [2, [0x104D8], 0]);
        t.add(0x104b1, 0x104b1, [2, [0x104D9], 0]);
        t.add(0x104b2, 0x104b2, [2, [0x104DA], 0]);
        t.add(0x104b3, 0x104b3, [2, [0x104DB], 0]);
        t.add(0x104b4, 0x104b4, [2, [0x104DC], 0]);
        t.add(0x104b5, 0x104b5, [2, [0x104DD], 0]);
        t.add(0x104b6, 0x104b6, [2, [0x104DE], 0]);
        t.add(0x104b7, 0x104b7, [2, [0x104DF], 0]);
        t.add(0x104b8, 0x104b8, [2, [0x104E0], 0]);
        t.add(0x104b9, 0x104b9, [2, [0x104E1], 0]);
        t.add(0x104ba, 0x104ba, [2, [0x104E2], 0]);
        t.add(0x104bb, 0x104bb, [2, [0x104E3], 0]);
        t.add(0x104bc, 0x104bc, [2, [0x104E4], 0]);
        t.add(0x104bd, 0x104bd, [2, [0x104E5], 0]);
        t.add(0x104be, 0x104be, [2, [0x104E6], 0]);
        t.add(0x104bf, 0x104bf, [2, [0x104E7], 0]);
        t.add(0x104c0, 0x104c0, [2, [0x104E8], 0]);
        t.add(0x104c1, 0x104c1, [2, [0x104E9], 0]);
        t.add(0x104c2, 0x104c2, [2, [0x104EA], 0]);
        t.add(0x104c3, 0x104c3, [2, [0x104EB], 0]);
        t.add(0x104c4, 0x104c4, [2, [0x104EC], 0]);
        t.add(0x104c5, 0x104c5, [2, [0x104ED], 0]);
        t.add(0x104c6, 0x104c6, [2, [0x104EE], 0]);
        t.add(0x104c7, 0x104c7, [2, [0x104EF], 0]);
        t.add(0x104c8, 0x104c8, [2, [0x104F0], 0]);
        t.add(0x104c9, 0x104c9, [2, [0x104F1], 0]);
        t.add(0x104ca, 0x104ca, [2, [0x104F2], 0]);
        t.add(0x104cb, 0x104cb, [2, [0x104F3], 0]);
        t.add(0x104cc, 0x104cc, [2, [0x104F4], 0]);
        t.add(0x104cd, 0x104cd, [2, [0x104F5], 0]);
        t.add(0x104ce, 0x104ce, [2, [0x104F6], 0]);
        t.add(0x104cf, 0x104cf, [2, [0x104F7], 0]);
        t.add(0x104d0, 0x104d0, [2, [0x104F8], 0]);
        t.add(0x104d1, 0x104d1, [2, [0x104F9], 0]);
        t.add(0x104d2, 0x104d2, [2, [0x104FA], 0]);
        t.add(0x104d3, 0x104d3, [2, [0x104FB], 0]);
        t.add(0x104d4, 0x104d7, [4, [], 0]);
        t.add(0x104d8, 0x104fb, [0, [], 0]);
        t.add(0x104fc, 0x104ff, [4, [], 0]);
        t.add(0x10500, 0x10527, [0, [], 0]);
        t.add(0x10528, 0x1052f, [4, [], 0]);
        t.add(0x10530, 0x10563, [0, [], 0]);
        t.add(0x10564, 0x1056e, [4, [], 0]);
        t.add(0x1056f, 0x1056f, [0, [], 1]);
        t.add(0x10570, 0x105ff, [4, [], 0]);
        t.add(0x10600, 0x10736, [0, [], 0]);
        t.add(0x10737, 0x1073f, [4, [], 0]);
        t.add(0x10740, 0x10755, [0, [], 0]);
        t.add(0x10756, 0x1075f, [4, [], 0]);
        t.add(0x10760, 0x10767, [0, [], 0]);
        t.add(0x10768, 0x107ff, [4, [], 0]);
        t.add(0x10800, 0x10805, [0, [], 0]);
        t.add(0x10806, 0x10807, [4, [], 0]);
        t.add(0x10808, 0x10808, [0, [], 0]);
        t.add(0x10809, 0x10809, [4, [], 0]);
        t.add(0x1080a, 0x10835, [0, [], 0]);
        t.add(0x10836, 0x10836, [4, [], 0]);
        t.add(0x10837, 0x10838, [0, [], 0]);
        t.add(0x10839, 0x1083b, [4, [], 0]);
        t.add(0x1083c, 0x1083c, [0, [], 0]);
        t.add(0x1083d, 0x1083e, [4, [], 0]);
        t.add(0x1083f, 0x1083f, [0, [], 0]);
        t.add(0x10840, 0x10855, [0, [], 0]);
        t.add(0x10856, 0x10856, [4, [], 0]);
        t.add(0x10857, 0x1085f, [0, [], 1]);
        t.add(0x10860, 0x10876, [0, [], 0]);
        t.add(0x10877, 0x1087f, [0, [], 1]);
        t.add(0x10880, 0x1089e, [0, [], 0]);
        t.add(0x1089f, 0x108a6, [4, [], 0]);
        t.add(0x108a7, 0x108af, [0, [], 1]);
        t.add(0x108b0, 0x108df, [4, [], 0]);
        t.add(0x108e0, 0x108f2, [0, [], 0]);
        t.add(0x108f3, 0x108f3, [4, [], 0]);
        t.add(0x108f4, 0x108f5, [0, [], 0]);
        t.add(0x108f6, 0x108fa, [4, [], 0]);
        t.add(0x108fb, 0x108ff, [0, [], 1]);
        t.add(0x10900, 0x10915, [0, [], 0]);
        t.add(0x10916, 0x10919, [0, [], 1]);
        t.add(0x1091a, 0x1091b, [0, [], 1]);
        t.add(0x1091c, 0x1091e, [4, [], 0]);
        t.add(0x1091f, 0x1091f, [0, [], 1]);
        t.add(0x10920, 0x10939, [0, [], 0]);
        t.add(0x1093a, 0x1093e, [4, [], 0]);
        t.add(0x1093f, 0x1093f, [0, [], 1]);
        t.add(0x10940, 0x1097f, [4, [], 0]);
        t.add(0x10980, 0x109b7, [0, [], 0]);
        t.add(0x109b8, 0x109bb, [4, [], 0]);
        t.add(0x109bc, 0x109bd, [0, [], 1]);
        t.add(0x109be, 0x109bf, [0, [], 0]);
        t.add(0x109c0, 0x109cf, [0, [], 1]);
        t.add(0x109d0, 0x109d1, [4, [], 0]);
        t.add(0x109d2, 0x109ff, [0, [], 1]);
        t.add(0x10a00, 0x10a03, [0, [], 0]);
        t.add(0x10a04, 0x10a04, [4, [], 0]);
        t.add(0x10a05, 0x10a06, [0, [], 0]);
        t.add(0x10a07, 0x10a0b, [4, [], 0]);
        t.add(0x10a0c, 0x10a13, [0, [], 0]);
        t.add(0x10a14, 0x10a14, [4, [], 0]);
        t.add(0x10a15, 0x10a17, [0, [], 0]);
        t.add(0x10a18, 0x10a18, [4, [], 0]);
        t.add(0x10a19, 0x10a33, [0, [], 0]);
        t.add(0x10a34, 0x10a35, [0, [], 0]);
        t.add(0x10a36, 0x10a37, [4, [], 0]);
        t.add(0x10a38, 0x10a3a, [0, [], 0]);
        t.add(0x10a3b, 0x10a3e, [4, [], 0]);
        t.add(0x10a3f, 0x10a3f, [0, [], 0]);
        t.add(0x10a40, 0x10a47, [0, [], 1]);
        t.add(0x10a48, 0x10a48, [0, [], 1]);
        t.add(0x10a49, 0x10a4f, [4, [], 0]);
        t.add(0x10a50, 0x10a58, [0, [], 1]);
        t.add(0x10a59, 0x10a5f, [4, [], 0]);
        t.add(0x10a60, 0x10a7c, [0, [], 0]);
        t.add(0x10a7d, 0x10a7f, [0, [], 1]);
        t.add(0x10a80, 0x10a9c, [0, [], 0]);
        t.add(0x10a9d, 0x10a9f, [0, [], 1]);
        t.add(0x10aa0, 0x10abf, [4, [], 0]);
        t.add(0x10ac0, 0x10ac7, [0, [], 0]);
        t.add(0x10ac8, 0x10ac8, [0, [], 1]);
        t.add(0x10ac9, 0x10ae6, [0, [], 0]);
        t.add(0x10ae7, 0x10aea, [4, [], 0]);
        t.add(0x10aeb, 0x10af6, [0, [], 1]);
        t.add(0x10af7, 0x10aff, [4, [], 0]);
        t.add(0x10b00, 0x10b35, [0, [], 0]);
        t.add(0x10b36, 0x10b38, [4, [], 0]);
        t.add(0x10b39, 0x10b3f, [0, [], 1]);
        t.add(0x10b40, 0x10b55, [0, [], 0]);
        t.add(0x10b56, 0x10b57, [4, [], 0]);
        t.add(0x10b58, 0x10b5f, [0, [], 1]);
        t.add(0x10b60, 0x10b72, [0, [], 0]);
        t.add(0x10b73, 0x10b77, [4, [], 0]);
        t.add(0x10b78, 0x10b7f, [0, [], 1]);
        t.add(0x10b80, 0x10b91, [0, [], 0]);
        t.add(0x10b92, 0x10b98, [4, [], 0]);
        t.add(0x10b99, 0x10b9c, [0, [], 1]);
        t.add(0x10b9d, 0x10ba8, [4, [], 0]);
        t.add(0x10ba9, 0x10baf, [0, [], 1]);
        t.add(0x10bb0, 0x10bff, [4, [], 0]);
        t.add(0x10c00, 0x10c48, [0, [], 0]);
        t.add(0x10c49, 0x10c7f, [4, [], 0]);
        t.add(0x10c80, 0x10c80, [2, [0x10CC0], 0]);
        t.add(0x10c81, 0x10c81, [2, [0x10CC1], 0]);
        t.add(0x10c82, 0x10c82, [2, [0x10CC2], 0]);
        t.add(0x10c83, 0x10c83, [2, [0x10CC3], 0]);
        t.add(0x10c84, 0x10c84, [2, [0x10CC4], 0]);
        t.add(0x10c85, 0x10c85, [2, [0x10CC5], 0]);
        t.add(0x10c86, 0x10c86, [2, [0x10CC6], 0]);
        t.add(0x10c87, 0x10c87, [2, [0x10CC7], 0]);
        t.add(0x10c88, 0x10c88, [2, [0x10CC8], 0]);
        t.add(0x10c89, 0x10c89, [2, [0x10CC9], 0]);
        t.add(0x10c8a, 0x10c8a, [2, [0x10CCA], 0]);
        t.add(0x10c8b, 0x10c8b, [2, [0x10CCB], 0]);
        t.add(0x10c8c, 0x10c8c, [2, [0x10CCC], 0]);
        t.add(0x10c8d, 0x10c8d, [2, [0x10CCD], 0]);
        t.add(0x10c8e, 0x10c8e, [2, [0x10CCE], 0]);
        t.add(0x10c8f, 0x10c8f, [2, [0x10CCF], 0]);
        t.add(0x10c90, 0x10c90, [2, [0x10CD0], 0]);
        t.add(0x10c91, 0x10c91, [2, [0x10CD1], 0]);
        t.add(0x10c92, 0x10c92, [2, [0x10CD2], 0]);
        t.add(0x10c93, 0x10c93, [2, [0x10CD3], 0]);
        t.add(0x10c94, 0x10c94, [2, [0x10CD4], 0]);
        t.add(0x10c95, 0x10c95, [2, [0x10CD5], 0]);
        t.add(0x10c96, 0x10c96, [2, [0x10CD6], 0]);
        t.add(0x10c97, 0x10c97, [2, [0x10CD7], 0]);
        t.add(0x10c98, 0x10c98, [2, [0x10CD8], 0]);
        t.add(0x10c99, 0x10c99, [2, [0x10CD9], 0]);
        t.add(0x10c9a, 0x10c9a, [2, [0x10CDA], 0]);
        t.add(0x10c9b, 0x10c9b, [2, [0x10CDB], 0]);
        t.add(0x10c9c, 0x10c9c, [2, [0x10CDC], 0]);
        t.add(0x10c9d, 0x10c9d, [2, [0x10CDD], 0]);
        t.add(0x10c9e, 0x10c9e, [2, [0x10CDE], 0]);
        t.add(0x10c9f, 0x10c9f, [2, [0x10CDF], 0]);
        t.add(0x10ca0, 0x10ca0, [2, [0x10CE0], 0]);
        t.add(0x10ca1, 0x10ca1, [2, [0x10CE1], 0]);
        t.add(0x10ca2, 0x10ca2, [2, [0x10CE2], 0]);
        t.add(0x10ca3, 0x10ca3, [2, [0x10CE3], 0]);
        t.add(0x10ca4, 0x10ca4, [2, [0x10CE4], 0]);
        t.add(0x10ca5, 0x10ca5, [2, [0x10CE5], 0]);
        t.add(0x10ca6, 0x10ca6, [2, [0x10CE6], 0]);
        t.add(0x10ca7, 0x10ca7, [2, [0x10CE7], 0]);
        t.add(0x10ca8, 0x10ca8, [2, [0x10CE8], 0]);
        t.add(0x10ca9, 0x10ca9, [2, [0x10CE9], 0]);
        t.add(0x10caa, 0x10caa, [2, [0x10CEA], 0]);
        t.add(0x10cab, 0x10cab, [2, [0x10CEB], 0]);
        t.add(0x10cac, 0x10cac, [2, [0x10CEC], 0]);
        t.add(0x10cad, 0x10cad, [2, [0x10CED], 0]);
        t.add(0x10cae, 0x10cae, [2, [0x10CEE], 0]);
        t.add(0x10caf, 0x10caf, [2, [0x10CEF], 0]);
        t.add(0x10cb0, 0x10cb0, [2, [0x10CF0], 0]);
        t.add(0x10cb1, 0x10cb1, [2, [0x10CF1], 0]);
        t.add(0x10cb2, 0x10cb2, [2, [0x10CF2], 0]);
        t.add(0x10cb3, 0x10cbf, [4, [], 0]);
        t.add(0x10cc0, 0x10cf2, [0, [], 0]);
        t.add(0x10cf3, 0x10cf9, [4, [], 0]);
        t.add(0x10cfa, 0x10cff, [0, [], 1]);
        t.add(0x10d00, 0x10d27, [0, [], 0]);
        t.add(0x10d28, 0x10d2f, [4, [], 0]);
        t.add(0x10d30, 0x10d39, [0, [], 0]);
        t.add(0x10d3a, 0x10e5f, [4, [], 0]);
        t.add(0x10e60, 0x10e7e, [0, [], 1]);
        t.add(0x10e7f, 0x10eff, [4, [], 0]);
        t.add(0x10f00, 0x10f1c, [0, [], 0]);
        t.add(0x10f1d, 0x10f26, [0, [], 1]);
        t.add(0x10f27, 0x10f27, [0, [], 0]);
        t.add(0x10f28, 0x10f2f, [4, [], 0]);
        t.add(0x10f30, 0x10f50, [0, [], 0]);
        t.add(0x10f51, 0x10f59, [0, [], 1]);
        t.add(0x10f5a, 0x10fdf, [4, [], 0]);
        t.add(0x10fe0, 0x10ff6, [0, [], 0]);
        t.add(0x10ff7, 0x10fff, [4, [], 0]);
        t.add(0x11000, 0x11046, [0, [], 0]);
        t.add(0x11047, 0x1104d, [0, [], 1]);
        t.add(0x1104e, 0x11051, [4, [], 0]);
        t.add(0x11052, 0x11065, [0, [], 1]);
        t.add(0x11066, 0x1106f, [0, [], 0]);
        t.add(0x11070, 0x1107e, [4, [], 0]);
        t.add(0x1107f, 0x1107f, [0, [], 0]);
        t.add(0x11080, 0x110ba, [0, [], 0]);
        t.add(0x110bb, 0x110bc, [0, [], 1]);
        t.add(0x110bd, 0x110bd, [4, [], 0]);
        t.add(0x110be, 0x110c1, [0, [], 1]);
        t.add(0x110c2, 0x110cc, [4, [], 0]);
        t.add(0x110cd, 0x110cd, [4, [], 0]);
        t.add(0x110ce, 0x110cf, [4, [], 0]);
        t.add(0x110d0, 0x110e8, [0, [], 0]);
        t.add(0x110e9, 0x110ef, [4, [], 0]);
        t.add(0x110f0, 0x110f9, [0, [], 0]);
        t.add(0x110fa, 0x110ff, [4, [], 0]);
        t.add(0x11100, 0x11134, [0, [], 0]);
        t.add(0x11135, 0x11135, [4, [], 0]);
        t.add(0x11136, 0x1113f, [0, [], 0]);
        t.add(0x11140, 0x11143, [0, [], 1]);
        t.add(0x11144, 0x11146, [0, [], 0]);
        t.add(0x11147, 0x1114f, [4, [], 0]);
        t.add(0x11150, 0x11173, [0, [], 0]);
        t.add(0x11174, 0x11175, [0, [], 1]);
        t.add(0x11176, 0x11176, [0, [], 0]);
        t.add(0x11177, 0x1117f, [4, [], 0]);
        t.add(0x11180, 0x111c4, [0, [], 0]);
        t.add(0x111c5, 0x111c8, [0, [], 1]);
        t.add(0x111c9, 0x111cc, [0, [], 0]);
        t.add(0x111cd, 0x111cd, [0, [], 1]);
        t.add(0x111ce, 0x111cf, [4, [], 0]);
        t.add(0x111d0, 0x111d9, [0, [], 0]);
        t.add(0x111da, 0x111da, [0, [], 0]);
        t.add(0x111db, 0x111db, [0, [], 1]);
        t.add(0x111dc, 0x111dc, [0, [], 0]);
        t.add(0x111dd, 0x111df, [0, [], 1]);
        t.add(0x111e0, 0x111e0, [4, [], 0]);
        t.add(0x111e1, 0x111f4, [0, [], 1]);
        t.add(0x111f5, 0x111ff, [4, [], 0]);
        t.add(0x11200, 0x11211, [0, [], 0]);
        t.add(0x11212, 0x11212, [4, [], 0]);
        t.add(0x11213, 0x11237, [0, [], 0]);
        t.add(0x11238, 0x1123d, [0, [], 1]);
        t.add(0x1123e, 0x1123e, [0, [], 0]);
        t.add(0x1123f, 0x1127f, [4, [], 0]);
        t.add(0x11280, 0x11286, [0, [], 0]);
        t.add(0x11287, 0x11287, [4, [], 0]);
        t.add(0x11288, 0x11288, [0, [], 0]);
        t.add(0x11289, 0x11289, [4, [], 0]);
        t.add(0x1128a, 0x1128d, [0, [], 0]);
        t.add(0x1128e, 0x1128e, [4, [], 0]);
        t.add(0x1128f, 0x1129d, [0, [], 0]);
        t.add(0x1129e, 0x1129e, [4, [], 0]);
        t.add(0x1129f, 0x112a8, [0, [], 0]);
        t.add(0x112a9, 0x112a9, [0, [], 1]);
        t.add(0x112aa, 0x112af, [4, [], 0]);
        t.add(0x112b0, 0x112ea, [0, [], 0]);
        t.add(0x112eb, 0x112ef, [4, [], 0]);
        t.add(0x112f0, 0x112f9, [0, [], 0]);
        t.add(0x112fa, 0x112ff, [4, [], 0]);
        t.add(0x11300, 0x11300, [0, [], 0]);
        t.add(0x11301, 0x11303, [0, [], 0]);
        t.add(0x11304, 0x11304, [4, [], 0]);
        t.add(0x11305, 0x1130c, [0, [], 0]);
        t.add(0x1130d, 0x1130e, [4, [], 0]);
        t.add(0x1130f, 0x11310, [0, [], 0]);
        t.add(0x11311, 0x11312, [4, [], 0]);
        t.add(0x11313, 0x11328, [0, [], 0]);
        t.add(0x11329, 0x11329, [4, [], 0]);
        t.add(0x1132a, 0x11330, [0, [], 0]);
        t.add(0x11331, 0x11331, [4, [], 0]);
        t.add(0x11332, 0x11333, [0, [], 0]);
        t.add(0x11334, 0x11334, [4, [], 0]);
        t.add(0x11335, 0x11339, [0, [], 0]);
        t.add(0x1133a, 0x1133a, [4, [], 0]);
        t.add(0x1133b, 0x1133b, [0, [], 0]);
        t.add(0x1133c, 0x11344, [0, [], 0]);
        t.add(0x11345, 0x11346, [4, [], 0]);
        t.add(0x11347, 0x11348, [0, [], 0]);
        t.add(0x11349, 0x1134a, [4, [], 0]);
        t.add(0x1134b, 0x1134d, [0, [], 0]);
        t.add(0x1134e, 0x1134f, [4, [], 0]);
        t.add(0x11350, 0x11350, [0, [], 0]);
        t.add(0x11351, 0x11356, [4, [], 0]);
        t.add(0x11357, 0x11357, [0, [], 0]);
        t.add(0x11358, 0x1135c, [4, [], 0]);
        t.add(0x1135d, 0x11363, [0, [], 0]);
        t.add(0x11364, 0x11365, [4, [], 0]);
        t.add(0x11366, 0x1136c, [0, [], 0]);
        t.add(0x1136d, 0x1136f, [4, [], 0]);
        t.add(0x11370, 0x11374, [0, [], 0]);
        t.add(0x11375, 0x113ff, [4, [], 0]);
        t.add(0x11400, 0x1144a, [0, [], 0]);
        t.add(0x1144b, 0x1144f, [0, [], 1]);
        t.add(0x11450, 0x11459, [0, [], 0]);
        t.add(0x1145a, 0x1145a, [4, [], 0]);
        t.add(0x1145b, 0x1145b, [0, [], 1]);
        t.add(0x1145c, 0x1145c, [4, [], 0]);
        t.add(0x1145d, 0x1145d, [0, [], 1]);
        t.add(0x1145e, 0x1145e, [0, [], 0]);
        t.add(0x1145f, 0x1145f, [0, [], 0]);
        t.add(0x11460, 0x1147f, [4, [], 0]);
        t.add(0x11480, 0x114c5, [0, [], 0]);
        t.add(0x114c6, 0x114c6, [0, [], 1]);
        t.add(0x114c7, 0x114c7, [0, [], 0]);
        t.add(0x114c8, 0x114cf, [4, [], 0]);
        t.add(0x114d0, 0x114d9, [0, [], 0]);
        t.add(0x114da, 0x1157f, [4, [], 0]);
        t.add(0x11580, 0x115b5, [0, [], 0]);
        t.add(0x115b6, 0x115b7, [4, [], 0]);
        t.add(0x115b8, 0x115c0, [0, [], 0]);
        t.add(0x115c1, 0x115c9, [0, [], 1]);
        t.add(0x115ca, 0x115d7, [0, [], 1]);
        t.add(0x115d8, 0x115dd, [0, [], 0]);
        t.add(0x115de, 0x115ff, [4, [], 0]);
        t.add(0x11600, 0x11640, [0, [], 0]);
        t.add(0x11641, 0x11643, [0, [], 1]);
        t.add(0x11644, 0x11644, [0, [], 0]);
        t.add(0x11645, 0x1164f, [4, [], 0]);
        t.add(0x11650, 0x11659, [0, [], 0]);
        t.add(0x1165a, 0x1165f, [4, [], 0]);
        t.add(0x11660, 0x1166c, [0, [], 1]);
        t.add(0x1166d, 0x1167f, [4, [], 0]);
        t.add(0x11680, 0x116b7, [0, [], 0]);
        t.add(0x116b8, 0x116b8, [0, [], 0]);
        t.add(0x116b9, 0x116bf, [4, [], 0]);
        t.add(0x116c0, 0x116c9, [0, [], 0]);
        t.add(0x116ca, 0x116ff, [4, [], 0]);
        t.add(0x11700, 0x11719, [0, [], 0]);
        t.add(0x1171a, 0x1171a, [0, [], 0]);
        t.add(0x1171b, 0x1171c, [4, [], 0]);
        t.add(0x1171d, 0x1172b, [0, [], 0]);
        t.add(0x1172c, 0x1172f, [4, [], 0]);
        t.add(0x11730, 0x11739, [0, [], 0]);
        t.add(0x1173a, 0x1173f, [0, [], 1]);
        t.add(0x11740, 0x117ff, [4, [], 0]);
        t.add(0x11800, 0x1183a, [0, [], 0]);
        t.add(0x1183b, 0x1183b, [0, [], 1]);
        t.add(0x1183c, 0x1189f, [4, [], 0]);
        t.add(0x118a0, 0x118a0, [2, [0x118C0], 0]);
        t.add(0x118a1, 0x118a1, [2, [0x118C1], 0]);
        t.add(0x118a2, 0x118a2, [2, [0x118C2], 0]);
        t.add(0x118a3, 0x118a3, [2, [0x118C3], 0]);
        t.add(0x118a4, 0x118a4, [2, [0x118C4], 0]);
        t.add(0x118a5, 0x118a5, [2, [0x118C5], 0]);
        t.add(0x118a6, 0x118a6, [2, [0x118C6], 0]);
        t.add(0x118a7, 0x118a7, [2, [0x118C7], 0]);
        t.add(0x118a8, 0x118a8, [2, [0x118C8], 0]);
        t.add(0x118a9, 0x118a9, [2, [0x118C9], 0]);
        t.add(0x118aa, 0x118aa, [2, [0x118CA], 0]);
        t.add(0x118ab, 0x118ab, [2, [0x118CB], 0]);
        t.add(0x118ac, 0x118ac, [2, [0x118CC], 0]);
        t.add(0x118ad, 0x118ad, [2, [0x118CD], 0]);
        t.add(0x118ae, 0x118ae, [2, [0x118CE], 0]);
        t.add(0x118af, 0x118af, [2, [0x118CF], 0]);
        t.add(0x118b0, 0x118b0, [2, [0x118D0], 0]);
        t.add(0x118b1, 0x118b1, [2, [0x118D1], 0]);
        t.add(0x118b2, 0x118b2, [2, [0x118D2], 0]);
        t.add(0x118b3, 0x118b3, [2, [0x118D3], 0]);
        t.add(0x118b4, 0x118b4, [2, [0x118D4], 0]);
        t.add(0x118b5, 0x118b5, [2, [0x118D5], 0]);
        t.add(0x118b6, 0x118b6, [2, [0x118D6], 0]);
        t.add(0x118b7, 0x118b7, [2, [0x118D7], 0]);
        t.add(0x118b8, 0x118b8, [2, [0x118D8], 0]);
        t.add(0x118b9, 0x118b9, [2, [0x118D9], 0]);
        t.add(0x118ba, 0x118ba, [2, [0x118DA], 0]);
        t.add(0x118bb, 0x118bb, [2, [0x118DB], 0]);
        t.add(0x118bc, 0x118bc, [2, [0x118DC], 0]);
        t.add(0x118bd, 0x118bd, [2, [0x118DD], 0]);
        t.add(0x118be, 0x118be, [2, [0x118DE], 0]);
        t.add(0x118bf, 0x118bf, [2, [0x118DF], 0]);
        t.add(0x118c0, 0x118e9, [0, [], 0]);
        t.add(0x118ea, 0x118f2, [0, [], 1]);
        t.add(0x118f3, 0x118fe, [4, [], 0]);
        t.add(0x118ff, 0x118ff, [0, [], 0]);
        t.add(0x11900, 0x1199f, [4, [], 0]);
        t.add(0x119a0, 0x119a7, [0, [], 0]);
        t.add(0x119a8, 0x119a9, [4, [], 0]);
        t.add(0x119aa, 0x119d7, [0, [], 0]);
        t.add(0x119d8, 0x119d9, [4, [], 0]);
        t.add(0x119da, 0x119e1, [0, [], 0]);
        t.add(0x119e2, 0x119e2, [0, [], 1]);
        t.add(0x119e3, 0x119e4, [0, [], 0]);
        t.add(0x119e5, 0x119ff, [4, [], 0]);
        t.add(0x11a00, 0x11a3e, [0, [], 0]);
        t.add(0x11a3f, 0x11a46, [0, [], 1]);
        t.add(0x11a47, 0x11a47, [0, [], 0]);
        t.add(0x11a48, 0x11a4f, [4, [], 0]);
        t.add(0x11a50, 0x11a83, [0, [], 0]);
        t.add(0x11a84, 0x11a85, [0, [], 0]);
        t.add(0x11a86, 0x11a99, [0, [], 0]);
        t.add(0x11a9a, 0x11a9c, [0, [], 1]);
        t.add(0x11a9d, 0x11a9d, [0, [], 0]);
        t.add(0x11a9e, 0x11aa2, [0, [], 1]);
        t.add(0x11aa3, 0x11abf, [4, [], 0]);
        t.add(0x11ac0, 0x11af8, [0, [], 0]);
        t.add(0x11af9, 0x11bff, [4, [], 0]);
        t.add(0x11c00, 0x11c08, [0, [], 0]);
        t.add(0x11c09, 0x11c09, [4, [], 0]);
        t.add(0x11c0a, 0x11c36, [0, [], 0]);
        t.add(0x11c37, 0x11c37, [4, [], 0]);
        t.add(0x11c38, 0x11c40, [0, [], 0]);
        t.add(0x11c41, 0x11c45, [0, [], 1]);
        t.add(0x11c46, 0x11c4f, [4, [], 0]);
        t.add(0x11c50, 0x11c59, [0, [], 0]);
        t.add(0x11c5a, 0x11c6c, [0, [], 1]);
        t.add(0x11c6d, 0x11c6f, [4, [], 0]);
        t.add(0x11c70, 0x11c71, [0, [], 1]);
        t.add(0x11c72, 0x11c8f, [0, [], 0]);
        t.add(0x11c90, 0x11c91, [4, [], 0]);
        t.add(0x11c92, 0x11ca7, [0, [], 0]);
        t.add(0x11ca8, 0x11ca8, [4, [], 0]);
        t.add(0x11ca9, 0x11cb6, [0, [], 0]);
        t.add(0x11cb7, 0x11cff, [4, [], 0]);
        t.add(0x11d00, 0x11d06, [0, [], 0]);
        t.add(0x11d07, 0x11d07, [4, [], 0]);
        t.add(0x11d08, 0x11d09, [0, [], 0]);
        t.add(0x11d0a, 0x11d0a, [4, [], 0]);
        t.add(0x11d0b, 0x11d36, [0, [], 0]);
        t.add(0x11d37, 0x11d39, [4, [], 0]);
        t.add(0x11d3a, 0x11d3a, [0, [], 0]);
        t.add(0x11d3b, 0x11d3b, [4, [], 0]);
        t.add(0x11d3c, 0x11d3d, [0, [], 0]);
        t.add(0x11d3e, 0x11d3e, [4, [], 0]);
        t.add(0x11d3f, 0x11d47, [0, [], 0]);
        t.add(0x11d48, 0x11d4f, [4, [], 0]);
        t.add(0x11d50, 0x11d59, [0, [], 0]);
        t.add(0x11d5a, 0x11d5f, [4, [], 0]);
        t.add(0x11d60, 0x11d65, [0, [], 0]);
        t.add(0x11d66, 0x11d66, [4, [], 0]);
        t.add(0x11d67, 0x11d68, [0, [], 0]);
        t.add(0x11d69, 0x11d69, [4, [], 0]);
        t.add(0x11d6a, 0x11d8e, [0, [], 0]);
        t.add(0x11d8f, 0x11d8f, [4, [], 0]);
        t.add(0x11d90, 0x11d91, [0, [], 0]);
        t.add(0x11d92, 0x11d92, [4, [], 0]);
        t.add(0x11d93, 0x11d98, [0, [], 0]);
        t.add(0x11d99, 0x11d9f, [4, [], 0]);
        t.add(0x11da0, 0x11da9, [0, [], 0]);
        t.add(0x11daa, 0x11edf, [4, [], 0]);
        t.add(0x11ee0, 0x11ef6, [0, [], 0]);
        t.add(0x11ef7, 0x11ef8, [0, [], 1]);
        t.add(0x11ef9, 0x11fbf, [4, [], 0]);
        t.add(0x11fc0, 0x11ff1, [0, [], 1]);
        t.add(0x11ff2, 0x11ffe, [4, [], 0]);
        t.add(0x11fff, 0x11fff, [0, [], 1]);
        t.add(0x12000, 0x1236e, [0, [], 0]);
        t.add(0x1236f, 0x12398, [0, [], 0]);
        t.add(0x12399, 0x12399, [0, [], 0]);
        t.add(0x1239a, 0x123ff, [4, [], 0]);
        t.add(0x12400, 0x12462, [0, [], 1]);
        t.add(0x12463, 0x1246e, [0, [], 1]);
        t.add(0x1246f, 0x1246f, [4, [], 0]);
        t.add(0x12470, 0x12473, [0, [], 1]);
        t.add(0x12474, 0x12474, [0, [], 1]);
        t.add(0x12475, 0x1247f, [4, [], 0]);
        t.add(0x12480, 0x12543, [0, [], 0]);
        t.add(0x12544, 0x12fff, [4, [], 0]);
        t.add(0x13000, 0x1342e, [0, [], 0]);
        t.add(0x1342f, 0x1342f, [4, [], 0]);
        t.add(0x13430, 0x13438, [4, [], 0]);
        t.add(0x13439, 0x143ff, [4, [], 0]);
        t.add(0x14400, 0x14646, [0, [], 0]);
        t.add(0x14647, 0x167ff, [4, [], 0]);
        t.add(0x16800, 0x16a38, [0, [], 0]);
        t.add(0x16a39, 0x16a3f, [4, [], 0]);
        t.add(0x16a40, 0x16a5e, [0, [], 0]);
        t.add(0x16a5f, 0x16a5f, [4, [], 0]);
        t.add(0x16a60, 0x16a69, [0, [], 0]);
        t.add(0x16a6a, 0x16a6d, [4, [], 0]);
        t.add(0x16a6e, 0x16a6f, [0, [], 1]);
        t.add(0x16a70, 0x16acf, [4, [], 0]);
        t.add(0x16ad0, 0x16aed, [0, [], 0]);
        t.add(0x16aee, 0x16aef, [4, [], 0]);
        t.add(0x16af0, 0x16af4, [0, [], 0]);
        t.add(0x16af5, 0x16af5, [0, [], 1]);
        t.add(0x16af6, 0x16aff, [4, [], 0]);
        t.add(0x16b00, 0x16b36, [0, [], 0]);
        t.add(0x16b37, 0x16b3f, [0, [], 1]);
        t.add(0x16b40, 0x16b43, [0, [], 0]);
        t.add(0x16b44, 0x16b45, [0, [], 1]);
        t.add(0x16b46, 0x16b4f, [4, [], 0]);
        t.add(0x16b50, 0x16b59, [0, [], 0]);
        t.add(0x16b5a, 0x16b5a, [4, [], 0]);
        t.add(0x16b5b, 0x16b61, [0, [], 1]);
        t.add(0x16b62, 0x16b62, [4, [], 0]);
        t.add(0x16b63, 0x16b77, [0, [], 0]);
        t.add(0x16b78, 0x16b7c, [4, [], 0]);
        t.add(0x16b7d, 0x16b8f, [0, [], 0]);
        t.add(0x16b90, 0x16e3f, [4, [], 0]);
        t.add(0x16e40, 0x16e40, [2, [0x16E60], 0]);
        t.add(0x16e41, 0x16e41, [2, [0x16E61], 0]);
        t.add(0x16e42, 0x16e42, [2, [0x16E62], 0]);
        t.add(0x16e43, 0x16e43, [2, [0x16E63], 0]);
        t.add(0x16e44, 0x16e44, [2, [0x16E64], 0]);
        t.add(0x16e45, 0x16e45, [2, [0x16E65], 0]);
        t.add(0x16e46, 0x16e46, [2, [0x16E66], 0]);
        t.add(0x16e47, 0x16e47, [2, [0x16E67], 0]);
        t.add(0x16e48, 0x16e48, [2, [0x16E68], 0]);
        t.add(0x16e49, 0x16e49, [2, [0x16E69], 0]);
        t.add(0x16e4a, 0x16e4a, [2, [0x16E6A], 0]);
        t.add(0x16e4b, 0x16e4b, [2, [0x16E6B], 0]);
        t.add(0x16e4c, 0x16e4c, [2, [0x16E6C], 0]);
        t.add(0x16e4d, 0x16e4d, [2, [0x16E6D], 0]);
        t.add(0x16e4e, 0x16e4e, [2, [0x16E6E], 0]);
        t.add(0x16e4f, 0x16e4f, [2, [0x16E6F], 0]);
        t.add(0x16e50, 0x16e50, [2, [0x16E70], 0]);
        t.add(0x16e51, 0x16e51, [2, [0x16E71], 0]);
        t.add(0x16e52, 0x16e52, [2, [0x16E72], 0]);
        t.add(0x16e53, 0x16e53, [2, [0x16E73], 0]);
        t.add(0x16e54, 0x16e54, [2, [0x16E74], 0]);
        t.add(0x16e55, 0x16e55, [2, [0x16E75], 0]);
        t.add(0x16e56, 0x16e56, [2, [0x16E76], 0]);
        t.add(0x16e57, 0x16e57, [2, [0x16E77], 0]);
        t.add(0x16e58, 0x16e58, [2, [0x16E78], 0]);
        t.add(0x16e59, 0x16e59, [2, [0x16E79], 0]);
        t.add(0x16e5a, 0x16e5a, [2, [0x16E7A], 0]);
        t.add(0x16e5b, 0x16e5b, [2, [0x16E7B], 0]);
        t.add(0x16e5c, 0x16e5c, [2, [0x16E7C], 0]);
        t.add(0x16e5d, 0x16e5d, [2, [0x16E7D], 0]);
        t.add(0x16e5e, 0x16e5e, [2, [0x16E7E], 0]);
        t.add(0x16e5f, 0x16e5f, [2, [0x16E7F], 0]);
        t.add(0x16e60, 0x16e7f, [0, [], 0]);
        t.add(0x16e80, 0x16e9a, [0, [], 1]);
        t.add(0x16e9b, 0x16eff, [4, [], 0]);
        t.add(0x16f00, 0x16f44, [0, [], 0]);
        t.add(0x16f45, 0x16f4a, [0, [], 0]);
        t.add(0x16f4b, 0x16f4e, [4, [], 0]);
        t.add(0x16f4f, 0x16f4f, [0, [], 0]);
        t.add(0x16f50, 0x16f7e, [0, [], 0]);
        t.add(0x16f7f, 0x16f87, [0, [], 0]);
        t.add(0x16f88, 0x16f8e, [4, [], 0]);
        t.add(0x16f8f, 0x16f9f, [0, [], 0]);
        t.add(0x16fa0, 0x16fdf, [4, [], 0]);
        t.add(0x16fe0, 0x16fe0, [0, [], 0]);
        t.add(0x16fe1, 0x16fe1, [0, [], 0]);
        t.add(0x16fe2, 0x16fe2, [0, [], 1]);
        t.add(0x16fe3, 0x16fe3, [0, [], 0]);
        t.add(0x16fe4, 0x16fff, [4, [], 0]);
        t.add(0x17000, 0x187ec, [0, [], 0]);
        t.add(0x187ed, 0x187f1, [0, [], 0]);
        t.add(0x187f2, 0x187f7, [0, [], 0]);
        t.add(0x187f8, 0x187ff, [4, [], 0]);
        t.add(0x18800, 0x18af2, [0, [], 0]);
        t.add(0x18af3, 0x1afff, [4, [], 0]);
        t.add(0x1b000, 0x1b001, [0, [], 0]);
        t.add(0x1b002, 0x1b11e, [0, [], 0]);
        t.add(0x1b11f, 0x1b14f, [4, [], 0]);
        t.add(0x1b150, 0x1b152, [0, [], 0]);
        t.add(0x1b153, 0x1b163, [4, [], 0]);
        t.add(0x1b164, 0x1b167, [0, [], 0]);
        t.add(0x1b168, 0x1b16f, [4, [], 0]);
        t.add(0x1b170, 0x1b2fb, [0, [], 0]);
        t.add(0x1b2fc, 0x1bbff, [4, [], 0]);
        t.add(0x1bc00, 0x1bc6a, [0, [], 0]);
        t.add(0x1bc6b, 0x1bc6f, [4, [], 0]);
        t.add(0x1bc70, 0x1bc7c, [0, [], 0]);
        t.add(0x1bc7d, 0x1bc7f, [4, [], 0]);
        t.add(0x1bc80, 0x1bc88, [0, [], 0]);
        t.add(0x1bc89, 0x1bc8f, [4, [], 0]);
        t.add(0x1bc90, 0x1bc99, [0, [], 0]);
        t.add(0x1bc9a, 0x1bc9b, [4, [], 0]);
        t.add(0x1bc9c, 0x1bc9c, [0, [], 1]);
        t.add(0x1bc9d, 0x1bc9e, [0, [], 0]);
        t.add(0x1bc9f, 0x1bc9f, [0, [], 1]);
        t.add(0x1bca0, 0x1bca3, [1, [], 0]);
        t.add(0x1bca4, 0x1cfff, [4, [], 0]);
        t.add(0x1d000, 0x1d0f5, [0, [], 1]);
        t.add(0x1d0f6, 0x1d0ff, [4, [], 0]);
        t.add(0x1d100, 0x1d126, [0, [], 1]);
        t.add(0x1d127, 0x1d128, [4, [], 0]);
        t.add(0x1d129, 0x1d129, [0, [], 1]);
        t.add(0x1d12a, 0x1d15d, [0, [], 1]);
        t.add(0x1d15e, 0x1d15e, [2, [0x1D157, 0x1D165], 0]);
        t.add(0x1d15f, 0x1d15f, [2, [0x1D158, 0x1D165], 0]);
        t.add(0x1d160, 0x1d160, [2, [0x1D158, 0x1D165, 0x1D16E], 0]);
        t.add(0x1d161, 0x1d161, [2, [0x1D158, 0x1D165, 0x1D16F], 0]);
        t.add(0x1d162, 0x1d162, [2, [0x1D158, 0x1D165, 0x1D170], 0]);
        t.add(0x1d163, 0x1d163, [2, [0x1D158, 0x1D165, 0x1D171], 0]);
        t.add(0x1d164, 0x1d164, [2, [0x1D158, 0x1D165, 0x1D172], 0]);
        t.add(0x1d165, 0x1d172, [0, [], 1]);
        t.add(0x1d173, 0x1d17a, [4, [], 0]);
        t.add(0x1d17b, 0x1d1ba, [0, [], 1]);
        t.add(0x1d1bb, 0x1d1bb, [2, [0x1D1B9, 0x1D165], 0]);
        t.add(0x1d1bc, 0x1d1bc, [2, [0x1D1BA, 0x1D165], 0]);
        t.add(0x1d1bd, 0x1d1bd, [2, [0x1D1B9, 0x1D165, 0x1D16E], 0]);
        t.add(0x1d1be, 0x1d1be, [2, [0x1D1BA, 0x1D165, 0x1D16E], 0]);
        t.add(0x1d1bf, 0x1d1bf, [2, [0x1D1B9, 0x1D165, 0x1D16F], 0]);
        t.add(0x1d1c0, 0x1d1c0, [2, [0x1D1BA, 0x1D165, 0x1D16F], 0]);
        t.add(0x1d1c1, 0x1d1dd, [0, [], 1]);
        t.add(0x1d1de, 0x1d1e8, [0, [], 1]);
        t.add(0x1d1e9, 0x1d1ff, [4, [], 0]);
        t.add(0x1d200, 0x1d245, [0, [], 1]);
        t.add(0x1d246, 0x1d2df, [4, [], 0]);
        t.add(0x1d2e0, 0x1d2f3, [0, [], 1]);
        t.add(0x1d2f4, 0x1d2ff, [4, [], 0]);
        t.add(0x1d300, 0x1d356, [0, [], 1]);
        t.add(0x1d357, 0x1d35f, [4, [], 0]);
        t.add(0x1d360, 0x1d371, [0, [], 1]);
        t.add(0x1d372, 0x1d378, [0, [], 1]);
        t.add(0x1d379, 0x1d3ff, [4, [], 0]);
        t.add(0x1d400, 0x1d400, [2, [0x0061], 0]);
        t.add(0x1d401, 0x1d401, [2, [0x0062], 0]);
        t.add(0x1d402, 0x1d402, [2, [0x0063], 0]);
        t.add(0x1d403, 0x1d403, [2, [0x0064], 0]);
        t.add(0x1d404, 0x1d404, [2, [0x0065], 0]);
        t.add(0x1d405, 0x1d405, [2, [0x0066], 0]);
        t.add(0x1d406, 0x1d406, [2, [0x0067], 0]);
        t.add(0x1d407, 0x1d407, [2, [0x0068], 0]);
        t.add(0x1d408, 0x1d408, [2, [0x0069], 0]);
        t.add(0x1d409, 0x1d409, [2, [0x006A], 0]);
        t.add(0x1d40a, 0x1d40a, [2, [0x006B], 0]);
        t.add(0x1d40b, 0x1d40b, [2, [0x006C], 0]);
        t.add(0x1d40c, 0x1d40c, [2, [0x006D], 0]);
        t.add(0x1d40d, 0x1d40d, [2, [0x006E], 0]);
        t.add(0x1d40e, 0x1d40e, [2, [0x006F], 0]);
        t.add(0x1d40f, 0x1d40f, [2, [0x0070], 0]);
        t.add(0x1d410, 0x1d410, [2, [0x0071], 0]);
        t.add(0x1d411, 0x1d411, [2, [0x0072], 0]);
        t.add(0x1d412, 0x1d412, [2, [0x0073], 0]);
        t.add(0x1d413, 0x1d413, [2, [0x0074], 0]);
        t.add(0x1d414, 0x1d414, [2, [0x0075], 0]);
        t.add(0x1d415, 0x1d415, [2, [0x0076], 0]);
        t.add(0x1d416, 0x1d416, [2, [0x0077], 0]);
        t.add(0x1d417, 0x1d417, [2, [0x0078], 0]);
        t.add(0x1d418, 0x1d418, [2, [0x0079], 0]);
        t.add(0x1d419, 0x1d419, [2, [0x007A], 0]);
        t.add(0x1d41a, 0x1d41a, [2, [0x0061], 0]);
        t.add(0x1d41b, 0x1d41b, [2, [0x0062], 0]);
        t.add(0x1d41c, 0x1d41c, [2, [0x0063], 0]);
        t.add(0x1d41d, 0x1d41d, [2, [0x0064], 0]);
        t.add(0x1d41e, 0x1d41e, [2, [0x0065], 0]);
        t.add(0x1d41f, 0x1d41f, [2, [0x0066], 0]);
        t.add(0x1d420, 0x1d420, [2, [0x0067], 0]);
        t.add(0x1d421, 0x1d421, [2, [0x0068], 0]);
        t.add(0x1d422, 0x1d422, [2, [0x0069], 0]);
        t.add(0x1d423, 0x1d423, [2, [0x006A], 0]);
        t.add(0x1d424, 0x1d424, [2, [0x006B], 0]);
        t.add(0x1d425, 0x1d425, [2, [0x006C], 0]);
        t.add(0x1d426, 0x1d426, [2, [0x006D], 0]);
        t.add(0x1d427, 0x1d427, [2, [0x006E], 0]);
        t.add(0x1d428, 0x1d428, [2, [0x006F], 0]);
        t.add(0x1d429, 0x1d429, [2, [0x0070], 0]);
        t.add(0x1d42a, 0x1d42a, [2, [0x0071], 0]);
        t.add(0x1d42b, 0x1d42b, [2, [0x0072], 0]);
        t.add(0x1d42c, 0x1d42c, [2, [0x0073], 0]);
        t.add(0x1d42d, 0x1d42d, [2, [0x0074], 0]);
        t.add(0x1d42e, 0x1d42e, [2, [0x0075], 0]);
        t.add(0x1d42f, 0x1d42f, [2, [0x0076], 0]);
        t.add(0x1d430, 0x1d430, [2, [0x0077], 0]);
        t.add(0x1d431, 0x1d431, [2, [0x0078], 0]);
        t.add(0x1d432, 0x1d432, [2, [0x0079], 0]);
        t.add(0x1d433, 0x1d433, [2, [0x007A], 0]);
        t.add(0x1d434, 0x1d434, [2, [0x0061], 0]);
        t.add(0x1d435, 0x1d435, [2, [0x0062], 0]);
        t.add(0x1d436, 0x1d436, [2, [0x0063], 0]);
        t.add(0x1d437, 0x1d437, [2, [0x0064], 0]);
        t.add(0x1d438, 0x1d438, [2, [0x0065], 0]);
        t.add(0x1d439, 0x1d439, [2, [0x0066], 0]);
        t.add(0x1d43a, 0x1d43a, [2, [0x0067], 0]);
        t.add(0x1d43b, 0x1d43b, [2, [0x0068], 0]);
        t.add(0x1d43c, 0x1d43c, [2, [0x0069], 0]);
        t.add(0x1d43d, 0x1d43d, [2, [0x006A], 0]);
        t.add(0x1d43e, 0x1d43e, [2, [0x006B], 0]);
        t.add(0x1d43f, 0x1d43f, [2, [0x006C], 0]);
        t.add(0x1d440, 0x1d440, [2, [0x006D], 0]);
        t.add(0x1d441, 0x1d441, [2, [0x006E], 0]);
        t.add(0x1d442, 0x1d442, [2, [0x006F], 0]);
        t.add(0x1d443, 0x1d443, [2, [0x0070], 0]);
        t.add(0x1d444, 0x1d444, [2, [0x0071], 0]);
        t.add(0x1d445, 0x1d445, [2, [0x0072], 0]);
        t.add(0x1d446, 0x1d446, [2, [0x0073], 0]);
        t.add(0x1d447, 0x1d447, [2, [0x0074], 0]);
        t.add(0x1d448, 0x1d448, [2, [0x0075], 0]);
        t.add(0x1d449, 0x1d449, [2, [0x0076], 0]);
        t.add(0x1d44a, 0x1d44a, [2, [0x0077], 0]);
        t.add(0x1d44b, 0x1d44b, [2, [0x0078], 0]);
        t.add(0x1d44c, 0x1d44c, [2, [0x0079], 0]);
        t.add(0x1d44d, 0x1d44d, [2, [0x007A], 0]);
        t.add(0x1d44e, 0x1d44e, [2, [0x0061], 0]);
        t.add(0x1d44f, 0x1d44f, [2, [0x0062], 0]);
        t.add(0x1d450, 0x1d450, [2, [0x0063], 0]);
        t.add(0x1d451, 0x1d451, [2, [0x0064], 0]);
        t.add(0x1d452, 0x1d452, [2, [0x0065], 0]);
        t.add(0x1d453, 0x1d453, [2, [0x0066], 0]);
        t.add(0x1d454, 0x1d454, [2, [0x0067], 0]);
        t.add(0x1d455, 0x1d455, [4, [], 0]);
        t.add(0x1d456, 0x1d456, [2, [0x0069], 0]);
        t.add(0x1d457, 0x1d457, [2, [0x006A], 0]);
        t.add(0x1d458, 0x1d458, [2, [0x006B], 0]);
        t.add(0x1d459, 0x1d459, [2, [0x006C], 0]);
        t.add(0x1d45a, 0x1d45a, [2, [0x006D], 0]);
        t.add(0x1d45b, 0x1d45b, [2, [0x006E], 0]);
        t.add(0x1d45c, 0x1d45c, [2, [0x006F], 0]);
        t.add(0x1d45d, 0x1d45d, [2, [0x0070], 0]);
        t.add(0x1d45e, 0x1d45e, [2, [0x0071], 0]);
        t.add(0x1d45f, 0x1d45f, [2, [0x0072], 0]);
        t.add(0x1d460, 0x1d460, [2, [0x0073], 0]);
        t.add(0x1d461, 0x1d461, [2, [0x0074], 0]);
        t.add(0x1d462, 0x1d462, [2, [0x0075], 0]);
        t.add(0x1d463, 0x1d463, [2, [0x0076], 0]);
        t.add(0x1d464, 0x1d464, [2, [0x0077], 0]);
        t.add(0x1d465, 0x1d465, [2, [0x0078], 0]);
        t.add(0x1d466, 0x1d466, [2, [0x0079], 0]);
        t.add(0x1d467, 0x1d467, [2, [0x007A], 0]);
        t.add(0x1d468, 0x1d468, [2, [0x0061], 0]);
        t.add(0x1d469, 0x1d469, [2, [0x0062], 0]);
        t.add(0x1d46a, 0x1d46a, [2, [0x0063], 0]);
        t.add(0x1d46b, 0x1d46b, [2, [0x0064], 0]);
        t.add(0x1d46c, 0x1d46c, [2, [0x0065], 0]);
        t.add(0x1d46d, 0x1d46d, [2, [0x0066], 0]);
        t.add(0x1d46e, 0x1d46e, [2, [0x0067], 0]);
        t.add(0x1d46f, 0x1d46f, [2, [0x0068], 0]);
        t.add(0x1d470, 0x1d470, [2, [0x0069], 0]);
        t.add(0x1d471, 0x1d471, [2, [0x006A], 0]);
        t.add(0x1d472, 0x1d472, [2, [0x006B], 0]);
        t.add(0x1d473, 0x1d473, [2, [0x006C], 0]);
        t.add(0x1d474, 0x1d474, [2, [0x006D], 0]);
        t.add(0x1d475, 0x1d475, [2, [0x006E], 0]);
        t.add(0x1d476, 0x1d476, [2, [0x006F], 0]);
        t.add(0x1d477, 0x1d477, [2, [0x0070], 0]);
        t.add(0x1d478, 0x1d478, [2, [0x0071], 0]);
        t.add(0x1d479, 0x1d479, [2, [0x0072], 0]);
        t.add(0x1d47a, 0x1d47a, [2, [0x0073], 0]);
        t.add(0x1d47b, 0x1d47b, [2, [0x0074], 0]);
        t.add(0x1d47c, 0x1d47c, [2, [0x0075], 0]);
        t.add(0x1d47d, 0x1d47d, [2, [0x0076], 0]);
        t.add(0x1d47e, 0x1d47e, [2, [0x0077], 0]);
        t.add(0x1d47f, 0x1d47f, [2, [0x0078], 0]);
        t.add(0x1d480, 0x1d480, [2, [0x0079], 0]);
        t.add(0x1d481, 0x1d481, [2, [0x007A], 0]);
        t.add(0x1d482, 0x1d482, [2, [0x0061], 0]);
        t.add(0x1d483, 0x1d483, [2, [0x0062], 0]);
        t.add(0x1d484, 0x1d484, [2, [0x0063], 0]);
        t.add(0x1d485, 0x1d485, [2, [0x0064], 0]);
        t.add(0x1d486, 0x1d486, [2, [0x0065], 0]);
        t.add(0x1d487, 0x1d487, [2, [0x0066], 0]);
        t.add(0x1d488, 0x1d488, [2, [0x0067], 0]);
        t.add(0x1d489, 0x1d489, [2, [0x0068], 0]);
        t.add(0x1d48a, 0x1d48a, [2, [0x0069], 0]);
        t.add(0x1d48b, 0x1d48b, [2, [0x006A], 0]);
        t.add(0x1d48c, 0x1d48c, [2, [0x006B], 0]);
        t.add(0x1d48d, 0x1d48d, [2, [0x006C], 0]);
        t.add(0x1d48e, 0x1d48e, [2, [0x006D], 0]);
        t.add(0x1d48f, 0x1d48f, [2, [0x006E], 0]);
        t.add(0x1d490, 0x1d490, [2, [0x006F], 0]);
        t.add(0x1d491, 0x1d491, [2, [0x0070], 0]);
        t.add(0x1d492, 0x1d492, [2, [0x0071], 0]);
        t.add(0x1d493, 0x1d493, [2, [0x0072], 0]);
        t.add(0x1d494, 0x1d494, [2, [0x0073], 0]);
        t.add(0x1d495, 0x1d495, [2, [0x0074], 0]);
        t.add(0x1d496, 0x1d496, [2, [0x0075], 0]);
        t.add(0x1d497, 0x1d497, [2, [0x0076], 0]);
        t.add(0x1d498, 0x1d498, [2, [0x0077], 0]);
        t.add(0x1d499, 0x1d499, [2, [0x0078], 0]);
        t.add(0x1d49a, 0x1d49a, [2, [0x0079], 0]);
        t.add(0x1d49b, 0x1d49b, [2, [0x007A], 0]);
        t.add(0x1d49c, 0x1d49c, [2, [0x0061], 0]);
        t.add(0x1d49d, 0x1d49d, [4, [], 0]);
        t.add(0x1d49e, 0x1d49e, [2, [0x0063], 0]);
        t.add(0x1d49f, 0x1d49f, [2, [0x0064], 0]);
        t.add(0x1d4a0, 0x1d4a1, [4, [], 0]);
        t.add(0x1d4a2, 0x1d4a2, [2, [0x0067], 0]);
        t.add(0x1d4a3, 0x1d4a4, [4, [], 0]);
        t.add(0x1d4a5, 0x1d4a5, [2, [0x006A], 0]);
        t.add(0x1d4a6, 0x1d4a6, [2, [0x006B], 0]);
        t.add(0x1d4a7, 0x1d4a8, [4, [], 0]);
        t.add(0x1d4a9, 0x1d4a9, [2, [0x006E], 0]);
        t.add(0x1d4aa, 0x1d4aa, [2, [0x006F], 0]);
        t.add(0x1d4ab, 0x1d4ab, [2, [0x0070], 0]);
        t.add(0x1d4ac, 0x1d4ac, [2, [0x0071], 0]);
        t.add(0x1d4ad, 0x1d4ad, [4, [], 0]);
        t.add(0x1d4ae, 0x1d4ae, [2, [0x0073], 0]);
        t.add(0x1d4af, 0x1d4af, [2, [0x0074], 0]);
        t.add(0x1d4b0, 0x1d4b0, [2, [0x0075], 0]);
        t.add(0x1d4b1, 0x1d4b1, [2, [0x0076], 0]);
        t.add(0x1d4b2, 0x1d4b2, [2, [0x0077], 0]);
        t.add(0x1d4b3, 0x1d4b3, [2, [0x0078], 0]);
        t.add(0x1d4b4, 0x1d4b4, [2, [0x0079], 0]);
        t.add(0x1d4b5, 0x1d4b5, [2, [0x007A], 0]);
        t.add(0x1d4b6, 0x1d4b6, [2, [0x0061], 0]);
        t.add(0x1d4b7, 0x1d4b7, [2, [0x0062], 0]);
        t.add(0x1d4b8, 0x1d4b8, [2, [0x0063], 0]);
        t.add(0x1d4b9, 0x1d4b9, [2, [0x0064], 0]);
        t.add(0x1d4ba, 0x1d4ba, [4, [], 0]);
        t.add(0x1d4bb, 0x1d4bb, [2, [0x0066], 0]);
        t.add(0x1d4bc, 0x1d4bc, [4, [], 0]);
        t.add(0x1d4bd, 0x1d4bd, [2, [0x0068], 0]);
        t.add(0x1d4be, 0x1d4be, [2, [0x0069], 0]);
        t.add(0x1d4bf, 0x1d4bf, [2, [0x006A], 0]);
        t.add(0x1d4c0, 0x1d4c0, [2, [0x006B], 0]);
        t.add(0x1d4c1, 0x1d4c1, [2, [0x006C], 0]);
        t.add(0x1d4c2, 0x1d4c2, [2, [0x006D], 0]);
        t.add(0x1d4c3, 0x1d4c3, [2, [0x006E], 0]);
        t.add(0x1d4c4, 0x1d4c4, [4, [], 0]);
        t.add(0x1d4c5, 0x1d4c5, [2, [0x0070], 0]);
        t.add(0x1d4c6, 0x1d4c6, [2, [0x0071], 0]);
        t.add(0x1d4c7, 0x1d4c7, [2, [0x0072], 0]);
        t.add(0x1d4c8, 0x1d4c8, [2, [0x0073], 0]);
        t.add(0x1d4c9, 0x1d4c9, [2, [0x0074], 0]);
        t.add(0x1d4ca, 0x1d4ca, [2, [0x0075], 0]);
        t.add(0x1d4cb, 0x1d4cb, [2, [0x0076], 0]);
        t.add(0x1d4cc, 0x1d4cc, [2, [0x0077], 0]);
        t.add(0x1d4cd, 0x1d4cd, [2, [0x0078], 0]);
        t.add(0x1d4ce, 0x1d4ce, [2, [0x0079], 0]);
        t.add(0x1d4cf, 0x1d4cf, [2, [0x007A], 0]);
        t.add(0x1d4d0, 0x1d4d0, [2, [0x0061], 0]);
        t.add(0x1d4d1, 0x1d4d1, [2, [0x0062], 0]);
        t.add(0x1d4d2, 0x1d4d2, [2, [0x0063], 0]);
        t.add(0x1d4d3, 0x1d4d3, [2, [0x0064], 0]);
        t.add(0x1d4d4, 0x1d4d4, [2, [0x0065], 0]);
        t.add(0x1d4d5, 0x1d4d5, [2, [0x0066], 0]);
        t.add(0x1d4d6, 0x1d4d6, [2, [0x0067], 0]);
        t.add(0x1d4d7, 0x1d4d7, [2, [0x0068], 0]);
        t.add(0x1d4d8, 0x1d4d8, [2, [0x0069], 0]);
        t.add(0x1d4d9, 0x1d4d9, [2, [0x006A], 0]);
        t.add(0x1d4da, 0x1d4da, [2, [0x006B], 0]);
        t.add(0x1d4db, 0x1d4db, [2, [0x006C], 0]);
        t.add(0x1d4dc, 0x1d4dc, [2, [0x006D], 0]);
        t.add(0x1d4dd, 0x1d4dd, [2, [0x006E], 0]);
        t.add(0x1d4de, 0x1d4de, [2, [0x006F], 0]);
        t.add(0x1d4df, 0x1d4df, [2, [0x0070], 0]);
        t.add(0x1d4e0, 0x1d4e0, [2, [0x0071], 0]);
        t.add(0x1d4e1, 0x1d4e1, [2, [0x0072], 0]);
        t.add(0x1d4e2, 0x1d4e2, [2, [0x0073], 0]);
        t.add(0x1d4e3, 0x1d4e3, [2, [0x0074], 0]);
        t.add(0x1d4e4, 0x1d4e4, [2, [0x0075], 0]);
        t.add(0x1d4e5, 0x1d4e5, [2, [0x0076], 0]);
        t.add(0x1d4e6, 0x1d4e6, [2, [0x0077], 0]);
        t.add(0x1d4e7, 0x1d4e7, [2, [0x0078], 0]);
        t.add(0x1d4e8, 0x1d4e8, [2, [0x0079], 0]);
        t.add(0x1d4e9, 0x1d4e9, [2, [0x007A], 0]);
        t.add(0x1d4ea, 0x1d4ea, [2, [0x0061], 0]);
        t.add(0x1d4eb, 0x1d4eb, [2, [0x0062], 0]);
        t.add(0x1d4ec, 0x1d4ec, [2, [0x0063], 0]);
        t.add(0x1d4ed, 0x1d4ed, [2, [0x0064], 0]);
        t.add(0x1d4ee, 0x1d4ee, [2, [0x0065], 0]);
        t.add(0x1d4ef, 0x1d4ef, [2, [0x0066], 0]);
        t.add(0x1d4f0, 0x1d4f0, [2, [0x0067], 0]);
        t.add(0x1d4f1, 0x1d4f1, [2, [0x0068], 0]);
        t.add(0x1d4f2, 0x1d4f2, [2, [0x0069], 0]);
        t.add(0x1d4f3, 0x1d4f3, [2, [0x006A], 0]);
        t.add(0x1d4f4, 0x1d4f4, [2, [0x006B], 0]);
        t.add(0x1d4f5, 0x1d4f5, [2, [0x006C], 0]);
        t.add(0x1d4f6, 0x1d4f6, [2, [0x006D], 0]);
        t.add(0x1d4f7, 0x1d4f7, [2, [0x006E], 0]);
        t.add(0x1d4f8, 0x1d4f8, [2, [0x006F], 0]);
        t.add(0x1d4f9, 0x1d4f9, [2, [0x0070], 0]);
        t.add(0x1d4fa, 0x1d4fa, [2, [0x0071], 0]);
        t.add(0x1d4fb, 0x1d4fb, [2, [0x0072], 0]);
        t.add(0x1d4fc, 0x1d4fc, [2, [0x0073], 0]);
        t.add(0x1d4fd, 0x1d4fd, [2, [0x0074], 0]);
        t.add(0x1d4fe, 0x1d4fe, [2, [0x0075], 0]);
        t.add(0x1d4ff, 0x1d4ff, [2, [0x0076], 0]);
        t.add(0x1d500, 0x1d500, [2, [0x0077], 0]);
        t.add(0x1d501, 0x1d501, [2, [0x0078], 0]);
        t.add(0x1d502, 0x1d502, [2, [0x0079], 0]);
        t.add(0x1d503, 0x1d503, [2, [0x007A], 0]);
        t.add(0x1d504, 0x1d504, [2, [0x0061], 0]);
        t.add(0x1d505, 0x1d505, [2, [0x0062], 0]);
        t.add(0x1d506, 0x1d506, [4, [], 0]);
        t.add(0x1d507, 0x1d507, [2, [0x0064], 0]);
        t.add(0x1d508, 0x1d508, [2, [0x0065], 0]);
        t.add(0x1d509, 0x1d509, [2, [0x0066], 0]);
        t.add(0x1d50a, 0x1d50a, [2, [0x0067], 0]);
        t.add(0x1d50b, 0x1d50c, [4, [], 0]);
        t.add(0x1d50d, 0x1d50d, [2, [0x006A], 0]);
        t.add(0x1d50e, 0x1d50e, [2, [0x006B], 0]);
        t.add(0x1d50f, 0x1d50f, [2, [0x006C], 0]);
        t.add(0x1d510, 0x1d510, [2, [0x006D], 0]);
        t.add(0x1d511, 0x1d511, [2, [0x006E], 0]);
        t.add(0x1d512, 0x1d512, [2, [0x006F], 0]);
        t.add(0x1d513, 0x1d513, [2, [0x0070], 0]);
        t.add(0x1d514, 0x1d514, [2, [0x0071], 0]);
        t.add(0x1d515, 0x1d515, [4, [], 0]);
        t.add(0x1d516, 0x1d516, [2, [0x0073], 0]);
        t.add(0x1d517, 0x1d517, [2, [0x0074], 0]);
        t.add(0x1d518, 0x1d518, [2, [0x0075], 0]);
        t.add(0x1d519, 0x1d519, [2, [0x0076], 0]);
        t.add(0x1d51a, 0x1d51a, [2, [0x0077], 0]);
        t.add(0x1d51b, 0x1d51b, [2, [0x0078], 0]);
        t.add(0x1d51c, 0x1d51c, [2, [0x0079], 0]);
        t.add(0x1d51d, 0x1d51d, [4, [], 0]);
        t.add(0x1d51e, 0x1d51e, [2, [0x0061], 0]);
        t.add(0x1d51f, 0x1d51f, [2, [0x0062], 0]);
        t.add(0x1d520, 0x1d520, [2, [0x0063], 0]);
        t.add(0x1d521, 0x1d521, [2, [0x0064], 0]);
        t.add(0x1d522, 0x1d522, [2, [0x0065], 0]);
        t.add(0x1d523, 0x1d523, [2, [0x0066], 0]);
        t.add(0x1d524, 0x1d524, [2, [0x0067], 0]);
        t.add(0x1d525, 0x1d525, [2, [0x0068], 0]);
        t.add(0x1d526, 0x1d526, [2, [0x0069], 0]);
        t.add(0x1d527, 0x1d527, [2, [0x006A], 0]);
        t.add(0x1d528, 0x1d528, [2, [0x006B], 0]);
        t.add(0x1d529, 0x1d529, [2, [0x006C], 0]);
        t.add(0x1d52a, 0x1d52a, [2, [0x006D], 0]);
        t.add(0x1d52b, 0x1d52b, [2, [0x006E], 0]);
        t.add(0x1d52c, 0x1d52c, [2, [0x006F], 0]);
        t.add(0x1d52d, 0x1d52d, [2, [0x0070], 0]);
        t.add(0x1d52e, 0x1d52e, [2, [0x0071], 0]);
        t.add(0x1d52f, 0x1d52f, [2, [0x0072], 0]);
        t.add(0x1d530, 0x1d530, [2, [0x0073], 0]);
        t.add(0x1d531, 0x1d531, [2, [0x0074], 0]);
        t.add(0x1d532, 0x1d532, [2, [0x0075], 0]);
        t.add(0x1d533, 0x1d533, [2, [0x0076], 0]);
        t.add(0x1d534, 0x1d534, [2, [0x0077], 0]);
        t.add(0x1d535, 0x1d535, [2, [0x0078], 0]);
        t.add(0x1d536, 0x1d536, [2, [0x0079], 0]);
        t.add(0x1d537, 0x1d537, [2, [0x007A], 0]);
        t.add(0x1d538, 0x1d538, [2, [0x0061], 0]);
        t.add(0x1d539, 0x1d539, [2, [0x0062], 0]);
        t.add(0x1d53a, 0x1d53a, [4, [], 0]);
        t.add(0x1d53b, 0x1d53b, [2, [0x0064], 0]);
        t.add(0x1d53c, 0x1d53c, [2, [0x0065], 0]);
        t.add(0x1d53d, 0x1d53d, [2, [0x0066], 0]);
        t.add(0x1d53e, 0x1d53e, [2, [0x0067], 0]);
        t.add(0x1d53f, 0x1d53f, [4, [], 0]);
        t.add(0x1d540, 0x1d540, [2, [0x0069], 0]);
        t.add(0x1d541, 0x1d541, [2, [0x006A], 0]);
        t.add(0x1d542, 0x1d542, [2, [0x006B], 0]);
        t.add(0x1d543, 0x1d543, [2, [0x006C], 0]);
        t.add(0x1d544, 0x1d544, [2, [0x006D], 0]);
        t.add(0x1d545, 0x1d545, [4, [], 0]);
        t.add(0x1d546, 0x1d546, [2, [0x006F], 0]);
        t.add(0x1d547, 0x1d549, [4, [], 0]);
        t.add(0x1d54a, 0x1d54a, [2, [0x0073], 0]);
        t.add(0x1d54b, 0x1d54b, [2, [0x0074], 0]);
        t.add(0x1d54c, 0x1d54c, [2, [0x0075], 0]);
        t.add(0x1d54d, 0x1d54d, [2, [0x0076], 0]);
        t.add(0x1d54e, 0x1d54e, [2, [0x0077], 0]);
        t.add(0x1d54f, 0x1d54f, [2, [0x0078], 0]);
        t.add(0x1d550, 0x1d550, [2, [0x0079], 0]);
        t.add(0x1d551, 0x1d551, [4, [], 0]);
        t.add(0x1d552, 0x1d552, [2, [0x0061], 0]);
        t.add(0x1d553, 0x1d553, [2, [0x0062], 0]);
        t.add(0x1d554, 0x1d554, [2, [0x0063], 0]);
        t.add(0x1d555, 0x1d555, [2, [0x0064], 0]);
        t.add(0x1d556, 0x1d556, [2, [0x0065], 0]);
        t.add(0x1d557, 0x1d557, [2, [0x0066], 0]);
        t.add(0x1d558, 0x1d558, [2, [0x0067], 0]);
        t.add(0x1d559, 0x1d559, [2, [0x0068], 0]);
        t.add(0x1d55a, 0x1d55a, [2, [0x0069], 0]);
        t.add(0x1d55b, 0x1d55b, [2, [0x006A], 0]);
        t.add(0x1d55c, 0x1d55c, [2, [0x006B], 0]);
        t.add(0x1d55d, 0x1d55d, [2, [0x006C], 0]);
        t.add(0x1d55e, 0x1d55e, [2, [0x006D], 0]);
        t.add(0x1d55f, 0x1d55f, [2, [0x006E], 0]);
        t.add(0x1d560, 0x1d560, [2, [0x006F], 0]);
        t.add(0x1d561, 0x1d561, [2, [0x0070], 0]);
        t.add(0x1d562, 0x1d562, [2, [0x0071], 0]);
        t.add(0x1d563, 0x1d563, [2, [0x0072], 0]);
        t.add(0x1d564, 0x1d564, [2, [0x0073], 0]);
        t.add(0x1d565, 0x1d565, [2, [0x0074], 0]);
        t.add(0x1d566, 0x1d566, [2, [0x0075], 0]);
        t.add(0x1d567, 0x1d567, [2, [0x0076], 0]);
        t.add(0x1d568, 0x1d568, [2, [0x0077], 0]);
        t.add(0x1d569, 0x1d569, [2, [0x0078], 0]);
        t.add(0x1d56a, 0x1d56a, [2, [0x0079], 0]);
        t.add(0x1d56b, 0x1d56b, [2, [0x007A], 0]);
        t.add(0x1d56c, 0x1d56c, [2, [0x0061], 0]);
        t.add(0x1d56d, 0x1d56d, [2, [0x0062], 0]);
        t.add(0x1d56e, 0x1d56e, [2, [0x0063], 0]);
        t.add(0x1d56f, 0x1d56f, [2, [0x0064], 0]);
        t.add(0x1d570, 0x1d570, [2, [0x0065], 0]);
        t.add(0x1d571, 0x1d571, [2, [0x0066], 0]);
        t.add(0x1d572, 0x1d572, [2, [0x0067], 0]);
        t.add(0x1d573, 0x1d573, [2, [0x0068], 0]);
        t.add(0x1d574, 0x1d574, [2, [0x0069], 0]);
        t.add(0x1d575, 0x1d575, [2, [0x006A], 0]);
        t.add(0x1d576, 0x1d576, [2, [0x006B], 0]);
        t.add(0x1d577, 0x1d577, [2, [0x006C], 0]);
        t.add(0x1d578, 0x1d578, [2, [0x006D], 0]);
        t.add(0x1d579, 0x1d579, [2, [0x006E], 0]);
        t.add(0x1d57a, 0x1d57a, [2, [0x006F], 0]);
        t.add(0x1d57b, 0x1d57b, [2, [0x0070], 0]);
        t.add(0x1d57c, 0x1d57c, [2, [0x0071], 0]);
        t.add(0x1d57d, 0x1d57d, [2, [0x0072], 0]);
        t.add(0x1d57e, 0x1d57e, [2, [0x0073], 0]);
        t.add(0x1d57f, 0x1d57f, [2, [0x0074], 0]);
        t.add(0x1d580, 0x1d580, [2, [0x0075], 0]);
        t.add(0x1d581, 0x1d581, [2, [0x0076], 0]);
        t.add(0x1d582, 0x1d582, [2, [0x0077], 0]);
        t.add(0x1d583, 0x1d583, [2, [0x0078], 0]);
        t.add(0x1d584, 0x1d584, [2, [0x0079], 0]);
        t.add(0x1d585, 0x1d585, [2, [0x007A], 0]);
        t.add(0x1d586, 0x1d586, [2, [0x0061], 0]);
        t.add(0x1d587, 0x1d587, [2, [0x0062], 0]);
        t.add(0x1d588, 0x1d588, [2, [0x0063], 0]);
        t.add(0x1d589, 0x1d589, [2, [0x0064], 0]);
        t.add(0x1d58a, 0x1d58a, [2, [0x0065], 0]);
        t.add(0x1d58b, 0x1d58b, [2, [0x0066], 0]);
        t.add(0x1d58c, 0x1d58c, [2, [0x0067], 0]);
        t.add(0x1d58d, 0x1d58d, [2, [0x0068], 0]);
        t.add(0x1d58e, 0x1d58e, [2, [0x0069], 0]);
        t.add(0x1d58f, 0x1d58f, [2, [0x006A], 0]);
        t.add(0x1d590, 0x1d590, [2, [0x006B], 0]);
        t.add(0x1d591, 0x1d591, [2, [0x006C], 0]);
        t.add(0x1d592, 0x1d592, [2, [0x006D], 0]);
        t.add(0x1d593, 0x1d593, [2, [0x006E], 0]);
        t.add(0x1d594, 0x1d594, [2, [0x006F], 0]);
        t.add(0x1d595, 0x1d595, [2, [0x0070], 0]);
        t.add(0x1d596, 0x1d596, [2, [0x0071], 0]);
        t.add(0x1d597, 0x1d597, [2, [0x0072], 0]);
        t.add(0x1d598, 0x1d598, [2, [0x0073], 0]);
        t.add(0x1d599, 0x1d599, [2, [0x0074], 0]);
        t.add(0x1d59a, 0x1d59a, [2, [0x0075], 0]);
        t.add(0x1d59b, 0x1d59b, [2, [0x0076], 0]);
        t.add(0x1d59c, 0x1d59c, [2, [0x0077], 0]);
        t.add(0x1d59d, 0x1d59d, [2, [0x0078], 0]);
        t.add(0x1d59e, 0x1d59e, [2, [0x0079], 0]);
        t.add(0x1d59f, 0x1d59f, [2, [0x007A], 0]);
        t.add(0x1d5a0, 0x1d5a0, [2, [0x0061], 0]);
        t.add(0x1d5a1, 0x1d5a1, [2, [0x0062], 0]);
        t.add(0x1d5a2, 0x1d5a2, [2, [0x0063], 0]);
        t.add(0x1d5a3, 0x1d5a3, [2, [0x0064], 0]);
        t.add(0x1d5a4, 0x1d5a4, [2, [0x0065], 0]);
        t.add(0x1d5a5, 0x1d5a5, [2, [0x0066], 0]);
        t.add(0x1d5a6, 0x1d5a6, [2, [0x0067], 0]);
        t.add(0x1d5a7, 0x1d5a7, [2, [0x0068], 0]);
        t.add(0x1d5a8, 0x1d5a8, [2, [0x0069], 0]);
        t.add(0x1d5a9, 0x1d5a9, [2, [0x006A], 0]);
        t.add(0x1d5aa, 0x1d5aa, [2, [0x006B], 0]);
        t.add(0x1d5ab, 0x1d5ab, [2, [0x006C], 0]);
        t.add(0x1d5ac, 0x1d5ac, [2, [0x006D], 0]);
        t.add(0x1d5ad, 0x1d5ad, [2, [0x006E], 0]);
        t.add(0x1d5ae, 0x1d5ae, [2, [0x006F], 0]);
        t.add(0x1d5af, 0x1d5af, [2, [0x0070], 0]);
        t.add(0x1d5b0, 0x1d5b0, [2, [0x0071], 0]);
        t.add(0x1d5b1, 0x1d5b1, [2, [0x0072], 0]);
        t.add(0x1d5b2, 0x1d5b2, [2, [0x0073], 0]);
        t.add(0x1d5b3, 0x1d5b3, [2, [0x0074], 0]);
        t.add(0x1d5b4, 0x1d5b4, [2, [0x0075], 0]);
        t.add(0x1d5b5, 0x1d5b5, [2, [0x0076], 0]);
        t.add(0x1d5b6, 0x1d5b6, [2, [0x0077], 0]);
        t.add(0x1d5b7, 0x1d5b7, [2, [0x0078], 0]);
        t.add(0x1d5b8, 0x1d5b8, [2, [0x0079], 0]);
        t.add(0x1d5b9, 0x1d5b9, [2, [0x007A], 0]);
        t.add(0x1d5ba, 0x1d5ba, [2, [0x0061], 0]);
        t.add(0x1d5bb, 0x1d5bb, [2, [0x0062], 0]);
        t.add(0x1d5bc, 0x1d5bc, [2, [0x0063], 0]);
        t.add(0x1d5bd, 0x1d5bd, [2, [0x0064], 0]);
        t.add(0x1d5be, 0x1d5be, [2, [0x0065], 0]);
        t.add(0x1d5bf, 0x1d5bf, [2, [0x0066], 0]);
        t.add(0x1d5c0, 0x1d5c0, [2, [0x0067], 0]);
        t.add(0x1d5c1, 0x1d5c1, [2, [0x0068], 0]);
        t.add(0x1d5c2, 0x1d5c2, [2, [0x0069], 0]);
        t.add(0x1d5c3, 0x1d5c3, [2, [0x006A], 0]);
        t.add(0x1d5c4, 0x1d5c4, [2, [0x006B], 0]);
        t.add(0x1d5c5, 0x1d5c5, [2, [0x006C], 0]);
        t.add(0x1d5c6, 0x1d5c6, [2, [0x006D], 0]);
        t.add(0x1d5c7, 0x1d5c7, [2, [0x006E], 0]);
        t.add(0x1d5c8, 0x1d5c8, [2, [0x006F], 0]);
        t.add(0x1d5c9, 0x1d5c9, [2, [0x0070], 0]);
        t.add(0x1d5ca, 0x1d5ca, [2, [0x0071], 0]);
        t.add(0x1d5cb, 0x1d5cb, [2, [0x0072], 0]);
        t.add(0x1d5cc, 0x1d5cc, [2, [0x0073], 0]);
        t.add(0x1d5cd, 0x1d5cd, [2, [0x0074], 0]);
        t.add(0x1d5ce, 0x1d5ce, [2, [0x0075], 0]);
        t.add(0x1d5cf, 0x1d5cf, [2, [0x0076], 0]);
        t.add(0x1d5d0, 0x1d5d0, [2, [0x0077], 0]);
        t.add(0x1d5d1, 0x1d5d1, [2, [0x0078], 0]);
        t.add(0x1d5d2, 0x1d5d2, [2, [0x0079], 0]);
        t.add(0x1d5d3, 0x1d5d3, [2, [0x007A], 0]);
        t.add(0x1d5d4, 0x1d5d4, [2, [0x0061], 0]);
        t.add(0x1d5d5, 0x1d5d5, [2, [0x0062], 0]);
        t.add(0x1d5d6, 0x1d5d6, [2, [0x0063], 0]);
        t.add(0x1d5d7, 0x1d5d7, [2, [0x0064], 0]);
        t.add(0x1d5d8, 0x1d5d8, [2, [0x0065], 0]);
        t.add(0x1d5d9, 0x1d5d9, [2, [0x0066], 0]);
        t.add(0x1d5da, 0x1d5da, [2, [0x0067], 0]);
        t.add(0x1d5db, 0x1d5db, [2, [0x0068], 0]);
        t.add(0x1d5dc, 0x1d5dc, [2, [0x0069], 0]);
        t.add(0x1d5dd, 0x1d5dd, [2, [0x006A], 0]);
        t.add(0x1d5de, 0x1d5de, [2, [0x006B], 0]);
        t.add(0x1d5df, 0x1d5df, [2, [0x006C], 0]);
        t.add(0x1d5e0, 0x1d5e0, [2, [0x006D], 0]);
        t.add(0x1d5e1, 0x1d5e1, [2, [0x006E], 0]);
        t.add(0x1d5e2, 0x1d5e2, [2, [0x006F], 0]);
        t.add(0x1d5e3, 0x1d5e3, [2, [0x0070], 0]);
        t.add(0x1d5e4, 0x1d5e4, [2, [0x0071], 0]);
        t.add(0x1d5e5, 0x1d5e5, [2, [0x0072], 0]);
        t.add(0x1d5e6, 0x1d5e6, [2, [0x0073], 0]);
        t.add(0x1d5e7, 0x1d5e7, [2, [0x0074], 0]);
        t.add(0x1d5e8, 0x1d5e8, [2, [0x0075], 0]);
        t.add(0x1d5e9, 0x1d5e9, [2, [0x0076], 0]);
        t.add(0x1d5ea, 0x1d5ea, [2, [0x0077], 0]);
        t.add(0x1d5eb, 0x1d5eb, [2, [0x0078], 0]);
        t.add(0x1d5ec, 0x1d5ec, [2, [0x0079], 0]);
        t.add(0x1d5ed, 0x1d5ed, [2, [0x007A], 0]);
        t.add(0x1d5ee, 0x1d5ee, [2, [0x0061], 0]);
        t.add(0x1d5ef, 0x1d5ef, [2, [0x0062], 0]);
        t.add(0x1d5f0, 0x1d5f0, [2, [0x0063], 0]);
        t.add(0x1d5f1, 0x1d5f1, [2, [0x0064], 0]);
        t.add(0x1d5f2, 0x1d5f2, [2, [0x0065], 0]);
        t.add(0x1d5f3, 0x1d5f3, [2, [0x0066], 0]);
        t.add(0x1d5f4, 0x1d5f4, [2, [0x0067], 0]);
        t.add(0x1d5f5, 0x1d5f5, [2, [0x0068], 0]);
        t.add(0x1d5f6, 0x1d5f6, [2, [0x0069], 0]);
        t.add(0x1d5f7, 0x1d5f7, [2, [0x006A], 0]);
        t.add(0x1d5f8, 0x1d5f8, [2, [0x006B], 0]);
        t.add(0x1d5f9, 0x1d5f9, [2, [0x006C], 0]);
        t.add(0x1d5fa, 0x1d5fa, [2, [0x006D], 0]);
        t.add(0x1d5fb, 0x1d5fb, [2, [0x006E], 0]);
        t.add(0x1d5fc, 0x1d5fc, [2, [0x006F], 0]);
        t.add(0x1d5fd, 0x1d5fd, [2, [0x0070], 0]);
        t.add(0x1d5fe, 0x1d5fe, [2, [0x0071], 0]);
        t.add(0x1d5ff, 0x1d5ff, [2, [0x0072], 0]);
        t.add(0x1d600, 0x1d600, [2, [0x0073], 0]);
        t.add(0x1d601, 0x1d601, [2, [0x0074], 0]);
        t.add(0x1d602, 0x1d602, [2, [0x0075], 0]);
        t.add(0x1d603, 0x1d603, [2, [0x0076], 0]);
        t.add(0x1d604, 0x1d604, [2, [0x0077], 0]);
        t.add(0x1d605, 0x1d605, [2, [0x0078], 0]);
        t.add(0x1d606, 0x1d606, [2, [0x0079], 0]);
        t.add(0x1d607, 0x1d607, [2, [0x007A], 0]);
        t.add(0x1d608, 0x1d608, [2, [0x0061], 0]);
        t.add(0x1d609, 0x1d609, [2, [0x0062], 0]);
        t.add(0x1d60a, 0x1d60a, [2, [0x0063], 0]);
        t.add(0x1d60b, 0x1d60b, [2, [0x0064], 0]);
        t.add(0x1d60c, 0x1d60c, [2, [0x0065], 0]);
        t.add(0x1d60d, 0x1d60d, [2, [0x0066], 0]);
        t.add(0x1d60e, 0x1d60e, [2, [0x0067], 0]);
        t.add(0x1d60f, 0x1d60f, [2, [0x0068], 0]);
        t.add(0x1d610, 0x1d610, [2, [0x0069], 0]);
        t.add(0x1d611, 0x1d611, [2, [0x006A], 0]);
        t.add(0x1d612, 0x1d612, [2, [0x006B], 0]);
        t.add(0x1d613, 0x1d613, [2, [0x006C], 0]);
        t.add(0x1d614, 0x1d614, [2, [0x006D], 0]);
        t.add(0x1d615, 0x1d615, [2, [0x006E], 0]);
        t.add(0x1d616, 0x1d616, [2, [0x006F], 0]);
        t.add(0x1d617, 0x1d617, [2, [0x0070], 0]);
        t.add(0x1d618, 0x1d618, [2, [0x0071], 0]);
        t.add(0x1d619, 0x1d619, [2, [0x0072], 0]);
        t.add(0x1d61a, 0x1d61a, [2, [0x0073], 0]);
        t.add(0x1d61b, 0x1d61b, [2, [0x0074], 0]);
        t.add(0x1d61c, 0x1d61c, [2, [0x0075], 0]);
        t.add(0x1d61d, 0x1d61d, [2, [0x0076], 0]);
        t.add(0x1d61e, 0x1d61e, [2, [0x0077], 0]);
        t.add(0x1d61f, 0x1d61f, [2, [0x0078], 0]);
        t.add(0x1d620, 0x1d620, [2, [0x0079], 0]);
        t.add(0x1d621, 0x1d621, [2, [0x007A], 0]);
        t.add(0x1d622, 0x1d622, [2, [0x0061], 0]);
        t.add(0x1d623, 0x1d623, [2, [0x0062], 0]);
        t.add(0x1d624, 0x1d624, [2, [0x0063], 0]);
        t.add(0x1d625, 0x1d625, [2, [0x0064], 0]);
        t.add(0x1d626, 0x1d626, [2, [0x0065], 0]);
        t.add(0x1d627, 0x1d627, [2, [0x0066], 0]);
        t.add(0x1d628, 0x1d628, [2, [0x0067], 0]);
        t.add(0x1d629, 0x1d629, [2, [0x0068], 0]);
        t.add(0x1d62a, 0x1d62a, [2, [0x0069], 0]);
        t.add(0x1d62b, 0x1d62b, [2, [0x006A], 0]);
        t.add(0x1d62c, 0x1d62c, [2, [0x006B], 0]);
        t.add(0x1d62d, 0x1d62d, [2, [0x006C], 0]);
        t.add(0x1d62e, 0x1d62e, [2, [0x006D], 0]);
        t.add(0x1d62f, 0x1d62f, [2, [0x006E], 0]);
        t.add(0x1d630, 0x1d630, [2, [0x006F], 0]);
        t.add(0x1d631, 0x1d631, [2, [0x0070], 0]);
        t.add(0x1d632, 0x1d632, [2, [0x0071], 0]);
        t.add(0x1d633, 0x1d633, [2, [0x0072], 0]);
        t.add(0x1d634, 0x1d634, [2, [0x0073], 0]);
        t.add(0x1d635, 0x1d635, [2, [0x0074], 0]);
        t.add(0x1d636, 0x1d636, [2, [0x0075], 0]);
        t.add(0x1d637, 0x1d637, [2, [0x0076], 0]);
        t.add(0x1d638, 0x1d638, [2, [0x0077], 0]);
        t.add(0x1d639, 0x1d639, [2, [0x0078], 0]);
        t.add(0x1d63a, 0x1d63a, [2, [0x0079], 0]);
        t.add(0x1d63b, 0x1d63b, [2, [0x007A], 0]);
        t.add(0x1d63c, 0x1d63c, [2, [0x0061], 0]);
        t.add(0x1d63d, 0x1d63d, [2, [0x0062], 0]);
        t.add(0x1d63e, 0x1d63e, [2, [0x0063], 0]);
        t.add(0x1d63f, 0x1d63f, [2, [0x0064], 0]);
        t.add(0x1d640, 0x1d640, [2, [0x0065], 0]);
        t.add(0x1d641, 0x1d641, [2, [0x0066], 0]);
        t.add(0x1d642, 0x1d642, [2, [0x0067], 0]);
        t.add(0x1d643, 0x1d643, [2, [0x0068], 0]);
        t.add(0x1d644, 0x1d644, [2, [0x0069], 0]);
        t.add(0x1d645, 0x1d645, [2, [0x006A], 0]);
        t.add(0x1d646, 0x1d646, [2, [0x006B], 0]);
        t.add(0x1d647, 0x1d647, [2, [0x006C], 0]);
        t.add(0x1d648, 0x1d648, [2, [0x006D], 0]);
        t.add(0x1d649, 0x1d649, [2, [0x006E], 0]);
        t.add(0x1d64a, 0x1d64a, [2, [0x006F], 0]);
        t.add(0x1d64b, 0x1d64b, [2, [0x0070], 0]);
        t.add(0x1d64c, 0x1d64c, [2, [0x0071], 0]);
        t.add(0x1d64d, 0x1d64d, [2, [0x0072], 0]);
        t.add(0x1d64e, 0x1d64e, [2, [0x0073], 0]);
        t.add(0x1d64f, 0x1d64f, [2, [0x0074], 0]);
        t.add(0x1d650, 0x1d650, [2, [0x0075], 0]);
        t.add(0x1d651, 0x1d651, [2, [0x0076], 0]);
        t.add(0x1d652, 0x1d652, [2, [0x0077], 0]);
        t.add(0x1d653, 0x1d653, [2, [0x0078], 0]);
        t.add(0x1d654, 0x1d654, [2, [0x0079], 0]);
        t.add(0x1d655, 0x1d655, [2, [0x007A], 0]);
        t.add(0x1d656, 0x1d656, [2, [0x0061], 0]);
        t.add(0x1d657, 0x1d657, [2, [0x0062], 0]);
        t.add(0x1d658, 0x1d658, [2, [0x0063], 0]);
        t.add(0x1d659, 0x1d659, [2, [0x0064], 0]);
        t.add(0x1d65a, 0x1d65a, [2, [0x0065], 0]);
        t.add(0x1d65b, 0x1d65b, [2, [0x0066], 0]);
        t.add(0x1d65c, 0x1d65c, [2, [0x0067], 0]);
        t.add(0x1d65d, 0x1d65d, [2, [0x0068], 0]);
        t.add(0x1d65e, 0x1d65e, [2, [0x0069], 0]);
        t.add(0x1d65f, 0x1d65f, [2, [0x006A], 0]);
        t.add(0x1d660, 0x1d660, [2, [0x006B], 0]);
        t.add(0x1d661, 0x1d661, [2, [0x006C], 0]);
        t.add(0x1d662, 0x1d662, [2, [0x006D], 0]);
        t.add(0x1d663, 0x1d663, [2, [0x006E], 0]);
        t.add(0x1d664, 0x1d664, [2, [0x006F], 0]);
        t.add(0x1d665, 0x1d665, [2, [0x0070], 0]);
        t.add(0x1d666, 0x1d666, [2, [0x0071], 0]);
        t.add(0x1d667, 0x1d667, [2, [0x0072], 0]);
        t.add(0x1d668, 0x1d668, [2, [0x0073], 0]);
        t.add(0x1d669, 0x1d669, [2, [0x0074], 0]);
        t.add(0x1d66a, 0x1d66a, [2, [0x0075], 0]);
        t.add(0x1d66b, 0x1d66b, [2, [0x0076], 0]);
        t.add(0x1d66c, 0x1d66c, [2, [0x0077], 0]);
        t.add(0x1d66d, 0x1d66d, [2, [0x0078], 0]);
        t.add(0x1d66e, 0x1d66e, [2, [0x0079], 0]);
        t.add(0x1d66f, 0x1d66f, [2, [0x007A], 0]);
        t.add(0x1d670, 0x1d670, [2, [0x0061], 0]);
        t.add(0x1d671, 0x1d671, [2, [0x0062], 0]);
        t.add(0x1d672, 0x1d672, [2, [0x0063], 0]);
        t.add(0x1d673, 0x1d673, [2, [0x0064], 0]);
        t.add(0x1d674, 0x1d674, [2, [0x0065], 0]);
        t.add(0x1d675, 0x1d675, [2, [0x0066], 0]);
        t.add(0x1d676, 0x1d676, [2, [0x0067], 0]);
        t.add(0x1d677, 0x1d677, [2, [0x0068], 0]);
        t.add(0x1d678, 0x1d678, [2, [0x0069], 0]);
        t.add(0x1d679, 0x1d679, [2, [0x006A], 0]);
        t.add(0x1d67a, 0x1d67a, [2, [0x006B], 0]);
        t.add(0x1d67b, 0x1d67b, [2, [0x006C], 0]);
        t.add(0x1d67c, 0x1d67c, [2, [0x006D], 0]);
        t.add(0x1d67d, 0x1d67d, [2, [0x006E], 0]);
        t.add(0x1d67e, 0x1d67e, [2, [0x006F], 0]);
        t.add(0x1d67f, 0x1d67f, [2, [0x0070], 0]);
        t.add(0x1d680, 0x1d680, [2, [0x0071], 0]);
        t.add(0x1d681, 0x1d681, [2, [0x0072], 0]);
        t.add(0x1d682, 0x1d682, [2, [0x0073], 0]);
        t.add(0x1d683, 0x1d683, [2, [0x0074], 0]);
        t.add(0x1d684, 0x1d684, [2, [0x0075], 0]);
        t.add(0x1d685, 0x1d685, [2, [0x0076], 0]);
        t.add(0x1d686, 0x1d686, [2, [0x0077], 0]);
        t.add(0x1d687, 0x1d687, [2, [0x0078], 0]);
        t.add(0x1d688, 0x1d688, [2, [0x0079], 0]);
        t.add(0x1d689, 0x1d689, [2, [0x007A], 0]);
        t.add(0x1d68a, 0x1d68a, [2, [0x0061], 0]);
        t.add(0x1d68b, 0x1d68b, [2, [0x0062], 0]);
        t.add(0x1d68c, 0x1d68c, [2, [0x0063], 0]);
        t.add(0x1d68d, 0x1d68d, [2, [0x0064], 0]);
        t.add(0x1d68e, 0x1d68e, [2, [0x0065], 0]);
        t.add(0x1d68f, 0x1d68f, [2, [0x0066], 0]);
        t.add(0x1d690, 0x1d690, [2, [0x0067], 0]);
        t.add(0x1d691, 0x1d691, [2, [0x0068], 0]);
        t.add(0x1d692, 0x1d692, [2, [0x0069], 0]);
        t.add(0x1d693, 0x1d693, [2, [0x006A], 0]);
        t.add(0x1d694, 0x1d694, [2, [0x006B], 0]);
        t.add(0x1d695, 0x1d695, [2, [0x006C], 0]);
        t.add(0x1d696, 0x1d696, [2, [0x006D], 0]);
        t.add(0x1d697, 0x1d697, [2, [0x006E], 0]);
        t.add(0x1d698, 0x1d698, [2, [0x006F], 0]);
        t.add(0x1d699, 0x1d699, [2, [0x0070], 0]);
        t.add(0x1d69a, 0x1d69a, [2, [0x0071], 0]);
        t.add(0x1d69b, 0x1d69b, [2, [0x0072], 0]);
        t.add(0x1d69c, 0x1d69c, [2, [0x0073], 0]);
        t.add(0x1d69d, 0x1d69d, [2, [0x0074], 0]);
        t.add(0x1d69e, 0x1d69e, [2, [0x0075], 0]);
        t.add(0x1d69f, 0x1d69f, [2, [0x0076], 0]);
        t.add(0x1d6a0, 0x1d6a0, [2, [0x0077], 0]);
        t.add(0x1d6a1, 0x1d6a1, [2, [0x0078], 0]);
        t.add(0x1d6a2, 0x1d6a2, [2, [0x0079], 0]);
        t.add(0x1d6a3, 0x1d6a3, [2, [0x007A], 0]);
        t.add(0x1d6a4, 0x1d6a4, [2, [0x0131], 0]);
        t.add(0x1d6a5, 0x1d6a5, [2, [0x0237], 0]);
        t.add(0x1d6a6, 0x1d6a7, [4, [], 0]);
        t.add(0x1d6a8, 0x1d6a8, [2, [0x03B1], 0]);
        t.add(0x1d6a9, 0x1d6a9, [2, [0x03B2], 0]);
        t.add(0x1d6aa, 0x1d6aa, [2, [0x03B3], 0]);
        t.add(0x1d6ab, 0x1d6ab, [2, [0x03B4], 0]);
        t.add(0x1d6ac, 0x1d6ac, [2, [0x03B5], 0]);
        t.add(0x1d6ad, 0x1d6ad, [2, [0x03B6], 0]);
        t.add(0x1d6ae, 0x1d6ae, [2, [0x03B7], 0]);
        t.add(0x1d6af, 0x1d6af, [2, [0x03B8], 0]);
        t.add(0x1d6b0, 0x1d6b0, [2, [0x03B9], 0]);
        t.add(0x1d6b1, 0x1d6b1, [2, [0x03BA], 0]);
        t.add(0x1d6b2, 0x1d6b2, [2, [0x03BB], 0]);
        t.add(0x1d6b3, 0x1d6b3, [2, [0x03BC], 0]);
        t.add(0x1d6b4, 0x1d6b4, [2, [0x03BD], 0]);
        t.add(0x1d6b5, 0x1d6b5, [2, [0x03BE], 0]);
        t.add(0x1d6b6, 0x1d6b6, [2, [0x03BF], 0]);
        t.add(0x1d6b7, 0x1d6b7, [2, [0x03C0], 0]);
        t.add(0x1d6b8, 0x1d6b8, [2, [0x03C1], 0]);
        t.add(0x1d6b9, 0x1d6b9, [2, [0x03B8], 0]);
        t.add(0x1d6ba, 0x1d6ba, [2, [0x03C3], 0]);
        t.add(0x1d6bb, 0x1d6bb, [2, [0x03C4], 0]);
        t.add(0x1d6bc, 0x1d6bc, [2, [0x03C5], 0]);
        t.add(0x1d6bd, 0x1d6bd, [2, [0x03C6], 0]);
        t.add(0x1d6be, 0x1d6be, [2, [0x03C7], 0]);
        t.add(0x1d6bf, 0x1d6bf, [2, [0x03C8], 0]);
        t.add(0x1d6c0, 0x1d6c0, [2, [0x03C9], 0]);
        t.add(0x1d6c1, 0x1d6c1, [2, [0x2207], 0]);
        t.add(0x1d6c2, 0x1d6c2, [2, [0x03B1], 0]);
        t.add(0x1d6c3, 0x1d6c3, [2, [0x03B2], 0]);
        t.add(0x1d6c4, 0x1d6c4, [2, [0x03B3], 0]);
        t.add(0x1d6c5, 0x1d6c5, [2, [0x03B4], 0]);
        t.add(0x1d6c6, 0x1d6c6, [2, [0x03B5], 0]);
        t.add(0x1d6c7, 0x1d6c7, [2, [0x03B6], 0]);
        t.add(0x1d6c8, 0x1d6c8, [2, [0x03B7], 0]);
        t.add(0x1d6c9, 0x1d6c9, [2, [0x03B8], 0]);
        t.add(0x1d6ca, 0x1d6ca, [2, [0x03B9], 0]);
        t.add(0x1d6cb, 0x1d6cb, [2, [0x03BA], 0]);
        t.add(0x1d6cc, 0x1d6cc, [2, [0x03BB], 0]);
        t.add(0x1d6cd, 0x1d6cd, [2, [0x03BC], 0]);
        t.add(0x1d6ce, 0x1d6ce, [2, [0x03BD], 0]);
        t.add(0x1d6cf, 0x1d6cf, [2, [0x03BE], 0]);
        t.add(0x1d6d0, 0x1d6d0, [2, [0x03BF], 0]);
        t.add(0x1d6d1, 0x1d6d1, [2, [0x03C0], 0]);
        t.add(0x1d6d2, 0x1d6d2, [2, [0x03C1], 0]);
        t.add(0x1d6d3, 0x1d6d4, [2, [0x03C3], 0]);
        t.add(0x1d6d5, 0x1d6d5, [2, [0x03C4], 0]);
        t.add(0x1d6d6, 0x1d6d6, [2, [0x03C5], 0]);
        t.add(0x1d6d7, 0x1d6d7, [2, [0x03C6], 0]);
        t.add(0x1d6d8, 0x1d6d8, [2, [0x03C7], 0]);
        t.add(0x1d6d9, 0x1d6d9, [2, [0x03C8], 0]);
        t.add(0x1d6da, 0x1d6da, [2, [0x03C9], 0]);
        t.add(0x1d6db, 0x1d6db, [2, [0x2202], 0]);
        t.add(0x1d6dc, 0x1d6dc, [2, [0x03B5], 0]);
        t.add(0x1d6dd, 0x1d6dd, [2, [0x03B8], 0]);
        t.add(0x1d6de, 0x1d6de, [2, [0x03BA], 0]);
        t.add(0x1d6df, 0x1d6df, [2, [0x03C6], 0]);
        t.add(0x1d6e0, 0x1d6e0, [2, [0x03C1], 0]);
        t.add(0x1d6e1, 0x1d6e1, [2, [0x03C0], 0]);
        t.add(0x1d6e2, 0x1d6e2, [2, [0x03B1], 0]);
        t.add(0x1d6e3, 0x1d6e3, [2, [0x03B2], 0]);
        t.add(0x1d6e4, 0x1d6e4, [2, [0x03B3], 0]);
        t.add(0x1d6e5, 0x1d6e5, [2, [0x03B4], 0]);
        t.add(0x1d6e6, 0x1d6e6, [2, [0x03B5], 0]);
        t.add(0x1d6e7, 0x1d6e7, [2, [0x03B6], 0]);
        t.add(0x1d6e8, 0x1d6e8, [2, [0x03B7], 0]);
        t.add(0x1d6e9, 0x1d6e9, [2, [0x03B8], 0]);
        t.add(0x1d6ea, 0x1d6ea, [2, [0x03B9], 0]);
        t.add(0x1d6eb, 0x1d6eb, [2, [0x03BA], 0]);
        t.add(0x1d6ec, 0x1d6ec, [2, [0x03BB], 0]);
        t.add(0x1d6ed, 0x1d6ed, [2, [0x03BC], 0]);
        t.add(0x1d6ee, 0x1d6ee, [2, [0x03BD], 0]);
        t.add(0x1d6ef, 0x1d6ef, [2, [0x03BE], 0]);
        t.add(0x1d6f0, 0x1d6f0, [2, [0x03BF], 0]);
        t.add(0x1d6f1, 0x1d6f1, [2, [0x03C0], 0]);
        t.add(0x1d6f2, 0x1d6f2, [2, [0x03C1], 0]);
        t.add(0x1d6f3, 0x1d6f3, [2, [0x03B8], 0]);
        t.add(0x1d6f4, 0x1d6f4, [2, [0x03C3], 0]);
        t.add(0x1d6f5, 0x1d6f5, [2, [0x03C4], 0]);
        t.add(0x1d6f6, 0x1d6f6, [2, [0x03C5], 0]);
        t.add(0x1d6f7, 0x1d6f7, [2, [0x03C6], 0]);
        t.add(0x1d6f8, 0x1d6f8, [2, [0x03C7], 0]);
        t.add(0x1d6f9, 0x1d6f9, [2, [0x03C8], 0]);
        t.add(0x1d6fa, 0x1d6fa, [2, [0x03C9], 0]);
        t.add(0x1d6fb, 0x1d6fb, [2, [0x2207], 0]);
        t.add(0x1d6fc, 0x1d6fc, [2, [0x03B1], 0]);
        t.add(0x1d6fd, 0x1d6fd, [2, [0x03B2], 0]);
        t.add(0x1d6fe, 0x1d6fe, [2, [0x03B3], 0]);
        t.add(0x1d6ff, 0x1d6ff, [2, [0x03B4], 0]);
        t.add(0x1d700, 0x1d700, [2, [0x03B5], 0]);
        t.add(0x1d701, 0x1d701, [2, [0x03B6], 0]);
        t.add(0x1d702, 0x1d702, [2, [0x03B7], 0]);
        t.add(0x1d703, 0x1d703, [2, [0x03B8], 0]);
        t.add(0x1d704, 0x1d704, [2, [0x03B9], 0]);
        t.add(0x1d705, 0x1d705, [2, [0x03BA], 0]);
        t.add(0x1d706, 0x1d706, [2, [0x03BB], 0]);
        t.add(0x1d707, 0x1d707, [2, [0x03BC], 0]);
        t.add(0x1d708, 0x1d708, [2, [0x03BD], 0]);
        t.add(0x1d709, 0x1d709, [2, [0x03BE], 0]);
        t.add(0x1d70a, 0x1d70a, [2, [0x03BF], 0]);
        t.add(0x1d70b, 0x1d70b, [2, [0x03C0], 0]);
        t.add(0x1d70c, 0x1d70c, [2, [0x03C1], 0]);
        t.add(0x1d70d, 0x1d70e, [2, [0x03C3], 0]);
        t.add(0x1d70f, 0x1d70f, [2, [0x03C4], 0]);
        t.add(0x1d710, 0x1d710, [2, [0x03C5], 0]);
        t.add(0x1d711, 0x1d711, [2, [0x03C6], 0]);
        t.add(0x1d712, 0x1d712, [2, [0x03C7], 0]);
        t.add(0x1d713, 0x1d713, [2, [0x03C8], 0]);
        t.add(0x1d714, 0x1d714, [2, [0x03C9], 0]);
        t.add(0x1d715, 0x1d715, [2, [0x2202], 0]);
        t.add(0x1d716, 0x1d716, [2, [0x03B5], 0]);
        t.add(0x1d717, 0x1d717, [2, [0x03B8], 0]);
        t.add(0x1d718, 0x1d718, [2, [0x03BA], 0]);
        t.add(0x1d719, 0x1d719, [2, [0x03C6], 0]);
        t.add(0x1d71a, 0x1d71a, [2, [0x03C1], 0]);
        t.add(0x1d71b, 0x1d71b, [2, [0x03C0], 0]);
        t.add(0x1d71c, 0x1d71c, [2, [0x03B1], 0]);
        t.add(0x1d71d, 0x1d71d, [2, [0x03B2], 0]);
        t.add(0x1d71e, 0x1d71e, [2, [0x03B3], 0]);
        t.add(0x1d71f, 0x1d71f, [2, [0x03B4], 0]);
        t.add(0x1d720, 0x1d720, [2, [0x03B5], 0]);
        t.add(0x1d721, 0x1d721, [2, [0x03B6], 0]);
        t.add(0x1d722, 0x1d722, [2, [0x03B7], 0]);
        t.add(0x1d723, 0x1d723, [2, [0x03B8], 0]);
        t.add(0x1d724, 0x1d724, [2, [0x03B9], 0]);
        t.add(0x1d725, 0x1d725, [2, [0x03BA], 0]);
        t.add(0x1d726, 0x1d726, [2, [0x03BB], 0]);
        t.add(0x1d727, 0x1d727, [2, [0x03BC], 0]);
        t.add(0x1d728, 0x1d728, [2, [0x03BD], 0]);
        t.add(0x1d729, 0x1d729, [2, [0x03BE], 0]);
        t.add(0x1d72a, 0x1d72a, [2, [0x03BF], 0]);
        t.add(0x1d72b, 0x1d72b, [2, [0x03C0], 0]);
        t.add(0x1d72c, 0x1d72c, [2, [0x03C1], 0]);
        t.add(0x1d72d, 0x1d72d, [2, [0x03B8], 0]);
        t.add(0x1d72e, 0x1d72e, [2, [0x03C3], 0]);
        t.add(0x1d72f, 0x1d72f, [2, [0x03C4], 0]);
        t.add(0x1d730, 0x1d730, [2, [0x03C5], 0]);
        t.add(0x1d731, 0x1d731, [2, [0x03C6], 0]);
        t.add(0x1d732, 0x1d732, [2, [0x03C7], 0]);
        t.add(0x1d733, 0x1d733, [2, [0x03C8], 0]);
        t.add(0x1d734, 0x1d734, [2, [0x03C9], 0]);
        t.add(0x1d735, 0x1d735, [2, [0x2207], 0]);
        t.add(0x1d736, 0x1d736, [2, [0x03B1], 0]);
        t.add(0x1d737, 0x1d737, [2, [0x03B2], 0]);
        t.add(0x1d738, 0x1d738, [2, [0x03B3], 0]);
        t.add(0x1d739, 0x1d739, [2, [0x03B4], 0]);
        t.add(0x1d73a, 0x1d73a, [2, [0x03B5], 0]);
        t.add(0x1d73b, 0x1d73b, [2, [0x03B6], 0]);
        t.add(0x1d73c, 0x1d73c, [2, [0x03B7], 0]);
        t.add(0x1d73d, 0x1d73d, [2, [0x03B8], 0]);
        t.add(0x1d73e, 0x1d73e, [2, [0x03B9], 0]);
        t.add(0x1d73f, 0x1d73f, [2, [0x03BA], 0]);
        t.add(0x1d740, 0x1d740, [2, [0x03BB], 0]);
        t.add(0x1d741, 0x1d741, [2, [0x03BC], 0]);
        t.add(0x1d742, 0x1d742, [2, [0x03BD], 0]);
        t.add(0x1d743, 0x1d743, [2, [0x03BE], 0]);
        t.add(0x1d744, 0x1d744, [2, [0x03BF], 0]);
        t.add(0x1d745, 0x1d745, [2, [0x03C0], 0]);
        t.add(0x1d746, 0x1d746, [2, [0x03C1], 0]);
        t.add(0x1d747, 0x1d748, [2, [0x03C3], 0]);
        t.add(0x1d749, 0x1d749, [2, [0x03C4], 0]);
        t.add(0x1d74a, 0x1d74a, [2, [0x03C5], 0]);
        t.add(0x1d74b, 0x1d74b, [2, [0x03C6], 0]);
        t.add(0x1d74c, 0x1d74c, [2, [0x03C7], 0]);
        t.add(0x1d74d, 0x1d74d, [2, [0x03C8], 0]);
        t.add(0x1d74e, 0x1d74e, [2, [0x03C9], 0]);
        t.add(0x1d74f, 0x1d74f, [2, [0x2202], 0]);
        t.add(0x1d750, 0x1d750, [2, [0x03B5], 0]);
        t.add(0x1d751, 0x1d751, [2, [0x03B8], 0]);
        t.add(0x1d752, 0x1d752, [2, [0x03BA], 0]);
        t.add(0x1d753, 0x1d753, [2, [0x03C6], 0]);
        t.add(0x1d754, 0x1d754, [2, [0x03C1], 0]);
        t.add(0x1d755, 0x1d755, [2, [0x03C0], 0]);
        t.add(0x1d756, 0x1d756, [2, [0x03B1], 0]);
        t.add(0x1d757, 0x1d757, [2, [0x03B2], 0]);
        t.add(0x1d758, 0x1d758, [2, [0x03B3], 0]);
        t.add(0x1d759, 0x1d759, [2, [0x03B4], 0]);
        t.add(0x1d75a, 0x1d75a, [2, [0x03B5], 0]);
        t.add(0x1d75b, 0x1d75b, [2, [0x03B6], 0]);
        t.add(0x1d75c, 0x1d75c, [2, [0x03B7], 0]);
        t.add(0x1d75d, 0x1d75d, [2, [0x03B8], 0]);
        t.add(0x1d75e, 0x1d75e, [2, [0x03B9], 0]);
        t.add(0x1d75f, 0x1d75f, [2, [0x03BA], 0]);
        t.add(0x1d760, 0x1d760, [2, [0x03BB], 0]);
        t.add(0x1d761, 0x1d761, [2, [0x03BC], 0]);
        t.add(0x1d762, 0x1d762, [2, [0x03BD], 0]);
        t.add(0x1d763, 0x1d763, [2, [0x03BE], 0]);
        t.add(0x1d764, 0x1d764, [2, [0x03BF], 0]);
        t.add(0x1d765, 0x1d765, [2, [0x03C0], 0]);
        t.add(0x1d766, 0x1d766, [2, [0x03C1], 0]);
        t.add(0x1d767, 0x1d767, [2, [0x03B8], 0]);
        t.add(0x1d768, 0x1d768, [2, [0x03C3], 0]);
        t.add(0x1d769, 0x1d769, [2, [0x03C4], 0]);
        t.add(0x1d76a, 0x1d76a, [2, [0x03C5], 0]);
        t.add(0x1d76b, 0x1d76b, [2, [0x03C6], 0]);
        t.add(0x1d76c, 0x1d76c, [2, [0x03C7], 0]);
        t.add(0x1d76d, 0x1d76d, [2, [0x03C8], 0]);
        t.add(0x1d76e, 0x1d76e, [2, [0x03C9], 0]);
        t.add(0x1d76f, 0x1d76f, [2, [0x2207], 0]);
        t.add(0x1d770, 0x1d770, [2, [0x03B1], 0]);
        t.add(0x1d771, 0x1d771, [2, [0x03B2], 0]);
        t.add(0x1d772, 0x1d772, [2, [0x03B3], 0]);
        t.add(0x1d773, 0x1d773, [2, [0x03B4], 0]);
        t.add(0x1d774, 0x1d774, [2, [0x03B5], 0]);
        t.add(0x1d775, 0x1d775, [2, [0x03B6], 0]);
        t.add(0x1d776, 0x1d776, [2, [0x03B7], 0]);
        t.add(0x1d777, 0x1d777, [2, [0x03B8], 0]);
        t.add(0x1d778, 0x1d778, [2, [0x03B9], 0]);
        t.add(0x1d779, 0x1d779, [2, [0x03BA], 0]);
        t.add(0x1d77a, 0x1d77a, [2, [0x03BB], 0]);
        t.add(0x1d77b, 0x1d77b, [2, [0x03BC], 0]);
        t.add(0x1d77c, 0x1d77c, [2, [0x03BD], 0]);
        t.add(0x1d77d, 0x1d77d, [2, [0x03BE], 0]);
        t.add(0x1d77e, 0x1d77e, [2, [0x03BF], 0]);
        t.add(0x1d77f, 0x1d77f, [2, [0x03C0], 0]);
        t.add(0x1d780, 0x1d780, [2, [0x03C1], 0]);
        t.add(0x1d781, 0x1d782, [2, [0x03C3], 0]);
        t.add(0x1d783, 0x1d783, [2, [0x03C4], 0]);
        t.add(0x1d784, 0x1d784, [2, [0x03C5], 0]);
        t.add(0x1d785, 0x1d785, [2, [0x03C6], 0]);
        t.add(0x1d786, 0x1d786, [2, [0x03C7], 0]);
        t.add(0x1d787, 0x1d787, [2, [0x03C8], 0]);
        t.add(0x1d788, 0x1d788, [2, [0x03C9], 0]);
        t.add(0x1d789, 0x1d789, [2, [0x2202], 0]);
        t.add(0x1d78a, 0x1d78a, [2, [0x03B5], 0]);
        t.add(0x1d78b, 0x1d78b, [2, [0x03B8], 0]);
        t.add(0x1d78c, 0x1d78c, [2, [0x03BA], 0]);
        t.add(0x1d78d, 0x1d78d, [2, [0x03C6], 0]);
        t.add(0x1d78e, 0x1d78e, [2, [0x03C1], 0]);
        t.add(0x1d78f, 0x1d78f, [2, [0x03C0], 0]);
        t.add(0x1d790, 0x1d790, [2, [0x03B1], 0]);
        t.add(0x1d791, 0x1d791, [2, [0x03B2], 0]);
        t.add(0x1d792, 0x1d792, [2, [0x03B3], 0]);
        t.add(0x1d793, 0x1d793, [2, [0x03B4], 0]);
        t.add(0x1d794, 0x1d794, [2, [0x03B5], 0]);
        t.add(0x1d795, 0x1d795, [2, [0x03B6], 0]);
        t.add(0x1d796, 0x1d796, [2, [0x03B7], 0]);
        t.add(0x1d797, 0x1d797, [2, [0x03B8], 0]);
        t.add(0x1d798, 0x1d798, [2, [0x03B9], 0]);
        t.add(0x1d799, 0x1d799, [2, [0x03BA], 0]);
        t.add(0x1d79a, 0x1d79a, [2, [0x03BB], 0]);
        t.add(0x1d79b, 0x1d79b, [2, [0x03BC], 0]);
        t.add(0x1d79c, 0x1d79c, [2, [0x03BD], 0]);
        t.add(0x1d79d, 0x1d79d, [2, [0x03BE], 0]);
        t.add(0x1d79e, 0x1d79e, [2, [0x03BF], 0]);
        t.add(0x1d79f, 0x1d79f, [2, [0x03C0], 0]);
        t.add(0x1d7a0, 0x1d7a0, [2, [0x03C1], 0]);
        t.add(0x1d7a1, 0x1d7a1, [2, [0x03B8], 0]);
        t.add(0x1d7a2, 0x1d7a2, [2, [0x03C3], 0]);
        t.add(0x1d7a3, 0x1d7a3, [2, [0x03C4], 0]);
        t.add(0x1d7a4, 0x1d7a4, [2, [0x03C5], 0]);
        t.add(0x1d7a5, 0x1d7a5, [2, [0x03C6], 0]);
        t.add(0x1d7a6, 0x1d7a6, [2, [0x03C7], 0]);
        t.add(0x1d7a7, 0x1d7a7, [2, [0x03C8], 0]);
        t.add(0x1d7a8, 0x1d7a8, [2, [0x03C9], 0]);
        t.add(0x1d7a9, 0x1d7a9, [2, [0x2207], 0]);
        t.add(0x1d7aa, 0x1d7aa, [2, [0x03B1], 0]);
        t.add(0x1d7ab, 0x1d7ab, [2, [0x03B2], 0]);
        t.add(0x1d7ac, 0x1d7ac, [2, [0x03B3], 0]);
        t.add(0x1d7ad, 0x1d7ad, [2, [0x03B4], 0]);
        t.add(0x1d7ae, 0x1d7ae, [2, [0x03B5], 0]);
        t.add(0x1d7af, 0x1d7af, [2, [0x03B6], 0]);
        t.add(0x1d7b0, 0x1d7b0, [2, [0x03B7], 0]);
        t.add(0x1d7b1, 0x1d7b1, [2, [0x03B8], 0]);
        t.add(0x1d7b2, 0x1d7b2, [2, [0x03B9], 0]);
        t.add(0x1d7b3, 0x1d7b3, [2, [0x03BA], 0]);
        t.add(0x1d7b4, 0x1d7b4, [2, [0x03BB], 0]);
        t.add(0x1d7b5, 0x1d7b5, [2, [0x03BC], 0]);
        t.add(0x1d7b6, 0x1d7b6, [2, [0x03BD], 0]);
        t.add(0x1d7b7, 0x1d7b7, [2, [0x03BE], 0]);
        t.add(0x1d7b8, 0x1d7b8, [2, [0x03BF], 0]);
        t.add(0x1d7b9, 0x1d7b9, [2, [0x03C0], 0]);
        t.add(0x1d7ba, 0x1d7ba, [2, [0x03C1], 0]);
        t.add(0x1d7bb, 0x1d7bc, [2, [0x03C3], 0]);
        t.add(0x1d7bd, 0x1d7bd, [2, [0x03C4], 0]);
        t.add(0x1d7be, 0x1d7be, [2, [0x03C5], 0]);
        t.add(0x1d7bf, 0x1d7bf, [2, [0x03C6], 0]);
        t.add(0x1d7c0, 0x1d7c0, [2, [0x03C7], 0]);
        t.add(0x1d7c1, 0x1d7c1, [2, [0x03C8], 0]);
        t.add(0x1d7c2, 0x1d7c2, [2, [0x03C9], 0]);
        t.add(0x1d7c3, 0x1d7c3, [2, [0x2202], 0]);
        t.add(0x1d7c4, 0x1d7c4, [2, [0x03B5], 0]);
        t.add(0x1d7c5, 0x1d7c5, [2, [0x03B8], 0]);
        t.add(0x1d7c6, 0x1d7c6, [2, [0x03BA], 0]);
        t.add(0x1d7c7, 0x1d7c7, [2, [0x03C6], 0]);
        t.add(0x1d7c8, 0x1d7c8, [2, [0x03C1], 0]);
        t.add(0x1d7c9, 0x1d7c9, [2, [0x03C0], 0]);
        t.add(0x1d7ca, 0x1d7cb, [2, [0x03DD], 0]);
        t.add(0x1d7cc, 0x1d7cd, [4, [], 0]);
        t.add(0x1d7ce, 0x1d7ce, [2, [0x0030], 0]);
        t.add(0x1d7cf, 0x1d7cf, [2, [0x0031], 0]);
        t.add(0x1d7d0, 0x1d7d0, [2, [0x0032], 0]);
        t.add(0x1d7d1, 0x1d7d1, [2, [0x0033], 0]);
        t.add(0x1d7d2, 0x1d7d2, [2, [0x0034], 0]);
        t.add(0x1d7d3, 0x1d7d3, [2, [0x0035], 0]);
        t.add(0x1d7d4, 0x1d7d4, [2, [0x0036], 0]);
        t.add(0x1d7d5, 0x1d7d5, [2, [0x0037], 0]);
        t.add(0x1d7d6, 0x1d7d6, [2, [0x0038], 0]);
        t.add(0x1d7d7, 0x1d7d7, [2, [0x0039], 0]);
        t.add(0x1d7d8, 0x1d7d8, [2, [0x0030], 0]);
        t.add(0x1d7d9, 0x1d7d9, [2, [0x0031], 0]);
        t.add(0x1d7da, 0x1d7da, [2, [0x0032], 0]);
        t.add(0x1d7db, 0x1d7db, [2, [0x0033], 0]);
        t.add(0x1d7dc, 0x1d7dc, [2, [0x0034], 0]);
        t.add(0x1d7dd, 0x1d7dd, [2, [0x0035], 0]);
        t.add(0x1d7de, 0x1d7de, [2, [0x0036], 0]);
        t.add(0x1d7df, 0x1d7df, [2, [0x0037], 0]);
        t.add(0x1d7e0, 0x1d7e0, [2, [0x0038], 0]);
        t.add(0x1d7e1, 0x1d7e1, [2, [0x0039], 0]);
        t.add(0x1d7e2, 0x1d7e2, [2, [0x0030], 0]);
        t.add(0x1d7e3, 0x1d7e3, [2, [0x0031], 0]);
        t.add(0x1d7e4, 0x1d7e4, [2, [0x0032], 0]);
        t.add(0x1d7e5, 0x1d7e5, [2, [0x0033], 0]);
        t.add(0x1d7e6, 0x1d7e6, [2, [0x0034], 0]);
        t.add(0x1d7e7, 0x1d7e7, [2, [0x0035], 0]);
        t.add(0x1d7e8, 0x1d7e8, [2, [0x0036], 0]);
        t.add(0x1d7e9, 0x1d7e9, [2, [0x0037], 0]);
        t.add(0x1d7ea, 0x1d7ea, [2, [0x0038], 0]);
        t.add(0x1d7eb, 0x1d7eb, [2, [0x0039], 0]);
        t.add(0x1d7ec, 0x1d7ec, [2, [0x0030], 0]);
        t.add(0x1d7ed, 0x1d7ed, [2, [0x0031], 0]);
        t.add(0x1d7ee, 0x1d7ee, [2, [0x0032], 0]);
        t.add(0x1d7ef, 0x1d7ef, [2, [0x0033], 0]);
        t.add(0x1d7f0, 0x1d7f0, [2, [0x0034], 0]);
        t.add(0x1d7f1, 0x1d7f1, [2, [0x0035], 0]);
        t.add(0x1d7f2, 0x1d7f2, [2, [0x0036], 0]);
        t.add(0x1d7f3, 0x1d7f3, [2, [0x0037], 0]);
        t.add(0x1d7f4, 0x1d7f4, [2, [0x0038], 0]);
        t.add(0x1d7f5, 0x1d7f5, [2, [0x0039], 0]);
        t.add(0x1d7f6, 0x1d7f6, [2, [0x0030], 0]);
        t.add(0x1d7f7, 0x1d7f7, [2, [0x0031], 0]);
        t.add(0x1d7f8, 0x1d7f8, [2, [0x0032], 0]);
        t.add(0x1d7f9, 0x1d7f9, [2, [0x0033], 0]);
        t.add(0x1d7fa, 0x1d7fa, [2, [0x0034], 0]);
        t.add(0x1d7fb, 0x1d7fb, [2, [0x0035], 0]);
        t.add(0x1d7fc, 0x1d7fc, [2, [0x0036], 0]);
        t.add(0x1d7fd, 0x1d7fd, [2, [0x0037], 0]);
        t.add(0x1d7fe, 0x1d7fe, [2, [0x0038], 0]);
        t.add(0x1d7ff, 0x1d7ff, [2, [0x0039], 0]);
        t.add(0x1d800, 0x1d9ff, [0, [], 1]);
        t.add(0x1da00, 0x1da36, [0, [], 0]);
        t.add(0x1da37, 0x1da3a, [0, [], 1]);
        t.add(0x1da3b, 0x1da6c, [0, [], 0]);
        t.add(0x1da6d, 0x1da74, [0, [], 1]);
        t.add(0x1da75, 0x1da75, [0, [], 0]);
        t.add(0x1da76, 0x1da83, [0, [], 1]);
        t.add(0x1da84, 0x1da84, [0, [], 0]);
        t.add(0x1da85, 0x1da8b, [0, [], 1]);
        t.add(0x1da8c, 0x1da9a, [4, [], 0]);
        t.add(0x1da9b, 0x1da9f, [0, [], 0]);
        t.add(0x1daa0, 0x1daa0, [4, [], 0]);
        t.add(0x1daa1, 0x1daaf, [0, [], 0]);
        t.add(0x1dab0, 0x1dfff, [4, [], 0]);
        t.add(0x1e000, 0x1e006, [0, [], 0]);
        t.add(0x1e007, 0x1e007, [4, [], 0]);
        t.add(0x1e008, 0x1e018, [0, [], 0]);
        t.add(0x1e019, 0x1e01a, [4, [], 0]);
        t.add(0x1e01b, 0x1e021, [0, [], 0]);
        t.add(0x1e022, 0x1e022, [4, [], 0]);
        t.add(0x1e023, 0x1e024, [0, [], 0]);
        t.add(0x1e025, 0x1e025, [4, [], 0]);
        t.add(0x1e026, 0x1e02a, [0, [], 0]);
        t.add(0x1e02b, 0x1e0ff, [4, [], 0]);
        t.add(0x1e100, 0x1e12c, [0, [], 0]);
        t.add(0x1e12d, 0x1e12f, [4, [], 0]);
        t.add(0x1e130, 0x1e13d, [0, [], 0]);
        t.add(0x1e13e, 0x1e13f, [4, [], 0]);
        t.add(0x1e140, 0x1e149, [0, [], 0]);
        t.add(0x1e14a, 0x1e14d, [4, [], 0]);
        t.add(0x1e14e, 0x1e14e, [0, [], 0]);
        t.add(0x1e14f, 0x1e14f, [0, [], 1]);
        t.add(0x1e150, 0x1e2bf, [4, [], 0]);
        t.add(0x1e2c0, 0x1e2f9, [0, [], 0]);
        t.add(0x1e2fa, 0x1e2fe, [4, [], 0]);
        t.add(0x1e2ff, 0x1e2ff, [0, [], 1]);
        t.add(0x1e300, 0x1e7ff, [4, [], 0]);
        t.add(0x1e800, 0x1e8c4, [0, [], 0]);
        t.add(0x1e8c5, 0x1e8c6, [4, [], 0]);
        t.add(0x1e8c7, 0x1e8cf, [0, [], 1]);
        t.add(0x1e8d0, 0x1e8d6, [0, [], 0]);
        t.add(0x1e8d7, 0x1e8ff, [4, [], 0]);
        t.add(0x1e900, 0x1e900, [2, [0x1E922], 0]);
        t.add(0x1e901, 0x1e901, [2, [0x1E923], 0]);
        t.add(0x1e902, 0x1e902, [2, [0x1E924], 0]);
        t.add(0x1e903, 0x1e903, [2, [0x1E925], 0]);
        t.add(0x1e904, 0x1e904, [2, [0x1E926], 0]);
        t.add(0x1e905, 0x1e905, [2, [0x1E927], 0]);
        t.add(0x1e906, 0x1e906, [2, [0x1E928], 0]);
        t.add(0x1e907, 0x1e907, [2, [0x1E929], 0]);
        t.add(0x1e908, 0x1e908, [2, [0x1E92A], 0]);
        t.add(0x1e909, 0x1e909, [2, [0x1E92B], 0]);
        t.add(0x1e90a, 0x1e90a, [2, [0x1E92C], 0]);
        t.add(0x1e90b, 0x1e90b, [2, [0x1E92D], 0]);
        t.add(0x1e90c, 0x1e90c, [2, [0x1E92E], 0]);
        t.add(0x1e90d, 0x1e90d, [2, [0x1E92F], 0]);
        t.add(0x1e90e, 0x1e90e, [2, [0x1E930], 0]);
        t.add(0x1e90f, 0x1e90f, [2, [0x1E931], 0]);
        t.add(0x1e910, 0x1e910, [2, [0x1E932], 0]);
        t.add(0x1e911, 0x1e911, [2, [0x1E933], 0]);
        t.add(0x1e912, 0x1e912, [2, [0x1E934], 0]);
        t.add(0x1e913, 0x1e913, [2, [0x1E935], 0]);
        t.add(0x1e914, 0x1e914, [2, [0x1E936], 0]);
        t.add(0x1e915, 0x1e915, [2, [0x1E937], 0]);
        t.add(0x1e916, 0x1e916, [2, [0x1E938], 0]);
        t.add(0x1e917, 0x1e917, [2, [0x1E939], 0]);
        t.add(0x1e918, 0x1e918, [2, [0x1E93A], 0]);
        t.add(0x1e919, 0x1e919, [2, [0x1E93B], 0]);
        t.add(0x1e91a, 0x1e91a, [2, [0x1E93C], 0]);
        t.add(0x1e91b, 0x1e91b, [2, [0x1E93D], 0]);
        t.add(0x1e91c, 0x1e91c, [2, [0x1E93E], 0]);
        t.add(0x1e91d, 0x1e91d, [2, [0x1E93F], 0]);
        t.add(0x1e91e, 0x1e91e, [2, [0x1E940], 0]);
        t.add(0x1e91f, 0x1e91f, [2, [0x1E941], 0]);
        t.add(0x1e920, 0x1e920, [2, [0x1E942], 0]);
        t.add(0x1e921, 0x1e921, [2, [0x1E943], 0]);
        t.add(0x1e922, 0x1e94a, [0, [], 0]);
        t.add(0x1e94b, 0x1e94b, [0, [], 0]);
        t.add(0x1e94c, 0x1e94f, [4, [], 0]);
        t.add(0x1e950, 0x1e959, [0, [], 0]);
        t.add(0x1e95a, 0x1e95d, [4, [], 0]);
        t.add(0x1e95e, 0x1e95f, [0, [], 1]);
        t.add(0x1e960, 0x1ec70, [4, [], 0]);
        t.add(0x1ec71, 0x1ecb4, [0, [], 1]);
        t.add(0x1ecb5, 0x1ed00, [4, [], 0]);
        t.add(0x1ed01, 0x1ed3d, [0, [], 1]);
        t.add(0x1ed3e, 0x1edff, [4, [], 0]);
        t.add(0x1ee00, 0x1ee00, [2, [0x0627], 0]);
        t.add(0x1ee01, 0x1ee01, [2, [0x0628], 0]);
        t.add(0x1ee02, 0x1ee02, [2, [0x062C], 0]);
        t.add(0x1ee03, 0x1ee03, [2, [0x062F], 0]);
        t.add(0x1ee04, 0x1ee04, [4, [], 0]);
        t.add(0x1ee05, 0x1ee05, [2, [0x0648], 0]);
        t.add(0x1ee06, 0x1ee06, [2, [0x0632], 0]);
        t.add(0x1ee07, 0x1ee07, [2, [0x062D], 0]);
        t.add(0x1ee08, 0x1ee08, [2, [0x0637], 0]);
        t.add(0x1ee09, 0x1ee09, [2, [0x064A], 0]);
        t.add(0x1ee0a, 0x1ee0a, [2, [0x0643], 0]);
        t.add(0x1ee0b, 0x1ee0b, [2, [0x0644], 0]);
        t.add(0x1ee0c, 0x1ee0c, [2, [0x0645], 0]);
        t.add(0x1ee0d, 0x1ee0d, [2, [0x0646], 0]);
        t.add(0x1ee0e, 0x1ee0e, [2, [0x0633], 0]);
        t.add(0x1ee0f, 0x1ee0f, [2, [0x0639], 0]);
        t.add(0x1ee10, 0x1ee10, [2, [0x0641], 0]);
        t.add(0x1ee11, 0x1ee11, [2, [0x0635], 0]);
        t.add(0x1ee12, 0x1ee12, [2, [0x0642], 0]);
        t.add(0x1ee13, 0x1ee13, [2, [0x0631], 0]);
        t.add(0x1ee14, 0x1ee14, [2, [0x0634], 0]);
        t.add(0x1ee15, 0x1ee15, [2, [0x062A], 0]);
        t.add(0x1ee16, 0x1ee16, [2, [0x062B], 0]);
        t.add(0x1ee17, 0x1ee17, [2, [0x062E], 0]);
        t.add(0x1ee18, 0x1ee18, [2, [0x0630], 0]);
        t.add(0x1ee19, 0x1ee19, [2, [0x0636], 0]);
        t.add(0x1ee1a, 0x1ee1a, [2, [0x0638], 0]);
        t.add(0x1ee1b, 0x1ee1b, [2, [0x063A], 0]);
        t.add(0x1ee1c, 0x1ee1c, [2, [0x066E], 0]);
        t.add(0x1ee1d, 0x1ee1d, [2, [0x06BA], 0]);
        t.add(0x1ee1e, 0x1ee1e, [2, [0x06A1], 0]);
        t.add(0x1ee1f, 0x1ee1f, [2, [0x066F], 0]);
        t.add(0x1ee20, 0x1ee20, [4, [], 0]);
        t.add(0x1ee21, 0x1ee21, [2, [0x0628], 0]);
        t.add(0x1ee22, 0x1ee22, [2, [0x062C], 0]);
        t.add(0x1ee23, 0x1ee23, [4, [], 0]);
        t.add(0x1ee24, 0x1ee24, [2, [0x0647], 0]);
        t.add(0x1ee25, 0x1ee26, [4, [], 0]);
        t.add(0x1ee27, 0x1ee27, [2, [0x062D], 0]);
        t.add(0x1ee28, 0x1ee28, [4, [], 0]);
        t.add(0x1ee29, 0x1ee29, [2, [0x064A], 0]);
        t.add(0x1ee2a, 0x1ee2a, [2, [0x0643], 0]);
        t.add(0x1ee2b, 0x1ee2b, [2, [0x0644], 0]);
        t.add(0x1ee2c, 0x1ee2c, [2, [0x0645], 0]);
        t.add(0x1ee2d, 0x1ee2d, [2, [0x0646], 0]);
        t.add(0x1ee2e, 0x1ee2e, [2, [0x0633], 0]);
        t.add(0x1ee2f, 0x1ee2f, [2, [0x0639], 0]);
        t.add(0x1ee30, 0x1ee30, [2, [0x0641], 0]);
        t.add(0x1ee31, 0x1ee31, [2, [0x0635], 0]);
        t.add(0x1ee32, 0x1ee32, [2, [0x0642], 0]);
        t.add(0x1ee33, 0x1ee33, [4, [], 0]);
        t.add(0x1ee34, 0x1ee34, [2, [0x0634], 0]);
        t.add(0x1ee35, 0x1ee35, [2, [0x062A], 0]);
        t.add(0x1ee36, 0x1ee36, [2, [0x062B], 0]);
        t.add(0x1ee37, 0x1ee37, [2, [0x062E], 0]);
        t.add(0x1ee38, 0x1ee38, [4, [], 0]);
        t.add(0x1ee39, 0x1ee39, [2, [0x0636], 0]);
        t.add(0x1ee3a, 0x1ee3a, [4, [], 0]);
        t.add(0x1ee3b, 0x1ee3b, [2, [0x063A], 0]);
        t.add(0x1ee3c, 0x1ee41, [4, [], 0]);
        t.add(0x1ee42, 0x1ee42, [2, [0x062C], 0]);
        t.add(0x1ee43, 0x1ee46, [4, [], 0]);
        t.add(0x1ee47, 0x1ee47, [2, [0x062D], 0]);
        t.add(0x1ee48, 0x1ee48, [4, [], 0]);
        t.add(0x1ee49, 0x1ee49, [2, [0x064A], 0]);
        t.add(0x1ee4a, 0x1ee4a, [4, [], 0]);
        t.add(0x1ee4b, 0x1ee4b, [2, [0x0644], 0]);
        t.add(0x1ee4c, 0x1ee4c, [4, [], 0]);
        t.add(0x1ee4d, 0x1ee4d, [2, [0x0646], 0]);
        t.add(0x1ee4e, 0x1ee4e, [2, [0x0633], 0]);
        t.add(0x1ee4f, 0x1ee4f, [2, [0x0639], 0]);
        t.add(0x1ee50, 0x1ee50, [4, [], 0]);
        t.add(0x1ee51, 0x1ee51, [2, [0x0635], 0]);
        t.add(0x1ee52, 0x1ee52, [2, [0x0642], 0]);
        t.add(0x1ee53, 0x1ee53, [4, [], 0]);
        t.add(0x1ee54, 0x1ee54, [2, [0x0634], 0]);
        t.add(0x1ee55, 0x1ee56, [4, [], 0]);
        t.add(0x1ee57, 0x1ee57, [2, [0x062E], 0]);
        t.add(0x1ee58, 0x1ee58, [4, [], 0]);
        t.add(0x1ee59, 0x1ee59, [2, [0x0636], 0]);
        t.add(0x1ee5a, 0x1ee5a, [4, [], 0]);
        t.add(0x1ee5b, 0x1ee5b, [2, [0x063A], 0]);
        t.add(0x1ee5c, 0x1ee5c, [4, [], 0]);
        t.add(0x1ee5d, 0x1ee5d, [2, [0x06BA], 0]);
        t.add(0x1ee5e, 0x1ee5e, [4, [], 0]);
        t.add(0x1ee5f, 0x1ee5f, [2, [0x066F], 0]);
        t.add(0x1ee60, 0x1ee60, [4, [], 0]);
        t.add(0x1ee61, 0x1ee61, [2, [0x0628], 0]);
        t.add(0x1ee62, 0x1ee62, [2, [0x062C], 0]);
        t.add(0x1ee63, 0x1ee63, [4, [], 0]);
        t.add(0x1ee64, 0x1ee64, [2, [0x0647], 0]);
        t.add(0x1ee65, 0x1ee66, [4, [], 0]);
        t.add(0x1ee67, 0x1ee67, [2, [0x062D], 0]);
        t.add(0x1ee68, 0x1ee68, [2, [0x0637], 0]);
        t.add(0x1ee69, 0x1ee69, [2, [0x064A], 0]);
        t.add(0x1ee6a, 0x1ee6a, [2, [0x0643], 0]);
        t.add(0x1ee6b, 0x1ee6b, [4, [], 0]);
        t.add(0x1ee6c, 0x1ee6c, [2, [0x0645], 0]);
        t.add(0x1ee6d, 0x1ee6d, [2, [0x0646], 0]);
        t.add(0x1ee6e, 0x1ee6e, [2, [0x0633], 0]);
        t.add(0x1ee6f, 0x1ee6f, [2, [0x0639], 0]);
        t.add(0x1ee70, 0x1ee70, [2, [0x0641], 0]);
        t.add(0x1ee71, 0x1ee71, [2, [0x0635], 0]);
        t.add(0x1ee72, 0x1ee72, [2, [0x0642], 0]);
        t.add(0x1ee73, 0x1ee73, [4, [], 0]);
        t.add(0x1ee74, 0x1ee74, [2, [0x0634], 0]);
        t.add(0x1ee75, 0x1ee75, [2, [0x062A], 0]);
        t.add(0x1ee76, 0x1ee76, [2, [0x062B], 0]);
        t.add(0x1ee77, 0x1ee77, [2, [0x062E], 0]);
        t.add(0x1ee78, 0x1ee78, [4, [], 0]);
        t.add(0x1ee79, 0x1ee79, [2, [0x0636], 0]);
        t.add(0x1ee7a, 0x1ee7a, [2, [0x0638], 0]);
        t.add(0x1ee7b, 0x1ee7b, [2, [0x063A], 0]);
        t.add(0x1ee7c, 0x1ee7c, [2, [0x066E], 0]);
        t.add(0x1ee7d, 0x1ee7d, [4, [], 0]);
        t.add(0x1ee7e, 0x1ee7e, [2, [0x06A1], 0]);
        t.add(0x1ee7f, 0x1ee7f, [4, [], 0]);
        t.add(0x1ee80, 0x1ee80, [2, [0x0627], 0]);
        t.add(0x1ee81, 0x1ee81, [2, [0x0628], 0]);
        t.add(0x1ee82, 0x1ee82, [2, [0x062C], 0]);
        t.add(0x1ee83, 0x1ee83, [2, [0x062F], 0]);
        t.add(0x1ee84, 0x1ee84, [2, [0x0647], 0]);
        t.add(0x1ee85, 0x1ee85, [2, [0x0648], 0]);
        t.add(0x1ee86, 0x1ee86, [2, [0x0632], 0]);
        t.add(0x1ee87, 0x1ee87, [2, [0x062D], 0]);
        t.add(0x1ee88, 0x1ee88, [2, [0x0637], 0]);
        t.add(0x1ee89, 0x1ee89, [2, [0x064A], 0]);
        t.add(0x1ee8a, 0x1ee8a, [4, [], 0]);
        t.add(0x1ee8b, 0x1ee8b, [2, [0x0644], 0]);
        t.add(0x1ee8c, 0x1ee8c, [2, [0x0645], 0]);
        t.add(0x1ee8d, 0x1ee8d, [2, [0x0646], 0]);
        t.add(0x1ee8e, 0x1ee8e, [2, [0x0633], 0]);
        t.add(0x1ee8f, 0x1ee8f, [2, [0x0639], 0]);
        t.add(0x1ee90, 0x1ee90, [2, [0x0641], 0]);
        t.add(0x1ee91, 0x1ee91, [2, [0x0635], 0]);
        t.add(0x1ee92, 0x1ee92, [2, [0x0642], 0]);
        t.add(0x1ee93, 0x1ee93, [2, [0x0631], 0]);
        t.add(0x1ee94, 0x1ee94, [2, [0x0634], 0]);
        t.add(0x1ee95, 0x1ee95, [2, [0x062A], 0]);
        t.add(0x1ee96, 0x1ee96, [2, [0x062B], 0]);
        t.add(0x1ee97, 0x1ee97, [2, [0x062E], 0]);
        t.add(0x1ee98, 0x1ee98, [2, [0x0630], 0]);
        t.add(0x1ee99, 0x1ee99, [2, [0x0636], 0]);
        t.add(0x1ee9a, 0x1ee9a, [2, [0x0638], 0]);
        t.add(0x1ee9b, 0x1ee9b, [2, [0x063A], 0]);
        t.add(0x1ee9c, 0x1eea0, [4, [], 0]);
        t.add(0x1eea1, 0x1eea1, [2, [0x0628], 0]);
        t.add(0x1eea2, 0x1eea2, [2, [0x062C], 0]);
        t.add(0x1eea3, 0x1eea3, [2, [0x062F], 0]);
        t.add(0x1eea4, 0x1eea4, [4, [], 0]);
        t.add(0x1eea5, 0x1eea5, [2, [0x0648], 0]);
        t.add(0x1eea6, 0x1eea6, [2, [0x0632], 0]);
        t.add(0x1eea7, 0x1eea7, [2, [0x062D], 0]);
        t.add(0x1eea8, 0x1eea8, [2, [0x0637], 0]);
        t.add(0x1eea9, 0x1eea9, [2, [0x064A], 0]);
        t.add(0x1eeaa, 0x1eeaa, [4, [], 0]);
        t.add(0x1eeab, 0x1eeab, [2, [0x0644], 0]);
        t.add(0x1eeac, 0x1eeac, [2, [0x0645], 0]);
        t.add(0x1eead, 0x1eead, [2, [0x0646], 0]);
        t.add(0x1eeae, 0x1eeae, [2, [0x0633], 0]);
        t.add(0x1eeaf, 0x1eeaf, [2, [0x0639], 0]);
        t.add(0x1eeb0, 0x1eeb0, [2, [0x0641], 0]);
        t.add(0x1eeb1, 0x1eeb1, [2, [0x0635], 0]);
        t.add(0x1eeb2, 0x1eeb2, [2, [0x0642], 0]);
        t.add(0x1eeb3, 0x1eeb3, [2, [0x0631], 0]);
        t.add(0x1eeb4, 0x1eeb4, [2, [0x0634], 0]);
        t.add(0x1eeb5, 0x1eeb5, [2, [0x062A], 0]);
        t.add(0x1eeb6, 0x1eeb6, [2, [0x062B], 0]);
        t.add(0x1eeb7, 0x1eeb7, [2, [0x062E], 0]);
        t.add(0x1eeb8, 0x1eeb8, [2, [0x0630], 0]);
        t.add(0x1eeb9, 0x1eeb9, [2, [0x0636], 0]);
        t.add(0x1eeba, 0x1eeba, [2, [0x0638], 0]);
        t.add(0x1eebb, 0x1eebb, [2, [0x063A], 0]);
        t.add(0x1eebc, 0x1eeef, [4, [], 0]);
        t.add(0x1eef0, 0x1eef1, [0, [], 1]);
        t.add(0x1eef2, 0x1efff, [4, [], 0]);
        t.add(0x1f000, 0x1f02b, [0, [], 1]);
        t.add(0x1f02c, 0x1f02f, [4, [], 0]);
        t.add(0x1f030, 0x1f093, [0, [], 1]);
        t.add(0x1f094, 0x1f09f, [4, [], 0]);
        t.add(0x1f0a0, 0x1f0ae, [0, [], 1]);
        t.add(0x1f0af, 0x1f0b0, [4, [], 0]);
        t.add(0x1f0b1, 0x1f0be, [0, [], 1]);
        t.add(0x1f0bf, 0x1f0bf, [0, [], 1]);
        t.add(0x1f0c0, 0x1f0c0, [4, [], 0]);
        t.add(0x1f0c1, 0x1f0cf, [0, [], 1]);
        t.add(0x1f0d0, 0x1f0d0, [4, [], 0]);
        t.add(0x1f0d1, 0x1f0df, [0, [], 1]);
        t.add(0x1f0e0, 0x1f0f5, [0, [], 1]);
        t.add(0x1f0f6, 0x1f0ff, [4, [], 0]);
        t.add(0x1f100, 0x1f100, [4, [], 0]);
        t.add(0x1f101, 0x1f101, [6, [0x0030, 0x002C], 0]);
        t.add(0x1f102, 0x1f102, [6, [0x0031, 0x002C], 0]);
        t.add(0x1f103, 0x1f103, [6, [0x0032, 0x002C], 0]);
        t.add(0x1f104, 0x1f104, [6, [0x0033, 0x002C], 0]);
        t.add(0x1f105, 0x1f105, [6, [0x0034, 0x002C], 0]);
        t.add(0x1f106, 0x1f106, [6, [0x0035, 0x002C], 0]);
        t.add(0x1f107, 0x1f107, [6, [0x0036, 0x002C], 0]);
        t.add(0x1f108, 0x1f108, [6, [0x0037, 0x002C], 0]);
        t.add(0x1f109, 0x1f109, [6, [0x0038, 0x002C], 0]);
        t.add(0x1f10a, 0x1f10a, [6, [0x0039, 0x002C], 0]);
        t.add(0x1f10b, 0x1f10c, [0, [], 1]);
        t.add(0x1f10d, 0x1f10f, [4, [], 0]);
        t.add(0x1f110, 0x1f110, [6, [0x0028, 0x0061, 0x0029], 0]);
        t.add(0x1f111, 0x1f111, [6, [0x0028, 0x0062, 0x0029], 0]);
        t.add(0x1f112, 0x1f112, [6, [0x0028, 0x0063, 0x0029], 0]);
        t.add(0x1f113, 0x1f113, [6, [0x0028, 0x0064, 0x0029], 0]);
        t.add(0x1f114, 0x1f114, [6, [0x0028, 0x0065, 0x0029], 0]);
        t.add(0x1f115, 0x1f115, [6, [0x0028, 0x0066, 0x0029], 0]);
        t.add(0x1f116, 0x1f116, [6, [0x0028, 0x0067, 0x0029], 0]);
        t.add(0x1f117, 0x1f117, [6, [0x0028, 0x0068, 0x0029], 0]);
        t.add(0x1f118, 0x1f118, [6, [0x0028, 0x0069, 0x0029], 0]);
        t.add(0x1f119, 0x1f119, [6, [0x0028, 0x006A, 0x0029], 0]);
        t.add(0x1f11a, 0x1f11a, [6, [0x0028, 0x006B, 0x0029], 0]);
        t.add(0x1f11b, 0x1f11b, [6, [0x0028, 0x006C, 0x0029], 0]);
        t.add(0x1f11c, 0x1f11c, [6, [0x0028, 0x006D, 0x0029], 0]);
        t.add(0x1f11d, 0x1f11d, [6, [0x0028, 0x006E, 0x0029], 0]);
        t.add(0x1f11e, 0x1f11e, [6, [0x0028, 0x006F, 0x0029], 0]);
        t.add(0x1f11f, 0x1f11f, [6, [0x0028, 0x0070, 0x0029], 0]);
        t.add(0x1f120, 0x1f120, [6, [0x0028, 0x0071, 0x0029], 0]);
        t.add(0x1f121, 0x1f121, [6, [0x0028, 0x0072, 0x0029], 0]);
        t.add(0x1f122, 0x1f122, [6, [0x0028, 0x0073, 0x0029], 0]);
        t.add(0x1f123, 0x1f123, [6, [0x0028, 0x0074, 0x0029], 0]);
        t.add(0x1f124, 0x1f124, [6, [0x0028, 0x0075, 0x0029], 0]);
        t.add(0x1f125, 0x1f125, [6, [0x0028, 0x0076, 0x0029], 0]);
        t.add(0x1f126, 0x1f126, [6, [0x0028, 0x0077, 0x0029], 0]);
        t.add(0x1f127, 0x1f127, [6, [0x0028, 0x0078, 0x0029], 0]);
        t.add(0x1f128, 0x1f128, [6, [0x0028, 0x0079, 0x0029], 0]);
        t.add(0x1f129, 0x1f129, [6, [0x0028, 0x007A, 0x0029], 0]);
        t.add(0x1f12a, 0x1f12a, [2, [0x3014, 0x0073, 0x3015], 0]);
        t.add(0x1f12b, 0x1f12b, [2, [0x0063], 0]);
        t.add(0x1f12c, 0x1f12c, [2, [0x0072], 0]);
        t.add(0x1f12d, 0x1f12d, [2, [0x0063, 0x0064], 0]);
        t.add(0x1f12e, 0x1f12e, [2, [0x0077, 0x007A], 0]);
        t.add(0x1f12f, 0x1f12f, [0, [], 1]);
        t.add(0x1f130, 0x1f130, [2, [0x0061], 0]);
        t.add(0x1f131, 0x1f131, [2, [0x0062], 0]);
        t.add(0x1f132, 0x1f132, [2, [0x0063], 0]);
        t.add(0x1f133, 0x1f133, [2, [0x0064], 0]);
        t.add(0x1f134, 0x1f134, [2, [0x0065], 0]);
        t.add(0x1f135, 0x1f135, [2, [0x0066], 0]);
        t.add(0x1f136, 0x1f136, [2, [0x0067], 0]);
        t.add(0x1f137, 0x1f137, [2, [0x0068], 0]);
        t.add(0x1f138, 0x1f138, [2, [0x0069], 0]);
        t.add(0x1f139, 0x1f139, [2, [0x006A], 0]);
        t.add(0x1f13a, 0x1f13a, [2, [0x006B], 0]);
        t.add(0x1f13b, 0x1f13b, [2, [0x006C], 0]);
        t.add(0x1f13c, 0x1f13c, [2, [0x006D], 0]);
        t.add(0x1f13d, 0x1f13d, [2, [0x006E], 0]);
        t.add(0x1f13e, 0x1f13e, [2, [0x006F], 0]);
        t.add(0x1f13f, 0x1f13f, [2, [0x0070], 0]);
        t.add(0x1f140, 0x1f140, [2, [0x0071], 0]);
        t.add(0x1f141, 0x1f141, [2, [0x0072], 0]);
        t.add(0x1f142, 0x1f142, [2, [0x0073], 0]);
        t.add(0x1f143, 0x1f143, [2, [0x0074], 0]);
        t.add(0x1f144, 0x1f144, [2, [0x0075], 0]);
        t.add(0x1f145, 0x1f145, [2, [0x0076], 0]);
        t.add(0x1f146, 0x1f146, [2, [0x0077], 0]);
        t.add(0x1f147, 0x1f147, [2, [0x0078], 0]);
        t.add(0x1f148, 0x1f148, [2, [0x0079], 0]);
        t.add(0x1f149, 0x1f149, [2, [0x007A], 0]);
        t.add(0x1f14a, 0x1f14a, [2, [0x0068, 0x0076], 0]);
        t.add(0x1f14b, 0x1f14b, [2, [0x006D, 0x0076], 0]);
        t.add(0x1f14c, 0x1f14c, [2, [0x0073, 0x0064], 0]);
        t.add(0x1f14d, 0x1f14d, [2, [0x0073, 0x0073], 0]);
        t.add(0x1f14e, 0x1f14e, [2, [0x0070, 0x0070, 0x0076], 0]);
        t.add(0x1f14f, 0x1f14f, [2, [0x0077, 0x0063], 0]);
        t.add(0x1f150, 0x1f156, [0, [], 1]);
        t.add(0x1f157, 0x1f157, [0, [], 1]);
        t.add(0x1f158, 0x1f15e, [0, [], 1]);
        t.add(0x1f15f, 0x1f15f, [0, [], 1]);
        t.add(0x1f160, 0x1f169, [0, [], 1]);
        t.add(0x1f16a, 0x1f16a, [2, [0x006D, 0x0063], 0]);
        t.add(0x1f16b, 0x1f16b, [2, [0x006D, 0x0064], 0]);
        t.add(0x1f16c, 0x1f16c, [2, [0x006D, 0x0072], 0]);
        t.add(0x1f16d, 0x1f16f, [4, [], 0]);
        t.add(0x1f170, 0x1f178, [0, [], 1]);
        t.add(0x1f179, 0x1f179, [0, [], 1]);
        t.add(0x1f17a, 0x1f17a, [0, [], 1]);
        t.add(0x1f17b, 0x1f17c, [0, [], 1]);
        t.add(0x1f17d, 0x1f17e, [0, [], 1]);
        t.add(0x1f17f, 0x1f17f, [0, [], 1]);
        t.add(0x1f180, 0x1f189, [0, [], 1]);
        t.add(0x1f18a, 0x1f18d, [0, [], 1]);
        t.add(0x1f18e, 0x1f18f, [0, [], 1]);
        t.add(0x1f190, 0x1f190, [2, [0x0064, 0x006A], 0]);
        t.add(0x1f191, 0x1f19a, [0, [], 1]);
        t.add(0x1f19b, 0x1f1ac, [0, [], 1]);
        t.add(0x1f1ad, 0x1f1e5, [4, [], 0]);
        t.add(0x1f1e6, 0x1f1ff, [0, [], 1]);
        t.add(0x1f200, 0x1f200, [2, [0x307B, 0x304B], 0]);
        t.add(0x1f201, 0x1f201, [2, [0x30B3, 0x30B3], 0]);
        t.add(0x1f202, 0x1f202, [2, [0x30B5], 0]);
        t.add(0x1f203, 0x1f20f, [4, [], 0]);
        t.add(0x1f210, 0x1f210, [2, [0x624B], 0]);
        t.add(0x1f211, 0x1f211, [2, [0x5B57], 0]);
        t.add(0x1f212, 0x1f212, [2, [0x53CC], 0]);
        t.add(0x1f213, 0x1f213, [2, [0x30C7], 0]);
        t.add(0x1f214, 0x1f214, [2, [0x4E8C], 0]);
        t.add(0x1f215, 0x1f215, [2, [0x591A], 0]);
        t.add(0x1f216, 0x1f216, [2, [0x89E3], 0]);
        t.add(0x1f217, 0x1f217, [2, [0x5929], 0]);
        t.add(0x1f218, 0x1f218, [2, [0x4EA4], 0]);
        t.add(0x1f219, 0x1f219, [2, [0x6620], 0]);
        t.add(0x1f21a, 0x1f21a, [2, [0x7121], 0]);
        t.add(0x1f21b, 0x1f21b, [2, [0x6599], 0]);
        t.add(0x1f21c, 0x1f21c, [2, [0x524D], 0]);
        t.add(0x1f21d, 0x1f21d, [2, [0x5F8C], 0]);
        t.add(0x1f21e, 0x1f21e, [2, [0x518D], 0]);
        t.add(0x1f21f, 0x1f21f, [2, [0x65B0], 0]);
        t.add(0x1f220, 0x1f220, [2, [0x521D], 0]);
        t.add(0x1f221, 0x1f221, [2, [0x7D42], 0]);
        t.add(0x1f222, 0x1f222, [2, [0x751F], 0]);
        t.add(0x1f223, 0x1f223, [2, [0x8CA9], 0]);
        t.add(0x1f224, 0x1f224, [2, [0x58F0], 0]);
        t.add(0x1f225, 0x1f225, [2, [0x5439], 0]);
        t.add(0x1f226, 0x1f226, [2, [0x6F14], 0]);
        t.add(0x1f227, 0x1f227, [2, [0x6295], 0]);
        t.add(0x1f228, 0x1f228, [2, [0x6355], 0]);
        t.add(0x1f229, 0x1f229, [2, [0x4E00], 0]);
        t.add(0x1f22a, 0x1f22a, [2, [0x4E09], 0]);
        t.add(0x1f22b, 0x1f22b, [2, [0x904A], 0]);
        t.add(0x1f22c, 0x1f22c, [2, [0x5DE6], 0]);
        t.add(0x1f22d, 0x1f22d, [2, [0x4E2D], 0]);
        t.add(0x1f22e, 0x1f22e, [2, [0x53F3], 0]);
        t.add(0x1f22f, 0x1f22f, [2, [0x6307], 0]);
        t.add(0x1f230, 0x1f230, [2, [0x8D70], 0]);
        t.add(0x1f231, 0x1f231, [2, [0x6253], 0]);
        t.add(0x1f232, 0x1f232, [2, [0x7981], 0]);
        t.add(0x1f233, 0x1f233, [2, [0x7A7A], 0]);
        t.add(0x1f234, 0x1f234, [2, [0x5408], 0]);
        t.add(0x1f235, 0x1f235, [2, [0x6E80], 0]);
        t.add(0x1f236, 0x1f236, [2, [0x6709], 0]);
        t.add(0x1f237, 0x1f237, [2, [0x6708], 0]);
        t.add(0x1f238, 0x1f238, [2, [0x7533], 0]);
        t.add(0x1f239, 0x1f239, [2, [0x5272], 0]);
        t.add(0x1f23a, 0x1f23a, [2, [0x55B6], 0]);
        t.add(0x1f23b, 0x1f23b, [2, [0x914D], 0]);
        t.add(0x1f23c, 0x1f23f, [4, [], 0]);
        t.add(0x1f240, 0x1f240, [2, [0x3014, 0x672C, 0x3015], 0]);
        t.add(0x1f241, 0x1f241, [2, [0x3014, 0x4E09, 0x3015], 0]);
        t.add(0x1f242, 0x1f242, [2, [0x3014, 0x4E8C, 0x3015], 0]);
        t.add(0x1f243, 0x1f243, [2, [0x3014, 0x5B89, 0x3015], 0]);
        t.add(0x1f244, 0x1f244, [2, [0x3014, 0x70B9, 0x3015], 0]);
        t.add(0x1f245, 0x1f245, [2, [0x3014, 0x6253, 0x3015], 0]);
        t.add(0x1f246, 0x1f246, [2, [0x3014, 0x76D7, 0x3015], 0]);
        t.add(0x1f247, 0x1f247, [2, [0x3014, 0x52DD, 0x3015], 0]);
        t.add(0x1f248, 0x1f248, [2, [0x3014, 0x6557, 0x3015], 0]);
        t.add(0x1f249, 0x1f24f, [4, [], 0]);
        t.add(0x1f250, 0x1f250, [2, [0x5F97], 0]);
        t.add(0x1f251, 0x1f251, [2, [0x53EF], 0]);
        t.add(0x1f252, 0x1f25f, [4, [], 0]);
        t.add(0x1f260, 0x1f265, [0, [], 1]);
        t.add(0x1f266, 0x1f2ff, [4, [], 0]);
        t.add(0x1f300, 0x1f320, [0, [], 1]);
        t.add(0x1f321, 0x1f32c, [0, [], 1]);
        t.add(0x1f32d, 0x1f32f, [0, [], 1]);
        t.add(0x1f330, 0x1f335, [0, [], 1]);
        t.add(0x1f336, 0x1f336, [0, [], 1]);
        t.add(0x1f337, 0x1f37c, [0, [], 1]);
        t.add(0x1f37d, 0x1f37d, [0, [], 1]);
        t.add(0x1f37e, 0x1f37f, [0, [], 1]);
        t.add(0x1f380, 0x1f393, [0, [], 1]);
        t.add(0x1f394, 0x1f39f, [0, [], 1]);
        t.add(0x1f3a0, 0x1f3c4, [0, [], 1]);
        t.add(0x1f3c5, 0x1f3c5, [0, [], 1]);
        t.add(0x1f3c6, 0x1f3ca, [0, [], 1]);
        t.add(0x1f3cb, 0x1f3ce, [0, [], 1]);
        t.add(0x1f3cf, 0x1f3d3, [0, [], 1]);
        t.add(0x1f3d4, 0x1f3df, [0, [], 1]);
        t.add(0x1f3e0, 0x1f3f0, [0, [], 1]);
        t.add(0x1f3f1, 0x1f3f7, [0, [], 1]);
        t.add(0x1f3f8, 0x1f3ff, [0, [], 1]);
        t.add(0x1f400, 0x1f43e, [0, [], 1]);
        t.add(0x1f43f, 0x1f43f, [0, [], 1]);
        t.add(0x1f440, 0x1f440, [0, [], 1]);
        t.add(0x1f441, 0x1f441, [0, [], 1]);
        t.add(0x1f442, 0x1f4f7, [0, [], 1]);
        t.add(0x1f4f8, 0x1f4f8, [0, [], 1]);
        t.add(0x1f4f9, 0x1f4fc, [0, [], 1]);
        t.add(0x1f4fd, 0x1f4fe, [0, [], 1]);
        t.add(0x1f4ff, 0x1f4ff, [0, [], 1]);
        t.add(0x1f500, 0x1f53d, [0, [], 1]);
        t.add(0x1f53e, 0x1f53f, [0, [], 1]);
        t.add(0x1f540, 0x1f543, [0, [], 1]);
        t.add(0x1f544, 0x1f54a, [0, [], 1]);
        t.add(0x1f54b, 0x1f54f, [0, [], 1]);
        t.add(0x1f550, 0x1f567, [0, [], 1]);
        t.add(0x1f568, 0x1f579, [0, [], 1]);
        t.add(0x1f57a, 0x1f57a, [0, [], 1]);
        t.add(0x1f57b, 0x1f5a3, [0, [], 1]);
        t.add(0x1f5a4, 0x1f5a4, [0, [], 1]);
        t.add(0x1f5a5, 0x1f5fa, [0, [], 1]);
        t.add(0x1f5fb, 0x1f5ff, [0, [], 1]);
        t.add(0x1f600, 0x1f600, [0, [], 1]);
        t.add(0x1f601, 0x1f610, [0, [], 1]);
        t.add(0x1f611, 0x1f611, [0, [], 1]);
        t.add(0x1f612, 0x1f614, [0, [], 1]);
        t.add(0x1f615, 0x1f615, [0, [], 1]);
        t.add(0x1f616, 0x1f616, [0, [], 1]);
        t.add(0x1f617, 0x1f617, [0, [], 1]);
        t.add(0x1f618, 0x1f618, [0, [], 1]);
        t.add(0x1f619, 0x1f619, [0, [], 1]);
        t.add(0x1f61a, 0x1f61a, [0, [], 1]);
        t.add(0x1f61b, 0x1f61b, [0, [], 1]);
        t.add(0x1f61c, 0x1f61e, [0, [], 1]);
        t.add(0x1f61f, 0x1f61f, [0, [], 1]);
        t.add(0x1f620, 0x1f625, [0, [], 1]);
        t.add(0x1f626, 0x1f627, [0, [], 1]);
        t.add(0x1f628, 0x1f62b, [0, [], 1]);
        t.add(0x1f62c, 0x1f62c, [0, [], 1]);
        t.add(0x1f62d, 0x1f62d, [0, [], 1]);
        t.add(0x1f62e, 0x1f62f, [0, [], 1]);
        t.add(0x1f630, 0x1f633, [0, [], 1]);
        t.add(0x1f634, 0x1f634, [0, [], 1]);
        t.add(0x1f635, 0x1f640, [0, [], 1]);
        t.add(0x1f641, 0x1f642, [0, [], 1]);
        t.add(0x1f643, 0x1f644, [0, [], 1]);
        t.add(0x1f645, 0x1f64f, [0, [], 1]);
        t.add(0x1f650, 0x1f67f, [0, [], 1]);
        t.add(0x1f680, 0x1f6c5, [0, [], 1]);
        t.add(0x1f6c6, 0x1f6cf, [0, [], 1]);
        t.add(0x1f6d0, 0x1f6d0, [0, [], 1]);
        t.add(0x1f6d1, 0x1f6d2, [0, [], 1]);
        t.add(0x1f6d3, 0x1f6d4, [0, [], 1]);
        t.add(0x1f6d5, 0x1f6d5, [0, [], 1]);
        t.add(0x1f6d6, 0x1f6df, [4, [], 0]);
        t.add(0x1f6e0, 0x1f6ec, [0, [], 1]);
        t.add(0x1f6ed, 0x1f6ef, [4, [], 0]);
        t.add(0x1f6f0, 0x1f6f3, [0, [], 1]);
        t.add(0x1f6f4, 0x1f6f6, [0, [], 1]);
        t.add(0x1f6f7, 0x1f6f8, [0, [], 1]);
        t.add(0x1f6f9, 0x1f6f9, [0, [], 1]);
        t.add(0x1f6fa, 0x1f6fa, [0, [], 1]);
        t.add(0x1f6fb, 0x1f6ff, [4, [], 0]);
        t.add(0x1f700, 0x1f773, [0, [], 1]);
        t.add(0x1f774, 0x1f77f, [4, [], 0]);
        t.add(0x1f780, 0x1f7d4, [0, [], 1]);
        t.add(0x1f7d5, 0x1f7d8, [0, [], 1]);
        t.add(0x1f7d9, 0x1f7df, [4, [], 0]);
        t.add(0x1f7e0, 0x1f7eb, [0, [], 1]);
        t.add(0x1f7ec, 0x1f7ff, [4, [], 0]);
        t.add(0x1f800, 0x1f80b, [0, [], 1]);
        t.add(0x1f80c, 0x1f80f, [4, [], 0]);
        t.add(0x1f810, 0x1f847, [0, [], 1]);
        t.add(0x1f848, 0x1f84f, [4, [], 0]);
        t.add(0x1f850, 0x1f859, [0, [], 1]);
        t.add(0x1f85a, 0x1f85f, [4, [], 0]);
        t.add(0x1f860, 0x1f887, [0, [], 1]);
        t.add(0x1f888, 0x1f88f, [4, [], 0]);
        t.add(0x1f890, 0x1f8ad, [0, [], 1]);
        t.add(0x1f8ae, 0x1f8ff, [4, [], 0]);
        t.add(0x1f900, 0x1f90b, [0, [], 1]);
        t.add(0x1f90c, 0x1f90c, [4, [], 0]);
        t.add(0x1f90d, 0x1f90f, [0, [], 1]);
        t.add(0x1f910, 0x1f918, [0, [], 1]);
        t.add(0x1f919, 0x1f91e, [0, [], 1]);
        t.add(0x1f91f, 0x1f91f, [0, [], 1]);
        t.add(0x1f920, 0x1f927, [0, [], 1]);
        t.add(0x1f928, 0x1f92f, [0, [], 1]);
        t.add(0x1f930, 0x1f930, [0, [], 1]);
        t.add(0x1f931, 0x1f932, [0, [], 1]);
        t.add(0x1f933, 0x1f93e, [0, [], 1]);
        t.add(0x1f93f, 0x1f93f, [0, [], 1]);
        t.add(0x1f940, 0x1f94b, [0, [], 1]);
        t.add(0x1f94c, 0x1f94c, [0, [], 1]);
        t.add(0x1f94d, 0x1f94f, [0, [], 1]);
        t.add(0x1f950, 0x1f95e, [0, [], 1]);
        t.add(0x1f95f, 0x1f96b, [0, [], 1]);
        t.add(0x1f96c, 0x1f970, [0, [], 1]);
        t.add(0x1f971, 0x1f971, [0, [], 1]);
        t.add(0x1f972, 0x1f972, [4, [], 0]);
        t.add(0x1f973, 0x1f976, [0, [], 1]);
        t.add(0x1f977, 0x1f979, [4, [], 0]);
        t.add(0x1f97a, 0x1f97a, [0, [], 1]);
        t.add(0x1f97b, 0x1f97b, [0, [], 1]);
        t.add(0x1f97c, 0x1f97f, [0, [], 1]);
        t.add(0x1f980, 0x1f984, [0, [], 1]);
        t.add(0x1f985, 0x1f991, [0, [], 1]);
        t.add(0x1f992, 0x1f997, [0, [], 1]);
        t.add(0x1f998, 0x1f9a2, [0, [], 1]);
        t.add(0x1f9a3, 0x1f9a4, [4, [], 0]);
        t.add(0x1f9a5, 0x1f9aa, [0, [], 1]);
        t.add(0x1f9ab, 0x1f9ad, [4, [], 0]);
        t.add(0x1f9ae, 0x1f9af, [0, [], 1]);
        t.add(0x1f9b0, 0x1f9b9, [0, [], 1]);
        t.add(0x1f9ba, 0x1f9bf, [0, [], 1]);
        t.add(0x1f9c0, 0x1f9c0, [0, [], 1]);
        t.add(0x1f9c1, 0x1f9c2, [0, [], 1]);
        t.add(0x1f9c3, 0x1f9ca, [0, [], 1]);
        t.add(0x1f9cb, 0x1f9cc, [4, [], 0]);
        t.add(0x1f9cd, 0x1f9cf, [0, [], 1]);
        t.add(0x1f9d0, 0x1f9e6, [0, [], 1]);
        t.add(0x1f9e7, 0x1f9ff, [0, [], 1]);
        t.add(0x1fa00, 0x1fa53, [0, [], 1]);
        t.add(0x1fa54, 0x1fa5f, [4, [], 0]);
        t.add(0x1fa60, 0x1fa6d, [0, [], 1]);
        t.add(0x1fa6e, 0x1fa6f, [4, [], 0]);
        t.add(0x1fa70, 0x1fa73, [0, [], 1]);
        t.add(0x1fa74, 0x1fa77, [4, [], 0]);
        t.add(0x1fa78, 0x1fa7a, [0, [], 1]);
        t.add(0x1fa7b, 0x1fa7f, [4, [], 0]);
        t.add(0x1fa80, 0x1fa82, [0, [], 1]);
        t.add(0x1fa83, 0x1fa8f, [4, [], 0]);
        t.add(0x1fa90, 0x1fa95, [0, [], 1]);
        t.add(0x1fa96, 0x1fffd, [4, [], 0]);
        t.add(0x1fffe, 0x1ffff, [4, [], 0]);
        t.add(0x20000, 0x2a6d6, [0, [], 0]);
        t.add(0x2a6d7, 0x2a6ff, [4, [], 0]);
        t.add(0x2a700, 0x2b734, [0, [], 0]);
        t.add(0x2b735, 0x2b73f, [4, [], 0]);
        t.add(0x2b740, 0x2b81d, [0, [], 0]);
        t.add(0x2b81e, 0x2b81f, [4, [], 0]);
        t.add(0x2b820, 0x2cea1, [0, [], 0]);
        t.add(0x2cea2, 0x2ceaf, [4, [], 0]);
        t.add(0x2ceb0, 0x2ebe0, [0, [], 0]);
        t.add(0x2ebe1, 0x2f7ff, [4, [], 0]);
        t.add(0x2f800, 0x2f800, [2, [0x4E3D], 0]);
        t.add(0x2f801, 0x2f801, [2, [0x4E38], 0]);
        t.add(0x2f802, 0x2f802, [2, [0x4E41], 0]);
        t.add(0x2f803, 0x2f803, [2, [0x20122], 0]);
        t.add(0x2f804, 0x2f804, [2, [0x4F60], 0]);
        t.add(0x2f805, 0x2f805, [2, [0x4FAE], 0]);
        t.add(0x2f806, 0x2f806, [2, [0x4FBB], 0]);
        t.add(0x2f807, 0x2f807, [2, [0x5002], 0]);
        t.add(0x2f808, 0x2f808, [2, [0x507A], 0]);
        t.add(0x2f809, 0x2f809, [2, [0x5099], 0]);
        t.add(0x2f80a, 0x2f80a, [2, [0x50E7], 0]);
        t.add(0x2f80b, 0x2f80b, [2, [0x50CF], 0]);
        t.add(0x2f80c, 0x2f80c, [2, [0x349E], 0]);
        t.add(0x2f80d, 0x2f80d, [2, [0x2063A], 0]);
        t.add(0x2f80e, 0x2f80e, [2, [0x514D], 0]);
        t.add(0x2f80f, 0x2f80f, [2, [0x5154], 0]);
        t.add(0x2f810, 0x2f810, [2, [0x5164], 0]);
        t.add(0x2f811, 0x2f811, [2, [0x5177], 0]);
        t.add(0x2f812, 0x2f812, [2, [0x2051C], 0]);
        t.add(0x2f813, 0x2f813, [2, [0x34B9], 0]);
        t.add(0x2f814, 0x2f814, [2, [0x5167], 0]);
        t.add(0x2f815, 0x2f815, [2, [0x518D], 0]);
        t.add(0x2f816, 0x2f816, [2, [0x2054B], 0]);
        t.add(0x2f817, 0x2f817, [2, [0x5197], 0]);
        t.add(0x2f818, 0x2f818, [2, [0x51A4], 0]);
        t.add(0x2f819, 0x2f819, [2, [0x4ECC], 0]);
        t.add(0x2f81a, 0x2f81a, [2, [0x51AC], 0]);
        t.add(0x2f81b, 0x2f81b, [2, [0x51B5], 0]);
        t.add(0x2f81c, 0x2f81c, [2, [0x291DF], 0]);
        t.add(0x2f81d, 0x2f81d, [2, [0x51F5], 0]);
        t.add(0x2f81e, 0x2f81e, [2, [0x5203], 0]);
        t.add(0x2f81f, 0x2f81f, [2, [0x34DF], 0]);
        t.add(0x2f820, 0x2f820, [2, [0x523B], 0]);
        t.add(0x2f821, 0x2f821, [2, [0x5246], 0]);
        t.add(0x2f822, 0x2f822, [2, [0x5272], 0]);
        t.add(0x2f823, 0x2f823, [2, [0x5277], 0]);
        t.add(0x2f824, 0x2f824, [2, [0x3515], 0]);
        t.add(0x2f825, 0x2f825, [2, [0x52C7], 0]);
        t.add(0x2f826, 0x2f826, [2, [0x52C9], 0]);
        t.add(0x2f827, 0x2f827, [2, [0x52E4], 0]);
        t.add(0x2f828, 0x2f828, [2, [0x52FA], 0]);
        t.add(0x2f829, 0x2f829, [2, [0x5305], 0]);
        t.add(0x2f82a, 0x2f82a, [2, [0x5306], 0]);
        t.add(0x2f82b, 0x2f82b, [2, [0x5317], 0]);
        t.add(0x2f82c, 0x2f82c, [2, [0x5349], 0]);
        t.add(0x2f82d, 0x2f82d, [2, [0x5351], 0]);
        t.add(0x2f82e, 0x2f82e, [2, [0x535A], 0]);
        t.add(0x2f82f, 0x2f82f, [2, [0x5373], 0]);
        t.add(0x2f830, 0x2f830, [2, [0x537D], 0]);
        t.add(0x2f831, 0x2f833, [2, [0x537F], 0]);
        t.add(0x2f834, 0x2f834, [2, [0x20A2C], 0]);
        t.add(0x2f835, 0x2f835, [2, [0x7070], 0]);
        t.add(0x2f836, 0x2f836, [2, [0x53CA], 0]);
        t.add(0x2f837, 0x2f837, [2, [0x53DF], 0]);
        t.add(0x2f838, 0x2f838, [2, [0x20B63], 0]);
        t.add(0x2f839, 0x2f839, [2, [0x53EB], 0]);
        t.add(0x2f83a, 0x2f83a, [2, [0x53F1], 0]);
        t.add(0x2f83b, 0x2f83b, [2, [0x5406], 0]);
        t.add(0x2f83c, 0x2f83c, [2, [0x549E], 0]);
        t.add(0x2f83d, 0x2f83d, [2, [0x5438], 0]);
        t.add(0x2f83e, 0x2f83e, [2, [0x5448], 0]);
        t.add(0x2f83f, 0x2f83f, [2, [0x5468], 0]);
        t.add(0x2f840, 0x2f840, [2, [0x54A2], 0]);
        t.add(0x2f841, 0x2f841, [2, [0x54F6], 0]);
        t.add(0x2f842, 0x2f842, [2, [0x5510], 0]);
        t.add(0x2f843, 0x2f843, [2, [0x5553], 0]);
        t.add(0x2f844, 0x2f844, [2, [0x5563], 0]);
        t.add(0x2f845, 0x2f846, [2, [0x5584], 0]);
        t.add(0x2f847, 0x2f847, [2, [0x5599], 0]);
        t.add(0x2f848, 0x2f848, [2, [0x55AB], 0]);
        t.add(0x2f849, 0x2f849, [2, [0x55B3], 0]);
        t.add(0x2f84a, 0x2f84a, [2, [0x55C2], 0]);
        t.add(0x2f84b, 0x2f84b, [2, [0x5716], 0]);
        t.add(0x2f84c, 0x2f84c, [2, [0x5606], 0]);
        t.add(0x2f84d, 0x2f84d, [2, [0x5717], 0]);
        t.add(0x2f84e, 0x2f84e, [2, [0x5651], 0]);
        t.add(0x2f84f, 0x2f84f, [2, [0x5674], 0]);
        t.add(0x2f850, 0x2f850, [2, [0x5207], 0]);
        t.add(0x2f851, 0x2f851, [2, [0x58EE], 0]);
        t.add(0x2f852, 0x2f852, [2, [0x57CE], 0]);
        t.add(0x2f853, 0x2f853, [2, [0x57F4], 0]);
        t.add(0x2f854, 0x2f854, [2, [0x580D], 0]);
        t.add(0x2f855, 0x2f855, [2, [0x578B], 0]);
        t.add(0x2f856, 0x2f856, [2, [0x5832], 0]);
        t.add(0x2f857, 0x2f857, [2, [0x5831], 0]);
        t.add(0x2f858, 0x2f858, [2, [0x58AC], 0]);
        t.add(0x2f859, 0x2f859, [2, [0x214E4], 0]);
        t.add(0x2f85a, 0x2f85a, [2, [0x58F2], 0]);
        t.add(0x2f85b, 0x2f85b, [2, [0x58F7], 0]);
        t.add(0x2f85c, 0x2f85c, [2, [0x5906], 0]);
        t.add(0x2f85d, 0x2f85d, [2, [0x591A], 0]);
        t.add(0x2f85e, 0x2f85e, [2, [0x5922], 0]);
        t.add(0x2f85f, 0x2f85f, [2, [0x5962], 0]);
        t.add(0x2f860, 0x2f860, [2, [0x216A8], 0]);
        t.add(0x2f861, 0x2f861, [2, [0x216EA], 0]);
        t.add(0x2f862, 0x2f862, [2, [0x59EC], 0]);
        t.add(0x2f863, 0x2f863, [2, [0x5A1B], 0]);
        t.add(0x2f864, 0x2f864, [2, [0x5A27], 0]);
        t.add(0x2f865, 0x2f865, [2, [0x59D8], 0]);
        t.add(0x2f866, 0x2f866, [2, [0x5A66], 0]);
        t.add(0x2f867, 0x2f867, [2, [0x36EE], 0]);
        t.add(0x2f868, 0x2f868, [4, [], 0]);
        t.add(0x2f869, 0x2f869, [2, [0x5B08], 0]);
        t.add(0x2f86a, 0x2f86b, [2, [0x5B3E], 0]);
        t.add(0x2f86c, 0x2f86c, [2, [0x219C8], 0]);
        t.add(0x2f86d, 0x2f86d, [2, [0x5BC3], 0]);
        t.add(0x2f86e, 0x2f86e, [2, [0x5BD8], 0]);
        t.add(0x2f86f, 0x2f86f, [2, [0x5BE7], 0]);
        t.add(0x2f870, 0x2f870, [2, [0x5BF3], 0]);
        t.add(0x2f871, 0x2f871, [2, [0x21B18], 0]);
        t.add(0x2f872, 0x2f872, [2, [0x5BFF], 0]);
        t.add(0x2f873, 0x2f873, [2, [0x5C06], 0]);
        t.add(0x2f874, 0x2f874, [4, [], 0]);
        t.add(0x2f875, 0x2f875, [2, [0x5C22], 0]);
        t.add(0x2f876, 0x2f876, [2, [0x3781], 0]);
        t.add(0x2f877, 0x2f877, [2, [0x5C60], 0]);
        t.add(0x2f878, 0x2f878, [2, [0x5C6E], 0]);
        t.add(0x2f879, 0x2f879, [2, [0x5CC0], 0]);
        t.add(0x2f87a, 0x2f87a, [2, [0x5C8D], 0]);
        t.add(0x2f87b, 0x2f87b, [2, [0x21DE4], 0]);
        t.add(0x2f87c, 0x2f87c, [2, [0x5D43], 0]);
        t.add(0x2f87d, 0x2f87d, [2, [0x21DE6], 0]);
        t.add(0x2f87e, 0x2f87e, [2, [0x5D6E], 0]);
        t.add(0x2f87f, 0x2f87f, [2, [0x5D6B], 0]);
        t.add(0x2f880, 0x2f880, [2, [0x5D7C], 0]);
        t.add(0x2f881, 0x2f881, [2, [0x5DE1], 0]);
        t.add(0x2f882, 0x2f882, [2, [0x5DE2], 0]);
        t.add(0x2f883, 0x2f883, [2, [0x382F], 0]);
        t.add(0x2f884, 0x2f884, [2, [0x5DFD], 0]);
        t.add(0x2f885, 0x2f885, [2, [0x5E28], 0]);
        t.add(0x2f886, 0x2f886, [2, [0x5E3D], 0]);
        t.add(0x2f887, 0x2f887, [2, [0x5E69], 0]);
        t.add(0x2f888, 0x2f888, [2, [0x3862], 0]);
        t.add(0x2f889, 0x2f889, [2, [0x22183], 0]);
        t.add(0x2f88a, 0x2f88a, [2, [0x387C], 0]);
        t.add(0x2f88b, 0x2f88b, [2, [0x5EB0], 0]);
        t.add(0x2f88c, 0x2f88c, [2, [0x5EB3], 0]);
        t.add(0x2f88d, 0x2f88d, [2, [0x5EB6], 0]);
        t.add(0x2f88e, 0x2f88e, [2, [0x5ECA], 0]);
        t.add(0x2f88f, 0x2f88f, [2, [0x2A392], 0]);
        t.add(0x2f890, 0x2f890, [2, [0x5EFE], 0]);
        t.add(0x2f891, 0x2f892, [2, [0x22331], 0]);
        t.add(0x2f893, 0x2f893, [2, [0x8201], 0]);
        t.add(0x2f894, 0x2f895, [2, [0x5F22], 0]);
        t.add(0x2f896, 0x2f896, [2, [0x38C7], 0]);
        t.add(0x2f897, 0x2f897, [2, [0x232B8], 0]);
        t.add(0x2f898, 0x2f898, [2, [0x261DA], 0]);
        t.add(0x2f899, 0x2f899, [2, [0x5F62], 0]);
        t.add(0x2f89a, 0x2f89a, [2, [0x5F6B], 0]);
        t.add(0x2f89b, 0x2f89b, [2, [0x38E3], 0]);
        t.add(0x2f89c, 0x2f89c, [2, [0x5F9A], 0]);
        t.add(0x2f89d, 0x2f89d, [2, [0x5FCD], 0]);
        t.add(0x2f89e, 0x2f89e, [2, [0x5FD7], 0]);
        t.add(0x2f89f, 0x2f89f, [2, [0x5FF9], 0]);
        t.add(0x2f8a0, 0x2f8a0, [2, [0x6081], 0]);
        t.add(0x2f8a1, 0x2f8a1, [2, [0x393A], 0]);
        t.add(0x2f8a2, 0x2f8a2, [2, [0x391C], 0]);
        t.add(0x2f8a3, 0x2f8a3, [2, [0x6094], 0]);
        t.add(0x2f8a4, 0x2f8a4, [2, [0x226D4], 0]);
        t.add(0x2f8a5, 0x2f8a5, [2, [0x60C7], 0]);
        t.add(0x2f8a6, 0x2f8a6, [2, [0x6148], 0]);
        t.add(0x2f8a7, 0x2f8a7, [2, [0x614C], 0]);
        t.add(0x2f8a8, 0x2f8a8, [2, [0x614E], 0]);
        t.add(0x2f8a9, 0x2f8a9, [2, [0x614C], 0]);
        t.add(0x2f8aa, 0x2f8aa, [2, [0x617A], 0]);
        t.add(0x2f8ab, 0x2f8ab, [2, [0x618E], 0]);
        t.add(0x2f8ac, 0x2f8ac, [2, [0x61B2], 0]);
        t.add(0x2f8ad, 0x2f8ad, [2, [0x61A4], 0]);
        t.add(0x2f8ae, 0x2f8ae, [2, [0x61AF], 0]);
        t.add(0x2f8af, 0x2f8af, [2, [0x61DE], 0]);
        t.add(0x2f8b0, 0x2f8b0, [2, [0x61F2], 0]);
        t.add(0x2f8b1, 0x2f8b1, [2, [0x61F6], 0]);
        t.add(0x2f8b2, 0x2f8b2, [2, [0x6210], 0]);
        t.add(0x2f8b3, 0x2f8b3, [2, [0x621B], 0]);
        t.add(0x2f8b4, 0x2f8b4, [2, [0x625D], 0]);
        t.add(0x2f8b5, 0x2f8b5, [2, [0x62B1], 0]);
        t.add(0x2f8b6, 0x2f8b6, [2, [0x62D4], 0]);
        t.add(0x2f8b7, 0x2f8b7, [2, [0x6350], 0]);
        t.add(0x2f8b8, 0x2f8b8, [2, [0x22B0C], 0]);
        t.add(0x2f8b9, 0x2f8b9, [2, [0x633D], 0]);
        t.add(0x2f8ba, 0x2f8ba, [2, [0x62FC], 0]);
        t.add(0x2f8bb, 0x2f8bb, [2, [0x6368], 0]);
        t.add(0x2f8bc, 0x2f8bc, [2, [0x6383], 0]);
        t.add(0x2f8bd, 0x2f8bd, [2, [0x63E4], 0]);
        t.add(0x2f8be, 0x2f8be, [2, [0x22BF1], 0]);
        t.add(0x2f8bf, 0x2f8bf, [2, [0x6422], 0]);
        t.add(0x2f8c0, 0x2f8c0, [2, [0x63C5], 0]);
        t.add(0x2f8c1, 0x2f8c1, [2, [0x63A9], 0]);
        t.add(0x2f8c2, 0x2f8c2, [2, [0x3A2E], 0]);
        t.add(0x2f8c3, 0x2f8c3, [2, [0x6469], 0]);
        t.add(0x2f8c4, 0x2f8c4, [2, [0x647E], 0]);
        t.add(0x2f8c5, 0x2f8c5, [2, [0x649D], 0]);
        t.add(0x2f8c6, 0x2f8c6, [2, [0x6477], 0]);
        t.add(0x2f8c7, 0x2f8c7, [2, [0x3A6C], 0]);
        t.add(0x2f8c8, 0x2f8c8, [2, [0x654F], 0]);
        t.add(0x2f8c9, 0x2f8c9, [2, [0x656C], 0]);
        t.add(0x2f8ca, 0x2f8ca, [2, [0x2300A], 0]);
        t.add(0x2f8cb, 0x2f8cb, [2, [0x65E3], 0]);
        t.add(0x2f8cc, 0x2f8cc, [2, [0x66F8], 0]);
        t.add(0x2f8cd, 0x2f8cd, [2, [0x6649], 0]);
        t.add(0x2f8ce, 0x2f8ce, [2, [0x3B19], 0]);
        t.add(0x2f8cf, 0x2f8cf, [2, [0x6691], 0]);
        t.add(0x2f8d0, 0x2f8d0, [2, [0x3B08], 0]);
        t.add(0x2f8d1, 0x2f8d1, [2, [0x3AE4], 0]);
        t.add(0x2f8d2, 0x2f8d2, [2, [0x5192], 0]);
        t.add(0x2f8d3, 0x2f8d3, [2, [0x5195], 0]);
        t.add(0x2f8d4, 0x2f8d4, [2, [0x6700], 0]);
        t.add(0x2f8d5, 0x2f8d5, [2, [0x669C], 0]);
        t.add(0x2f8d6, 0x2f8d6, [2, [0x80AD], 0]);
        t.add(0x2f8d7, 0x2f8d7, [2, [0x43D9], 0]);
        t.add(0x2f8d8, 0x2f8d8, [2, [0x6717], 0]);
        t.add(0x2f8d9, 0x2f8d9, [2, [0x671B], 0]);
        t.add(0x2f8da, 0x2f8da, [2, [0x6721], 0]);
        t.add(0x2f8db, 0x2f8db, [2, [0x675E], 0]);
        t.add(0x2f8dc, 0x2f8dc, [2, [0x6753], 0]);
        t.add(0x2f8dd, 0x2f8dd, [2, [0x233C3], 0]);
        t.add(0x2f8de, 0x2f8de, [2, [0x3B49], 0]);
        t.add(0x2f8df, 0x2f8df, [2, [0x67FA], 0]);
        t.add(0x2f8e0, 0x2f8e0, [2, [0x6785], 0]);
        t.add(0x2f8e1, 0x2f8e1, [2, [0x6852], 0]);
        t.add(0x2f8e2, 0x2f8e2, [2, [0x6885], 0]);
        t.add(0x2f8e3, 0x2f8e3, [2, [0x2346D], 0]);
        t.add(0x2f8e4, 0x2f8e4, [2, [0x688E], 0]);
        t.add(0x2f8e5, 0x2f8e5, [2, [0x681F], 0]);
        t.add(0x2f8e6, 0x2f8e6, [2, [0x6914], 0]);
        t.add(0x2f8e7, 0x2f8e7, [2, [0x3B9D], 0]);
        t.add(0x2f8e8, 0x2f8e8, [2, [0x6942], 0]);
        t.add(0x2f8e9, 0x2f8e9, [2, [0x69A3], 0]);
        t.add(0x2f8ea, 0x2f8ea, [2, [0x69EA], 0]);
        t.add(0x2f8eb, 0x2f8eb, [2, [0x6AA8], 0]);
        t.add(0x2f8ec, 0x2f8ec, [2, [0x236A3], 0]);
        t.add(0x2f8ed, 0x2f8ed, [2, [0x6ADB], 0]);
        t.add(0x2f8ee, 0x2f8ee, [2, [0x3C18], 0]);
        t.add(0x2f8ef, 0x2f8ef, [2, [0x6B21], 0]);
        t.add(0x2f8f0, 0x2f8f0, [2, [0x238A7], 0]);
        t.add(0x2f8f1, 0x2f8f1, [2, [0x6B54], 0]);
        t.add(0x2f8f2, 0x2f8f2, [2, [0x3C4E], 0]);
        t.add(0x2f8f3, 0x2f8f3, [2, [0x6B72], 0]);
        t.add(0x2f8f4, 0x2f8f4, [2, [0x6B9F], 0]);
        t.add(0x2f8f5, 0x2f8f5, [2, [0x6BBA], 0]);
        t.add(0x2f8f6, 0x2f8f6, [2, [0x6BBB], 0]);
        t.add(0x2f8f7, 0x2f8f7, [2, [0x23A8D], 0]);
        t.add(0x2f8f8, 0x2f8f8, [2, [0x21D0B], 0]);
        t.add(0x2f8f9, 0x2f8f9, [2, [0x23AFA], 0]);
        t.add(0x2f8fa, 0x2f8fa, [2, [0x6C4E], 0]);
        t.add(0x2f8fb, 0x2f8fb, [2, [0x23CBC], 0]);
        t.add(0x2f8fc, 0x2f8fc, [2, [0x6CBF], 0]);
        t.add(0x2f8fd, 0x2f8fd, [2, [0x6CCD], 0]);
        t.add(0x2f8fe, 0x2f8fe, [2, [0x6C67], 0]);
        t.add(0x2f8ff, 0x2f8ff, [2, [0x6D16], 0]);
        t.add(0x2f900, 0x2f900, [2, [0x6D3E], 0]);
        t.add(0x2f901, 0x2f901, [2, [0x6D77], 0]);
        t.add(0x2f902, 0x2f902, [2, [0x6D41], 0]);
        t.add(0x2f903, 0x2f903, [2, [0x6D69], 0]);
        t.add(0x2f904, 0x2f904, [2, [0x6D78], 0]);
        t.add(0x2f905, 0x2f905, [2, [0x6D85], 0]);
        t.add(0x2f906, 0x2f906, [2, [0x23D1E], 0]);
        t.add(0x2f907, 0x2f907, [2, [0x6D34], 0]);
        t.add(0x2f908, 0x2f908, [2, [0x6E2F], 0]);
        t.add(0x2f909, 0x2f909, [2, [0x6E6E], 0]);
        t.add(0x2f90a, 0x2f90a, [2, [0x3D33], 0]);
        t.add(0x2f90b, 0x2f90b, [2, [0x6ECB], 0]);
        t.add(0x2f90c, 0x2f90c, [2, [0x6EC7], 0]);
        t.add(0x2f90d, 0x2f90d, [2, [0x23ED1], 0]);
        t.add(0x2f90e, 0x2f90e, [2, [0x6DF9], 0]);
        t.add(0x2f90f, 0x2f90f, [2, [0x6F6E], 0]);
        t.add(0x2f910, 0x2f910, [2, [0x23F5E], 0]);
        t.add(0x2f911, 0x2f911, [2, [0x23F8E], 0]);
        t.add(0x2f912, 0x2f912, [2, [0x6FC6], 0]);
        t.add(0x2f913, 0x2f913, [2, [0x7039], 0]);
        t.add(0x2f914, 0x2f914, [2, [0x701E], 0]);
        t.add(0x2f915, 0x2f915, [2, [0x701B], 0]);
        t.add(0x2f916, 0x2f916, [2, [0x3D96], 0]);
        t.add(0x2f917, 0x2f917, [2, [0x704A], 0]);
        t.add(0x2f918, 0x2f918, [2, [0x707D], 0]);
        t.add(0x2f919, 0x2f919, [2, [0x7077], 0]);
        t.add(0x2f91a, 0x2f91a, [2, [0x70AD], 0]);
        t.add(0x2f91b, 0x2f91b, [2, [0x20525], 0]);
        t.add(0x2f91c, 0x2f91c, [2, [0x7145], 0]);
        t.add(0x2f91d, 0x2f91d, [2, [0x24263], 0]);
        t.add(0x2f91e, 0x2f91e, [2, [0x719C], 0]);
        t.add(0x2f91f, 0x2f91f, [4, [], 0]);
        t.add(0x2f920, 0x2f920, [2, [0x7228], 0]);
        t.add(0x2f921, 0x2f921, [2, [0x7235], 0]);
        t.add(0x2f922, 0x2f922, [2, [0x7250], 0]);
        t.add(0x2f923, 0x2f923, [2, [0x24608], 0]);
        t.add(0x2f924, 0x2f924, [2, [0x7280], 0]);
        t.add(0x2f925, 0x2f925, [2, [0x7295], 0]);
        t.add(0x2f926, 0x2f926, [2, [0x24735], 0]);
        t.add(0x2f927, 0x2f927, [2, [0x24814], 0]);
        t.add(0x2f928, 0x2f928, [2, [0x737A], 0]);
        t.add(0x2f929, 0x2f929, [2, [0x738B], 0]);
        t.add(0x2f92a, 0x2f92a, [2, [0x3EAC], 0]);
        t.add(0x2f92b, 0x2f92b, [2, [0x73A5], 0]);
        t.add(0x2f92c, 0x2f92d, [2, [0x3EB8], 0]);
        t.add(0x2f92e, 0x2f92e, [2, [0x7447], 0]);
        t.add(0x2f92f, 0x2f92f, [2, [0x745C], 0]);
        t.add(0x2f930, 0x2f930, [2, [0x7471], 0]);
        t.add(0x2f931, 0x2f931, [2, [0x7485], 0]);
        t.add(0x2f932, 0x2f932, [2, [0x74CA], 0]);
        t.add(0x2f933, 0x2f933, [2, [0x3F1B], 0]);
        t.add(0x2f934, 0x2f934, [2, [0x7524], 0]);
        t.add(0x2f935, 0x2f935, [2, [0x24C36], 0]);
        t.add(0x2f936, 0x2f936, [2, [0x753E], 0]);
        t.add(0x2f937, 0x2f937, [2, [0x24C92], 0]);
        t.add(0x2f938, 0x2f938, [2, [0x7570], 0]);
        t.add(0x2f939, 0x2f939, [2, [0x2219F], 0]);
        t.add(0x2f93a, 0x2f93a, [2, [0x7610], 0]);
        t.add(0x2f93b, 0x2f93b, [2, [0x24FA1], 0]);
        t.add(0x2f93c, 0x2f93c, [2, [0x24FB8], 0]);
        t.add(0x2f93d, 0x2f93d, [2, [0x25044], 0]);
        t.add(0x2f93e, 0x2f93e, [2, [0x3FFC], 0]);
        t.add(0x2f93f, 0x2f93f, [2, [0x4008], 0]);
        t.add(0x2f940, 0x2f940, [2, [0x76F4], 0]);
        t.add(0x2f941, 0x2f941, [2, [0x250F3], 0]);
        t.add(0x2f942, 0x2f942, [2, [0x250F2], 0]);
        t.add(0x2f943, 0x2f943, [2, [0x25119], 0]);
        t.add(0x2f944, 0x2f944, [2, [0x25133], 0]);
        t.add(0x2f945, 0x2f945, [2, [0x771E], 0]);
        t.add(0x2f946, 0x2f947, [2, [0x771F], 0]);
        t.add(0x2f948, 0x2f948, [2, [0x774A], 0]);
        t.add(0x2f949, 0x2f949, [2, [0x4039], 0]);
        t.add(0x2f94a, 0x2f94a, [2, [0x778B], 0]);
        t.add(0x2f94b, 0x2f94b, [2, [0x4046], 0]);
        t.add(0x2f94c, 0x2f94c, [2, [0x4096], 0]);
        t.add(0x2f94d, 0x2f94d, [2, [0x2541D], 0]);
        t.add(0x2f94e, 0x2f94e, [2, [0x784E], 0]);
        t.add(0x2f94f, 0x2f94f, [2, [0x788C], 0]);
        t.add(0x2f950, 0x2f950, [2, [0x78CC], 0]);
        t.add(0x2f951, 0x2f951, [2, [0x40E3], 0]);
        t.add(0x2f952, 0x2f952, [2, [0x25626], 0]);
        t.add(0x2f953, 0x2f953, [2, [0x7956], 0]);
        t.add(0x2f954, 0x2f954, [2, [0x2569A], 0]);
        t.add(0x2f955, 0x2f955, [2, [0x256C5], 0]);
        t.add(0x2f956, 0x2f956, [2, [0x798F], 0]);
        t.add(0x2f957, 0x2f957, [2, [0x79EB], 0]);
        t.add(0x2f958, 0x2f958, [2, [0x412F], 0]);
        t.add(0x2f959, 0x2f959, [2, [0x7A40], 0]);
        t.add(0x2f95a, 0x2f95a, [2, [0x7A4A], 0]);
        t.add(0x2f95b, 0x2f95b, [2, [0x7A4F], 0]);
        t.add(0x2f95c, 0x2f95c, [2, [0x2597C], 0]);
        t.add(0x2f95d, 0x2f95e, [2, [0x25AA7], 0]);
        t.add(0x2f95f, 0x2f95f, [4, [], 0]);
        t.add(0x2f960, 0x2f960, [2, [0x4202], 0]);
        t.add(0x2f961, 0x2f961, [2, [0x25BAB], 0]);
        t.add(0x2f962, 0x2f962, [2, [0x7BC6], 0]);
        t.add(0x2f963, 0x2f963, [2, [0x7BC9], 0]);
        t.add(0x2f964, 0x2f964, [2, [0x4227], 0]);
        t.add(0x2f965, 0x2f965, [2, [0x25C80], 0]);
        t.add(0x2f966, 0x2f966, [2, [0x7CD2], 0]);
        t.add(0x2f967, 0x2f967, [2, [0x42A0], 0]);
        t.add(0x2f968, 0x2f968, [2, [0x7CE8], 0]);
        t.add(0x2f969, 0x2f969, [2, [0x7CE3], 0]);
        t.add(0x2f96a, 0x2f96a, [2, [0x7D00], 0]);
        t.add(0x2f96b, 0x2f96b, [2, [0x25F86], 0]);
        t.add(0x2f96c, 0x2f96c, [2, [0x7D63], 0]);
        t.add(0x2f96d, 0x2f96d, [2, [0x4301], 0]);
        t.add(0x2f96e, 0x2f96e, [2, [0x7DC7], 0]);
        t.add(0x2f96f, 0x2f96f, [2, [0x7E02], 0]);
        t.add(0x2f970, 0x2f970, [2, [0x7E45], 0]);
        t.add(0x2f971, 0x2f971, [2, [0x4334], 0]);
        t.add(0x2f972, 0x2f972, [2, [0x26228], 0]);
        t.add(0x2f973, 0x2f973, [2, [0x26247], 0]);
        t.add(0x2f974, 0x2f974, [2, [0x4359], 0]);
        t.add(0x2f975, 0x2f975, [2, [0x262D9], 0]);
        t.add(0x2f976, 0x2f976, [2, [0x7F7A], 0]);
        t.add(0x2f977, 0x2f977, [2, [0x2633E], 0]);
        t.add(0x2f978, 0x2f978, [2, [0x7F95], 0]);
        t.add(0x2f979, 0x2f979, [2, [0x7FFA], 0]);
        t.add(0x2f97a, 0x2f97a, [2, [0x8005], 0]);
        t.add(0x2f97b, 0x2f97b, [2, [0x264DA], 0]);
        t.add(0x2f97c, 0x2f97c, [2, [0x26523], 0]);
        t.add(0x2f97d, 0x2f97d, [2, [0x8060], 0]);
        t.add(0x2f97e, 0x2f97e, [2, [0x265A8], 0]);
        t.add(0x2f97f, 0x2f97f, [2, [0x8070], 0]);
        t.add(0x2f980, 0x2f980, [2, [0x2335F], 0]);
        t.add(0x2f981, 0x2f981, [2, [0x43D5], 0]);
        t.add(0x2f982, 0x2f982, [2, [0x80B2], 0]);
        t.add(0x2f983, 0x2f983, [2, [0x8103], 0]);
        t.add(0x2f984, 0x2f984, [2, [0x440B], 0]);
        t.add(0x2f985, 0x2f985, [2, [0x813E], 0]);
        t.add(0x2f986, 0x2f986, [2, [0x5AB5], 0]);
        t.add(0x2f987, 0x2f987, [2, [0x267A7], 0]);
        t.add(0x2f988, 0x2f988, [2, [0x267B5], 0]);
        t.add(0x2f989, 0x2f989, [2, [0x23393], 0]);
        t.add(0x2f98a, 0x2f98a, [2, [0x2339C], 0]);
        t.add(0x2f98b, 0x2f98b, [2, [0x8201], 0]);
        t.add(0x2f98c, 0x2f98c, [2, [0x8204], 0]);
        t.add(0x2f98d, 0x2f98d, [2, [0x8F9E], 0]);
        t.add(0x2f98e, 0x2f98e, [2, [0x446B], 0]);
        t.add(0x2f98f, 0x2f98f, [2, [0x8291], 0]);
        t.add(0x2f990, 0x2f990, [2, [0x828B], 0]);
        t.add(0x2f991, 0x2f991, [2, [0x829D], 0]);
        t.add(0x2f992, 0x2f992, [2, [0x52B3], 0]);
        t.add(0x2f993, 0x2f993, [2, [0x82B1], 0]);
        t.add(0x2f994, 0x2f994, [2, [0x82B3], 0]);
        t.add(0x2f995, 0x2f995, [2, [0x82BD], 0]);
        t.add(0x2f996, 0x2f996, [2, [0x82E6], 0]);
        t.add(0x2f997, 0x2f997, [2, [0x26B3C], 0]);
        t.add(0x2f998, 0x2f998, [2, [0x82E5], 0]);
        t.add(0x2f999, 0x2f999, [2, [0x831D], 0]);
        t.add(0x2f99a, 0x2f99a, [2, [0x8363], 0]);
        t.add(0x2f99b, 0x2f99b, [2, [0x83AD], 0]);
        t.add(0x2f99c, 0x2f99c, [2, [0x8323], 0]);
        t.add(0x2f99d, 0x2f99d, [2, [0x83BD], 0]);
        t.add(0x2f99e, 0x2f99e, [2, [0x83E7], 0]);
        t.add(0x2f99f, 0x2f99f, [2, [0x8457], 0]);
        t.add(0x2f9a0, 0x2f9a0, [2, [0x8353], 0]);
        t.add(0x2f9a1, 0x2f9a1, [2, [0x83CA], 0]);
        t.add(0x2f9a2, 0x2f9a2, [2, [0x83CC], 0]);
        t.add(0x2f9a3, 0x2f9a3, [2, [0x83DC], 0]);
        t.add(0x2f9a4, 0x2f9a4, [2, [0x26C36], 0]);
        t.add(0x2f9a5, 0x2f9a5, [2, [0x26D6B], 0]);
        t.add(0x2f9a6, 0x2f9a6, [2, [0x26CD5], 0]);
        t.add(0x2f9a7, 0x2f9a7, [2, [0x452B], 0]);
        t.add(0x2f9a8, 0x2f9a8, [2, [0x84F1], 0]);
        t.add(0x2f9a9, 0x2f9a9, [2, [0x84F3], 0]);
        t.add(0x2f9aa, 0x2f9aa, [2, [0x8516], 0]);
        t.add(0x2f9ab, 0x2f9ab, [2, [0x273CA], 0]);
        t.add(0x2f9ac, 0x2f9ac, [2, [0x8564], 0]);
        t.add(0x2f9ad, 0x2f9ad, [2, [0x26F2C], 0]);
        t.add(0x2f9ae, 0x2f9ae, [2, [0x455D], 0]);
        t.add(0x2f9af, 0x2f9af, [2, [0x4561], 0]);
        t.add(0x2f9b0, 0x2f9b0, [2, [0x26FB1], 0]);
        t.add(0x2f9b1, 0x2f9b1, [2, [0x270D2], 0]);
        t.add(0x2f9b2, 0x2f9b2, [2, [0x456B], 0]);
        t.add(0x2f9b3, 0x2f9b3, [2, [0x8650], 0]);
        t.add(0x2f9b4, 0x2f9b4, [2, [0x865C], 0]);
        t.add(0x2f9b5, 0x2f9b5, [2, [0x8667], 0]);
        t.add(0x2f9b6, 0x2f9b6, [2, [0x8669], 0]);
        t.add(0x2f9b7, 0x2f9b7, [2, [0x86A9], 0]);
        t.add(0x2f9b8, 0x2f9b8, [2, [0x8688], 0]);
        t.add(0x2f9b9, 0x2f9b9, [2, [0x870E], 0]);
        t.add(0x2f9ba, 0x2f9ba, [2, [0x86E2], 0]);
        t.add(0x2f9bb, 0x2f9bb, [2, [0x8779], 0]);
        t.add(0x2f9bc, 0x2f9bc, [2, [0x8728], 0]);
        t.add(0x2f9bd, 0x2f9bd, [2, [0x876B], 0]);
        t.add(0x2f9be, 0x2f9be, [2, [0x8786], 0]);
        t.add(0x2f9bf, 0x2f9bf, [4, [], 0]);
        t.add(0x2f9c0, 0x2f9c0, [2, [0x87E1], 0]);
        t.add(0x2f9c1, 0x2f9c1, [2, [0x8801], 0]);
        t.add(0x2f9c2, 0x2f9c2, [2, [0x45F9], 0]);
        t.add(0x2f9c3, 0x2f9c3, [2, [0x8860], 0]);
        t.add(0x2f9c4, 0x2f9c4, [2, [0x8863], 0]);
        t.add(0x2f9c5, 0x2f9c5, [2, [0x27667], 0]);
        t.add(0x2f9c6, 0x2f9c6, [2, [0x88D7], 0]);
        t.add(0x2f9c7, 0x2f9c7, [2, [0x88DE], 0]);
        t.add(0x2f9c8, 0x2f9c8, [2, [0x4635], 0]);
        t.add(0x2f9c9, 0x2f9c9, [2, [0x88FA], 0]);
        t.add(0x2f9ca, 0x2f9ca, [2, [0x34BB], 0]);
        t.add(0x2f9cb, 0x2f9cb, [2, [0x278AE], 0]);
        t.add(0x2f9cc, 0x2f9cc, [2, [0x27966], 0]);
        t.add(0x2f9cd, 0x2f9cd, [2, [0x46BE], 0]);
        t.add(0x2f9ce, 0x2f9ce, [2, [0x46C7], 0]);
        t.add(0x2f9cf, 0x2f9cf, [2, [0x8AA0], 0]);
        t.add(0x2f9d0, 0x2f9d0, [2, [0x8AED], 0]);
        t.add(0x2f9d1, 0x2f9d1, [2, [0x8B8A], 0]);
        t.add(0x2f9d2, 0x2f9d2, [2, [0x8C55], 0]);
        t.add(0x2f9d3, 0x2f9d3, [2, [0x27CA8], 0]);
        t.add(0x2f9d4, 0x2f9d4, [2, [0x8CAB], 0]);
        t.add(0x2f9d5, 0x2f9d5, [2, [0x8CC1], 0]);
        t.add(0x2f9d6, 0x2f9d6, [2, [0x8D1B], 0]);
        t.add(0x2f9d7, 0x2f9d7, [2, [0x8D77], 0]);
        t.add(0x2f9d8, 0x2f9d8, [2, [0x27F2F], 0]);
        t.add(0x2f9d9, 0x2f9d9, [2, [0x20804], 0]);
        t.add(0x2f9da, 0x2f9da, [2, [0x8DCB], 0]);
        t.add(0x2f9db, 0x2f9db, [2, [0x8DBC], 0]);
        t.add(0x2f9dc, 0x2f9dc, [2, [0x8DF0], 0]);
        t.add(0x2f9dd, 0x2f9dd, [2, [0x208DE], 0]);
        t.add(0x2f9de, 0x2f9de, [2, [0x8ED4], 0]);
        t.add(0x2f9df, 0x2f9df, [2, [0x8F38], 0]);
        t.add(0x2f9e0, 0x2f9e0, [2, [0x285D2], 0]);
        t.add(0x2f9e1, 0x2f9e1, [2, [0x285ED], 0]);
        t.add(0x2f9e2, 0x2f9e2, [2, [0x9094], 0]);
        t.add(0x2f9e3, 0x2f9e3, [2, [0x90F1], 0]);
        t.add(0x2f9e4, 0x2f9e4, [2, [0x9111], 0]);
        t.add(0x2f9e5, 0x2f9e5, [2, [0x2872E], 0]);
        t.add(0x2f9e6, 0x2f9e6, [2, [0x911B], 0]);
        t.add(0x2f9e7, 0x2f9e7, [2, [0x9238], 0]);
        t.add(0x2f9e8, 0x2f9e8, [2, [0x92D7], 0]);
        t.add(0x2f9e9, 0x2f9e9, [2, [0x92D8], 0]);
        t.add(0x2f9ea, 0x2f9ea, [2, [0x927C], 0]);
        t.add(0x2f9eb, 0x2f9eb, [2, [0x93F9], 0]);
        t.add(0x2f9ec, 0x2f9ec, [2, [0x9415], 0]);
        t.add(0x2f9ed, 0x2f9ed, [2, [0x28BFA], 0]);
        t.add(0x2f9ee, 0x2f9ee, [2, [0x958B], 0]);
        t.add(0x2f9ef, 0x2f9ef, [2, [0x4995], 0]);
        t.add(0x2f9f0, 0x2f9f0, [2, [0x95B7], 0]);
        t.add(0x2f9f1, 0x2f9f1, [2, [0x28D77], 0]);
        t.add(0x2f9f2, 0x2f9f2, [2, [0x49E6], 0]);
        t.add(0x2f9f3, 0x2f9f3, [2, [0x96C3], 0]);
        t.add(0x2f9f4, 0x2f9f4, [2, [0x5DB2], 0]);
        t.add(0x2f9f5, 0x2f9f5, [2, [0x9723], 0]);
        t.add(0x2f9f6, 0x2f9f6, [2, [0x29145], 0]);
        t.add(0x2f9f7, 0x2f9f7, [2, [0x2921A], 0]);
        t.add(0x2f9f8, 0x2f9f8, [2, [0x4A6E], 0]);
        t.add(0x2f9f9, 0x2f9f9, [2, [0x4A76], 0]);
        t.add(0x2f9fa, 0x2f9fa, [2, [0x97E0], 0]);
        t.add(0x2f9fb, 0x2f9fb, [2, [0x2940A], 0]);
        t.add(0x2f9fc, 0x2f9fc, [2, [0x4AB2], 0]);
        t.add(0x2f9fd, 0x2f9fd, [2, [0x29496], 0]);
        t.add(0x2f9fe, 0x2f9ff, [2, [0x980B], 0]);
        t.add(0x2fa00, 0x2fa00, [2, [0x9829], 0]);
        t.add(0x2fa01, 0x2fa01, [2, [0x295B6], 0]);
        t.add(0x2fa02, 0x2fa02, [2, [0x98E2], 0]);
        t.add(0x2fa03, 0x2fa03, [2, [0x4B33], 0]);
        t.add(0x2fa04, 0x2fa04, [2, [0x9929], 0]);
        t.add(0x2fa05, 0x2fa05, [2, [0x99A7], 0]);
        t.add(0x2fa06, 0x2fa06, [2, [0x99C2], 0]);
        t.add(0x2fa07, 0x2fa07, [2, [0x99FE], 0]);
        t.add(0x2fa08, 0x2fa08, [2, [0x4BCE], 0]);
        t.add(0x2fa09, 0x2fa09, [2, [0x29B30], 0]);
        t.add(0x2fa0a, 0x2fa0a, [2, [0x9B12], 0]);
        t.add(0x2fa0b, 0x2fa0b, [2, [0x9C40], 0]);
        t.add(0x2fa0c, 0x2fa0c, [2, [0x9CFD], 0]);
        t.add(0x2fa0d, 0x2fa0d, [2, [0x4CCE], 0]);
        t.add(0x2fa0e, 0x2fa0e, [2, [0x4CED], 0]);
        t.add(0x2fa0f, 0x2fa0f, [2, [0x9D67], 0]);
        t.add(0x2fa10, 0x2fa10, [2, [0x2A0CE], 0]);
        t.add(0x2fa11, 0x2fa11, [2, [0x4CF8], 0]);
        t.add(0x2fa12, 0x2fa12, [2, [0x2A105], 0]);
        t.add(0x2fa13, 0x2fa13, [2, [0x2A20E], 0]);
        t.add(0x2fa14, 0x2fa14, [2, [0x2A291], 0]);
        t.add(0x2fa15, 0x2fa15, [2, [0x9EBB], 0]);
        t.add(0x2fa16, 0x2fa16, [2, [0x4D56], 0]);
        t.add(0x2fa17, 0x2fa17, [2, [0x9EF9], 0]);
        t.add(0x2fa18, 0x2fa18, [2, [0x9EFE], 0]);
        t.add(0x2fa19, 0x2fa19, [2, [0x9F05], 0]);
        t.add(0x2fa1a, 0x2fa1a, [2, [0x9F0F], 0]);
        t.add(0x2fa1b, 0x2fa1b, [2, [0x9F16], 0]);
        t.add(0x2fa1c, 0x2fa1c, [2, [0x9F3B], 0]);
        t.add(0x2fa1d, 0x2fa1d, [2, [0x2A600], 0]);
        t.add(0x2fa1e, 0x2fffd, [4, [], 0]);
        t.add(0x2fffe, 0x2ffff, [4, [], 0]);
        t.add(0x30000, 0x3fffd, [4, [], 0]);
        t.add(0x3fffe, 0x3ffff, [4, [], 0]);
        t.add(0x40000, 0x4fffd, [4, [], 0]);
        t.add(0x4fffe, 0x4ffff, [4, [], 0]);
        t.add(0x50000, 0x5fffd, [4, [], 0]);
        t.add(0x5fffe, 0x5ffff, [4, [], 0]);
        t.add(0x60000, 0x6fffd, [4, [], 0]);
        t.add(0x6fffe, 0x6ffff, [4, [], 0]);
        t.add(0x70000, 0x7fffd, [4, [], 0]);
        t.add(0x7fffe, 0x7ffff, [4, [], 0]);
        t.add(0x80000, 0x8fffd, [4, [], 0]);
        t.add(0x8fffe, 0x8ffff, [4, [], 0]);
        t.add(0x90000, 0x9fffd, [4, [], 0]);
        t.add(0x9fffe, 0x9ffff, [4, [], 0]);
        t.add(0xa0000, 0xafffd, [4, [], 0]);
        t.add(0xafffe, 0xaffff, [4, [], 0]);
        t.add(0xb0000, 0xbfffd, [4, [], 0]);
        t.add(0xbfffe, 0xbffff, [4, [], 0]);
        t.add(0xc0000, 0xcfffd, [4, [], 0]);
        t.add(0xcfffe, 0xcffff, [4, [], 0]);
        t.add(0xd0000, 0xdfffd, [4, [], 0]);
        t.add(0xdfffe, 0xdffff, [4, [], 0]);
        t.add(0xe0000, 0xe0000, [4, [], 0]);
        t.add(0xe0001, 0xe0001, [4, [], 0]);
        t.add(0xe0002, 0xe001f, [4, [], 0]);
        t.add(0xe0020, 0xe007f, [4, [], 0]);
        t.add(0xe0080, 0xe00ff, [4, [], 0]);
        t.add(0xe0100, 0xe01ef, [1, [], 0]);
        t.add(0xe01f0, 0xefffd, [4, [], 0]);
        t.add(0xefffe, 0xeffff, [4, [], 0]);
        t.add(0xf0000, 0xffffd, [4, [], 0]);
        t.add(0xffffe, 0xfffff, [4, [], 0]);
        t.add(0x100000, 0x10fffd, [4, [], 0]);
        t.add(0x10fffe, 0x10ffff, [4, [], 0]);
    }
}
exports.IDNAMappingTable = IDNAMappingTable;
IDNAMappingTable._instance = undefined;

});

unwrapExports(IDNAMappingTable_1);
var IDNAMappingTable_2 = IDNAMappingTable_1.Status;
var IDNAMappingTable_3 = IDNAMappingTable_1.IDNA2008Status;
var IDNAMappingTable_4 = IDNAMappingTable_1.IDNAMappingTable;

var ObjectCache_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Represents an object cache with a size limit.
 */
class ObjectCache {
    /**
     * Initializes a new instance of `ObjectCache`.
     *
     * @param limit - maximum number of items to keep in the cache. When the limit
     * is exceeded the first item is removed from the cache.
     */
    constructor(limit = 1000) {
        this._items = new Set();
        this._limit = limit;
    }
    /**
     * Adds a new item to the cache.
     *
     * @param item - an item
     */
    add(item) {
        this._items.add(item);
        if (this._items.size > this._limit) {
            const it = this._items.values().next();
            /* istanbul ignore else */
            if (!it.done) {
                this._items.delete(it.value);
            }
        }
    }
    /**
     * Removes an item from the cache.
     *
     * @param item - an item
     */
    remove(item) {
        this._items.delete(item);
    }
    /**
     * Removes all items from the cache.
     */
    clear() {
        this._items.clear();
    }
    /**
     * Gets the number of items in the cache.
     */
    get length() { return this._items.size; }
    /**
     * Iterates through the items in the cache.
     */
    *entries() {
        yield* this;
    }
    /**
     * Iterates through the items in the cache.
     */
    *[Symbol.iterator]() {
        yield* this._items;
    }
}
exports.ObjectCache = ObjectCache;

});

unwrapExports(ObjectCache_1);
var ObjectCache_2 = ObjectCache_1.ObjectCache;

var CompareCache_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Represents a cache for storing order between equal objects.
 *
 * This cache is used when an algorithm compares two objects and finds them to
 * be equal but still needs to establish an order between those two objects.
 * When two such objects `a` and `b` are passed to the `check` method, a random
 * number is generated with `Math.random()`. If the random number is less than
 * `0.5` it is assumed that `a < b` otherwise `a > b`. The random number along
 * with `a` and `b` is stored in the cache, so that subsequent checks result
 * in the same consistent result.
 *
 * The cache has a size limit which is defined on initialization.
 */
class CompareCache {
    /**
     * Initializes a new instance of `CompareCache`.
     *
     * @param limit - maximum number of items to keep in the cache. When the limit
     * is exceeded the first item is removed from the cache.
     */
    constructor(limit = 1000) {
        this._items = new Map();
        this._limit = limit;
    }
    /**
     * Compares and caches the given objects. Returns `true` if `objA < objB` and
     * `false` otherwise.
     *
     * @param objA - an item to compare
     * @param objB - an item to compare
     */
    check(objA, objB) {
        if (this._items.get(objA) === objB)
            return true;
        else if (this._items.get(objB) === objA)
            return false;
        const result = (Math.random() < 0.5);
        if (result) {
            this._items.set(objA, objB);
        }
        else {
            this._items.set(objB, objA);
        }
        if (this._items.size > this._limit) {
            const it = this._items.keys().next();
            /* istanbul ignore else */
            if (!it.done) {
                this._items.delete(it.value);
            }
        }
        return result;
    }
}
exports.CompareCache = CompareCache;

});

unwrapExports(CompareCache_1);
var CompareCache_2 = CompareCache_1.CompareCache;

var StringWalker_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Walks through the code points of a string.
 */
class StringWalker {
    /**
     * Initializes a new `StringWalker`.
     *
     * @param input - input string
     */
    constructor(input) {
        this._pointer = 0;
        this._chars = Array.from(input);
        this._length = this._chars.length;
    }
    /**
     * Determines if the current position is beyond the end of string.
     */
    get eof() { return this._pointer >= this._length; }
    /**
     * Returns the number of code points in the input string.
     */
    get length() { return this._length; }
    /**
     * Returns the current code point. Returns `-1` if the position is beyond
     * the end of string.
     */
    codePoint() {
        if (this._codePoint === undefined) {
            if (this.eof) {
                this._codePoint = -1;
            }
            else {
                const cp = this._chars[this._pointer].codePointAt(0);
                /* istanbul ignore else */
                if (cp !== undefined) {
                    this._codePoint = cp;
                }
                else {
                    this._codePoint = -1;
                }
            }
        }
        return this._codePoint;
    }
    /**
     * Returns the current character. Returns an empty string if the position is
     * beyond the end of string.
     */
    c() {
        if (this._c === undefined) {
            this._c = (this.eof ? "" : this._chars[this._pointer]);
        }
        return this._c;
    }
    /**
     * Returns the remaining string.
     */
    remaining() {
        if (this._remaining === undefined) {
            this._remaining = (this.eof ?
                "" : this._chars.slice(this._pointer + 1).join(''));
        }
        return this._remaining;
    }
    /**
     * Returns the substring from the current character to the end of string.
     */
    substring() {
        if (this._substring === undefined) {
            this._substring = (this.eof ?
                "" : this._chars.slice(this._pointer).join(''));
        }
        return this._substring;
    }
    /**
     * Gets or sets the current position.
     */
    get pointer() { return this._pointer; }
    set pointer(val) {
        if (val === this._pointer)
            return;
        this._pointer = val;
        this._codePoint = undefined;
        this._c = undefined;
        this._remaining = undefined;
        this._substring = undefined;
    }
}
exports.StringWalker = StringWalker;

});

unwrapExports(StringWalker_1);
var StringWalker_2 = StringWalker_1.StringWalker;

var lib$1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.ObjectCache = ObjectCache_1.ObjectCache;

exports.CompareCache = CompareCache_1.CompareCache;

exports.StringWalker = StringWalker_1.StringWalker;
/**
 * Applies the mixin to a given class.
 *
 * @param baseClass - class to receive the mixin
 * @param mixinClass - mixin class
 * @param overrides - an array with names of function overrides. Base class
 * functions whose names are in this array will be kept by prepending an
 * underscore to their names.
 */
function applyMixin(baseClass, mixinClass, ...overrides) {
    Object.getOwnPropertyNames(mixinClass.prototype).forEach(name => {
        if (overrides.includes(name)) {
            const orgPropDesc = Object.getOwnPropertyDescriptor(baseClass.prototype, name);
            /* istanbul ignore else */
            if (orgPropDesc) {
                Object.defineProperty(baseClass.prototype, "_" + name, orgPropDesc);
            }
        }
        const propDesc = Object.getOwnPropertyDescriptor(mixinClass.prototype, name);
        /* istanbul ignore else */
        if (propDesc) {
            Object.defineProperty(baseClass.prototype, name, propDesc);
        }
    });
}
exports.applyMixin = applyMixin;
/**
 * Applies default values to the given object.
 *
 * @param obj - an object
 * @param defaults - an object with default values
 * @param overwrite - if set to `true` defaults object always overwrites object
 * values, whether they are `undefined` or not.
 */
function applyDefaults(obj, defaults, overwrite = false) {
    const result = clone(obj || {});
    for (const [key, val] of forEachObject(defaults)) {
        if (isObject(val)) {
            result[key] = applyDefaults(result[key], val);
        }
        else if (overwrite || result[key] === undefined) {
            result[key] = val;
        }
    }
    return result;
}
exports.applyDefaults = applyDefaults;
/**
 * Iterates over items pairs of an array.
 *
 * @param arr - array to iterate
 */
function* forEachArray(arr) {
    yield* arr;
}
exports.forEachArray = forEachArray;
/**
 * Iterates over key/value pairs of a map or object.
 *
 * @param obj - map or object to iterate
 */
function* forEachObject(obj) {
    if (isMap(obj)) {
        yield* obj;
    }
    else {
        for (const key in obj) {
            /* istanbul ignore next */
            if (!obj.hasOwnProperty(key))
                continue;
            yield [key, obj[key]];
        }
    }
}
exports.forEachObject = forEachObject;
/**
 * Returns the number of entries in a map or object.
 *
 * @param obj - map or object
 */
function objectLength(obj) {
    if (isMap(obj)) {
        return obj.size;
    }
    else {
        return Object.keys(obj).length;
    }
}
exports.objectLength = objectLength;
/**
 * Gets the value of a key from a map or object.
 *
 * @param obj - map or object
 * @param key - the key to retrieve
 */
function getObjectValue(obj, key) {
    if (isMap(obj)) {
        return obj.get(key);
    }
    else {
        return obj[key];
    }
}
exports.getObjectValue = getObjectValue;
/**
 * Removes a property from a map or object.
 *
 * @param obj - map or object
 * @param key - the key to remove
 */
function removeObjectValue(obj, key) {
    if (isMap(obj)) {
        obj.delete(key);
    }
    else {
        delete obj[key];
    }
}
exports.removeObjectValue = removeObjectValue;
/**
 * Deep clones the given object.
 *
 * @param obj - an object
 */
function clone(obj) {
    if (isFunction(obj)) {
        return obj;
    }
    else if (isArray(obj)) {
        const result = [];
        for (const item of obj) {
            result.push(clone(item));
        }
        return result;
    }
    else if (isObject(obj)) {
        const result = {};
        for (const key in obj) {
            /* istanbul ignore next */
            if (obj.hasOwnProperty(key)) {
                const val = obj[key];
                result[key] = clone(val);
            }
        }
        return result;
    }
    else {
        return obj;
    }
}
exports.clone = clone;
/**
 * Type guard for boolean types
 *
 * @param x - a variable to type check
 */
function isBoolean(x) {
    return typeof x === "boolean";
}
exports.isBoolean = isBoolean;
/**
 * Type guard for numeric types
 *
 * @param x - a variable to type check
 */
function isNumber(x) {
    return typeof x === "number";
}
exports.isNumber = isNumber;
/**
 * Type guard for strings
 *
 * @param x - a variable to type check
 */
function isString(x) {
    return typeof x === "string";
}
exports.isString = isString;
/**
 * Type guard for function objects
 *
 * @param x - a variable to type check
 */
function isFunction(x) {
    return !!x && Object.prototype.toString.call(x) === '[object Function]';
}
exports.isFunction = isFunction;
/**
 * Type guard for JS objects
 *
 * _Note:_ Functions are objects too
 *
 * @param x - a variable to type check
 */
function isObject(x) {
    const type = typeof x;
    return !!x && (type === 'function' || type === 'object');
}
exports.isObject = isObject;
/**
 * Type guard for arrays
 *
 * @param x - a variable to type check
 */
function isArray(x) {
    return Array.isArray(x);
}
exports.isArray = isArray;
/**
 * Type guard for maps.
 *
 * @param x - a variable to check
 */
function isMap(x) {
    return x instanceof Map;
}
exports.isMap = isMap;
/**
 * Determines if `x` is an empty Array or an Object with no own properties.
 *
 * @param x - a variable to check
 */
function isEmpty(x) {
    if (isArray(x)) {
        return !x.length;
    }
    else if (isObject(x)) {
        for (const key in x) {
            if (x.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }
    return false;
}
exports.isEmpty = isEmpty;
/**
 * Determines if `x` is a plain Object.
 *
 * @param x - a variable to check
 */
function isPlainObject(x) {
    if (isObject(x)) {
        const proto = Object.getPrototypeOf(x);
        const ctor = proto.constructor;
        return proto && ctor &&
            (typeof ctor === 'function') && (ctor instanceof ctor) &&
            (Function.prototype.toString.call(ctor) === Function.prototype.toString.call(Object));
    }
    return false;
}
exports.isPlainObject = isPlainObject;
/**
 * Determines if `x` is an iterable Object.
 *
 * @param x - a variable to check
 */
function isIterable(x) {
    return x && (typeof x[Symbol.iterator] === 'function');
}
exports.isIterable = isIterable;
/**
 * Gets the primitive value of an object.
 */
function getValue(obj) {
    if (isFunction(obj.valueOf)) {
        return obj.valueOf();
    }
    else {
        return obj;
    }
}
exports.getValue = getValue;
/**
 * UTF-8 encodes the given string.
 *
 * @param input - a string
 */
function utf8Encode(input) {
    const bytes = new Uint8Array(input.length * 4);
    let byteIndex = 0;
    for (let i = 0; i < input.length; i++) {
        let char = input.charCodeAt(i);
        if (char < 128) {
            bytes[byteIndex++] = char;
            continue;
        }
        else if (char < 2048) {
            bytes[byteIndex++] = char >> 6 | 192;
        }
        else {
            if (char > 0xd7ff && char < 0xdc00) {
                if (++i >= input.length) {
                    throw new Error("Incomplete surrogate pair.");
                }
                const c2 = input.charCodeAt(i);
                if (c2 < 0xdc00 || c2 > 0xdfff) {
                    throw new Error("Invalid surrogate character.");
                }
                char = 0x10000 + ((char & 0x03ff) << 10) + (c2 & 0x03ff);
                bytes[byteIndex++] = char >> 18 | 240;
                bytes[byteIndex++] = char >> 12 & 63 | 128;
            }
            else {
                bytes[byteIndex++] = char >> 12 | 224;
            }
            bytes[byteIndex++] = char >> 6 & 63 | 128;
        }
        bytes[byteIndex++] = char & 63 | 128;
    }
    return bytes.subarray(0, byteIndex);
}
exports.utf8Encode = utf8Encode;
/**
 * UTF-8 decodes the given byte sequence into a string.
 *
 * @param bytes - a byte sequence
 */
function utf8Decode(bytes) {
    let result = "";
    let i = 0;
    while (i < bytes.length) {
        var c = bytes[i++];
        if (c > 127) {
            if (c > 191 && c < 224) {
                if (i >= bytes.length) {
                    throw new Error("Incomplete 2-byte sequence.");
                }
                c = (c & 31) << 6 | bytes[i++] & 63;
            }
            else if (c > 223 && c < 240) {
                if (i + 1 >= bytes.length) {
                    throw new Error("Incomplete 3-byte sequence.");
                }
                c = (c & 15) << 12 | (bytes[i++] & 63) << 6 | bytes[i++] & 63;
            }
            else if (c > 239 && c < 248) {
                if (i + 2 >= bytes.length) {
                    throw new Error("Incomplete 4-byte sequence.");
                }
                c = (c & 7) << 18 | (bytes[i++] & 63) << 12 | (bytes[i++] & 63) << 6 | bytes[i++] & 63;
            }
            else {
                throw new Error("Unknown multi-byte start.");
            }
        }
        if (c <= 0xffff) {
            result += String.fromCharCode(c);
        }
        else if (c <= 0x10ffff) {
            c -= 0x10000;
            result += String.fromCharCode(c >> 10 | 0xd800);
            result += String.fromCharCode(c & 0x3FF | 0xdc00);
        }
        else {
            throw new Error("Code point exceeds UTF-16 limit.");
        }
    }
    return result;
}
exports.utf8Decode = utf8Decode;

});

unwrapExports(lib$1);
var lib_1$1 = lib$1.ObjectCache;
var lib_2 = lib$1.CompareCache;
var lib_3 = lib$1.StringWalker;
var lib_4 = lib$1.applyMixin;
var lib_5 = lib$1.applyDefaults;
var lib_6 = lib$1.forEachArray;
var lib_7 = lib$1.forEachObject;
var lib_8 = lib$1.objectLength;
var lib_9 = lib$1.getObjectValue;
var lib_10 = lib$1.removeObjectValue;
var lib_11 = lib$1.clone;
var lib_12 = lib$1.isBoolean;
var lib_13 = lib$1.isNumber;
var lib_14 = lib$1.isString;
var lib_15 = lib$1.isFunction;
var lib_16 = lib$1.isObject;
var lib_17 = lib$1.isArray;
var lib_18 = lib$1.isMap;
var lib_19 = lib$1.isEmpty;
var lib_20 = lib$1.isPlainObject;
var lib_21 = lib$1.isIterable;
var lib_22 = lib$1.getValue;
var lib_23 = lib$1.utf8Encode;
var lib_24 = lib$1.utf8Decode;

var UTS46Algorithm = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });



/**
 * Processes a domain name string.
 *
 * @param domainName - domain name
 * @param options - processing options
 * @param output - determines if any errors were produced during processing
 */
function process(domainName, options, output = { errors: false }) {
    output.errors = false;
    let result = "";
    /**
     * 1. Map. For each code point in the domain_name string, look up the status
     * value in Section 5, IDNA Mapping Table, and take the following actions:
     * - disallowed: Leave the code point unchanged in the string, and record that
     * there was an error.
     * - ignored: Remove the code point from the string. This is equivalent to
     * mapping the code point to an empty string.
     * - mapped: Replace the code point in the string by the value for the mapping
     * in Section 5, IDNA Mapping Table.
     * - deviation:
     *   If Transitional_Processing, replace the code point in the string by the
     * value for the mapping in Section 5, IDNA Mapping Table .
     *   Otherwise, leave the code point unchanged in the string.
     * - valid: Leave the code point unchanged in the string.
     */
    for (const char of domainName) {
        const cp = char.codePointAt(0);
        /* istanbul ignore next */
        if (cp === undefined) {
            throw new Error("Invalid code point.");
        }
        const mapping = IDNAMappingTable_1.IDNAMappingTable.instance.get(cp);
        let status = mapping[0];
        /**
         * Resolve STD3 status codes into Valid, Mapped or Disallowed
         * - disallowed_STD3_valid: the status is disallowed if
         *   UseSTD3ASCIIRules=true (the normal case); implementations that
         *   allow UseSTD3ASCIIRules=false would treat the code point as valid.
         * - disallowed_STD3_mapped: the status is disallowed if
         *   UseSTD3ASCIIRules=true (the normal case); implementations that allow
         *   UseSTD3ASCIIRules=false would treat the code point as mapped.
         */
        if (status === IDNAMappingTable_1.Status.DisallowedSTD3Valid) {
            status = (options.useSTD3ASCIIRules ? IDNAMappingTable_1.Status.Disallowed : IDNAMappingTable_1.Status.Valid);
        }
        else if (status === IDNAMappingTable_1.Status.DisallowedSTD3Mapped) {
            status = (options.useSTD3ASCIIRules ? IDNAMappingTable_1.Status.Disallowed : IDNAMappingTable_1.Status.Mapped);
        }
        switch (status) {
            case IDNAMappingTable_1.Status.Disallowed:
                output.errors = true;
                result += char;
                break;
            case IDNAMappingTable_1.Status.Ignored:
                // skip this code point
                break;
            case IDNAMappingTable_1.Status.Mapped:
                result += String.fromCodePoint(...mapping[1]);
                break;
            case IDNAMappingTable_1.Status.Deviation:
                if (options.transitionalProcessing)
                    result += String.fromCodePoint(...mapping[1]);
                else
                    result += char;
                break;
            case IDNAMappingTable_1.Status.Valid:
                result += char;
                break;
        }
    }
    /** 2. Normalize. Normalize the domain_name string to Unicode Normalization
     * Form C. */
    result = result.normalize("NFC");
    /**
     * 3. Break. Break the string into labels at U+002E ( . ) FULL STOP.
     */
    const labels = result.split('.');
    /**
     * 4. Convert/Validate. For each label in the domain_name string:
     */
    const validateOptions = lib$1.clone(options);
    validateOptions.checkNormalization = false;
    validateOptions.checkDot = false;
    const transitionalProcessing = validateOptions.transitionalProcessing;
    for (let i = 0; i < labels.length; i++) {
        let label = labels[i];
        if (label.startsWith("xn--")) {
            /**
             * - If the label starts with “xn--”:
             *   - Attempt to convert the rest of the label to Unicode according to
             * Punycode [RFC3492]. If that conversion fails, record that there was an
             * error, and continue with the next label. Otherwise replace the original
             * label in the string by the results of the conversion.
             *   - Verify that the label meets the validity criteria in Section 4.1,
             * Validity Criteria for Nontransitional Processing. If any of the validity
             * criteria are not satisfied, record that there was an error.
             */
            try {
                label = punycode_1.decode(label.substring(4));
                labels[i] = label;
            }
            catch (_a) {
                output.errors = true;
                continue;
            }
            validateOptions.transitionalProcessing = false;
            if (!validate(label, validateOptions))
                output.errors = true;
            validateOptions.transitionalProcessing = transitionalProcessing;
        }
        else {
            /**
             * - If the label does not start with “xn--”:
             *   - Verify that the label meets the validity criteria in Section 4.1,
             * Validity Criteria for the input Processing choice (Transitional or
             * Nontransitional). If any of the validity criteria are not satisfied,
             * record that there was an error.
             */
            if (!validate(label, options))
                output.errors = true;
        }
    }
    return labels.join('.');
}
/**
 * Validates a label in a domain name string.
 *
 * @param label - a label
 * @param options - processing options
 */
function validate(label, options) {
    /**
     * 1. The label must be in Unicode Normalization Form NFC.
     */
    if (options.checkNormalization && (label.normalize("NFC") !== label))
        return false;
    /**
     * 2. If CheckHyphens, the label must not contain a U+002D HYPHEN-MINUS
     * character in both the third and fourth positions.
     */
    if (options.checkHyphens && label[2] === '-' && label[3] === '-')
        return false;
    /**
     * 3. If CheckHyphens, the label must neither begin nor end with a
     * U+002D HYPHEN-MINUS character.
     */
    if (options.checkHyphens && (label[0] === '-' || label[label.length - 1] === '-'))
        return false;
    /**
     * 4. The label must not contain a U+002E ( . ) FULL STOP.
     */
    if (options.checkDot && /\./.test(label))
        return false;
    /**
     * 5. The label must not begin with a combining mark, that is:
     * General_Category=Mark.
     */
    // TODO
    /**
     * 6. Each code point in the label must only have certain status values
     * according to Section 5, IDNA Mapping Table:
     * 6.1. For Transitional Processing, each value must be valid.
     * 6.2. For Nontransitional Processing, each value must be either valid or
     * deviation.
     */
    for (const char of label) {
        const cp = char.codePointAt(0);
        /* istanbul ignore next */
        if (cp === undefined) {
            throw new Error("Invalid code point.");
        }
        let status = IDNAMappingTable_1.IDNAMappingTable.instance.get(cp)[0];
        /**
         * Resolve STD3 status codes into Valid, Mapped or Disallowed
         * - disallowed_STD3_valid: the status is disallowed if
         *   UseSTD3ASCIIRules=true (the normal case); implementations that
         *   allow UseSTD3ASCIIRules=false would treat the code point as valid.
         * - disallowed_STD3_mapped: the status is disallowed if
         *   UseSTD3ASCIIRules=true (the normal case); implementations that allow
         *   UseSTD3ASCIIRules=false would treat the code point as mapped.
         */
        if (status === IDNAMappingTable_1.Status.DisallowedSTD3Valid) {
            status = (options.useSTD3ASCIIRules ? IDNAMappingTable_1.Status.Disallowed : IDNAMappingTable_1.Status.Valid);
        }
        else if (status === IDNAMappingTable_1.Status.DisallowedSTD3Mapped) {
            status = (options.useSTD3ASCIIRules ? IDNAMappingTable_1.Status.Disallowed : IDNAMappingTable_1.Status.Mapped);
        }
        if (options.transitionalProcessing && status !== IDNAMappingTable_1.Status.Valid)
            return false;
        if (!options.transitionalProcessing && status !== IDNAMappingTable_1.Status.Valid &&
            status !== IDNAMappingTable_1.Status.Deviation)
            return false;
    }
    /**
     * 7. If CheckJoiners, the label must satisfy the ContextJ rules from
     * Appendix A, in The Unicode Code Points and Internationalized Domain Names
     * for Applications (IDNA) [IDNA2008].
     */
    // TODO
    /**
     * 8. If CheckBidi, and if the domain name is a  Bidi domain name, then the
     * label must satisfy all six of the numbered conditions in [IDNA2008]
     * RFC 5893, Section 2.
     */
    // TODO
    return true;
}
/**
 * Converts domain name string to ASCII.
 *
 * @param domainName - domain name
 * @param options - conversion options
 * @param output - determines if any errors were produced during conversion
 */
function toASCII(domainName, { useSTD3ASCIIRules = true, checkHyphens = true, checkBidi = true, checkJoiners = true, transitionalProcessing = true, verifyDnsLength = true } = {}) {
    /**
     * 1. To the input domain_name, apply the Processing Steps in Section 4,
     * Processing, using the input boolean flags Transitional_Processing,
     * CheckHyphens, CheckBidi, CheckJoiners, and UseSTD3ASCIIRules. This may
     * record an error.
     * 2. Break the result into labels at U+002E FULL STOP.
     * 3. Convert each label with non-ASCII characters into Punycode [RFC3492],
     * and prefix by “xn--”. This may record an error.
     * 4. If VerifyDnsLength flag is true, then verify DNS length restrictions.
     * This may record an error. For more information, see [STD13] and [STD3].
     * 4.1. The length of the domain name, excluding the root label and its dot,
     * is from 1 to 253.
     * 4.2. The length of each label is from 1 to 63.
     * 5. If an error was recorded in steps 1-4, then the operation has failed
     * and a failure value is returned. No DNS lookup should be done.
     * 6. Otherwise join the labels using U+002E FULL STOP as a separator, and
     * return the result.
     */
    const output = { errors: false };
    const processedName = process(domainName, { useSTD3ASCIIRules,
        checkHyphens, checkBidi, checkJoiners, transitionalProcessing }, output);
    if (output.errors) {
        return null;
    }
    const result = punycode_1.toASCII(processedName);
    if (verifyDnsLength) {
        const lengthExpectRoot = result.length - (result.indexOf('.') + 1);
        if (lengthExpectRoot < 1 || lengthExpectRoot > 253) {
            output.errors = true;
            return null;
        }
        for (const label of result.split('.')) {
            if (label.length < 1 || label.length > 63) {
                output.errors = true;
                return null;
            }
        }
    }
    return result;
}
exports.toASCII = toASCII;
/**
 * Converts domain name string to Unicode.
 *
 * @param domainName - domain name
 * @param options - conversion options
 * @param output - determines if any errors were produced during conversion
 */
function toUnicode(domainName, { useSTD3ASCIIRules = true, checkHyphens = true, checkBidi = true, checkJoiners = true, transitionalProcessing = true } = {}, output = { errors: false }) {
    /**
     * 1. To the input domain_name, apply the Processing Steps in Section 4,
     * Processing, using the input boolean flags Transitional_Processing,
     * CheckHyphens, CheckBidi, CheckJoiners, and UseSTD3ASCIIRules. This may
     * record an error.
     * 2. Like [RFC3490], this will always produce a converted Unicode string.
     * Unlike ToASCII of [RFC3490], this always signals whether or not there was
     * an error.
     */
    return process(domainName, { useSTD3ASCIIRules, checkHyphens, checkBidi,
        checkJoiners, transitionalProcessing }, output);
}
exports.toUnicode = toUnicode;

});

unwrapExports(UTS46Algorithm);
var UTS46Algorithm_1 = UTS46Algorithm.toASCII;
var UTS46Algorithm_2 = UTS46Algorithm.toUnicode;

var lib$2 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.toASCII = UTS46Algorithm.toASCII;
exports.toUnicode = UTS46Algorithm.toUnicode;

});

var uts46 = unwrapExports(lib$2);
var lib_1$2 = lib$2.toASCII;
var lib_2$1 = lib$2.toUnicode;

function validate(input) {
    try {
        const domain = new Domain(input);
        const checker = new SpoofChecker();
        return domain.labels.every(label => {
            return checker.safeToDisplayAsUnicode(label, domain.isTldAscii);
        });
    }
    catch (e) {
        return false;
    }
}
const normalize$1 = (name) => {
    return name
        ? uts46.toUnicode(name, {
            useSTD3ASCIIRules: true,
            transitionalProcessing: false,
        })
        : name;
};
const namehash = (inputName) => {
    // Reject empty names:
    let node = '';
    for (let i = 0; i < 32; i += 1) {
        node += '00';
    }
    const name = normalize$1(inputName);
    if (name) {
        const labels = name.split('.');
        for (let i = labels.length - 1; i >= 0; i -= 1) {
            const labelSha = sha3.keccak256(labels[i]);
            node = sha3.keccak256(Buffer.from(node + labelSha, 'hex'));
        }
    }
    return '0x' + node;
};

export { validate, normalize$1 as normalize, namehash };
//# sourceMappingURL=ens-validation.es6.js.map
